const data = {
    type: 'Topology',
    objects: {
        countries: {
            type: 'GeometryCollection',
            geometries: [
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[0]],
                        [[1]],
                        [[2]],
                        [[3]],
                        [[4]],
                        [[5]],
                        [[6]],
                        [[7]],
                        [[8]],
                        [[9]],
                        [[10]],
                        [[11]],
                        [[12]],
                        [[13]],
                        [[14]],
                        [[15]],
                        [[16]],
                        [[17]],
                        [[18]],
                        [[19]],
                        [[20]],
                        [[21]],
                        [[22]],
                        [[23]],
                        [[24]],
                        [[25], [26], [27], [28], [29]],
                        [[30]],
                        [[31]],
                        [[32]],
                        [[33]],
                        [[34]],
                        [[35]],
                        [[36]],
                        [[37]],
                        [[38]],
                        [[39]],
                        [[40]],
                        [[41]],
                        [[42]],
                        [[43]],
                        [[44]],
                        [[45]],
                        [[46]],
                        [[47]],
                        [[48], [49], [50], [51], [52]],
                        [[53]],
                        [[54]],
                        [[55]],
                        [[56]],
                        [[57]],
                        [[58]],
                        [[59]],
                        [[60], [61], [62]],
                        [[63]],
                        [[64]],
                        [[65]],
                        [[66]],
                        [[67]],
                        [[68]],
                        [[69]],
                        [[70]],
                        [[71]],
                        [[72]],
                        [[73]],
                        [[74]],
                        [[75]],
                        [[76]],
                        [[77]],
                        [[78]],
                        [[79]],
                        [[80]],
                        [[81]],
                        [[82]],
                        [[83]],
                        [[84]],
                        [[85]],
                        [[86]],
                        [[87]],
                        [[88]],
                        [[89]],
                        [[90]],
                        [[91]],
                        [[92]],
                        [[93]],
                        [[94]],
                        [[95]],
                        [[96]],
                        [[97], [98], [99]],
                        [[100]],
                        [[101]],
                        [[102]],
                        [[103]],
                        [[104]],
                        [[105]],
                        [[106]],
                        [[107]],
                        [[108]],
                        [[109]],
                        [[110]],
                        [[111]],
                        [[112]],
                        [[113]],
                        [[114]],
                        [[115]],
                        [[116]],
                        [[117]],
                        [[118]],
                        [[119]],
                        [[120]],
                        [[121]],
                        [[122]],
                        [[123]],
                        [[124]],
                        [[125]],
                        [[126]],
                        [[127]],
                        [[128]],
                        [[129]],
                        [[130]],
                        [[131]],
                        [[132]],
                        [[133]],
                        [[134]],
                        [[135]],
                        [[136]],
                        [[137]],
                        [[138]],
                        [[139]],
                        [[140]],
                        [[141]],
                        [[142]],
                        [[143]],
                        [[144]],
                        [[145]],
                        [[146]],
                        [[147]],
                        [[148]],
                        [[149]],
                        [[150]],
                        [[151]],
                        [[152]],
                        [[153]],
                        [[154]],
                        [[155]],
                        [[156]],
                        [[157]],
                        [[158]],
                        [[159]],
                        [[160]],
                        [[161]],
                        [[162]],
                        [[163]],
                        [[164]],
                        [[165]],
                        [[166]],
                        [[167]],
                        [[168]],
                        [[169]],
                        [[170]],
                        [[171]],
                        [[172]],
                        [[173]],
                        [[174]],
                        [[175]],
                        [[176]],
                        [[177]],
                        [[178]],
                        [[179]],
                        [[180]],
                        [[181]],
                        [[182]],
                        [[183]],
                        [[184]],
                        [[185]],
                        [[186]],
                        [[187]],
                        [[188]],
                        [[189]],
                        [[190], [191]],
                        [[192]],
                        [[193]],
                        [[194]],
                        [[195]],
                        [[196]],
                        [[197]],
                        [[198]],
                        [[199]],
                        [[200]],
                        [[201]],
                        [[202]],
                        [[203]],
                        [[204]],
                        [[205]],
                        [[206]],
                        [[207]],
                        [[208]],
                        [[209]],
                        [[210]],
                        [[211]],
                        [[212]],
                        [[213]],
                        [[214]],
                        [[215]],
                        [[216]],
                        [[217]],
                        [[218]],
                        [[219]],
                        [[220]],
                        [[221]],
                        [[222]],
                        [[223]],
                        [[224]],
                        [[225]],
                        [[226]],
                        [[227]],
                        [[228]],
                        [[229]],
                        [[230]],
                        [[231]],
                        [[232]],
                        [[233]],
                        [[234]],
                        [[235]],
                        [[236]],
                        [[237]],
                        [[238]],
                        [[239]],
                        [[240]],
                        [[241]],
                        [[242]],
                        [[243]],
                        [[244]],
                        [[245]],
                        [[246]],
                        [[247]],
                        [[248]],
                        [[249]],
                        [[250]],
                        [[251]],
                        [[252]],
                        [[253]],
                        [[254]],
                        [[255]],
                        [[256]],
                        [[257]],
                        [[258]],
                        [[259]],
                        [[260]],
                        [[261]],
                        [[262]],
                        [[263]],
                        [[264]],
                        [[265]],
                        [[266]],
                        [[267]],
                        [[268]],
                        [[269]],
                        [[270]],
                        [[271]],
                        [[272]],
                        [[273]],
                        [[274]],
                        [[275]],
                        [[276]],
                        [[277]],
                        [[278]],
                        [[279]],
                        [[280]],
                        [[281], [282]],
                        [[283]],
                        [[284]],
                        [[285]],
                        [[286]],
                        [[287]],
                        [[288]],
                        [[289]],
                        [[290]],
                        [[291]],
                        [[292]],
                        [[293]],
                        [[294]],
                        [[295]],
                        [[296]],
                        [[297]],
                        [[298]],
                        [[299]],
                        [[300]],
                        [[301]],
                        [[302]],
                        [[303]],
                        [[304]],
                        [[305], [306], [307], [308]],
                        [[309]],
                        [[310]],
                        [[311]],
                        [[312]],
                        [[313]],
                        [[314]],
                        [[315]],
                        [[316]],
                        [[317]],
                        [[318]],
                        [[319]],
                        [[320]],
                        [[321]],
                        [[322]],
                        [[323]],
                        [[324]],
                        [[325]],
                        [[326]],
                        [[327]],
                        [[328]],
                        [[329]],
                        [[330]],
                        [[331]],
                        [[332]],
                        [[333]],
                        [[334]],
                        [[335]],
                        [[336]],
                        [[337]],
                        [[338]],
                        [[339]],
                        [[340]],
                        [[341]],
                        [[342]],
                        [[343]],
                        [[344]],
                        [[345]],
                        [[346]],
                        [[347]],
                        [[348]],
                        [[349]],
                        [[350]],
                        [[351]],
                        [[352]],
                        [[353]],
                        [[354]],
                        [[355]],
                        [[356]],
                        [[357]],
                        [[358]],
                        [[359]],
                        [[360]],
                        [[361]],
                        [[362]],
                        [[363]],
                        [[364]],
                        [[365]],
                        [[366]],
                        [[367]],
                        [[368]],
                        [[369]],
                        [[370]],
                        [[371]],
                        [[372]],
                        [[373]],
                        [[374]],
                        [[375]],
                        [[376]],
                        [[377]],
                        [[378]],
                        [[379]],
                        [[380]],
                        [[381]],
                        [[382]],
                        [[383]],
                        [[384]],
                        [[385]],
                        [[386]],
                        [[387]],
                        [[388]],
                        [[389]],
                        [[390]],
                        [[391]],
                        [[392]],
                        [[393]],
                        [[394]],
                        [[395]],
                        [[396]],
                        [[397]],
                        [[398]],
                        [[399]],
                        [[400]],
                        [[401]],
                        [[402]],
                        [[403]],
                        [[404]],
                        [[405]],
                        [[406]],
                        [[407]],
                        [[408]],
                        [[409]],
                        [[410]],
                        [[411]],
                        [[412]],
                        [[413]],
                        [[414]],
                        [[415]],
                        [[416]],
                        [[417]],
                        [[418]],
                        [[419]],
                        [[420]],
                        [[421]],
                        [[422]],
                        [[423]],
                        [[424]],
                        [[425]],
                        [[426]],
                        [[427]],
                        [[428]],
                        [[429]],
                        [[430]],
                        [[431], [432]],
                        [[433]],
                        [[434]],
                        [[435]],
                        [[436]],
                        [[437]],
                        [[438]],
                        [[439]],
                        [[440]],
                        [[441]],
                        [[442]],
                        [[443]],
                        [[444]],
                        [[445]],
                        [[446]],
                        [[447]],
                        [[448]],
                        [[449]],
                        [[450]],
                        [[451]],
                        [[452]],
                        [[453]],
                        [[454]],
                        [[455], [456], [457]],
                        [[458]],
                        [[459]],
                        [[460]],
                        [[461]],
                        [[462]],
                        [[463]],
                        [[464]],
                        [[465]],
                        [[466]],
                        [[467]],
                        [[468]],
                        [[469]],
                        [[470]],
                        [[471]],
                        [[472]],
                        [[473], [474], [475]],
                        [[476]],
                        [[477]],
                        [[478]],
                        [[479]],
                        [[480]],
                        [[481]],
                        [[482]],
                        [[483]],
                        [[484]],
                        [[485]],
                        [[486]],
                        [[487]],
                        [[488]],
                        [[489]],
                        [[490]],
                        [[491]],
                        [[492]],
                        [[493]],
                        [[494]],
                        [[495]],
                        [[496]],
                        [[497]],
                        [[498]],
                        [[499]],
                        [[500]],
                        [[501]],
                        [[502]],
                        [[503]],
                        [[504]],
                        [[505]],
                        [[506]],
                        [[507]],
                        [[508]],
                        [[509]],
                        [[510]],
                        [[511]],
                        [[512]],
                        [[513]],
                        [[514]],
                        [[515]],
                        [[516]],
                        [[517]],
                        [[518]],
                        [[519]],
                        [[520]],
                        [[521]],
                        [[522]],
                        [[523]],
                        [[524]],
                        [[525]],
                        [[526]],
                        [[527]],
                        [[528]],
                        [[529]],
                        [[530]],
                        [[531]],
                        [[532]],
                        [[533]],
                        [[534]],
                        [[535]],
                        [[536]],
                        [[537]],
                        [[538]],
                        [[539]],
                        [[540]],
                        [[541]],
                        [[542]],
                        [[543]],
                        [[544]],
                        [[545]],
                        [[546]],
                        [[547]],
                        [[548]],
                        [[549]],
                        [[550]],
                        [[551]],
                        [[552]],
                        [[553]],
                        [[554]],
                        [[555]],
                        [[556]],
                        [[557]],
                        [[558]],
                        [[559]],
                        [[560]],
                        [[561]],
                        [[562]],
                        [[563]],
                        [[564]],
                        [[565]],
                        [[566]],
                        [[567]],
                        [[568]],
                        [[569], [570], [571], [572]],
                        [[573]],
                        [[574]],
                        [[575], [576]],
                        [[577]],
                        [[578]],
                        [[579]],
                        [[580]],
                        [[581]],
                        [[582]],
                        [[583]],
                        [[584]],
                        [[585]],
                        [[586]],
                        [[587]],
                        [[588]],
                        [[589]],
                        [[590]],
                        [[591]],
                        [[592]],
                        [[593]],
                        [[594]],
                        [[595]],
                        [[596]],
                        [[597]],
                        [[598]],
                        [[599]],
                        [[600]],
                        [[601]],
                        [[602]],
                        [[603]],
                        [[604]],
                        [[605]],
                        [[606]],
                        [[607]],
                        [[608]],
                        [[609]],
                        [[610]],
                        [[611]],
                        [[612]],
                        [[613]],
                        [[614]],
                        [[615]],
                        [[616]],
                        [[617]],
                        [[618]],
                        [[619]],
                        [[620]],
                        [[621]],
                        [[622]],
                        [[623]],
                        [[624]],
                        [[625]],
                        [[626]],
                        [[627]],
                        [[628]],
                        [[629]],
                        [[630]],
                        [[631]],
                        [[632]],
                        [[633]],
                        [[634]],
                        [[635]],
                        [[636]],
                        [[637]],
                        [[638]],
                        [[639]],
                        [[640]],
                        [[641]],
                        [[642]],
                        [[643]],
                        [[644]],
                        [[645]],
                        [[646]],
                        [[647]],
                        [[648]],
                        [[649]],
                        [[650]],
                        [[651]],
                        [[652]],
                        [[653]],
                        [
                            [654],
                            [655],
                            [656],
                            [657],
                            [658],
                            [659],
                            [660],
                            [661],
                            [662],
                            [663],
                            [664],
                            [665],
                            [666],
                            [667],
                            [668],
                            [669],
                            [670],
                            [671],
                            [672],
                        ],
                        [[673]],
                        [[674]],
                        [[675]],
                        [[676]],
                        [[677]],
                        [[678]],
                        [[679]],
                        [[680]],
                        [[681]],
                        [[682], [683], [684], [685], [686], [687]],
                        [[688]],
                        [[689]],
                        [[690]],
                        [[691]],
                        [[692]],
                        [[693]],
                        [
                            [694],
                            [695],
                            [696],
                            [697],
                            [698],
                            [699],
                            [700],
                            [701],
                            [702],
                            [703],
                            [704],
                            [705],
                        ],
                        [[706], [707], [708], [709]],
                        [[710]],
                        [[711]],
                        [[712]],
                        [[713]],
                        [[714]],
                        [[715]],
                        [[716]],
                        [[717]],
                        [[718]],
                        [[719]],
                        [[720]],
                        [[721]],
                        [[722]],
                        [[723]],
                        [[724]],
                        [[725]],
                        [[726]],
                        [[727]],
                        [[728]],
                        [[729]],
                        [[730]],
                        [[731]],
                        [[732]],
                        [[733]],
                        [[734]],
                        [[735]],
                        [[736]],
                        [[737]],
                        [[738]],
                        [[739]],
                        [[740], [741]],
                        [[742]],
                        [[743]],
                        [[744]],
                        [[745]],
                        [[746]],
                        [[747]],
                        [[748]],
                        [[749]],
                        [[750]],
                        [[751]],
                        [[752]],
                        [[753]],
                        [[754]],
                        [[755]],
                        [[756]],
                        [[757]],
                        [[758]],
                        [[759], [760], [761], [762], [763]],
                        [[764]],
                        [[765]],
                        [[766], [767]],
                        [[768]],
                        [[769]],
                        [[770]],
                        [[771]],
                        [[772]],
                        [[773]],
                        [[774]],
                        [[775]],
                        [[776]],
                        [[777]],
                        [[778]],
                        [[779]],
                        [[780]],
                        [[781]],
                        [[782]],
                        [[783]],
                        [[784]],
                        [[785]],
                        [[786]],
                        [[787]],
                        [[788]],
                        [[789]],
                        [[790]],
                        [[791]],
                        [[792]],
                        [[793]],
                        [[794]],
                        [[795]],
                        [[796]],
                        [[797]],
                        [[798]],
                        [[799]],
                        [[800], [801]],
                        [[802]],
                        [[803]],
                        [[804]],
                        [[805], [806], [807], [808]],
                        [[809]],
                        [[810], [811], [812], [813], [814], [815]],
                        [[816]],
                        [[817], [818], [819]],
                        [[820]],
                        [[821]],
                        [[822]],
                        [[823]],
                        [[824]],
                        [[825]],
                        [[826]],
                        [[827]],
                        [[828]],
                        [[829]],
                        [[830]],
                        [[831]],
                        [[832]],
                        [[833]],
                        [[834]],
                        [[835]],
                        [[836]],
                        [[837]],
                        [[838], [839], [840], [841]],
                        [[842]],
                        [[843]],
                        [[844]],
                        [[845]],
                        [[846]],
                        [[847]],
                        [[848]],
                        [[849]],
                        [[850]],
                        [[851]],
                        [[852]],
                        [[853]],
                        [[854]],
                        [[855]],
                        [[856]],
                        [[857]],
                        [[858]],
                        [[859]],
                        [[860]],
                        [[861]],
                        [[862]],
                        [[863]],
                        [[864]],
                        [[865]],
                        [[866]],
                        [[867]],
                        [[868]],
                        [[869]],
                        [[870]],
                        [[871]],
                        [[872]],
                        [[873]],
                        [[874]],
                        [[875]],
                        [[876]],
                        [[877]],
                        [[878]],
                        [[879]],
                        [[880]],
                        [[881]],
                        [[882]],
                        [[883]],
                        [[884]],
                        [[885]],
                        [[886]],
                        [[887]],
                        [[888]],
                        [[889]],
                        [[890]],
                        [[891]],
                        [[892]],
                        [[893]],
                        [[894]],
                        [[895]],
                        [[896], [897], [898], [899], [900]],
                        [[901]],
                        [[902]],
                        [[903]],
                        [[904]],
                        [[905, 906], [907], [908]],
                        [[909]],
                        [[910]],
                        [[911]],
                        [[912]],
                        [[913]],
                        [[914]],
                        [[915]],
                        [[916]],
                        [[917]],
                        [[918]],
                        [[919]],
                        [[920], [921], [922], [923], [924], [925], [926], [927]],
                        [[928]],
                        [[929]],
                        [[930]],
                        [[931]],
                        [[932]],
                        [[933]],
                        [[934]],
                        [
                            [
                                935,
                                936,
                                937,
                                938,
                                939,
                                940,
                                941,
                                942,
                                943,
                                944,
                                945,
                                946,
                                947,
                                948,
                                949,
                                950,
                                951,
                                952,
                            ],
                        ],
                    ],
                    properties: {
                        name: 'Autonomous Region In Muslim Mindanao',
                        country: 'PH',
                        state: 'autonomous region in muslim mindanao',
                        regionNumb: 'PH-15',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [[[953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964]]],
                    properties: {
                        name: 'Cordillera Administrative Region',
                        country: 'PH',
                        state: 'cordillera administrative region',
                        regionNumb: 'PH-14',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [[[965, 966, 967, 968, 969]]],
                    properties: {
                        name: 'National Capital Region',
                        country: 'PH',
                        state: 'national capital region',
                        regionNumb: 'PH-13',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[970, 971]],
                        [[972]],
                        [[973]],
                        [[974]],
                        [[975]],
                        [[976]],
                        [[977]],
                        [[978]],
                        [[979]],
                        [[980]],
                        [[981]],
                        [[982]],
                        [[983]],
                        [[984]],
                        [[985]],
                        [[986]],
                        [[987]],
                        [[988]],
                        [[989]],
                        [[990]],
                        [[991]],
                        [[992]],
                        [[993]],
                        [[994]],
                        [[995]],
                        [[996]],
                        [[997]],
                        [[998]],
                        [[999]],
                        [[1000]],
                        [[1001]],
                        [[1002]],
                        [[1003]],
                        [[1004]],
                        [[1005]],
                        [[1006]],
                        [[1007]],
                        [[1008]],
                        [[1009]],
                        [[1010]],
                        [[1011]],
                        [[1012]],
                        [[1013]],
                        [[1014]],
                        [[1015]],
                        [[1016]],
                        [[1017]],
                        [[1018]],
                        [[1019]],
                        [[1020]],
                        [[1021]],
                        [[1022]],
                        [[1023]],
                        [[1024]],
                        [[1025]],
                        [[1026]],
                        [[1027]],
                        [[1028]],
                        [[1029]],
                        [[1030]],
                        [[1031]],
                        [[1032]],
                        [[1033]],
                        [[1034]],
                        [[1035]],
                        [[1036]],
                        [[1037]],
                        [[1038]],
                        [[1039]],
                        [[1040]],
                        [[1041]],
                        [[1042]],
                        [[1043]],
                        [[1044]],
                        [[1045]],
                        [[1046]],
                        [[1047]],
                        [[1048]],
                        [[1049]],
                        [[1050]],
                        [[1051]],
                        [[1052]],
                        [[1053]],
                        [[1054]],
                        [[1055]],
                        [[1056]],
                        [[1057]],
                        [[1058]],
                        [[1059]],
                        [[1060]],
                        [[1061]],
                        [[1062]],
                        [[1063]],
                        [[1064]],
                        [[1065]],
                        [[1066]],
                        [[1067]],
                        [[1068]],
                        [[1069]],
                        [[1070]],
                        [[1071]],
                        [[1072]],
                        [[1073]],
                        [[1074]],
                        [[1075]],
                        [[1076]],
                        [[1077]],
                        [[1078]],
                        [[1079]],
                        [[1080]],
                        [[1081]],
                        [[1082]],
                        [[1083]],
                        [[1084]],
                        [[1085]],
                        [[1086]],
                        [[1087]],
                        [[1088]],
                        [[1089]],
                        [[1090]],
                        [[1091]],
                        [[1092]],
                        [[1093]],
                        [[1094]],
                        [[1095]],
                        [
                            [-962, 1096, -960, 1097, -958, 1098, 1099, 1100, 1101, 1102, 1103],
                            [1104],
                        ],
                    ],
                    properties: {
                        name: 'Ilocos Region',
                        country: 'PH',
                        state: 'ilocos region',
                        regionNumb: 'PH-01',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[1105]],
                        [[1106]],
                        [[1107]],
                        [[1108]],
                        [[1109]],
                        [[1110]],
                        [[1111]],
                        [[1112]],
                        [[1113]],
                        [[1114]],
                        [[1115]],
                        [[1116]],
                        [[1117]],
                        [[1118]],
                        [[1119]],
                        [[1120]],
                        [[1121]],
                        [[1122]],
                        [[1123]],
                        [[1124]],
                        [[1125]],
                        [[1126]],
                        [[1127]],
                        [[1128]],
                        [[1129]],
                        [[1130]],
                        [[1131]],
                        [[1132]],
                        [[1133]],
                        [[1134]],
                        [[1135]],
                        [[1136]],
                        [[1137]],
                        [[1138]],
                        [[1139]],
                        [[1140]],
                        [[1141]],
                        [[1142]],
                        [[1143]],
                        [[1144], [1145]],
                        [[1146]],
                        [[1147]],
                        [[1148]],
                        [[1149]],
                        [[1150]],
                        [[1151]],
                        [[1152]],
                        [
                            [1153, 1154, 1155, 1156, 1157, -954, 1158, -964, 1159],
                            [1160],
                            [1161],
                            [1162],
                        ],
                        [[1163]],
                        [[1164]],
                        [[1165]],
                        [[1166]],
                        [[1167]],
                        [[1168]],
                        [[1169]],
                        [[1170]],
                        [[1171], [1172]],
                        [[1173]],
                        [[1174]],
                        [[1175]],
                        [[1176]],
                        [[1177]],
                        [[1178]],
                        [[1179]],
                        [[1180]],
                        [[1181]],
                        [[1182]],
                        [[1183]],
                        [[1184]],
                        [[1185]],
                        [[1186]],
                        [[1187]],
                        [[1188]],
                        [[1189]],
                        [[1190]],
                        [[1191]],
                        [[1192]],
                        [[1193]],
                        [[1194]],
                        [[1195]],
                        [[1196]],
                        [[1197]],
                        [[1198]],
                        [[1199]],
                    ],
                    properties: {
                        name: 'Cagayan Valley',
                        country: 'PH',
                        state: 'cagayan valley',
                        regionNumb: 'PH-02',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[1200]],
                        [[1201]],
                        [[1202]],
                        [[1203]],
                        [[1204]],
                        [[1205]],
                        [[1206]],
                        [[1207]],
                        [[1208]],
                        [[1209]],
                        [[-971, 1210]],
                        [[1211]],
                        [[1212]],
                        [[1213]],
                        [[1214]],
                        [
                            [1215, 1216, 1217, -969, 1218, -1103, 1219, -1156, 1220, -1154, 1221],
                            [1222],
                        ],
                    ],
                    properties: {
                        name: 'Central Luzon',
                        country: 'PH',
                        state: 'central luzon',
                        regionNumb: 'PH-03',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[1223]],
                        [[1224]],
                        [[1225]],
                        [[1226]],
                        [[1227]],
                        [[1228]],
                        [[1229]],
                        [[1230]],
                        [[1231]],
                        [[1232]],
                        [[1233]],
                        [[1234]],
                        [[1235]],
                        [[1236]],
                        [[1237]],
                        [[1238]],
                        [[1239]],
                        [[1240]],
                        [[1241]],
                        [[1242]],
                        [[1243]],
                        [[1244]],
                        [[1245]],
                        [[1246]],
                        [[1247]],
                        [[1248]],
                        [[1249]],
                        [[1250]],
                        [[1251]],
                        [[1252]],
                        [[1253]],
                        [[1254]],
                        [[1255]],
                        [[1256]],
                        [[1257]],
                        [[1258]],
                        [[1259]],
                        [[1260]],
                        [[1261]],
                        [[1262]],
                        [[1263]],
                        [[1264]],
                        [[1265]],
                        [[1266]],
                        [[1267]],
                        [[1268]],
                        [[1269]],
                        [[1270]],
                        [[1271]],
                        [[1272]],
                        [[1273]],
                        [[1274]],
                        [[1275]],
                        [[1276]],
                        [[1277]],
                        [[1278]],
                        [[1279]],
                        [[1280]],
                        [[1281]],
                        [[1282]],
                        [[1283]],
                        [[1284]],
                        [[1285]],
                        [[1286]],
                        [[1287]],
                        [[1288]],
                        [[1289]],
                        [[1290]],
                        [[1291]],
                        [[1292]],
                        [[1293]],
                        [[1294]],
                        [[1295]],
                        [[1296]],
                        [[1297]],
                        [[1298]],
                        [[1299]],
                        [[1300]],
                        [[1301]],
                        [[1302]],
                        [[1303]],
                        [[1304]],
                        [[1305]],
                        [[1306]],
                        [[1307]],
                        [[1308]],
                        [[1309]],
                        [[1310]],
                        [[1311]],
                        [[1312]],
                        [[1313]],
                        [[1314]],
                        [[1315]],
                        [[1316]],
                        [[1317]],
                        [[1318]],
                        [[1319]],
                        [[1320]],
                        [[1321]],
                        [[1322]],
                        [[1323]],
                        [[1324]],
                        [[1325]],
                        [[1326]],
                        [[1327]],
                        [[1328]],
                        [[1329]],
                        [
                            [1330, 1331, 1332, 1333, -966, 1334, 1335, -1216],
                            [1336],
                            [1337],
                            [1338],
                            [1339],
                            [1340],
                            [1341],
                        ],
                    ],
                    properties: {
                        name: 'Calabarzon',
                        country: 'PH',
                        state: 'calabarzon',
                        regionNumb: 'PH-04',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[1342]],
                        [[1343]],
                        [[1344]],
                        [[1345]],
                        [[1346]],
                        [[1347]],
                        [[1348]],
                        [[1349]],
                        [[1350]],
                        [[1351]],
                        [[1352], [1353]],
                        [[1354]],
                        [[1355]],
                        [[1356]],
                        [[1357]],
                        [[1358]],
                        [[1359]],
                        [[1360]],
                        [[1361]],
                        [[1362]],
                        [[1363]],
                        [[1364]],
                        [[1365]],
                        [[1366]],
                        [[1367]],
                        [[1368]],
                        [[1369]],
                        [[1370]],
                        [[1371]],
                        [[1372]],
                        [[1373]],
                        [[1374]],
                        [[1375], [1376]],
                        [[1377]],
                        [[1378]],
                        [[1379]],
                        [[1380]],
                        [[1381]],
                        [[1382]],
                        [[1383]],
                        [[1384]],
                        [[1385]],
                        [[1386]],
                        [[1387]],
                        [[1388]],
                        [[1389]],
                        [[1390]],
                        [[1391]],
                        [[1392]],
                        [[1393]],
                        [[1394]],
                        [[1395]],
                        [[1396]],
                        [[1397]],
                        [[1398]],
                        [[1399]],
                        [[1400]],
                        [[1401]],
                        [[1402]],
                        [[1403]],
                        [[1404]],
                        [[1405]],
                        [[1406]],
                        [[1407]],
                        [[1408]],
                        [[1409]],
                        [[1410]],
                        [[1411]],
                        [[1412]],
                        [[1413]],
                        [[1414]],
                        [[1415]],
                        [[1416]],
                        [[1417]],
                        [[1418]],
                        [[1419]],
                        [[1420]],
                        [[1421]],
                        [[1422]],
                        [[1423]],
                        [[1424]],
                        [[1425]],
                        [[1426]],
                        [[1427]],
                        [[1428]],
                        [[1429]],
                        [[1430]],
                        [[1431]],
                        [[1432], [1433], [1434], [1435], [1436]],
                        [[1437]],
                        [[1438]],
                        [[1439]],
                        [[1440]],
                        [[1441]],
                        [[1442]],
                        [[1443]],
                        [[1444]],
                        [[1445]],
                        [[1446]],
                        [[1447]],
                        [[1448]],
                        [[1449]],
                        [[1450]],
                        [[1451]],
                        [[1452]],
                        [[1453]],
                        [[1454]],
                        [[1455]],
                        [[1456]],
                        [[1457]],
                        [[1458]],
                        [[1459]],
                        [[1460]],
                        [[1461]],
                        [[1462]],
                        [[1463]],
                        [[1464]],
                        [[1465]],
                        [[1466]],
                        [[1467]],
                        [[1468]],
                        [[1469]],
                        [[1470]],
                        [[1471]],
                        [[1472]],
                        [[1473]],
                        [[1474]],
                        [[1475]],
                        [[1476]],
                        [[1477]],
                        [[1478]],
                        [[1479]],
                        [[1480]],
                        [[1481]],
                        [[1482]],
                        [[1483]],
                        [[1484]],
                        [[1485]],
                        [[1486]],
                        [[1487]],
                        [[1488]],
                        [[1489]],
                        [[1490]],
                        [[1491]],
                        [[1492]],
                        [[1493]],
                        [[1494]],
                        [[1495]],
                        [[1496]],
                        [[1497]],
                        [[1498]],
                        [[1499]],
                        [[1500]],
                        [[1501]],
                        [[1502]],
                        [[1503]],
                        [[1504]],
                        [[1505]],
                        [[1506]],
                        [[1507]],
                        [[1508]],
                        [[1509]],
                        [[1510]],
                        [[1511]],
                        [[1512]],
                        [[1513]],
                        [[1514]],
                        [[1515]],
                        [[1516]],
                        [[1517]],
                        [[1518]],
                        [[1519]],
                        [[1520]],
                        [[1521]],
                        [[1522]],
                        [[1523]],
                        [[1524]],
                        [[1525]],
                        [[1526]],
                        [[1527]],
                        [[1528]],
                        [[1529]],
                        [[1530]],
                        [[1531]],
                        [[1532]],
                        [[1533]],
                        [[1534]],
                        [[1535]],
                        [[1536]],
                        [[1537]],
                        [[1538]],
                        [[1539]],
                        [[1540]],
                        [[1541]],
                        [[1542]],
                        [[1543]],
                        [[1544]],
                        [[1545]],
                        [[1546]],
                        [[1547]],
                        [[1548]],
                        [[1549]],
                        [[1550]],
                        [[1551]],
                        [[1552]],
                        [[1553]],
                        [[1554]],
                        [[1555]],
                        [[1556]],
                        [[1557]],
                        [[1558]],
                        [[1559]],
                        [[1560]],
                        [[1561]],
                        [[1562]],
                        [[1563]],
                        [[1564]],
                        [[1565]],
                        [[1566]],
                        [[1567]],
                        [[1568]],
                        [[1569]],
                        [[1570]],
                        [[1571]],
                        [[1572]],
                        [[1573]],
                        [[1574]],
                        [[1575]],
                        [[1576]],
                        [[1577]],
                        [[1578]],
                        [[1579]],
                        [[1580]],
                        [[1581]],
                        [[1582]],
                        [[1583]],
                        [[1584]],
                        [[1585], [1586]],
                        [[1587]],
                        [[1588]],
                        [[1589]],
                        [[1590]],
                        [[1591]],
                        [[1592]],
                        [[1593]],
                        [[1594]],
                        [[1595]],
                        [[1596]],
                        [[1597]],
                        [[1598]],
                        [[1599]],
                        [[1600]],
                        [[1601]],
                        [[1602]],
                        [[1603]],
                        [[1604]],
                        [[1605]],
                        [[1606]],
                        [[1607]],
                        [[1608]],
                        [[1609]],
                        [[1610]],
                        [[1611]],
                        [[1612]],
                        [[1613]],
                        [[1614]],
                        [[1615]],
                        [[1616]],
                        [[1617]],
                        [[1618]],
                        [[1619]],
                        [[1620]],
                        [[1621]],
                        [[1622]],
                        [[1623]],
                        [[1624]],
                        [[1625]],
                        [[1626]],
                        [[1627]],
                        [[1628]],
                        [[1629]],
                        [[1630]],
                        [[1631]],
                        [[1632]],
                        [[1633]],
                        [[1634]],
                        [[1635]],
                        [[1636]],
                        [[1637]],
                        [[1638]],
                        [[1639]],
                        [[1640]],
                        [[1641]],
                        [[1642]],
                        [[1643]],
                        [[1644]],
                        [[1645]],
                        [[1646], [1647]],
                        [[1648]],
                        [[1649]],
                        [[1650]],
                        [[1651]],
                        [[1652]],
                        [[1653]],
                        [[1654]],
                        [[1655]],
                        [[1656]],
                        [[1657]],
                        [[1658]],
                        [[1659]],
                        [[1660]],
                        [[1661]],
                        [[1662]],
                        [[1663]],
                        [[1664]],
                        [[1665]],
                        [[1666]],
                        [[1667]],
                        [[1668]],
                        [[1669]],
                        [[1670]],
                        [[1671]],
                        [[1672]],
                        [[1673]],
                        [[1674]],
                        [[1675]],
                        [[1676]],
                        [[1677]],
                        [[1678]],
                        [[1679]],
                        [[1680]],
                        [[1681]],
                        [[1682]],
                        [[1683]],
                        [[1684]],
                        [[1685]],
                        [[1686]],
                        [[1687]],
                        [[1688]],
                        [[1689]],
                        [[1690]],
                        [[1691], [1692], [1693]],
                        [[1694]],
                        [[1695]],
                        [[1696], [1697]],
                        [[1698]],
                        [[1699]],
                        [[1700]],
                        [[1701]],
                        [[1702], [1703]],
                        [[1704]],
                        [[1705]],
                        [[1706]],
                        [[1707]],
                        [[1708]],
                        [[1709]],
                        [[1710]],
                        [[1711]],
                        [[1712]],
                        [[1713]],
                        [[1714]],
                        [[1715]],
                        [[1716]],
                        [[1717]],
                        [[1718]],
                        [[1719]],
                        [[1720]],
                        [[1721]],
                        [[1722]],
                        [[1723]],
                        [[1724]],
                        [[1725]],
                        [[1726]],
                        [[1727]],
                        [[1728]],
                        [[1729]],
                        [[1730]],
                        [[1731]],
                        [[1732]],
                        [[1733]],
                        [[1734]],
                        [[1735]],
                        [[1736]],
                        [[1737]],
                        [[1738]],
                        [
                            [1739],
                            [1740],
                            [1741],
                            [1742],
                            [1743],
                            [1744],
                            [1745],
                            [1746],
                            [1747],
                            [1748],
                            [1749],
                        ],
                        [[1750]],
                        [[1751]],
                        [[1752]],
                        [[1753]],
                        [[1754]],
                        [[1755]],
                        [[1756]],
                        [[1757]],
                        [[1758]],
                        [[1759]],
                        [[1760]],
                        [[1761]],
                        [[1762]],
                        [[1763]],
                        [[1764]],
                        [[1765]],
                        [[1766]],
                        [[1767]],
                        [[1768]],
                        [[1769]],
                        [[1770]],
                        [[1771]],
                        [[1772]],
                        [[1773]],
                        [[1774]],
                        [[1775]],
                        [[1776]],
                        [[1777]],
                        [[1778]],
                        [[1779]],
                        [[1780]],
                        [[1781]],
                        [[1782]],
                        [[1783]],
                        [[1784]],
                        [[1785]],
                        [[1786]],
                        [[1787]],
                        [[1788]],
                        [[1789]],
                        [[1790]],
                        [[1791]],
                        [[1792]],
                        [[1793]],
                        [[1794]],
                        [[1795]],
                        [[1796]],
                        [[1797]],
                        [[1798]],
                        [[1799]],
                        [[1800]],
                        [[1801]],
                        [[1802]],
                        [[1803]],
                        [[1804]],
                        [[1805]],
                        [[1806], [1807], [1808]],
                        [[1809]],
                        [[1810]],
                        [[1811]],
                        [[1812]],
                        [[1813]],
                        [[1814]],
                        [[1815]],
                        [[1816]],
                        [[1817]],
                        [[1818]],
                        [[1819]],
                        [[1820]],
                        [[1821]],
                        [[1822]],
                        [[1823]],
                        [[1824]],
                        [[1825]],
                        [[1826]],
                        [[1827]],
                        [[1828]],
                        [[1829]],
                        [[1830]],
                        [[1831]],
                        [[1832]],
                        [[1833]],
                        [[1834]],
                        [[1835]],
                        [[1836]],
                        [[1837]],
                        [[1838]],
                        [[1839]],
                        [[1840]],
                        [[1841]],
                        [[1842]],
                        [[1843]],
                        [[1844]],
                        [[1845]],
                        [[1846]],
                        [[1847]],
                        [[1848]],
                        [[1849]],
                        [[1850]],
                        [[1851]],
                        [[1852]],
                        [[1853]],
                        [[1854]],
                        [[1855]],
                        [[1856]],
                        [[1857]],
                        [[1858]],
                        [[1859]],
                        [[1860]],
                        [[1861]],
                        [[1862]],
                        [[1863]],
                        [[1864]],
                        [[1865]],
                        [[1866]],
                        [[1867]],
                        [[1868]],
                        [[1869]],
                        [[1870]],
                        [[1871]],
                        [[1872]],
                        [[1873]],
                        [[1874]],
                        [[1875]],
                        [[1876]],
                        [[1877]],
                        [[1878]],
                        [[1879]],
                        [[1880]],
                        [[1881]],
                        [[1882]],
                        [[1883]],
                        [[1884]],
                        [[1885]],
                        [[1886]],
                        [[1887]],
                        [[1888]],
                        [[1889]],
                        [[1890]],
                        [[1891]],
                        [[1892]],
                        [[1893]],
                        [[1894]],
                        [[1895]],
                        [[1896]],
                        [[1897]],
                        [[1898]],
                        [[1899]],
                        [[1900]],
                        [[1901]],
                        [[1902]],
                        [[1903]],
                        [[1904]],
                        [[1905]],
                        [[1906]],
                        [[1907]],
                        [[1908]],
                        [[1909]],
                        [[1910]],
                        [[1911]],
                        [[1912]],
                        [[1913]],
                        [[1914]],
                        [[1915]],
                        [[1916]],
                        [[1917]],
                        [[1918]],
                        [[1919]],
                        [[1920]],
                        [[1921]],
                        [[1922]],
                        [[1923]],
                        [[1924]],
                        [[1925]],
                        [[1926]],
                        [[1927]],
                        [[1928]],
                        [[1929]],
                        [[1930]],
                        [[1931]],
                        [[1932]],
                        [[1933]],
                        [[1934]],
                        [[1935]],
                        [[1936]],
                        [[1937]],
                        [[1938]],
                        [[1939]],
                        [[1940]],
                        [[1941]],
                        [[1942]],
                        [[1943]],
                        [[1944]],
                        [[1945]],
                        [[1946]],
                        [[1947]],
                        [[1948]],
                        [[1949]],
                        [[1950]],
                        [[1951]],
                        [[1952]],
                        [[1953]],
                        [[1954]],
                        [[1955]],
                        [[1956]],
                        [[1957]],
                        [[1958], [1959], [1960]],
                        [[1961]],
                        [[1962]],
                        [[1963]],
                        [[1964]],
                        [[1965]],
                        [[1966]],
                        [[1967]],
                        [[1968]],
                        [[1969]],
                        [[1970]],
                        [[1971]],
                        [[1972]],
                        [[1973]],
                        [[1974]],
                        [[1975], [1976], [1977], [1978], [1979], [1980], [1981], [1982]],
                        [[1983]],
                        [[1984]],
                        [[1985]],
                        [[1986]],
                        [[1987], [1988], [1989], [1990]],
                        [[1991]],
                        [[1992], [1993]],
                        [[1994]],
                        [[1995]],
                        [[1996], [1997], [1998]],
                        [[1999]],
                        [[2000]],
                        [[2001]],
                        [[2002]],
                        [[2003]],
                        [[2004]],
                        [[2005]],
                        [[2006]],
                        [[2007]],
                        [[2008]],
                        [[2009]],
                        [[2010]],
                        [[2011]],
                        [[2012]],
                        [[2013]],
                        [[2014]],
                        [[2015]],
                        [[2016]],
                        [[2017]],
                        [[2018]],
                        [[2019]],
                        [[2020]],
                        [[2021]],
                        [[2022]],
                        [[2023]],
                        [[2024]],
                        [[2025]],
                        [[2026]],
                        [[2027]],
                        [[2028]],
                        [[2029]],
                        [[2030]],
                        [[2031]],
                        [[2032]],
                        [[2033]],
                        [[2034]],
                        [[2035]],
                        [[2036]],
                        [[2037]],
                        [[2038]],
                        [[2039]],
                        [[2040]],
                        [[2041]],
                        [[2042]],
                        [[2043]],
                        [[2044]],
                        [[2045]],
                        [[2046]],
                        [[2047]],
                        [[2048]],
                        [[2049]],
                        [[2050]],
                        [[2051]],
                        [[2052]],
                        [[2053]],
                        [[2054]],
                        [[2055]],
                        [[2056]],
                        [[2057]],
                        [[2058]],
                        [[2059]],
                        [[2060]],
                        [[2061]],
                        [[2062]],
                        [[2063]],
                        [[2064]],
                        [[2065]],
                        [[2066]],
                        [[2067]],
                        [[2068]],
                        [[2069]],
                        [[2070]],
                        [[2071]],
                        [[2072]],
                        [[2073]],
                        [[2074]],
                        [[2075]],
                        [[2076]],
                        [[2077]],
                        [[2078]],
                        [[2079]],
                        [[2080]],
                        [[2081]],
                        [[2082]],
                        [[2083]],
                        [[2084], [2085], [2086]],
                        [[2087]],
                        [[2088]],
                        [[2089]],
                        [[2090]],
                        [[2091]],
                        [[2092]],
                        [[2093]],
                        [[2094]],
                        [[2095]],
                        [[2096]],
                        [[2097]],
                        [[2098]],
                        [[2099]],
                        [[2100]],
                        [[2101], [2102], [2103]],
                        [[2104]],
                        [[2105]],
                        [[2106]],
                        [[2107]],
                        [[2108]],
                        [
                            [2109],
                            [2110],
                            [2111],
                            [2112],
                            [2113],
                            [2114],
                            [2115],
                            [2116],
                            [2117],
                            [2118],
                            [2119],
                        ],
                        [[2120]],
                        [[2121]],
                        [[2122]],
                        [[2123]],
                        [[2124]],
                        [[2125]],
                        [[2126]],
                        [[2127]],
                        [[2128]],
                        [[2129]],
                        [[2130]],
                        [[2131]],
                        [[2132]],
                        [[2133]],
                        [[2134]],
                        [[2135]],
                        [[2136]],
                        [[2137]],
                        [[2138]],
                        [[2139], [2140]],
                        [[2141]],
                        [[2142]],
                        [[2143]],
                        [[2144]],
                        [[2145]],
                        [[2146]],
                        [[2147]],
                        [[2148]],
                        [[2149]],
                        [[2150]],
                        [[2151]],
                        [[2152]],
                        [[2153]],
                        [[2154]],
                        [[2155]],
                        [[2156]],
                        [[2157]],
                        [[2158]],
                        [[2159], [2160], [2161], [2162], [2163], [2164]],
                        [[2165]],
                        [[2166]],
                        [[2167]],
                        [[2168]],
                        [[2169]],
                        [[2170]],
                        [[2171]],
                        [[2172]],
                        [[2173]],
                        [[2174]],
                        [[2175]],
                        [[2176]],
                        [[2177]],
                        [[2178]],
                        [[2179]],
                        [[2180]],
                        [[2181]],
                        [[2182]],
                        [[2183]],
                        [[2184]],
                        [[2185]],
                        [[2186]],
                        [[2187]],
                        [[2188]],
                        [[2189]],
                        [[2190]],
                        [[2191]],
                        [[2192]],
                        [[2193], [2194], [2195], [2196], [2197], [2198], [2199], [2200]],
                        [[2201]],
                        [[2202]],
                        [[2203]],
                        [[2204]],
                        [[2205]],
                    ],
                    properties: {
                        name: 'Mimaropa',
                        country: 'PH',
                        state: 'mimaropa',
                        regionNumb: 'PH-17',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[2206]],
                        [[2207]],
                        [[2208]],
                        [[-906, 2209]],
                        [[2210]],
                        [[2211]],
                        [[2212]],
                        [[2213]],
                        [[2214]],
                        [[2215]],
                        [[2216]],
                        [[2217]],
                        [[2218]],
                        [[2219]],
                        [[2220]],
                        [[2221]],
                        [[2222]],
                        [[2223]],
                        [[2224]],
                        [[2225]],
                        [[2226]],
                        [[2227]],
                        [[2228]],
                        [[2229]],
                        [[2230]],
                        [[2231]],
                        [[2232]],
                        [[2233]],
                        [[2234]],
                        [[2235]],
                        [[2236]],
                        [[2237]],
                        [[2238]],
                        [[2239]],
                        [[2240]],
                        [[2241]],
                        [[2242]],
                        [[2243]],
                        [[2244]],
                        [[2245]],
                        [[2246]],
                        [[2247]],
                        [[2248]],
                        [[2249]],
                        [[2250]],
                        [[2251]],
                        [[2252]],
                        [[2253]],
                        [[2254]],
                        [[2255]],
                        [[2256]],
                        [[2257]],
                        [[2258]],
                        [[2259]],
                        [[2260]],
                        [[2261]],
                        [[2262]],
                        [[2263]],
                        [[2264]],
                        [[2265]],
                        [[2266]],
                        [[2267]],
                        [[2268]],
                        [[2269]],
                        [[2270]],
                        [[2271]],
                        [[2272]],
                        [[2273]],
                        [[2274]],
                        [[2275]],
                        [[2276]],
                        [[2277]],
                        [[2278]],
                        [[2279]],
                        [[2280]],
                        [[2281]],
                        [[2282]],
                        [[2283]],
                        [[2284]],
                        [[2285]],
                        [[2286]],
                        [[2287]],
                        [[2288]],
                        [[2289]],
                        [[2290]],
                        [[2291]],
                        [[2292]],
                        [[2293]],
                        [[2294]],
                        [[2295]],
                        [[2296]],
                        [[2297]],
                        [[2298]],
                        [[2299]],
                        [[2300]],
                        [[2301]],
                        [[2302]],
                        [[2303]],
                        [[2304]],
                        [[2305]],
                        [
                            [2306, 2307],
                            [2308],
                            [2309],
                            [2310],
                            [2311],
                            [2312],
                            [2313],
                            [2314],
                            [2315],
                            [2316],
                            [2317],
                            [2318],
                            [2319],
                            [2320],
                            [2321],
                            [2322],
                            [2323],
                        ],
                        [[2324]],
                        [[2325]],
                    ],
                    properties: {
                        name: 'Zamboanga Peninsula',
                        country: 'PH',
                        state: 'zamboanga peninsula',
                        regionNumb: 'PH-09',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[2326]],
                        [[2327]],
                        [[2328]],
                        [[2329]],
                        [[2330]],
                        [[2331]],
                        [[2332]],
                        [[2333]],
                        [[2334]],
                        [[2335]],
                        [[2336]],
                        [[2337]],
                        [[2338]],
                        [[2339]],
                        [[2340]],
                        [[2341]],
                        [[2342]],
                        [[2343]],
                        [[2344]],
                        [[2345]],
                        [[2346]],
                        [[2347]],
                        [[2348]],
                        [[2349]],
                        [[2350]],
                        [[2351]],
                        [[2352]],
                        [[2353]],
                        [[2354]],
                        [[2355]],
                        [[2356]],
                        [[2357]],
                        [[2358]],
                        [[2359]],
                        [[2360]],
                        [[2361]],
                        [[2362]],
                        [[2363]],
                        [[2364]],
                        [[2365]],
                        [[2366]],
                        [[2367]],
                        [[2368]],
                        [[2369]],
                        [[2370]],
                        [[2371]],
                        [[2372]],
                        [[2373]],
                        [[2374]],
                        [[2375]],
                        [[2376]],
                        [[2377]],
                        [[2378]],
                        [[2379], [2380]],
                        [[2381]],
                        [[2382]],
                        [[2383]],
                        [[2384]],
                        [[2385]],
                        [[2386]],
                        [[2387]],
                        [[2388]],
                        [[2389]],
                        [[2390]],
                        [[2391]],
                        [[2392]],
                        [[2393]],
                        [[2394]],
                        [[2395]],
                        [[2396]],
                        [[2397]],
                        [[2398]],
                        [[2399]],
                        [[2400]],
                        [[2401]],
                        [[2402]],
                        [[2403]],
                        [[2404]],
                        [[2405]],
                        [[2406]],
                        [[2407]],
                        [[2408]],
                        [[2409]],
                        [[2410]],
                        [[2411]],
                        [[2412]],
                        [[2413]],
                        [[2414]],
                        [[2415]],
                        [[2416]],
                        [[2417]],
                        [[2418]],
                        [[2419], [2420], [2421]],
                        [[2422]],
                        [[2423]],
                        [[2424]],
                        [[2425]],
                        [[2426]],
                        [[2427]],
                        [[2428]],
                        [[2429]],
                        [[2430]],
                        [[2431]],
                        [[2432]],
                        [[2433]],
                        [[2434]],
                        [[2435]],
                        [[2436]],
                        [[2437]],
                        [[2438]],
                        [[2439]],
                        [[2440]],
                        [[2441]],
                        [[2442]],
                        [[2443]],
                        [[2444]],
                        [[2445]],
                        [[2446]],
                        [[2447]],
                        [[2448]],
                        [[2449]],
                        [[2450]],
                        [[2451]],
                        [[2452]],
                        [[2453]],
                        [[2454]],
                        [[2455]],
                        [[2456]],
                        [[2457]],
                        [[2458]],
                        [[2459]],
                        [[2460]],
                        [[2461]],
                        [[2462]],
                        [[2463]],
                        [[2464]],
                        [[2465]],
                        [[2466]],
                        [[2467]],
                        [[2468]],
                        [[2469]],
                        [[2470]],
                        [[2471]],
                        [[2472]],
                        [[2473]],
                        [[2474]],
                        [[2475]],
                        [[2476]],
                        [[2477]],
                        [[2478]],
                        [[2479]],
                        [[2480]],
                        [[2481]],
                        [[2482]],
                        [[2483], [2484]],
                        [[2485]],
                        [[2486]],
                        [[2487]],
                        [[2488]],
                        [[2489]],
                        [[2490]],
                        [[2491]],
                        [[2492]],
                        [[2493]],
                        [[2494]],
                        [[2495]],
                        [[2496]],
                        [[2497]],
                        [[2498]],
                        [[2499]],
                        [[2500]],
                        [[2501]],
                        [[2502]],
                        [[2503]],
                        [[2504]],
                        [[2505]],
                        [[2506]],
                        [[2507]],
                        [[2508]],
                        [[2509]],
                        [[2510]],
                        [[2511]],
                        [[2512]],
                        [[2513]],
                        [[2514]],
                        [[2515]],
                        [[2516]],
                        [[2517]],
                        [[2518]],
                        [[2519]],
                        [[2520]],
                        [[2521]],
                        [[2522]],
                        [[2523]],
                        [[2524]],
                        [[2525]],
                        [[2526]],
                        [[2527]],
                        [[2528]],
                        [[2529]],
                        [[2530]],
                        [[2531]],
                        [[2532]],
                        [[2533]],
                        [[2534]],
                        [[2535]],
                        [[2536]],
                        [[2537]],
                        [[2538]],
                        [[2539]],
                        [[2540]],
                        [[2541]],
                        [[2542]],
                        [[2543]],
                        [[2544]],
                        [[2545]],
                        [[2546]],
                        [[2547]],
                        [[2548]],
                        [[2549]],
                        [[2550]],
                        [[2551]],
                        [[2552]],
                        [[2553]],
                        [[2554]],
                        [[2555]],
                        [[2556]],
                        [[2557]],
                        [[2558]],
                        [[2559]],
                        [[2560]],
                        [[2561]],
                        [[2562]],
                        [[2563]],
                        [[2564]],
                        [[2565]],
                        [[2566]],
                        [[2567]],
                        [[2568]],
                        [[2569]],
                        [[2570]],
                        [[2571]],
                        [[2572]],
                        [[2573]],
                        [[2574]],
                        [[2575]],
                        [[2576]],
                        [[2577]],
                        [[2578]],
                        [[2579]],
                        [[2580]],
                        [[2581]],
                        [[2582]],
                        [[2583]],
                        [[2584]],
                        [[2585]],
                        [[2586]],
                        [[2587]],
                        [[2588]],
                        [[2589]],
                        [[2590]],
                        [[2591]],
                        [[2592]],
                        [[2593]],
                        [[2594]],
                        [[2595]],
                        [[2596]],
                        [[2597]],
                        [[2598]],
                        [[2599]],
                        [[2600]],
                        [[2601]],
                        [[2602]],
                        [[2603]],
                        [[2604]],
                        [[2605]],
                        [[2606]],
                        [[2607]],
                        [[2608]],
                        [[2609]],
                        [[2610]],
                        [[2611]],
                        [[2612]],
                        [[2613]],
                        [[2614]],
                        [[2615]],
                        [[2616]],
                        [[2617]],
                        [[2618]],
                        [[2619]],
                        [[2620]],
                        [[2621]],
                        [[2622]],
                        [[2623]],
                        [[2624]],
                        [[2625]],
                        [[2626]],
                        [[2627]],
                        [[2628]],
                        [[2629]],
                        [[2630]],
                        [[2631]],
                        [[2632]],
                        [[2633]],
                        [[2634]],
                        [[2635]],
                        [[2636]],
                        [[2637]],
                        [[2638]],
                        [[2639]],
                        [[2640]],
                        [[2641]],
                        [
                            [2642],
                            [2643],
                            [2644],
                            [2645],
                            [2646],
                            [2647],
                            [2648],
                            [2649],
                            [2650],
                            [2651],
                            [2652],
                            [2653],
                            [2654],
                            [2655],
                            [2656],
                            [2657],
                            [2658],
                            [2659],
                            [2660],
                        ],
                        [[2661]],
                        [[2662]],
                        [[2663]],
                        [[2664]],
                        [[2665]],
                        [[2666]],
                        [[2667]],
                        [[2668]],
                        [[2669]],
                        [[2670]],
                        [[2671]],
                        [[2672]],
                        [[2673]],
                        [[2674]],
                        [
                            [-1332, 2675],
                            [2676],
                            [2677],
                            [2678],
                            [2679],
                            [2680],
                            [2681],
                            [2682],
                            [2683],
                            [2684],
                            [2685],
                            [2686],
                            [2687],
                            [2688],
                            [2689],
                            [2690],
                        ],
                        [[2691]],
                        [[2692]],
                        [[2693]],
                        [[2694]],
                        [[2695]],
                        [[2696]],
                        [[2697]],
                        [[2698]],
                        [[2699]],
                        [[2700]],
                        [[2701]],
                        [[2702]],
                        [[2703]],
                        [[2704]],
                        [[2705]],
                        [[2706]],
                        [[2707]],
                        [[2708]],
                        [[2709]],
                        [[2710]],
                        [[2711]],
                        [[2712]],
                        [[2713]],
                        [[2714]],
                        [[2715]],
                        [[2716]],
                        [[2717]],
                        [[2718]],
                        [[2719]],
                    ],
                    properties: {
                        name: 'Bicol',
                        country: 'PH',
                        state: 'bicol',
                        regionNumb: 'PH-05',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[2720]],
                        [[2721]],
                        [[2722]],
                        [[2723]],
                        [[2724]],
                        [[2725]],
                        [[2726]],
                        [[2727]],
                        [[2728]],
                        [[2729]],
                        [[2730]],
                        [[2731]],
                        [[2732]],
                        [[2733]],
                        [[2734]],
                        [[2735]],
                        [[2736]],
                        [[2737]],
                        [[2738]],
                        [[2739]],
                        [[2740]],
                        [[2741]],
                        [[2742]],
                        [[2743]],
                        [[2744]],
                        [[2745]],
                        [[2746]],
                        [[2747]],
                        [[2748]],
                        [[2749]],
                        [[2750]],
                        [[2751]],
                        [[2752]],
                        [[2753]],
                        [[2754]],
                        [[2755]],
                        [[2756]],
                        [[2757]],
                        [[2758]],
                        [[2759]],
                        [[2760]],
                        [[2761]],
                        [[2762]],
                        [[2763]],
                        [[2764]],
                        [[2765]],
                        [[2766]],
                        [[2767]],
                        [[2768]],
                        [[2769]],
                        [[2770]],
                        [[2771]],
                        [[2772]],
                        [[2773]],
                        [[2774]],
                        [[2775]],
                        [[2776]],
                        [[2777]],
                        [[2778]],
                        [[2779]],
                        [[2780], [2781], [2782], [2783], [2784], [2785]],
                        [[2786]],
                        [[2787]],
                        [[2788]],
                        [[2789]],
                        [[2790]],
                        [[2791]],
                        [[2792]],
                        [[2793]],
                        [[2794]],
                        [[2795]],
                        [[2796]],
                        [[2797]],
                        [[2798]],
                        [[2799]],
                        [[2800]],
                        [[2801], [2802], [2803], [2804]],
                        [[2805]],
                        [[2806]],
                        [[2807]],
                        [
                            [2808, 2809, 2810],
                            [2811],
                            [2812],
                            [2813],
                            [2814],
                            [2815],
                            [2816],
                            [2817],
                            [2818],
                            [2819],
                            [2820],
                            [2821],
                            [2822],
                            [2823],
                            [2824],
                            [2825],
                            [2826],
                            [2827],
                            [2828],
                            [2829],
                        ],
                        [[2830]],
                        [[2831]],
                        [[2832]],
                        [[2833]],
                        [[2834]],
                        [[2835]],
                        [[2836]],
                        [[2837]],
                        [[2838]],
                        [[2839]],
                        [[2840]],
                        [[2841]],
                        [[2842]],
                        [[2843]],
                        [[2844]],
                        [[2845]],
                        [[2846]],
                        [[2847]],
                        [[2848]],
                        [[2849]],
                        [[2850]],
                        [[2851]],
                        [[2852]],
                        [[2853]],
                        [[2854]],
                        [[2855]],
                        [[2856]],
                        [[2857]],
                        [[2858]],
                        [[2859]],
                        [[2860]],
                        [[2861]],
                        [[2862]],
                        [[2863]],
                        [[2864]],
                        [[2865]],
                        [[2866]],
                        [[2867]],
                        [[2868]],
                        [[2869]],
                        [[2870]],
                        [[2871]],
                        [[2872]],
                        [[2873]],
                        [[2874]],
                        [[2875]],
                        [[2876]],
                        [[2877]],
                        [[2878]],
                        [[2879]],
                        [[2880]],
                        [[2881]],
                        [[2882]],
                        [[2883]],
                        [[2884]],
                        [[2885]],
                        [[2886]],
                        [[2887]],
                        [[2888]],
                        [[2889]],
                        [[2890]],
                        [[2891]],
                        [[2892]],
                        [[2893]],
                        [[2894]],
                        [[2895]],
                        [[2896]],
                        [[2897]],
                        [[2898]],
                        [[2899]],
                        [[2900]],
                        [[2901]],
                        [[2902]],
                        [[2903]],
                        [[2904]],
                        [[2905]],
                        [[2906]],
                        [[2907]],
                        [[2908]],
                        [[2909]],
                        [[2910]],
                        [[2911]],
                        [[2912]],
                        [[2913]],
                        [[2914]],
                        [[2915]],
                        [[2916]],
                        [[2917]],
                        [[2918]],
                        [[2919], [2920], [2921], [2922], [2923]],
                        [[2924]],
                        [[2925], [2926], [2927], [2928]],
                        [[2929]],
                        [[2930]],
                        [[2931]],
                        [[2932]],
                        [[2933]],
                        [[2934]],
                        [[2935]],
                        [[2936]],
                        [[2937]],
                        [[2938]],
                        [[2939]],
                        [[2940]],
                        [[2941]],
                        [[2942]],
                        [[2943]],
                        [[2944]],
                        [[2945]],
                        [[2946]],
                        [[2947]],
                        [[2948], [2949], [2950]],
                        [[2951]],
                        [[2952]],
                        [[2953]],
                        [[2954]],
                        [[2955]],
                        [[2956]],
                        [[2957]],
                        [[2958]],
                        [[2959]],
                        [[2960]],
                        [[2961]],
                        [[2962]],
                        [[2963]],
                        [[2964]],
                        [[2965]],
                        [[2966], [2967], [2968], [2969], [2970]],
                        [[2971]],
                        [[2972]],
                    ],
                    properties: {
                        name: 'Western Visayas',
                        country: 'PH',
                        state: 'western visayas',
                        regionNumb: 'PH-06',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[2973]],
                        [[2974]],
                        [[2975]],
                        [[2976]],
                        [[2977]],
                        [[2978]],
                        [[2979]],
                        [[2980]],
                        [[2981]],
                        [[2982]],
                        [[2983], [2984], [2985], [2986], [2987], [2988]],
                        [[2989]],
                        [[2990]],
                        [[2991]],
                        [[2992]],
                        [[2993]],
                        [[2994]],
                        [[2995]],
                        [[2996]],
                        [[2997]],
                        [[2998]],
                        [[2999]],
                        [[3000]],
                        [[3001]],
                        [[3002]],
                        [[3003]],
                        [[3004]],
                        [[3005]],
                        [[3006]],
                        [[3007]],
                        [[3008]],
                        [[3009]],
                        [[3010]],
                        [[3011]],
                        [[3012]],
                        [[3013]],
                        [[3014]],
                        [[3015]],
                        [[3016]],
                        [[3017]],
                        [[3018]],
                        [[3019]],
                        [[3020]],
                        [[3021]],
                        [[3022]],
                        [[3023]],
                        [[3024]],
                        [[3025]],
                        [[3026]],
                        [[3027]],
                        [[3028]],
                        [[3029]],
                        [[3030]],
                        [[3031]],
                        [[3032]],
                        [[3033]],
                        [[3034]],
                        [[3035]],
                        [[3036]],
                        [[3037]],
                        [[3038]],
                        [[3039]],
                        [[3040]],
                        [[3041]],
                        [[3042]],
                        [[3043]],
                        [[3044]],
                        [[3045]],
                        [[3046]],
                        [[3047]],
                        [[3048]],
                        [[3049]],
                        [[3050]],
                        [[3051], [3052], [3053]],
                        [[3054]],
                        [[3055]],
                        [[3056]],
                        [[3057]],
                        [[3058]],
                        [[3059]],
                        [[3060]],
                        [[3061]],
                        [[3062]],
                        [[3063]],
                        [[3064]],
                        [[3065]],
                        [[3066]],
                        [[3067]],
                        [[3068]],
                        [[3069]],
                        [[3070]],
                        [[3071]],
                        [[3072]],
                        [[3073]],
                        [[3074]],
                        [[3075]],
                        [[3076]],
                        [[3077]],
                        [[3078]],
                        [[3079]],
                        [[3080]],
                        [[3081]],
                        [[3082]],
                        [[3083]],
                        [[3084]],
                        [[3085]],
                        [[3086]],
                        [[3087], [3088]],
                        [[3089]],
                        [[3090]],
                        [[3091]],
                        [[3092]],
                        [[3093]],
                        [[3094]],
                        [[3095]],
                        [[3096]],
                        [[3097]],
                        [[3098]],
                        [[3099]],
                        [[3100]],
                        [[3101]],
                        [[3102]],
                        [[3103]],
                        [[3104], [3105]],
                        [[3106]],
                        [[3107, -2810, 3108], [3109]],
                        [[3110]],
                        [[3111]],
                        [[3112]],
                        [[3113]],
                        [[3114]],
                        [[3115]],
                        [[3116]],
                        [[3117]],
                        [[3118]],
                        [[3119]],
                        [[3120]],
                        [[3121]],
                        [[3122]],
                        [[3123]],
                        [[3124]],
                        [[3125]],
                        [[3126]],
                        [[3127]],
                        [[3128]],
                        [[3129]],
                        [[3130]],
                        [[3131]],
                        [[3132]],
                        [[3133]],
                        [[3134]],
                        [[3135]],
                        [[3136]],
                        [[3137]],
                        [[3138]],
                        [[3139]],
                        [[3140]],
                        [[3141]],
                        [[3142]],
                        [[3143]],
                        [[3144]],
                        [[3145]],
                        [[3146]],
                        [[3147]],
                        [[3148]],
                        [[3149]],
                        [[3150]],
                        [[3151]],
                        [[3152]],
                        [[3153]],
                        [[3154]],
                        [[3155]],
                        [[3156]],
                        [[3157]],
                        [[3158]],
                        [[3159]],
                        [[3160]],
                        [[3161]],
                    ],
                    properties: {
                        name: 'Central Visayas',
                        country: 'PH',
                        state: 'central visayas',
                        regionNumb: 'PH-07',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[3162]],
                        [[3163]],
                        [[3164]],
                        [[3165]],
                        [[3166]],
                        [[3167]],
                        [[3168]],
                        [[3169]],
                        [[3170]],
                        [[3171]],
                        [[3172]],
                        [[3173]],
                        [[3174]],
                        [[3175]],
                        [[3176]],
                        [[3177]],
                        [[3178]],
                        [[3179]],
                        [[3180]],
                        [[3181]],
                        [[3182]],
                        [[3183]],
                        [[3184]],
                        [[3185]],
                        [[3186]],
                        [[3187]],
                        [[3188]],
                        [[3189], [3190], [3191]],
                        [[3192]],
                        [[3193]],
                        [[3194]],
                        [[3195]],
                        [[3196]],
                        [[3197]],
                        [[3198]],
                        [[3199]],
                        [[3200]],
                        [[3201]],
                        [[3202]],
                        [[3203]],
                        [[3204]],
                        [[3205]],
                        [[3206]],
                        [[3207]],
                        [[3208]],
                        [[3209]],
                        [[3210]],
                        [[3211]],
                        [[3212]],
                        [[3213]],
                        [[3214]],
                        [[3215]],
                        [[3216]],
                        [[3217]],
                        [[3218]],
                        [[3219]],
                        [[3220]],
                        [[3221]],
                        [[3222]],
                        [[3223]],
                        [[3224]],
                        [[3225]],
                        [[3226]],
                        [[3227]],
                        [[3228]],
                        [[3229]],
                        [[3230]],
                        [[3231]],
                        [[3232]],
                        [[3233]],
                        [[3234]],
                        [[3235]],
                        [[3236]],
                        [[3237]],
                        [[3238]],
                        [[3239]],
                        [[3240]],
                        [[3241]],
                        [[3242]],
                        [[3243]],
                        [[3244]],
                        [[3245]],
                        [[3246]],
                        [[3247]],
                        [[3248]],
                        [[3249]],
                        [[3250]],
                        [[3251]],
                        [[3252]],
                        [[3253]],
                        [[3254]],
                        [[3255]],
                        [[3256]],
                        [[3257]],
                        [[3258]],
                        [[3259]],
                        [[3260]],
                        [[3261]],
                        [[3262]],
                        [[3263], [3264]],
                        [[3265]],
                        [[3266]],
                        [[3267]],
                        [[3268]],
                        [[3269]],
                        [[3270]],
                        [[3271]],
                        [[3272]],
                        [[3273]],
                        [[3274]],
                        [[3275]],
                        [[3276]],
                        [[3277]],
                        [[3278]],
                        [[3279]],
                        [[3280]],
                        [[3281]],
                        [[3282]],
                        [[3283]],
                        [[3284]],
                        [[3285]],
                        [[3286]],
                        [[3287]],
                        [[3288]],
                        [[3289]],
                        [[3290]],
                        [[3291]],
                        [[3292]],
                        [[3293]],
                        [[3294]],
                        [[3295]],
                        [[3296]],
                        [[3297]],
                        [[3298]],
                        [[3299]],
                        [[3300]],
                        [[3301]],
                        [[3302]],
                        [[3303]],
                        [[3304]],
                        [[3305]],
                        [[3306]],
                        [[3307]],
                        [[3308]],
                        [[3309]],
                        [[3310]],
                        [[3311]],
                        [[3312]],
                        [[3313]],
                        [[3314]],
                        [[3315]],
                        [[3316]],
                        [[3317]],
                        [[3318]],
                        [[3319]],
                        [[3320]],
                        [[3321]],
                        [[3322]],
                        [[3323]],
                        [[3324]],
                        [[3325]],
                        [[3326]],
                        [[3327]],
                        [[3328]],
                        [[3329]],
                        [[3330]],
                        [[3331]],
                        [[3332]],
                        [[3333]],
                        [[3334]],
                        [[3335]],
                        [[3336]],
                        [[3337]],
                        [[3338]],
                        [[3339]],
                        [[3340]],
                        [[3341]],
                        [[3342]],
                        [[3343]],
                        [[3344]],
                        [[3345]],
                        [[3346]],
                        [[3347]],
                        [[3348]],
                        [[3349]],
                        [[3350]],
                        [[3351]],
                        [[3352]],
                        [[3353]],
                        [[3354]],
                        [[3355]],
                        [[3356]],
                        [[3357]],
                        [[3358]],
                        [[3359]],
                        [[3360]],
                        [[3361]],
                        [[3362]],
                        [[3363]],
                        [[3364]],
                        [[3365]],
                        [[3366]],
                        [[3367]],
                        [[3368]],
                        [[3369]],
                        [[3370]],
                        [[3371]],
                        [[3372]],
                        [[3373]],
                        [
                            [3374],
                            [3375],
                            [3376],
                            [3377],
                            [3378],
                            [3379],
                            [3380],
                            [3381],
                            [3382],
                            [3383],
                        ],
                        [[3384]],
                        [[3385]],
                        [[3386]],
                        [[3387]],
                        [[3388]],
                        [[3389]],
                        [[3390]],
                        [[3391]],
                        [[3392]],
                        [[3393]],
                        [[3394]],
                        [[3395]],
                        [[3396]],
                        [[3397]],
                        [[3398]],
                        [[3399]],
                        [[3400]],
                        [[3401]],
                        [[3402]],
                        [[3403]],
                        [[3404]],
                        [[3405], [3406]],
                        [[3407]],
                        [[3408]],
                        [[3409]],
                        [[3410]],
                        [[3411]],
                        [[3412]],
                        [[3413]],
                        [[3414], [3415], [3416], [3417]],
                        [[3418]],
                        [[3419]],
                        [[3420], [3421]],
                        [[3422]],
                        [[3423]],
                        [[3424]],
                    ],
                    properties: {
                        name: 'Eastern Visayas',
                        country: 'PH',
                        state: 'eastern visayas',
                        regionNumb: 'PH-08',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[3425]],
                        [[3426]],
                        [
                            [
                                3427,
                                3428,
                                3429,
                                3430,
                                3431,
                                3432,
                                3433,
                                3434,
                                3435,
                                3436,
                                -936,
                                3437,
                                -952,
                                3438,
                                -2307,
                                3439,
                            ],
                        ],
                        [[3440]],
                        [[3441]],
                    ],
                    properties: {
                        name: 'Northern Mindanao',
                        country: 'PH',
                        state: 'northern mindanao',
                        regionNumb: 'PH-10',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[3442]],
                        [[3443]],
                        [[3444]],
                        [[3445]],
                        [[3446]],
                        [[3447]],
                        [[3448]],
                        [[3449]],
                        [[3450]],
                        [[3451]],
                        [[3452]],
                        [[3453]],
                        [[3454]],
                        [[3455]],
                        [[3456]],
                        [[3457]],
                        [[3458, 3459, 3460, 3461, 3462, 3463, -3432, 3464]],
                    ],
                    properties: {
                        name: 'Davao',
                        country: 'PH',
                        state: 'davao',
                        regionNumb: 'PH-11',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[3465]],
                        [
                            [
                                3466,
                                -3436,
                                3467,
                                -3434,
                                3468,
                                -3463,
                                3469,
                                -3461,
                                3470,
                                -949,
                                3471,
                                -947,
                                3472,
                                -945,
                                3473,
                                -943,
                                3474,
                                -941,
                                3475,
                                -939,
                                3476,
                            ],
                        ],
                    ],
                    properties: {
                        name: 'Soccsksargen',
                        country: 'PH',
                        state: 'soccsksargen',
                        regionNumb: 'PH-12',
                    },
                },
                {
                    type: 'MultiPolygon',
                    arcs: [
                        [[3477]],
                        [[3478]],
                        [[3479]],
                        [[3480]],
                        [[3481]],
                        [[3482]],
                        [[3483]],
                        [[3484]],
                        [[3485]],
                        [[3486]],
                        [[3487]],
                        [[3488]],
                        [[3489]],
                        [[3490]],
                        [[3491]],
                        [[3492], [3493]],
                        [[3494]],
                        [[3495]],
                        [[3496]],
                        [[3497]],
                        [[3498]],
                        [[3499]],
                        [[3500]],
                        [[3501]],
                        [[3502]],
                        [[3503]],
                        [[3504]],
                        [[3505]],
                        [[3506]],
                        [[3507]],
                        [[3508]],
                        [[3509]],
                        [[3510]],
                        [[3511]],
                        [[3512]],
                        [[3513]],
                        [[3514]],
                        [[3515]],
                        [[3516]],
                        [[3517]],
                        [[3518]],
                        [[3519]],
                        [[3520]],
                        [[3521]],
                        [[3522]],
                        [[3523]],
                        [[3524]],
                        [[3525]],
                        [[3526]],
                        [[3527]],
                        [[3528]],
                        [[3529]],
                        [[3530]],
                        [[3531]],
                        [[3532]],
                        [[3533]],
                        [[3534]],
                        [[3535]],
                        [[3536]],
                        [[3537]],
                        [[3538]],
                        [[3539]],
                        [[3540]],
                        [[3541]],
                        [[3542]],
                        [[3543]],
                        [[3544]],
                        [[3545]],
                        [[3546]],
                        [[3547]],
                        [[3548]],
                        [[3549]],
                        [[3550]],
                        [[3551]],
                        [[3552]],
                        [[3553]],
                        [[3554]],
                        [[3555]],
                        [[3556]],
                        [[3557]],
                        [[3558]],
                        [[3559]],
                        [[3560]],
                        [[3561]],
                        [[3562]],
                        [[3563], [3564]],
                        [[3565]],
                        [[3566]],
                        [[3567]],
                        [[3568]],
                        [[3569]],
                        [[3570]],
                        [[3571]],
                        [[3572]],
                        [[3573]],
                        [[3574]],
                        [[3575]],
                        [[3576]],
                        [[3577]],
                        [[3578]],
                        [[3579]],
                        [[3580]],
                        [[3581]],
                        [[3582]],
                        [[3583]],
                        [[3584]],
                        [[3585]],
                        [[3586]],
                        [[3587]],
                        [[3588]],
                        [[3589]],
                        [[3590]],
                        [[3591]],
                        [[3592]],
                        [[3593]],
                        [[3594]],
                        [[3595]],
                        [[3596]],
                        [[3597]],
                        [[3598]],
                        [[3599]],
                        [[3600]],
                        [[3601]],
                        [[3602]],
                        [[3603]],
                        [[3604]],
                        [[3605]],
                        [[3606]],
                        [[3607]],
                        [[3608]],
                        [[3609]],
                        [[3610]],
                        [[3611]],
                        [[3612]],
                        [[3613]],
                        [[3614]],
                        [[3615]],
                        [[3616]],
                        [[3617]],
                        [[3618]],
                        [[-3459, 3619, -3430, 3620, -3428, 3621], [3622]],
                        [[3623]],
                        [[3624]],
                        [[3625], [3626]],
                        [[3627]],
                        [[3628]],
                        [[3629]],
                        [[3630]],
                        [[3631]],
                        [[3632]],
                        [[3633]],
                        [[3634]],
                        [[3635]],
                        [[3636]],
                        [[3637]],
                        [[3638]],
                        [[3639]],
                        [[3640]],
                        [[3641]],
                        [[3642]],
                        [[3643]],
                        [[3644], [3645]],
                        [[3646]],
                        [[3647]],
                        [[3648]],
                        [[3649]],
                        [[3650]],
                        [[3651]],
                        [[3652]],
                        [[3653]],
                        [[3654]],
                        [[3655]],
                        [[3656]],
                        [[3657]],
                        [[3658]],
                        [[3659]],
                        [[3660]],
                        [[3661]],
                        [[3662]],
                        [[3663]],
                        [[3664], [3665]],
                        [[3666], [3667]],
                        [[3668]],
                        [[3669]],
                        [[3670]],
                        [[3671]],
                        [[3672]],
                        [[3673]],
                        [[3674]],
                        [[3675]],
                        [[3676]],
                        [[3677]],
                        [[3678]],
                        [[3679]],
                        [[3680]],
                        [[3681]],
                        [[3682]],
                        [
                            [3683],
                            [3684],
                            [3685],
                            [3686],
                            [3687],
                            [3688],
                            [3689],
                            [3690],
                            [3691],
                            [3692],
                            [3693],
                            [3694],
                        ],
                        [[3695]],
                        [[3696]],
                        [[3697]],
                        [[3698]],
                        [[3699]],
                        [[3700]],
                        [[3701]],
                        [[3702]],
                        [[3703]],
                        [[3704]],
                        [[3705]],
                        [[3706]],
                        [[3707]],
                        [[3708]],
                        [[3709]],
                        [[3710]],
                        [[3711]],
                        [[3712]],
                        [[3713]],
                        [[3714]],
                        [[3715]],
                        [[3716]],
                        [[3717]],
                        [[3718]],
                        [[3719]],
                        [[3720]],
                        [[3721]],
                        [[3722]],
                        [[3723]],
                        [[3724]],
                        [[3725]],
                        [[3726]],
                        [[3727]],
                        [[3728]],
                        [[3729]],
                        [[3730]],
                        [[3731]],
                        [[3732]],
                        [[3733]],
                        [[3734]],
                        [[3735]],
                        [[3736]],
                        [[3737]],
                        [[3738]],
                        [[3739]],
                        [[3740]],
                        [[3741]],
                        [[3742]],
                        [[3743]],
                        [[3744]],
                        [[3745]],
                        [[3746]],
                        [[3747]],
                        [[3748]],
                        [[3749]],
                        [[3750]],
                        [[3751]],
                        [[3752]],
                        [[3753]],
                        [[3754]],
                        [[3755], [3756], [3757], [3758], [3759], [3760], [3761], [3762]],
                    ],
                    properties: {
                        name: 'Caraga',
                        country: 'PH',
                        state: 'caraga',
                        regionNumb: 'PH-16',
                    },
                },
            ],
        },
    },
    arcs: [
        [
            [119.46876076500007, 4.593602191000059],
            [119.47071046400004, 4.590070523000065],
            [119.46588099700011, 4.587390601000038],
            [119.46767207500011, 4.594282771000053],
            [119.46876076500007, 4.593602191000059],
        ],
        [
            [119.47129114900008, 4.59654813100002],
            [119.47112776600011, 4.596065786000054],
            [119.470800499, 4.596061696000049],
            [119.47117057500009, 4.596879195000042],
            [119.47129114900008, 4.59654813100002],
        ],
        [
            [119.4701593850001, 4.602214924000066],
            [119.47197860300003, 4.598650792000058],
            [119.4707920510001, 4.597888209000075],
            [119.46725598300009, 4.599457467000036],
            [119.4701593850001, 4.602214924000066],
        ],
        [
            [119.38935273300001, 4.614592463000065],
            [119.38914092100003, 4.614587375000042],
            [119.38921365300007, 4.614780695000036],
            [119.38944843200011, 4.614795957000069],
            [119.38935273300001, 4.614592463000065],
        ],
        [
            [119.3930068410001, 4.618535244000043],
            [119.39328751000005, 4.61832589100004],
            [119.39285146200007, 4.61725361200007],
            [119.39236697500007, 4.617799811000054],
            [119.3930068410001, 4.618535244000043],
        ],
        [
            [119.39434848700012, 4.619334244000072],
            [119.39384032300006, 4.61953113200002],
            [119.39377279900009, 4.620266503000039],
            [119.3943332980001, 4.620108318000064],
            [119.39434848700012, 4.619334244000072],
        ],
        [
            [119.38482335100002, 4.62609899000006],
            [119.39158048000002, 4.622812432000046],
            [119.39186636300008, 4.616097907000039],
            [119.3836918940001, 4.616867650000074],
            [119.38482335100002, 4.62609899000006],
        ],
        [
            [119.38559128200006, 4.634695774000022],
            [119.38493736800001, 4.629150166000045],
            [119.38126545400007, 4.630394992000049],
            [119.38111754900001, 4.630967343000066],
            [119.38559128200006, 4.634695774000022],
        ],
        [
            [119.3869027940001, 4.640084076000051],
            [119.38706272500008, 4.638313147000076],
            [119.384795015, 4.636620660000062],
            [119.3850821200001, 4.638547593000055],
            [119.3869027940001, 4.640084076000051],
        ],
        [
            [119.45574208100004, 4.641930612000067],
            [119.4580374190001, 4.64161234200003],
            [119.4583908400001, 4.639307903000031],
            [119.4553686380001, 4.641234220000058],
            [119.45549011300011, 4.64313048300005],
            [119.45574208100004, 4.641930612000067],
        ],
        [
            [119.39110902200002, 4.650766095000051],
            [119.39800153100009, 4.648524132000034],
            [119.4001102410001, 4.642747520000057],
            [119.39194237900006, 4.641813443000046],
            [119.39110902200002, 4.650766095000051],
        ],
        [
            [119.39366534100009, 4.651138477000075],
            [119.39486167400003, 4.650868029000037],
            [119.3950580290001, 4.64984817800007],
            [119.39309308500003, 4.650537130000032],
            [119.39366534100009, 4.651138477000075],
        ],
        [
            [119.38957729300012, 4.658751701000028],
            [119.38981910600012, 4.658276556000033],
            [119.38910287400006, 4.657732552000027],
            [119.38898542200002, 4.658577253000033],
            [119.38957729300012, 4.658751701000028],
        ],
        [
            [119.40073265600006, 4.664636563000045],
            [119.40134985600002, 4.664382811000053],
            [119.40093339200007, 4.663448118000076],
            [119.40034653400005, 4.663655198000072],
            [119.40073265600006, 4.664636563000045],
        ],
        [
            [119.39558477300011, 4.667010713000025],
            [119.4001523820001, 4.664510389000043],
            [119.40155523600004, 4.656976489000044],
            [119.38974697000003, 4.659944514000074],
            [119.39558477300011, 4.667010713000025],
        ],
        [
            [119.20855450400006, 4.669228965000059],
            [119.20735824700012, 4.668951864000064],
            [119.20564895300004, 4.669866985000056],
            [119.20765678300006, 4.671081141000059],
            [119.20855450400006, 4.669228965000059],
        ],
        [
            [119.39241851500003, 4.673877953000044],
            [119.39205614700006, 4.673385465000024],
            [119.39170554700002, 4.673394848000044],
            [119.39186320200008, 4.673774768000044],
            [119.39241851500003, 4.673877953000044],
        ],
        [
            [119.39097787600008, 4.674978234000037],
            [119.39144522000004, 4.674740857000074],
            [119.39140702100008, 4.674543792000065],
            [119.39081385600002, 4.67502526100003],
            [119.39097787600008, 4.674978234000037],
        ],
        [
            [119.39357638900003, 4.678423412000029],
            [119.39495803800003, 4.677688477000061],
            [119.392606967, 4.67545055000005],
            [119.39200829600009, 4.676713857000038],
            [119.39357638900003, 4.678423412000029],
        ],
        [
            [119.41065838800012, 4.690017921000049],
            [119.41087041800006, 4.68988958500006],
            [119.41082381600006, 4.688971507000076],
            [119.40989511700002, 4.689809768000032],
            [119.41065838800012, 4.690017921000049],
        ],
        [
            [119.41093508600011, 4.692945261000034],
            [119.41105263600002, 4.692635407000068],
            [119.4109178550001, 4.69257447800004],
            [119.4107891750001, 4.692723225000066],
            [119.41093508600011, 4.692945261000034],
        ],
        [
            [119.03226917100005, 4.708461507000038],
            [119.03078197700006, 4.709646010000029],
            [119.03060819100006, 4.71189217500006],
            [119.03270993100011, 4.709283762000041],
            [119.03226917100005, 4.708461507000038],
        ],
        [
            [119.14649321400009, 4.722332488000063],
            [119.14808386800007, 4.721215814000061],
            [119.14798111900006, 4.71674695300004],
            [119.14572457000008, 4.721111078000035],
            [119.14649321400009, 4.722332488000063],
        ],
        [
            [119.23779548400012, 4.726248443000031],
            [119.23447094900007, 4.726195477000033],
            [119.23431357000004, 4.726498545000027],
            [119.23901161900005, 4.728370443000074],
            [119.23779548400012, 4.726248443000031],
        ],
        [
            [119.46658303700008, 4.744182910000063],
            [119.46714348600005, 4.743929876000038],
            [119.46703972400007, 4.743600875000027],
            [119.46612139100012, 4.743934587000069],
            [119.46658303700008, 4.744182910000063],
        ],
        [
            [119.42216259600002, 4.787864003000038],
            [119.41274648700005, 4.699970334000056],
            [119.40139837200002, 4.667517407000048],
            [119.38924462800003, 4.744319871000073],
            [119.42216259600002, 4.787864003000038],
        ],
        [
            [119.40350328300008, 4.715082651000046],
            [119.4028121, 4.715052631000049],
            [119.40269659000012, 4.714466277000042],
            [119.4039917230001, 4.714999274000036],
            [119.40350328300008, 4.715082651000046],
        ],
        [
            [119.40625947100011, 4.723030888000039],
            [119.40607464600009, 4.723036924000041],
            [119.40653480800006, 4.722905111000046],
            [119.40635330600003, 4.723032515000057],
            [119.40625947100011, 4.723030888000039],
        ],
        [
            [119.405449481, 4.727809996000076],
            [119.40528931100005, 4.727739801000041],
            [119.40573683600007, 4.72757467200006],
            [119.40567791500007, 4.72770373000003],
            [119.405449481, 4.727809996000076],
        ],
        [
            [119.40185686000007, 4.752256904000035],
            [119.40171474400006, 4.752581433000046],
            [119.40115025800003, 4.752063962000022],
            [119.40145937000011, 4.751986121000073],
            [119.40185686000007, 4.752256904000035],
        ],
        [
            [119.82664122100005, 4.822658842000067],
            [119.86506979700005, 4.805839613000046],
            [119.86786768000002, 4.796479087000023],
            [119.81439590200011, 4.79824274200007],
            [119.82664122100005, 4.822658842000067],
        ],
        [
            [119.4143696320001, 4.865091475000042],
            [119.41483678400004, 4.864774746000023],
            [119.41414132500006, 4.864554261000023],
            [119.41401136500008, 4.864958484000056],
            [119.4143696320001, 4.865091475000042],
        ],
        [
            [119.41226183700007, 4.866602592000049],
            [119.419123538, 4.853164348000064],
            [119.41586165000001, 4.846348644000045],
            [119.40863545900004, 4.857305112000063],
            [119.41226183700007, 4.866602592000049],
        ],
        [
            [119.79805404500007, 4.868302773000039],
            [119.80021665000004, 4.862605472000041],
            [119.79994082200005, 4.860448953000059],
            [119.79779336000001, 4.86763477900007],
            [119.79805404500007, 4.868302773000039],
        ],
        [
            [119.79761326200003, 4.870128087000069],
            [119.79816924600004, 4.869333298000072],
            [119.79799435300004, 4.868978766000055],
            [119.79745614800004, 4.869165738000049],
            [119.79761326200003, 4.870128087000069],
        ],
        [
            [119.79555379900012, 4.877942214000029],
            [119.79589682500011, 4.874932572000034],
            [119.79711089800003, 4.872803888000021],
            [119.79726072900007, 4.870640423000054],
            [119.79490519, 4.877025945000071],
            [119.79555379900012, 4.877942214000029],
        ],
        [
            [119.387737592, 4.897409255000071],
            [119.3875945960001, 4.897299431000022],
            [119.38715517500009, 4.897373636000054],
            [119.38769141600005, 4.897787706000031],
            [119.387737592, 4.897409255000071],
        ],
        [
            [119.40561775900005, 4.899904545000027],
            [119.40576651300012, 4.899619763000032],
            [119.40555839300009, 4.899392663000071],
            [119.4052966370001, 4.89972466100005],
            [119.40561775900005, 4.899904545000027],
        ],
        [
            [119.933244564, 4.902309522000053],
            [119.93331520100003, 4.902274922000061],
            [119.93329436700003, 4.902208006000023],
            [119.93316236300006, 4.902242598000043],
            [119.933244564, 4.902309522000053],
        ],
        [
            [119.93337885100004, 4.902519506000033],
            [119.93342517200006, 4.902484904000062],
            [119.93336728200006, 4.90245143900006],
            [119.93335685500006, 4.90248835400007],
            [119.93337885100004, 4.902519506000033],
        ],
        [
            [119.93156820900003, 4.902249367000024],
            [119.93392030500002, 4.900959960000023],
            [119.93105835100005, 4.89497573400007],
            [119.92871861200001, 4.90194553200007],
            [119.93156820900003, 4.902249367000024],
        ],
        [
            [119.93195110500005, 4.902815501000021],
            [119.93190482500006, 4.902841948000059],
            [119.93196019400011, 4.902907714000037],
            [119.93199282400008, 4.902851786000042],
            [119.93195110500005, 4.902815501000021],
        ],
        [
            [119.93262446100005, 4.903009993000069],
            [119.932531229, 4.903017720000037],
            [119.93256695700006, 4.903096680000033],
            [119.93263921300002, 4.903079661000049],
            [119.93262446100005, 4.903009993000069],
        ],
        [
            [119.93341980900004, 4.903611371000068],
            [119.93377204100011, 4.903204256000038],
            [119.93312406500002, 4.902440763000072],
            [119.93283550800004, 4.902482454000051],
            [119.93341980900004, 4.903611371000068],
        ],
        [
            [119.93624839200004, 4.904370018000066],
            [119.93626102400003, 4.903981464000026],
            [119.93563200400001, 4.90408165100007],
            [119.93572003200006, 4.90431772200003],
            [119.93624839200004, 4.904370018000066],
        ],
        [
            [119.40379514500012, 4.90424951500006],
            [119.40564029100005, 4.902578761000029],
            [119.40892366900005, 4.897980105000045],
            [119.40455691400007, 4.89709606200006],
            [119.40695113800007, 4.89981240700007],
            [119.40379514500012, 4.90424951500006],
        ],
        [
            [119.39729694000005, 4.906483172000037],
            [119.40431903100011, 4.900826279000057],
            [119.40349216900006, 4.898989862000064],
            [119.40999524400002, 4.874997570000062],
            [119.39729694000005, 4.906483172000037],
        ],
        [
            [119.94310463200009, 4.909832214000062],
            [119.94362536000006, 4.904776125000069],
            [119.93700758800003, 4.90485506400006],
            [119.94267677800008, 4.908293722000053],
            [119.94310463200009, 4.909832214000062],
        ],
        [
            [119.454818627, 4.913843534000023],
            [119.50696375100006, 4.762035095000044],
            [119.45798573400009, 4.642097964000072],
            [119.4545626370001, 4.674848891000067],
            [119.47144753700002, 4.763805011000045],
            [119.454818627, 4.913843534000023],
        ],
        [
            [119.45782215100007, 4.662336251000056],
            [119.45734728200011, 4.662036324000042],
            [119.45729510000001, 4.661805743000059],
            [119.45793521500002, 4.661908031000053],
            [119.45782215100007, 4.662336251000056],
        ],
        [
            [119.4618054010001, 4.671100342000045],
            [119.46205985300003, 4.671630085000061],
            [119.461948043, 4.671857236000051],
            [119.46164333400009, 4.671304990000067],
            [119.4618054010001, 4.671100342000045],
        ],
        [
            [119.462847753, 4.674564108000027],
            [119.462401924, 4.674777966000022],
            [119.46218976800003, 4.67448710900004],
            [119.46298751100005, 4.674499823000076],
            [119.462847753, 4.674564108000027],
        ],
        [
            [119.46947634300011, 4.743134393000048],
            [119.46953460200007, 4.743565395000076],
            [119.4694871910001, 4.743602896000027],
            [119.46919164000008, 4.742881302000058],
            [119.46947634300011, 4.743134393000048],
        ],
        [
            [119.94798616600008, 4.914334463000046],
            [119.94797937600003, 4.913031296000042],
            [119.94523781800001, 4.910725692000028],
            [119.94687117700005, 4.914373911000041],
            [119.94798616600008, 4.914334463000046],
        ],
        [
            [119.94757557600008, 4.915075449000028],
            [119.94751520000011, 4.915168767000068],
            [119.94767547200001, 4.915237224000066],
            [119.94768380800008, 4.915148047000059],
            [119.94757557600008, 4.915075449000028],
        ],
        [
            [119.95021259000009, 4.914619883000057],
            [119.94996754100009, 4.915071863000037],
            [119.95030148, 4.915300434000073],
            [119.95031492200008, 4.914808242000049],
            [119.95021259000009, 4.914619883000057],
        ],
        [
            [119.9494294220001, 4.91710461200006],
            [119.94996591100005, 4.915424588000064],
            [119.9481769030001, 4.915803546000063],
            [119.9485928250001, 4.916465291000065],
            [119.9494294220001, 4.91710461200006],
        ],
        [
            [119.83006353200005, 4.917683535000037],
            [119.83127536500001, 4.917053002000046],
            [119.8319132800001, 4.916409875000056],
            [119.82917699600011, 4.917165313000055],
            [119.83006353200005, 4.917683535000037],
        ],
        [
            [119.95150862700007, 4.918577037000034],
            [119.95155240200006, 4.91752346800007],
            [119.95144816200002, 4.917410589000042],
            [119.95054632400002, 4.918151126000055],
            [119.95150862700007, 4.918577037000034],
        ],
        [
            [119.96189176400003, 4.925479297000038],
            [119.95935849500006, 4.92129970600007],
            [119.95521079200012, 4.921193401000039],
            [119.96042860500006, 4.925309089000052],
            [119.96189176400003, 4.925479297000038],
        ],
        [
            [119.80171236000001, 4.926614810000046],
            [119.85277449000012, 4.901226748000056],
            [119.85199989500006, 4.863409103000038],
            [119.80413627500002, 4.854942393000044],
            [119.80171236000001, 4.926614810000046],
        ],
        [
            [119.81779349100009, 4.905763235000052],
            [119.81774308400009, 4.906190931000026],
            [119.81730893500003, 4.905981943000029],
            [119.81758048200004, 4.905696812000031],
            [119.81779349100009, 4.905763235000052],
        ],
        [
            [119.82842447000007, 4.90815748700004],
            [119.82814313600011, 4.907718881000051],
            [119.8282626670001, 4.907486506000055],
            [119.82885303000012, 4.907753736000075],
            [119.82842447000007, 4.90815748700004],
        ],
        [
            [119.9720427100001, 4.938182185000073],
            [119.97300621900001, 4.936032513000043],
            [119.97200178100002, 4.933864313000072],
            [119.9713359000001, 4.937684986000022],
            [119.9720427100001, 4.938182185000073],
        ],
        [
            [119.97021696000002, 4.940489183000068],
            [119.9718501860001, 4.934206375000031],
            [119.96986948500012, 4.932127194000032],
            [119.96955216900005, 4.938373701000046],
            [119.97021696000002, 4.940489183000068],
        ],
        [
            [119.97055921700007, 4.941929892000076],
            [119.970560739, 4.941376431000037],
            [119.97010034200002, 4.940748706000022],
            [119.97026540700006, 4.941794089000041],
            [119.97055921700007, 4.941929892000076],
        ],
        [
            [119.97146032, 4.943846619000055],
            [119.97122861300011, 4.942935099000067],
            [119.97081819000005, 4.942458292000026],
            [119.97134066500007, 4.94465838800005],
            [119.97146032, 4.943846619000055],
        ],
        [
            [119.87352189, 4.944523296000057],
            [119.86975405400005, 4.940588171000059],
            [119.86723724700005, 4.939148147000026],
            [119.86794243100007, 4.943879043000038],
            [119.87352189, 4.944523296000057],
        ],
        [
            [119.97183590500003, 4.945034104000058],
            [119.97156026000005, 4.945462248000069],
            [119.97237202500003, 4.946539591000032],
            [119.97236749300009, 4.945357007000041],
            [119.97183590500003, 4.945034104000058],
        ],
        [
            [119.97778729000004, 4.947016991000055],
            [119.97855471900004, 4.946669320000069],
            [119.9786052500001, 4.946480536000024],
            [119.976921962, 4.946869109000033],
            [119.97778729000004, 4.947016991000055],
        ],
        [
            [119.97829249400002, 4.953225436000025],
            [119.9805973340001, 4.947312902000021],
            [119.97353593700007, 4.947913712000059],
            [119.97787604100006, 4.951303924000058],
            [119.97829249400002, 4.953225436000025],
        ],
        [
            [119.98307733800004, 4.961952169000028],
            [119.98338475100002, 4.961596566000026],
            [119.98321360600005, 4.961203932000046],
            [119.98278683900003, 4.961447351000061],
            [119.98307733800004, 4.961952169000028],
        ],
        [
            [119.9877117640001, 4.963230743000054],
            [119.98697442500008, 4.960971262000044],
            [119.98498518500003, 4.961006238000039],
            [119.98487528100009, 4.963872543000036],
            [119.9877117640001, 4.963230743000054],
        ],
        [
            [119.98540077100006, 4.972704410000063],
            [119.98548605200006, 4.971594683000035],
            [119.984511515, 4.96998170300003],
            [119.98360391900007, 4.971643850000021],
            [119.98540077100006, 4.972704410000063],
        ],
        [
            [119.98629607700002, 4.97827824500007],
            [119.99077816800002, 4.976346712000066],
            [119.98712672400006, 4.973331373000065],
            [119.98571888800006, 4.976998076000029],
            [119.98629607700002, 4.97827824500007],
        ],
        [
            [119.98775874300009, 4.985644212000068],
            [119.98751091600002, 4.985553444000061],
            [119.98746535700002, 4.985825748000025],
            [119.9877550970001, 4.98572045800006],
            [119.98775874300009, 4.985644212000068],
        ],
        [
            [119.98896714200009, 4.986067671000058],
            [119.99160046400004, 4.983347587000026],
            [119.98947091600007, 4.979213327000025],
            [119.9881016170001, 4.979790340000022],
            [119.98896714200009, 4.986067671000058],
        ],
        [
            [119.98767491700005, 4.986065377000045],
            [119.9875090910001, 4.986132545000032],
            [119.98753642500003, 4.986208790000035],
            [119.9876949610001, 4.986152514000025],
            [119.98767491700005, 4.986065377000045],
        ],
        [
            [119.98797716100012, 4.987014980000026],
            [119.9879922770001, 4.986830495000049],
            [119.9875652180001, 4.986850574000073],
            [119.98764962200005, 4.987011214000063],
            [119.98797716100012, 4.987014980000026],
        ],
        [
            [119.99971225500008, 4.991330607000066],
            [119.99964758400006, 4.991043873000024],
            [119.9991997950001, 4.990951148000022],
            [119.99937881400001, 4.991612962000033],
            [119.99971225500008, 4.991330607000066],
        ],
        [
            [120.12520590200006, 5.000890901000048],
            [120.12888712000006, 5.000041280000062],
            [120.136946856, 4.99957243700004],
            [120.12938544300005, 4.999552895000022],
            [120.12520590200006, 5.000890901000048],
        ],
        [
            [119.98965940000005, 5.001725485000065],
            [119.9928076540001, 4.997800441000038],
            [119.99252147400011, 4.995384986000033],
            [119.98756549100005, 4.998912268000026],
            [119.98965940000005, 5.001725485000065],
        ],
        [
            [120.12464000400007, 5.002145899000027],
            [120.12483804100009, 5.001918378000028],
            [120.12480972900005, 5.001725103000069],
            [120.12430247900011, 5.001956679000045],
            [120.12464000400007, 5.002145899000027],
        ],
        [
            [119.98779670800002, 5.008290962000046],
            [119.99038266200012, 5.005923749000033],
            [119.98920852700007, 5.003724029000068],
            [119.98787543800006, 5.00485582400006],
            [119.98779670800002, 5.008290962000046],
        ],
        [
            [120.030273437, 5.005493164000029],
            [120.02893066400009, 5.005676270000038],
            [120.02850341800001, 5.009094239000035],
            [120.03070068400007, 5.006530762000068],
            [120.030273437, 5.005493164000029],
        ],
        [
            [120.02688863800006, 5.009118213000022],
            [120.02755722300003, 5.009054985000034],
            [120.02740279600005, 5.008373069000072],
            [120.02657262200012, 5.008875725000053],
            [120.02688863800006, 5.009118213000022],
        ],
        [
            [120.16594743500002, 5.009914474000027],
            [120.16283461500007, 5.00947114500002],
            [120.1603389060001, 5.009536354000033],
            [120.16605188800008, 5.010094064000043],
            [120.16594743500002, 5.009914474000027],
        ],
        [
            [120.16723576600009, 5.010175968000055],
            [120.16657916500003, 5.010214285000075],
            [120.16790519000006, 5.010469805000071],
            [120.16784363500005, 5.010336943000027],
            [120.16723576600009, 5.010175968000055],
        ],
        [
            [119.9993996280001, 5.010388870000043],
            [119.9992149410001, 5.010598246000029],
            [119.99933863100011, 5.010726806000037],
            [119.9994712240001, 5.010571055000071],
            [119.9993996280001, 5.010388870000043],
        ],
        [
            [119.9998851680001, 5.010714495000059],
            [119.99971834700011, 5.01068880300005],
            [119.99964270200007, 5.011065206000069],
            [119.99976895100008, 5.010977894000064],
            [119.9998851680001, 5.010714495000059],
        ],
        [
            [120.1950103590001, 5.012270487000023],
            [120.19578157500007, 5.012179805000073],
            [120.19598933200007, 5.011890654000069],
            [120.19509859300001, 5.011955816000068],
            [120.1950103590001, 5.012270487000023],
        ],
        [
            [120.17045515300003, 5.012303537000037],
            [120.17060606300004, 5.01211405500004],
            [120.170567258, 5.011772387000065],
            [120.17024753500004, 5.012440225000034],
            [120.17045515300003, 5.012303537000037],
        ],
        [
            [120.18010608600002, 5.012840125000025],
            [120.17494966000004, 5.012038842000038],
            [120.17262775600011, 5.011181216000068],
            [120.16959698900007, 5.010663785000077],
            [120.17571150200001, 5.012342875000058],
            [120.18010608600002, 5.012840125000025],
        ],
        [
            [120.18185280900002, 5.01289848600004],
            [120.1816263820001, 5.012794947000032],
            [120.18114568600004, 5.012817126000073],
            [120.18128859500007, 5.012891083000056],
            [120.18185280900002, 5.01289848600004],
        ],
        [
            [120.18933109700004, 5.013254639000024],
            [120.19394164100004, 5.012585115000036],
            [120.18268086800003, 5.012907033000033],
            [120.1847611500001, 5.013100521000069],
            [120.18933109700004, 5.013254639000024],
        ],
        [
            [120.11593836300005, 5.013275445000033],
            [120.11595418900004, 5.01138777500006],
            [120.12010437600009, 5.004649591000032],
            [120.11592322900003, 5.011105200000031],
            [120.11593836300005, 5.013275445000033],
        ],
        [
            [119.98650568000005, 5.01385506400004],
            [119.9877243410001, 5.012229399000034],
            [119.98715139700005, 5.010554072000048],
            [119.98569189000011, 5.011829497000065],
            [119.98650568000005, 5.01385506400004],
        ],
        [
            [120.01348056800009, 5.01654872000006],
            [120.02612386400006, 5.007534607000025],
            [120.02481248800007, 4.998020976000021],
            [119.99465763600006, 4.953141092000067],
            [120.01348056800009, 5.01654872000006],
        ],
        [
            [120.01243671700001, 5.011248010000031],
            [120.01230507700006, 5.011345303000041],
            [120.01251881700011, 5.010919469000044],
            [120.01257118700005, 5.011173278000058],
            [120.01243671700001, 5.011248010000031],
        ],
        [
            [120.01461350400007, 5.011680710000064],
            [120.0145002910001, 5.011532975000023],
            [120.01497073300004, 5.011381569000037],
            [120.01495904300009, 5.011580418000051],
            [120.01461350400007, 5.011680710000064],
        ],
        [
            [119.98448476500005, 5.017127213000038],
            [119.98454620300004, 5.017034332000037],
            [119.98440150200008, 5.017000549000045],
            [119.98439649800002, 5.017098330000067],
            [119.98448476500005, 5.017127213000038],
        ],
        [
            [120.11297078100006, 5.017263716000059],
            [120.11462853400008, 5.016011334000041],
            [120.11475433500004, 5.015580121000028],
            [120.11392638500001, 5.015898570000047],
            [120.11297078100006, 5.017263716000059],
        ],
        [
            [120.01192661000005, 5.017942276000042],
            [120.01222292400007, 5.017827346000047],
            [120.01180862600006, 5.01723959800006],
            [120.01156998200008, 5.018203484000026],
            [120.01192661000005, 5.017942276000042],
        ],
        [
            [119.9835145720001, 5.018489360000046],
            [119.98341103500002, 5.018554492000021],
            [119.98349821200009, 5.018692011000041],
            [119.98359085300001, 5.018579835000025],
            [119.9835145720001, 5.018489360000046],
        ],
        [
            [119.98766833400009, 5.018649340000024],
            [119.98753602800002, 5.01882084600004],
            [119.9875903950001, 5.018880426000067],
            [119.9876792020001, 5.018815435000022],
            [119.98766833400009, 5.018649340000024],
        ],
        [
            [120.10623493300011, 5.018898586000034],
            [120.1052923950001, 5.018579862000024],
            [120.10473321300003, 5.018849763000048],
            [120.1062839330001, 5.019013438000059],
            [120.10623493300011, 5.018898586000034],
        ],
        [
            [119.987961917, 5.019033898000032],
            [119.98809240800006, 5.018940023000027],
            [119.98797098600005, 5.018833501000074],
            [119.98781512200003, 5.018941817000041],
            [119.987961917, 5.019033898000032],
        ],
        [
            [120.11001929100007, 5.019311682000023],
            [120.1118024640001, 5.018328304000022],
            [120.10714457000006, 5.018830796000032],
            [120.10723496800006, 5.019069263000063],
            [120.11001929100007, 5.019311682000023],
        ],
        [
            [119.98836787100004, 5.019227091000062],
            [119.98825731700003, 5.019284858000049],
            [119.98832255600007, 5.019400406000045],
            [119.98839867600009, 5.019342638000069],
            [119.98836787100004, 5.019227091000062],
        ],
        [
            [119.98746169800006, 5.019380512000055],
            [119.987760739, 5.019250536000072],
            [119.98754327300003, 5.018932780000057],
            [119.98726054000008, 5.019097058000057],
            [119.98746169800006, 5.019380512000055],
        ],
        [
            [120.10306476400001, 5.019399276000058],
            [120.10359363700002, 5.019114667000053],
            [120.10410394900009, 5.018961022000042],
            [120.10349672300003, 5.018954175000033],
            [120.10257019000005, 5.019672516000071],
            [120.10306476400001, 5.019399276000058],
        ],
        [
            [120.01616125900011, 5.019294550000041],
            [120.01568603500004, 5.018676758000026],
            [120.01507568400007, 5.019104004000042],
            [120.01550292900004, 5.019714355000076],
            [120.01616125900011, 5.019294550000041],
        ],
        [
            [119.98809225800005, 5.019868426000073],
            [119.98796176300004, 5.020007435000025],
            [119.98808318600004, 5.020117569000035],
            [119.98821186700002, 5.020005640000022],
            [119.98809225800005, 5.019868426000073],
        ],
        [
            [120.0169067380001, 5.021118165000075],
            [120.01568603500004, 5.020874024000022],
            [120.01489257800006, 5.021728516000053],
            [120.01647949200003, 5.022094727000024],
            [120.0169067380001, 5.021118165000075],
        ],
        [
            [119.98432542400008, 5.022709673000065],
            [119.98718153900006, 5.020112169000072],
            [119.98591472700002, 5.016941572000064],
            [119.98358608900003, 5.017762385000026],
            [119.98432542400008, 5.022709673000065],
        ],
        [
            [120.01245958400011, 5.021423993000042],
            [120.012392814, 5.019045810000023],
            [120.00930468400009, 5.01939799400003],
            [120.010187631, 5.022682261000057],
            [120.01245958400011, 5.021423993000042],
        ],
        [
            [120.09796094900003, 5.023733012000037],
            [120.10084555100002, 5.021471839000071],
            [120.10120854700006, 5.020683413000029],
            [120.09727707200011, 5.024066489000063],
            [120.09796094900003, 5.023733012000037],
        ],
        [
            [120.01611328100012, 5.023681641000053],
            [120.01507568400007, 5.024108887000068],
            [120.01507568400007, 5.024902344000054],
            [120.01647949200003, 5.024719239000035],
            [120.01611328100012, 5.023681641000053],
        ],
        [
            [120.01427451300003, 5.028531074000057],
            [120.01531982400002, 5.028076172000056],
            [120.01531982400002, 5.027526856000065],
            [120.01367187500011, 5.027709961000028],
            [120.01427451300003, 5.028531074000057],
        ],
        [
            [120.01457504900009, 5.029923598000039],
            [120.01487695600008, 5.029013079000038],
            [120.01452455100002, 5.028505874000075],
            [120.013755048, 5.029218320000041],
            [120.01457504900009, 5.029923598000039],
        ],
        [
            [120.01450479800008, 5.030251367000062],
            [120.01462865000008, 5.030221906000065],
            [120.01462680500003, 5.030131677000043],
            [120.01446043700003, 5.030122467000069],
            [120.01450479800008, 5.030251367000062],
        ],
        [
            [120.01475721700001, 5.030603419000045],
            [120.01464445800002, 5.030619989000058],
            [120.01467772900003, 5.030741522000028],
            [120.01477015600005, 5.030702854000026],
            [120.01475721700001, 5.030603419000045],
        ],
        [
            [120.01540381600012, 5.03117308100002],
            [120.01532673800011, 5.031229952000047],
            [120.01543235800011, 5.031352231000028],
            [120.01550372600002, 5.031266922000043],
            [120.01540381600012, 5.03117308100002],
        ],
        [
            [120.01531246500008, 5.031352230000039],
            [120.01519256900008, 5.031394882000029],
            [120.01519827600009, 5.031517160000021],
            [120.01532102600004, 5.031502943000021],
            [120.01531246500008, 5.031352230000039],
        ],
        [
            [120.01463565100005, 5.031789795000066],
            [120.01429717300005, 5.031462827000041],
            [120.01408860800007, 5.031609275000051],
            [120.01451256400003, 5.031888563000052],
            [120.01463565100005, 5.031789795000066],
        ],
        [
            [120.01488997100012, 5.031713366000076],
            [120.01470156200003, 5.03183279600006],
            [120.01470155900006, 5.03192948100002],
            [120.01492707700004, 5.031949389000033],
            [120.01488997100012, 5.031713366000076],
        ],
        [
            [120.01075829500007, 5.034426465000024],
            [120.01156799800003, 5.03385903700007],
            [120.01112017700007, 5.033195221000028],
            [120.0102388140001, 5.034205184000029],
            [120.01075829500007, 5.034426465000024],
        ],
        [
            [120.00918324600002, 5.033918938000056],
            [120.0089928970001, 5.03403597700003],
            [120.00906103300008, 5.034518202000072],
            [120.00925843700008, 5.034169414000075],
            [120.00918324600002, 5.033918938000056],
        ],
        [
            [119.75876430800008, 5.03531220900004],
            [119.78018826300001, 5.026323956000056],
            [119.74518033200002, 5.005452905000027],
            [119.73746552000011, 5.03006593200007],
            [119.75876430800008, 5.03531220900004],
        ],
        [
            [120.01516474300001, 5.03591136700004],
            [120.01510455000005, 5.035936440000057],
            [120.01513081500002, 5.035996399000055],
            [120.01519757400001, 5.035978958000044],
            [120.01516474300001, 5.03591136700004],
        ],
        [
            [120.01554450000003, 5.036054187000047],
            [120.01545147400009, 5.036102153000058],
            [120.01550291, 5.036186099000076],
            [120.01554887500004, 5.036158844000056],
            [120.01554450000003, 5.036054187000047],
        ],
        [
            [120.01581409200003, 5.036356638000029],
            [120.01561859200001, 5.036468717000048],
            [120.01590409100004, 5.037108991000025],
            [120.01602083400007, 5.036722310000073],
            [120.01581409200003, 5.036356638000029],
        ],
        [
            [120.10617482900011, 5.03702111900003],
            [120.13639603600006, 5.020451693000041],
            [120.13408088000006, 5.003763152000033],
            [120.1009628170001, 5.029457086000036],
            [120.10617482900011, 5.03702111900003],
        ],
        [
            [120.01511415800007, 5.034282349000023],
            [120.01573273100007, 5.035989448000066],
            [120.01629638600002, 5.029479981000065],
            [120.01504891700006, 5.033530407000057],
            [120.00988769500009, 5.035888672000056],
            [120.00988769500009, 5.039306641000053],
            [120.01511415800007, 5.034282349000023],
        ],
        [
            [119.787713198, 5.039670037000064],
            [119.80172756800005, 5.037096179000059],
            [119.80494498900009, 5.032013291000055],
            [119.77774789300008, 5.036609355000053],
            [119.787713198, 5.039670037000064],
        ],
        [
            [120.04556216000003, 5.043389741000055],
            [120.04549889100008, 5.043456719000062],
            [120.04554611600008, 5.043514156000072],
            [120.04562700500003, 5.043428837000022],
            [120.04556216000003, 5.043389741000055],
        ],
        [
            [120.04554287200006, 5.043677654000021],
            [120.04546760500011, 5.043694385000038],
            [120.04545158300004, 5.043730270000026],
            [120.04553644200007, 5.04377415700003],
            [120.04554287200006, 5.043677654000021],
        ],
        [
            [120.0472641240001, 5.04405711000004],
            [120.0473184330001, 5.044019146000039],
            [120.04724336700008, 5.043905193000057],
            [120.04716015400004, 5.044021408000049],
            [120.0472641240001, 5.04405711000004],
        ],
        [
            [120.045196841, 5.044185783000046],
            [120.04515288100004, 5.04420036700003],
            [120.04514601700009, 5.044302534000053],
            [120.04524956900002, 5.044270450000056],
            [120.045196841, 5.044185783000046],
        ],
        [
            [120.04579953700011, 5.044191774000069],
            [120.04572431300005, 5.044226785000035],
            [120.04583661400011, 5.044356227000037],
            [120.04586008700005, 5.044243361000042],
            [120.04579953700011, 5.044191774000069],
        ],
        [
            [120.04548498800011, 5.044244238000033],
            [120.04542148000007, 5.044301631000053],
            [120.0455191320001, 5.044417448000047],
            [120.04554553600008, 5.044302637000044],
            [120.04548498800011, 5.044244238000033],
        ],
        [
            [120.0466576230001, 5.044426007000027],
            [120.0466895940001, 5.044367839000074],
            [120.04659483600005, 5.044333787000028],
            [120.04656506000003, 5.044428179000022],
            [120.0466576230001, 5.044426007000027],
        ],
        [
            [120.04450224700008, 5.04447654300003],
            [120.04469859000005, 5.044474647000072],
            [120.04466445300011, 5.044276138000043],
            [120.04438019000008, 5.044306230000075],
            [120.04450224700008, 5.04447654300003],
        ],
        [
            [120.04438208700003, 5.044525164000049],
            [120.04413695000005, 5.044353846000035],
            [120.04407051700002, 5.04438691200005],
            [120.04422870200005, 5.044617563000031],
            [120.04438208700003, 5.044525164000049],
        ],
        [
            [120.04693067100004, 5.044676713000058],
            [120.04727731100002, 5.044676800000047],
            [120.04729952200012, 5.044422629000053],
            [120.04695963600011, 5.044370749000052],
            [120.04693067100004, 5.044676713000058],
        ],
        [
            [120.05134250300011, 5.044740572000023],
            [120.05131813500009, 5.044814547000044],
            [120.05142771300007, 5.044807298000023],
            [120.0514216360001, 5.044769699000028],
            [120.05134250300011, 5.044740572000023],
        ],
        [
            [120.04420617400001, 5.044851085000062],
            [120.04428825800005, 5.044734343000073],
            [120.04407044000004, 5.044684661000076],
            [120.04409871300004, 5.044896790000053],
            [120.04420617400001, 5.044851085000062],
        ],
        [
            [120.21023181700002, 5.045145045000027],
            [120.21464734900007, 5.015194190000045],
            [120.18461282300007, 5.021685541000068],
            [120.20416554100007, 5.041964501000052],
            [120.21023181700002, 5.045145045000027],
        ],
        [
            [120.05008054600012, 5.045362982000029],
            [120.05101469300007, 5.04536465700005],
            [120.05212402300003, 5.042114258000026],
            [120.04888916000004, 5.04272461000005],
            [120.05008054600012, 5.045362982000029],
        ],
        [
            [120.07151326500002, 5.061487800000066],
            [120.07570713200005, 5.060284049000074],
            [120.07676999700004, 5.059294067000053],
            [120.06818876200009, 5.060659193000049],
            [120.07151326500002, 5.061487800000066],
        ],
        [
            [119.92142615000012, 5.072680515000059],
            [119.92527617200005, 5.070533615000045],
            [119.92187345500008, 5.066020801000036],
            [119.91907723700001, 5.068826582000042],
            [119.92142615000012, 5.072680515000059],
        ],
        [
            [119.81629077500008, 5.074552880000056],
            [119.81858584100007, 5.07364814400006],
            [119.81937563100007, 5.070657784000048],
            [119.81792575800011, 5.071277996000049],
            [119.81629077500008, 5.074552880000056],
        ],
        [
            [119.95373863000009, 5.07851398300005],
            [119.9560630090001, 5.077836235000063],
            [119.9513967260001, 5.074455424000064],
            [119.95199081100009, 5.078085892000047],
            [119.95373863000009, 5.07851398300005],
        ],
        [
            [119.93895507600007, 5.08571947400003],
            [119.93902299000001, 5.08543824000003],
            [119.93837788000008, 5.085334986000021],
            [119.93844577900006, 5.085660724000036],
            [119.93895507600007, 5.08571947400003],
        ],
        [
            [119.94088540300004, 5.086265295000032],
            [119.9438320810001, 5.079956461000052],
            [119.93401043400002, 5.073780210000052],
            [119.932237299, 5.078265],
            [119.94088540300004, 5.086265295000032],
        ],
        [
            [120.30348206400004, 5.088792347000037],
            [120.30377499600002, 5.088513787000068],
            [120.302495399, 5.088274206000051],
            [120.30306921500005, 5.088807308000071],
            [120.30348206400004, 5.088792347000037],
        ],
        [
            [120.30441330000008, 5.089109381000071],
            [120.30460044300003, 5.08901785200004],
            [120.3039461190001, 5.08874226000006],
            [120.30401076900012, 5.089096659000063],
            [120.30441330000008, 5.089109381000071],
        ],
        [
            [120.30680185500012, 5.090219443000024],
            [120.305908208, 5.089701485000035],
            [120.3054030400001, 5.089748196000073],
            [120.3058682300001, 5.090228885000045],
            [120.30680185500012, 5.090219443000024],
        ],
        [
            [120.2596707990001, 5.089736022000068],
            [120.27281422300007, 5.081228168000052],
            [120.2522620630001, 5.064493019000054],
            [120.24395029000004, 5.074858987000027],
            [120.2596707990001, 5.089736022000068],
        ],
        [
            [119.97495750400003, 5.090789653000058],
            [119.97489218100009, 5.090207077000059],
            [119.97445162100007, 5.09031602500005],
            [119.97449263600004, 5.090792677000024],
            [119.97495750400003, 5.090789653000058],
        ],
        [
            [120.26838440900008, 5.090108663000024],
            [120.2675684410001, 5.090159141000072],
            [120.26830467700006, 5.091116584000076],
            [120.26842430200008, 5.091042799000036],
            [120.26838440900008, 5.090108663000024],
        ],
        [
            [119.97793148200003, 5.091117126000029],
            [119.97773115700011, 5.090756222000039],
            [119.97749250400011, 5.090877678000027],
            [119.9776649580001, 5.091259403000038],
            [119.97793148200003, 5.091117126000029],
        ],
        [
            [119.97745857600012, 5.091596538000033],
            [119.97764845200004, 5.091589599000031],
            [119.97752303100003, 5.091390061000027],
            [119.977333154, 5.091579186000047],
            [119.97745857600012, 5.091596538000033],
        ],
        [
            [119.97785071700002, 5.093311887000027],
            [119.97826357100007, 5.092723685000067],
            [119.97740888300007, 5.091812902000072],
            [119.97674862600002, 5.093124337000063],
            [119.97785071700002, 5.093311887000027],
        ],
        [
            [119.98053564000008, 5.09375824500006],
            [119.980476414, 5.09342336900005],
            [119.97983710400001, 5.09338866500002],
            [119.98008272400011, 5.093768655000076],
            [119.98053564000008, 5.09375824500006],
        ],
        [
            [119.97805815600009, 5.093681563000075],
            [119.97775330900004, 5.093678091000072],
            [119.97800241200002, 5.094012969000062],
            [119.9780912550001, 5.093733617000055],
            [119.97805815600009, 5.093681563000075],
        ],
        [
            [119.97723070600011, 5.094309668000051],
            [119.97731606700006, 5.093978262000064],
            [119.97695895900006, 5.093830775000072],
            [119.97696418100008, 5.094299256000056],
            [119.97723070600011, 5.094309668000051],
        ],
        [
            [119.97924133800007, 5.094764606000069],
            [119.97986497200009, 5.09464835700004],
            [119.97991200500007, 5.094412380000051],
            [119.97877274100006, 5.094447079000076],
            [119.97924133800007, 5.094764606000069],
        ],
        [
            [119.98163477100002, 5.096319195000035],
            [119.98201509300009, 5.096258374000058],
            [119.98197467300008, 5.095943214000044],
            [119.98156498500009, 5.095969917000048],
            [119.98163477100002, 5.096319195000035],
        ],
        [
            [119.98244746800003, 5.097713935000058],
            [119.98238440000011, 5.096740771000043],
            [119.981474692, 5.096740763000071],
            [119.9816386870001, 5.097534894000034],
            [119.98244746800003, 5.097713935000058],
        ],
        [
            [119.99178753000001, 5.101738417000035],
            [119.99722111100004, 5.090397215000053],
            [119.98755046100007, 5.084631164000029],
            [119.98395569500008, 5.089524469000025],
            [119.99178753000001, 5.101738417000035],
        ],
        [
            [119.80900945200005, 5.104685391000032],
            [119.81668566600001, 5.10152471300006],
            [119.81544248600005, 5.091867791000027],
            [119.8057120630001, 5.096207457000048],
            [119.80900945200005, 5.104685391000032],
        ],
        [
            [120.27216402200008, 5.105041804000052],
            [120.27266589500005, 5.104593589000046],
            [120.27134920300011, 5.104219117000071],
            [120.27163067600009, 5.104977235000035],
            [120.27216402200008, 5.105041804000052],
        ],
        [
            [120.26864172300009, 5.105684573000076],
            [120.26855387900002, 5.105564936000064],
            [120.26818384300009, 5.105624123000041],
            [120.26859220400002, 5.105787215000021],
            [120.26864172300009, 5.105684573000076],
        ],
        [
            [120.2696555980001, 5.106404538000049],
            [120.26888869700008, 5.105914838000047],
            [120.26836012000001, 5.106085518000043],
            [120.26930197200011, 5.107032684000046],
            [120.2696555980001, 5.106404538000049],
        ],
        [
            [119.98245455000006, 5.110892964000072],
            [119.9836951210001, 5.11000901500006],
            [119.98323629100003, 5.108951791000038],
            [119.98148054900003, 5.110030623000057],
            [119.98245455000006, 5.110892964000072],
        ],
        [
            [119.80959315100006, 5.12307564300005],
            [119.80381156500005, 5.097912433000033],
            [119.81681393100007, 5.058299031000047],
            [119.74157609200006, 5.036432959000024],
            [119.80959315100006, 5.12307564300005],
        ],
        [
            [120.31650205400001, 5.127108381000028],
            [120.31599131000007, 5.128323627000043],
            [120.31642498800011, 5.130420628000024],
            [120.31676695400006, 5.129349455000067],
            [120.31650205400001, 5.127108381000028],
        ],
        [
            [120.31285168800002, 5.130493914000056],
            [120.31843488100003, 5.10328381100004],
            [120.28255867300004, 5.082734927000047],
            [120.26939125900003, 5.089487215000077],
            [120.31285168800002, 5.130493914000056],
        ],
        [
            [120.31587563800008, 5.13123362500005],
            [120.31633898500002, 5.131042078000064],
            [120.31637529500006, 5.130623143000037],
            [120.31552395200004, 5.13131974700002],
            [120.31587563800008, 5.13123362500005],
        ],
        [
            [120.3130852490001, 5.132792867000035],
            [120.31343732800008, 5.131701053000029],
            [120.31204863000005, 5.131447785000034],
            [120.31216763000009, 5.132404688000065],
            [120.3130852490001, 5.132792867000035],
        ],
        [
            [119.81022560300005, 5.13304290800005],
            [119.80846192400008, 5.128458303000059],
            [119.80480239400003, 5.127161641000043],
            [119.80502892800007, 5.13045578200007],
            [119.81022560300005, 5.13304290800005],
        ],
        [
            [120.2312562400001, 5.141810949000046],
            [120.23233832500011, 5.137833468000053],
            [120.22898481400011, 5.137027418000059],
            [120.2276062300001, 5.140332901000022],
            [120.2312562400001, 5.141810949000046],
        ],
        [
            [120.14992305800001, 5.149753328000031],
            [120.15071933100012, 5.148150311000052],
            [120.15086418300007, 5.145355583000025],
            [120.14845984300007, 5.147126134000075],
            [120.14992305800001, 5.149753328000031],
        ],
        [
            [120.23286079400009, 5.15073127200003],
            [120.23335591400007, 5.149882389000027],
            [120.23270720900007, 5.14927061700007],
            [120.23188572300012, 5.150229844000023],
            [120.23286079400009, 5.15073127200003],
        ],
        [
            [120.45063690400002, 5.151740665000034],
            [120.4513121980001, 5.151179733000049],
            [120.44984321800007, 5.147801402000027],
            [120.44989870800009, 5.154996236000045],
            [120.45063690400002, 5.151740665000034],
        ],
        [
            [120.45422995400008, 5.155338666000034],
            [120.45404175800002, 5.155457915000056],
            [120.4541613450001, 5.157102125000051],
            [120.454901317, 5.156403631000046],
            [120.45422995400008, 5.155338666000034],
        ],
        [
            [120.4504906730001, 5.158110368000052],
            [120.45112615100004, 5.157808604000024],
            [120.4505837050001, 5.156649904000062],
            [120.45015342400006, 5.157857183000033],
            [120.4504906730001, 5.158110368000052],
        ],
        [
            [120.50207519500009, 5.158081055000025],
            [120.50152587900004, 5.159301758000026],
            [120.502929687, 5.159729004000042],
            [120.502929687, 5.158874512000068],
            [120.50207519500009, 5.158081055000025],
        ],
        [
            [119.85216210400006, 5.161015345000067],
            [119.85275309600001, 5.159919198000068],
            [119.85012440900005, 5.159340636000024],
            [119.85184049400004, 5.161013934000039],
            [119.85216210400006, 5.161015345000067],
        ],
        [
            [120.3424104830001, 5.161136217000035],
            [120.34835397400002, 5.13306265500006],
            [120.3359663650001, 5.116951078000056],
            [120.31818650900004, 5.137834524000027],
            [120.3424104830001, 5.161136217000035],
        ],
        [
            [120.32326049800008, 5.141956569000058],
            [120.32272588500007, 5.141878629000075],
            [120.32296904900011, 5.141316819000053],
            [120.32334917700007, 5.141386072000046],
            [120.32326049800008, 5.141956569000058],
        ],
        [
            [119.84721542500006, 5.161385131000031],
            [119.84825670200007, 5.161152550000054],
            [119.849341148, 5.160428319000061],
            [119.84770197000012, 5.160210293000034],
            [119.84721542500006, 5.161385131000031],
        ],
        [
            [120.06363041800012, 5.161308666000025],
            [120.05641929100011, 5.149123118000034],
            [120.04059322800003, 5.153179235000039],
            [120.04462112600004, 5.16092453400006],
            [120.06363041800012, 5.161308666000025],
        ],
        [
            [120.283493152, 5.161667726000076],
            [120.28553733400008, 5.15996334700003],
            [120.28468069100006, 5.159025661000044],
            [120.28441091000002, 5.156903326000077],
            [120.28817519300003, 5.155489783000064],
            [120.28035335100003, 5.151572371000043],
            [120.283493152, 5.161667726000076],
        ],
        [
            [120.23463183000001, 5.161942220000071],
            [120.23641852600008, 5.158257578000075],
            [120.2344302240001, 5.156193616000053],
            [120.23232197700008, 5.157430067000064],
            [120.23463183000001, 5.161942220000071],
        ],
        [
            [120.14000427200006, 5.162280795000072],
            [120.1405098250001, 5.16076214900005],
            [120.13901416400006, 5.158695112000032],
            [120.13784274900001, 5.161159777000023],
            [120.14000427200006, 5.162280795000072],
        ],
        [
            [120.2364826490001, 5.164706508000052],
            [120.2368971620001, 5.163960336000059],
            [120.23643895600003, 5.163691081000024],
            [120.23614615300005, 5.164333547000069],
            [120.2364826490001, 5.164706508000052],
        ],
        [
            [119.85045101800006, 5.164907865000032],
            [119.85257944400007, 5.163280969000027],
            [119.84524166300002, 5.162106263000055],
            [119.8461473970001, 5.164095484000029],
            [119.85045101800006, 5.164907865000032],
        ],
        [
            [120.14964960500004, 5.165762982000047],
            [120.15415467700007, 5.164169901000037],
            [120.15487430400003, 5.163001678000057],
            [120.154053513, 5.160756878000029],
            [120.14302917700002, 5.158726570000056],
            [120.14964960500004, 5.165762982000047],
        ],
        [
            [120.45730447200003, 5.16327085000006],
            [120.45645565400002, 5.164625957000055],
            [120.45720576100007, 5.168523926000034],
            [120.4579002480001, 5.167476162000071],
            [120.45730447200003, 5.16327085000006],
        ],
        [
            [120.29957234800008, 5.171062051000035],
            [120.30007799700002, 5.169263486000034],
            [120.29750845400008, 5.168533787000058],
            [120.29706471200006, 5.170465952000029],
            [120.29957234800008, 5.171062051000035],
        ],
        [
            [120.28887312000006, 5.170426804000044],
            [120.29047672900003, 5.166689390000045],
            [120.28657999500001, 5.164809705000039],
            [120.28416491300004, 5.169501616000048],
            [120.28887312000006, 5.170426804000044],
        ],
        [
            [120.35672742300005, 5.170710055000029],
            [120.35644176900007, 5.171004081000035],
            [120.35642275000009, 5.171279116000051],
            [120.3570226490001, 5.170961350000027],
            [120.35672742300005, 5.170710055000029],
        ],
        [
            [120.2613113650001, 5.173009537000041],
            [120.26666737100004, 5.17075849400004],
            [120.2690419060001, 5.167014350000045],
            [120.2595761870001, 5.165333920000023],
            [120.2613113650001, 5.173009537000041],
        ],
        [
            [120.31890869200004, 5.173278809000067],
            [120.3176879880001, 5.173522950000063],
            [120.31848144500009, 5.174926758000026],
            [120.31909179600007, 5.17468261700003],
            [120.31890869200004, 5.173278809000067],
        ],
        [
            [120.45611572300004, 5.174072265000063],
            [120.45507812500011, 5.174499512000068],
            [120.45532226500006, 5.174926758000026],
            [120.45568847600009, 5.175109864000035],
            [120.45611572300004, 5.174072265000063],
        ],
        [
            [120.35066521400006, 5.176445342000022],
            [120.35384281800009, 5.175276950000068],
            [120.35369720300002, 5.170597823000037],
            [120.34699019800007, 5.173330855000074],
            [120.35066521400006, 5.176445342000022],
        ],
        [
            [120.28248159600003, 5.177022365000028],
            [120.28386588600006, 5.176643761000037],
            [120.28271584000004, 5.174464186000023],
            [120.28169974700006, 5.175576918000047],
            [120.28248159600003, 5.177022365000028],
        ],
        [
            [120.4547119130001, 5.176513672000056],
            [120.45312499900001, 5.176879883000026],
            [120.45330810500002, 5.178100586000028],
            [120.45452880900007, 5.177307130000031],
            [120.4547119130001, 5.176513672000056],
        ],
        [
            [120.52691650400004, 5.177124024000022],
            [120.52349853500004, 5.17889404400006],
            [120.52368164100005, 5.180725098000039],
            [120.52612304600007, 5.178710938000052],
            [120.52691650400004, 5.177124024000022],
        ],
        [
            [120.28225414400004, 5.180762077000054],
            [120.28457198000001, 5.179677080000033],
            [120.28510949500003, 5.17794056200006],
            [120.28128500100001, 5.178818264000029],
            [120.28225414400004, 5.180762077000054],
        ],
        [
            [120.45111084000007, 5.179077148000033],
            [120.45031738300008, 5.179687500000057],
            [120.4505004880001, 5.181518555000025],
            [120.45190429700006, 5.179870606000065],
            [120.45111084000007, 5.179077148000033],
        ],
        [
            [120.521930429, 5.185179825000034],
            [120.522405079, 5.184748761000037],
            [120.5223322820001, 5.182613973000059],
            [120.52164372100003, 5.183808549000048],
            [120.521930429, 5.185179825000034],
        ],
        [
            [120.356170872, 5.188900169000021],
            [120.35621375900007, 5.188605349000056],
            [120.3557557370001, 5.188583003000076],
            [120.35586552000007, 5.188903814000071],
            [120.356170872, 5.188900169000021],
        ],
        [
            [120.35543163300008, 5.189213384000027],
            [120.35573333900004, 5.188835178000033],
            [120.3548394290001, 5.189775100000077],
            [120.35520249300009, 5.189804845000026],
            [120.35543163300008, 5.189213384000027],
        ],
        [
            [120.59967041000004, 5.187927246000072],
            [120.59869384800004, 5.188720703000058],
            [120.59930419900002, 5.189880371000072],
            [120.60009765600012, 5.189086915000075],
            [120.59967041000004, 5.187927246000072],
        ],
        [
            [120.35526943000002, 5.190231341000072],
            [120.35562321300006, 5.19012943000007],
            [120.3556120940001, 5.189884666000069],
            [120.35512798900004, 5.189936483000054],
            [120.35526943000002, 5.190231341000072],
        ],
        [
            [120.60272216800001, 5.19030761700003],
            [120.60229492100007, 5.189880371000072],
            [120.601074218, 5.190673829000048],
            [120.60229492100007, 5.191284180000025],
            [120.60272216800001, 5.19030761700003],
        ],
        [
            [120.45507812500011, 5.19171142600004],
            [120.45532226500006, 5.190917969000054],
            [120.45452880900007, 5.191101074000073],
            [120.45507812500011, 5.19171142600004],
        ],
        [
            [120.6043090820001, 5.191284180000025],
            [120.603698731, 5.191894531000059],
            [120.60510253900009, 5.192687988000046],
            [120.60510253900009, 5.191894531000059],
            [120.6043090820001, 5.191284180000025],
        ],
        [
            [120.23979959200005, 5.193296474000022],
            [120.24021503600011, 5.192992257000071],
            [120.2401309820001, 5.192895701000054],
            [120.24020469100003, 5.192485973000032],
            [120.24014345900002, 5.192451149000021],
            [120.23979959200005, 5.193296474000022],
        ],
        [
            [120.45312499900001, 5.192687988000046],
            [120.45227050800008, 5.192687988000046],
            [120.45208740200007, 5.193481446000021],
            [120.45288086000005, 5.193481446000021],
            [120.45312499900001, 5.192687988000046],
        ],
        [
            [120.48206627200011, 5.193963318000044],
            [120.50461157900008, 5.183729500000027],
            [120.51049804700006, 5.169921875000057],
            [120.50769042900004, 5.161071777000075],
            [120.48206627200011, 5.193963318000044],
        ],
        [
            [120.6052856450001, 5.194091797000056],
            [120.60510253900009, 5.193481446000021],
            [120.604492187, 5.193908692000036],
            [120.60491943400007, 5.194274903000064],
            [120.6052856450001, 5.194091797000056],
        ],
        [
            [120.23857547400007, 5.193450399000028],
            [120.23811711700012, 5.193717243000037],
            [120.23819974100002, 5.194313],
            [120.23889929300003, 5.193851606000067],
            [120.23857547400007, 5.193450399000028],
        ],
        [
            [120.60711669900002, 5.194091797000056],
            [120.60668945300006, 5.193908692000036],
            [120.60607910100009, 5.194274903000064],
            [120.60650634800004, 5.194702148000033],
            [120.60711669900002, 5.194091797000056],
        ],
        [
            [120.45068359400011, 5.195312500000057],
            [120.45068359400011, 5.194702148000033],
            [120.45007324200003, 5.194885254000042],
            [120.45007324200003, 5.195678711000028],
            [120.45068359400011, 5.195312500000057],
        ],
        [
            [120.50848388700001, 5.194274903000064],
            [120.50708007800006, 5.194702148000033],
            [120.5081176760001, 5.195922852000024],
            [120.50872802700007, 5.195129395000038],
            [120.50848388700001, 5.194274903000064],
        ],
        [
            [120.24179676200004, 5.196225920000074],
            [120.242305299, 5.194237616000066],
            [120.2413579360001, 5.192933250000067],
            [120.24101684900006, 5.193663154000035],
            [120.24179676200004, 5.196225920000074],
        ],
        [
            [120.60791015600012, 5.195922852000024],
            [120.60729980400004, 5.195495606000065],
            [120.60729980400004, 5.196289062000062],
            [120.60791015600012, 5.195922852000024],
        ],
        [
            [119.87440206500003, 5.196143774000063],
            [119.87413766300006, 5.196084241000051],
            [119.87399281500007, 5.196173539000029],
            [119.87436068000011, 5.196491810000055],
            [119.87440206500003, 5.196143774000063],
        ],
        [
            [120.6096801760001, 5.195129395000038],
            [120.6087036130001, 5.195922852000024],
            [120.60992431600005, 5.196899414000029],
            [120.61047363300008, 5.195678711000028],
            [120.6096801760001, 5.195129395000038],
        ],
        [
            [119.87554474900003, 5.19694024100005],
            [119.87507342200001, 5.196546411000043],
            [119.87475843600009, 5.196894446000044],
            [119.87538610800004, 5.197111969000048],
            [119.87554474900003, 5.19694024100005],
        ],
        [
            [119.87214582500008, 5.197199492000038],
            [119.87235083500002, 5.196657250000044],
            [119.87386033200005, 5.196277467000073],
            [119.87231414500002, 5.196431002000054],
            [119.87214582500008, 5.197199492000038],
        ],
        [
            [120.24065728200003, 5.197674969000047],
            [120.24128307100011, 5.196812682000029],
            [120.23888303300009, 5.19438189400006],
            [120.23838559300009, 5.195917523000048],
            [120.24065728200003, 5.197674969000047],
        ],
        [
            [120.35602767400007, 5.197839378000026],
            [120.35762861, 5.191771484000071],
            [120.3524337450001, 5.190059907000034],
            [120.35280684600002, 5.194654845000059],
            [120.35602767400007, 5.197839378000026],
        ],
        [
            [120.35842674500009, 5.197542773000066],
            [120.35891631800007, 5.196969414000023],
            [120.358885772, 5.19674898300002],
            [120.35800572700009, 5.197264916000051],
            [120.35842674500009, 5.197542773000066],
        ],
        [
            [120.36090802400008, 5.198457242000075],
            [120.361591943, 5.197862412000063],
            [120.36129697400008, 5.197154487000034],
            [120.36042049100001, 5.197851423000031],
            [120.36090802400008, 5.198457242000075],
        ],
        [
            [120.35936405300004, 5.198582371000043],
            [120.3598068660001, 5.19789430700007],
            [120.35978716800003, 5.197422991000053],
            [120.35929405500008, 5.197709619000022],
            [120.35936405300004, 5.198582371000043],
        ],
        [
            [120.61291503900009, 5.197509766000053],
            [120.61169433600003, 5.197875976000034],
            [120.61187744100005, 5.198486328000058],
            [120.61291503900009, 5.198486328000058],
            [120.61291503900009, 5.197509766000053],
        ],
        [
            [120.59930419900002, 5.197326661000034],
            [120.59851074200003, 5.19812011700003],
            [120.59887695300006, 5.198913575000063],
            [120.59967041000004, 5.197875976000034],
            [120.59930419900002, 5.197326661000034],
        ],
        [
            [120.61492919900002, 5.198730469000054],
            [120.61370849600007, 5.199096680000025],
            [120.61407470600011, 5.200317383000026],
            [120.61492919900002, 5.200317383000026],
            [120.61492919900002, 5.198730469000054],
        ],
        [
            [120.59509904700008, 5.20088348400003],
            [120.59629577800001, 5.199810829000057],
            [120.59592788300006, 5.199175199000024],
            [120.59382693300006, 5.200442088000045],
            [120.59509904700008, 5.20088348400003],
        ],
        [
            [119.87798622000003, 5.19974101300005],
            [119.87672433000012, 5.198885120000057],
            [119.8762303630001, 5.199065569000027],
            [119.87820182200005, 5.201183695000054],
            [119.87798622000003, 5.19974101300005],
        ],
        [
            [120.58439973400004, 5.199096680000025],
            [120.58392333900008, 5.200317383000026],
            [120.58471679700006, 5.201293945000032],
            [120.58532714800003, 5.20147705100004],
            [120.58569335900006, 5.201904297000056],
            [120.58439973400004, 5.199096680000025],
        ],
        [
            [120.59138931400003, 5.202707480000072],
            [120.59233341000004, 5.201917340000023],
            [120.59013492800011, 5.201409727000055],
            [120.59063136600003, 5.202826671000025],
            [120.59138931400003, 5.202707480000072],
        ],
        [
            [120.51189339600012, 5.203146489000062],
            [120.52264385700005, 5.192192570000032],
            [120.52394728200011, 5.185308088000056],
            [120.50709531600012, 5.19955535400004],
            [120.51189339600012, 5.203146489000062],
        ],
        [
            [120.61968994100005, 5.202880859000061],
            [120.61907958900008, 5.202880859000061],
            [120.61907958900008, 5.203918457000043],
            [120.61968994100005, 5.203674317000036],
            [120.61968994100005, 5.202880859000061],
        ],
        [
            [120.58706270700009, 5.202029280000033],
            [120.58611387000008, 5.197905940000055],
            [120.58085213600009, 5.199967613000069],
            [120.58249103700007, 5.200969813000029],
            [120.58263712300004, 5.199681099000031],
            [120.58409164000011, 5.199058824000076],
            [120.58472927000003, 5.19905529600004],
            [120.5859036700001, 5.200284258000067],
            [120.58569763100002, 5.201948390000041],
            [120.58326017000002, 5.201981415000034],
            [120.5839286690001, 5.205465377000053],
            [120.58706270700009, 5.202029280000033],
        ],
        [
            [120.35632324200003, 5.209899902000075],
            [120.3552856440001, 5.209716797000056],
            [120.35552978500004, 5.212280274000022],
            [120.35668945300006, 5.211730957000043],
            [120.35632324200003, 5.209899902000075],
        ],
        [
            [120.69647216800001, 5.209472657000049],
            [120.69110107400002, 5.21069336000005],
            [120.69049072200005, 5.212097168000071],
            [120.69567871000004, 5.210327149000022],
            [120.69647216800001, 5.209472657000049],
        ],
        [
            [119.87878558700004, 5.213348900000028],
            [119.87642284100002, 5.208397650000052],
            [119.87002160100008, 5.200509667000063],
            [119.87080837400003, 5.199088117000031],
            [119.87060183900007, 5.198011056000041],
            [119.87130037700001, 5.197523405000027],
            [119.87094995300004, 5.19717210500005],
            [119.87033495500009, 5.198251416000062],
            [119.87048456600007, 5.199435146000042],
            [119.86976436700002, 5.200585744000023],
            [119.87878558700004, 5.213348900000028],
        ],
        [
            [120.61090087800005, 5.213500977000024],
            [120.60949707000009, 5.213500977000024],
            [120.60949707000009, 5.215087891000053],
            [120.61047363300008, 5.215270996000072],
            [120.61090087800005, 5.213500977000024],
        ],
        [
            [120.68530273400006, 5.213684082000043],
            [120.68267822200005, 5.214477540000075],
            [120.68072509700005, 5.216674805000025],
            [120.68231201100002, 5.216491699000073],
            [120.68530273400006, 5.213684082000043],
        ],
        [
            [120.31514448400003, 5.217038383000045],
            [120.31579560900002, 5.216936515000043],
            [120.31578510500003, 5.215980315000024],
            [120.3146579920001, 5.216089665000027],
            [120.31514448400003, 5.217038383000045],
        ],
        [
            [120.35446648600009, 5.219585700000039],
            [120.35619588600002, 5.217968088000021],
            [120.35417101900009, 5.214535009000031],
            [120.35301864300004, 5.217804826000076],
            [120.35446648600009, 5.219585700000039],
        ],
        [
            [120.60353639400012, 5.219888647000062],
            [120.59877594700004, 5.202448104000041],
            [120.58369572000004, 5.206227180000042],
            [120.58088262500007, 5.202210001000026],
            [120.56881083600001, 5.207610310000064],
            [120.60353639400012, 5.219888647000062],
        ],
        [
            [119.906925279, 5.22030869200006],
            [119.90615207300004, 5.218136260000051],
            [119.90354940400005, 5.219719759000043],
            [119.90477443800012, 5.21928906100004],
            [119.906925279, 5.22030869200006],
        ],
        [
            [120.33032226600005, 5.218688965000069],
            [120.32928466700002, 5.219116211000028],
            [120.33007812500011, 5.220520020000038],
            [120.33050537100007, 5.219909668000071],
            [120.33032226600005, 5.218688965000069],
        ],
        [
            [119.89949460300011, 5.221546482000065],
            [119.89774501700003, 5.214577260000056],
            [119.89130943900011, 5.21452256200007],
            [119.89141633300005, 5.218104636000021],
            [119.89949460300011, 5.221546482000065],
        ],
        [
            [120.32765924000012, 5.220116917000041],
            [120.32812500000011, 5.21710205100004],
            [120.32647705000011, 5.215270996000072],
            [120.32761602700009, 5.222520665000047],
            [120.32765924000012, 5.220116917000041],
        ],
        [
            [120.24751936900009, 5.222155106000059],
            [120.24923948000003, 5.218040282000061],
            [120.24889180600007, 5.214863244000071],
            [120.24730162800006, 5.216762935000077],
            [120.24751936900009, 5.222155106000059],
        ],
        [
            [120.58227539000006, 5.218322754000042],
            [120.59368896400008, 5.222900391000053],
            [120.59667968800011, 5.221679687000062],
            [120.59667968800011, 5.221130372000061],
            [120.58227539000006, 5.218322754000042],
        ],
        [
            [120.675292968, 5.220520020000038],
            [120.67327880900007, 5.220520020000038],
            [120.6716918940001, 5.222900391000053],
            [120.67449951200001, 5.221496582000043],
            [120.675292968, 5.220520020000038],
        ],
        [
            [120.66082203100007, 5.22298956000003],
            [120.67084744300007, 5.219815865000044],
            [120.68621013100005, 5.20955544900005],
            [120.67259739800011, 5.209140233000028],
            [120.66082203100007, 5.22298956000003],
        ],
        [
            [120.312483487, 5.223045470000045],
            [120.31552562400009, 5.220477140000071],
            [120.31447378500002, 5.218451419000075],
            [120.31222342900003, 5.219891532000076],
            [120.312483487, 5.223045470000045],
        ],
        [
            [120.32992494200005, 5.223147200000028],
            [120.33013441300011, 5.221213743000021],
            [120.32908478600007, 5.220325642000034],
            [120.32900644100005, 5.222041340000033],
            [120.32992494200005, 5.223147200000028],
        ],
        [
            [119.90540846600004, 5.225035237000043],
            [119.90858891800008, 5.224911246000033],
            [119.9102742770001, 5.221281536000049],
            [119.90327215800005, 5.220688167000048],
            [119.90540846600004, 5.225035237000043],
        ],
        [
            [119.90898761900007, 5.226130922000038],
            [119.91031615100007, 5.224947452000038],
            [119.90965946000006, 5.223655274000066],
            [119.90906090600004, 5.223951527000054],
            [119.90898761900007, 5.226130922000038],
        ],
        [
            [120.36907959000007, 5.223876953000058],
            [120.36730957000009, 5.224670411000034],
            [120.3674926760001, 5.226074219000054],
            [120.36987304600007, 5.225708008000026],
            [120.36907959000007, 5.223876953000058],
        ],
        [
            [120.31360787800008, 5.22733541100007],
            [120.314364952, 5.226224577000039],
            [120.31388365100008, 5.225229234000039],
            [120.31214262200001, 5.225930652000045],
            [120.31360787800008, 5.22733541100007],
        ],
        [
            [119.92001568300009, 5.227847383000039],
            [119.9189926040001, 5.226128029000051],
            [119.91847737800003, 5.221868769000025],
            [119.9180107520001, 5.227398986000026],
            [119.92001568300009, 5.227847383000039],
        ],
        [
            [120.250733104, 5.224561496000035],
            [120.2499193210001, 5.222541299000056],
            [120.24847133700007, 5.22162641500006],
            [120.25031928900012, 5.228189462000046],
            [120.250733104, 5.224561496000035],
        ],
        [
            [119.89439064600003, 5.228079818000026],
            [119.88916358000006, 5.223478486000033],
            [119.88829901500003, 5.223640670000066],
            [119.8931736940001, 5.227843920000055],
            [119.89439064600003, 5.228079818000026],
        ],
        [
            [119.92490547300008, 5.226827177000075],
            [119.92381885000009, 5.226527720000036],
            [119.92456144000005, 5.228758713000047],
            [119.9251088100001, 5.22845630300003],
            [119.92490547300008, 5.226827177000075],
        ],
        [
            [120.32508317700001, 5.230026150000072],
            [120.32588211100006, 5.228960588000064],
            [120.32444613900009, 5.227479256000038],
            [120.3242642140001, 5.229528692000031],
            [120.32508317700001, 5.230026150000072],
        ],
        [
            [120.6541137690001, 5.230712891000053],
            [120.65307617100007, 5.230529785000044],
            [120.65130615200007, 5.231689453000058],
            [120.6516723630001, 5.232299805000025],
            [120.6541137690001, 5.230712891000053],
        ],
        [
            [119.91269496200005, 5.232849868000073],
            [119.91332294200004, 5.23256377000007],
            [119.91337124600011, 5.232465267000066],
            [119.91271335300007, 5.232170261000022],
            [119.91269496200005, 5.232849868000073],
        ],
        [
            [120.32077694800012, 5.23297393100006],
            [120.32107480000002, 5.231209844000034],
            [120.31968752000012, 5.230978905000029],
            [120.3194818610001, 5.23278390400003],
            [120.32077694800012, 5.23297393100006],
        ],
        [
            [120.32782208600008, 5.233010180000065],
            [120.328038117, 5.231362874000069],
            [120.32504774800009, 5.231020206000039],
            [120.32737594100001, 5.233250689000045],
            [120.32782208600008, 5.233010180000065],
        ],
        [
            [119.90592047200005, 5.233321757000056],
            [119.9076887330001, 5.232490785000039],
            [119.90799911600004, 5.23185404700007],
            [119.89526609900008, 5.228618529000073],
            [119.90592047200005, 5.233321757000056],
        ],
        [
            [119.90631304600004, 5.23254617300006],
            [119.90611416100012, 5.232215284000063],
            [119.90672253900004, 5.232264233000024],
            [119.9066827580001, 5.232383070000026],
            [119.90631304600004, 5.23254617300006],
        ],
        [
            [120.6480712880001, 5.233520508000026],
            [120.6472778320001, 5.232482910000044],
            [120.64367675800008, 5.233703613000046],
            [120.64447021500007, 5.234313965000069],
            [120.6480712880001, 5.233520508000026],
        ],
        [
            [120.63926522200006, 5.235012452000035],
            [120.65282484900001, 5.228399421000063],
            [120.64808515200002, 5.222665107000068],
            [120.62985554600004, 5.227903643000047],
            [120.63926522200006, 5.235012452000035],
        ],
        [
            [120.32518344700009, 5.234883302000071],
            [120.32477501300002, 5.233224809000035],
            [120.32257516700008, 5.232270536000044],
            [120.3224584300001, 5.234380995000038],
            [120.32518344700009, 5.234883302000071],
        ],
        [
            [120.377772348, 5.234961670000075],
            [120.37843805400007, 5.232579439000062],
            [120.3766363520001, 5.231165765000071],
            [120.37432820600009, 5.234433958000068],
            [120.377772348, 5.234961670000075],
        ],
        [
            [119.93505578300005, 5.23461605500006],
            [119.9350829230001, 5.233508650000033],
            [119.93471215800002, 5.235993948000043],
            [119.93537725300007, 5.235102548000043],
            [119.93505578300005, 5.23461605500006],
        ],
        [
            [119.91576943400003, 5.236400671000069],
            [119.912832578, 5.235134106000032],
            [119.91240831100004, 5.233859152000036],
            [119.91274055100007, 5.235399625000071],
            [119.91576943400003, 5.236400671000069],
        ],
        [
            [120.40439540300008, 5.236733340000058],
            [120.40580825200004, 5.235237988000051],
            [120.40562140200007, 5.232236882000052],
            [120.40278535800007, 5.23590817500002],
            [120.40439540300008, 5.236733340000058],
        ],
        [
            [119.92596657700005, 5.241381614000034],
            [119.92765281100003, 5.24033642400002],
            [119.92776284600006, 5.240057261000061],
            [119.92749669500006, 5.23972430200007],
            [119.9174803410001, 5.237274475000049],
            [119.92596657700005, 5.241381614000034],
        ],
        [
            [119.94913727200003, 5.241542016000039],
            [119.95443656200007, 5.239666269000054],
            [119.937211767, 5.227866577000043],
            [119.94231542600005, 5.238820874000055],
            [119.94913727200003, 5.241542016000039],
        ],
        [
            [120.3233309530001, 5.244534430000044],
            [120.32598813700008, 5.236800305000031],
            [120.3207989870001, 5.235609343000021],
            [120.32088722600008, 5.23955718600007],
            [120.3233309530001, 5.244534430000044],
        ],
        [
            [120.34651785100004, 5.246382009000058],
            [120.34424479900008, 5.237039484000036],
            [120.33970128400006, 5.235565867000048],
            [120.34308132800004, 5.242273100000034],
            [120.34651785100004, 5.246382009000058],
        ],
        [
            [119.93630195900005, 5.24694919500007],
            [119.93477243900008, 5.237718692000044],
            [119.9349997160001, 5.241859934000047],
            [119.93426537900007, 5.244313775000023],
            [119.93630195900005, 5.24694919500007],
        ],
        [
            [119.96342322100008, 5.246144896000033],
            [119.96311641700004, 5.243514278000021],
            [119.95964143900005, 5.244604340000024],
            [119.96374634800009, 5.247432906000029],
            [119.96342322100008, 5.246144896000033],
        ],
        [
            [119.93997836300002, 5.247648206000065],
            [119.93950479600005, 5.247754091000047],
            [119.93871473700005, 5.248576992000039],
            [119.9388983660001, 5.248528864000036],
            [119.93997836300002, 5.247648206000065],
        ],
        [
            [120.29821627900003, 5.249044617000038],
            [120.29866201000004, 5.24793162800006],
            [120.29728105000004, 5.246399017000044],
            [120.2970507550001, 5.248580827000069],
            [120.29821627900003, 5.249044617000038],
        ],
        [
            [120.31480139100006, 5.250839867000025],
            [120.32138108100003, 5.243485799000041],
            [120.3107264790001, 5.224563573000069],
            [120.29823345900002, 5.241257114000064],
            [120.31480139100006, 5.250839867000025],
        ],
        [
            [119.9411584500001, 5.250737621000042],
            [119.93980722100002, 5.249564303000056],
            [119.939467766, 5.249571484000057],
            [119.94160553400002, 5.251140594000049],
            [119.9411584500001, 5.250737621000042],
        ],
        [
            [119.96349458700001, 5.250625565000064],
            [119.9641263310001, 5.248947131000023],
            [119.96766843800003, 5.250869215000023],
            [119.96919935500011, 5.24895934500006],
            [119.965205953, 5.248557856000048],
            [119.95714515800012, 5.243750989000034],
            [119.96349458700001, 5.250625565000064],
        ],
        [
            [120.32517582100002, 5.25242344000003],
            [120.33006796100005, 5.245984669000052],
            [120.32880232000002, 5.243432646000031],
            [120.32523779400003, 5.247296092000056],
            [120.32517582100002, 5.25242344000003],
        ],
        [
            [119.94537326400007, 5.253020227000036],
            [119.9444640370001, 5.252529751000054],
            [119.94643649700004, 5.253830063000066],
            [119.94619602500006, 5.25352020400004],
            [119.94537326400007, 5.253020227000036],
        ],
        [
            [120.31870111500007, 5.25391133200003],
            [120.3186489090001, 5.252148764000026],
            [120.3173827170001, 5.251427306000039],
            [120.31713872500006, 5.252785559000074],
            [120.31870111500007, 5.25391133200003],
        ],
        [
            [120.254836769, 5.254392279000058],
            [120.25557452700002, 5.253477153000063],
            [120.25477413100009, 5.252399838000031],
            [120.25438633400006, 5.252851040000053],
            [120.254836769, 5.254392279000058],
        ],
        [
            [120.27030337700012, 5.256442140000047],
            [120.3187552070001, 5.206657990000053],
            [120.30114896900011, 5.185461937000071],
            [120.28190177600004, 5.182887077000032],
            [120.27195941700006, 5.171295255000075],
            [120.24160238700006, 5.19086644500004],
            [120.25986247800006, 5.247929440000064],
            [120.27030337700012, 5.256442140000047],
        ],
        [
            [120.26597439500006, 5.18244278100002],
            [120.26499475900005, 5.181897612000057],
            [120.26519556400001, 5.180544639000061],
            [120.26676526900008, 5.181231911000054],
            [120.26597439500006, 5.18244278100002],
        ],
        [
            [120.30233486300006, 5.189667297000028],
            [120.30201491000003, 5.190160623000054],
            [120.30168658700006, 5.188086429000066],
            [120.30307051200009, 5.189012676000061],
            [120.30233486300006, 5.189667297000028],
        ],
        [
            [120.24614464500007, 5.197566807000044],
            [120.24372238, 5.197386780000045],
            [120.24380949700003, 5.196204489000024],
            [120.24440064300006, 5.196028536000028],
            [120.24614464500007, 5.197566807000044],
        ],
        [
            [119.96370997000008, 5.25680107200003],
            [119.96402501700004, 5.256355005000046],
            [119.96175355200012, 5.256289958000025],
            [119.96250364600007, 5.256677031000038],
            [119.96370997000008, 5.25680107200003],
        ],
        [
            [119.97119677100011, 5.256948388000069],
            [119.97256165500005, 5.255724025000063],
            [119.97266389100002, 5.254561785000021],
            [119.97228012700009, 5.254179694000072],
            [119.97119677100011, 5.256948388000069],
        ],
        [
            [119.96890899000005, 5.257702116000075],
            [119.96954341500009, 5.257499998000071],
            [119.96947116700005, 5.257205573000022],
            [119.9675412580001, 5.255959564000023],
            [119.96890899000005, 5.257702116000075],
        ],
        [
            [120.28037449900012, 5.258500535000053],
            [120.28781564400003, 5.254266022000024],
            [120.28631971000004, 5.247775089000072],
            [120.27787366700011, 5.251949292000063],
            [120.28037449900012, 5.258500535000053],
        ],
        [
            [120.35813995100011, 5.258682250000049],
            [120.36722854400011, 5.250154946000066],
            [120.34669320800003, 5.215985141000033],
            [120.34259439800007, 5.181741117000058],
            [120.32884005300002, 5.213023625000062],
            [120.35813995100011, 5.258682250000049],
        ],
        [
            [120.25689697200005, 5.25811767600004],
            [120.25592041000004, 5.258483887000068],
            [120.25610351600005, 5.259277344000054],
            [120.25689697200005, 5.259094238000046],
            [120.25689697200005, 5.25811767600004],
        ],
        [
            [120.2590942380001, 5.26007080100004],
            [120.25811767500011, 5.259887696000021],
            [120.25830078100012, 5.260925293000071],
            [120.2590942380001, 5.260681152000075],
            [120.2590942380001, 5.26007080100004],
        ],
        [
            [120.36749311500012, 5.260958023000057],
            [120.36895733500012, 5.258066636000024],
            [120.36386914800005, 5.25826789000007],
            [120.36453130000007, 5.260381593000034],
            [120.36749311500012, 5.260958023000057],
        ],
        [
            [120.25555954000004, 5.262039915000059],
            [120.2561709040001, 5.261633130000064],
            [120.25621384200008, 5.260367484000028],
            [120.25477961800004, 5.260698098000034],
            [120.25555954000004, 5.262039915000059],
        ],
        [
            [120.26537228100005, 5.262598947000072],
            [120.26900778800007, 5.259346208000068],
            [120.26183256400009, 5.251760294000064],
            [120.26305358400009, 5.259360795000021],
            [120.26537228100005, 5.262598947000072],
        ],
        [
            [120.28088183000011, 5.269745195000041],
            [120.28280728700008, 5.268672332000051],
            [120.28150206200007, 5.267134819000034],
            [120.27968081600011, 5.268196845000034],
            [120.28088183000011, 5.269745195000041],
        ],
        [
            [120.27404313000011, 5.26745539500007],
            [120.27367140400008, 5.267527087000076],
            [120.27307210700008, 5.269855619000055],
            [120.27491868300001, 5.268888175000029],
            [120.27404313000011, 5.26745539500007],
        ],
        [
            [120.2822202970001, 5.271985070000028],
            [120.28327069300008, 5.270485519000033],
            [120.28254288700009, 5.269642404000024],
            [120.28093998800011, 5.270592200000067],
            [120.2822202970001, 5.271985070000028],
        ],
        [
            [120.37268087300004, 5.27237978900007],
            [120.38313137000011, 5.267092676000061],
            [120.37906669600011, 5.259699799000032],
            [120.36856784200006, 5.267699702000073],
            [120.37268087300004, 5.27237978900007],
        ],
        [
            [120.26952280300009, 5.271427484000071],
            [120.26746391400002, 5.271384331000036],
            [120.26710448900008, 5.271937594000065],
            [120.26894562000007, 5.272935352000047],
            [120.26952280300009, 5.271427484000071],
        ],
        [
            [120.26287841800001, 5.271911622000061],
            [120.26147460900006, 5.272705078000058],
            [120.26232910100009, 5.273681641000053],
            [120.26312255800008, 5.273315430000025],
            [120.26287841800001, 5.271911622000061],
        ],
        [
            [120.28905502100008, 5.274678867000034],
            [120.29109135200008, 5.269910334000031],
            [120.29732791600009, 5.267441657000063],
            [120.29266298000005, 5.26239848900002],
            [120.28905502100008, 5.274678867000034],
        ],
        [
            [120.2558394460001, 5.274030343000049],
            [120.25623417300005, 5.271648350000021],
            [120.2544589040001, 5.271693834000075],
            [120.25435803200003, 5.273921377000022],
            [120.2558394460001, 5.274030343000049],
        ],
        [
            [120.295105508, 5.276148919000036],
            [120.29729231100009, 5.27381774600002],
            [120.2975632350001, 5.271805663000066],
            [120.29489526200007, 5.274432477000062],
            [120.295105508, 5.276148919000036],
        ],
        [
            [120.29277758300009, 5.276513794000039],
            [120.29283284300004, 5.273052211000049],
            [120.29717456800006, 5.26902848900005],
            [120.29122486200004, 5.271049724000022],
            [120.29277758300009, 5.276513794000039],
        ],
        [
            [120.30591917400011, 5.283159642000044],
            [120.31077500300012, 5.281227275000049],
            [120.31517657800009, 5.275810255000067],
            [120.30699314200001, 5.275282704000062],
            [120.30591917400011, 5.283159642000044],
        ],
        [
            [120.26054217100011, 5.284861090000049],
            [120.26538491400004, 5.282346247000021],
            [120.26503510600003, 5.280300021000073],
            [120.26164493600004, 5.280352090000065],
            [120.26054217100011, 5.284861090000049],
        ],
        [
            [120.26356818400006, 5.285108842000056],
            [120.2643009950001, 5.28451960600006],
            [120.26472196300006, 5.28325896900003],
            [120.2625429630001, 5.284366702000057],
            [120.26356818400006, 5.285108842000056],
        ],
        [
            [120.26287841800001, 5.285705567000036],
            [120.2625122070001, 5.285278321000021],
            [120.26171875000011, 5.285888672000056],
            [120.2625122070001, 5.286071777000075],
            [120.26287841800001, 5.285705567000036],
        ],
        [
            [120.2710637880001, 5.287027726000076],
            [120.27209186000005, 5.285123054000053],
            [120.27113128000008, 5.283644940000045],
            [120.26864486700003, 5.286899812000058],
            [120.2710637880001, 5.287027726000076],
        ],
        [
            [120.276147777, 5.285204130000068],
            [120.2740695010001, 5.285224471000049],
            [120.27446364700006, 5.287714648000076],
            [120.27634416100011, 5.287243815000068],
            [120.276147777, 5.285204130000068],
        ],
        [
            [120.28642540400006, 5.29535878300004],
            [120.2866576240001, 5.295296356000051],
            [120.28613790200006, 5.295161395000036],
            [120.28616124000007, 5.295390313000041],
            [120.28642540400006, 5.29535878300004],
        ],
        [
            [120.2849866680001, 5.29687924600006],
            [120.28501966800002, 5.296258215000023],
            [120.2847397810001, 5.29619199800004],
            [120.28451326600009, 5.296652083000026],
            [120.2849866680001, 5.29687924600006],
        ],
        [
            [120.24100389500006, 5.296174076000057],
            [120.23984173500003, 5.295273358000031],
            [120.23872004100008, 5.296867333000023],
            [120.24041594200003, 5.296691872000054],
            [120.24100389500006, 5.296174076000057],
        ],
        [
            [120.47743729800004, 5.296206909000034],
            [120.47543604300006, 5.295989724000037],
            [120.47484597900007, 5.29674877900004],
            [120.47650675500006, 5.297865136000041],
            [120.47743729800004, 5.296206909000034],
        ],
        [
            [120.22563432600009, 5.298889359000043],
            [120.22949820300005, 5.297189990000049],
            [120.22972846300001, 5.296397144000025],
            [120.22444922200009, 5.29844150200006],
            [120.22563432600009, 5.298889359000043],
        ],
        [
            [120.28446418200008, 5.300205819000041],
            [120.2890839800001, 5.299182099000063],
            [120.28990859700002, 5.29728115000006],
            [120.28386391600009, 5.298161188000051],
            [120.28322439900012, 5.296155945000066],
            [120.28446418200008, 5.300205819000041],
        ],
        [
            [120.2725588830001, 5.300929739000026],
            [120.27217009300011, 5.300935649000053],
            [120.27214278100007, 5.301174073000027],
            [120.27232445400011, 5.301151935000064],
            [120.2725588830001, 5.300929739000026],
        ],
        [
            [120.57287682700007, 5.302617958000042],
            [120.57596110000009, 5.296836479000035],
            [120.57130869100001, 5.292705898000065],
            [120.56634202200007, 5.30186879300004],
            [120.57287682700007, 5.302617958000042],
        ],
        [
            [120.2424926760001, 5.308471680000025],
            [120.24267578100012, 5.307922363000046],
            [120.24188232400002, 5.308288574000073],
            [120.2424926760001, 5.308471680000025],
        ],
        [
            [120.41713171600009, 5.308680706000075],
            [120.41846915000008, 5.306741608000038],
            [120.41613486800009, 5.305396881000036],
            [120.41562856400003, 5.307545557000026],
            [120.41713171600009, 5.308680706000075],
        ],
        [
            [120.26611213900003, 5.314083055000026],
            [120.27413253200007, 5.308835773000055],
            [120.2776502160001, 5.29964853000007],
            [120.26593699400007, 5.305596053000045],
            [120.26611213900003, 5.314083055000026],
        ],
        [
            [120.23849319200008, 5.312727152000036],
            [120.23783808400003, 5.312985283000046],
            [120.23806315400009, 5.314167540000028],
            [120.23903904500003, 5.313229996000075],
            [120.23849319200008, 5.312727152000036],
        ],
        [
            [120.21974532100012, 5.31536830500005],
            [120.21864441700006, 5.31505474100004],
            [120.2208406630001, 5.319147375000057],
            [120.22058981000009, 5.316761862000021],
            [120.21974532100012, 5.31536830500005],
        ],
        [
            [120.22615243300004, 5.326141335000045],
            [120.23891356900003, 5.305887034000023],
            [120.23763427300003, 5.298733259000073],
            [120.21826510200003, 5.30629880400005],
            [120.22615243300004, 5.326141335000045],
        ],
        [
            [120.57927303800011, 5.329774212000075],
            [120.5790242280001, 5.32788835100007],
            [120.57669352800008, 5.327724199000045],
            [120.57742241300002, 5.330412785000021],
            [120.57927303800011, 5.329774212000075],
        ],
        [
            [120.2686767570001, 5.333679199000073],
            [120.26770019500009, 5.334472657000049],
            [120.26812744100005, 5.335083008000026],
            [120.2686767570001, 5.334716797000056],
            [120.2686767570001, 5.333679199000073],
        ],
        [
            [120.27307128900009, 5.335327148000033],
            [120.2722778320001, 5.335327148000033],
            [120.27270507800006, 5.336486817000036],
            [120.27331542900004, 5.335876465000069],
            [120.27307128900009, 5.335327148000033],
        ],
        [
            [120.26726865600006, 5.348774167000045],
            [120.27064356700009, 5.348693258000026],
            [120.27551527500009, 5.342709678000062],
            [120.26603796300003, 5.344242017000056],
            [120.26726865600006, 5.348774167000045],
        ],
        [
            [120.2097818200001, 5.348895184000071],
            [120.21431423400008, 5.302048056000046],
            [120.25499245300011, 5.256577217000029],
            [120.21618505200001, 5.147684773000037],
            [120.22385610200001, 5.124340781000058],
            [120.16635368400011, 5.144711903000029],
            [120.19138627000007, 5.183166368000059],
            [120.15813215500009, 5.163182172000063],
            [120.15555452300009, 5.182037015000049],
            [120.14209158200003, 5.18397856100006],
            [120.12656915900004, 5.209237460000054],
            [120.1182652120001, 5.208285441000044],
            [120.09575793200008, 5.150596817000064],
            [120.05100172200002, 5.184913478000055],
            [119.99517122100008, 5.156058121000058],
            [119.9674636960001, 5.078900834000024],
            [119.942976799, 5.08995836400004],
            [119.91867997700001, 5.087563030000069],
            [119.82195477800008, 5.053754268000034],
            [119.83021069900008, 5.149516691000031],
            [119.94304267400003, 5.188275805000046],
            [119.97930273200006, 5.237112523000064],
            [120.03130579800006, 5.231817282000065],
            [120.2097818200001, 5.348895184000071],
        ],
        [
            [120.22599064300005, 5.358664506000025],
            [120.24218270100005, 5.348842015000059],
            [120.24490555000011, 5.324188574000061],
            [120.2246861960001, 5.338732090000065],
            [120.22599064300005, 5.358664506000025],
        ],
        [
            [120.32128549800007, 5.386889401000076],
            [120.33922650600005, 5.379027629000063],
            [120.29335502700008, 5.37031640500004],
            [120.2961760710001, 5.382087583000043],
            [120.32128549800007, 5.386889401000076],
        ],
        [
            [120.39172597800007, 5.404842822000035],
            [120.40350341800001, 5.398498535000044],
            [120.366699218, 5.388488770000038],
            [120.37621733600008, 5.402213232000065],
            [120.39172597800007, 5.404842822000035],
        ],
        [
            [120.58745101300008, 5.413605388000065],
            [120.587282791, 5.413681147000034],
            [120.58750708700006, 5.413788810000028],
            [120.58754714000008, 5.413687131000074],
            [120.58745101300008, 5.413605388000065],
        ],
        [
            [120.58823003600003, 5.414042013000028],
            [120.58824806000007, 5.413888499000052],
            [120.5881279030001, 5.413864573000069],
            [120.58810387100004, 5.41398618900007],
            [120.58823003600003, 5.414042013000028],
        ],
        [
            [120.58780547900005, 5.413988181000036],
            [120.58769333200007, 5.414085872000044],
            [120.58777143400005, 5.414237393000064],
            [120.58788358000004, 5.414081886000076],
            [120.58780547900005, 5.413988181000036],
        ],
        [
            [120.58811388100003, 5.414857434000055],
            [120.5882060030001, 5.414620184000057],
            [120.58807182700002, 5.414380941000047],
            [120.58795367100004, 5.414805597000054],
            [120.58811388100003, 5.414857434000055],
        ],
        [
            [120.58695545500007, 5.424287172000049],
            [120.58739078000008, 5.422569746000022],
            [120.5867436750001, 5.422028234000038],
            [120.58564239900011, 5.423781567000049],
            [120.58695545500007, 5.424287172000049],
        ],
        [
            [120.58618905700007, 5.434978955000076],
            [120.60814149200007, 5.411716717000047],
            [120.60788448100004, 5.404287698000076],
            [120.57856158600009, 5.405126259000042],
            [120.6006959450001, 5.408945566000057],
            [120.58618905700007, 5.434978955000076],
        ],
        [
            [120.23192003800011, 5.444879679000053],
            [120.23268251200011, 5.444217880000053],
            [120.23266835100003, 5.443642275000059],
            [120.23159558200007, 5.444370143000071],
            [120.23192003800011, 5.444879679000053],
        ],
        [
            [120.23551342200005, 5.44639158800004],
            [120.23443540100004, 5.445699506000039],
            [120.23276146500007, 5.445669185000042],
            [120.23401708400002, 5.44658402400006],
            [120.23551342200005, 5.44639158800004],
        ],
        [
            [120.24229603200001, 5.446352908000051],
            [120.24179207300006, 5.446416047000071],
            [120.24205023000002, 5.446956107000062],
            [120.24253008100004, 5.44680685700007],
            [120.24229603200001, 5.446352908000051],
        ],
        [
            [120.2305630620001, 5.447652607000066],
            [120.23188573100003, 5.446369907000076],
            [120.23064407600009, 5.444453224000029],
            [120.22974218800005, 5.446776478000061],
            [120.2305630620001, 5.447652607000066],
        ],
        [
            [120.23791020100009, 5.449084680000055],
            [120.24085491000005, 5.447961986000053],
            [120.2417420380001, 5.44700232100007],
            [120.23877452500005, 5.447740929000076],
            [120.23791020100009, 5.449084680000055],
        ],
        [
            [120.73502975300005, 5.452523107000047],
            [120.73528465800007, 5.452393531000041],
            [120.73516245700011, 5.452126561000057],
            [120.73479606600006, 5.452501999000049],
            [120.73502975300005, 5.452523107000047],
        ],
        [
            [120.7349157000001, 5.453279165000026],
            [120.73516526900005, 5.453001554000025],
            [120.73479876100009, 5.452726695000024],
            [120.73457309800006, 5.453043954000066],
            [120.7349157000001, 5.453279165000026],
        ],
        [
            [120.23882140400008, 5.454308130000072],
            [120.23942816800002, 5.452763640000057],
            [120.24337679300004, 5.451426864000041],
            [120.2369360350001, 5.452780319000055],
            [120.23882140400008, 5.454308130000072],
        ],
        [
            [120.1905455640001, 5.461566980000043],
            [120.19401557200001, 5.45521197000005],
            [120.19318423800007, 5.443199331000073],
            [120.18088159700005, 5.449294411000039],
            [120.1905455640001, 5.461566980000043],
        ],
        [
            [120.81697993300008, 5.463613125000052],
            [120.81917565000003, 5.464537353000026],
            [120.82026464100011, 5.464424815000029],
            [120.816958913, 5.463432285000067],
            [120.81622115500011, 5.463963220000039],
            [120.81629878100011, 5.464619359000039],
            [120.81697993300008, 5.463613125000052],
        ],
        [
            [120.23295085100006, 5.466359984000064],
            [120.22741517600002, 5.443126877000054],
            [120.25061935600002, 5.441628490000028],
            [120.2256949, 5.442134726000063],
            [120.23295085100006, 5.466359984000064],
        ],
        [
            [120.82469596500005, 5.467528687000026],
            [120.82544735400006, 5.465986461000057],
            [120.82028727200009, 5.464700307000044],
            [120.8228447250001, 5.465839320000043],
            [120.82469596500005, 5.467528687000026],
        ],
        [
            [120.5871826880001, 5.467912555000055],
            [120.59122375700008, 5.445939312000064],
            [120.58457316800002, 5.44283764100004],
            [120.57790305100002, 5.460085599000024],
            [120.5871826880001, 5.467912555000055],
        ],
        [
            [120.80541262500003, 5.471405351000044],
            [120.80543677900005, 5.47000429600007],
            [120.80415667900002, 5.46925526800004],
            [120.80417039500003, 5.471209445000056],
            [120.80541262500003, 5.471405351000044],
        ],
        [
            [120.72492465000005, 5.473421819000066],
            [120.72453395100001, 5.473042172000021],
            [120.72411114400006, 5.473067400000048],
            [120.7245363720001, 5.473819889000026],
            [120.72492465000005, 5.473421819000066],
        ],
        [
            [120.72630409100009, 5.474284369000031],
            [120.72665255100003, 5.473511598000073],
            [120.72567818000005, 5.473081721000028],
            [120.72544709200008, 5.473895648000052],
            [120.72630409100009, 5.474284369000031],
        ],
        [
            [120.86257100000012, 5.474551],
            [120.860717, 5.473526],
            [120.855529, 5.478295],
            [120.86166299900003, 5.478005],
            [120.86257100000012, 5.474551],
        ],
        [
            [120.860763, 5.485702],
            [120.86012199900006, 5.48549],
            [120.858451, 5.486049001000026],
            [120.8596490000001, 5.486793],
            [120.860763, 5.485702],
        ],
        [
            [120.85060799900009, 5.479399001000047],
            [120.844703, 5.479966],
            [120.840606, 5.486534],
            [120.850784, 5.482954],
            [120.85060799900009, 5.479399001000047],
        ],
        [
            [120.92441632400005, 5.487251054000069],
            [120.92486459300005, 5.487163256000031],
            [120.92483536800012, 5.486729525000044],
            [120.9241724640001, 5.486892284000021],
            [120.92441632400005, 5.487251054000069],
        ],
        [
            [120.853462, 5.487243],
            [120.855499, 5.48694],
            [120.855827, 5.486347],
            [120.851509, 5.487226],
            [120.853462, 5.487243],
        ],
        [
            [120.92459316700001, 5.487987178000026],
            [120.92490324700009, 5.487573437000037],
            [120.9247459070001, 5.487318138000035],
            [120.92422200700003, 5.487699810000038],
            [120.92459316700001, 5.487987178000026],
        ],
        [
            [120.7216827200001, 5.488077590000046],
            [120.73558276300002, 5.474949167000034],
            [120.74320118900005, 5.459479516000044],
            [120.74077379300002, 5.443733982000026],
            [120.7216827200001, 5.488077590000046],
        ],
        [
            [120.866333, 5.486416],
            [120.86312799900008, 5.486732001000064],
            [120.86940699900003, 5.488209],
            [120.86959800000011, 5.487775],
            [120.866333, 5.486416],
        ],
        [
            [120.873802, 5.489234],
            [120.87281699900007, 5.488377],
            [120.870872, 5.488819001000024],
            [120.87112399900002, 5.489141],
            [120.873802, 5.489234],
        ],
        [
            [120.9456867560001, 5.489841927000043],
            [120.94554928200012, 5.489481805000025],
            [120.94518464200007, 5.489709291000054],
            [120.94558545100006, 5.490031682000051],
            [120.9456867560001, 5.489841927000043],
        ],
        [
            [120.844749, 5.49001],
            [120.84594699900003, 5.489768],
            [120.8497, 5.488151],
            [120.840072, 5.489717001000031],
            [120.844749, 5.49001],
        ],
        [
            [120.95151877800004, 5.491147845000057],
            [120.95156416500004, 5.490819786000031],
            [120.95109211700003, 5.490672450000034],
            [120.95112680600005, 5.491005656000027],
            [120.95151877800004, 5.491147845000057],
        ],
        [
            [120.902999, 5.491876],
            [120.90415899900006, 5.491474],
            [120.90138999900012, 5.49177],
            [120.902374, 5.492169],
            [120.902999, 5.491876],
        ],
        [
            [120.89922299900002, 5.49182],
            [120.900382, 5.491142],
            [120.897308, 5.491734],
            [120.897674, 5.492357],
            [120.89922299900002, 5.49182],
        ],
        [
            [120.89310400000011, 5.492638],
            [120.895919, 5.492387001000054],
            [120.896461, 5.491589001000023],
            [120.892265, 5.491506],
            [120.89310400000011, 5.492638],
        ],
        [
            [120.94230909100008, 5.49222168700004],
            [120.94193878100009, 5.492032251000069],
            [120.94177344800005, 5.492585163000058],
            [120.94210157700002, 5.492630345000066],
            [120.94230909100008, 5.49222168700004],
        ],
        [
            [120.884201, 5.493224],
            [120.88571099900003, 5.492549],
            [120.876091, 5.49063],
            [120.8785620000001, 5.492372],
            [120.884201, 5.493224],
        ],
        [
            [120.9418493170001, 5.491834185000073],
            [120.94144343900007, 5.491771232000076],
            [120.94123408500002, 5.49323440400002],
            [120.94156783200003, 5.492985942000075],
            [120.9418493170001, 5.491834185000073],
        ],
        [
            [120.9392037340001, 5.493271845000038],
            [120.9394819150001, 5.492388464000044],
            [120.93925564300002, 5.491332349000061],
            [120.93879058300001, 5.492894059000037],
            [120.9392037340001, 5.493271845000038],
        ],
        [
            [120.921706, 5.493198],
            [120.92153399900008, 5.493421001000058],
            [120.921577, 5.493982],
            [120.9218780000001, 5.493722],
            [120.921706, 5.493198],
        ],
        [
            [120.94219282600011, 5.493566303000023],
            [120.94167635400004, 5.493434391000051],
            [120.94179866000002, 5.494116958000063],
            [120.94215032000011, 5.493971112000054],
            [120.94219282600011, 5.493566303000023],
        ],
        [
            [120.93644590600002, 5.494461571000045],
            [120.93720814000005, 5.493995292000022],
            [120.93684069200003, 5.490956289000053],
            [120.9359574670001, 5.492372347000071],
            [120.93644590600002, 5.494461571000045],
        ],
        [
            [120.92868147100012, 5.495089079000024],
            [120.93003661500006, 5.494376317000047],
            [120.930162515, 5.492442021000045],
            [120.92878362200008, 5.493650241000068],
            [120.92868147100012, 5.495089079000024],
        ],
        [
            [120.93664915500005, 5.494782032000046],
            [120.93635403300004, 5.494793275000063],
            [120.93643786400003, 5.495436803000075],
            [120.93673804500008, 5.495335815000033],
            [120.93664915500005, 5.494782032000046],
        ],
        [
            [120.921912, 5.495118001000037],
            [120.92161099900011, 5.494932],
            [120.92161099900011, 5.495489001000067],
            [120.921912, 5.49534],
            [120.921912, 5.495118001000037],
        ],
        [
            [120.76979714000004, 5.493947796000043],
            [120.77785682400008, 5.492378422000058],
            [120.7733027490001, 5.483448119000059],
            [120.77266559800012, 5.478215406000061],
            [120.76979714000004, 5.493947796000043],
        ],
        [
            [120.93757042100003, 5.495356383000058],
            [120.93833495400008, 5.494358117000047],
            [120.93806945400001, 5.493636412000058],
            [120.93690992000006, 5.494892389000029],
            [120.93757042100003, 5.495356383000058],
        ],
        [
            [120.93904401800012, 5.49490404900007],
            [120.93850042800011, 5.494843435000064],
            [120.93854888200008, 5.495581857000047],
            [120.93896556900006, 5.495345849000046],
            [120.93904401800012, 5.49490404900007],
        ],
        [
            [120.94764699900009, 5.494998],
            [120.94721899900003, 5.494077],
            [120.94632700000011, 5.49556],
            [120.946922, 5.495657],
            [120.94764699900009, 5.494998],
        ],
        [
            [120.94352027700006, 5.495396885000048],
            [120.94479313000011, 5.494154614000024],
            [120.94474806000005, 5.492296316000022],
            [120.942988968, 5.493308194000065],
            [120.94352027700006, 5.495396885000048],
        ],
        [
            [120.93121991100008, 5.496043304000068],
            [120.93137651800009, 5.495919306000076],
            [120.931362293, 5.49465704000005],
            [120.93081770800006, 5.496691648000024],
            [120.93121991100008, 5.496043304000068],
        ],
        [
            [120.92070400000011, 5.496441],
            [120.920446, 5.49659],
            [120.920575, 5.497034],
            [120.92104799900005, 5.496812],
            [120.92070400000011, 5.496441],
        ],
        [
            [120.93046426, 5.496528883000053],
            [120.9302008730001, 5.496900882000034],
            [120.93033078300004, 5.497102827000049],
            [120.93059060900009, 5.496922144000052],
            [120.93046426, 5.496528883000053],
        ],
        [
            [120.91639, 5.497745],
            [120.91613199900007, 5.497745],
            [120.91613199900007, 5.49819],
            [120.91639, 5.498153],
            [120.91639, 5.497745],
        ],
        [
            [120.92308, 5.497625],
            [120.92286500000012, 5.497882],
            [120.92303699900003, 5.498254],
            [120.923295, 5.498217001000057],
            [120.92308, 5.497625],
        ],
        [
            [120.918928, 5.498061001000053],
            [120.918326, 5.498172],
            [120.919014, 5.498915],
            [120.919229, 5.49873],
            [120.918928, 5.498061001000053],
        ],
        [
            [120.91660600000012, 5.499051],
            [120.916434, 5.498977],
            [120.9163479990001, 5.499236],
            [120.91660600000012, 5.499236],
            [120.91660600000012, 5.499051],
        ],
        [
            [120.93698630400002, 5.499026498000035],
            [120.93763485600005, 5.497139670000024],
            [120.93687430800003, 5.496230026000035],
            [120.936066116, 5.498749106000048],
            [120.93698630400002, 5.499026498000035],
        ],
        [
            [120.894569, 5.499232001000053],
            [120.893943, 5.498905],
            [120.89400400000011, 5.500167],
            [120.89458399900002, 5.499668],
            [120.894569, 5.499232001000053],
        ],
        [
            [120.93742456000007, 5.499952307000058],
            [120.93676224700005, 5.499719407000043],
            [120.93684597200001, 5.500480326000059],
            [120.93704900800003, 5.500575214000037],
            [120.93742456000007, 5.499952307000058],
        ],
        [
            [120.91694999900005, 5.500401],
            [120.916821, 5.500549],
            [120.916993, 5.500623],
            [120.917036, 5.500512],
            [120.91694999900005, 5.500401],
        ],
        [
            [120.92565162500011, 5.500669945000027],
            [120.9289578690001, 5.493195277000041],
            [120.92807293800001, 5.487606819000064],
            [120.92191749300002, 5.491549287000055],
            [120.92565162500011, 5.500669945000027],
        ],
        [
            [120.936049034, 5.50049731200005],
            [120.93581841900004, 5.500525588000073],
            [120.93594876500003, 5.50149037400007],
            [120.93616768100003, 5.500986358000034],
            [120.936049034, 5.50049731200005],
        ],
        [
            [120.83735425300006, 5.501324859000022],
            [120.83751274600002, 5.500757130000068],
            [120.83668897000007, 5.499887931000046],
            [120.83662854800002, 5.501233721000062],
            [120.83735425300006, 5.501324859000022],
        ],
        [
            [120.92829703300004, 5.502307851000069],
            [120.9306925300001, 5.499250083000049],
            [120.9299268100001, 5.496886707000044],
            [120.92817782400004, 5.500607559000059],
            [120.92829703300004, 5.502307851000069],
        ],
        [
            [120.56689453100012, 5.498107910000044],
            [120.56207275400004, 5.501708984000061],
            [120.56207275400004, 5.503112793000071],
            [120.56610107400002, 5.502319336000028],
            [120.56689453100012, 5.498107910000044],
        ],
        [
            [120.83674545100007, 5.503592697000045],
            [120.83691444800002, 5.503488840000045],
            [120.83701268200002, 5.503259628000023],
            [120.83673246, 5.503172810000024],
            [120.83674545100007, 5.503592697000045],
        ],
        [
            [120.7826752630001, 5.503259836000041],
            [120.78251333000003, 5.502822174000073],
            [120.78216034700006, 5.503128502000038],
            [120.78262458300003, 5.503593131000059],
            [120.7826752630001, 5.503259836000041],
        ],
        [
            [120.78267345600011, 5.503866293000044],
            [120.78258220100008, 5.503942293000023],
            [120.78269967300002, 5.504161411000041],
            [120.78289157000006, 5.504017809000061],
            [120.78267345600011, 5.503866293000044],
        ],
        [
            [120.8371975440001, 5.503944552000064],
            [120.83741768300001, 5.503494513000021],
            [120.83735231800006, 5.503407942000024],
            [120.83685384800003, 5.503778577000048],
            [120.8371975440001, 5.503944552000064],
        ],
        [
            [120.78447335300007, 5.505682318000026],
            [120.78516558900003, 5.503733402000023],
            [120.78336481200006, 5.502918610000052],
            [120.78379760300004, 5.505393570000024],
            [120.78447335300007, 5.505682318000026],
        ],
        [
            [120.9336067480001, 5.505102931000067],
            [120.93517369300002, 5.503576281000051],
            [120.9351540030001, 5.500344325000071],
            [120.93362238600002, 5.501804306000054],
            [120.9336067480001, 5.505102931000067],
        ],
        [
            [120.96323694800003, 5.50688395100002],
            [120.96478657700004, 5.506305963000045],
            [120.96520515800012, 5.504112780000071],
            [120.96243560800008, 5.497666706000075],
            [120.95693822400006, 5.491925524000067],
            [120.95174088200008, 5.489440530000024],
            [120.9257299730001, 5.485643467000045],
            [120.91551637700002, 5.488220862000048],
            [120.90437682000004, 5.488900896000075],
            [120.90338965600006, 5.489438868000036],
            [120.91485733900004, 5.488846454000054],
            [120.92476375100011, 5.486430571000028],
            [120.93258776200003, 5.488555981000047],
            [120.94501523600002, 5.488890963000074],
            [120.95154769600003, 5.490398739000057],
            [120.96323694800003, 5.50688395100002],
        ],
        [
            [120.9539762070001, 5.491879956000048],
            [120.95395024200002, 5.491445352000028],
            [120.95442384900002, 5.491741475000026],
            [120.95437386900005, 5.491853128000059],
            [120.9539762070001, 5.491879956000048],
        ],
        [
            [120.94638740100004, 5.506980622000071],
            [120.95097221800006, 5.504294730000026],
            [120.94785650800009, 5.500580238000055],
            [120.9455007470001, 5.501957440000069],
            [120.94638740100004, 5.506980622000071],
        ],
        [
            [120.94069357400008, 5.507725622000066],
            [120.94413764300009, 5.505996473000039],
            [120.94342805200006, 5.49883557000004],
            [120.94103403200006, 5.501134678000028],
            [120.94069357400008, 5.507725622000066],
        ],
        [
            [120.88993788700009, 5.509684161000052],
            [120.88985785600005, 5.509071865000067],
            [120.8891972350001, 5.508767145000036],
            [120.88935218900008, 5.509290853000039],
            [120.88993788700009, 5.509684161000052],
        ],
        [
            [120.907028, 5.508042],
            [120.905403, 5.509107],
            [120.906532, 5.511319],
            [120.907577, 5.510456],
            [120.907028, 5.508042],
        ],
        [
            [120.94846684700008, 5.51477597500002],
            [120.94924588200001, 5.514525330000026],
            [120.94920024100009, 5.51371230500007],
            [120.94838501000004, 5.514407842000026],
            [120.94846684700008, 5.51477597500002],
        ],
        [
            [120.94564914900002, 5.514940140000022],
            [120.94933677200004, 5.512997],
            [120.95175730300002, 5.51418263100004],
            [120.95170526700008, 5.508632523000074],
            [120.94564914900002, 5.514940140000022],
        ],
        [
            [120.964218, 5.514498],
            [120.9634850000001, 5.514263],
            [120.963066, 5.514442],
            [120.964073, 5.515277],
            [120.964218, 5.514498],
        ],
        [
            [120.94606843300005, 5.515951997000059],
            [120.9480985780001, 5.514880934000075],
            [120.94811116700009, 5.514716448000058],
            [120.94626084600009, 5.514877601000023],
            [120.94606843300005, 5.515951997000059],
        ],
        [
            [120.79437162200009, 5.517206478000048],
            [120.79403044100002, 5.516786515000035],
            [120.79378213200005, 5.516802595000058],
            [120.79398805500011, 5.517190411000058],
            [120.79437162200009, 5.517206478000048],
        ],
        [
            [120.95327251000003, 5.517656242000044],
            [120.95429952200004, 5.516976814000031],
            [120.95420862300011, 5.515183612000044],
            [120.9522894270001, 5.515904123000041],
            [120.95327251000003, 5.517656242000044],
        ],
        [
            [120.94783594500007, 5.518126688000052],
            [120.94967706200009, 5.516882845000055],
            [120.95014289800008, 5.515666443000043],
            [120.94726369400007, 5.516329112000051],
            [120.94783594500007, 5.518126688000052],
        ],
        [
            [120.95493785800011, 5.519476430000054],
            [120.95450285800007, 5.517348104000064],
            [120.95411362900006, 5.518215189000045],
            [120.95234474000006, 5.517828297000051],
            [120.95493785800011, 5.519476430000054],
        ],
        [
            [120.963897, 5.517041],
            [120.96275999900001, 5.517765],
            [120.963195, 5.520222],
            [120.963806, 5.519516],
            [120.963897, 5.517041],
        ],
        [
            [120.95490051500008, 5.520410484000024],
            [120.9552333370001, 5.520092731000034],
            [120.95416173400008, 5.519770632000075],
            [120.95441717000006, 5.520398448000037],
            [120.95490051500008, 5.520410484000024],
        ],
        [
            [120.82444408600009, 5.521366778000072],
            [120.8242327050001, 5.521549685000025],
            [120.82437553300008, 5.521815054000058],
            [120.8246747820001, 5.521574208000061],
            [120.82444408600009, 5.521366778000072],
        ],
        [
            [120.82376331700004, 5.522391670000047],
            [120.82395233500006, 5.521388263000063],
            [120.82272564400012, 5.521126353000056],
            [120.82271211200009, 5.521830117000036],
            [120.82376331700004, 5.522391670000047],
        ],
        [
            [120.9625390000001, 5.521317],
            [120.961891, 5.522091],
            [120.962051, 5.522482],
            [120.962509, 5.522165001000076],
            [120.9625390000001, 5.521317],
        ],
        [
            [120.82474490800007, 5.52267590200006],
            [120.82480060700004, 5.522211793000054],
            [120.82449885400001, 5.521893530000057],
            [120.82422572900009, 5.522529993000035],
            [120.82474490800007, 5.52267590200006],
        ],
        [
            [120.80672575000006, 5.508959200000049],
            [120.80563119900012, 5.510339287000022],
            [120.81053288800001, 5.524378107000075],
            [120.81115154800011, 5.51633552900006],
            [120.80672575000006, 5.508959200000049],
        ],
        [
            [120.95641588700005, 5.524365231000047],
            [120.95585448400004, 5.522832243000039],
            [120.95439100500005, 5.522962751000023],
            [120.95494589300006, 5.524037665000037],
            [120.95641588700005, 5.524365231000047],
        ],
        [
            [120.90942915900007, 5.526133837000032],
            [120.90980887600006, 5.523432273000026],
            [120.90773254400005, 5.523080376000053],
            [120.90730707500006, 5.524570545000074],
            [120.90942915900007, 5.526133837000032],
        ],
        [
            [120.80161053000006, 5.526411569000061],
            [120.8022364420001, 5.52610644400005],
            [120.80122513000003, 5.523660348000021],
            [120.8000892230001, 5.525730005000071],
            [120.80161053000006, 5.526411569000061],
        ],
        [
            [120.80366258000004, 5.514685792000023],
            [120.80039869500001, 5.456466716000023],
            [120.79025066800011, 5.455053231000022],
            [120.77377779200003, 5.483617253000034],
            [120.80366258000004, 5.514685792000023],
        ],
        [
            [120.79906103200005, 5.474980484000071],
            [120.79415083800006, 5.473356856000066],
            [120.79330833400002, 5.464627804000031],
            [120.80018881600006, 5.468701373000044],
            [120.79906103200005, 5.474980484000071],
        ],
        [
            [120.79898814700005, 5.475497779000023],
            [120.79858098600005, 5.475076096000066],
            [120.79918808600007, 5.47509214300004],
            [120.79935225400004, 5.475202957000022],
            [120.79898814700005, 5.475497779000023],
        ],
        [
            [120.959869, 5.528769],
            [120.959877, 5.528173001000027],
            [120.958251, 5.528985],
            [120.95907499900011, 5.529405],
            [120.959869, 5.528769],
        ],
        [
            [120.95858, 5.530684],
            [120.958007, 5.530863001000057],
            [120.958297, 5.531324],
            [120.958694, 5.530983],
            [120.95858, 5.530684],
        ],
        [
            [120.80642938400001, 5.541740714000071],
            [120.8062499350001, 5.540808059000028],
            [120.80631375100006, 5.540708551000023],
            [120.8061678580001, 5.540738508000061],
            [120.8062354440001, 5.541918873000043],
            [120.80642938400001, 5.541740714000071],
        ],
        [
            [120.80771848400002, 5.54712312700002],
            [120.80764885400004, 5.546913236000023],
            [120.80740813400007, 5.546948878000023],
            [120.80755336200002, 5.547192432000031],
            [120.80771848400002, 5.54712312700002],
        ],
        [
            [120.80835907500011, 5.548411624000039],
            [120.80790747200001, 5.547374049000041],
            [120.80780004300004, 5.547350287000029],
            [120.8077542960001, 5.548083477000034],
            [120.80835907500011, 5.548411624000039],
        ],
        [
            [120.80840898500003, 5.549050560000069],
            [120.80871535500012, 5.548882250000077],
            [120.80833338500008, 5.548527812000032],
            [120.80811852800002, 5.549171347000026],
            [120.80840898500003, 5.549050560000069],
        ],
        [
            [120.8998316520001, 5.549908944000038],
            [120.900043159, 5.549525193000022],
            [120.89950338100005, 5.549235395000039],
            [120.89947710400008, 5.54972114800006],
            [120.8998316520001, 5.549908944000038],
        ],
        [
            [120.75637494900002, 5.555750556000021],
            [120.75674172600009, 5.551273477000052],
            [120.7534632820001, 5.550362386000074],
            [120.75239453400002, 5.55269944500003],
            [120.75637494900002, 5.555750556000021],
        ],
        [
            [120.91243098600012, 5.556719807000036],
            [120.92719977100012, 5.551764761000072],
            [120.93013840800006, 5.545698242000071],
            [120.91998548400011, 5.546308894000049],
            [120.91243098600012, 5.556719807000036],
        ],
        [
            [120.76375049500007, 5.559091705000071],
            [120.76351784700012, 5.558932179000067],
            [120.76339201200005, 5.558572524000056],
            [120.76345594200006, 5.559203033000074],
            [120.76375049500007, 5.559091705000071],
        ],
        [
            [120.79411646200003, 5.569782560000021],
            [120.8054664440001, 5.530475864000039],
            [120.75849781800002, 5.497767826000029],
            [120.76070178300006, 5.556125859000076],
            [120.79411646200003, 5.569782560000021],
        ],
        [
            [120.8222034470001, 5.571285190000026],
            [120.8222812780001, 5.570848566000052],
            [120.8218310530001, 5.570402988000069],
            [120.8217197130001, 5.57117069100002],
            [120.8222034470001, 5.571285190000026],
        ],
        [
            [120.72936950400003, 5.586067329000059],
            [120.72916827100005, 5.583211515000073],
            [120.72614051300002, 5.583976377000056],
            [120.72604777300012, 5.584570787000075],
            [120.72936950400003, 5.586067329000059],
        ],
        [
            [120.86125600800005, 5.58863889600002],
            [120.8615804750001, 5.588417183000047],
            [120.86086447200012, 5.58848376800006],
            [120.86099235200004, 5.588816700000052],
            [120.86125600800005, 5.58863889600002],
        ],
        [
            [120.86322984100002, 5.589317723000022],
            [120.86344248900002, 5.589141433000066],
            [120.863065075, 5.589000032000058],
            [120.8630209910001, 5.589186486000074],
            [120.86322984100002, 5.589317723000022],
        ],
        [
            [120.85073244300008, 5.592251361000024],
            [120.90810740800009, 5.536364913000057],
            [120.856914802, 5.487558487000058],
            [120.81227254500004, 5.544503208000037],
            [120.85073244300008, 5.592251361000024],
        ],
        [
            [120.81908886800011, 5.54995980800004],
            [120.81890123300002, 5.549601860000053],
            [120.81902111300008, 5.549335562000067],
            [120.8195683780001, 5.549788619000026],
            [120.81908886800011, 5.54995980800004],
        ],
        [
            [120.81925391200002, 5.550940274000027],
            [120.81947108600002, 5.550124087000029],
            [120.82024421100004, 5.550359262000029],
            [120.8196569810001, 5.550530452000032],
            [120.81925391200002, 5.550940274000027],
        ],
        [
            [120.87413421100007, 5.601648954000041],
            [120.87436126700004, 5.601371717000063],
            [120.87385587500012, 5.60073187100005],
            [120.87378131500009, 5.601622629000076],
            [120.87413421100007, 5.601648954000041],
        ],
        [
            [120.87315722100004, 5.603301759000033],
            [120.87380579, 5.601797537000039],
            [120.87290476100009, 5.600127263000047],
            [120.87214954600006, 5.602909608000061],
            [120.87315722100004, 5.603301759000033],
        ],
        [
            [120.85743983900011, 5.600536625000075],
            [120.8662192270001, 5.592666827000073],
            [120.87718874000007, 5.600572929000066],
            [120.87724389700008, 5.594180829000038],
            [120.8593539420001, 5.588695065000024],
            [120.85743983900011, 5.600536625000075],
        ],
        [
            [120.27564225000003, 5.629650402000038],
            [120.28496296900005, 5.623055165000039],
            [120.27451240700009, 5.615090266000038],
            [120.26949498700003, 5.623467757000071],
            [120.27564225000003, 5.629650402000038],
        ],
        [
            [120.27922495200005, 5.639652893000061],
            [120.2813049, 5.636781087000031],
            [120.28054299000007, 5.634859494000068],
            [120.27637941500006, 5.638405172000034],
            [120.27922495200005, 5.639652893000061],
        ],
        [
            [120.2816599030001, 5.655532659000073],
            [120.2828416960001, 5.65354161700003],
            [120.2824417060001, 5.651536390000047],
            [120.28003570400006, 5.65393763700007],
            [120.2816599030001, 5.655532659000073],
        ],
        [
            [120.34858697800007, 5.669886041000041],
            [120.35383353400005, 5.663114570000062],
            [120.35327019600004, 5.660612084000036],
            [120.34578860200008, 5.665880832000028],
            [120.34858697800007, 5.669886041000041],
        ],
        [
            [121.01278876900005, 5.685343274000047],
            [121.01348271200004, 5.684412519000034],
            [121.01200578100008, 5.683447023000042],
            [121.01172094500009, 5.683882009000058],
            [121.01278876900005, 5.685343274000047],
        ],
        [
            [121.01651108100009, 5.685431487000074],
            [121.01657297500003, 5.68524207400003],
            [121.01620376700009, 5.685149237000076],
            [121.01626928000007, 5.685592861000032],
            [121.01651108100009, 5.685431487000074],
        ],
        [
            [121.01550454300002, 5.685849680000047],
            [121.0147130790001, 5.68631047100007],
            [121.0153273310001, 5.687441840000076],
            [121.01626911300002, 5.686741355000038],
            [121.01550454300002, 5.685849680000047],
        ],
        [
            [120.21525344100007, 5.689603770000076],
            [120.21585235300006, 5.689990953000063],
            [120.21612957800005, 5.688963368000032],
            [120.21532125100009, 5.689066639000032],
            [120.21473583400007, 5.690170741000031],
            [120.21525344100007, 5.689603770000076],
        ],
        [
            [121.01594830500005, 5.690208765000023],
            [121.01644447500007, 5.689861780000058],
            [121.0158755540001, 5.689516536000042],
            [121.01551330300003, 5.689901763000023],
            [121.01594830500005, 5.690208765000023],
        ],
        [
            [121.01672133800002, 5.690314447000048],
            [121.0169715830001, 5.690214509000043],
            [121.01653101000011, 5.689899599000057],
            [121.0164211870001, 5.690318510000054],
            [121.01672133800002, 5.690314447000048],
        ],
        [
            [121.0110711320001, 5.691994945000033],
            [121.01417947800007, 5.687182538000059],
            [121.00982404600006, 5.684811404000072],
            [121.00809323500005, 5.686931052000034],
            [121.0110711320001, 5.691994945000033],
        ],
        [
            [121.01601157000005, 5.69206321200005],
            [121.01570384100012, 5.690834989000052],
            [121.0149278, 5.690814440000054],
            [121.01484386700008, 5.691813529000058],
            [121.01601157000005, 5.69206321200005],
        ],
        [
            [121.06690138800002, 5.694177133000039],
            [121.07100447900007, 5.675202],
            [121.042223755, 5.658227541000031],
            [121.0123234460001, 5.681861568000045],
            [121.06690138800002, 5.694177133000039],
        ],
        [
            [121.01560485300001, 5.694409317000066],
            [121.01682129400001, 5.693617670000037],
            [121.01662804400007, 5.692511786000068],
            [121.01454805700007, 5.693445815000075],
            [121.01560485300001, 5.694409317000066],
        ],
        [
            [120.89994872300008, 5.696396355000047],
            [120.89998882700002, 5.69568920200004],
            [120.8988435440001, 5.695908088000067],
            [120.89916128800007, 5.696300516000065],
            [120.89994872300008, 5.696396355000047],
        ],
        [
            [120.90080543800002, 5.697070093000036],
            [120.90060477100008, 5.696885099000042],
            [120.90039082400006, 5.697011366000027],
            [120.90067707100002, 5.697152313000061],
            [120.90080543800002, 5.697070093000036],
        ],
        [
            [120.994292158, 5.698180187000048],
            [121.01138202300001, 5.672777019000023],
            [121.0110141670001, 5.667683577000048],
            [120.99539707100007, 5.678975342000058],
            [120.994292158, 5.698180187000048],
        ],
        [
            [120.90981802700003, 5.698176811000053],
            [120.9111801250001, 5.697512867000057],
            [120.9115165180001, 5.696369358000027],
            [120.908781255, 5.694636339000056],
            [120.90981802700003, 5.698176811000053],
        ],
        [
            [120.22028273900003, 5.698426357000073],
            [120.2243093720001, 5.696212698000068],
            [120.22219849600003, 5.692291239000042],
            [120.21575417300005, 5.697676762000071],
            [120.22028273900003, 5.698426357000073],
        ],
        [
            [120.91142331200001, 5.699259479000034],
            [120.91152841700011, 5.698852964000025],
            [120.91107376700006, 5.698719114000028],
            [120.91104166800005, 5.699223105000044],
            [120.91142331200001, 5.699259479000034],
        ],
        [
            [120.91078489000006, 5.699348895000071],
            [120.91078950800011, 5.698719217000075],
            [120.9105075110001, 5.698589663000064],
            [120.91024738800002, 5.699089718000039],
            [120.91078489000006, 5.699348895000071],
        ],
        [
            [120.91080471100008, 5.699534026000038],
            [120.91065059000005, 5.699393763000046],
            [120.91037639000001, 5.699500800000067],
            [120.9105274750001, 5.699724047000075],
            [120.91080471100008, 5.699534026000038],
        ],
        [
            [120.90526375800005, 5.701234714000066],
            [120.90560240600007, 5.701272729000038],
            [120.90578690300003, 5.701147124000045],
            [120.90538916300011, 5.700921755000024],
            [120.90526375800005, 5.701234714000066],
        ],
        [
            [120.91540929400003, 5.701662145000057],
            [120.91626941600009, 5.700062761000027],
            [120.91447381500006, 5.697778702000051],
            [120.91330614200001, 5.700565643000061],
            [120.91540929400003, 5.701662145000057],
        ],
        [
            [120.87931192700012, 5.706366415000048],
            [120.87941527400005, 5.706341122000026],
            [120.87943201400003, 5.706200209000031],
            [120.87923839100006, 5.706316667000067],
            [120.87931192700012, 5.706366415000048],
        ],
        [
            [120.87961471200003, 5.706394403000047],
            [120.87954578400002, 5.706293544000062],
            [120.8794073680001, 5.706396144000053],
            [120.87956337100002, 5.706524744000035],
            [120.87961471200003, 5.706394403000047],
        ],
        [
            [121.00732421900011, 5.70648193300002],
            [121.00628662100007, 5.706909180000025],
            [121.00671386700003, 5.707885743000077],
            [121.00750732400002, 5.707702637000068],
            [121.00732421900011, 5.70648193300002],
        ],
        [
            [121.02551269500009, 5.707275391000053],
            [121.0247192380001, 5.707275391000053],
            [121.024902343, 5.708312988000046],
            [121.0256958010001, 5.708129883000026],
            [121.02551269500009, 5.707275391000053],
        ],
        [
            [121.01611328100012, 5.707885743000077],
            [121.01531982400002, 5.707702637000068],
            [121.01489257800006, 5.707885743000077],
            [121.01531982400002, 5.708679199000073],
            [121.01611328100012, 5.707885743000077],
        ],
        [
            [121.01867675800008, 5.707092285000044],
            [121.01751709000007, 5.708129883000026],
            [121.01910400400004, 5.709106446000021],
            [121.01928710900006, 5.707885743000077],
            [121.01867675800008, 5.707092285000044],
        ],
        [
            [120.83627921200002, 5.710169099000041],
            [120.88819958600004, 5.684756834000041],
            [120.79838860300003, 5.66350275800005],
            [120.80484387500007, 5.69996165200007],
            [120.83627921200002, 5.710169099000041],
        ],
        [
            [121.02146099900006, 5.711444],
            [121.02159799900005, 5.710708001000057],
            [121.019866, 5.710300001000064],
            [121.019851, 5.711102],
            [121.02146099900006, 5.711444],
        ],
        [
            [121.0166239990001, 5.711108],
            [121.015968, 5.710935],
            [121.015068, 5.711431001000051],
            [121.015861, 5.711808],
            [121.0166239990001, 5.711108],
        ],
        [
            [121.0145030000001, 5.711485],
            [121.014038, 5.711424],
            [121.013389, 5.711457],
            [121.013908, 5.712091],
            [121.0145030000001, 5.711485],
        ],
        [
            [121.024536, 5.712725],
            [121.023925, 5.712482001000069],
            [121.023513, 5.713039],
            [121.024398, 5.713232],
            [121.024536, 5.712725],
        ],
        [
            [121.017723, 5.713039],
            [121.018608, 5.712773],
            [121.015846, 5.712014001000057],
            [121.0158530000001, 5.713092],
            [121.017723, 5.713039],
        ],
        [
            [121.03070068400007, 5.713928223000039],
            [121.0300903320001, 5.711730957000043],
            [121.02288818300008, 5.709472657000049],
            [121.02538195900001, 5.712588870000047],
            [121.024688, 5.713823],
            [121.03070068400007, 5.713928223000039],
        ],
        [
            [121.02807617100007, 5.716674804000036],
            [121.02709960900006, 5.717285156000059],
            [121.02850341800001, 5.718322754000042],
            [121.02868652300003, 5.717285156000059],
            [121.02807617100007, 5.716674804000036],
        ],
        [
            [121.00007019200007, 5.719755974000066],
            [121.00033096600009, 5.718967650000025],
            [120.99934861700001, 5.718537609000066],
            [120.99914894800008, 5.719551499000033],
            [121.00007019200007, 5.719755974000066],
        ],
        [
            [121.02429199200003, 5.720092773000033],
            [121.02429199200003, 5.719482422000056],
            [121.02368164100005, 5.719726563000052],
            [121.02429199200003, 5.720092773000033],
        ],
        [
            [121.00049036500002, 5.720474097000022],
            [121.00050551200002, 5.720361040000057],
            [120.99984499000004, 5.720002283000042],
            [121.00002981900002, 5.720398730000056],
            [121.00049036500002, 5.720474097000022],
        ],
        [
            [121.02947998000002, 5.720092773000033],
            [121.02850341800001, 5.720092773000033],
            [121.02868652300003, 5.720886231000065],
            [121.02947998000002, 5.720886231000065],
            [121.02947998000002, 5.720092773000033],
        ],
        [
            [121.0112218480001, 5.720965931000023],
            [121.01190294000003, 5.720249588000058],
            [121.01088967400005, 5.719826176000026],
            [121.01047552200009, 5.721097273000055],
            [121.0112218480001, 5.720965931000023],
        ],
        [
            [120.99864534400001, 5.721133749000046],
            [120.99864442800003, 5.72011896500004],
            [120.99801231600009, 5.720073843000023],
            [120.99791968500006, 5.720831963000023],
            [120.99864534400001, 5.721133749000046],
        ],
        [
            [121.01313891100006, 5.721163337000064],
            [121.01401429500004, 5.721320708000064],
            [121.01529435200007, 5.720448501000021],
            [121.01298563600005, 5.719508103000067],
            [121.01313891100006, 5.721163337000064],
        ],
        [
            [121.0247192380001, 5.721496583000032],
            [121.02368164100005, 5.721130371000072],
            [121.02392578100012, 5.722473145000038],
            [121.02447509700005, 5.722473145000038],
            [121.0247192380001, 5.721496583000032],
        ],
        [
            [121.02770996000004, 5.722290039000029],
            [121.02709960900006, 5.722106934000067],
            [121.02728271500007, 5.722900391000053],
            [121.02770996000004, 5.722900391000053],
            [121.02770996000004, 5.722290039000029],
        ],
        [
            [121.02777799900002, 5.724161],
            [121.026962, 5.724105001000055],
            [121.026741, 5.725553],
            [121.02795399900003, 5.724892],
            [121.02777799900002, 5.724161],
        ],
        [
            [121.02745, 5.726482],
            [121.026756, 5.726654],
            [121.027023, 5.727452],
            [121.0273889990001, 5.727354],
            [121.02745, 5.726482],
        ],
        [
            [120.29945397900008, 5.732872970000074],
            [120.30027122900003, 5.727829754000027],
            [120.29487171900007, 5.725384875000032],
            [120.29512090900005, 5.72986363900003],
            [120.29945397900008, 5.732872970000074],
        ],
        [
            [120.99796906300003, 5.737726473000066],
            [121.01650613000004, 5.731874961000074],
            [121.00862451600005, 5.721719730000075],
            [121.0121052400001, 5.715750972000023],
            [120.99796906300003, 5.737726473000066],
        ],
        [
            [120.40688896200004, 5.734393092000062],
            [120.40069970000002, 5.720162108000068],
            [120.3979316550001, 5.719419094000045],
            [120.40881570400006, 5.739992347000054],
            [120.40688896200004, 5.734393092000062],
        ],
        [
            [120.91082791600002, 5.759481673000039],
            [120.9348160720001, 5.718136884000046],
            [120.89058576700006, 5.694105813000021],
            [120.88598562400011, 5.741931357000055],
            [120.91082791600002, 5.759481673000039],
        ],
        [
            [120.41566311200006, 5.763638624000066],
            [120.41883827700008, 5.759159716000056],
            [120.41053337100004, 5.745510864000039],
            [120.40884829000004, 5.75969974700007],
            [120.41566311200006, 5.763638624000066],
        ],
        [
            [121.157500303, 5.779552871000021],
            [121.1574179910001, 5.779322565000029],
            [121.15723323500004, 5.779477540000073],
            [121.157337815, 5.779639205000024],
            [121.157500303, 5.779552871000021],
        ],
        [
            [121.19748880300006, 5.791672591000065],
            [121.19283468700007, 5.788506215000041],
            [121.19229081200001, 5.788375930000029],
            [121.19383398100001, 5.789964785000052],
            [121.19748880300006, 5.791672591000065],
        ],
        [
            [121.21418596600006, 5.79902689000005],
            [121.21361310100008, 5.798033047000047],
            [121.20850748200007, 5.796776493000038],
            [121.20761997800003, 5.796838019000063],
            [121.21418596600006, 5.79902689000005],
        ],
        [
            [121.20646650300012, 5.800223824000057],
            [121.20632391900006, 5.800568592000047],
            [121.20656578300009, 5.80127069200006],
            [121.20665060500005, 5.80050394500006],
            [121.20646650300012, 5.800223824000057],
        ],
        [
            [121.21191853700009, 5.801249454000072],
            [121.21176446600009, 5.80136993800005],
            [121.21184796700004, 5.80175256800004],
            [121.21206964600003, 5.801437951000025],
            [121.21191853700009, 5.801249454000072],
        ],
        [
            [121.21230330000003, 5.802473622000036],
            [121.21273155300003, 5.80198841400005],
            [121.21212747300001, 5.80180327000005],
            [121.21186274000002, 5.802189712000029],
            [121.21230330000003, 5.802473622000036],
        ],
        [
            [121.21308656500003, 5.803184430000044],
            [121.21330713700002, 5.803496869000071],
            [121.21412996300012, 5.803068691000021],
            [121.21278341900006, 5.802844500000049],
            [121.21272714200006, 5.803825362000055],
            [121.21308656500003, 5.803184430000044],
        ],
        [
            [121.21146296800009, 5.80331598600003],
            [121.21148005000009, 5.802848795000045],
            [121.21105130300009, 5.804045887000029],
            [121.21128561300009, 5.80388742100007],
            [121.21146296800009, 5.80331598600003],
        ],
        [
            [121.20635741000001, 5.804049638000038],
            [121.20607823500006, 5.803709753000021],
            [121.20583697500001, 5.803834486000028],
            [121.20632880800008, 5.804503174000047],
            [121.20635741000001, 5.804049638000038],
        ],
        [
            [121.20629545700001, 5.805020458000058],
            [121.20645584200008, 5.805061340000066],
            [121.20635907700012, 5.804905134000023],
            [121.2061396360001, 5.80514359600005],
            [121.20629545700001, 5.805020458000058],
        ],
        [
            [121.21111943900007, 5.805493746000025],
            [121.2126672930001, 5.803628016000062],
            [121.21211470500009, 5.802576307000038],
            [121.21115789400005, 5.804272567000055],
            [121.21111943900007, 5.805493746000025],
        ],
        [
            [121.20641594000006, 5.805247773000076],
            [121.20619955000006, 5.805408567000029],
            [121.20631103200003, 5.805664815000057],
            [121.20647409000003, 5.805546204000052],
            [121.20641594000006, 5.805247773000076],
        ],
        [
            [121.20917294500009, 5.806579085000067],
            [121.2105606340001, 5.802471036000043],
            [121.20915701100012, 5.800701981000032],
            [121.20671913000001, 5.803489253000066],
            [121.20917294500009, 5.806579085000067],
        ],
        [
            [121.23370487800003, 5.808286710000061],
            [121.23445204600011, 5.807813710000062],
            [121.23229107400005, 5.806408603000023],
            [121.23340892500005, 5.808375193000074],
            [121.23370487800003, 5.808286710000061],
        ],
        [
            [121.23539259900008, 5.808602348000022],
            [121.23504880300004, 5.808134572000029],
            [121.23501718400007, 5.809057163000034],
            [121.23513984300007, 5.808999849000031],
            [121.23539259900008, 5.808602348000022],
        ],
        [
            [121.23695179200001, 5.809682131000045],
            [121.237342065, 5.809480612000073],
            [121.2362474680001, 5.808859363000067],
            [121.23616382300008, 5.809537901000056],
            [121.23695179200001, 5.809682131000045],
        ],
        [
            [121.21119709900006, 5.810205765000035],
            [121.21152367600007, 5.808726318000026],
            [121.21072425300008, 5.807905361000053],
            [121.21028816800003, 5.809762084000056],
            [121.21119709900006, 5.810205765000035],
        ],
        [
            [121.21270945200001, 5.81007167000007],
            [121.21675309300008, 5.805222327000024],
            [121.21579878600005, 5.802964687000042],
            [121.21118991600008, 5.80580963400007],
            [121.21270945200001, 5.81007167000007],
        ],
        [
            [121.2392446770001, 5.810764723000034],
            [121.23851955400005, 5.810279988000048],
            [121.23832564200006, 5.810291332000077],
            [121.23850976800009, 5.81075822400004],
            [121.2392446770001, 5.810764723000034],
        ],
        [
            [120.39942147900001, 5.811546514000042],
            [120.41991419100009, 5.791956601000038],
            [120.41593006700009, 5.773303481000028],
            [120.40115273900005, 5.787964395000074],
            [120.39942147900001, 5.811546514000042],
        ],
        [
            [121.21010923600011, 5.821240618000047],
            [121.24187883400009, 5.814911584000072],
            [121.22385621600006, 5.817699092000055],
            [121.22461183000007, 5.811132882000038],
            [121.21010923600011, 5.821240618000047],
        ],
        [
            [121.2006182450001, 5.824143814000024],
            [121.20049803400002, 5.823553024000034],
            [121.20003553400011, 5.823744986000065],
            [121.20029196100006, 5.82435102200003],
            [121.2006182450001, 5.824143814000024],
        ],
        [
            [121.20333205000009, 5.828793104000056],
            [121.20399313500002, 5.828450867000072],
            [121.20385216800003, 5.826377083000068],
            [121.20182379100004, 5.827626391000024],
            [121.20333205000009, 5.828793104000056],
        ],
        [
            [121.20348924000007, 5.830385100000058],
            [121.20352326800003, 5.830024512000023],
            [121.20297291400004, 5.830229090000046],
            [121.20303948900005, 5.830410121000057],
            [121.20348924000007, 5.830385100000058],
        ],
        [
            [121.1969259120001, 5.830763914000045],
            [121.19718947900003, 5.830439280000064],
            [121.19663789700007, 5.829531471000053],
            [121.1964561530001, 5.83055700400007],
            [121.1969259120001, 5.830763914000045],
        ],
        [
            [121.19683004800004, 5.831157026000028],
            [121.19698066, 5.830967954000073],
            [121.19695197100009, 5.830825258000061],
            [121.19661489200007, 5.830905524000059],
            [121.19683004800004, 5.831157026000028],
        ],
        [
            [121.19508330100007, 5.83451562700003],
            [121.194801589, 5.834629684000049],
            [121.19479176100003, 5.835017477000065],
            [121.1951136020001, 5.834782845000063],
            [121.19508330100007, 5.83451562700003],
        ],
        [
            [121.14084471500007, 5.836724675000028],
            [121.1407148720001, 5.836857329000054],
            [121.14090611900008, 5.836969044000057],
            [121.14097104300004, 5.836794497000028],
            [121.14084471500007, 5.836724675000028],
        ],
        [
            [121.1406306450001, 5.837120896000044],
            [121.1404429160001, 5.836691500000029],
            [121.14001479100011, 5.836934113000041],
            [121.1404657060001, 5.837442060000058],
            [121.1406306450001, 5.837120896000044],
        ],
        [
            [121.19866454600003, 5.838194711000028],
            [121.20412736500009, 5.833734092000043],
            [121.20043031600005, 5.82866752800004],
            [121.19577702600009, 5.832690360000072],
            [121.19866454600003, 5.838194711000028],
        ],
        [
            [121.19547613500004, 5.83945600900006],
            [121.19740186400008, 5.839139132000071],
            [121.19732937600008, 5.838466615000073],
            [121.19509122000011, 5.837981489000072],
            [121.19547613500004, 5.83945600900006],
        ],
        [
            [121.17823916600003, 5.843539537000026],
            [121.17866345300001, 5.843156721000071],
            [121.17830446200003, 5.842256687000031],
            [121.17799356700004, 5.842625757000064],
            [121.17823916600003, 5.843539537000026],
        ],
        [
            [121.23995118100004, 5.843678657000055],
            [121.24102766100009, 5.842759775000047],
            [121.24133282900004, 5.841073894000033],
            [121.23831159300005, 5.836703950000071],
            [121.23297331800006, 5.837890774000073],
            [121.23764936200007, 5.837399556000037],
            [121.23995118100004, 5.843678657000055],
        ],
        [
            [121.02747624500012, 5.841191753000032],
            [121.0318007510001, 5.83854883500004],
            [121.0286182100001, 5.833741840000073],
            [121.02106091000007, 5.839546084000062],
            [121.02747624500012, 5.841191753000032],
        ],
        [
            [121.12930255100002, 5.845058030000075],
            [121.13135865400011, 5.843044668000061],
            [121.12963436400003, 5.841450953000049],
            [121.12775237700009, 5.843334550000066],
            [121.12930255100002, 5.845058030000075],
        ],
        [
            [121.10377292500004, 5.844833965000021],
            [121.10723169200003, 5.84245616100003],
            [121.10246427200002, 5.839238959000056],
            [121.10048700900006, 5.841676508000035],
            [121.10377292500004, 5.844833965000021],
        ],
        [
            [121.146611731, 5.849783845000047],
            [121.19370692100006, 5.83592477600007],
            [121.20606404000011, 5.800202280000065],
            [121.13857167800006, 5.788394658000072],
            [121.146611731, 5.849783845000047],
        ],
        [
            [121.15924268600008, 5.844497788000069],
            [121.15940956000009, 5.844746817000043],
            [121.15913615300008, 5.844865138000046],
            [121.15908645400009, 5.844557831000031],
            [121.15924268600008, 5.844497788000069],
        ],
        [
            [121.15881835800008, 5.845057636000035],
            [121.15827155500006, 5.844905729000061],
            [121.15831950600011, 5.844435942000075],
            [121.15893554400009, 5.844688519000044],
            [121.15881835800008, 5.845057636000035],
        ],
        [
            [121.15539574800005, 5.84514110300006],
            [121.154880896, 5.845137550000061],
            [121.1547708380001, 5.844791386000054],
            [121.15539931800004, 5.844685444000049],
            [121.15539574800005, 5.84514110300006],
        ],
        [
            [121.27973681000003, 5.85567605600005],
            [121.27445522800008, 5.853975705000039],
            [121.27242455100009, 5.85400450000003],
            [121.2714273150001, 5.854324187000032],
            [121.27119209400007, 5.854590358000053],
            [121.27973681000003, 5.85567605600005],
        ],
        [
            [121.08999997700005, 5.85915667300003],
            [121.09520677100011, 5.85027956700003],
            [121.08246922, 5.840283103000047],
            [121.07905070200002, 5.851170926000066],
            [121.08999997700005, 5.85915667300003],
        ],
        [
            [121.21748693400002, 5.859419372000048],
            [121.23869287500008, 5.844910864000042],
            [121.23726657300006, 5.839002855000047],
            [121.2241607840001, 5.841798251000057],
            [121.21748693400002, 5.859419372000048],
        ],
        [
            [121.23365360800005, 5.847991408000041],
            [121.23327544800009, 5.847803533000047],
            [121.23418993300004, 5.847595868000042],
            [121.23400107500004, 5.84794196200005],
            [121.23365360800005, 5.847991408000041],
        ],
        [
            [121.29264466300003, 5.860978145000047],
            [121.29296572300007, 5.86091183800005],
            [121.29302000700011, 5.860804140000027],
            [121.29256881300012, 5.860790593000047],
            [121.29264466300003, 5.860978145000047],
        ],
        [
            [121.28832134400011, 5.86147079400007],
            [121.28821348800011, 5.861743548000049],
            [121.28842508200012, 5.861935194000068],
            [121.28853471700006, 5.86180418500004],
            [121.28832134400011, 5.86147079400007],
        ],
        [
            [121.28806168100004, 5.861600829000054],
            [121.28800584600003, 5.861980890000041],
            [121.28826579500003, 5.862026908000075],
            [121.28827650000005, 5.861883747000036],
            [121.28806168100004, 5.861600829000054],
        ],
        [
            [119.97108890000004, 5.863576671000033],
            [119.97078140500003, 5.862835893000067],
            [119.97031631100003, 5.862803009000061],
            [119.970268, 5.863387024000076],
            [119.97108890000004, 5.863576671000033],
        ],
        [
            [121.29379768400008, 5.874276806000069],
            [121.29344921000006, 5.874032009000075],
            [121.29328036200002, 5.874094547000027],
            [121.29385875600008, 5.874460850000048],
            [121.29379768400008, 5.874276806000069],
        ],
        [
            [121.30032292100009, 5.874701317000074],
            [121.30023122000011, 5.87448558400007],
            [121.30008372000009, 5.87457514700003],
            [121.30026390000012, 5.874758190000023],
            [121.30032292100009, 5.874701317000074],
        ],
        [
            [121.297100053, 5.874727079000024],
            [121.29730241300001, 5.874456538000061],
            [121.29654790000006, 5.874389324000049],
            [121.2967072670001, 5.874739661000035],
            [121.297100053, 5.874727079000024],
        ],
        [
            [121.29936735400008, 5.875323896000054],
            [121.30030536800007, 5.874913493000065],
            [121.29912086900003, 5.873899252000058],
            [121.29846863900002, 5.874314368000057],
            [121.29936735400008, 5.875323896000054],
        ],
        [
            [119.97994547300004, 5.875239312000076],
            [119.97981663500002, 5.873311783000077],
            [119.98092352100002, 5.872450140000069],
            [119.97954472200001, 5.873308859000076],
            [119.97994547300004, 5.875239312000076],
        ],
        [
            [119.97604438600001, 5.875589781000031],
            [119.97873964200005, 5.870755295000038],
            [119.97744710000006, 5.872231328000055],
            [119.97545495500003, 5.872087694000072],
            [119.97604438600001, 5.875589781000031],
        ],
        [
            [121.30101700300008, 5.875981744000057],
            [121.30088401400008, 5.875319227000034],
            [121.30009286800009, 5.875501970000073],
            [121.30005855900004, 5.875718987000027],
            [121.30101700300008, 5.875981744000057],
        ],
        [
            [119.97559377800007, 5.87658860800002],
            [119.97488849800004, 5.875584702000026],
            [119.97385871600011, 5.875670611000032],
            [119.97540052500005, 5.876732760000039],
            [119.97559377800007, 5.87658860800002],
        ],
        [
            [121.21301920500002, 5.876213023000048],
            [121.21513008500006, 5.874730198000066],
            [121.21233706600003, 5.869948238000063],
            [121.20859350300009, 5.873583237000048],
            [121.21301920500002, 5.876213023000048],
        ],
        [
            [121.30459414100005, 5.877261247000035],
            [121.30509125800006, 5.876816657000063],
            [121.30576395900005, 5.876801056000033],
            [121.30517763300008, 5.87622073600005],
            [121.30459414100005, 5.877261247000035],
        ],
        [
            [119.97948052000004, 5.877387628000065],
            [119.97972777000007, 5.876520141000071],
            [119.98037844200007, 5.876187134000077],
            [119.97887307400003, 5.876731285000062],
            [119.97948052000004, 5.877387628000065],
        ],
        [
            [119.97856255200008, 5.878201528000034],
            [119.97902920500007, 5.878385775000027],
            [119.97963545700009, 5.878290031000063],
            [119.97849968900005, 5.87787731100002],
            [119.9779700570001, 5.878889203000028],
            [119.97856255200008, 5.878201528000034],
        ],
        [
            [121.25621916600005, 5.879351455000062],
            [121.2558855320001, 5.879882417000033],
            [121.25666951300002, 5.880114755000022],
            [121.2566945430001, 5.879890752000051],
            [121.25621916600005, 5.879351455000062],
        ],
        [
            [121.257578566, 5.881035697000073],
            [121.25787054000011, 5.879500863000032],
            [121.2575619590001, 5.879276845000049],
            [121.25681954900006, 5.882280122000054],
            [121.257578566, 5.881035697000073],
        ],
        [
            [121.25614153700008, 5.882001646000049],
            [121.2553339970001, 5.882531032000031],
            [121.25533395900004, 5.883425575000047],
            [121.25625160600009, 5.883157862000076],
            [121.25614153700008, 5.882001646000049],
        ],
        [
            [119.93958933300007, 5.884971500000063],
            [119.95616439000003, 5.877562013000045],
            [119.96190433100003, 5.862464293000073],
            [119.91996939800003, 5.872188747000052],
            [119.93958933300007, 5.884971500000063],
        ],
        [
            [121.25496120300011, 5.885013002000051],
            [121.25587813400011, 5.884609623000074],
            [121.25552550200007, 5.884000093000054],
            [121.25456449, 5.884236836000071],
            [121.25496120300011, 5.885013002000051],
        ],
        [
            [119.975036982, 5.885241257000075],
            [119.97467184600009, 5.883710262000022],
            [119.97343650500011, 5.884144324000033],
            [119.97439956500011, 5.886146478000057],
            [119.975036982, 5.885241257000075],
        ],
        [
            [120.01776435700003, 5.88046345500004],
            [120.01477327400005, 5.878722192000055],
            [120.0174700230001, 5.880593910000073],
            [120.02038542800005, 5.886323793000031],
            [120.01776435700003, 5.88046345500004],
        ],
        [
            [119.97724057900007, 5.887797705000025],
            [119.9783303160001, 5.886958191000076],
            [119.97807040900011, 5.885474749000025],
            [119.97643367100011, 5.885922108000045],
            [119.97724057900007, 5.887797705000025],
        ],
        [
            [120.00999934700008, 5.888587193000035],
            [120.01528458100006, 5.88776462800007],
            [120.01862241600008, 5.884077221000041],
            [120.01177257800009, 5.885089017000041],
            [120.00921699700007, 5.86891182200003],
            [119.97107573200003, 5.86204486500003],
            [120.00999934700008, 5.888587193000035],
        ],
        [
            [119.97625256100002, 5.889271784000073],
            [119.97707535000006, 5.888801897000064],
            [119.97700623700007, 5.888478654000039],
            [119.9760267690001, 5.888542765000068],
            [119.97625256100002, 5.889271784000073],
        ],
        [
            [121.3096374590001, 5.880024072000026],
            [121.31036246500003, 5.88330183100004],
            [121.32015047800007, 5.890014317000066],
            [121.32032647200003, 5.887629490000052],
            [121.3096374590001, 5.880024072000026],
        ],
        [
            [120.01154919100009, 5.890425054000048],
            [120.01329773100008, 5.889919275000068],
            [120.01384638600007, 5.888918745000069],
            [120.01056266100011, 5.88887128500005],
            [120.01154919100009, 5.890425054000048],
        ],
        [
            [120.00930165800003, 5.891747683000062],
            [120.01089275800007, 5.891458306000061],
            [120.0110025670001, 5.891214208000065],
            [120.00948934500002, 5.890123119000066],
            [120.00930165800003, 5.891747683000062],
        ],
        [
            [119.97193920200004, 5.893329273000063],
            [119.97389571600002, 5.886227330000054],
            [119.97072037600003, 5.888862464000056],
            [119.96794322000005, 5.888001089000056],
            [119.96970486100008, 5.866354831000024],
            [119.96462956300002, 5.881246170000054],
            [119.96586235000007, 5.887187280000035],
            [119.97193920200004, 5.893329273000063],
        ],
        [
            [120.07327194900006, 5.893912439000076],
            [120.07582239400006, 5.89082974400003],
            [120.07863850000001, 5.871150359000069],
            [120.06646995300002, 5.887444307000067],
            [120.07327194900006, 5.893912439000076],
        ],
        [
            [121.0463246170001, 5.894227710000052],
            [121.04601161700009, 5.893988709000041],
            [121.0463246170001, 5.894895709000025],
            [121.04652261600006, 5.894510709000031],
            [121.0463246170001, 5.894227710000052],
        ],
        [
            [121.32457547900003, 5.891557194000029],
            [121.32392747900008, 5.891750180000031],
            [121.32865748800009, 5.895826872000043],
            [121.32688748200007, 5.892963085000076],
            [121.32457547900003, 5.891557194000029],
        ],
        [
            [121.0453096220001, 5.896152563000044],
            [121.04420362200005, 5.897154563000072],
            [121.04403562100003, 5.898874563000049],
            [121.04501162100007, 5.898443563000058],
            [121.0453096220001, 5.896152563000044],
        ],
        [
            [121.3327774920001, 5.89846466900002],
            [121.33222849200001, 5.898384677000024],
            [121.33146549300011, 5.898505669000031],
            [121.33352549300002, 5.89884863900005],
            [121.3327774920001, 5.89846466900002],
        ],
        [
            [120.00963196400005, 5.900825456000064],
            [120.01142278500004, 5.896317579000026],
            [120.00923521300001, 5.895064443000024],
            [120.01324231800004, 5.896281926000029],
            [120.01489065400006, 5.893507524000029],
            [120.01464700100007, 5.892674099000033],
            [120.00574686800007, 5.894936187000042],
            [120.00963196400005, 5.900825456000064],
        ],
        [
            [120.01015114400002, 5.902509503000033],
            [120.00832257500008, 5.900173951000056],
            [120.00666553500002, 5.901437703000056],
            [120.00742073000004, 5.90191644500004],
            [120.00829311500001, 5.901795961000062],
            [120.01015114400002, 5.902509503000033],
        ],
        [
            [120.00933446200008, 5.903582605000054],
            [120.00845196900002, 5.90201683500004],
            [120.00691879200008, 5.902017522000051],
            [120.0084155720001, 5.903775865000057],
            [120.00933446200008, 5.903582605000054],
        ],
        [
            [121.37703415800001, 5.904008361000024],
            [121.3760898480001, 5.903713425000035],
            [121.3756450840001, 5.904016425000066],
            [121.37688767600002, 5.904338894000034],
            [121.37703415800001, 5.904008361000024],
        ],
        [
            [121.39140169000007, 5.905235004000076],
            [121.38977594000005, 5.904374130000065],
            [121.38705586200001, 5.904033666000032],
            [121.38999000500007, 5.905313483000043],
            [121.39140169000007, 5.905235004000076],
        ],
        [
            [119.98645304100012, 5.90808802500004],
            [119.985922404, 5.904694212000038],
            [119.98345560400003, 5.905886843000076],
            [119.98349151100001, 5.906852911000044],
            [119.98645304100012, 5.90808802500004],
        ],
        [
            [121.03841264900007, 5.908916860000033],
            [121.03986964900002, 5.908478861000049],
            [121.04001464900011, 5.905859860000021],
            [121.03764964900006, 5.907650860000047],
            [121.03841264900007, 5.908916860000033],
        ],
        [
            [121.0416706530001, 5.907037702000025],
            [121.040624653, 5.907764703000055],
            [121.04088465200005, 5.90908470200003],
            [121.04244865300006, 5.907935702000032],
            [121.0416706530001, 5.907037702000025],
        ],
        [
            [119.98443224400012, 5.910855668000067],
            [119.98578704800002, 5.909781274000068],
            [119.9813197520001, 5.91052185500007],
            [119.98393398000007, 5.910524871000064],
            [119.98443224400012, 5.910855668000067],
        ],
        [
            [119.98564418700005, 5.914309420000052],
            [119.98749868300001, 5.912916863000021],
            [119.98803638800007, 5.910577218000071],
            [119.9835462100001, 5.912962286000038],
            [119.98564418700005, 5.914309420000052],
        ],
        [
            [121.3882545570001, 5.914500095000051],
            [121.38847726800009, 5.913146722000022],
            [121.38630871900011, 5.913072133000071],
            [121.38730105500008, 5.914355037000064],
            [121.3882545570001, 5.914500095000051],
        ],
        [
            [119.99470207200011, 5.915909861000046],
            [119.99544788300011, 5.914504289000035],
            [119.9940079810001, 5.914049196000065],
            [119.99400499400008, 5.915755237000042],
            [119.99470207200011, 5.915909861000046],
        ],
        [
            [119.99023438800009, 5.917913613000053],
            [119.9910069340001, 5.917410450000034],
            [119.99118420200011, 5.916453539000031],
            [119.99002613100004, 5.913686957000039],
            [119.99023438800009, 5.917913613000053],
        ],
        [
            [119.99418157900004, 5.920420061000073],
            [119.99657731600007, 5.917372151000052],
            [119.99547816200004, 5.916434137000067],
            [119.99430014100005, 5.916635995000036],
            [119.99418157900004, 5.920420061000073],
        ],
        [
            [120.00352518500006, 5.921047972000054],
            [120.00832324900011, 5.918840678000038],
            [120.00293284400004, 5.913357650000023],
            [120.0069934070001, 5.912101869000026],
            [120.00816772200005, 5.903762693000033],
            [120.00629673700007, 5.90277308900005],
            [119.9998708930001, 5.915921655000034],
            [120.00352518500006, 5.921047972000054],
        ],
        [
            [120.00345177300005, 5.92436222300006],
            [120.00540985200007, 5.922048442000062],
            [120.00154351300012, 5.923442517000069],
            [120.00162463000004, 5.921080202000041],
            [119.99931007100008, 5.918192097000031],
            [119.99735433600006, 5.917429865000031],
            [120.001247153, 5.922621260000028],
            [119.99906891300009, 5.923655362000034],
            [120.00345177300005, 5.92436222300006],
        ],
        [
            [121.38415825700008, 5.934203943000057],
            [121.38370531200007, 5.93380477200003],
            [121.38349234200007, 5.933944020000069],
            [121.38365783800009, 5.934317276000058],
            [121.38415825700008, 5.934203943000057],
        ],
        [
            [119.99176649300011, 5.940498944000069],
            [119.9993818690001, 5.921727610000062],
            [119.98003938500005, 5.91704868000005],
            [119.97767230500006, 5.930960810000045],
            [119.99176649300011, 5.940498944000069],
        ],
        [
            [120.12054496700011, 5.968905714000073],
            [120.12297470800002, 5.951542793000044],
            [120.11073410100005, 5.955835578000062],
            [120.12141377000012, 5.950039933000028],
            [120.11931844600008, 5.936820065000063],
            [120.11514447900004, 5.939743892000024],
            [120.1095522060001, 5.958820662000051],
            [120.11444380700004, 5.959304139000039],
            [120.11183515800008, 5.960961157000042],
            [120.11586762600007, 5.960681750000049],
            [120.11973213500005, 5.964969833000055],
            [120.12054496700011, 5.968905714000073],
        ],
        [
            [120.1036051320001, 5.969366655000044],
            [120.1092773800001, 5.967070388000025],
            [120.11030557000004, 5.961509125000021],
            [120.10600950500009, 5.961630867000054],
            [120.1036051320001, 5.969366655000044],
        ],
        [
            [121.57860546400002, 5.979331108000054],
            [121.5974645660001, 5.955010753000067],
            [121.57073097500006, 5.93231565800005],
            [121.55810717400004, 5.955182121000064],
            [121.57860546400002, 5.979331108000054],
        ],
        [
            [120.10283101100003, 5.989327029000037],
            [120.10996495400002, 5.988566706000029],
            [120.12094338300005, 5.970633132000046],
            [120.11401986400006, 5.963975144000074],
            [120.10624272900009, 5.98614750400003],
            [120.09589251300008, 5.984029359000033],
            [120.119907011, 5.917116428000043],
            [120.08989946300005, 5.974229951000041],
            [120.09579380000002, 5.985513634000029],
            [120.10283101100003, 5.989327029000037],
        ],
        [
            [121.65266628400002, 6.002701879000028],
            [121.65315695800007, 6.002791978000062],
            [121.65327388300011, 6.002507053000045],
            [121.65228927400005, 6.001896180000074],
            [121.65266628400002, 6.002701879000028],
        ],
        [
            [121.65838429400003, 6.005876211000043],
            [121.65854776900005, 6.005722205000041],
            [121.65846645400006, 6.005579942000054],
            [121.65832831000012, 6.005756698000027],
            [121.65838429400003, 6.005876211000043],
        ],
        [
            [121.65895680900007, 6.006010161000063],
            [121.65879088600002, 6.005918836000035],
            [121.65864017000001, 6.005525345000024],
            [121.6585299940001, 6.005851473000064],
            [121.65895680900007, 6.006010161000063],
        ],
        [
            [121.65801083600002, 6.009935191000068],
            [121.65796249200002, 6.009877492000044],
            [121.65787546600006, 6.009933582000031],
            [121.65801566400012, 6.010097064000036],
            [121.65801083600002, 6.009935191000068],
        ],
        [
            [121.67015063000008, 6.010599047000028],
            [121.66996800800007, 6.010632478000048],
            [121.6699204360001, 6.010708040000054],
            [121.67011398600005, 6.010778121000044],
            [121.67015063000008, 6.010599047000028],
        ],
        [
            [121.36765412800003, 6.016152632000058],
            [121.37420183600011, 6.011491945000046],
            [121.36863468100012, 6.006942012000025],
            [121.3623267270001, 6.012363536000066],
            [121.36765412800003, 6.016152632000058],
        ],
        [
            [120.88153076200001, 6.014892579000048],
            [120.88049316400009, 6.015686035000044],
            [120.882324218, 6.017272949000073],
            [120.882324218, 6.015686035000044],
            [120.88153076200001, 6.014892579000048],
        ],
        [
            [121.86965972000007, 6.021563883000056],
            [121.8698384160001, 6.021094679000043],
            [121.86941929500006, 6.020787833000043],
            [121.86937016800005, 6.021479882000051],
            [121.86965972000007, 6.021563883000056],
        ],
        [
            [121.86146194900005, 6.022991342000068],
            [121.861308258, 6.021983976000058],
            [121.85949050200009, 6.022933590000036],
            [121.86107692900009, 6.022385184000029],
            [121.86146194900005, 6.022991342000068],
        ],
        [
            [121.66617543200005, 6.027979215000073],
            [121.66742769300004, 6.021868683000037],
            [121.65576530100009, 6.008523112000034],
            [121.66004629800011, 6.022025036000059],
            [121.66617543200005, 6.027979215000073],
        ],
        [
            [121.32738190000009, 6.034086424000066],
            [121.32692564700005, 6.023242245000063],
            [121.31567599400012, 6.017981992000045],
            [121.31701568500011, 6.030732889000035],
            [121.32738190000009, 6.034086424000066],
        ],
        [
            [121.71658791200002, 6.037041915000032],
            [121.71705669000005, 6.036677245000021],
            [121.71684762200005, 6.036401934000025],
            [121.71624258100007, 6.036758489000022],
            [121.71658791200002, 6.037041915000032],
        ],
        [
            [121.79691728500006, 6.039947687000051],
            [121.7975809940001, 6.03991028400003],
            [121.79789294300008, 6.039436198000033],
            [121.79640073700011, 6.039965395000024],
            [121.79691728500006, 6.039947687000051],
        ],
        [
            [121.66346457200007, 6.041080603000069],
            [121.66553687100009, 6.038057672000036],
            [121.66453890100001, 6.036970265000036],
            [121.66259419100004, 6.039415502000054],
            [121.66346457200007, 6.041080603000069],
        ],
        [
            [121.66604562400005, 6.040310522000027],
            [121.66539638800009, 6.03997700900004],
            [121.66588309200006, 6.041677769000046],
            [121.66637960000003, 6.040968791000068],
            [121.66604562400005, 6.040310522000027],
        ],
        [
            [121.5511122470001, 6.042056303000038],
            [121.55624840100006, 6.01597663900003],
            [121.52562703300009, 5.992710975000023],
            [121.53420263100008, 6.025875255000074],
            [121.5511122470001, 6.042056303000038],
        ],
        [
            [121.79300335500011, 6.043273068000076],
            [121.7951823620001, 6.041333731000066],
            [121.79541341200002, 6.04069252000005],
            [121.79289191700002, 6.043129930000021],
            [121.79279343500002, 6.043678347000025],
            [121.79300335500011, 6.043273068000076],
        ],
        [
            [121.51791005100006, 6.050046366000061],
            [121.52339131300005, 6.044237851000048],
            [121.51405457600004, 6.042278190000047],
            [121.51447101800011, 6.049969636000071],
            [121.51791005100006, 6.050046366000061],
        ],
        [
            [121.78061611200008, 6.052070951000076],
            [121.792097968, 6.044743771000071],
            [121.79345306200003, 6.044730407000031],
            [121.79136822400005, 6.044558359000064],
            [121.78231069500009, 6.049525294000034],
            [121.78061611200008, 6.052070951000076],
        ],
        [
            [121.40752729000008, 6.057120550000036],
            [121.43318525900008, 6.037635285000022],
            [121.42390605800006, 6.013719768000044],
            [121.38143342400008, 6.026055545000077],
            [121.40752729000008, 6.057120550000036],
        ],
        [
            [121.67759060600008, 6.057386554000061],
            [121.68838061100007, 6.036318658000027],
            [121.72793096400005, 6.031149767000045],
            [121.66742298800011, 5.988113835000036],
            [121.67759060600008, 6.057386554000061],
        ],
        [
            [121.67435733600007, 6.014836980000041],
            [121.67441344200006, 6.014918819000059],
            [121.6742767180001, 6.014998897000055],
            [121.6742595290001, 6.014829785000074],
            [121.67435733600007, 6.014836980000041],
        ],
        [
            [121.67460448000008, 6.015305573000035],
            [121.67437948000008, 6.015218179000044],
            [121.67452061000006, 6.014957365000043],
            [121.67468204600004, 6.015163256000051],
            [121.67460448000008, 6.015305573000035],
        ],
        [
            [121.67394508400002, 6.015144147000058],
            [121.6724516490001, 6.014289278000035],
            [121.67438201000004, 6.012991804000023],
            [121.67506214900004, 6.013757615000031],
            [121.67394508400002, 6.015144147000058],
        ],
        [
            [121.67434201000003, 6.015660560000072],
            [121.674115991, 6.015753141000062],
            [121.67400616000009, 6.015546175000054],
            [121.67420790400001, 6.015395277000039],
            [121.67434201000003, 6.015660560000072],
        ],
        [
            [121.67629615500005, 6.016901949000044],
            [121.6763913320001, 6.016968974000065],
            [121.67633889700005, 6.017139500000042],
            [121.6761615580001, 6.017060449000041],
            [121.67629615500005, 6.016901949000044],
        ],
        [
            [121.67705300000011, 6.017267065000055],
            [121.67701249100003, 6.017350959000055],
            [121.67686504500011, 6.017349746000036],
            [121.6769052200001, 6.017256008000061],
            [121.67705300000011, 6.017267065000055],
        ],
        [
            [121.67752549400007, 6.017207174000021],
            [121.6775047540001, 6.017326130000072],
            [121.67745276100004, 6.017363599000021],
            [121.67740479600002, 6.017264194000063],
            [121.67752549400007, 6.017207174000021],
        ],
        [
            [121.678204058, 6.018185927000047],
            [121.67826559200012, 6.018283644000064],
            [121.67814197300004, 6.018364170000041],
            [121.67804724200005, 6.018273724000039],
            [121.678204058, 6.018185927000047],
        ],
        [
            [121.68018519300006, 6.019185181000068],
            [121.67996646600011, 6.019155148000038],
            [121.67999298500001, 6.019009260000075],
            [121.68028887600008, 6.019002628000067],
            [121.68018519300006, 6.019185181000068],
        ],
        [
            [121.680194776, 6.019240518000061],
            [121.68017122700007, 6.019525710000039],
            [121.68007856400004, 6.019568315000072],
            [121.6800683250001, 6.019385771000032],
            [121.680194776, 6.019240518000061],
        ],
        [
            [121.68319621700005, 6.022862154000052],
            [121.68314799100006, 6.022770605000062],
            [121.68321185400009, 6.022716285000058],
            [121.68328935600005, 6.022775195000065],
            [121.68319621700005, 6.022862154000052],
        ],
        [
            [121.68347052100012, 6.02416521400005],
            [121.68348861400011, 6.024263313000063],
            [121.68339583200009, 6.024282826000046],
            [121.68337913300002, 6.024181256000077],
            [121.68347052100012, 6.02416521400005],
        ],
        [
            [121.68194117200005, 6.024573076000024],
            [121.68181209800002, 6.024275654000064],
            [121.68214601500006, 6.024100771000064],
            [121.6822723780001, 6.024485625000068],
            [121.68194117200005, 6.024573076000024],
        ],
        [
            [121.68345671000009, 6.024627216000056],
            [121.68330781500003, 6.024629293000032],
            [121.6833825870001, 6.024448954000036],
            [121.68353969200007, 6.024571630000025],
            [121.68345671000009, 6.024627216000056],
        ],
        [
            [121.68305219600006, 6.024665468000023],
            [121.6830931510001, 6.024738844000069],
            [121.68300136800008, 6.024782087000062],
            [121.68298468800003, 6.024700639000059],
            [121.68305219600006, 6.024665468000023],
        ],
        [
            [121.68616658500002, 6.027798702000041],
            [121.68594345600002, 6.027808342000071],
            [121.68589746200007, 6.027719289000061],
            [121.68612459500002, 6.027661350000074],
            [121.68616658500002, 6.027798702000041],
        ],
        [
            [121.68195724300006, 6.033356752000032],
            [121.68140601000005, 6.032827661000056],
            [121.68227548300001, 6.032054229000039],
            [121.68256435900003, 6.032816345000072],
            [121.68195724300006, 6.033356752000032],
        ],
        [
            [121.68147158400006, 6.037080292000041],
            [121.68159127500007, 6.037431190000063],
            [121.68127728000002, 6.037520846000064],
            [121.68113582600006, 6.03728124600002],
            [121.68147158400006, 6.037080292000041],
        ],
        [
            [120.48332373500011, 6.060443617000033],
            [120.48747940500004, 6.057373068000061],
            [120.48893987600002, 6.048286611000037],
            [120.47977250600002, 6.053258301000028],
            [120.48332373500011, 6.060443617000033],
        ],
        [
            [121.70875194300004, 6.064352279000047],
            [121.70869668000012, 6.064334011000028],
            [121.70864975300003, 6.064387950000025],
            [121.70871380500012, 6.064430782000045],
            [121.70875194300004, 6.064352279000047],
        ],
        [
            [121.76873291200002, 6.064790703000028],
            [121.76873343500006, 6.064648742000031],
            [121.76857790500003, 6.064816360000066],
            [121.76862947100005, 6.064845505000051],
            [121.76873291200002, 6.064790703000028],
        ],
        [
            [121.76852070100006, 6.064940605000061],
            [121.76847096600011, 6.064975994000065],
            [121.76850895300004, 6.065126574000033],
            [121.7685868860001, 6.065005712000072],
            [121.76852070100006, 6.064940605000061],
        ],
        [
            [121.70796263000011, 6.065131128000075],
            [121.70805747300005, 6.065077635000023],
            [121.70796906700002, 6.064987110000061],
            [121.70793097300009, 6.065040947000057],
            [121.70796263000011, 6.065131128000075],
        ],
        [
            [121.76829672300005, 6.065136910000035],
            [121.76822418000006, 6.065194856000062],
            [121.768239031, 6.065341515000057],
            [121.76833678700007, 6.065261552000038],
            [121.76829672300005, 6.065136910000035],
        ],
        [
            [121.19404576800002, 6.07024100700005],
            [121.19386898500011, 6.07022200800003],
            [121.19377218700004, 6.070466613000065],
            [121.19401233000008, 6.070554583000046],
            [121.19404576800002, 6.07024100700005],
        ],
        [
            [121.192871093, 6.071289062000062],
            [121.1917114260001, 6.070312500000057],
            [121.19207763700001, 6.072692871000072],
            [121.1926879880001, 6.072082520000038],
            [121.192871093, 6.071289062000062],
        ],
        [
            [121.4530357750001, 6.076421529000072],
            [121.46139881800002, 6.064226444000042],
            [121.44569767300004, 6.050375833000032],
            [121.44171474300003, 6.071118470000044],
            [121.4530357750001, 6.076421529000072],
        ],
        [
            [121.7042341230001, 6.076702089000037],
            [121.71544480300008, 6.071105699000043],
            [121.72102151400009, 6.060115721000045],
            [121.70716333100006, 6.06544032100004],
            [121.70124805800003, 6.073506322000071],
            [121.7042341230001, 6.076702089000037],
        ],
        [
            [121.70699375000004, 6.066174194000041],
            [121.70695549600009, 6.066264996000029],
            [121.70690120200004, 6.066257633000021],
            [121.70695549600009, 6.06615946900007],
            [121.70699375000004, 6.066174194000041],
        ],
        [
            [121.70710850800003, 6.06621468700007],
            [121.70708259500009, 6.066274813000064],
            [121.70699745200011, 6.066226958000072],
            [121.70709740300003, 6.066159470000059],
            [121.70710850800003, 6.06621468700007],
        ],
        [
            [121.70685924600002, 6.066369295000072],
            [121.70678027300005, 6.066321439000035],
            [121.7068641830001, 6.066260087000046],
            [121.7069036690001, 6.06629076400003],
            [121.70685924600002, 6.066369295000072],
        ],
        [
            [121.7069629, 6.06640856100006],
            [121.7069382200001, 6.066334937000022],
            [121.7070714890001, 6.066359479000027],
            [121.70703940600004, 6.066397518000031],
            [121.7069629, 6.06640856100006],
        ],
        [
            [121.70702706500003, 6.066607343000044],
            [121.70691354000007, 6.066607343000044],
            [121.70679014400002, 6.066457642000046],
            [121.70703940500005, 6.066545990000066],
            [121.70702706500003, 6.066607343000044],
        ],
        [
            [121.16545906700003, 6.078401675000066],
            [121.17370270100002, 6.077936659000045],
            [121.17747297400001, 6.076209050000045],
            [121.16723304100003, 6.070988767000074],
            [121.16545906700003, 6.078401675000066],
        ],
        [
            [121.65699649800001, 6.086101165000059],
            [121.65695604600012, 6.085908412000038],
            [121.65679085500005, 6.086079373000075],
            [121.6569442440001, 6.086134687000026],
            [121.65699649800001, 6.086101165000059],
        ],
        [
            [121.65683910900009, 6.086388957000054],
            [121.6568509110001, 6.086216318000027],
            [121.65678011400007, 6.086192852000067],
            [121.65668740500007, 6.086323588000027],
            [121.65683910900009, 6.086388957000054],
        ],
        [
            [118.31771998300007, 6.086710464000021],
            [118.31802838200008, 6.073478925000074],
            [118.30968561700001, 6.070947512000032],
            [118.30879948200004, 6.076628453000069],
            [118.31771998300007, 6.086710464000021],
        ],
        [
            [121.65714987900003, 6.086875529000054],
            [121.65732518300001, 6.086825248000025],
            [121.65717516600012, 6.08663081800006],
            [121.65701840000008, 6.086865471000067],
            [121.65714987900003, 6.086875529000054],
        ],
        [
            [121.27229778300011, 6.09082810600006],
            [121.27816126700009, 6.076027894000049],
            [121.26554720500008, 6.074967684000057],
            [121.2646614460001, 6.077395395000053],
            [121.27229778300011, 6.09082810600006],
        ],
        [
            [121.05967660600004, 6.091090096000073],
            [121.153964, 6.077749414000039],
            [121.20607966200009, 5.996285843000067],
            [121.27959852800007, 6.018948006000073],
            [121.36340318700002, 5.988912893000077],
            [121.39397047600005, 6.010562918000062],
            [121.42545115700011, 5.959418321000044],
            [121.38327422400005, 5.937028536000071],
            [121.38482829500003, 5.903989113000023],
            [121.35355282100011, 5.918755224000051],
            [121.29091517100005, 5.874290157000075],
            [121.29748329800009, 5.872781819000068],
            [121.29674364200002, 5.865050327000063],
            [121.2986613170001, 5.869050537000021],
            [121.300499392, 5.868230474000029],
            [121.29504454900007, 5.86020411800007],
            [121.28637096600005, 5.863804715000072],
            [121.28852985600008, 5.856992458000036],
            [121.28412349700011, 5.855934571000034],
            [121.19592377100003, 5.954869698000039],
            [121.06905813700007, 5.897940474000052],
            [121.07575754700008, 5.877682278000066],
            [121.02444244600008, 5.928018267000027],
            [120.94031669300011, 5.889324385000066],
            [120.88004436200004, 5.920293024000046],
            [120.91799255900003, 6.024920592000058],
            [121.05967660600004, 6.091090096000073],
        ],
        [
            [121.28389086900006, 5.861463654000033],
            [121.28373663900004, 5.86162392600005],
            [121.28344746100004, 5.861302008000052],
            [121.28378621600007, 5.861178725000059],
            [121.28389086900006, 5.861463654000033],
        ],
        [
            [121.29359009000007, 5.861970493000058],
            [121.29355646700003, 5.862201858000049],
            [121.29335460300001, 5.861560249000036],
            [121.293474478, 5.861613388000023],
            [121.29359009000007, 5.861970493000058],
        ],
        [
            [121.29101703700007, 5.862273],
            [121.290731531, 5.862278034000042],
            [121.29070937000006, 5.86215334700006],
            [121.29101868100008, 5.862017665000053],
            [121.29101703700007, 5.862273],
        ],
        [
            [121.2821602570001, 5.863202629000057],
            [121.28125230700005, 5.863272298000027],
            [121.28117471200005, 5.861295771000073],
            [121.28206977800005, 5.861788736000051],
            [121.2821602570001, 5.863202629000057],
        ],
        [
            [121.28182425300008, 5.863939680000044],
            [121.28145589100006, 5.863741696000034],
            [121.28156587900003, 5.863538508000033],
            [121.28219436400002, 5.86367223700006],
            [121.28182425300008, 5.863939680000044],
        ],
        [
            [121.2892361050001, 5.863871857000049],
            [121.28940046700006, 5.864060761000076],
            [121.28915731300003, 5.864206632000048],
            [121.2890912800001, 5.863997487000063],
            [121.2892361050001, 5.863871857000049],
        ],
        [
            [121.29199761500001, 5.873549326000045],
            [121.29125292200001, 5.873390974000074],
            [121.29099560600002, 5.873173768000072],
            [121.29186613200011, 5.872950095000022],
            [121.29199761500001, 5.873549326000045],
        ],
        [
            [121.285169601, 5.87398657500006],
            [121.28491785800009, 5.874232936000055],
            [121.2847500580001, 5.873425715000053],
            [121.28596178300006, 5.874029174000043],
            [121.28503936200002, 5.873834463000037],
            [121.285169601, 5.87398657500006],
        ],
        [
            [121.28239448000011, 5.875869093000063],
            [121.28206898500002, 5.875588419000053],
            [121.28291679900008, 5.874987164000061],
            [121.28292723200002, 5.875397720000024],
            [121.28239448000011, 5.875869093000063],
        ],
        [
            [121.37297934800006, 5.912256242000069],
            [121.37246002400002, 5.912402283000063],
            [121.37112684200008, 5.911650010000074],
            [121.37234956800012, 5.911342698000055],
            [121.37297934800006, 5.912256242000069],
        ],
        [
            [121.3655700590001, 5.914441900000043],
            [121.36548986800005, 5.915146141000037],
            [121.36486400400008, 5.914972998000053],
            [121.36484640100002, 5.914360190000025],
            [121.3655700590001, 5.914441900000043],
        ],
        [
            [121.66289626200012, 6.091519443000038],
            [121.66826671900003, 6.082625661000066],
            [121.65639935800004, 6.077379886000074],
            [121.65662128100007, 6.085599257000069],
            [121.65687243700006, 6.085622726000054],
            [121.65914608900005, 6.089751694000029],
            [121.66289626200012, 6.091519443000038],
        ],
        [
            [121.65764925200006, 6.078091417000053],
            [121.65758049700003, 6.078203451000036],
            [121.65725447900002, 6.077888213000051],
            [121.65745903400011, 6.077922002000037],
            [121.65764925200006, 6.078091417000053],
        ],
        [
            [121.65845542300008, 6.078361523000069],
            [121.65836416700006, 6.078581845000031],
            [121.658318903, 6.078601412000069],
            [121.65828565100003, 6.078373240000076],
            [121.65845542300008, 6.078361523000069],
        ],
        [
            [121.65807025700008, 6.078119534000052],
            [121.65816095100001, 6.078393958000049],
            [121.65804585700005, 6.078626278000058],
            [121.65799537900011, 6.078211064000072],
            [121.65807025700008, 6.078119534000052],
        ],
        [
            [121.76428985500002, 6.094636853000054],
            [121.85346408200007, 6.019332616000042],
            [121.86989528000004, 6.018787073000055],
            [121.9484758860001, 6.051934623000022],
            [121.85417697700007, 5.99869913200007],
            [121.76428985500002, 6.094636853000054],
        ],
        [
            [118.4495463180001, 6.106405389000031],
            [118.44955600700007, 6.101124422000055],
            [118.44586717700008, 6.100931825000032],
            [118.44423660300004, 6.105272599000045],
            [118.4495463180001, 6.106405389000031],
        ],
        [
            [120.9666073410001, 6.109221044000037],
            [120.9668030900001, 6.109314072000075],
            [120.96710972200003, 6.109115988000042],
            [120.96638586000006, 6.108727186000067],
            [120.9666073410001, 6.109221044000037],
        ],
        [
            [120.50472394100007, 6.112256653000031],
            [120.51298521800004, 6.106204155000057],
            [120.51357693400007, 6.098347051000076],
            [120.50432735900006, 6.10294766800007],
            [120.50472394100007, 6.112256653000031],
        ],
        [
            [120.9661957300001, 6.11432161700003],
            [120.9624958490001, 6.101269797000043],
            [120.95149336500003, 6.103201579000029],
            [120.9621176280001, 6.11375922700006],
            [120.9661957300001, 6.11432161700003],
        ],
        [
            [121.82009296400008, 6.11907627100004],
            [121.82011144800003, 6.118928115000074],
            [121.81990683400011, 6.118995239000071],
            [121.82010448300002, 6.119222948000072],
            [121.82009296400008, 6.11907627100004],
        ],
        [
            [121.82000045500001, 6.119515325000066],
            [121.8199119190001, 6.119305102000055],
            [121.81960590100005, 6.119488367000031],
            [121.81986325000003, 6.119628086000034],
            [121.82000045500001, 6.119515325000066],
        ],
        [
            [120.97929380500011, 6.121549031000029],
            [120.97985208000011, 6.12133437600005],
            [120.97756322600003, 6.12018396600007],
            [120.97349569900007, 6.120530675000055],
            [120.97289167300005, 6.120913085000041],
            [120.97929380500011, 6.121549031000029],
        ],
        [
            [120.88889649300006, 6.128677709000044],
            [120.89061126700005, 6.127713594000056],
            [120.89270291300011, 6.124372529000027],
            [120.88874016000011, 6.126343876000021],
            [120.88889649300006, 6.128677709000044],
        ],
        [
            [120.89811217400006, 6.131009420000055],
            [120.90955973300004, 6.126655859000039],
            [120.91600613800006, 6.129403548000028],
            [120.90862120600002, 6.124439533000043],
            [120.89437038800008, 6.122790239000039],
            [120.89811217400006, 6.131009420000055],
        ],
        [
            [120.98328443100002, 6.131437234000032],
            [120.98596154400002, 6.130998377000026],
            [120.98610476100009, 6.130104974000062],
            [120.98312479300012, 6.130151156000068],
            [120.98328443100002, 6.131437234000032],
        ],
        [
            [120.99217539500012, 6.131655110000054],
            [120.99651120100009, 6.130850331000033],
            [120.98623952800006, 6.122322840000038],
            [120.98275041600004, 6.121522561000063],
            [120.99217539500012, 6.131655110000054],
        ],
        [
            [120.44442286300011, 6.133741316000055],
            [120.44445712700008, 6.133656737000024],
            [120.444239734, 6.13348522900003],
            [120.44438033100005, 6.133761286000038],
            [120.44442286300011, 6.133741316000055],
        ],
        [
            [120.44486709900002, 6.133913999000072],
            [120.44466388400008, 6.133736617000068],
            [120.44457291200001, 6.133785955000064],
            [120.44460244900006, 6.13394689200004],
            [120.44486709900002, 6.133913999000072],
        ],
        [
            [120.88233433100004, 6.135251771000071],
            [120.88246788700008, 6.133393004000027],
            [120.88798731200006, 6.128897484000049],
            [120.88288835800006, 6.131756366000047],
            [120.88120762400001, 6.134785106000038],
            [120.88233433100004, 6.135251771000071],
        ],
        [
            [121.00049879300002, 6.135150520000025],
            [121.00094997800011, 6.133436224000036],
            [120.99976259200002, 6.132637991000024],
            [120.99855994100005, 6.132486444000051],
            [120.99755479500004, 6.132695832000024],
            [121.00049879300002, 6.135150520000025],
        ],
        [
            [120.99126772900001, 6.13617649300005],
            [120.99083004700003, 6.135161585000048],
            [120.98875603700003, 6.135564713000065],
            [120.9899716010001, 6.137127259000067],
            [120.99126772900001, 6.13617649300005],
        ],
        [
            [120.97802654000009, 6.137295839000046],
            [120.97991325900011, 6.133149726000056],
            [120.97544055800006, 6.130097197000055],
            [120.97220216700009, 6.133499251000046],
            [120.97802654000009, 6.137295839000046],
        ],
        [
            [120.9818349950001, 6.137978922000059],
            [120.98182232200008, 6.137185135000038],
            [120.98090323600002, 6.136958020000066],
            [120.98088706200008, 6.137756780000075],
            [120.9818349950001, 6.137978922000059],
        ],
        [
            [120.89939102900007, 6.137306832000036],
            [120.89949899300007, 6.135901545000024],
            [120.89756540000008, 6.136935994000055],
            [120.89842913500001, 6.138409608000075],
            [120.89939102900007, 6.137306832000036],
        ],
        [
            [120.98261392400002, 6.138721203000046],
            [120.98274688900005, 6.137998017000029],
            [120.98185643300008, 6.13837666400002],
            [120.98208733000001, 6.138735008000026],
            [120.98261392400002, 6.138721203000046],
        ],
        [
            [121.82694030900007, 6.14007022800007],
            [121.82660850400009, 6.13899252300007],
            [121.82543302400006, 6.13855688600006],
            [121.82568402100003, 6.139530762000049],
            [121.82694030900007, 6.14007022800007],
        ],
        [
            [120.99277700500011, 6.14042433700007],
            [120.9986482600001, 6.138783222000029],
            [121.00091938900005, 6.136159962000022],
            [120.99424949100012, 6.132148011000027],
            [120.99277700500011, 6.14042433700007],
        ],
        [
            [120.98870336200002, 6.140714401000025],
            [120.99043042700009, 6.13985795800005],
            [120.98286900900007, 6.138869232000047],
            [120.98500603200011, 6.140289288000076],
            [120.98870336200002, 6.140714401000025],
        ],
        [
            [120.4292705470001, 6.140810312000042],
            [120.4298150090001, 6.140189313000064],
            [120.42978769500007, 6.14007887300005],
            [120.42921774000001, 6.140303374000041],
            [120.4292705470001, 6.140810312000042],
        ],
        [
            [120.53500667300011, 6.145129487000077],
            [120.55645266300007, 6.127491382000073],
            [120.54696559600006, 6.113127435000024],
            [120.53189019700005, 6.121145019000039],
            [120.53500667300011, 6.145129487000077],
        ],
        [
            [121.76352205400008, 6.145567426000071],
            [121.7685381760001, 6.140061781000043],
            [121.76838378800005, 6.137556280000069],
            [121.76190792000011, 6.138723134000031],
            [121.76352205400008, 6.145567426000071],
        ],
        [
            [121.83622111500006, 6.145412534000059],
            [121.83588635500007, 6.145356169000024],
            [121.83582327700003, 6.145508488000075],
            [121.83606745300006, 6.145572366000067],
            [121.83622111500006, 6.145412534000059],
        ],
        [
            [121.83666756100001, 6.145580402000064],
            [121.83625573400002, 6.145598747000065],
            [121.83667020400003, 6.146027074000074],
            [121.83676805400012, 6.145947960000058],
            [121.83666756100001, 6.145580402000064],
        ],
        [
            [120.90771806900011, 6.147458090000043],
            [120.91505180100012, 6.145818666000025],
            [120.91343140900005, 6.142370749000065],
            [120.90621146600006, 6.145197168000038],
            [120.90771806900011, 6.147458090000043],
        ],
        [
            [121.84104161200003, 6.147588711000026],
            [121.8543873960001, 6.126317917000051],
            [121.84624408200011, 6.116665645000069],
            [121.82107243300004, 6.118377541000029],
            [121.84104161200003, 6.147588711000026],
        ],
        [
            [121.85342361800008, 6.126306215000056],
            [121.8533973110001, 6.12604334200006],
            [121.85362881000003, 6.126021109000021],
            [121.85359066600006, 6.126235591000068],
            [121.85342361800008, 6.126306215000056],
        ],
        [
            [120.93327256900011, 6.142133551000029],
            [120.93099901000005, 6.140113362000022],
            [120.93499317800001, 6.14803435500005],
            [120.93527024200012, 6.146559198000034],
            [120.93327256900011, 6.142133551000029],
        ],
        [
            [120.479770088, 6.149233145000039],
            [120.48257393400002, 6.141797031000067],
            [120.47872613200002, 6.136464763000049],
            [120.47403235600007, 6.140520596000044],
            [120.479770088, 6.149233145000039],
        ],
        [
            [120.92349315100012, 6.152459151000073],
            [120.92343523900001, 6.151684110000076],
            [120.92349310800012, 6.153695028000072],
            [120.92357213100001, 6.15324466800007],
            [120.92349315100012, 6.152459151000073],
        ],
        [
            [121.87099075800006, 6.156549195000025],
            [121.87231851600006, 6.155372471000021],
            [121.87149673700003, 6.154565630000036],
            [121.86969621300011, 6.156057599000064],
            [121.87099075800006, 6.156549195000025],
        ],
        [
            [121.86171130900004, 6.158248682000021],
            [121.86261521500012, 6.158234909000043],
            [121.86281070100006, 6.157412042000033],
            [121.8618029380001, 6.157454638000047],
            [121.86171130900004, 6.158248682000021],
        ],
        [
            [120.4643875380001, 6.158395206000023],
            [120.46459286800007, 6.15833556900003],
            [120.46459056000003, 6.157820620000052],
            [120.46400807000009, 6.158341481000036],
            [120.4643875380001, 6.158395206000023],
        ],
        [
            [120.42126582300011, 6.161365832000058],
            [120.42151032000004, 6.161106632000042],
            [120.42172645000005, 6.160507653000025],
            [120.42139955400012, 6.160840717000042],
            [120.42126582300011, 6.161365832000058],
        ],
        [
            [120.94837691600003, 6.166042676000075],
            [120.94940071500002, 6.165459842000075],
            [120.9503230580001, 6.163573191000069],
            [120.94693829300002, 6.15926858000006],
            [120.94837691600003, 6.166042676000075],
        ],
        [
            [120.94099589600012, 6.167786453000076],
            [120.94120471000008, 6.165356559000031],
            [120.93623084300009, 6.164652021000052],
            [120.93651992000002, 6.167064599000071],
            [120.94099589600012, 6.167786453000076],
        ],
        [
            [118.11031580800011, 6.164868609000052],
            [118.10869039600004, 6.166858354000055],
            [118.11023425700012, 6.167843067000035],
            [118.11159863000012, 6.166814252000052],
            [118.11031580800011, 6.164868609000052],
        ],
        [
            [120.99172174000012, 6.168939274000024],
            [120.99308348900001, 6.164490310000076],
            [121.0012799650001, 6.162116336000054],
            [120.98650654900007, 6.164303156000074],
            [120.99172174000012, 6.168939274000024],
        ],
        [
            [120.97618356800001, 6.169493557000067],
            [120.97614367100005, 6.168522985000038],
            [120.97184747200004, 6.166613719000054],
            [120.97478231100001, 6.169208950000041],
            [120.97618356800001, 6.169493557000067],
        ],
        [
            [121.00501537100001, 6.172305708000067],
            [121.00877197000011, 6.167650411000068],
            [121.00738855600002, 6.162403373000075],
            [121.0044842420001, 6.159628632000022],
            [121.0051044600001, 6.171409538000034],
            [120.99221407300001, 6.168017219000035],
            [121.00501537100001, 6.172305708000067],
        ],
        [
            [120.458291744, 6.171958564000022],
            [120.46572771600006, 6.162779152000041],
            [120.45241858400004, 6.133489531000066],
            [120.41539512500003, 6.152478941000027],
            [120.458291744, 6.171958564000022],
        ],
        [
            [121.80936511000004, 6.173000754000043],
            [121.80825251300007, 6.172464242000046],
            [121.80776192000008, 6.172438828000054],
            [121.80817153900011, 6.172848948000023],
            [121.80936511000004, 6.173000754000043],
        ],
        [
            [120.93568026900004, 6.174588093000068],
            [120.93680168000003, 6.172726318000059],
            [120.93736829600005, 6.170889227000032],
            [120.9374170210001, 6.167703129000074],
            [120.93568026900004, 6.174588093000068],
        ],
        [
            [120.95164254200006, 6.175249632000032],
            [120.95198182400009, 6.172884291000059],
            [120.95109024200008, 6.170773213000075],
            [120.94926094400012, 6.172079094000026],
            [120.95164254200006, 6.175249632000032],
        ],
        [
            [121.81758118700009, 6.176278909000075],
            [121.83263608400011, 6.147160822000046],
            [121.8054571990001, 6.129978554000047],
            [121.79654766500005, 6.155409879000047],
            [121.81758118700009, 6.176278909000075],
        ],
        [
            [121.815818938, 6.139928171000065],
            [121.81485030800002, 6.139534248000075],
            [121.81520428400006, 6.137416873000063],
            [121.81642172800002, 6.138534665000066],
            [121.815818938, 6.139928171000065],
        ],
        [
            [121.81711895300009, 6.140137849000041],
            [121.81678419800005, 6.139655315000027],
            [121.81693277700003, 6.138904940000032],
            [121.81740420900007, 6.139562762000025],
            [121.81711895300009, 6.140137849000041],
        ],
        [
            [121.8290231420001, 6.14561178200006],
            [121.82902688900003, 6.145681167000021],
            [121.82884869100008, 6.14573570400006],
            [121.82888834900007, 6.145644218000029],
            [121.8290231420001, 6.14561178200006],
        ],
        [
            [121.82876582600011, 6.145794567000053],
            [121.8284960310001, 6.145822475000045],
            [121.82846133100009, 6.145700848000047],
            [121.82874255200011, 6.145688840000048],
            [121.82876582600011, 6.145794567000053],
        ],
        [
            [120.97074212600012, 6.176124984000069],
            [120.97076946900006, 6.175602747000028],
            [120.96994421900001, 6.17621622300004],
            [120.97039767400008, 6.176457415000073],
            [120.97074212600012, 6.176124984000069],
        ],
        [
            [120.93410900200001, 6.177392282000028],
            [120.93410043800009, 6.176376061000042],
            [120.93495254900006, 6.175071481000032],
            [120.93372573200008, 6.175690066000072],
            [120.93410900200001, 6.177392282000028],
        ],
        [
            [120.93007560100011, 6.178108890000033],
            [120.93350193100002, 6.174462450000021],
            [120.93373393800005, 6.169126310000024],
            [120.88291571000002, 6.137180661000059],
            [120.893115899, 6.156875792000051],
            [120.93007560100011, 6.178108890000033],
        ],
        [
            [120.89696022600003, 6.151027844000055],
            [120.89431828700003, 6.149918118000073],
            [120.89551839500007, 6.146123015000057],
            [120.89937503100009, 6.149483371000031],
            [120.89696022600003, 6.151027844000055],
        ],
        [
            [120.96420051900009, 6.179730981000034],
            [120.96621048400004, 6.179179373000068],
            [120.96950151700003, 6.174434449000046],
            [120.96462674400004, 6.176469736000058],
            [120.96420051900009, 6.179730981000034],
        ],
        [
            [118.12254801600011, 6.190174300000024],
            [118.12217492700006, 6.185431577000031],
            [118.11451648500008, 6.185446420000062],
            [118.11947536900004, 6.190073297000026],
            [118.12254801600011, 6.190174300000024],
        ],
        [
            [120.97057117000008, 6.190764852000029],
            [120.97678661700002, 6.189382933000047],
            [120.97843018300011, 6.176989598000034],
            [120.96768907, 6.181164742000021],
            [120.97057117000008, 6.190764852000029],
        ],
        [
            [120.96505995200005, 6.206409592000057],
            [120.99043169900006, 6.195205694000038],
            [120.99054236000006, 6.181602705000046],
            [120.96827393300009, 6.198426222000023],
            [120.96359012000005, 6.193494374000068],
            [120.963966991, 6.173129349000021],
            [120.9574725870001, 6.19160862800004],
            [120.96505995200005, 6.206409592000057],
        ],
        [
            [118.14991533000011, 6.206928080000068],
            [118.15108388800002, 6.204511661000026],
            [118.15008329000011, 6.203172667000047],
            [118.14834893600005, 6.205773334000071],
            [118.14991533000011, 6.206928080000068],
        ],
        [
            [121.04389585500007, 6.207875280000053],
            [121.05454829000007, 6.202457303000074],
            [121.050133662, 6.195408924000049],
            [121.04038558000002, 6.203159292000066],
            [121.04389585500007, 6.207875280000053],
        ],
        [
            [120.85563451500002, 6.21831923600007],
            [120.86077092700009, 6.20820821600006],
            [120.84541082900012, 6.20741308700002],
            [120.84760365300008, 6.214811844000053],
            [120.85563451500002, 6.21831923600007],
        ],
        [
            [118.07044894900002, 6.235952085000065],
            [118.0720581600001, 6.232077923000077],
            [118.06429079200007, 6.228023306000068],
            [118.0678378120001, 6.234224633000053],
            [118.07044894900002, 6.235952085000065],
        ],
        [
            [121.8343626090001, 6.242493710000076],
            [121.84577130100001, 6.229977036000037],
            [121.83745689400007, 6.215273237000076],
            [121.83137703200009, 6.228303605000065],
            [121.8343626090001, 6.242493710000076],
        ],
        [
            [120.58133705300008, 6.271193909000033],
            [120.58118145000003, 6.27085852600004],
            [120.58137436400011, 6.27175363200007],
            [120.58146418600006, 6.271666505000042],
            [120.58133705300008, 6.271193909000033],
        ],
        [
            [120.58170535700003, 6.273047791000067],
            [120.5816044710001, 6.272178699000051],
            [120.58139410000001, 6.271906483000066],
            [120.58147526300002, 6.272750426000073],
            [120.58170535700003, 6.273047791000067],
        ],
        [
            [121.99379767100004, 6.28772321100007],
            [121.99380442900008, 6.287339712000062],
            [121.993437018, 6.287448704000042],
            [121.99348590900001, 6.287683877000063],
            [121.99379767100004, 6.28772321100007],
        ],
        [
            [121.99176690200011, 6.288063916000056],
            [121.99199350900005, 6.287674096000046],
            [121.99129389900008, 6.287434952000069],
            [121.99142629700009, 6.287986972000056],
            [121.99176690200011, 6.288063916000056],
        ],
        [
            [121.99932584900012, 6.288380232000065],
            [121.99973975700004, 6.288024653000036],
            [121.99914273900004, 6.287739117000058],
            [121.9988715930001, 6.288167517000034],
            [121.99932584900012, 6.288380232000065],
        ],
        [
            [121.99767066200002, 6.288588190000041],
            [121.99834504400008, 6.286589560000039],
            [121.99278932900006, 6.285930151000059],
            [121.99326103800001, 6.287105392000058],
            [121.99681663100012, 6.287258692000023],
            [121.99767066200002, 6.288588190000041],
        ],
        [
            [121.9933201980001, 6.288533683000026],
            [121.99332842900003, 6.288078203000055],
            [121.99217966800006, 6.287502239000048],
            [121.9930525530001, 6.289123411000048],
            [121.9933201980001, 6.288533683000026],
        ],
        [
            [121.99545955700012, 6.288911447000032],
            [121.99605871900008, 6.288828013000057],
            [121.99629479200007, 6.287345909000067],
            [121.99476333200005, 6.288533847000053],
            [121.99545955700012, 6.288911447000032],
        ],
        [
            [121.9984522530001, 6.289011380000034],
            [121.99784228200008, 6.288637861000041],
            [121.99737459900007, 6.289510776000043],
            [121.99825527100006, 6.289590867000072],
            [121.9984522530001, 6.289011380000034],
        ],
        [
            [118.07914738900001, 6.290202109000063],
            [118.08202866700003, 6.283725119000053],
            [118.07070003600006, 6.28140225900006],
            [118.0770970430001, 6.289642317000073],
            [118.07914738900001, 6.290202109000063],
        ],
        [
            [121.99908676600012, 6.290292303000058],
            [121.9993689370001, 6.289714615000037],
            [121.99880830100005, 6.289559968000049],
            [121.99857576800002, 6.290098128000068],
            [121.99908676600012, 6.290292303000058],
        ],
        [
            [121.99991967300002, 6.290574898000045],
            [122.0001918050001, 6.290145623000058],
            [121.99988156000006, 6.289806266000028],
            [121.99943485100005, 6.290301322000062],
            [121.99991967300002, 6.290574898000045],
        ],
        [
            [122.00125882000009, 6.290593790000059],
            [122.00193014400008, 6.29015294200002],
            [122.00127959100007, 6.289411051000059],
            [122.00067953300004, 6.289859528000022],
            [122.00125882000009, 6.290593790000059],
        ],
        [
            [122.00727945100004, 6.291338464000034],
            [122.00740840500009, 6.291255941000031],
            [122.00713332100008, 6.290891267000063],
            [122.00701742000001, 6.291141866000032],
            [122.00727945100004, 6.291338464000034],
        ],
        [
            [121.959924494, 6.291561018000039],
            [121.95986807800011, 6.291344823000031],
            [121.95974891300011, 6.291320459000076],
            [121.95980430500003, 6.291544754000029],
            [121.959924494, 6.291561018000039],
        ],
        [
            [120.58513422300007, 6.293448485000056],
            [120.585082026, 6.292899693000038],
            [120.5848402900001, 6.292624145000048],
            [120.58476927600009, 6.293253033000042],
            [120.58513422300007, 6.293448485000056],
        ],
        [
            [120.58515797900009, 6.293938396000044],
            [120.58506552300003, 6.293615723000073],
            [120.58477170000003, 6.293709972000045],
            [120.5850726860001, 6.294051464000063],
            [120.58515797900009, 6.293938396000044],
        ],
        [
            [122.00975681600005, 6.294660128000032],
            [122.00958033800009, 6.293987575000074],
            [122.00932302000001, 6.293929515000059],
            [122.00910436700008, 6.294360502000075],
            [122.00975681600005, 6.294660128000032],
        ],
        [
            [120.64455509800007, 6.295512269000028],
            [120.6447109070001, 6.295004187000075],
            [120.64338979700005, 6.294037450000076],
            [120.64383262500007, 6.295165018000034],
            [120.64455509800007, 6.295512269000028],
        ],
        [
            [121.99403066500008, 6.295720881000022],
            [121.99416524800006, 6.296026662000031],
            [121.99420889500004, 6.29578099400004],
            [121.99370770000007, 6.295121032000054],
            [121.99403066500008, 6.295720881000022],
        ],
        [
            [120.64511083900004, 6.296724055000027],
            [120.64544979400011, 6.29635997400004],
            [120.64557280200006, 6.295819288000075],
            [120.64495229300007, 6.295898080000029],
            [120.64511083900004, 6.296724055000027],
        ],
        [
            [121.99355106700011, 6.299754664000034],
            [121.9936785750001, 6.299617436000062],
            [121.9932190400001, 6.299523779000026],
            [121.993285549, 6.299956184000052],
            [121.99355106700011, 6.299754664000034],
        ],
        [
            [121.99246205600002, 6.302834510000025],
            [121.99226701300006, 6.302903805000028],
            [121.9924587060001, 6.303338259000043],
            [121.99261716100011, 6.303215309000052],
            [121.99246205600002, 6.302834510000025],
        ],
        [
            [121.96316167700002, 6.312896298000055],
            [121.98673255200003, 6.28483957900005],
            [121.99478833600006, 6.285102679000033],
            [122.00728935300003, 6.289979815000038],
            [122.01015460600001, 6.294913541000028],
            [122.01556624000011, 6.29117967600007],
            [121.98246752800003, 6.279680179000025],
            [121.97060569100006, 6.27904713700002],
            [121.96316167700002, 6.312896298000055],
        ],
        [
            [121.97952254100005, 6.291136154000071],
            [121.97842493400003, 6.291146962000028],
            [121.97875909700008, 6.290165729000023],
            [121.97953598400011, 6.290697558000033],
            [121.97952254100005, 6.291136154000071],
        ],
        [
            [121.99525561900009, 6.313109424000061],
            [121.99381242600009, 6.30976442900004],
            [121.98940562400003, 6.310640543000034],
            [121.99236563500006, 6.313093787000071],
            [121.99525561900009, 6.313109424000061],
        ],
        [
            [122.00071838500003, 6.316252291000069],
            [122.00621800700003, 6.312481292000029],
            [122.01632195200011, 6.295405963000064],
            [122.00638904200002, 6.302736004000053],
            [122.00071838500003, 6.316252291000069],
        ],
        [
            [122.03860777400007, 6.320240387000069],
            [122.03775992800001, 6.319017942000073],
            [122.03729700600002, 6.319273377000059],
            [122.03776259800009, 6.319949392000069],
            [122.03860777400007, 6.320240387000069],
        ],
        [
            [120.65358232800008, 6.320532891000028],
            [120.66764168500004, 6.305624765000061],
            [120.66315412200004, 6.279231998000057],
            [120.63277653400007, 6.250229635000039],
            [120.65358232800008, 6.320532891000028],
        ],
        [
            [120.65082869200012, 6.292594434000023],
            [120.6495435170001, 6.291530121000051],
            [120.64997300700009, 6.290981071000033],
            [120.651654129, 6.291556526000022],
            [120.65082869200012, 6.292594434000023],
        ],
        [
            [120.65138276900007, 6.296052682000038],
            [120.65048941200007, 6.293214496000076],
            [120.65127233500004, 6.29238218100005],
            [120.65206618900004, 6.294588005000037],
            [120.65138276900007, 6.296052682000038],
        ],
        [
            [120.65235474100007, 6.300847016000034],
            [120.65164392400004, 6.29930672100005],
            [120.65296364400001, 6.29756719300002],
            [120.65342518000011, 6.298077497000065],
            [120.65235474100007, 6.300847016000034],
        ],
        [
            [121.924201003, 6.327577267000038],
            [121.93176864700001, 6.310477637000076],
            [121.92795108100006, 6.304161666000027],
            [121.91909512100005, 6.317969130000051],
            [121.924201003, 6.327577267000038],
        ],
        [
            [122.05001033600001, 6.342050172000029],
            [122.0520616770001, 6.33917186900004],
            [122.05254502000003, 6.334730614000023],
            [122.04902071000004, 6.324347350000039],
            [122.04684628600012, 6.321451664000051],
            [122.03943304600011, 6.315409472000056],
            [122.03771862400004, 6.315024025000071],
            [122.05001033600001, 6.342050172000029],
        ],
        [
            [122.04449676200011, 6.322401567000043],
            [122.04360097400001, 6.322258235000049],
            [122.04375131200004, 6.321675529000061],
            [122.04429523600004, 6.321878192000042],
            [122.04449676200011, 6.322401567000043],
        ],
        [
            [122.04448492100005, 6.323426718000064],
            [122.04395904700004, 6.322965227000054],
            [122.04446733200007, 6.322624353000037],
            [122.04494220100003, 6.322973967000053],
            [122.04448492100005, 6.323426718000064],
        ],
        [
            [122.04375151900001, 6.324932144000059],
            [122.04287916300007, 6.324629726000069],
            [122.042975898, 6.324016151000023],
            [122.04385880400002, 6.324365769000053],
            [122.04375151900001, 6.324932144000059],
        ],
        [
            [122.04533603100003, 6.329055761000063],
            [122.04526740000006, 6.329144748000033],
            [122.04488031100004, 6.329003569000065],
            [122.04507749700008, 6.328709957000058],
            [122.04533603100003, 6.329055761000063],
        ],
        [
            [122.04843622600004, 6.330464868000035],
            [122.04858296800012, 6.330717811000056],
            [122.04829532300005, 6.330945501000031],
            [122.04811837400007, 6.330656777000058],
            [122.04843622600004, 6.330464868000035],
        ],
        [
            [120.85606471100004, 6.34277326800003],
            [120.87597189600001, 6.322659421000026],
            [120.84227988400005, 6.309450741000035],
            [120.84619341500002, 6.337547620000066],
            [120.85606471100004, 6.34277326800003],
        ],
        [
            [122.02957766200007, 6.35038922800004],
            [122.04077459000007, 6.328963432000023],
            [122.01671600300006, 6.326876790000028],
            [122.01760996900009, 6.340736634000052],
            [122.02957766200007, 6.35038922800004],
        ],
        [
            [122.02392426800009, 6.32835041900006],
            [122.02388723100012, 6.328508175000024],
            [122.02371528300012, 6.328368821000026],
            [122.02385284500008, 6.328287316000058],
            [122.02392426800009, 6.32835041900006],
        ],
        [
            [122.02461997300009, 6.330254019000051],
            [122.02451414600012, 6.33093236600007],
            [122.02431045100002, 6.331000724000035],
            [122.02415967000002, 6.330559006000044],
            [122.02461997300009, 6.330254019000051],
        ],
        [
            [121.97578390600006, 6.361866175000046],
            [121.98187282600009, 6.337448085000062],
            [121.95860906000007, 6.335781437000037],
            [121.94999504300006, 6.351376074000029],
            [121.97578390600006, 6.361866175000046],
        ],
        [
            [120.7015732000001, 6.393788106000045],
            [120.70220993200007, 6.393566707000048],
            [120.70230033700011, 6.393103329000041],
            [120.7011555690001, 6.393221061000077],
            [120.7015732000001, 6.393788106000045],
        ],
        [
            [120.70457416700003, 6.393882690000055],
            [120.7045364170001, 6.393510423000066],
            [120.7040934800001, 6.393437906000031],
            [120.70424902600007, 6.393784401000062],
            [120.70457416700003, 6.393882690000055],
        ],
        [
            [120.70476740100003, 6.394149576000075],
            [120.70525270600001, 6.393945807000023],
            [120.70492986400006, 6.393472903000031],
            [120.70460009300007, 6.393941221000034],
            [120.70476740100003, 6.394149576000075],
        ],
        [
            [120.70433628, 6.394339287000037],
            [120.70417128600002, 6.393847629000049],
            [120.70376838700008, 6.393672087000027],
            [120.70363415600002, 6.394095890000074],
            [120.70433628, 6.394339287000037],
        ],
        [
            [120.70564152500003, 6.394479575000048],
            [120.70602784900007, 6.394086173000062],
            [120.70576392200007, 6.393711598000039],
            [120.70538705900003, 6.394360204000066],
            [120.70564152500003, 6.394479575000048],
        ],
        [
            [120.59546068400005, 6.394604762000029],
            [120.57735629000001, 6.25012743700006],
            [120.47917998200012, 6.253483012000061],
            [120.51841449200003, 6.263136770000074],
            [120.55670807800004, 6.37434662000004],
            [120.59546068400005, 6.394604762000029],
        ],
        [
            [120.70658086700007, 6.394564493000075],
            [120.70661918000008, 6.394217884000057],
            [120.70785725300004, 6.393760180000072],
            [120.70623552200004, 6.394183281000039],
            [120.70658086700007, 6.394564493000075],
        ],
        [
            [120.70344007000006, 6.394848147000062],
            [120.70308702800003, 6.394828524000047],
            [120.70323224900005, 6.395153116000074],
            [120.70348630300009, 6.395136684000022],
            [120.70344007000006, 6.394848147000062],
        ],
        [
            [120.70471871400002, 6.395294269000033],
            [120.70457354000007, 6.39530740500004],
            [120.70452076300012, 6.395405780000033],
            [120.70474184000011, 6.395497557000056],
            [120.70471871400002, 6.395294269000033],
        ],
        [
            [120.7057415590001, 6.395431832000043],
            [120.70541493300004, 6.395546641000067],
            [120.70557664700004, 6.395822047000024],
            [120.70584716700012, 6.395599040000036],
            [120.7057415590001, 6.395431832000043],
        ],
        [
            [120.70966614500003, 6.396537640000076],
            [120.70972454200012, 6.396363449000035],
            [120.70947051300004, 6.396305427000073],
            [120.70948324000005, 6.396474560000058],
            [120.70966614500003, 6.396537640000076],
        ],
        [
            [120.70862761600006, 6.39762921800002],
            [120.70879385700005, 6.397426919000054],
            [120.70860454400008, 6.396743205000064],
            [120.7083495170001, 6.397498210000037],
            [120.70862761600006, 6.39762921800002],
        ],
        [
            [122.03990268200005, 6.397995405000074],
            [122.04119128400009, 6.393436501000053],
            [122.0381863240001, 6.392319482000062],
            [122.03698076600006, 6.395599259000051],
            [122.03990268200005, 6.397995405000074],
        ],
        [
            [120.70096331400009, 6.398249749000058],
            [120.70070239800009, 6.398096270000053],
            [120.70056509900007, 6.39819863300005],
            [120.70087752500001, 6.398474917000044],
            [120.70096331400009, 6.398249749000058],
        ],
        [
            [120.70035913800007, 6.398263479000036],
            [120.69985106700005, 6.398181673000067],
            [120.6997034960001, 6.398471666000034],
            [120.6999884380001, 6.39858420500002],
            [120.70035913800007, 6.398263479000036],
        ],
        [
            [122.12183392400004, 6.430126035000058],
            [122.12785039100004, 6.428267093000045],
            [122.11395931800007, 6.427503093000041],
            [122.11889989200006, 6.432384137000042],
            [122.12183392400004, 6.430126035000058],
        ],
        [
            [122.13407548300006, 6.430045070000062],
            [122.12931929600006, 6.429292360000034],
            [122.12649885200005, 6.434552086000053],
            [122.13630730000011, 6.436212196000042],
            [122.13407548300006, 6.430045070000062],
        ],
        [
            [120.71114813100007, 6.437376265000069],
            [120.71079588000009, 6.396836941000061],
            [120.70678308800007, 6.400968998000053],
            [120.69922043000008, 6.400366380000037],
            [120.700936178, 6.393157971000051],
            [120.67046800300011, 6.403164873000037],
            [120.71114813100007, 6.437376265000069],
        ],
        [
            [120.69887473000006, 6.398937305000061],
            [120.69864278600005, 6.398737904000029],
            [120.69764383000006, 6.398755093000034],
            [120.6986530480001, 6.398471809000057],
            [120.69887473000006, 6.398937305000061],
        ],
        [
            [120.69922926800007, 6.399365684000031],
            [120.69908704200009, 6.399240380000037],
            [120.69925874800003, 6.399107033000064],
            [120.69934999500003, 6.399248343000068],
            [120.69922926800007, 6.399365684000031],
        ],
        [
            [120.68927789100007, 6.400448546000064],
            [120.68903533700006, 6.400173981000023],
            [120.68967347300008, 6.40040503900002],
            [120.68930769500002, 6.400331989000051],
            [120.68927789100007, 6.400448546000064],
        ],
        [
            [122.14315699600002, 6.444594719000065],
            [122.14303404800012, 6.444188310000072],
            [122.14417173200002, 6.444988096000031],
            [122.14390041700005, 6.44436509600007],
            [122.14271093400009, 6.44408545400006],
            [122.1425658600001, 6.445438259000071],
            [122.14315699600002, 6.444594719000065],
        ],
        [
            [122.14094835700007, 6.445519511000043],
            [122.14088178500003, 6.445026119000033],
            [122.14182523500006, 6.444558784000037],
            [122.140745164, 6.444814840000049],
            [122.14094835700007, 6.445519511000043],
        ],
        [
            [122.14518024300003, 6.445987095000021],
            [122.14548703700007, 6.445131784000068],
            [122.14494782800011, 6.444436537000058],
            [122.14423826000007, 6.44491933200004],
            [122.14518024300003, 6.445987095000021],
        ],
        [
            [122.17464381400009, 6.453470853000056],
            [122.17761746300005, 6.452842632000056],
            [122.17091059900008, 6.451987231000032],
            [122.16972495000005, 6.45200598100007],
            [122.16924961400002, 6.452361953000036],
            [122.17464381400009, 6.453470853000056],
        ],
        [
            [121.85658386600005, 6.453654437000068],
            [121.85648920000006, 6.451450987000044],
            [121.85453480800004, 6.451849861000028],
            [121.85463861800008, 6.453192603000048],
            [121.85658386600005, 6.453654437000068],
        ],
        [
            [122.17982573400002, 6.454015346000062],
            [122.18022618200007, 6.453163693000022],
            [122.17802184200002, 6.453088482000055],
            [122.17917747000001, 6.453256914000065],
            [122.17982573400002, 6.454015346000062],
        ],
        [
            [122.17747058500004, 6.454603540000051],
            [122.17752836900002, 6.454377461000036],
            [122.17720308800006, 6.454246867000052],
            [122.17713219200004, 6.454567422000025],
            [122.17747058500004, 6.454603540000051],
        ],
        [
            [122.17617456000005, 6.45701397800002],
            [122.17632151400005, 6.455368203000035],
            [122.17486825000003, 6.455309095000075],
            [122.17452768500004, 6.456399317000034],
            [122.17617456000005, 6.45701397800002],
        ],
        [
            [122.17554010300012, 6.457165618000033],
            [122.17579458000012, 6.457225290000054],
            [122.17604417000007, 6.457048504000056],
            [122.17535124000005, 6.457011397000031],
            [122.17554010300012, 6.457165618000033],
        ],
        [
            [122.22239792200003, 6.465527697000027],
            [122.22361601500006, 6.464481300000045],
            [122.22618199300007, 6.465465790000053],
            [122.22794351800007, 6.464532076000069],
            [122.22968170900003, 6.462476249000076],
            [122.23205269800007, 6.455692783000075],
            [122.23096582200003, 6.450041838000061],
            [122.22575280100011, 6.447102674000064],
            [122.21922261600002, 6.448276373000056],
            [122.218771306, 6.448909429000025],
            [122.229888877, 6.452698730000066],
            [122.22239792200003, 6.465527697000027],
        ],
        [
            [121.82710866700006, 6.46829525000004],
            [121.83401605800009, 6.45924367300006],
            [121.82654452100007, 6.448045742000033],
            [121.81640016300003, 6.461971048000066],
            [121.82710866700006, 6.46829525000004],
        ],
        [
            [122.20633786700012, 6.479009187000031],
            [122.22592993300009, 6.45637092000004],
            [122.2242099660001, 6.451820625000039],
            [122.19746497200003, 6.462858923000056],
            [122.20633786700012, 6.479009187000031],
        ],
        [
            [122.21171586700007, 6.487392813000042],
            [122.21002490500007, 6.486779236000075],
            [122.20901398600006, 6.487330550000024],
            [122.21084108500008, 6.488678035000021],
            [122.21171586700007, 6.487392813000042],
        ],
        [
            [122.20522264800002, 6.486159800000053],
            [122.20389258400007, 6.486966685000027],
            [122.203414242, 6.490099773000054],
            [122.2056308650001, 6.488850246000027],
            [122.20522264800002, 6.486159800000053],
        ],
        [
            [122.20676593500002, 6.489839495000069],
            [122.20355441800007, 6.491533978000064],
            [122.20555389800006, 6.493852415000049],
            [122.20706985900006, 6.491996881000034],
            [122.20676593500002, 6.489839495000069],
        ],
        [
            [122.20786859600003, 6.507983086000024],
            [122.21887614100001, 6.499590736000073],
            [122.2175882030001, 6.493594072000064],
            [122.20136912500004, 6.515284590000022],
            [122.20786859600003, 6.507983086000024],
        ],
        [
            [121.77909457500004, 6.526616378000028],
            [121.7817520750001, 6.521587407000027],
            [121.77338287300006, 6.519265184000062],
            [121.7730934000001, 6.52171429200007],
            [121.77909457500004, 6.526616378000028],
        ],
        [
            [122.20214138000006, 6.52009791100005],
            [122.19956678800008, 6.52169110400007],
            [122.20406060100004, 6.527996472000041],
            [122.20446955400007, 6.524908538000034],
            [122.20214138000006, 6.52009791100005],
        ],
        [
            [121.78829255000005, 6.531935597000029],
            [121.79238552000004, 6.529074424000044],
            [121.792936015, 6.524097267000059],
            [121.78884109400008, 6.526459716000033],
            [121.78829255000005, 6.531935597000029],
        ],
        [
            [122.20555372800004, 6.531437849000042],
            [122.20507141600001, 6.531239106000044],
            [122.20486616300002, 6.531315150000069],
            [122.20607081300011, 6.532151940000062],
            [122.20555372800004, 6.531437849000042],
        ],
        [
            [121.83660340100005, 6.533072942000047],
            [121.83867858500003, 6.532512570000051],
            [121.83878897300008, 6.526121921000026],
            [121.83826466100004, 6.525892145000057],
            [121.83660340100005, 6.533072942000047],
        ],
        [
            [121.75741588800008, 6.540588079000031],
            [121.76231631600001, 6.539103624000063],
            [121.76377674300011, 6.535307132000071],
            [121.75548056000002, 6.533747303000041],
            [121.75741588800008, 6.540588079000031],
        ],
        [
            [121.831682526, 6.550752701000022],
            [121.83448930800012, 6.54635851300003],
            [121.83717647300011, 6.54577818000007],
            [121.83513214200002, 6.545591287000036],
            [121.83293755500006, 6.546826500000066],
            [121.831682526, 6.550752701000022],
        ],
        [
            [121.86573922800005, 6.550242784000034],
            [121.86682379100012, 6.548391719000051],
            [121.86558627700003, 6.546996509000053],
            [121.863111247, 6.549510647000034],
            [121.86573922800005, 6.550242784000034],
        ],
        [
            [121.85973241500005, 6.552038587000027],
            [121.85949603600011, 6.551941890000023],
            [121.859023277, 6.552218167000035],
            [121.8595933690001, 6.552646396000057],
            [121.85973241500005, 6.552038587000027],
        ],
        [
            [121.79390727100008, 6.566765545000067],
            [121.7978692580001, 6.564494334000074],
            [121.80585779900002, 6.549558212000022],
            [121.79094059500005, 6.55198077700004],
            [121.79390727100008, 6.566765545000067],
        ],
        [
            [121.748983672, 6.562701675000028],
            [121.74291874700009, 6.567597524000064],
            [121.74495648700008, 6.572044145000064],
            [121.74842209600001, 6.56994015500004],
            [121.748983672, 6.562701675000028],
        ],
        [
            [121.6919263630001, 6.586061790000031],
            [121.69418425100002, 6.584492642000043],
            [121.69682680300002, 6.56406048100007],
            [121.6896416940001, 6.570620167000072],
            [121.6919263630001, 6.586061790000031],
        ],
        [
            [122.26439349300006, 6.587072104000072],
            [122.26456003300007, 6.586666379000064],
            [122.26243743600003, 6.585949246000041],
            [122.26108801100008, 6.586448361000066],
            [122.26439349300006, 6.587072104000072],
        ],
        [
            [121.56316900400009, 6.587214561000053],
            [121.56680594900001, 6.58701334400007],
            [121.56568140800005, 6.583018947000028],
            [121.56136923000008, 6.585499151000022],
            [121.56316900400009, 6.587214561000053],
        ],
        [
            [121.77404259500008, 6.596298684000033],
            [121.78082657900006, 6.591740463000065],
            [121.78135273100008, 6.587859562000062],
            [121.77430409800002, 6.588582884000061],
            [121.77404259500008, 6.596298684000033],
        ],
        [
            [121.56092713800001, 6.60224594500005],
            [121.56638277000002, 6.597111662000032],
            [121.56444726900008, 6.591517195000051],
            [121.55986125200002, 6.594028858000058],
            [121.56092713800001, 6.60224594500005],
        ],
        [
            [121.5472796140001, 6.603063158000055],
            [121.55071624800007, 6.602522435000026],
            [121.551268047, 6.602136270000074],
            [121.54778784000007, 6.599966316000064],
            [121.5472796140001, 6.603063158000055],
        ],
        [
            [121.55084484300005, 6.611804160000077],
            [121.55121157700012, 6.611579919000064],
            [121.55121742900008, 6.610899327000027],
            [121.55050398900005, 6.61100288800003],
            [121.55084484300005, 6.611804160000077],
        ],
        [
            [121.75488152600008, 6.61293605000003],
            [121.75689690400009, 6.610292278000031],
            [121.75572536800007, 6.608706926000025],
            [121.75454239100009, 6.610669184000074],
            [121.75488152600008, 6.61293605000003],
        ],
        [
            [121.54861285800007, 6.623645837000026],
            [121.55462340400004, 6.618418194000071],
            [121.54445562300009, 6.61445836200005],
            [121.54524408200007, 6.619121636000045],
            [121.54861285800007, 6.623645837000026],
        ],
        [
            [121.51561288800008, 6.62555315000003],
            [121.51766120100001, 6.624329160000059],
            [121.51764743800004, 6.614606608000031],
            [121.51013099800002, 6.620962064000025],
            [121.51561288800008, 6.62555315000003],
        ],
        [
            [121.56215194000004, 6.63671490400003],
            [121.56157445000008, 6.629741295000031],
            [121.55847284300012, 6.629468767000049],
            [121.55953839600011, 6.636276507000048],
            [121.56215194000004, 6.63671490400003],
        ],
        [
            [121.64000046000001, 6.645016253000051],
            [121.641765931, 6.643083485000034],
            [121.63801139100008, 6.638433951000025],
            [121.63815521800007, 6.643196139000054],
            [121.64000046000001, 6.645016253000051],
        ],
        [
            [121.5738070210001, 6.648039139000048],
            [121.57311509200008, 6.645706207000046],
            [121.5690504270001, 6.643871570000044],
            [121.56912957800012, 6.646446405000063],
            [121.5738070210001, 6.648039139000048],
        ],
        [
            [121.58733527700008, 6.650446927000075],
            [121.59130526900003, 6.63191977200006],
            [121.58510813200007, 6.62522301000007],
            [121.5694856240001, 6.638750679000054],
            [121.58733527700008, 6.650446927000075],
        ],
        [
            [121.53251054900011, 6.659549109000068],
            [121.53766099200004, 6.653018347000057],
            [121.53430384700005, 6.645823159000031],
            [121.52915025900006, 6.650218547000065],
            [121.53251054900011, 6.659549109000068],
        ],
        [
            [121.52952434800011, 6.662676260000069],
            [121.5293538730001, 6.662459218000038],
            [121.52910126100005, 6.662585440000043],
            [121.52934922300005, 6.662970268000038],
            [121.52952434800011, 6.662676260000069],
        ],
        [
            [121.56963159200006, 6.664965754000036],
            [121.57050141600007, 6.65353705800004],
            [121.56503969700009, 6.646216184000025],
            [121.5634043440001, 6.647260077000055],
            [121.56963159200006, 6.664965754000036],
        ],
        [
            [121.53123991700011, 6.665070429000025],
            [121.53129472300009, 6.664890229000036],
            [121.531035814, 6.664820778000035],
            [121.53099801600001, 6.665012240000067],
            [121.53123991700011, 6.665070429000025],
        ],
        [
            [121.53218295200008, 6.66570863100003],
            [121.53219051100007, 6.665404545000058],
            [121.53176529500001, 6.665438335000033],
            [121.5318673480001, 6.665753682000059],
            [121.53218295200008, 6.66570863100003],
        ],
        [
            [122.20061104600006, 6.666230553000048],
            [122.20092106700008, 6.665484475000028],
            [122.19969441800004, 6.665473286000065],
            [122.19981594, 6.666209939000055],
            [122.20061104600006, 6.666230553000048],
        ],
        [
            [122.1841873620001, 6.666601852000042],
            [122.18448301400008, 6.666336955000077],
            [122.18404838100003, 6.666137399000036],
            [122.18395501900011, 6.666613678000033],
            [122.1841873620001, 6.666601852000042],
        ],
        [
            [122.18126487100005, 6.667326264000053],
            [122.18134832400006, 6.667070092000074],
            [122.18086888900007, 6.667150697000068],
            [122.18095143700009, 6.667332926000029],
            [122.18126487100005, 6.667326264000053],
        ],
        [
            [122.1798068060001, 6.667621259000043],
            [122.180118547, 6.666783722000048],
            [122.1790157590001, 6.666553605000047],
            [122.17939020000006, 6.667567820000045],
            [122.1798068060001, 6.667621259000043],
        ],
        [
            [122.19753010500006, 6.667612551000047],
            [122.1980980940001, 6.667133775000025],
            [122.1970120850001, 6.666784184000051],
            [122.19703857800005, 6.667452162000075],
            [122.19753010500006, 6.667612551000047],
        ],
        [
            [121.53091063600004, 6.667853838000042],
            [121.53125599100008, 6.667290078000065],
            [121.53078528200001, 6.666525270000022],
            [121.53054300800011, 6.668156250000038],
            [121.53091063600004, 6.667853838000042],
        ],
        [
            [121.53332519500009, 6.669921875000057],
            [121.53332519500009, 6.669128418000071],
            [121.53271484400011, 6.669494629000042],
            [121.53332519500009, 6.669921875000057],
        ],
        [
            [121.91564711100011, 6.679490110000074],
            [121.91699032400004, 6.678340369000068],
            [121.91660588800005, 6.676488504000076],
            [121.91481147800005, 6.677746539000054],
            [121.91564711100011, 6.679490110000074],
        ],
        [
            [121.59499496600006, 6.683052267000051],
            [121.63228444600009, 6.652059055000052],
            [121.61851794300003, 6.558756046000042],
            [121.5844938890001, 6.664510625000048],
            [121.59499496600006, 6.683052267000051],
        ],
        [
            [121.6121557130001, 6.587248764000037],
            [121.61050020400012, 6.586867131000076],
            [121.612087803, 6.582806873000038],
            [121.61286292600005, 6.584161799000071],
            [121.6121557130001, 6.587248764000037],
        ],
        [
            [121.61626267000008, 6.598814383000047],
            [121.61427016000005, 6.596528252000041],
            [121.6139547900001, 6.59395558500006],
            [121.6160335940001, 6.595002565000073],
            [121.61626267000008, 6.598814383000047],
        ],
        [
            [121.61692299900005, 6.601897158000043],
            [121.61595255500004, 6.601412273000051],
            [121.61643945500009, 6.599683647000063],
            [121.61784279500012, 6.600438707000023],
            [121.61692299900005, 6.601897158000043],
        ],
        [
            [121.61151748200007, 6.607518360000029],
            [121.6111644130001, 6.605930262000072],
            [121.6114466460001, 6.606051812000032],
            [121.61219194800003, 6.607325766000031],
            [121.61151748200007, 6.607518360000029],
        ],
        [
            [121.71008720100008, 6.694497979000062],
            [121.71757250600001, 6.686280404000058],
            [121.70542189700006, 6.642427056000031],
            [121.70284080800002, 6.685043184000051],
            [121.71008720100008, 6.694497979000062],
        ],
        [
            [122.25553813400006, 6.738063667000063],
            [122.25995338400003, 6.734881186000052],
            [122.2639139800001, 6.726620116000049],
            [122.25556737000011, 6.730046550000054],
            [122.25553813400006, 6.738063667000063],
        ],
        [
            [122.25140295100005, 6.74217972100007],
            [122.25136743300004, 6.740877240000032],
            [122.25032157700002, 6.740988143000038],
            [122.250456944, 6.742095674000041],
            [122.25140295100005, 6.74217972100007],
        ],
        [
            [122.39629677900007, 6.750006219000056],
            [122.40685314500001, 6.742042901000048],
            [122.40542102000006, 6.734471150000047],
            [122.39171356600002, 6.738916862000053],
            [122.39629677900007, 6.750006219000056],
        ],
        [
            [121.93648783900005, 6.564648783000052],
            [122.04289291400005, 6.564819979000049],
        ],
        [
            [122.04289291400005, 6.564819979000049],
            [122.03030071700005, 6.733338556000035],
            [122.06383901800007, 6.751012958000047],
            [122.09356402600008, 6.713038324000024],
            [122.13600839800006, 6.717310965000024],
            [122.1468243810001, 6.675309855000023],
            [122.14296379600012, 6.669920869000066],
            [122.30046257400011, 6.646725157000049],
            [122.32692870700009, 6.616833038000038],
            [122.21193171700008, 6.58096714900006],
            [122.18999921300008, 6.520963164000023],
            [122.19286109600012, 6.461202539000055],
            [121.95697609800004, 6.406642008000063],
            [121.86961204700003, 6.505512593000049],
            [121.8695355210001, 6.576247254000066],
            [121.79800440600002, 6.598083999000039],
            [121.79499172900012, 6.630069024000022],
            [121.83358880300011, 6.679851664000068],
            [121.88506619400005, 6.656494962000068],
            [121.91648332700004, 6.674926640000024],
            [121.93648783900005, 6.564648783000052],
        ],
        [
            [122.17399455200007, 6.66531849200004],
            [122.17359908800006, 6.665051549000054],
            [122.17408803600006, 6.664453844000036],
            [122.17385842300007, 6.66496597400004],
            [122.17399455200007, 6.66531849200004],
        ],
        [
            [122.14259424800002, 6.680065771000045],
            [122.14182386700008, 6.67974337000004],
            [122.14153378100002, 6.678683516000035],
            [122.1425677520001, 6.679259587000047],
            [122.14259424800002, 6.680065771000045],
        ],
        [
            [121.45869593200007, 6.765970226000036],
            [121.47216337200007, 6.74834658900005],
            [121.46855025600007, 6.734026112000038],
            [121.45051384600004, 6.746777535000035],
            [121.45869593200007, 6.765970226000036],
        ],
        [
            [122.37739154500002, 6.775369309000041],
            [122.37991643100008, 6.76776157300003],
            [122.36280894900005, 6.762323586000036],
            [122.36248129300009, 6.769155912000031],
            [122.37739154500002, 6.775369309000041],
        ],
        [
            [121.43472083400002, 6.780159627000046],
            [121.43890061400009, 6.761392262000072],
            [121.43375523500004, 6.756572601000073],
            [121.42944880700009, 6.766018162000023],
            [121.43472083400002, 6.780159627000046],
        ],
        [
            [121.53419730100006, 6.835152028000039],
            [121.54646087700007, 6.824424430000022],
            [121.54869616400003, 6.812109787000054],
            [121.53011811100009, 6.828680413000029],
            [121.53419730100006, 6.835152028000039],
        ],
        [
            [121.55331132700007, 6.846515269000065],
            [121.56113402300002, 6.842456240000047],
            [121.55639625900005, 6.828235225000071],
            [121.5471231360001, 6.838321179000047],
            [121.55331132700007, 6.846515269000065],
        ],
        [
            [118.4009098890001, 6.878896047000069],
            [118.39881765200005, 6.871415640000066],
            [118.39410683800008, 6.870988390000036],
            [118.39437442500002, 6.87777489900003],
            [118.4009098890001, 6.878896047000069],
        ],
        [
            [118.4087638520001, 6.889356615000054],
            [118.41043496400005, 6.887051445000054],
            [118.40738349600008, 6.884142359000066],
            [118.40588835800008, 6.887758014000042],
            [118.4087638520001, 6.889356615000054],
        ],
        [
            [121.58843326500005, 6.906588414000055],
            [121.5936898120001, 6.900784642000076],
            [121.5931401260001, 6.888397267000073],
            [121.58609492900007, 6.90235879100004],
            [121.58843326500005, 6.906588414000055],
        ],
        [
            [118.530273437, 7.03070068300002],
            [118.52893066400009, 7.03070068300002],
            [118.52868652300003, 7.031311035000044],
            [118.530273437, 7.031677246000072],
            [118.530273437, 7.03070068300002],
        ],
        [
            [118.44207763600002, 7.044677734000061],
            [118.44207763600002, 7.044311523000033],
            [118.4417114260001, 7.044677734000061],
            [118.44207763600002, 7.044677734000061],
        ],
        [
            [118.45727539000006, 7.045471192000036],
            [118.45690918000003, 7.044921875000057],
            [118.45672607400002, 7.045471192000036],
            [118.45727539000006, 7.045471192000036],
        ],
        [
            [118.5070373850001, 7.049084868000023],
            [118.53570727200008, 6.963959885000065],
            [118.48239070500006, 6.967807793000077],
            [118.43079225100007, 6.988844032000031],
            [118.4083293430001, 7.020894291000047],
            [118.5070373850001, 7.049084868000023],
        ],
        [
            [118.43816966300005, 6.987445746000049],
            [118.43776034000007, 6.987643390000073],
            [118.43761949300006, 6.986848731000066],
            [118.43826442200009, 6.986911743000064],
            [118.43816966300005, 6.987445746000049],
        ],
        [
            [118.42111769400003, 7.009685173000037],
            [118.419610078, 7.008423874000073],
            [118.42305886200006, 7.007474571000046],
            [118.42281356700005, 7.009260528000027],
            [118.42111769400003, 7.009685173000037],
        ],
        [
            [118.42098443600003, 7.010497871000041],
            [118.42083417900005, 7.010186007000073],
            [118.42128772800004, 7.010169757000028],
            [118.42127405400004, 7.010427377000042],
            [118.42098443600003, 7.010497871000041],
        ],
        [
            [118.42411402500011, 7.011101479000047],
            [118.42401832200005, 7.010839649000047],
            [118.42427512800009, 7.010587100000066],
            [118.42448055500006, 7.010828082000046],
            [118.42411402500011, 7.011101479000047],
        ],
        [
            [118.42288597100003, 7.013127865000058],
            [118.42259651300003, 7.01307865900003],
            [118.42311994300007, 7.01261428600003],
            [118.42307432000007, 7.013147551000031],
            [118.42288597100003, 7.013127865000058],
        ],
        [
            [118.42253841600007, 7.013585956000043],
            [118.42243110800007, 7.013837168000066],
            [118.42235132200005, 7.013867201000039],
            [118.42234307900003, 7.013596870000072],
            [118.42253841600007, 7.013585956000043],
        ],
        [
            [118.47573640000007, 7.031690260000062],
            [118.47480354800007, 7.031649001000062],
            [118.47456433100001, 7.030628896000053],
            [118.47556015500004, 7.030920551000065],
            [118.47573640000007, 7.031690260000062],
        ],
        [
            [118.45744393200005, 7.082006468000031],
            [118.46062985700007, 7.079913745000056],
            [118.45773456000006, 7.076664158000028],
            [118.45417538100003, 7.078255696000042],
            [118.45744393200005, 7.082006468000031],
        ],
        [
            [118.43843071300012, 7.088274153000043],
            [118.44100967400004, 7.086165770000036],
            [118.43989318100012, 7.082363020000059],
            [118.4360860480001, 7.083950854000022],
            [118.43843071300012, 7.088274153000043],
        ],
        [
            [118.4249089860001, 7.097586423000052],
            [118.4245513950001, 7.097826093000037],
            [118.42649494200009, 7.099782548000064],
            [118.42611178600009, 7.098603039000068],
            [118.4249089860001, 7.097586423000052],
        ],
        [
            [118.42252736300009, 7.098258607000048],
            [118.42315206100011, 7.097484282000039],
            [118.4213994380001, 7.098341494000067],
            [118.42052849800007, 7.100204772000041],
            [118.4209751090001, 7.100902873000052],
            [118.42252736300009, 7.098258607000048],
        ],
        [
            [118.42377151100004, 7.126258598000049],
            [118.42608872300002, 7.125542852000024],
            [118.42573356500009, 7.12228753100004],
            [118.42132974300011, 7.123434023000073],
            [118.42377151100004, 7.126258598000049],
        ],
        [
            [118.42021269600002, 7.17907290100004],
            [118.42366897900001, 7.176584197000068],
            [118.41486168200004, 7.170347760000027],
            [118.41479170000002, 7.175698827000076],
            [118.42021269600002, 7.17907290100004],
        ],
        [
            [124.07623725500002, 7.376436348000027],
            [124.0455397820001, 7.313150782000037],
            [124.02105807500004, 7.29695511500006],
            [124.0272513220001, 7.344405837000068],
            [124.07623725500002, 7.376436348000027],
        ],
        [
            [124.53716690600004, 8.090485116000025],
            [124.59761010300008, 7.902537395000024],
        ],
        [
            [124.59761010300008, 7.902537395000024],
            [124.73141648500007, 7.745150887000023],
            [124.82843723300005, 7.546219757000074],
            [124.79875829800005, 7.522033002000057],
            [124.7419621140001, 7.590973957000074],
        ],
        [
            [124.7419621140001, 7.590973957000074],
            [124.52804919700009, 7.638289207000071],
        ],
        [
            [124.52804919700009, 7.638289207000071],
            [124.48528910200002, 7.438605069000062],
            [124.39602007500002, 7.355388001000051],
            [124.33983748000003, 7.169215253000061],
            [124.37708222800006, 7.169739380000067],
            [124.41811717900009, 7.230269718000045],
            [124.48961885200004, 7.207222989000059],
            [124.43154138400007, 7.089539807000051],
            [124.50123402500003, 7.030097615000045],
            [124.53700086300012, 7.039461171000028],
            [124.58614784800011, 6.96985163100004],
            [124.67720998200002, 6.94663898400006],
            [124.72158600500006, 6.998578679000047],
            [124.68922780600008, 7.072480119000033],
            [124.73689625200007, 7.110297365000065],
        ],
        [
            [124.73689625200007, 7.110297365000065],
            [124.69462501100008, 7.182765975000052],
            [124.79642000500007, 7.136251160000029],
            [124.7719886320001, 7.075949368000067],
        ],
        [
            [124.7719886320001, 7.075949368000067],
            [124.82521197800008, 7.062747508000029],
            [124.804196208, 6.816775648000032],
        ],
        [
            [124.804196208, 6.816775648000032],
            [124.94174955300002, 6.790628155000036],
            [124.958628642, 6.736979865000023],
        ],
        [
            [124.958628642, 6.736979865000023],
            [125.00774339400004, 6.734105528000043],
        ],
        [
            [125.00774339400004, 6.734105528000043],
            [124.88680814300005, 6.677562946000023],
        ],
        [
            [124.88680814300005, 6.677562946000023],
            [124.90200884800004, 6.655854541000053],
        ],
        [
            [124.90200884800004, 6.655854541000053],
            [124.84011123500011, 6.60095775000002],
            [124.78551554, 6.603158045000043],
            [124.76099799200006, 6.664839584000049],
        ],
        [
            [124.76099799200006, 6.664839584000049],
            [124.79525675200011, 6.683821813000066],
            [124.6337791850001, 6.888110593000022],
            [124.58028927100008, 6.850143099000036],
        ],
        [
            [124.58028927100008, 6.850143099000036],
            [124.58572981500004, 6.809829827000044],
            [124.57798591900007, 6.781466885000043],
        ],
        [
            [124.57798591900007, 6.781466885000043],
            [124.50931452600003, 6.772891965000042],
            [124.51615695200007, 6.727921230000049],
            [124.27895399600004, 6.69617573000005],
            [124.28391654000006, 6.75407068800007],
        ],
        [
            [124.28391654000006, 6.75407068800007],
            [124.0333427710001, 6.740810256000032],
            [124.02174317200001, 6.787775639000074],
            [123.97093539900004, 6.769237715000031],
            [123.94352583200009, 6.817967650000071],
            [123.97489414200004, 6.866021498000066],
            [123.96962284000006, 6.963310435000039],
            [124.06612388000008, 7.144750887000043],
            [124.17259624600001, 7.197923073000027],
            [124.31783060700002, 7.142674627000076],
            [124.23449351600004, 7.233458753000036],
        ],
        [
            [124.23449351600004, 7.233458753000036],
            [124.23995740100008, 7.268762815000059],
            [124.20397732600009, 7.261279040000034],
            [124.2023006180001, 7.351668366000069],
            [124.23136376600007, 7.341948307000052],
            [124.25778384500006, 7.349196233000043],
            [124.24842209200006, 7.408074172000056],
            [124.15578643000003, 7.401877307000063],
            [124.18004472000007, 7.414766909000036],
            [124.12819961200012, 7.446359163000068],
            [124.14489176100005, 7.463355705000026],
            [124.03656586900001, 7.627608628000075],
            [123.85057887500011, 7.697496347000026],
            [123.85057305100008, 7.734377462000054],
            [124.00162475900004, 7.742659211000046],
        ],
        [
            [124.00162475900004, 7.742659211000046],
            [124.0294234910001, 7.821626718000061],
            [123.96570479000002, 7.879629500000021],
            [124.00188328500008, 7.912551852000036],
            [123.98784113600004, 7.935095518000026],
            [124.1016348600001, 7.96445142400006],
            [124.10883464400001, 8.029945532000056],
            [124.19412436100004, 8.021356720000028],
            [124.21396427800005, 8.071286340000029],
            [124.33181769100008, 8.073890680000034],
            [124.36887539100007, 8.156649365000021],
            [124.43501488000004, 8.128414759000066],
        ],
        [
            [124.43501488000004, 8.128414759000066],
            [124.48420959200007, 8.158275346000039],
            [124.53716690600004, 8.090485116000025],
        ],
        [
            [121.22208115400008, 18.500580942000056],
            [121.22654139600002, 18.436471329000028],
            [121.28555701000005, 18.388537952000036],
            [121.48022320600012, 18.30637117400005],
            [121.46035909600005, 18.04941033700004],
            [121.36446941600002, 18.061619119000056],
            [121.34689143800006, 18.03861084700003],
            [121.31511820900005, 17.97078315600004],
            [121.35706746300002, 17.91319670400003],
            [121.30605326800003, 17.815184255000077],
            [121.38829731500005, 17.793630291000056],
            [121.49661415900005, 17.59104271800004],
            [121.61420260300008, 17.560316989000057],
            [121.64723067800003, 17.50048373000004],
            [121.62909621500012, 17.418319980000035],
            [121.60608069200009, 17.42143218600006],
            [121.53017478800007, 17.274919214000022],
            [121.56821946600007, 17.130746136000027],
            [121.56822243500005, 16.909511535000036],
            [121.5213223400001, 16.83893476700007],
            [121.33917264000002, 16.78847038300006],
            [121.28988428800005, 16.657925439000053],
            [121.0721316260001, 16.62783025400006],
            [120.983716533, 16.569470823000074],
            [120.90440899500004, 16.595359904000077],
            [120.889427, 16.436073],
            [120.84552298100004, 16.319500078000033],
            [120.80005260900009, 16.304845744000033],
            [120.76896590800004, 16.198033657000053],
        ],
        [
            [120.76896590800004, 16.198033657000053],
            [120.62923698700001, 16.180376652000064],
        ],
        [
            [120.62923698700001, 16.180376652000064],
            [120.51182322200009, 16.23220132700004],
            [120.49628202200006, 16.34544155100002],
        ],
        [
            [120.49628202200006, 16.34544155100002],
            [120.4446372650001, 16.386976410000045],
            [120.47820839000008, 16.52999621600003],
        ],
        [
            [120.47820839000008, 16.52999621600003],
            [120.59903624900005, 16.738317935000055],
            [120.58601613200005, 16.836661373000027],
            [120.6600777640001, 16.908990164000045],
            [120.78527385300004, 16.92133500700004],
            [120.767612847, 17.066790583000056],
        ],
        [
            [120.767612847, 17.066790583000056],
            [120.81235520500002, 17.155871674000025],
            [120.67213393400004, 17.192852724000034],
            [120.67840099500006, 17.256838869000035],
        ],
        [
            [120.67840099500006, 17.256838869000035],
            [120.53861061300006, 17.343604767000045],
            [120.58889100400006, 17.492162257000075],
            [120.47441593400004, 17.484247811000046],
            [120.46816717700005, 17.51472706000004],
            [120.58279342800006, 17.799097519000043],
            [120.69086868800002, 17.83457964200005],
            [120.83369465900012, 17.95945428300007],
            [120.90997355400009, 17.94992527000005],
        ],
        [
            [120.90997355400009, 17.94992527000005],
            [120.94522217500003, 17.990138341000034],
            [120.92814130400006, 18.088193385000068],
        ],
        [
            [120.92814130400006, 18.088193385000068],
            [120.97006946800002, 18.18186392000007],
            [120.91666636100001, 18.284560256000077],
        ],
        [
            [120.91666636100001, 18.284560256000077],
            [120.95867309800008, 18.463202412000044],
        ],
        [
            [120.95867309800008, 18.463202412000044],
            [121.002873797, 18.46610564300005],
            [121.06136538900012, 18.539197991000037],
            [121.0935009960001, 18.541745912000067],
            [121.08906431300011, 18.49539121400005],
        ],
        [
            [121.08906431300011, 18.49539121400005],
            [121.13578782700006, 18.54380326000006],
            [121.22208115400008, 18.500580942000056],
        ],
        [
            [121.1349717920001, 14.776730445000055],
            [121.10670234300005, 14.675499389000038],
            [121.13503641400007, 14.65766351800005],
        ],
        [
            [121.13503641400007, 14.65766351800005],
            [121.10187866500007, 14.620657343000062],
            [121.10388566000006, 14.516490905000069],
        ],
        [
            [121.10388566000006, 14.516490905000069],
            [121.0621771220001, 14.487713453000026],
            [121.05801511200002, 14.380206515000054],
            [121.01542139300011, 14.351729568000053],
            [120.96595096500005, 14.465177050000023],
            [120.98546445900001, 14.562417100000062],
            [120.93279649300007, 14.602898354000047],
            [120.9604671830001, 14.600846682000054],
            [120.95929464700009, 14.629373004000058],
            [120.90639543200007, 14.700714606000076],
            [120.94533687500007, 14.688489937000043],
        ],
        [
            [120.94533687500007, 14.688489937000043],
            [120.92669637300003, 14.735891321000054],
            [120.98298298400005, 14.725317432000054],
        ],
        [
            [120.98298298400005, 14.725317432000054],
            [121.03841659800003, 14.785247081000023],
            [121.1349717920001, 14.776730445000055],
        ],
        [
            [119.86610479, 15.812580896000043],
            [119.86388672300006, 15.812573862000022],
        ],
        [
            [119.86388672300006, 15.812573862000022],
            [119.8647941810001, 15.814655654000035],
            [119.8659631480001, 15.815394096000034],
            [119.86610479, 15.812580896000043],
        ],
        [
            [119.77832336200004, 15.881815353000036],
            [119.7789765770001, 15.880935429000033],
            [119.77805919000002, 15.880369525000049],
            [119.77719439500004, 15.881463617000065],
            [119.77832336200004, 15.881815353000036],
        ],
        [
            [119.7748779320001, 15.91447017300004],
            [119.77563677600006, 15.913836358000026],
            [119.77526785100008, 15.913505848000057],
            [119.77600454900005, 15.912583337000058],
            [119.77603027600003, 15.91217440400004],
            [119.7743129160001, 15.91364025100006],
            [119.7748779320001, 15.91447017300004],
        ],
        [
            [119.7743820070001, 15.915478350000058],
            [119.7723941590001, 15.91403451800005],
            [119.77108762800003, 15.914657194000029],
            [119.77162948800003, 15.915421367000022],
            [119.7743820070001, 15.915478350000058],
        ],
        [
            [119.80576537800005, 15.92452150400004],
            [119.80593890700004, 15.92441789000003],
            [119.80588349700008, 15.92421665300003],
            [119.80560033900008, 15.924386348000041],
            [119.80576537800005, 15.92452150400004],
        ],
        [
            [120.11673750500006, 16.12250672500005],
            [120.12535627300008, 16.11102107800002],
            [120.11064615200007, 16.10847013700004],
            [120.10970902000008, 16.119219333000046],
            [120.11673750500006, 16.12250672500005],
        ],
        [
            [120.11154068600001, 16.12363888400006],
            [120.11219383800005, 16.12309326600007],
            [120.11134190100006, 16.122561287000053],
            [120.11097272800009, 16.123570682000036],
            [120.11154068600001, 16.12363888400006],
        ],
        [
            [120.0484712110001, 16.183834278000063],
            [120.04833789600002, 16.183978626000055],
            [120.04856264700004, 16.184060164000073],
            [120.0485966650001, 16.183912071000066],
            [120.0484712110001, 16.183834278000063],
        ],
        [
            [120.04967000800002, 16.189266489000033],
            [120.04948890700007, 16.189253993000023],
            [120.04965696200009, 16.18946851900006],
            [120.04972103400007, 16.18943345100007],
            [120.04967000800002, 16.189266489000033],
        ],
        [
            [120.04939092300003, 16.191172934000065],
            [120.04906733700011, 16.190634791000036],
            [120.04815920300007, 16.190487303000054],
            [120.0489910020001, 16.191140012000062],
            [120.04939092300003, 16.191172934000065],
        ],
        [
            [120.04811988100005, 16.192018500000074],
            [120.04797614800009, 16.19216558000005],
            [120.04812240700005, 16.192629528000055],
            [120.04842705300007, 16.192391728000075],
            [120.04811988100005, 16.192018500000074],
        ],
        [
            [120.04591513500009, 16.193134857000075],
            [120.04581489200007, 16.193340969000076],
            [120.0458786800001, 16.193460682000023],
            [120.04601818600008, 16.19332072900005],
            [120.04591513500009, 16.193134857000075],
        ],
        [
            [120.0439636750001, 16.194516295000028],
            [120.04384218500002, 16.194494061000057],
            [120.0439231680001, 16.19468960200004],
            [120.04400649100012, 16.19461407600005],
            [120.0439636750001, 16.194516295000028],
        ],
        [
            [120.03984034900009, 16.19482922000003],
            [120.04056000500009, 16.194617915000038],
            [120.04148044600004, 16.19373217900005],
            [120.0397623990001, 16.19374500500004],
            [120.03984034900009, 16.19482922000003],
        ],
        [
            [120.04670798000006, 16.19560901600005],
            [120.04730256700009, 16.19506197900006],
            [120.04724012300005, 16.194711401000063],
            [120.0461945620001, 16.195036603000062],
            [120.04670798000006, 16.19560901600005],
        ],
        [
            [120.0308345740001, 16.196005978000073],
            [120.03142526800002, 16.194666410000025],
            [120.03489411100009, 16.193625922000024],
            [120.03225360300007, 16.193077823000067],
            [120.02988602200003, 16.194996633000073],
            [120.0308345740001, 16.196005978000073],
        ],
        [
            [120.03244067300011, 16.195123645000024],
            [120.03193243800001, 16.19555780500002],
            [120.03223788900004, 16.196088546000055],
            [120.03277033100005, 16.19562636200004],
            [120.03244067300011, 16.195123645000024],
        ],
        [
            [120.04599846500003, 16.195883706000075],
            [120.04571640300003, 16.196023550000064],
            [120.04564547000007, 16.19637483500003],
            [120.04592025400007, 16.19624373000005],
            [120.04599846500003, 16.195883706000075],
        ],
        [
            [120.04208153600007, 16.196921683000028],
            [120.0434878320001, 16.19667976100004],
            [120.04296557600003, 16.194664110000076],
            [120.03984226200009, 16.19640453200003],
            [120.04208153600007, 16.196921683000028],
        ],
        [
            [120.03921347100004, 16.197540823000054],
            [120.03945024100005, 16.197385132000022],
            [120.03948665500002, 16.197229458000038],
            [120.03916062700011, 16.197281958000076],
            [120.03921347100004, 16.197540823000054],
        ],
        [
            [120.03608500900009, 16.196528381000064],
            [120.03642715700005, 16.19475800400005],
            [120.04003989600005, 16.19208076800004],
            [120.03573965300006, 16.192566726000052],
            [120.03608500900009, 16.196528381000064],
        ],
        [
            [120.04087383500007, 16.198367760000053],
            [120.041238313, 16.197897754000053],
            [120.04114479400005, 16.19764203400007],
            [120.04068383800006, 16.197856242000057],
            [120.04087383500007, 16.198367760000053],
        ],
        [
            [120.04050695100011, 16.198954769000068],
            [120.04062463200012, 16.19890889100003],
            [120.04061837000006, 16.198691378000035],
            [120.04047015900005, 16.19876857400004],
            [120.04050695100011, 16.198954769000068],
        ],
        [
            [120.03757565800004, 16.198282654000025],
            [120.03680763000011, 16.198400244000027],
            [120.03710636900007, 16.19944457400004],
            [120.0376555260001, 16.19919901800006],
            [120.03757565800004, 16.198282654000025],
        ],
        [
            [120.02797507100001, 16.19994674900005],
            [120.02764468700002, 16.19996102600004],
            [120.0275239980001, 16.20009742900004],
            [120.02771022900004, 16.200268058000063],
            [120.02797507100001, 16.19994674900005],
        ],
        [
            [120.03688149300001, 16.199703963000047],
            [120.03680353000004, 16.199103776000072],
            [120.0369829550001, 16.20072080600005],
            [120.03710053400005, 16.20049395500007],
            [120.03688149300001, 16.199703963000047],
        ],
        [
            [120.02933055300002, 16.20068073500005],
            [120.02909845200008, 16.199644397000043],
            [120.02852981800004, 16.19945117800006],
            [120.02888567800005, 16.200663888000065],
            [120.02933055300002, 16.20068073500005],
        ],
        [
            [120.03219503800005, 16.201682341000037],
            [120.03468177500008, 16.200860990000024],
            [120.03413790600007, 16.196329130000038],
            [120.02984887700006, 16.197499167000046],
            [120.03219503800005, 16.201682341000037],
        ],
        [
            [120.03012172600006, 16.201540313000066],
            [120.02938087300004, 16.202184354000053],
            [120.02969344300004, 16.20286131900002],
            [120.03006755700005, 16.20261116100005],
            [120.03012172600006, 16.201540313000066],
        ],
        [
            [120.04956275500001, 16.203330692000065],
            [120.04948869600003, 16.202920129000063],
            [120.0492228490001, 16.202959642000053],
            [120.04923111100004, 16.203235988000074],
            [120.04956275500001, 16.203330692000065],
        ],
        [
            [120.05008354200004, 16.203646449000075],
            [120.04981768400012, 16.203609638000046],
            [120.0502370690001, 16.20395172700006],
            [120.0501739980001, 16.203720130000022],
            [120.05008354200004, 16.203646449000075],
        ],
        [
            [120.0470556780001, 16.20376365100003],
            [120.0467537180001, 16.203918565000038],
            [120.0471243720001, 16.20424475300007],
            [120.04724445400007, 16.20405690800004],
            [120.0470556780001, 16.20376365100003],
        ],
        [
            [120.03097910000008, 16.20515135100004],
            [120.03139183700011, 16.204609179000045],
            [120.03028563900011, 16.20309067100004],
            [120.02995479000003, 16.203890357000034],
            [120.03097910000008, 16.20515135100004],
        ],
        [
            [120.04180457300004, 16.204999],
            [120.04282661600007, 16.204329307000023],
            [120.04247389800003, 16.203218641000035],
            [120.03992945400012, 16.204880772000024],
            [120.04180457300004, 16.204999],
        ],
        [
            [120.04796016700004, 16.205417665000027],
            [120.04744408300007, 16.204670434000036],
            [120.04723550800009, 16.20470124600007],
            [120.0474093140001, 16.205435634000025],
            [120.04796016700004, 16.205417665000027],
        ],
        [
            [120.04968765500007, 16.20628848900003],
            [120.04964877200007, 16.205823872000053],
            [120.04920381000011, 16.20590476600006],
            [120.04933967300008, 16.206286417000058],
            [120.04968765500007, 16.20628848900003],
        ],
        [
            [120.04770532900011, 16.20652322500007],
            [120.0481813130001, 16.20607643200003],
            [120.04812783300008, 16.205691264000052],
            [120.04767324300008, 16.20586843800004],
            [120.04770532900011, 16.20652322500007],
        ],
        [
            [120.03817092500003, 16.205732268000077],
            [120.03919622700005, 16.20498310100004],
            [120.04019219700001, 16.201998614000047],
            [120.03644617500004, 16.205719803000022],
            [120.03736703300001, 16.207681145000038],
            [120.03817092500003, 16.205732268000077],
        ],
        [
            [120.04465705400003, 16.20757653000004],
            [120.04420956800004, 16.20671855200004],
            [120.04382304600006, 16.206492042000036],
            [120.04359212500003, 16.20729564800007],
            [120.04465705400003, 16.20757653000004],
        ],
        [
            [120.04131959200004, 16.208367100000032],
            [120.04135182700008, 16.207384133000062],
            [120.03876435600012, 16.206978993000064],
            [120.03984370400008, 16.207869368000047],
            [120.04131959200004, 16.208367100000032],
        ],
        [
            [120.04830976500011, 16.208503903000064],
            [120.04853535100006, 16.20816082300007],
            [120.04848934000006, 16.20780373300005],
            [120.0481592860001, 16.208080623000058],
            [120.04830976500011, 16.208503903000064],
        ],
        [
            [120.03925798800003, 16.20898702200003],
            [120.0389559350001, 16.208789298000056],
            [120.03860242000007, 16.20885194600004],
            [120.0386985340001, 16.208977179000044],
            [120.03925798800003, 16.20898702200003],
        ],
        [
            [120.047154911, 16.209374652000065],
            [120.04735060900009, 16.208838280000066],
            [120.04688892900003, 16.208612050000056],
            [120.04673693100005, 16.20907909500005],
            [120.047154911, 16.209374652000065],
        ],
        [
            [120.05015742000012, 16.209322993000058],
            [120.04989910000006, 16.20913639500003],
            [120.0498735000001, 16.208957131000034],
            [120.04975844800003, 16.209158514000023],
            [120.05015742000012, 16.209322993000058],
        ],
        [
            [120.05119831600007, 16.209634727000036],
            [120.05136707400004, 16.20944561400006],
            [120.0513082440001, 16.20937440700004],
            [120.05096046900007, 16.209561089000033],
            [120.05119831600007, 16.209634727000036],
        ],
        [
            [120.03398677700011, 16.21009568900007],
            [120.0339819300001, 16.209538923000025],
            [120.03335398800004, 16.209370311000043],
            [120.03360422900005, 16.209880860000055],
            [120.03398677700011, 16.21009568900007],
        ],
        [
            [120.04780658400011, 16.21025036900005],
            [120.04819417300007, 16.210031443000048],
            [120.04793198200002, 16.20964284400003],
            [120.0476051930001, 16.209779672000025],
            [120.04780658400011, 16.21025036900005],
        ],
        [
            [120.04616283100006, 16.21074825000005],
            [120.0458930850001, 16.210543039000072],
            [120.04539945200008, 16.210587074000046],
            [120.04603052900006, 16.210860660000037],
            [120.04616283100006, 16.21074825000005],
        ],
        [
            [120.04651694200004, 16.210898074000056],
            [120.04636919600011, 16.210910195000054],
            [120.04685389100007, 16.211062413000036],
            [120.04677640400007, 16.210958610000034],
            [120.04651694200004, 16.210898074000056],
        ],
        [
            [120.00248604900003, 16.211090013000046],
            [119.99755717300002, 16.20832805200007],
            [119.99414759100011, 16.209602],
            [119.996172741, 16.211001657000054],
            [120.00248604900003, 16.211090013000046],
        ],
        [
            [120.042796382, 16.21121559200003],
            [120.04274670200004, 16.21108840100004],
            [120.04243584200003, 16.211144954000076],
            [120.0426161040001, 16.211250931000052],
            [120.042796382, 16.21121559200003],
        ],
        [
            [120.04735802300002, 16.211450280000065],
            [120.04813320400001, 16.211021550000055],
            [120.04802019400006, 16.210596663000047],
            [120.0470018200001, 16.211061877000077],
            [120.04735802300002, 16.211450280000065],
        ],
        [
            [120.0388060250001, 16.211447581000073],
            [120.0423223140001, 16.211060124000028],
            [120.04326733300002, 16.209571552000057],
            [120.03875122400007, 16.21038644600003],
            [120.0388060250001, 16.211447581000073],
        ],
        [
            [120.05096473900005, 16.211606768000024],
            [120.05070326900011, 16.211493423000036],
            [120.05072863100008, 16.211901049000062],
            [120.05095633500002, 16.21182003200005],
            [120.05096473900005, 16.211606768000024],
        ],
        [
            [120.04739524000001, 16.212228391000053],
            [120.04754437600002, 16.211744232000058],
            [120.04742860200008, 16.211620740000058],
            [120.04699907100007, 16.212082702000032],
            [120.04739524000001, 16.212228391000053],
        ],
        [
            [120.04630348800004, 16.21206414900007],
            [120.0459335810001, 16.211911267000062],
            [120.0458179960001, 16.211940879000053],
            [120.04617767700006, 16.21249333800006],
            [120.04630348800004, 16.21206414900007],
        ],
        [
            [120.03099233600005, 16.213012482000067],
            [120.03096661900008, 16.21268447600005],
            [120.03050125400011, 16.21289371100005],
            [120.03085714200006, 16.21308768800003],
            [120.03099233600005, 16.213012482000067],
        ],
        [
            [120.04867041400007, 16.212845584000036],
            [120.04847030100007, 16.212905888000023],
            [120.04852525400008, 16.213113115000056],
            [120.04875282700004, 16.21295673000003],
            [120.04867041400007, 16.212845584000036],
        ],
        [
            [120.0408178350001, 16.213583630000073],
            [120.04245282700003, 16.21255670200003],
            [120.03854159000002, 16.212825535000036],
            [120.03893032100007, 16.21327558200005],
            [120.0408178350001, 16.213583630000073],
        ],
        [
            [120.0478665930001, 16.213566849000074],
            [120.04817818900005, 16.21303595100005],
            [120.0477108020001, 16.212723976000063],
            [120.04754359700007, 16.21376753100003],
            [120.0478665930001, 16.213566849000074],
        ],
        [
            [120.03530166200005, 16.21410201900005],
            [120.03587824500005, 16.214024290000054],
            [120.03602899000009, 16.21369744800006],
            [120.03517929400005, 16.213715147000073],
            [120.03530166200005, 16.21410201900005],
        ],
        [
            [120.03242178700009, 16.214116226000044],
            [120.03228233800007, 16.21412668800002],
            [120.03232373800006, 16.214223977000074],
            [120.03237821100004, 16.21422816100005],
            [120.03242178700009, 16.214116226000044],
        ],
        [
            [120.03223985000011, 16.214227116000075],
            [120.03220063000003, 16.21423130100004],
            [120.03220716700002, 16.214263730000027],
            [120.03223440300007, 16.214266869000028],
            [120.03223985000011, 16.214227116000075],
        ],
        [
            [120.03226164000012, 16.214277329000026],
            [120.03220716700002, 16.214280468000027],
            [120.03219954100007, 16.214336959000036],
            [120.03225946100008, 16.21433486600006],
            [120.03226164000012, 16.214277329000026],
        ],
        [
            [120.03244140000004, 16.214290928000025],
            [120.03239673100006, 16.21427837500005],
            [120.03237167500004, 16.214354741000022],
            [120.03242614700002, 16.214359973000057],
            [120.03244140000004, 16.214290928000025],
        ],
        [
            [120.04183797200005, 16.213478719000022],
            [120.0420215800001, 16.214542531000063],
            [120.04277961900004, 16.21427880500005],
            [120.04285133000008, 16.213964588000067],
            [120.04183797200005, 16.213478719000022],
        ],
        [
            [120.04414374300006, 16.215637295000022],
            [120.04550380600006, 16.214854383000045],
            [120.04569495100009, 16.21448515800006],
            [120.04403342600006, 16.213918987000056],
            [120.04414374300006, 16.215637295000022],
        ],
        [
            [120.03732603200001, 16.213759089000064],
            [120.0374629800001, 16.212733857000046],
            [120.03687977300001, 16.21029342500003],
            [120.03756908500009, 16.216010048000044],
            [120.03732603200001, 16.213759089000064],
        ],
        [
            [120.04003153100007, 16.215546079000035],
            [120.04011556600005, 16.214729282000064],
            [120.03978929300001, 16.214110896000022],
            [120.03950120800005, 16.216266714000028],
            [120.04003153100007, 16.215546079000035],
        ],
        [
            [120.04348198600007, 16.216410677000056],
            [120.04342154200003, 16.215658851000057],
            [120.04149780000012, 16.214980311000033],
            [120.04130842300003, 16.216335016000073],
            [120.04348198600007, 16.216410677000056],
        ],
        [
            [120.0433259350001, 16.217079713000032],
            [120.0434664820001, 16.216983296000024],
            [120.04328572400004, 16.216610555000045],
            [120.04302805400005, 16.216780894000067],
            [120.0433259350001, 16.217079713000032],
        ],
        [
            [120.03764552700011, 16.218216991000077],
            [120.03793968800005, 16.217956238000056],
            [120.03781813600006, 16.21778310800005],
            [120.03743659800011, 16.217881657000078],
            [120.03764552700011, 16.218216991000077],
        ],
        [
            [120.047721969, 16.21894892100005],
            [120.04840951800008, 16.21899836800003],
            [120.04876156000012, 16.21809435600005],
            [120.04742133600007, 16.218970323000065],
            [120.047721969, 16.21894892100005],
        ],
        [
            [120.05088880400001, 16.220019012000023],
            [120.05144092300009, 16.218978207000077],
            [120.05026889800001, 16.217593773000033],
            [120.05012061900004, 16.218758526000045],
            [120.05088880400001, 16.220019012000023],
        ],
        [
            [120.04973819800011, 16.221411312000043],
            [120.0497712990001, 16.22120740300005],
            [120.04860792600005, 16.220762712000067],
            [120.04917046300011, 16.221382221000056],
            [120.04973819800011, 16.221411312000043],
        ],
        [
            [120.05051932300012, 16.222284513000034],
            [120.05048642400004, 16.221711984000024],
            [120.05001347300004, 16.22166874800007],
            [120.049994104, 16.221965732000058],
            [120.05051932300012, 16.222284513000034],
        ],
        [
            [120.04404911600011, 16.222630767000055],
            [120.0439304570001, 16.22232554200002],
            [120.04339507100008, 16.222465776000035],
            [120.04346504600005, 16.222578227000042],
            [120.04404911600011, 16.222630767000055],
        ],
        [
            [120.04665126600003, 16.222882837000043],
            [120.048012147, 16.222555585000066],
            [120.0460153680001, 16.220835543000078],
            [120.04604929400011, 16.222727769000073],
            [120.04665126600003, 16.222882837000043],
        ],
        [
            [120.0416467010001, 16.22332712800005],
            [120.04183960800003, 16.223301031000062],
            [120.04191024500005, 16.223204500000065],
            [120.04155023300007, 16.22308712100005],
            [120.0416467010001, 16.22332712800005],
        ],
        [
            [120.05441262800002, 16.223473445000025],
            [120.05428886400011, 16.22349621500007],
            [120.0544205440001, 16.223609982000028],
            [120.05445213200005, 16.22351642500007],
            [120.05441262800002, 16.223473445000025],
        ],
        [
            [120.04646851100006, 16.223584780000067],
            [120.04653626700008, 16.22341322500006],
            [120.04624365400002, 16.223105625000073],
            [120.04623132200004, 16.223673532000078],
            [120.04646851100006, 16.223584780000067],
        ],
        [
            [120.052573574, 16.223479062000024],
            [120.05227101300011, 16.223512244000062],
            [120.05215793700006, 16.223713055000076],
            [120.0524138180001, 16.22382633500007],
            [120.052573574, 16.223479062000024],
        ],
        [
            [120.05274577600005, 16.223938863000058],
            [120.05273523800008, 16.223895881000033],
            [120.05249561500011, 16.224004627000056],
            [120.05273525400003, 16.22405264400004],
            [120.05274577600005, 16.223938863000058],
        ],
        [
            [120.05110638500003, 16.222208282000054],
            [120.05061310700012, 16.22263276700005],
            [120.05156360400008, 16.22409613600007],
            [120.05143901400004, 16.222359056000073],
            [120.05110638500003, 16.222208282000054],
        ],
        [
            [120.04201002500008, 16.224224562000074],
            [120.04182894100006, 16.224421362000044],
            [120.04202917200007, 16.22483260300004],
            [120.04215245900002, 16.224568275000024],
            [120.04201002500008, 16.224224562000074],
        ],
        [
            [120.05069611500005, 16.224197847000028],
            [120.05033704800007, 16.224451097000042],
            [120.05057492700007, 16.22509406100005],
            [120.05099588100006, 16.22471258400003],
            [120.05069611500005, 16.224197847000028],
        ],
        [
            [120.04015483400008, 16.225218249000022],
            [120.04038164600001, 16.224782640000058],
            [120.03969888000006, 16.22484583100004],
            [120.03978963100008, 16.22521173100006],
            [120.04015483400008, 16.225218249000022],
        ],
        [
            [120.0525270710001, 16.22482119600005],
            [120.05207834700002, 16.224747516000036],
            [120.05173925000008, 16.224924111000064],
            [120.05258281700003, 16.22527276900007],
            [120.0525270710001, 16.22482119600005],
        ],
        [
            [120.04930874700005, 16.22544833300003],
            [120.04934682100009, 16.22443786100007],
            [120.04917910200004, 16.223971935000066],
            [120.04807875900008, 16.224907478000034],
            [120.04930874700005, 16.22544833300003],
        ],
        [
            [120.0421796380001, 16.225928214000078],
            [120.0422840660001, 16.225686621000023],
            [120.04201108400002, 16.225540771000055],
            [120.04189004200009, 16.225832506000074],
            [120.0421796380001, 16.225928214000078],
        ],
        [
            [120.05064121500004, 16.226311907000024],
            [120.05065739300005, 16.22589881500005],
            [120.04996589600012, 16.226040581000063],
            [120.05004712700008, 16.22630418700004],
            [120.05064121500004, 16.226311907000024],
        ],
        [
            [120.04640200300003, 16.22667659800004],
            [120.04619663900007, 16.226329159000045],
            [120.04583836800009, 16.22634591600007],
            [120.04599969900005, 16.227177186000063],
            [120.04640200300003, 16.22667659800004],
        ],
        [
            [120.04800154600002, 16.22849808500007],
            [120.04722250600003, 16.227303661000064],
            [120.04664790200002, 16.22736722700006],
            [120.0470814570001, 16.22826431900006],
            [120.04800154600002, 16.22849808500007],
        ],
        [
            [120.04898439200008, 16.228670027000078],
            [120.04958844200007, 16.228474508000033],
            [120.0494417220001, 16.227890313000046],
            [120.04902398500008, 16.22794767700003],
            [120.04898439200008, 16.228670027000078],
        ],
        [
            [120.04365110300012, 16.229831094000076],
            [120.043522843, 16.229472315000066],
            [120.04321325900003, 16.229654905000075],
            [120.0435315740001, 16.22999721800005],
            [120.04365110300012, 16.229831094000076],
        ],
        [
            [120.043979766, 16.23173001200007],
            [120.04432228100006, 16.231362946000047],
            [120.0436447410001, 16.230945606000034],
            [120.04384536100008, 16.23178320200003],
            [120.043979766, 16.23173001200007],
        ],
        [
            [120.04790197200009, 16.234094694000078],
            [120.04787354500002, 16.233744024000032],
            [120.04746969300004, 16.233670079000035],
            [120.04753156200002, 16.23403802400003],
            [120.04790197200009, 16.234094694000078],
        ],
        [
            [120.0176444550001, 16.24401481800004],
            [120.0180138500001, 16.243235972000036],
            [120.01770782800008, 16.243063862000042],
            [120.01724608300003, 16.243870523000055],
            [120.0176444550001, 16.24401481800004],
        ],
        [
            [120.01750275400002, 16.245522248000043],
            [120.01783775000001, 16.245370999000045],
            [120.01742851000006, 16.244925945000034],
            [120.01716232400008, 16.24536056900007],
            [120.01750275400002, 16.245522248000043],
        ],
        [
            [120.01781081800004, 16.24610356100004],
            [120.01768043900006, 16.245672415000058],
            [120.01727301000005, 16.245757601000037],
            [120.01764241400008, 16.24655035400002],
            [120.01781081800004, 16.24610356100004],
        ],
        [
            [120.01804721300005, 16.24686845800005],
            [120.0177947740001, 16.246947379000062],
            [120.01797720600007, 16.24738977000004],
            [120.01817954900002, 16.247289699000078],
            [120.01804721300005, 16.24686845800005],
        ],
        [
            [120.01858085000003, 16.247457378000036],
            [120.01839692700003, 16.247574205000035],
            [120.01839401000007, 16.247790688000066],
            [120.01869068700012, 16.247713717000067],
            [120.01858085000003, 16.247457378000036],
        ],
        [
            [120.01887772500004, 16.248220700000047],
            [120.01890730800005, 16.247853243000066],
            [120.01817749400004, 16.248098368000058],
            [120.01842680200002, 16.248460068000043],
            [120.01887772500004, 16.248220700000047],
        ],
        [
            [120.01957983200009, 16.250530449000053],
            [120.01973497000006, 16.25040819000003],
            [120.01949539100008, 16.250248897000063],
            [120.01943224200011, 16.25052011200006],
            [120.01957983200009, 16.250530449000053],
        ],
        [
            [120.01971632300001, 16.25060924400003],
            [120.01941148800006, 16.250615862000075],
            [120.01945285300008, 16.250892468000075],
            [120.01960589300006, 16.250866793000057],
            [120.01971632300001, 16.25060924400003],
        ],
        [
            [120.01800568100009, 16.253323256000044],
            [120.01832915000011, 16.25308164100005],
            [120.01767871000004, 16.253030848000037],
            [120.01780348300008, 16.253301411000052],
            [120.01800568100009, 16.253323256000044],
        ],
        [
            [120.01709231000007, 16.253492065000046],
            [120.01682203500002, 16.253854243000035],
            [120.01703430700002, 16.254091756000037],
            [120.01745342000004, 16.25369518800005],
            [120.01709231000007, 16.253492065000046],
        ],
        [
            [119.92428970100002, 16.267502747000037],
            [119.92505167900003, 16.267026892000047],
            [119.92488905400012, 16.266407921000052],
            [119.9232584660001, 16.267195685000047],
            [119.92428970100002, 16.267502747000037],
        ],
        [
            [119.93716828700008, 16.26853804600006],
            [119.93820281700005, 16.268224192000048],
            [119.93832051000004, 16.267791561000024],
            [119.93611710200003, 16.268200012000023],
            [119.93716828700008, 16.26853804600006],
        ],
        [
            [119.91612729700012, 16.29687896300004],
            [119.91549472400004, 16.29488026300004],
            [119.9155887070001, 16.29891553500005],
            [119.91576842800009, 16.298726979000037],
            [119.91612729700012, 16.29687896300004],
        ],
        [
            [119.92277848100002, 16.313554112000077],
            [119.92373152800008, 16.312804457000027],
            [119.92154395400007, 16.310969928000077],
            [119.92116635800005, 16.312975064000057],
            [119.92277848100002, 16.313554112000077],
        ],
        [
            [119.93262972100001, 16.318446264000045],
            [119.93337480000002, 16.317942569000024],
            [119.93309681100004, 16.31716483100007],
            [119.9322252070001, 16.317393829000025],
            [119.93262972100001, 16.318446264000045],
        ],
        [
            [120.02452714500009, 16.31673019300007],
            [120.025114142, 16.319780124000033],
            [120.02656245000003, 16.320901754000033],
            [120.0249552040001, 16.318278445000033],
            [120.02452714500009, 16.31673019300007],
        ],
        [
            [119.94221287500011, 16.344271626000022],
            [119.94187828800011, 16.344849299000032],
            [119.94234137800004, 16.34607038200005],
            [119.94267908900008, 16.345269677000033],
            [119.94221287500011, 16.344271626000022],
        ],
        [
            [119.94397508300005, 16.346322376000046],
            [119.95073941600003, 16.341954911000073],
            [119.95164736400011, 16.337285489000067],
            [119.94298369600006, 16.340225796000027],
            [119.94397508300005, 16.346322376000046],
        ],
        [
            [119.98987217600006, 16.350072441000066],
            [120.02284019100011, 16.313182665000056],
            [119.9963680400001, 16.21885261400007],
            [119.91745602300011, 16.29866116000005],
            [119.98987217600006, 16.350072441000066],
        ],
        [
            [119.94318057200007, 16.354217823000056],
            [119.94333841100001, 16.35242002700005],
            [119.94075338000005, 16.352868081000054],
            [119.94244983100009, 16.355369747000054],
            [119.94318057200007, 16.354217823000056],
        ],
        [
            [119.9907676250001, 16.363259688000028],
            [119.98892854300004, 16.359490962000052],
            [119.99071176300004, 16.35665812600007],
            [119.99003285100002, 16.355720963000067],
            [119.98644026700003, 16.360881955000025],
            [119.9907676250001, 16.363259688000028],
        ],
        [
            [119.96164107700008, 16.366904685000065],
            [119.96330495500001, 16.361571953000066],
            [119.94728114400004, 16.35073320200007],
            [119.94685318100005, 16.362323297000046],
            [119.96164107700008, 16.366904685000065],
        ],
        [
            [119.93009881500006, 16.372638645000052],
            [119.93056906600009, 16.371937567000032],
            [119.93029408900009, 16.371516029000077],
            [119.92931160400008, 16.371892787000036],
            [119.93009881500006, 16.372638645000052],
        ],
        [
            [119.96213753200004, 16.408385804000034],
            [119.96518060400001, 16.40684727200005],
            [119.96236848300009, 16.404645609000056],
            [119.95980344200007, 16.40793726800007],
            [119.96213753200004, 16.408385804000034],
        ],
        [
            [119.93586639800003, 16.426587562000066],
            [119.96252866200007, 16.403538208000043],
            [119.96164050900006, 16.369525645000067],
            [119.9273905120001, 16.389882062000027],
            [119.9110939520001, 16.385426557000073],
            [119.93586639800003, 16.426587562000066],
        ],
        [
            [119.92354068400005, 16.443564698000046],
            [119.92487268200011, 16.442647470000054],
            [119.92240406300004, 16.439919236000037],
            [119.92173871900002, 16.443138262000048],
            [119.92354068400005, 16.443564698000046],
        ],
        [
            [120.42295124500004, 17.50722084100005],
            [120.40747832600005, 17.488900471000022],
            [120.38765052800011, 17.501410070000077],
            [120.40282397200008, 17.500430823000045],
            [120.42295124500004, 17.50722084100005],
        ],
        [
            [120.40836528500006, 17.512183667000045],
            [120.4143690630001, 17.51159887400007],
            [120.3929636690001, 17.506376455000066],
            [120.39389061800011, 17.50743727100007],
            [120.40836528500006, 17.512183667000045],
        ],
        [
            [120.92814130400006, 18.088193385000068],
            [120.94559264400004, 17.99113452000006],
            [120.90997355400009, 17.94992527000005],
        ],
        [
            [120.67840099500006, 17.256838869000035],
            [120.6916257580001, 17.172729916000037],
            [120.80803980100006, 17.165297140000064],
            [120.767612847, 17.066790583000056],
        ],
        [
            [120.47820839000008, 16.52999621600003],
            [120.44461437400003, 16.38612987700003],
            [120.49628202200006, 16.34544155100002],
        ],
        [
            [120.49628202200006, 16.34544155100002],
            [120.51264871600006, 16.23144790500004],
            [120.62923698700001, 16.180376652000064],
        ],
        [
            [120.62923698700001, 16.180376652000064],
            [120.76891381100006, 16.198050425000076],
            [120.84150888600004, 16.168612326000073],
        ],
        [
            [120.84150888600004, 16.168612326000073],
            [120.92052940700012, 15.966318216000047],
        ],
        [
            [120.92052940700012, 15.966318216000047],
            [120.81905751900001, 15.793215701000065],
            [120.74735183200005, 15.851278652000076],
            [120.6150636640001, 15.815561238000043],
            [120.5900943040001, 15.862431135000065],
            [120.55103785800009, 15.763746918000038],
            [120.46759425200003, 15.722242866000045],
            [120.37859424500004, 15.74830558900004],
            [120.31499980300009, 15.64784824000003],
            [120.25285678300008, 15.617769571000053],
            [120.14561601700007, 15.825531330000047],
            [120.07646877200011, 15.832614756000055],
        ],
        [
            [120.07646877200011, 15.832614756000055],
            [120.03471133200003, 15.874044964000063],
            [119.98300293400007, 15.808030712000061],
            [119.90178234300004, 15.807124243000032],
            [119.88163307600007, 15.814750821000075],
            [119.9093294380001, 15.858320364000065],
            [119.85694013500006, 15.963927752000075],
            [119.77030689900005, 15.917114686000048],
            [119.749719464, 15.96558922500003],
            [119.77457381600004, 16.02359880700004],
            [119.77198796300002, 16.276326768000047],
            [119.81668234300002, 16.360016235000046],
            [119.92501861200003, 16.383584793000068],
            [119.91285025000002, 16.29520606600005],
            [119.91841485300006, 16.247847344000036],
            [119.97705281200001, 16.228443819000063],
            [120.01152278900008, 16.170461604000025],
            [120.04340668200007, 16.19455939200003],
            [120.04351906200009, 16.18899394300007],
            [120.04242930800001, 16.18965839400005],
            [120.04199238400008, 16.18827932800002],
            [120.03901982100001, 16.187389349000057],
            [120.03522854800008, 16.18455868800004],
            [120.03507548900006, 16.183952098000077],
            [120.08797611500006, 16.168018846000052],
            [120.11090133800008, 16.14550543400003],
            [120.08640994200005, 16.14641124800005],
            [120.097100511, 16.065202056000032],
            [120.14214665700001, 16.038067030000036],
            [120.33036472600008, 16.06245843000005],
            [120.42313200600006, 16.162379255000076],
            [120.40133064300005, 16.24905847800005],
            [120.3642511380001, 16.27287592700003],
            [120.37629322400005, 16.238415892000035],
            [120.34229213600008, 16.296604697000078],
            [120.30402566600003, 16.50121718500003],
            [120.31976034800005, 16.575304901000038],
            [120.27787949200001, 16.618356576000053],
            [120.31048716900011, 16.614997077000055],
            [120.33627394700011, 16.67931701200007],
            [120.3349635620001, 16.836049081000056],
            [120.39981216700005, 16.881749352000043],
            [120.4498729720001, 16.998169936000068],
            [120.40438302100006, 17.211027779000062],
            [120.46127535700009, 17.40782160400005],
            [120.43205140000009, 17.450185803000068],
            [120.43569769800001, 17.47981945500004],
            [120.42399672200008, 17.507024451000063],
            [120.4210617980001, 17.508898359000057],
            [120.41593470500004, 17.508121582000058],
            [120.41855334400009, 17.51568426500006],
            [120.3454236560001, 17.560621406000053],
            [120.351893173, 17.68291502900007],
            [120.43616815300004, 17.733837804000075],
            [120.40243276000001, 17.79754809800005],
            [120.45756304500003, 17.82541503400006],
            [120.42925633200002, 17.915851813000074],
            [120.49787879100006, 17.99744534200005],
            [120.4706446460001, 18.086689913000043],
            [120.5947224890001, 18.322683475000076],
            [120.56398582600002, 18.492737007000073],
            [120.62477444600006, 18.545790984000064],
            [120.761300817, 18.539447190000033],
            [120.78296965000004, 18.621965113000044],
            [120.84667757600005, 18.650965169000074],
            [120.90710918000002, 18.565822411000056],
            [120.97645367700011, 18.568958937000048],
            [120.91666636100001, 18.284560256000077],
        ],
        [
            [120.04032569900005, 16.190729781000073],
            [120.03963102600005, 16.190039825000042],
            [120.04020184, 16.189708405000033],
            [120.0408220710001, 16.190198328000065],
            [120.04032569900005, 16.190729781000073],
        ],
        [
            [122.46666630600009, 16.921348420000072],
            [122.46955008500004, 16.920572364000066],
            [122.47057453700006, 16.919156091000048],
            [122.46719337600007, 16.919507272000033],
            [122.46666630600009, 16.921348420000072],
        ],
        [
            [122.46687074400006, 16.923861060000036],
            [122.46702797900002, 16.923161358000073],
            [122.46619406700006, 16.923272501000042],
            [122.46609836300001, 16.923520993000068],
            [122.46687074400006, 16.923861060000036],
        ],
        [
            [122.46784134900008, 16.924214208000024],
            [122.46890766800004, 16.923933040000065],
            [122.46892135600001, 16.923167942000077],
            [122.46723303400006, 16.92315482500004],
            [122.46784134900008, 16.924214208000024],
        ],
        [
            [122.50139055700004, 17.021974734000025],
            [122.50155427200002, 17.02201291500006],
            [122.5018018400001, 17.021942280000076],
            [122.5015103500001, 17.021615833000055],
            [122.50139055700004, 17.021974734000025],
        ],
        [
            [122.50133765500004, 17.022762940000064],
            [122.50133985200011, 17.02264117200002],
            [122.5011620030001, 17.022687360000077],
            [122.5012432420001, 17.02275034400003],
            [122.50133765500004, 17.022762940000064],
        ],
        [
            [122.50104921200011, 17.023457799000028],
            [122.5012848990001, 17.023292536000042],
            [122.5013372740001, 17.023022103000073],
            [122.50087812100003, 17.023300882000058],
            [122.50104921200011, 17.023457799000028],
        ],
        [
            [122.50236102600002, 17.023898620000068],
            [122.50228710700003, 17.02393237700005],
            [122.50235220000002, 17.024051584000063],
            [122.5024018470001, 17.024025210000048],
            [122.50236102600002, 17.023898620000068],
        ],
        [
            [122.50678688000005, 17.03521444300003],
            [122.50840598200011, 17.033923446000074],
            [122.508950292, 17.03145839900003],
            [122.5062325130001, 17.03373682000006],
            [122.50678688000005, 17.03521444300003],
        ],
        [
            [122.50560848900011, 17.03558249100007],
            [122.50548901000002, 17.035152465000067],
            [122.5047157570001, 17.03500309100002],
            [122.50480106400005, 17.035246451000035],
            [122.50560848900011, 17.03558249100007],
        ],
        [
            [122.51094001800004, 17.03861441500004],
            [122.510867716, 17.038645836000057],
            [122.51087691300006, 17.038801688000035],
            [122.5109702520001, 17.038686059000042],
            [122.51094001800004, 17.03861441500004],
        ],
        [
            [122.51204549500005, 17.04391520100006],
            [122.51207921900004, 17.043699143000026],
            [122.51181782300011, 17.04384103600006],
            [122.51180939300002, 17.043911980000075],
            [122.51204549500005, 17.04391520100006],
        ],
        [
            [122.516876324, 17.045985189000078],
            [122.51747192000005, 17.044410423000045],
            [122.51545086800002, 17.04427722400004],
            [122.51642025100011, 17.044479575000025],
            [122.516876324, 17.045985189000078],
        ],
        [
            [122.51113137400012, 17.046786912000073],
            [122.51128825900003, 17.04638748900004],
            [122.51080677000004, 17.045963365000034],
            [122.51072562600007, 17.046625087000052],
            [122.51113137400012, 17.046786912000073],
        ],
        [
            [122.4237675930001, 17.27115868800007],
            [122.42413012000009, 17.270547711000063],
            [122.42360403300006, 17.270072543000026],
            [122.42286473500008, 17.27080572600005],
            [122.4237675930001, 17.27115868800007],
        ],
        [
            [122.4220060780001, 17.274336883000046],
            [122.42203443800008, 17.27303351300003],
            [122.41955963100008, 17.273010918000068],
            [122.42098720500007, 17.274312893000058],
            [122.4220060780001, 17.274336883000046],
        ],
        [
            [122.30773355400004, 17.339222868000036],
            [122.30744406000008, 17.339610651000044],
            [122.30765152900005, 17.339957137000056],
            [122.30779411000003, 17.339726120000023],
            [122.30773355400004, 17.339222868000036],
        ],
        [
            [122.39193923700009, 17.35054505000005],
            [122.39448011800005, 17.345758029000024],
            [122.39021435300003, 17.343678321000027],
            [122.38867395800003, 17.349337621000075],
            [122.39193923700009, 17.35054505000005],
        ],
        [
            [122.36730601900001, 17.362888268000063],
            [122.36810713900002, 17.35744642900005],
            [122.36283298600006, 17.35593947900003],
            [122.36491618100001, 17.36184748000005],
            [122.36730601900001, 17.362888268000063],
        ],
        [
            [122.32753657600006, 18.24593611800003],
            [122.32536259000005, 18.24731505400007],
            [122.32932959200002, 18.248056981000047],
            [122.32970358300008, 18.24702503800006],
            [122.32753657600006, 18.24593611800003],
        ],
        [
            [122.33540926, 18.282325978000074],
            [122.33541378600012, 18.28174815400007],
            [122.33362032200012, 18.281622350000077],
            [122.33431520300007, 18.282164987000044],
            [122.33540926, 18.282325978000074],
        ],
        [
            [122.31430312000009, 18.38734088600006],
            [122.31475242300007, 18.386200315000053],
            [122.31301656500011, 18.38640338600004],
            [122.3135940200001, 18.387395368000057],
            [122.31430312000009, 18.38734088600006],
        ],
        [
            [122.31353569300006, 18.39027870900003],
            [122.31376944400006, 18.38870526100004],
            [122.31145733700009, 18.38943864500004],
            [122.3123715590001, 18.389926565000053],
            [122.31353569300006, 18.39027870900003],
        ],
        [
            [122.3093144400001, 18.395740111000066],
            [122.3112463220001, 18.394991984000058],
            [122.31355497200002, 18.390591017000077],
            [122.30965468300008, 18.390736177000065],
            [122.3093144400001, 18.395740111000066],
        ],
        [
            [122.13239840400001, 18.511812821000035],
            [122.13688716500008, 18.508962799000074],
            [122.13404231600009, 18.503222969000035],
            [122.13107202700007, 18.508013531000074],
            [122.13239840400001, 18.511812821000035],
        ],
        [
            [122.19706116900011, 18.513925533000076],
            [122.19692960600003, 18.513991474000022],
            [122.1971131570001, 18.514579121000054],
            [122.19741981200002, 18.514302929000053],
            [122.19706116900011, 18.513925533000076],
        ],
        [
            [122.190509, 18.515180718000067],
            [122.19026834700003, 18.51484236500005],
            [122.18995853100012, 18.514991226000063],
            [122.19003333900002, 18.515180574000055],
            [122.190509, 18.515180718000067],
        ],
        [
            [122.20169342000008, 18.514905562000024],
            [122.2022742900001, 18.514648968000074],
            [122.20252330100004, 18.514299120000032],
            [122.2010363280001, 18.514435410000033],
            [122.20092688000011, 18.515431269000032],
            [122.20169342000008, 18.514905562000024],
        ],
        [
            [122.18658336700003, 18.52114540100007],
            [122.18688169400002, 18.520398813000043],
            [122.18678246800005, 18.520042885000066],
            [122.1862281870001, 18.521371875000057],
            [122.18658336700003, 18.52114540100007],
        ],
        [
            [122.15833953000003, 18.525891288000025],
            [122.15776449100008, 18.52523046400006],
            [122.15727665000009, 18.525808736000045],
            [122.15795291300003, 18.526308577000066],
            [122.15833953000003, 18.525891288000025],
        ],
        [
            [122.15973390400006, 18.525315651000028],
            [122.15897379500007, 18.524955594000062],
            [122.15890421000006, 18.526640774000043],
            [122.1597112720001, 18.526560438000047],
            [122.15973390400006, 18.525315651000028],
        ],
        [
            [122.15833069100006, 18.528167344000053],
            [122.15738830600003, 18.527169537000077],
            [122.1577339590001, 18.528996621000033],
            [122.15833069100006, 18.528167344000053],
        ],
        [
            [122.1550803780001, 18.546540802000038],
            [122.15514021800004, 18.546243729000025],
            [122.15476900100009, 18.54626458000007],
            [122.15485085700004, 18.54650865900004],
            [122.1550803780001, 18.546540802000038],
        ],
        [
            [122.17757831800009, 18.54965349500003],
            [122.17673922300003, 18.54965362300004],
            [122.17747025400001, 18.550833915000055],
            [122.17782212500003, 18.550782538000078],
            [122.17757831800009, 18.54965349500003],
        ],
        [
            [122.1808062550001, 18.550436709000053],
            [122.18040959900009, 18.550386639000067],
            [122.18004832100007, 18.550980005000042],
            [122.18070060700006, 18.551080171000024],
            [122.1808062550001, 18.550436709000053],
        ],
        [
            [122.17856313200002, 18.55092404100003],
            [122.17786735100003, 18.550431195000044],
            [122.17801230500004, 18.55135890400004],
            [122.17856313200002, 18.55092404100003],
        ],
        [
            [122.111174473, 18.55766942100007],
            [122.11107953400005, 18.557736904000024],
            [122.1113010040001, 18.557965667000076],
            [122.11136035700008, 18.557819434000066],
            [122.111174473, 18.55766942100007],
        ],
        [
            [122.11249183200005, 18.562371967000047],
            [122.11259074600002, 18.562173243000075],
            [122.11224658700007, 18.56239068600007],
            [122.11238105900009, 18.562506945000052],
            [122.11249183200005, 18.562371967000047],
        ],
        [
            [122.1132670510001, 18.56278810400005],
            [122.11321015200008, 18.56237193000004],
            [122.11285745900011, 18.562558093000064],
            [122.11305058700009, 18.56301972500006],
            [122.1132670510001, 18.56278810400005],
        ],
        [
            [122.16528320300006, 18.572692871000072],
            [122.16467285100009, 18.572509766000053],
            [122.16491699200003, 18.573486329000048],
            [122.165527343, 18.57330322300004],
            [122.16528320300006, 18.572692871000072],
        ],
        [
            [122.13345586200012, 18.581714198000043],
            [122.15698081200003, 18.579808435000075],
            [122.15302455000005, 18.52262070100005],
            [122.1334235710001, 18.518662618000064],
            [122.115325331, 18.500811859000066],
            [122.13345586200012, 18.581714198000043],
        ],
        [
            [122.1485835950001, 18.529276982000056],
            [122.14841875700006, 18.529688780000072],
            [122.14833418500007, 18.529664856000068],
            [122.14826594500005, 18.529068727000038],
            [122.1485835950001, 18.529276982000056],
        ],
        [
            [122.16949462900004, 18.58392334000007],
            [122.16912841700002, 18.583496094000054],
            [122.16870117200006, 18.583679200000063],
            [122.16888427700007, 18.58447265600006],
            [122.16949462900004, 18.58392334000007],
        ],
        [
            [122.13728673800006, 18.587349637000045],
            [122.13892383000007, 18.58646000500005],
            [122.13869988700003, 18.584984873000053],
            [122.13765924400002, 18.585254097000075],
            [122.13728673800006, 18.587349637000045],
        ],
        [
            [122.1379320750001, 18.59009578100006],
            [122.137567106, 18.589839183000038],
            [122.13750959300012, 18.590538868000067],
            [122.13781720200006, 18.590398967000056],
            [122.1379320750001, 18.59009578100006],
        ],
        [
            [122.13821371400002, 18.590761818000033],
            [122.13828489200012, 18.59076932200003],
            [122.13838970100005, 18.590625035000073],
            [122.13820780000003, 18.590632509000045],
            [122.13821371400002, 18.590761818000033],
        ],
        [
            [122.16870117200006, 18.589721680000025],
            [122.16790771500007, 18.590270996000072],
            [122.1682739260001, 18.59088134800004],
            [122.16870117200006, 18.590270996000072],
            [122.16870117200006, 18.589721680000025],
        ],
        [
            [122.1392912440001, 18.59107490300005],
            [122.13949095600003, 18.59093999600003],
            [122.13943561400004, 18.59079569100004],
            [122.13917262300004, 18.590979314000037],
            [122.1392912440001, 18.59107490300005],
        ],
        [
            [122.14073656100004, 18.592709684000056],
            [122.14192602500009, 18.591325054000038],
            [122.14119000700009, 18.589875122000024],
            [122.13805880200005, 18.589298292000024],
            [122.14087331600001, 18.591084270000067],
            [122.14073656100004, 18.592709684000056],
        ],
        [
            [122.05880819100003, 16.50925477800007],
            [121.84589590900009, 16.249155589000054],
            [121.46354426900007, 15.926616156000023],
            [121.47114962, 15.886741050000069],
            [121.31660385400005, 15.804170806000059],
            [121.28476349300001, 15.75441853700005],
            [121.19399818500005, 15.922087606000048],
        ],
        [
            [121.19399818500005, 15.922087606000048],
            [121.17424918400002, 16.090108902000054],
            [121.04773934000002, 16.137989391000076],
        ],
        [
            [121.04773934000002, 16.137989391000076],
            [120.87044651800011, 16.118870179000055],
        ],
        [
            [120.87044651800011, 16.118870179000055],
            [120.84150888600004, 16.168612326000073],
        ],
        [
            [120.84150888600004, 16.168612326000073],
            [120.76896590800004, 16.198033657000053],
        ],
        [
            [121.22208115400008, 18.500580942000056],
            [121.15600338400009, 18.54377499800006],
            [121.11848091500008, 18.54311065400003],
            [121.08906431300011, 18.49539121400005],
        ],
        [
            [120.95867309800008, 18.463202412000044],
            [120.9835647750001, 18.593782429000044],
            [121.12411076400008, 18.628677862000075],
            [121.6215175860001, 18.35134620900004],
            [121.9028313230001, 18.26572081100005],
            [122.01112034500011, 18.287867860000063],
            [122.12768463700002, 18.38083504800005],
            [122.14913526600003, 18.510599324000054],
            [122.237064056, 18.514806126000053],
            [122.33762092300003, 18.309250727000062],
            [122.30290430500008, 18.219388010000046],
            [122.16749598500007, 18.086634737000054],
            [122.19064936100006, 17.917885927000043],
            [122.13686809600006, 17.793759050000062],
            [122.16348324800003, 17.610620805000053],
            [122.24667340000008, 17.364629184000023],
            [122.29483541600007, 17.333676824000065],
            [122.3734178090001, 17.352744434000044],
            [122.39952495600005, 17.28969369600003],
            [122.39329639000005, 17.340982765000035],
            [122.40758161000008, 17.333176841000068],
            [122.44369316000007, 17.263802671000064],
            [122.44046220100006, 17.24132663100005],
            [122.42840833100001, 17.28202768400007],
            [122.41250192900009, 17.275081423000074],
            [122.41739599200002, 17.13998496000005],
            [122.4715508910001, 17.122578774000033],
            [122.44231337200006, 17.120435514000064],
            [122.44712671600007, 17.101911057000052],
            [122.50986301400008, 17.142289332000075],
            [122.52852482800006, 17.098073122000073],
            [122.46666246600012, 16.97672328500005],
            [122.43460964600001, 16.797859368000047],
            [122.27939556000001, 16.526350963000027],
            [122.21427288000007, 16.479844291000063],
            [122.05880819100003, 16.50925477800007],
        ],
        [
            [122.38474196400011, 17.316295473000025],
            [122.38332938500002, 17.315639607000037],
            [122.38321884100003, 17.31463051000003],
            [122.38478992400007, 17.314589166000076],
            [122.38474196400011, 17.316295473000025],
        ],
        [
            [122.1955365870001, 18.512120883000023],
            [122.19526674500003, 18.51207501700003],
            [122.195515494, 18.51143266100007],
            [122.19582493500002, 18.512022646000048],
            [122.1955365870001, 18.512120883000023],
        ],
        [
            [122.197718269, 18.51271999100004],
            [122.19725733900009, 18.512236706000067],
            [122.19754965300001, 18.51187336600003],
            [122.19783737900002, 18.512135213000022],
            [122.197718269, 18.51271999100004],
        ],
        [
            [121.25265585500006, 18.875714765000055],
            [121.26420320600005, 18.867774091000058],
            [121.25640180000005, 18.853508659000056],
            [121.24224646500011, 18.859511809000026],
            [121.25265585500006, 18.875714765000055],
        ],
        [
            [121.822408558, 18.876891320000027],
            [121.82447698900012, 18.873552553000025],
            [121.82433928000012, 18.872769891000075],
            [121.82194363300005, 18.87517920500005],
            [121.822408558, 18.876891320000027],
        ],
        [
            [121.25255778500002, 18.88891975100006],
            [121.26853499100002, 18.884226530000035],
            [121.26961737600004, 18.880590432000076],
            [121.26446801600002, 18.877485900000067],
            [121.25255778500002, 18.88891975100006],
        ],
        [
            [121.41474585900005, 18.90582760700005],
            [121.48191962300007, 18.87649338700004],
            [121.3456867330001, 18.841541815000028],
            [121.27515030400002, 18.857614503000036],
            [121.284627139, 18.88468141800007],
            [121.41474585900005, 18.90582760700005],
        ],
        [
            [121.83403788900011, 18.90756016000006],
            [121.83876219500007, 18.90471100900004],
            [121.83863134400008, 18.896488883000075],
            [121.83017521700003, 18.903653613000074],
            [121.83403788900011, 18.90756016000006],
        ],
        [
            [121.21868204800012, 18.98688670100006],
            [121.2179323800001, 18.98198883400005],
            [121.213851943, 18.98028300800007],
            [121.21386981800003, 18.98246354400004],
            [121.21868204800012, 18.98688670100006],
        ],
        [
            [121.91774692900003, 19.00351504300005],
            [121.98898475800002, 18.942674100000033],
            [121.85241784800007, 18.812880848000077],
            [121.82765646000007, 18.87492978800003],
            [121.86440475100005, 18.88229844600005],
            [121.86656880300006, 18.97395436900007],
            [121.91774692900003, 19.00351504300005],
        ],
        [
            [121.21789591400011, 19.171320620000074],
            [121.24776716400004, 19.104926773000045],
            [121.24860183300007, 19.012878562000026],
            [121.1967146510001, 19.06728430900006],
            [121.21789591400011, 19.171320620000074],
        ],
        [
            [121.40700169100012, 19.393310426000028],
            [121.48807760900002, 19.36708804600005],
            [121.52405156800012, 19.38790537400007],
            [121.53896633700003, 19.267341077000026],
            [121.5115129300001, 19.244146181000076],
            [121.40277740200008, 19.283181864000028],
            [121.34653265300005, 19.357380531000047],
            [121.40700169100012, 19.393310426000028],
        ],
        [
            [121.3880810710001, 19.322464426000067],
            [121.38781570600008, 19.321952086000067],
            [121.38816428200005, 19.32176282300003],
            [121.38846049200004, 19.322225670000023],
            [121.3880810710001, 19.322464426000067],
        ],
        [
            [121.50912406000009, 19.44732815900005],
            [121.51532178200011, 19.44059534200005],
            [121.51465047900001, 19.423449693000066],
            [121.50462890800009, 19.43572593700003],
            [121.50912406000009, 19.44732815900005],
        ],
        [
            [121.96981482700005, 19.573752417000037],
            [121.99415670600001, 19.512952416000076],
            [121.95936440100002, 19.47580261400003],
            [121.89298309700007, 19.545112396000036],
            [121.96981482700005, 19.573752417000037],
        ],
        [
            [121.80941423100012, 20.336653299000034],
            [121.81960547100005, 20.325700495000035],
            [121.80672786000002, 20.29904337100004],
            [121.79814524900007, 20.314279894000038],
            [121.80941423100012, 20.336653299000034],
        ],
        [
            [121.78282914200008, 20.338509002000023],
            [121.7911489390001, 20.332596413000033],
            [121.78966128900004, 20.32878228800007],
            [121.77920597600007, 20.333519076000073],
            [121.78282914200008, 20.338509002000023],
        ],
        [
            [121.84473327, 20.355984787000068],
            [121.88928427200005, 20.31316702500004],
            [121.86284234000004, 20.260625272000027],
            [121.84050524700001, 20.28722706600007],
            [121.84473327, 20.355984787000068],
        ],
        [
            [121.9839031460001, 20.42139532300007],
            [121.98311714700003, 20.42155932000003],
            [121.98323215200003, 20.42198129700006],
            [121.98460514800001, 20.421668302000057],
            [121.9839031460001, 20.42139532300007],
        ],
        [
            [121.9839577460001, 20.422844621000024],
            [121.98298874400007, 20.422585642000058],
            [121.98249274800003, 20.42296662600006],
            [121.98309575300004, 20.423378599000046],
            [121.9839577460001, 20.422844621000024],
        ],
        [
            [121.98648370700005, 20.423547382000038],
            [121.98578471500002, 20.423160076000045],
            [121.98546471800012, 20.423523059000047],
            [121.98582372300007, 20.42399603000007],
            [121.98648370700005, 20.423547382000038],
        ],
        [
            [121.98428020400002, 20.42495041500007],
            [121.98380193300011, 20.42511816700005],
            [121.98376267100002, 20.425300196000023],
            [121.984023223, 20.425357303000055],
            [121.98428020400002, 20.42495041500007],
        ],
        [
            [121.98742114700008, 20.426834989000042],
            [121.98715684900003, 20.426780479000058],
            [121.9867408450001, 20.427006309000035],
            [121.98709072100007, 20.427109],
            [121.98742114700008, 20.426834989000042],
        ],
        [
            [122.00281302700012, 20.489435999000023],
            [122.03521826700012, 20.46452759300007],
            [121.96239566600002, 20.41258308700003],
            [121.97178541700009, 20.366555430000062],
            [121.91494288600006, 20.347475033000023],
            [121.95724084100004, 20.46961568300003],
            [122.00281302700012, 20.489435999000023],
        ],
        [
            [121.9382218070001, 20.69659405400006],
            [121.9380641680001, 20.696412621000036],
            [121.93777863200012, 20.69656728600006],
            [121.93800170600002, 20.696707079000078],
            [121.9382218070001, 20.69659405400006],
        ],
        [
            [121.93736347600009, 20.697032381000042],
            [121.93717882900012, 20.697262713000043],
            [121.93750053300005, 20.697428323000054],
            [121.93756906100009, 20.697207510000055],
            [121.93736347600009, 20.697032381000042],
        ],
        [
            [121.94332865700005, 20.700232493000044],
            [121.94268154300005, 20.699637910000035],
            [121.94266430100004, 20.698168464000048],
            [121.9418487260001, 20.699247006000064],
            [121.94332865700005, 20.700232493000044],
        ],
        [
            [121.92460187000006, 20.709177858000032],
            [121.92351949300007, 20.709268647000044],
            [121.92340133200003, 20.71047736500003],
            [121.92464199100004, 20.709808659000032],
            [121.92460187000006, 20.709177858000032],
        ],
        [
            [121.94254314600005, 20.710102850000055],
            [121.94199349000007, 20.710224202000063],
            [121.94185072300002, 20.710588260000065],
            [121.94277157500005, 20.710381247000043],
            [121.94254314600005, 20.710102850000055],
        ],
        [
            [121.93317627400006, 20.712346409000077],
            [121.93516998500002, 20.698292190000075],
            [121.92118403900008, 20.70026007200005],
            [121.9251460160001, 20.709288842000035],
            [121.93317627400006, 20.712346409000077],
        ],
        [
            [121.93349993900006, 20.71365215900005],
            [121.93426511900009, 20.713908424000067],
            [121.93454692400007, 20.713615546000028],
            [121.93313594200004, 20.71312131800005],
            [121.93286196000008, 20.714060354000026],
            [121.93349993900006, 20.71365215900005],
        ],
        [
            [121.85145731000011, 20.719783042000074],
            [121.85125470000003, 20.71996503300005],
            [121.85128058300006, 20.72024553400007],
            [121.85142160800001, 20.720097770000052],
            [121.85145731000011, 20.719783042000074],
        ],
        [
            [121.86002349600005, 20.836194656000032],
            [121.87649312200006, 20.758629082000027],
            [121.79957186400009, 20.68873165100007],
            [121.78272710300007, 20.72158550100005],
            [121.86002349600005, 20.836194656000032],
        ],
        [
            [121.91108293900004, 20.89819580300008],
            [121.91156003700007, 20.897793767000053],
            [121.91055901700008, 20.897120878000067],
            [121.91014743500011, 20.898108446000037],
            [121.91108293900004, 20.89819580300008],
        ],
        [
            [121.90139605400009, 20.90902865000004],
            [121.9078453190001, 20.905164210000066],
            [121.9033948440001, 20.89885080700003],
            [121.89856120200011, 20.900771588000055],
            [121.90139605400009, 20.90902865000004],
        ],
        [
            [121.90902334000009, 20.92087658300005],
            [121.90902333500003, 20.92061644300003],
            [121.90814687600005, 20.920650890000047],
            [121.90883905600003, 20.921553716000062],
            [121.90902334000009, 20.92087658300005],
        ],
        [
            [121.9078838690001, 20.92429575600005],
            [121.9073268300001, 20.92517509100003],
            [121.90894761800007, 20.926699624000037],
            [121.90875449400005, 20.925232349000055],
            [121.9078838690001, 20.92429575600005],
        ],
        [
            [121.92018209200012, 20.93557757600007],
            [121.9303341320001, 20.926201693000053],
            [121.93202777800002, 20.92179906000007],
            [121.91356943700009, 20.93020542100004],
            [121.92018209200012, 20.93557757600007],
        ],
        [
            [121.93465625500005, 21.06959503300004],
            [121.93543371400006, 21.062492105000047],
            [121.92761921100009, 21.06197194300006],
            [121.92800343100009, 21.065834451000057],
            [121.93465625500005, 21.06959503300004],
        ],
        [
            [121.94566696200002, 21.121755276000044],
            [121.95561915600001, 21.113598353000043],
            [121.9488878410001, 21.102982182000062],
            [121.94645547700009, 21.110459431000038],
            [121.94566696200002, 21.121755276000044],
        ],
        [
            [120.11686801200005, 14.763089660000048],
            [120.11855632600009, 14.761547782000036],
            [120.1141188690001, 14.76173039200006],
            [120.1144169800001, 14.76327410500005],
            [120.11686801200005, 14.763089660000048],
        ],
        [
            [120.22594739800002, 14.764984253000023],
            [120.22585994000008, 14.763970699000026],
            [120.2250469820001, 14.762907598000027],
            [120.22444799300001, 14.763678199000026],
            [120.22594739800002, 14.764984253000023],
        ],
        [
            [120.10269233400004, 14.768858092000073],
            [120.11081216500008, 14.76642212300004],
            [120.11431105300005, 14.76394392800006],
            [120.1036466700001, 14.757284063000043],
            [120.10269233400004, 14.768858092000073],
        ],
        [
            [120.22398855900008, 14.775514972000053],
            [120.22968052200008, 14.774055774000033],
            [120.23025698000004, 14.769814586000052],
            [120.224058119, 14.76838458800006],
            [120.22398855900008, 14.775514972000053],
        ],
        [
            [120.23458587300001, 14.832553786000062],
            [120.23500773800004, 14.832084051000038],
            [120.23458796200009, 14.831570890000023],
            [120.23401052600002, 14.832387788000062],
            [120.23458587300001, 14.832553786000062],
        ],
        [
            [120.23247823800011, 14.85601738300005],
            [120.23212986400006, 14.851969964000034],
            [120.23362808400009, 14.851069581000047],
            [120.23097307500007, 14.851685329000077],
            [120.23040732600009, 14.85391284900004],
            [120.23247823800011, 14.85601738300005],
        ],
        [
            [119.89875117600002, 15.496401053000056],
            [119.899860106, 15.494025183000076],
            [119.89199386700011, 15.490705947000038],
            [119.89300196800002, 15.497988410000062],
            [119.89875117600002, 15.496401053000056],
        ],
        [
            [119.92429243900006, 15.52948652200007],
            [119.93118838300006, 15.524471695000045],
            [119.90748610600008, 15.508152923000068],
            [119.90469960100006, 15.528027104000046],
            [119.92429243900006, 15.52948652200007],
        ],
        [
            [119.82683722900003, 15.741964443000029],
            [119.83305001500003, 15.740261813000075],
            [119.820435255, 15.72897172300003],
            [119.82067338400009, 15.738453101000061],
            [119.82683722900003, 15.741964443000029],
        ],
        [
            [119.78803981300007, 15.811973864000038],
            [119.80520883600002, 15.804525803000047],
            [119.79445039600012, 15.777968250000072],
            [119.7885690380001, 15.784278033000078],
            [119.78803981300007, 15.811973864000038],
        ],
        [
            [119.86610479, 15.812580896000043],
            [119.86503552900001, 15.811371129000065],
            [119.86469575800004, 15.811204190000069],
            [119.86388672300006, 15.812573862000022],
        ],
        [
            [122.13135940000006, 16.258959477000076],
            [122.13271736800004, 16.25605604900005],
            [122.13134911100008, 16.25433141900004],
            [122.13039068800003, 16.25864340000004],
            [122.13135940000006, 16.258959477000076],
        ],
        [
            [122.20820027700006, 16.26463964100003],
            [122.207922241, 16.264909596000052],
            [122.20810111600008, 16.26538350100003],
            [122.20842111200011, 16.265033138000035],
            [122.20820027700006, 16.26463964100003],
        ],
        [
            [122.20908998400012, 16.26560203300005],
            [122.20945540200012, 16.265269545000024],
            [122.20912493800006, 16.26482419200005],
            [122.20873092300008, 16.265412910000066],
            [122.20908998400012, 16.26560203300005],
        ],
        [
            [122.23724696400006, 16.312613615000032],
            [122.2382574290001, 16.311946479000028],
            [122.23464676100002, 16.31045785500004],
            [122.23656472800008, 16.312341831000026],
            [122.23724696400006, 16.312613615000032],
        ],
        [
            [121.4171205020001, 15.216888696000069],
            [121.38046702200006, 15.168480773000056],
            [121.39541639100003, 15.104844096000022],
            [121.34476914000004, 15.040210904000048],
        ],
        [
            [121.34476914000004, 15.040210904000048],
            [121.33073668700001, 14.835204220000037],
            [121.16528463600002, 14.823417534000043],
        ],
        [
            [121.16528463600002, 14.823417534000043],
            [121.0914569040001, 14.767226754000035],
            [121.03060207100009, 14.784248399000035],
            [120.98298298400005, 14.725317432000054],
        ],
        [
            [120.94533687500007, 14.688489937000043],
            [120.86050778100002, 14.722449031000053],
            [120.8189455690001, 14.777901136000025],
            [120.80141902000003, 14.754859574000022],
            [120.651980965, 14.767892699000072],
            [120.57010409800012, 14.848579843000039],
            [120.58481444900008, 14.821525265000048],
            [120.58082184400007, 14.814151095000057],
            [120.53865809700005, 14.809313932000066],
            [120.54535757000008, 14.720876807000025],
            [120.61505819700005, 14.47966724500003],
            [120.57082479900009, 14.425364411000032],
            [120.48638082800005, 14.43344234600005],
            [120.49805247000006, 14.407525703000033],
            [120.38916306400006, 14.458738967000045],
            [120.3927709620001, 14.588010925000049],
            [120.24819656700004, 14.692123213000059],
            [120.27957336200006, 14.735986058000037],
            [120.24182201800011, 14.761394883000037],
            [120.29775314800008, 14.817252032000056],
            [120.22305702500012, 14.87799620800007],
            [120.17799889200012, 14.740767637000033],
            [120.08339710900009, 14.786804799000038],
            [120.10934331500005, 14.817475497000032],
            [120.08006060500009, 14.814417026000058],
            [120.05347957000004, 14.887076620000073],
            [120.05930491000004, 15.064894112000047],
            [120.01570831600009, 15.266141874000027],
            [119.89007786000002, 15.431047498000055],
            [119.91854115100011, 15.448509676000072],
            [119.90295717300012, 15.491807336000022],
            [119.9423159690001, 15.477655728000059],
            [119.9687055490001, 15.50635701300007],
            [119.90351894700007, 15.621943934000058],
            [119.93353407300003, 15.69270836000004],
            [119.86938103900002, 15.733476014000075],
            [119.91115541600004, 15.759198930000025],
            [119.88567664400011, 15.811170954000033],
            [119.9819645440001, 15.807559754000067],
            [120.03641615200002, 15.874149902000056],
            [120.07646877200011, 15.832614756000055],
        ],
        [
            [120.92052940700012, 15.966318216000047],
            [120.87044651800011, 16.118870179000055],
        ],
        [
            [121.04773934000002, 16.137989391000076],
            [121.18248110400009, 16.079479501000037],
            [121.19399818500005, 15.922087606000048],
        ],
        [
            [122.05880819100003, 16.50925477800007],
            [122.11920472500003, 16.49782908700007],
            [122.23417917900008, 16.487238956000056],
            [122.19930659600004, 16.433408903000043],
            [122.22114622100003, 16.39486697700005],
            [122.23782144300003, 16.428502362000074],
            [122.24297540200007, 16.421148129000073],
            [122.22985672100003, 16.366321003000053],
            [122.17986272600001, 16.302900863000048],
            [122.23555867300001, 16.309770167000067],
            [122.0491422020001, 16.06556464700003],
            [121.98893589300008, 16.02915378700004],
            [122.12949300100001, 16.22560919700004],
            [122.13984762000007, 16.255127465000044],
            [122.13151345300003, 16.26133108500005],
            [122.0704071890001, 16.24121973000007],
            [122.07878979600002, 16.189755958000035],
            [121.74347405500009, 16.069732224000063],
            [121.55509348900011, 15.899520266000025],
            [121.561348382, 15.775046018000069],
            [121.63510249400008, 15.751572512000052],
            [121.63930240800005, 15.704980272000057],
            [121.61029250800004, 15.706981607000046],
            [121.58806595600004, 15.672570367000048],
            [121.61620934700011, 15.647771480000074],
            [121.49385778600004, 15.52388989900004],
            [121.48412245000009, 15.428910406000057],
            [121.373935931, 15.337117804000059],
            [121.4171205020001, 15.216888696000069],
        ],
        [
            [121.59519941700012, 15.632490423000036],
            [121.59256301100004, 15.631938493000064],
            [121.59189799300009, 15.630713178000065],
            [121.59488323700009, 15.63042260800006],
            [121.59519941700012, 15.632490423000036],
        ],
        [
            [122.7216452990001, 13.36484783900005],
            [122.72540942900002, 13.331003800000076],
            [122.71919811700002, 13.323537565000038],
            [122.71316912100008, 13.344623257000023],
            [122.7216452990001, 13.36484783900005],
        ],
        [
            [121.08896686700007, 13.569401490000075],
            [121.08033677600008, 13.526216527000031],
            [121.04241371700004, 13.570844325000053],
            [121.06043150200003, 13.562763894000057],
            [121.08896686700007, 13.569401490000075],
        ],
        [
            [120.9665497740001, 13.626597248000053],
            [120.96535921200007, 13.626641089000032],
            [120.96359351700005, 13.628071556000066],
            [120.96660156100006, 13.626757344000055],
            [120.9665497740001, 13.626597248000053],
        ],
        [
            [120.94929417300011, 13.631112452000025],
            [120.95160493100002, 13.629888949000076],
            [120.95192744300005, 13.628848359000074],
            [120.94798711900012, 13.629531846000077],
            [120.94929417300011, 13.631112452000025],
        ],
        [
            [120.83115867100003, 13.687686794000058],
            [120.84090173800007, 13.672426964000067],
            [120.88492621700004, 13.65488741200005],
            [120.93407597600003, 13.655353820000073],
            [120.94646802900002, 13.638114896000047],
            [120.87260698000011, 13.634652058000029],
            [120.84196022700007, 13.651250004000076],
            [120.83115867100003, 13.687686794000058],
        ],
        [
            [120.84255816200005, 13.691783431000033],
            [120.84424933200012, 13.68118656300004],
            [120.84275075000005, 13.67419097800007],
            [120.84045105000007, 13.680525471000067],
            [120.84255816200005, 13.691783431000033],
        ],
        [
            [121.77726217500003, 13.899440691000052],
            [121.77663285200003, 13.899443973000075],
            [121.77678881400004, 13.900102644000071],
            [121.77716693000002, 13.899760053000023],
            [121.77726217500003, 13.899440691000052],
        ],
        [
            [121.77860353100004, 13.901742472000024],
            [121.77935835800008, 13.900645542000063],
            [121.7789924440001, 13.900008230000026],
            [121.77780185800009, 13.900795057000039],
            [121.77860353100004, 13.901742472000024],
        ],
        [
            [121.80240029200002, 13.92178320000005],
            [121.80307936300005, 13.921646203000023],
            [121.79941450800004, 13.921038231000068],
            [121.80097065600012, 13.921875398000054],
            [121.80240029200002, 13.92178320000005],
        ],
        [
            [121.80378799000005, 13.940619974000072],
            [121.80352195500006, 13.940793364000058],
            [121.80362924100007, 13.941237382000054],
            [121.8040394200001, 13.940916628000025],
            [121.80378799000005, 13.940619974000072],
        ],
        [
            [121.802958396, 13.941423322000048],
            [121.80288291500005, 13.941508660000068],
            [121.80305862300008, 13.941850359000057],
            [121.8031677240001, 13.941630857000064],
            [121.802958396, 13.941423322000048],
        ],
        [
            [121.751492976, 13.94274798500004],
            [121.75154904700003, 13.942625083000053],
            [121.75132624800005, 13.942578463000075],
            [121.75130063600011, 13.94272313600004],
            [121.751492976, 13.94274798500004],
        ],
        [
            [121.75544034400002, 13.94330261400006],
            [121.78061922400002, 13.937367120000033],
            [121.78508167500001, 13.937036712000065],
            [121.78937820800002, 13.939213055000039],
            [121.7903771330001, 13.938766613000041],
            [121.79206015400007, 13.879955455000072],
            [121.78599021700006, 13.90932222500004],
            [121.74183015100004, 13.89186150100005],
            [121.75544034400002, 13.94330261400006],
        ],
        [
            [121.7538675400001, 13.943996101000039],
            [121.75417286400011, 13.943699767000055],
            [121.75360696900009, 13.943629957000041],
            [121.75350785900002, 13.943943355000044],
            [121.7538675400001, 13.943996101000039],
        ],
        [
            [122.21634691400004, 13.945071260000077],
            [122.21636540100008, 13.942866675000062],
            [122.2143946330001, 13.943941756000072],
            [122.21496761900005, 13.944779698000048],
            [122.21634691400004, 13.945071260000077],
        ],
        [
            [121.71664467800008, 13.951679553000076],
            [121.72028074800005, 13.948719954000069],
            [121.71872094000003, 13.945003830000076],
            [121.71641381300003, 13.945397735000029],
            [121.71664467800008, 13.951679553000076],
        ],
        [
            [122.19755404800003, 13.960079237000059],
            [122.1981516080001, 13.959798395000064],
            [122.19790669400004, 13.959411765000027],
            [122.19738003500004, 13.959948065000049],
            [122.19755404800003, 13.960079237000059],
        ],
        [
            [122.19515922300002, 13.961718389000055],
            [122.19480072400006, 13.961246617000029],
            [122.19399116200009, 13.961216654000054],
            [122.19414456200002, 13.961503898000046],
            [122.19515922300002, 13.961718389000055],
        ],
        [
            [122.10742641200011, 14.032938684000044],
            [122.10730829300007, 14.032747726000025],
            [122.10716770600004, 14.032927789000041],
            [122.10734486600006, 14.032968698000047],
            [122.10742641200011, 14.032938684000044],
        ],
        [
            [120.48736857800009, 14.06156674600004],
            [120.49497611100003, 14.055287536000037],
            [120.4954339630001, 14.05200310400005],
            [120.49083583600009, 14.055166763000045],
            [120.48736857800009, 14.06156674600004],
        ],
        [
            [120.57969748200003, 14.113615208000056],
            [120.578503124, 14.113100693000035],
            [120.5780505460001, 14.113277793000066],
            [120.57869314000004, 14.113631974000043],
            [120.57969748200003, 14.113615208000056],
        ],
        [
            [120.57636598600004, 14.115548365000052],
            [120.5769940560001, 14.115365416000031],
            [120.57619026100008, 14.11465908100007],
            [120.57560101000001, 14.115487143000053],
            [120.57636598600004, 14.115548365000052],
        ],
        [
            [120.58122937300004, 14.118496037000057],
            [120.58095438500004, 14.118116971000063],
            [120.58034080300001, 14.118385861000036],
            [120.5810998390001, 14.118566566000027],
            [120.58122937300004, 14.118496037000057],
        ],
        [
            [120.570342, 14.137001914000052],
            [120.57028816400009, 14.136109497000064],
            [120.56984197100007, 14.136071599000047],
            [120.56965602100001, 14.136442970000076],
            [120.570342, 14.137001914000052],
        ],
        [
            [120.56984384600003, 14.137852554000062],
            [120.57039886100006, 14.137399801000072],
            [120.56737533000012, 14.137075438000068],
            [120.5681545430001, 14.137840135000033],
            [120.56984384600003, 14.137852554000062],
        ],
        [
            [120.57099805200005, 14.150479420000067],
            [120.5716108260001, 14.149381100000028],
            [120.56952429000012, 14.149282714000037],
            [120.56958215300006, 14.149682706000021],
            [120.57099805200005, 14.150479420000067],
        ],
        [
            [120.57188141200004, 14.151852306000023],
            [120.57590467600005, 14.150125071000048],
            [120.57526859000006, 14.14887849300004],
            [120.57192917800012, 14.150006095000037],
            [120.57188141200004, 14.151852306000023],
        ],
        [
            [122.14939992600011, 14.17704419100005],
            [122.14844580500005, 14.174373948000039],
            [122.15059960200006, 14.16916625600004],
            [122.14705423900011, 14.173193380000043],
            [122.14939992600011, 14.17704419100005],
        ],
        [
            [120.5799538650001, 14.192515712000045],
            [120.5805202030001, 14.190651781000042],
            [120.57811510400006, 14.190186371000038],
            [120.57786579700007, 14.190870078000046],
            [120.5799538650001, 14.192515712000045],
        ],
        [
            [120.5803671330001, 14.198647169000026],
            [120.58030905400005, 14.198584452000034],
            [120.58025596100003, 14.198573202000034],
            [120.58028417800006, 14.19864235800003],
            [120.5803671330001, 14.198647169000026],
        ],
        [
            [120.58100922500012, 14.198807900000077],
            [120.581606469, 14.198669475000031],
            [120.58165456000006, 14.198555271000032],
            [120.5807387960001, 14.198812771000064],
            [120.58100922500012, 14.198807900000077],
        ],
        [
            [120.57862863300011, 14.199654447000057],
            [120.57992761700007, 14.198827528000038],
            [120.580347361, 14.198788858000057],
            [120.57837618000008, 14.198317774000031],
            [120.57862863300011, 14.199654447000057],
        ],
        [
            [120.58336312300003, 14.211869694000029],
            [120.58416597500002, 14.211455029000035],
            [120.58263709800008, 14.211012496000023],
            [120.58264008100002, 14.211386935000064],
            [120.58336312300003, 14.211869694000029],
        ],
        [
            [121.2065812190001, 14.217044925000039],
            [121.20326915900011, 14.218426623000028],
            [121.20327606800004, 14.219953543000031],
            [121.204732196, 14.218150750000063],
            [121.2065812190001, 14.217044925000039],
        ],
        [
            [121.31114187900005, 14.222714448000033],
            [121.31107418800002, 14.224029680000058],
            [121.31221305200006, 14.225555235000058],
            [121.31286378300001, 14.224841436000077],
            [121.31114187900005, 14.222714448000033],
        ],
        [
            [121.92953189500008, 14.235899976000042],
            [122.12790608600005, 14.087178908000055],
            [122.18732526600002, 14.005848111000034],
            [121.98529217600003, 14.111868205000064],
            [121.91413763700007, 14.188181898000039],
            [121.92953189500008, 14.235899976000042],
        ],
        [
            [120.58996251200006, 14.239791472000036],
            [120.59473648800008, 14.233081661000028],
            [120.59483857500004, 14.231094588000076],
            [120.58740989000012, 14.236988436000047],
            [120.58996251200006, 14.239791472000036],
        ],
        [
            [121.90119870400008, 14.243383123000058],
            [121.90235760200005, 14.242985213000054],
            [121.90271512800007, 14.242515327000035],
            [121.89988826600006, 14.242492994000031],
            [121.90119870400008, 14.243383123000058],
        ],
        [
            [120.61401933800005, 14.272452971000064],
            [120.61492610000005, 14.270603696000023],
            [120.61552184100003, 14.26388585500007],
            [120.61249690600005, 14.266764526000031],
            [120.61401933800005, 14.272452971000064],
        ],
        [
            [121.31166998300012, 14.284807145000059],
            [121.31303878100005, 14.284320348000051],
            [121.31063435600004, 14.283308872000077],
            [121.3107205550001, 14.284896736000064],
            [121.31166998300012, 14.284807145000059],
        ],
        [
            [121.3081831500001, 14.278380759000072],
            [121.30682558300009, 14.282318518000068],
            [121.30901600900006, 14.28541800100004],
            [121.30985621200011, 14.280465033000041],
            [121.3081831500001, 14.278380759000072],
        ],
        [
            [121.24942067900008, 14.300682091000056],
            [121.24540532800006, 14.298285111000041],
            [121.24446556800001, 14.302462942000034],
            [121.24661657700005, 14.303363596000054],
            [121.24942067900008, 14.300682091000056],
        ],
        [
            [121.25229504100002, 14.303178236000065],
            [121.25203488600005, 14.303523063000057],
            [121.25315012200008, 14.30518126100003],
            [121.2529031790001, 14.303816402000052],
            [121.25229504100002, 14.303178236000065],
        ],
        [
            [121.41241577900007, 14.304329116000076],
            [121.41182645600009, 14.304993031000038],
            [121.41266965600005, 14.306236633000026],
            [121.41298954600006, 14.305880409000054],
            [121.41241577900007, 14.304329116000076],
        ],
        [
            [121.82630932500001, 14.306325829000059],
            [121.85145168600002, 14.298514331000035],
            [121.82079319000002, 14.248830264000048],
            [121.80393840500005, 14.29268184700004],
            [121.82630932500001, 14.306325829000059],
        ],
        [
            [121.25824175800005, 14.30980814700007],
            [121.25797036000006, 14.311688331000028],
            [121.25966313100002, 14.311869996000041],
            [121.25946940100005, 14.310880097000052],
            [121.25824175800005, 14.30980814700007],
        ],
        [
            [121.41859077600009, 14.336080576000029],
            [121.41928621000011, 14.334902039000042],
            [121.41707369200003, 14.33558578700007],
            [121.41724583000007, 14.336057352000068],
            [121.41859077600009, 14.336080576000029],
        ],
        [
            [120.6234744200001, 14.367355404000023],
            [120.61877760700008, 14.364594301000068],
            [120.6139057580001, 14.364601547000063],
            [120.61216342300008, 14.365468085000032],
            [120.6234744200001, 14.367355404000023],
        ],
        [
            [120.6220032870001, 14.383054367000057],
            [120.6212361690001, 14.383838776000061],
            [120.6211975330001, 14.384425319000059],
            [120.62184165100007, 14.383760147000032],
            [120.6220032870001, 14.383054367000057],
        ],
        [
            [120.60839100100009, 14.393779098000039],
            [120.579754234, 14.372401714000034],
            [120.56206015900011, 14.384419968000032],
            [120.57323388200007, 14.39271984000004],
            [120.60839100100009, 14.393779098000039],
        ],
        [
            [121.43212124500008, 14.396286640000028],
            [121.43105247000005, 14.396296082000049],
            [121.43085051000003, 14.398493876000032],
            [121.43163554400007, 14.397821158000056],
            [121.43212124500008, 14.396286640000028],
        ],
        [
            [122.0380948190001, 14.402329412000029],
            [122.03869386600002, 14.401633951000065],
            [122.03819940900007, 14.399140149000061],
            [122.03761880600007, 14.401208508000025],
            [122.0380948190001, 14.402329412000029],
        ],
        [
            [121.2310912150001, 14.401883034000036],
            [121.26628327600008, 14.336757668000075],
            [121.24201342900005, 14.329726662000041],
            [121.23720929400008, 14.287057657000048],
            [121.2246012810001, 14.422586051000053],
            [121.2310912150001, 14.401883034000036],
        ],
        [
            [121.20270916200002, 14.431274812000026],
            [121.20282551100001, 14.431871604000037],
            [121.20351777300004, 14.431865635000065],
            [121.20351872000003, 14.431747586000029],
            [121.20270916200002, 14.431274812000026],
        ],
        [
            [122.04386387800002, 14.439530713000067],
            [122.04501343200002, 14.438946133000059],
            [122.04503775, 14.438197080000066],
            [122.04323845600004, 14.438456537000036],
            [122.04386387800002, 14.439530713000067],
        ],
        [
            [122.04706478700007, 14.440335465000032],
            [122.04765172900011, 14.439126086000044],
            [122.04701058500007, 14.438379262000069],
            [122.04569043700008, 14.439505849000057],
            [122.04706478700007, 14.440335465000032],
        ],
        [
            [121.32334041500008, 14.441540971000052],
            [121.32287356800009, 14.442160694000052],
            [121.3230388500001, 14.443003384000065],
            [121.32350747400005, 14.442515835000052],
            [121.32334041500008, 14.441540971000052],
        ],
        [
            [122.03143319300011, 14.445382017000043],
            [122.0459397080001, 14.423994328000049],
            [122.033560168, 14.394004495000047],
            [122.02659820400004, 14.43813127900006],
            [122.03143319300011, 14.445382017000043],
        ],
        [
            [121.23763341000006, 14.48040787900004],
            [121.23714175200007, 14.480718227000068],
            [121.23720784400007, 14.481094441000039],
            [121.237820714, 14.480740140000023],
            [121.23763341000006, 14.48040787900004],
        ],
        [
            [121.23819873100001, 14.480972892000068],
            [121.23786808000011, 14.481301271000063],
            [121.23786015600001, 14.481575991000057],
            [121.23817965100011, 14.481202666000058],
            [121.23819873100001, 14.480972892000068],
        ],
        [
            [121.24550655100006, 14.486876191000022],
            [121.24469074700005, 14.486024334000035],
            [121.24389410100002, 14.486483030000045],
            [121.24636789500005, 14.487389036000025],
            [121.24550655100006, 14.486876191000022],
        ],
        [
            [121.23632638000004, 14.487756976000071],
            [121.23574220900002, 14.488456515000053],
            [121.23583828700009, 14.488708865000035],
            [121.23666569000011, 14.488256412000055],
            [121.23632638000004, 14.487756976000071],
        ],
        [
            [122.40357791800011, 14.733756071000073],
            [122.43616814500001, 14.695244497000033],
            [122.30658647900009, 14.676466754000046],
            [122.33369786700007, 14.711425330000054],
            [122.40357791800011, 14.733756071000073],
        ],
        [
            [121.65645906000009, 14.779769488000056],
            [121.6575444240001, 14.778981670000064],
            [121.65823430000012, 14.777114882000035],
            [121.65427109400002, 14.778200351000066],
            [121.65645906000009, 14.779769488000056],
        ],
        [
            [122.26262706800003, 14.805629474000057],
            [122.26448138300009, 14.804868929000065],
            [122.26426170900004, 14.802348079000069],
            [122.26233028500008, 14.803410479000036],
            [122.26262706800003, 14.805629474000057],
        ],
        [
            [122.02540292700007, 14.807040639000036],
            [122.02962238600003, 14.801534787000037],
            [122.02952197200011, 14.80093989900007],
            [122.02065077600002, 14.804135467000037],
            [122.02540292700007, 14.807040639000036],
        ],
        [
            [122.24659558700012, 14.825657397000043],
            [122.2584446090001, 14.80902655400007],
            [122.25320009600011, 14.805592710000042],
            [122.24693407600012, 14.819982246000052],
            [122.24659558700012, 14.825657397000043],
        ],
        [
            [122.1530050020001, 14.840911947000052],
            [122.15448370400009, 14.840315222000072],
            [122.15444231300012, 14.839881752000053],
            [122.15287081300005, 14.84056059900007],
            [122.1530050020001, 14.840911947000052],
        ],
        [
            [122.01513283100007, 14.841813612000067],
            [122.01554690400008, 14.841725998000072],
            [122.01568440500012, 14.841283027000031],
            [122.01485928200009, 14.841403853000031],
            [122.01513283100007, 14.841813612000067],
        ],
        [
            [122.15065159100004, 14.84268933800007],
            [122.1517496570001, 14.840310723000073],
            [122.14738100900001, 14.83997258900007],
            [122.14891570500004, 14.842515156000047],
            [122.15065159100004, 14.84268933800007],
        ],
        [
            [122.15240647100006, 14.844242326000028],
            [122.15235680700005, 14.84381008500003],
            [122.15152277600009, 14.843524866000052],
            [122.151424216, 14.844086104000041],
            [122.15240647100006, 14.844242326000028],
        ],
        [
            [122.21271132600009, 14.844220552000024],
            [122.21156224700007, 14.842604265000034],
            [122.20998569500011, 14.843087136000065],
            [122.21121870000002, 14.844481337000047],
            [122.21271132600009, 14.844220552000024],
        ],
        [
            [122.00421374300004, 14.844785878000039],
            [122.00514631400006, 14.836461266000072],
            [121.99759464400006, 14.833564465000052],
            [121.99917507000009, 14.84164418100005],
            [122.00421374300004, 14.844785878000039],
        ],
        [
            [122.18363433200011, 14.845124357000032],
            [122.19608780800002, 14.830184312000029],
            [122.21391153400009, 14.841074301000049],
            [122.19196403300009, 14.805842168000027],
            [122.25939985800005, 14.787822652000045],
            [122.25594289900005, 14.725484249000033],
            [122.1145409510001, 14.799614671000029],
            [122.09361976900004, 14.842219216000046],
            [122.13738006900007, 14.828237302000048],
            [122.18363433200011, 14.845124357000032],
        ],
        [
            [122.18869314000005, 14.846259513000064],
            [122.18938293600002, 14.844724001000031],
            [122.18828024800007, 14.843795802000045],
            [122.18706775200008, 14.845794007000052],
            [122.18869314000005, 14.846259513000064],
        ],
        [
            [122.14015798900004, 14.84631758100005],
            [122.14029636300006, 14.839380560000052],
            [122.12952085800009, 14.835941012000035],
            [122.13091099100006, 14.845488905000025],
            [122.14015798900004, 14.84631758100005],
        ],
        [
            [122.18967123700008, 14.846413518000077],
            [122.18997242900002, 14.845482650000065],
            [122.1898628020001, 14.845186329000057],
            [122.18939638000006, 14.846018194000067],
            [122.18967123700008, 14.846413518000077],
        ],
        [
            [122.19391439900005, 14.848249476000035],
            [122.19520483800011, 14.847684885000035],
            [122.1952736820001, 14.846932825000067],
            [122.19348012900002, 14.847061196000027],
            [122.19391439900005, 14.848249476000035],
        ],
        [
            [121.99937145100012, 14.849555946000066],
            [121.99811404900004, 14.849641907000034],
            [121.9976971960001, 14.85070128600006],
            [121.99876586800008, 14.850389302000053],
            [121.99937145100012, 14.849555946000066],
        ],
        [
            [122.21000550300005, 14.851182067000025],
            [122.21185007800011, 14.849545702000057],
            [122.21311254200009, 14.847603321000065],
            [122.2074646860001, 14.847960228000034],
            [122.21000550300005, 14.851182067000025],
        ],
        [
            [122.19961814400006, 14.868243932000041],
            [122.20098198300002, 14.867103083000075],
            [122.200561794, 14.866022520000058],
            [122.19935230200008, 14.868444817000068],
            [122.19961814400006, 14.868243932000041],
        ],
        [
            [122.20935626700009, 14.869037043000048],
            [122.21168956500003, 14.86589206800005],
            [122.20510518100002, 14.86552765600004],
            [122.204972644, 14.866460505000077],
            [122.20935626700009, 14.869037043000048],
        ],
        [
            [122.02330063200009, 14.878453083000068],
            [122.06279965100009, 14.867986400000063],
            [122.08406836600011, 14.841586820000032],
            [122.02475787000003, 14.845631652000066],
            [122.02330063200009, 14.878453083000068],
        ],
        [
            [122.00750491800011, 14.883998524000049],
            [122.01340955600006, 14.87907019100004],
            [121.9950268560001, 14.880498728000077],
            [122.00110361300005, 14.883302435000076],
            [122.00750491800011, 14.883998524000049],
        ],
        [
            [122.1602135930001, 14.884362530000033],
            [122.16503891200011, 14.882212196000069],
            [122.16047153900001, 14.874636442000053],
            [122.15710446800006, 14.881710099000031],
            [122.1602135930001, 14.884362530000033],
        ],
        [
            [122.11171115600007, 14.894676229000027],
            [122.11260128100002, 14.892005378000022],
            [122.10850083800005, 14.891911961000062],
            [122.10913314400011, 14.893283517000043],
            [122.11171115600007, 14.894676229000027],
        ],
        [
            [122.11731987600001, 14.903037372000028],
            [122.12102291000008, 14.897139499000048],
            [122.11612056400008, 14.894728086000043],
            [122.11240260600005, 14.897206968000035],
            [122.11731987600001, 14.903037372000028],
        ],
        [
            [122.02044351300003, 14.905140373000052],
            [122.01576279000005, 14.893643334000046],
            [122.00702027300008, 14.892541322000056],
            [122.00538581500007, 14.90108088200003],
            [122.02044351300003, 14.905140373000052],
        ],
        [
            [122.15501041800007, 14.910010433000025],
            [122.15530976000002, 14.909792786000025],
            [122.15519968100011, 14.909463018000054],
            [122.15501173100006, 14.909659401000056],
            [122.15501041800007, 14.910010433000025],
        ],
        [
            [122.04005905600002, 14.915661119000049],
            [122.03788868400011, 14.90988720100006],
            [122.02810093000005, 14.914055996000059],
            [122.0389446160001, 14.916058391000035],
            [122.04005905600002, 14.915661119000049],
        ],
        [
            [122.14725139300003, 14.91703908900007],
            [122.15666539200004, 14.90572277700005],
            [122.15019172100006, 14.892891826000039],
            [122.14055379800004, 14.897754187000032],
            [122.14725139300003, 14.91703908900007],
        ],
        [
            [122.18546641500006, 14.917683637000039],
            [122.18768167600001, 14.914762675000077],
            [122.1869704830001, 14.912936486000035],
            [122.18519542500007, 14.91672754900003],
            [122.18546641500006, 14.917683637000039],
        ],
        [
            [122.18613902900006, 14.918734076000021],
            [122.18632703600008, 14.918449488000022],
            [122.18619009400004, 14.917858074000037],
            [122.18559057800007, 14.918527792000077],
            [122.18613902900006, 14.918734076000021],
        ],
        [
            [122.18462713800011, 14.923361274000058],
            [122.18499332400006, 14.922053049000056],
            [122.18391180800006, 14.920385901000031],
            [122.18277392100003, 14.921601318000057],
            [122.18462713800011, 14.923361274000058],
        ],
        [
            [122.18383361200006, 14.924487101000068],
            [122.18414412200002, 14.923826727000062],
            [122.18303966700012, 14.923134613000059],
            [122.1828315570001, 14.923580713000035],
            [122.18383361200006, 14.924487101000068],
        ],
        [
            [122.17565574900004, 14.933028609000075],
            [122.18026355000006, 14.931440954000038],
            [122.18405670700008, 14.92488703600003],
            [122.17630704300007, 14.924778626000034],
            [122.17565574900004, 14.933028609000075],
        ],
        [
            [122.052557836, 14.933514939000077],
            [122.05356365900002, 14.929189067000038],
            [122.044492063, 14.92645989600004],
            [122.04607094700009, 14.930289231000074],
            [122.052557836, 14.933514939000077],
        ],
        [
            [122.06150143900004, 14.949742829000058],
            [122.06394488300009, 14.949001949000035],
            [122.06313069200007, 14.946640933000026],
            [122.06026577600005, 14.948534664000022],
            [122.06150143900004, 14.949742829000058],
        ],
        [
            [122.15110865400004, 14.95040887700003],
            [122.15099332000011, 14.950191739000047],
            [122.15061039700004, 14.950260597000067],
            [122.15064030000008, 14.95044527300007],
            [122.15110865400004, 14.95040887700003],
        ],
        [
            [122.15657698300004, 14.950721828000042],
            [122.16089045400008, 14.938052751000043],
            [122.14898056400011, 14.922107674000074],
            [122.13846385800002, 14.925183263000065],
            [122.15657698300004, 14.950721828000042],
        ],
        [
            [122.03144323100003, 15.017406481000023],
            [122.02960239400011, 15.015067117000058],
            [122.02700317500012, 15.017126277000045],
            [122.03046101600012, 15.017922848000069],
            [122.03144323100003, 15.017406481000023],
        ],
        [
            [121.97226519500009, 15.040339628000027],
            [121.97257565900009, 15.040191226000047],
            [121.972154, 15.03995141400003],
            [121.97204298800011, 15.040557456000045],
            [121.97226519500009, 15.040339628000027],
        ],
        [
            [121.98090299500006, 15.041852652000046],
            [121.97996925300004, 15.040999647000035],
            [121.9789550810001, 15.041182322000054],
            [121.98083854000004, 15.042052985000055],
            [121.98090299500006, 15.041852652000046],
        ],
        [
            [121.98199915100008, 15.042757839000046],
            [121.98257385400007, 15.042116577000058],
            [121.98147436800002, 15.041647645000069],
            [121.98099263800009, 15.042595434000077],
            [121.98199915100008, 15.042757839000046],
        ],
        [
            [121.94692959200006, 15.057647710000026],
            [121.94730982700003, 15.057351701000073],
            [121.94668988800004, 15.057220439000048],
            [121.946689934, 15.057928132000029],
            [121.94692959200006, 15.057647710000026],
        ],
        [
            [121.94369313300001, 15.058174819000044],
            [121.94430172400007, 15.058187447000023],
            [121.94486347000009, 15.057663016000049],
            [121.9443541170001, 15.05748221400006],
            [121.94369313300001, 15.058174819000044],
        ],
        [
            [121.935241356, 15.058663221000074],
            [121.93612242600011, 15.039909857000055],
            [122.01928407200012, 15.030033341000035],
            [122.0068030650001, 15.007130327000027],
            [122.04976502800002, 15.005664352000053],
            [122.05622120100008, 14.964554802000066],
            [122.01150536700004, 14.989225043000033],
            [121.99123662500006, 14.957875984000054],
            [122.01919169300004, 14.967738950000069],
            [122.02116312100009, 14.92107413900004],
            [121.96733893500004, 14.906652561000044],
            [122.03672085900007, 14.715139518000058],
            [121.9392382850001, 14.626554099000032],
            [121.9029874150001, 14.678776638000045],
            [121.90518101000009, 14.723870838000039],
            [121.93787047300009, 14.711513782000054],
            [121.90902773900007, 14.803031722000071],
            [121.83512834800001, 14.954624961000036],
            [121.83065564600008, 14.928385726000045],
            [121.80142751700009, 14.935976593000078],
            [121.83693888200003, 15.03924087200005],
            [121.86655855800007, 15.021614631000034],
            [121.935241356, 15.058663221000074],
        ],
        [
            [121.4171205020001, 15.216888696000069],
            [121.48082561300009, 15.18063332500003],
            [121.60210874300003, 14.827585130000045],
            [121.73432880200005, 14.695812426000032],
            [121.678415201, 14.702057872000069],
            [121.69093568700009, 14.698668316000067],
            [121.62545633200011, 14.65748544400003],
            [121.61980403900009, 14.685947707000025],
            [121.60377247500003, 14.651903466000022],
            [121.65865646000009, 14.401156308000054],
            [121.7582555350001, 14.247317021000072],
            [121.729639012, 14.177372757000057],
            [121.7691068360001, 14.123910528000067],
            [121.94620206200011, 13.988165566000077],
            [122.23141412900009, 13.894815571000038],
            [122.24366136600008, 13.943020733000026],
            [122.18174390900003, 13.993851267000025],
            [122.2988423060001, 13.959299013000077],
            [122.3236965110001, 14.019973611000069],
            [122.29001362800011, 14.016900387000021],
            [122.16460668500008, 14.14070551900005],
            [122.24532010700011, 14.185958476000053],
            [122.25030371500009, 14.242292741000028],
            [122.27715698000009, 14.234632820000058],
            [122.2675543150001, 14.12383923300007],
            [122.3117271650001, 14.135829314000034],
            [122.30379789200003, 14.067382637000037],
            [122.38376856000002, 14.066641330000039],
        ],
        [
            [122.38376856000002, 14.066641330000039],
            [122.45199363600011, 14.150213563000023],
            [122.79251799700012, 14.013752262000025],
        ],
        [
            [122.79251799700012, 14.013752262000025],
            [122.55090404000009, 13.945773315000054],
            [122.53031252500011, 13.962686435000023],
            [122.52472539900009, 13.922746047000032],
            [122.41952651500003, 13.942829433000043],
            [122.52452337400007, 13.816284814000028],
            [122.52344478000009, 13.731804152000052],
            [122.48016865000011, 13.712774086000024],
            [122.49706499000001, 13.646851930000025],
            [122.63422480100007, 13.528953963000049],
            [122.61791855800004, 13.513439711000046],
            [122.5649292920001, 13.563009350000073],
            [122.67662059600002, 13.37938967100007],
            [122.70287154700009, 13.224974931000077],
            [122.62373092000007, 13.171993893000035],
            [122.56474436600001, 13.178755602000024],
            [122.5050062040001, 13.242810104000057],
            [122.51885024400008, 13.343179445000033],
            [122.40185701500002, 13.524247646000049],
            [122.32175913100002, 13.590393050000046],
            [122.28025184600006, 13.574426499000026],
            [122.26718864000009, 13.606513561000043],
            [122.20807032100004, 13.602104904000043],
            [122.09861132600008, 13.785267875000045],
            [121.98064205300011, 13.805884823000042],
            [121.97532501800004, 13.84048830200004],
            [121.82275196700004, 13.893207060000066],
            [121.81779086200004, 13.940646236000077],
            [121.74940984000011, 13.969266813000047],
            [121.69508389500004, 13.961380707000046],
            [121.70821996200004, 13.922247691000052],
            [121.47448112500001, 13.839383071000043],
            [121.4324404780001, 13.764619125000024],
            [121.46946066900011, 13.684060761000069],
            [121.36341557700007, 13.658694487000048],
            [121.2856053160001, 13.59700506400003],
            [121.18397593100008, 13.644615659000067],
            [121.03688060900004, 13.633548872000063],
            [121.06016673900001, 13.738544390000072],
            [121.00151244100005, 13.781751476000068],
            [120.89288217700005, 13.682676938000043],
            [120.87338905100012, 13.719511616000034],
            [120.92845353400003, 13.779915285000072],
            [120.91334930000005, 13.87356765800007],
            [120.878494498, 13.902038024000035],
            [120.71672092600011, 13.92803105300004],
            [120.69750751600009, 13.892656917000068],
            [120.71914254300009, 13.84324986200005],
            [120.65143142500006, 13.848380502000055],
            [120.66604765200009, 13.771020775000068],
            [120.62137359200005, 13.81119910700005],
            [120.60272388500005, 13.974092881000047],
            [120.63222438100001, 13.983069947000047],
            [120.62408248500003, 14.109274096000036],
            [120.56833634500003, 14.134578256000054],
            [120.6099353410001, 14.145538643000066],
            [120.57541243800006, 14.170900767000035],
            [120.60564893800006, 14.174057446000063],
            [120.613414282, 14.178083332000028],
            [120.58295833700004, 14.193582080000056],
            [120.58776270400006, 14.22950561500005],
            [120.62114977600004, 14.221184751000067],
            [120.6228299490001, 14.266767899000058],
            [120.76864946, 14.331668028000024],
            [120.89985872600005, 14.495779044000074],
            [120.92098839500011, 14.48079068900006],
            [120.89703915400003, 14.475310687000047],
            [120.8896082220001, 14.450550798000052],
            [120.9701566110001, 14.475500013000044],
            [121.00689103200011, 14.353943146000063],
            [121.0573845020001, 14.37863958500003],
            [121.09093242800009, 14.356038872000056],
            [121.19663173300012, 14.181952233000061],
            [121.28948705300002, 14.194273415000055],
            [121.40116717500007, 14.301964289000068],
            [121.43991096700006, 14.28946863300007],
            [121.42869360300006, 14.343979226000044],
            [121.47346211900003, 14.317128560000072],
            [121.47342802900005, 14.371872782000025],
            [121.4329674060001, 14.405779249000034],
            [121.30865646400002, 14.288267806000022],
            [121.33884720800006, 14.413015950000045],
            [121.32510470500006, 14.46085707900005],
            [121.24203842400004, 14.502582748000066],
            [121.2203872230001, 14.47389143600003],
            [121.22233477300006, 14.42317487400004],
            [121.21588996600008, 14.411446136000052],
            [121.18476833500006, 14.483051347000071],
            [121.13884003200008, 14.535651631000064],
            [121.10388566000006, 14.516490905000069],
        ],
        [
            [121.10388566000006, 14.516490905000069],
            [121.09589522800002, 14.563931524000054],
            [121.13503641400007, 14.65766351800005],
        ],
        [
            [121.1349717920001, 14.776730445000055],
            [121.10491462400012, 14.762656063000065],
            [121.09950513400008, 14.76921105100007],
            [121.16528463600002, 14.823417534000043],
        ],
        [
            [121.16528463600002, 14.823417534000043],
            [121.33290834400009, 14.83915042500007],
            [121.34476914000004, 15.040210904000048],
        ],
        [
            [120.58514255600005, 14.197761918000026],
            [120.58520715000009, 14.197848954000051],
            [120.58510276800007, 14.197905196000022],
            [120.58507234300009, 14.197815176000063],
            [120.58514255600005, 14.197761918000026],
        ],
        [
            [120.58755315500002, 14.22109884300005],
            [120.58703009200008, 14.221098835000078],
            [120.58666028700009, 14.220821091000062],
            [120.58798459900004, 14.220998733000044],
            [120.58755315500002, 14.22109884300005],
        ],
        [
            [120.58766695700001, 14.223355833000028],
            [120.58753202900004, 14.223117288000026],
            [120.58823167500009, 14.222847191000028],
            [120.588245, 14.222944077000022],
            [120.58766695700001, 14.223355833000028],
        ],
        [
            [120.71481306600003, 14.296729048000032],
            [120.71060934000002, 14.29352975300003],
            [120.71299547800004, 14.288014443000066],
            [120.71447210100007, 14.291528958000072],
            [120.71481306600003, 14.296729048000032],
        ],
        [
            [121.43620395100004, 14.320447896000076],
            [121.43650365600001, 14.321251244000052],
            [121.43605571700004, 14.32150778700003],
            [121.43559936800011, 14.320718671000066],
            [121.43620395100004, 14.320447896000076],
        ],
        [
            [121.43780887100002, 14.321534590000056],
            [121.43780089600011, 14.322686992000058],
            [121.4373144540001, 14.322851698000022],
            [121.43705483100007, 14.321911236000062],
            [121.43780887100002, 14.321534590000056],
        ],
        [
            [117.31259603500007, 7.506706648000034],
            [117.30734518200006, 7.509526919000052],
            [117.31311096200011, 7.513903058000039],
            [117.31533488700006, 7.509352976000059],
            [117.31259603500007, 7.506706648000034],
        ],
        [
            [117.30603512400012, 7.522422813000048],
            [117.3024576790001, 7.520391167000071],
            [117.29566985600002, 7.524006629000041],
            [117.2966984410001, 7.524138020000066],
            [117.30603512400012, 7.522422813000048],
        ],
        [
            [117.29841576700005, 7.558995103000029],
            [117.29172734800011, 7.559922753000023],
            [117.29135383300002, 7.56060812000004],
            [117.29268046800007, 7.561033789000021],
            [117.29841576700005, 7.558995103000029],
        ],
        [
            [117.02483948200006, 7.808196318000057],
            [117.02541649700004, 7.807875975000059],
            [117.02503430900003, 7.806712116000028],
            [117.02387417200009, 7.80742037400006],
            [117.02483948200006, 7.808196318000057],
        ],
        [
            [117.21551874700003, 7.830793776000064],
            [117.22405152200008, 7.825837601000046],
            [117.22677949900003, 7.822911437000073],
            [117.21088526000005, 7.823057363000032],
            [117.21551874700003, 7.830793776000064],
        ],
        [
            [117.07713868200005, 7.872216761000061],
            [117.07697210000003, 7.872415053000054],
            [117.07694970200009, 7.872996061000038],
            [117.07726326800002, 7.872718730000031],
            [117.07713868200005, 7.872216761000061],
        ],
        [
            [117.2209498200001, 7.917257845000051],
            [117.2228329940001, 7.916477840000027],
            [117.22091336900007, 7.914512343000069],
            [117.21930967800006, 7.916125742000077],
            [117.2209498200001, 7.917257845000051],
        ],
        [
            [117.00985111200009, 8.070796694000023],
            [117.01667749100011, 8.067086378000056],
            [117.00111261000006, 8.068438485000058],
            [117.00390028000004, 8.070279882000023],
            [117.00985111200009, 8.070796694000023],
        ],
        [
            [117.04152358400006, 8.074501698000063],
            [117.04223513500006, 8.071716557000059],
            [117.0419318370001, 8.071111405000067],
            [117.03954414700002, 8.073615739000047],
            [117.04152358400006, 8.074501698000063],
        ],
        [
            [117.04115625500003, 8.078838060000066],
            [117.04140336000012, 8.078170151000052],
            [117.04106299300008, 8.077925555000036],
            [117.04077631400003, 8.078241778000063],
            [117.04115625500003, 8.078838060000066],
        ],
        [
            [117.06552744600003, 8.080091683000035],
            [117.07841545800011, 8.005077908000032],
            [117.05192275800005, 7.990905267000073],
            [117.07501528500006, 7.991531046000034],
            [117.08633166600009, 7.906319216000043],
            [117.01158686600002, 7.804182972000035],
            [116.92894110700001, 7.936283580000065],
            [116.96730528300009, 7.951989981000054],
            [116.95006613200007, 7.998533544000054],
            [116.96650318000002, 8.054158980000068],
            [116.96934204500008, 8.015360071000032],
            [116.99668503200007, 8.062639919000048],
            [117.03724086600005, 8.063916240000026],
            [117.06552744600003, 8.080091683000035],
        ],
        [
            [117.05375812300008, 7.984847107000064],
            [117.05389222800011, 7.985089710000068],
            [117.05363140800011, 7.985396103000028],
            [117.0535849470001, 7.984971545000064],
            [117.05375812300008, 7.984847107000064],
        ],
        [
            [117.07382401200005, 8.090820093000048],
            [117.07852669500005, 8.08740302700005],
            [117.07950110200011, 8.082227978000049],
            [117.07571340800007, 8.083368059000065],
            [117.07382401200005, 8.090820093000048],
        ],
        [
            [117.10670039000001, 8.092460218000042],
            [117.10909281200009, 8.073828890000073],
            [117.09836217000009, 8.072088894000046],
            [117.10230052600002, 8.089360537000061],
            [117.10670039000001, 8.092460218000042],
        ],
        [
            [116.988652623, 8.093558233000067],
            [116.991621914, 8.087017134000064],
            [116.98617941400005, 8.077935696000054],
            [116.98363884700007, 8.088530482000067],
            [116.988652623, 8.093558233000067],
        ],
        [
            [117.028958525, 8.13001756500006],
            [117.06248217500001, 8.084082256000045],
            [117.04544748500007, 8.082751746000042],
            [117.01560336800003, 8.071425272000056],
            [116.9898855030001, 8.097728095000036],
            [117.028958525, 8.13001756500006],
        ],
        [
            [117.13053658800004, 8.135096235000049],
            [117.13637329900007, 8.125578134000023],
            [117.1562544310001, 8.113564005000057],
            [117.14352618300006, 8.11449863200005],
            [117.13441337000006, 8.123648367000044],
            [117.13053658800004, 8.135096235000049],
        ],
        [
            [117.22641367500012, 8.163390995000043],
            [117.23207211600004, 8.156460405000075],
            [117.23087768900007, 8.151967194000065],
            [117.21910670200009, 8.155100745000027],
            [117.22641367500012, 8.163390995000043],
        ],
        [
            [117.24082264000003, 8.176852508000024],
            [117.24984716300003, 8.175767964000045],
            [117.25735028300005, 8.16719372700004],
            [117.24136163600008, 8.168735149000042],
            [117.24082264000003, 8.176852508000024],
        ],
        [
            [117.14015332200006, 8.179950629000075],
            [117.18970407400002, 8.178831153000033],
            [117.20561925100003, 8.153628395000055],
            [117.14854163500002, 8.15127003400005],
            [117.14015332200006, 8.179950629000075],
        ],
        [
            [117.00997316200005, 8.180132437000054],
            [117.02785992200006, 8.17243497800007],
            [117.02932950600007, 8.17068338000007],
            [117.01562275200001, 8.17434589100003],
            [117.00997316200005, 8.180132437000054],
        ],
        [
            [117.27608996100003, 8.180662597000037],
            [117.27565702200002, 8.17994860500005],
            [117.27530428800003, 8.179974642000047],
            [117.27531792600007, 8.180277532000048],
            [117.27608996100003, 8.180662597000037],
        ],
        [
            [117.28153543100007, 8.183020271000032],
            [117.28207647700003, 8.17997464900003],
            [117.2812364780001, 8.178063535000035],
            [117.27762667800005, 8.182321029000036],
            [117.28153543100007, 8.183020271000032],
        ],
        [
            [117.28364103800004, 8.18311361700006],
            [117.28347870000005, 8.183188273000042],
            [117.28406582200012, 8.184087261000059],
            [117.28405552800007, 8.183429348000061],
            [117.28364103800004, 8.18311361700006],
        ],
        [
            [117.28210663900006, 8.185031546000062],
            [117.28318674000002, 8.18438216800007],
            [117.28348904400002, 8.183583044000045],
            [117.28278992900005, 8.183179482000071],
            [117.28210663900006, 8.185031546000062],
        ],
        [
            [117.18825060100005, 8.201747036000029],
            [117.1946128190001, 8.199408886000072],
            [117.19830889400009, 8.195722998000065],
            [117.18748135600003, 8.200377403000061],
            [117.18825060100005, 8.201747036000029],
        ],
        [
            [117.14075796400004, 8.235172771000066],
            [117.1415281300001, 8.233665201000065],
            [117.14060478600004, 8.233171703000039],
            [117.13984695200008, 8.234569323000073],
            [117.14075796400004, 8.235172771000066],
        ],
        [
            [117.08110016100011, 8.248246230000063],
            [117.11434123400011, 8.241501663000065],
            [117.12762877400007, 8.21732273300006],
            [117.08521064500007, 8.215919504000055],
            [117.08110016100011, 8.248246230000063],
        ],
        [
            [117.12542691300007, 8.287441627000021],
            [117.1279230450001, 8.284946700000035],
            [117.12644950100002, 8.278783812000029],
            [117.12054879800007, 8.281377329000065],
            [117.12542691300007, 8.287441627000021],
        ],
        [
            [117.14266528300004, 8.301039436000053],
            [117.14159310900004, 8.303897096000071],
            [117.14243794300012, 8.305209625000032],
            [117.14321037600007, 8.30192850100002],
            [117.14266528300004, 8.301039436000053],
        ],
        [
            [117.18241672500005, 8.308644944000037],
            [117.18337889500003, 8.308224250000023],
            [117.18396449600004, 8.307418443000074],
            [117.18409375600004, 8.303883864000056],
            [117.18177232100004, 8.302567804000034],
            [117.18241672500005, 8.308644944000037],
        ],
        [
            [117.3405177840001, 8.311474039000075],
            [117.34141601500005, 8.310266231000071],
            [117.33807280200006, 8.308725227000025],
            [117.33919118400001, 8.311020235000058],
            [117.3405177840001, 8.311474039000075],
        ],
        [
            [117.3069265790001, 8.330478263000032],
            [117.352212602, 8.290773534000039],
            [117.34659454300004, 8.210644413000068],
            [117.2924179580001, 8.177289189000021],
            [117.26281150900002, 8.209508570000025],
            [117.265426864, 8.299006012000063],
            [117.3069265790001, 8.330478263000032],
        ],
        [
            [117.23108121000007, 8.338854892000029],
            [117.25693883200006, 8.28843650500005],
            [117.1757155890001, 8.255559969000046],
            [117.163135312, 8.286050917000068],
            [117.23108121000007, 8.338854892000029],
        ],
        [
            [117.23483057100009, 8.310513860000071],
            [117.23464594900008, 8.310054477000051],
            [117.23550275900004, 8.309971122000036],
            [117.23547587100006, 8.310153809000042],
            [117.23483057100009, 8.310513860000071],
        ],
        [
            [117.520221805, 8.342745085000047],
            [117.51703065600009, 8.33806063000003],
            [117.51491037900007, 8.337686182000027],
            [117.5151766140001, 8.341483289000053],
            [117.520221805, 8.342745085000047],
        ],
        [
            [117.31675162200008, 8.350721836000048],
            [117.31674272700002, 8.346720527000059],
            [117.31055675200002, 8.34369309400006],
            [117.31244850900009, 8.35007883000003],
            [117.31675162200008, 8.350721836000048],
        ],
        [
            [117.22364849300004, 8.355927332000022],
            [117.22321757200007, 8.355267868000055],
            [117.22243254600005, 8.355327416000023],
            [117.22328565900011, 8.356675473000053],
            [117.22364849300004, 8.355927332000022],
        ],
        [
            [117.22529698200003, 8.359550400000046],
            [117.22546147800006, 8.358037351000064],
            [117.22437194600002, 8.357399021000049],
            [117.22416592900004, 8.35860045100003],
            [117.22529698200003, 8.359550400000046],
        ],
        [
            [117.23799582900006, 8.367162627000027],
            [117.23988587600002, 8.365016198000035],
            [117.22917333300006, 8.358456396000065],
            [117.22850183900005, 8.360826434000046],
            [117.23799582900006, 8.367162627000027],
        ],
        [
            [117.24780356400004, 8.378368180000052],
            [117.24595786600003, 8.37128647700007],
            [117.24162612600003, 8.367647816000044],
            [117.24132578500007, 8.369537666000042],
            [117.24780356400004, 8.378368180000052],
        ],
        [
            [117.26547325500007, 8.393310132000067],
            [117.26355782700011, 8.390314604000025],
            [117.26125587900003, 8.391791932000046],
            [117.26408967200007, 8.393165787000044],
            [117.26547325500007, 8.393310132000067],
        ],
        [
            [117.26162345400007, 8.396355830000061],
            [117.26104308100003, 8.395036853000022],
            [117.25932258300008, 8.394411361000039],
            [117.25941557600004, 8.395134038000037],
            [117.26162345400007, 8.396355830000061],
        ],
        [
            [117.26961349200008, 8.401035261000061],
            [117.26889641200012, 8.398358213000051],
            [117.26447275800001, 8.395628609000028],
            [117.2643984990001, 8.396175363000054],
            [117.26961349200008, 8.401035261000061],
        ],
        [
            [117.19155457000011, 8.43460260200004],
            [117.1918651090001, 8.43214045700006],
            [117.18980560200009, 8.43239956800005],
            [117.18982002500002, 8.433194959000048],
            [117.19155457000011, 8.43460260200004],
        ],
        [
            [117.43532005000009, 8.438636548000034],
            [117.43172079400006, 8.43766679600003],
            [117.429310944, 8.43939565900007],
            [117.4332492210001, 8.441859133000037],
            [117.43532005000009, 8.438636548000034],
        ],
        [
            [118.1186145580001, 9.04280714600003],
            [118.11843266100004, 9.041754463000075],
            [118.11785162700005, 9.041388846000075],
            [118.11755196400009, 9.042590741000026],
            [118.1186145580001, 9.04280714600003],
        ],
        [
            [118.11998959400012, 9.044374470000037],
            [118.11961626800007, 9.044730370000025],
            [118.12113052400002, 9.04901310400004],
            [118.12140023400002, 9.04631388100006],
            [118.11998959400012, 9.044374470000037],
        ],
        [
            [118.12028797900007, 9.049838025000042],
            [118.11906302600005, 9.043217655000035],
            [118.117317748, 9.043305317000033],
            [118.11646161700003, 9.048349028000075],
            [118.12028797900007, 9.049838025000042],
        ],
        [
            [118.13871645100005, 9.070176753000055],
            [118.143329816, 9.067063780000069],
            [118.14368191400001, 9.06601439700006],
            [118.13611892600011, 9.060204627000076],
            [118.13871645100005, 9.070176753000055],
        ],
        [
            [118.15517733600007, 9.088961427000072],
            [118.16013194000004, 9.087733408000076],
            [118.15984676500011, 9.08299807700007],
            [118.15614696300008, 9.084993303000033],
            [118.15517733600007, 9.088961427000072],
        ],
        [
            [118.12658248200012, 9.096864405000076],
            [118.13083040300012, 9.092064070000049],
            [118.12532019800005, 9.089155066000046],
            [118.12148923500001, 9.09417601000007],
            [118.12658248200012, 9.096864405000076],
        ],
        [
            [118.13236846500001, 9.102878377000025],
            [118.1349839500001, 9.102009633000023],
            [118.13419340100006, 9.09956765000004],
            [118.12964256200007, 9.102310555000031],
            [118.13236846500001, 9.102878377000025],
        ],
        [
            [118.16262202200005, 9.126696582000022],
            [118.16438921300005, 9.124424926000074],
            [118.1635086550001, 9.121109059000048],
            [118.15896118700005, 9.124691883000025],
            [118.16262202200005, 9.126696582000022],
        ],
        [
            [118.3800561700001, 9.20680635900004],
            [118.38258937100011, 9.204674930000067],
            [118.38177318300006, 9.201975535000031],
            [118.37844769800006, 9.205516209000052],
            [118.3800561700001, 9.20680635900004],
        ],
        [
            [118.38535214300009, 9.22052756100004],
            [118.3862433700001, 9.21914467800002],
            [118.38555306500007, 9.218359730000032],
            [118.38466490100006, 9.219836108000038],
            [118.38535214300009, 9.22052756100004],
        ],
        [
            [118.39012628500006, 9.229046711000024],
            [118.39145592300008, 9.22853826000005],
            [118.39089837300003, 9.22698097600005],
            [118.38947953200011, 9.227464532000056],
            [118.39012628500006, 9.229046711000024],
        ],
        [
            [117.85878361000005, 9.248082859000021],
            [117.85684411900002, 9.242893837000054],
            [117.84908130500003, 9.243691039000055],
            [117.84938715800001, 9.245189888000027],
            [117.85878361000005, 9.248082859000021],
        ],
        [
            [118.44078088800006, 9.248988835000034],
            [118.45667435200005, 9.219435161000035],
            [118.42668282600005, 9.207418245000042],
            [118.43244523100009, 9.244747466000035],
            [118.44078088800006, 9.248988835000034],
        ],
        [
            [118.50143926300007, 9.25270643500005],
            [118.50247399000011, 9.251472532000037],
            [118.50170703600008, 9.250512711000056],
            [118.49976043900006, 9.252110793000043],
            [118.50143926300007, 9.25270643500005],
        ],
        [
            [117.88952510900003, 9.26236500500005],
            [117.89182369700006, 9.259376598000074],
            [117.8912272010001, 9.257904232000044],
            [117.8845751450001, 9.259527502000026],
            [117.88952510900003, 9.26236500500005],
        ],
        [
            [117.94109878900008, 9.273456819000046],
            [117.9468630880001, 9.269143678000034],
            [117.94398410500003, 9.265079506000063],
            [117.933797088, 9.270880853000051],
            [117.94109878900008, 9.273456819000046],
        ],
        [
            [120.82291128400004, 9.28226182800006],
            [120.81532216100004, 9.27563297000006],
            [120.80694717000006, 9.275636089000045],
            [120.81537818900006, 9.280501718000039],
            [120.82291128400004, 9.28226182800006],
        ],
        [
            [117.94706103500005, 9.294799631000046],
            [117.93804499900011, 9.282126835000042],
            [117.9380732080001, 9.273266680000063],
            [117.93013191300008, 9.28348244800003],
            [117.94706103500005, 9.294799631000046],
        ],
        [
            [117.99902083500001, 9.297470275000023],
            [118.00074076900012, 9.297102421000034],
            [118.00330196700008, 9.287069908000035],
            [118.00033661100008, 9.287379079000061],
            [117.99902083500001, 9.297470275000023],
        ],
        [
            [117.96007457500002, 9.301348398000073],
            [117.96534914200004, 9.297587950000036],
            [117.96685721600011, 9.289186073000053],
            [117.9567910400001, 9.300040952000074],
            [117.96007457500002, 9.301348398000073],
        ],
        [
            [117.9444285410001, 9.316281035000031],
            [117.94845719600005, 9.312156040000048],
            [117.94865579600003, 9.31123942000005],
            [117.94615419900003, 9.312523034000037],
            [117.9444285410001, 9.316281035000031],
        ],
        [
            [118.08742081800006, 9.359164425000074],
            [118.08729342700008, 9.35604733200006],
            [118.09339314700003, 9.352184253000075],
            [118.08434495600011, 9.35366354200005],
            [118.08742081800006, 9.359164425000074],
        ],
        [
            [118.58349685600001, 9.377001910000047],
            [118.58418012200002, 9.37500983700005],
            [118.58102074500005, 9.370988436000061],
            [118.57980108700008, 9.374767833000021],
            [118.58349685600001, 9.377001910000047],
        ],
        [
            [118.6285802760001, 9.46208034600005],
            [118.62712079000005, 9.43685443000004],
            [118.61146926600009, 9.431196278000073],
            [118.6095244170001, 9.448916396000072],
            [118.6285802760001, 9.46208034600005],
        ],
        [
            [121.19421531000012, 9.566586401000052],
            [121.19433426300009, 9.566316995000022],
            [121.19392327700007, 9.566107665000061],
            [121.1939864950001, 9.566542752000032],
            [121.19421531000012, 9.566586401000052],
        ],
        [
            [121.2321746020001, 9.601315728000031],
            [121.23221251300004, 9.600609702000042],
            [121.23174441700007, 9.60057979000004],
            [121.23167108000007, 9.60122345000002],
            [121.2321746020001, 9.601315728000031],
        ],
        [
            [121.22884610300002, 9.60226398900005],
            [121.22890516300004, 9.602068287000066],
            [121.22809469600008, 9.601870297000062],
            [121.22828137200008, 9.602086955000061],
            [121.22884610300002, 9.60226398900005],
        ],
        [
            [121.0068913560001, 9.615405404000057],
            [121.01768021400005, 9.61187489200006],
            [121.01954803900003, 9.60911969700004],
            [121.00533622300009, 9.607576443000028],
            [121.0068913560001, 9.615405404000057],
        ],
        [
            [121.22822160300007, 9.61668116900006],
            [121.22819677400003, 9.616398453000045],
            [121.227540567, 9.616422949000025],
            [121.22751021400006, 9.615906449000022],
            [121.22725380700001, 9.61611577900004],
            [121.22742201300002, 9.616518099000075],
            [121.22822160300007, 9.61668116900006],
        ],
        [
            [121.22812515100009, 9.617673403000026],
            [121.22826851000002, 9.61738252400005],
            [121.22773082700007, 9.616705660000036],
            [121.22776395300002, 9.617559244000063],
            [121.22812515100009, 9.617673403000026],
        ],
        [
            [121.22671902400009, 9.618657541000061],
            [121.2273200840001, 9.618508001000066],
            [121.22705811900005, 9.61778219200005],
            [121.22666660800007, 9.617996966000021],
            [121.22671902400009, 9.618657541000061],
        ],
        [
            [121.22736973100007, 9.618872269000065],
            [121.22707197300008, 9.619280046000029],
            [121.22738080200008, 9.619782942000029],
            [121.22731460400007, 9.61923925900004],
            [121.22736973100007, 9.618872269000065],
        ],
        [
            [121.28095899300001, 9.623006081000028],
            [121.26757902100007, 9.60745692200004],
            [121.25008835100004, 9.595925924000028],
            [121.2407980800001, 9.591130777000046],
            [121.2385395440001, 9.592019110000024],
            [121.28095899300001, 9.623006081000028],
        ],
        [
            [121.22712447700007, 9.623870349000072],
            [121.22669287200006, 9.624279367000042],
            [121.22698064100007, 9.624702540000044],
            [121.2271676470001, 9.624028746000022],
            [121.22712447700007, 9.623870349000072],
        ],
        [
            [121.22767125400003, 9.624995665000029],
            [121.22777915100005, 9.624804163000022],
            [121.22715329100004, 9.624707261000026],
            [121.22729477700011, 9.624910572000033],
            [121.22767125400003, 9.624995665000029],
        ],
        [
            [121.29092874300011, 9.625807339000062],
            [121.29048442700002, 9.625357658000041],
            [121.29058706300009, 9.62499501000002],
            [121.29031474200008, 9.624736031000054],
            [121.29026948800004, 9.625442465000049],
            [121.29092874300011, 9.625807339000062],
        ],
        [
            [121.22777368400011, 9.625572509000051],
            [121.22760509400007, 9.62573874100002],
            [121.22807179000006, 9.626084466000066],
            [121.22807986700002, 9.625777283000048],
            [121.22777368400011, 9.625572509000051],
        ],
        [
            [121.22745519900002, 9.62779250400007],
            [121.22709503500005, 9.627801073000057],
            [121.22731928700011, 9.628206383000077],
            [121.22751488300003, 9.628041319000033],
            [121.22745519900002, 9.62779250400007],
        ],
        [
            [121.23011660800012, 9.63102665100007],
            [121.22981020000009, 9.631212770000047],
            [121.2297946010001, 9.631437481000034],
            [121.23012718700011, 9.63121777200007],
            [121.23011660800012, 9.63102665100007],
        ],
        [
            [121.22969776200011, 9.631607994000035],
            [121.22945168500007, 9.63194130100004],
            [121.22972953100009, 9.632235597000033],
            [121.22980544900008, 9.632134828000062],
            [121.22969776200011, 9.631607994000035],
        ],
        [
            [121.23030087000006, 9.632799719000047],
            [121.23005249500011, 9.63291386700007],
            [121.23015977300008, 9.633281211000053],
            [121.23020045700002, 9.633264298000029],
            [121.23030087000006, 9.632799719000047],
        ],
        [
            [121.23059862800005, 9.636126448000027],
            [121.23061584200002, 9.635781476000034],
            [121.2302042440001, 9.636086629000033],
            [121.2302854730001, 9.636159010000029],
            [121.23059862800005, 9.636126448000027],
        ],
        [
            [121.2294260330001, 9.635399321000023],
            [121.22915981500012, 9.635576158000049],
            [121.22936162000008, 9.636200551000059],
            [121.22950731800006, 9.635692179000046],
            [121.2294260330001, 9.635399321000023],
        ],
        [
            [121.22920476700006, 9.644673067000042],
            [121.229133466, 9.644538392000072],
            [121.2290113890001, 9.644594346000076],
            [121.22905068700004, 9.64468891100006],
            [121.22920476700006, 9.644673067000042],
        ],
        [
            [121.23045128600006, 9.645014720000063],
            [121.22521375400004, 9.62279774500007],
            [121.22641522800006, 9.61514886200007],
            [121.23006977600005, 9.61286221100005],
            [121.22111130200005, 9.590954746000023],
            [121.23199351400001, 9.591015887000026],
            [121.18231344100002, 9.569916044000024],
            [121.23045128600006, 9.645014720000063],
        ],
        [
            [121.21769250300008, 9.587668117000021],
            [121.21731874900001, 9.587506891000032],
            [121.21826850700006, 9.587474548000046],
            [121.21813741900007, 9.587580660000071],
            [121.21769250300008, 9.587668117000021],
        ],
        [
            [121.21716506500002, 9.58765049300007],
            [121.21488634800005, 9.587087620000034],
            [121.21364475400003, 9.587220752000064],
            [121.21505465200005, 9.586886974000038],
            [121.21716506500002, 9.58765049300007],
        ],
        [
            [121.21902111500003, 9.587921196000025],
            [121.21874979800009, 9.587805346000039],
            [121.21874125000011, 9.587670532000061],
            [121.21915783300005, 9.587700014000063],
            [121.21902111500003, 9.587921196000025],
        ],
        [
            [121.21955520000006, 9.588138150000077],
            [121.21942488400009, 9.588136047000035],
            [121.21936720000008, 9.587984382000059],
            [121.21963210400008, 9.588064422000059],
            [121.21955520000006, 9.588138150000077],
        ],
        [
            [121.22905522300005, 9.645021390000068],
            [121.2291642030001, 9.644936782000059],
            [121.2291103230001, 9.644756236000035],
            [121.22889528500002, 9.644952683000042],
            [121.22905522300005, 9.645021390000068],
        ],
        [
            [121.22943483900008, 9.645419601000071],
            [121.22952777800003, 9.645238980000045],
            [121.22925446300007, 9.645187529000054],
            [121.22929088300009, 9.645336555000029],
            [121.22943483900008, 9.645419601000071],
        ],
        [
            [121.22960047700008, 9.645963517000041],
            [121.2296905710001, 9.645901847000061],
            [121.22944050500007, 9.645834619000027],
            [121.22950018200004, 9.645977900000048],
            [121.22960047700008, 9.645963517000041],
        ],
        [
            [121.2363910360001, 9.646484582000028],
            [121.2365970190001, 9.646414625000034],
            [121.23657758900004, 9.646278468000048],
            [121.23638735300005, 9.646399514000052],
            [121.2363910360001, 9.646484582000028],
        ],
        [
            [121.23643671700006, 9.646704578000026],
            [121.23621480400004, 9.646774481000023],
            [121.23632277900003, 9.647020862000034],
            [121.23642132300006, 9.646929599000032],
            [121.23643671700006, 9.646704578000026],
        ],
        [
            [121.22988728700011, 9.647277164000059],
            [121.22991311800001, 9.646758116000058],
            [121.22959552300006, 9.646820478000052],
            [121.22975676900012, 9.647302968000076],
            [121.22988728700011, 9.647277164000059],
        ],
        [
            [121.23566596800003, 9.648517842000047],
            [121.23594090600011, 9.645854848000056],
            [121.23420113400005, 9.643877710000027],
            [121.2334690350001, 9.647478351000075],
            [121.23566596800003, 9.648517842000047],
        ],
        [
            [121.23730943900011, 9.649094127000069],
            [121.23747467200008, 9.648708860000056],
            [121.2366439330001, 9.648448012000074],
            [121.23687408400008, 9.649083002000054],
            [121.23730943900011, 9.649094127000069],
        ],
        [
            [121.23858220000011, 9.662186890000044],
            [121.23863339900004, 9.650671483000053],
            [121.23459212600005, 9.650971861000073],
            [121.23102044200004, 9.645789346000072],
            [121.23858220000011, 9.662186890000044],
        ],
        [
            [121.2392336580001, 9.663031379000074],
            [121.23956339400002, 9.662855147000073],
            [121.23947178600008, 9.662669133000065],
            [121.2391735330001, 9.662765769000032],
            [121.2392336580001, 9.663031379000074],
        ],
        [
            [118.77300938100007, 9.84030199600005],
            [118.77682650500003, 9.83893265200004],
            [118.77628787900005, 9.833092057000044],
            [118.76786795700002, 9.839886613000033],
            [118.77300938100007, 9.84030199600005],
        ],
        [
            [118.76455804300008, 9.855318877000059],
            [118.76395352400004, 9.84886244300003],
            [118.75750041100002, 9.852855264000027],
            [118.75849504500002, 9.853617670000062],
            [118.76455804300008, 9.855318877000059],
        ],
        [
            [118.7678600700001, 9.87463914600005],
            [118.77091633400005, 9.87192480400006],
            [118.7704076340001, 9.86911498400002],
            [118.76709281700005, 9.87219944800006],
            [118.7678600700001, 9.87463914600005],
        ],
        [
            [118.81545065300008, 9.877525088000027],
            [118.81760536700006, 9.874070173000064],
            [118.81758755200008, 9.872580966000044],
            [118.81391493700005, 9.873106493000023],
            [118.81545065300008, 9.877525088000027],
        ],
        [
            [118.76944034200005, 9.880506624000077],
            [118.77122031700003, 9.878888674000052],
            [118.77146578500003, 9.877948609000043],
            [118.76906581700007, 9.877809548000073],
            [118.76944034200005, 9.880506624000077],
        ],
        [
            [118.77991811200002, 9.889163598000039],
            [118.787534993, 9.888987367000027],
            [118.79479974100002, 9.878922982000063],
            [118.77801375500007, 9.881088728000066],
            [118.77991811200002, 9.889163598000039],
        ],
        [
            [118.79790404700009, 9.903856971000039],
            [118.79720983200002, 9.902180716000032],
            [118.7977877400001, 9.899556291000067],
            [118.79639112200005, 9.901558264000073],
            [118.79790404700009, 9.903856971000039],
        ],
        [
            [118.83866018800006, 9.913740346000054],
            [118.83298238900011, 9.90702901700007],
            [118.830260683, 9.904812483000057],
            [118.827419426, 9.903319574000022],
            [118.8269205580001, 9.900778670000022],
            [118.82318258100008, 9.901898837000033],
            [118.82525753900006, 9.898236419000057],
            [118.81969454600005, 9.898484605000021],
            [118.82015767000007, 9.899794137000072],
            [118.82474136500002, 9.903208543000062],
            [118.8321474710001, 9.906412148000072],
            [118.83866018800006, 9.913740346000054],
        ],
        [
            [118.87779339400004, 9.915670515000045],
            [118.88415179900005, 9.912330736000058],
            [118.87967578400003, 9.904740834000052],
            [118.87606666300007, 9.909811038000043],
            [118.87779339400004, 9.915670515000045],
        ],
        [
            [118.84178703500004, 9.92305471800006],
            [118.84443155000008, 9.92084535400005],
            [118.84051876500007, 9.919532158000038],
            [118.83935705500005, 9.92104585100003],
            [118.84178703500004, 9.92305471800006],
        ],
        [
            [118.79273864200002, 9.930316720000064],
            [118.7919222490001, 9.92541084100003],
            [118.78792199100008, 9.92439405500005],
            [118.78796003800005, 9.929904481000051],
            [118.79273864200002, 9.930316720000064],
        ],
        [
            [118.85463243900006, 9.933722841000076],
            [118.85836192400006, 9.929259693000063],
            [118.8539642180001, 9.926718006000044],
            [118.85294389300009, 9.927940742000033],
            [118.85463243900006, 9.933722841000076],
        ],
        [
            [118.86681541400003, 9.938044157000036],
            [118.86591704900002, 9.938609491000022],
            [118.8659917760001, 9.938809024000022],
            [118.86656541700006, 9.938602565000053],
            [118.86681541400003, 9.938044157000036],
        ],
        [
            [118.92196739200006, 9.940244060000055],
            [118.93238642400001, 9.933760454000037],
            [118.92403506100004, 9.925774432000026],
            [118.91659302500011, 9.933018850000053],
            [118.92196739200006, 9.940244060000055],
        ],
        [
            [119.23045051000008, 10.087451570000042],
            [119.23149653200005, 10.07365291900004],
            [119.21448948300008, 10.06097107200003],
            [119.21401179100008, 10.065785528000049],
            [119.23045051000008, 10.087451570000042],
        ],
        [
            [118.78323281300004, 10.096590050000032],
            [118.78206688900002, 10.073419139000066],
            [118.781190175, 10.072244549000061],
            [118.78029521300004, 10.080662921000055],
            [118.78323281300004, 10.096590050000032],
        ],
        [
            [119.2404558830001, 10.127435525000067],
            [119.24716259200011, 10.103565983000067],
            [119.23720097700004, 10.086443270000075],
            [119.22941453600004, 10.092777761000036],
            [119.2404558830001, 10.127435525000067],
        ],
        [
            [119.24767741100004, 10.154613384000072],
            [119.25413551200006, 10.148884991000045],
            [119.24981048100005, 10.141767035000044],
            [119.24731812300001, 10.14519443100005],
            [119.24767741100004, 10.154613384000072],
        ],
        [
            [119.2574502440001, 10.185651027000063],
            [119.25798078800005, 10.185368659000062],
            [119.25659588000008, 10.185721241000067],
            [119.25683223700003, 10.185878368000033],
            [119.2574502440001, 10.185651027000063],
        ],
        [
            [119.29389035300005, 10.211296083000036],
            [119.29484145600009, 10.210638440000025],
            [119.29493655800002, 10.209873999000024],
            [119.2936472880001, 10.210963468000045],
            [119.29389035300005, 10.211296083000036],
        ],
        [
            [119.30058251000003, 10.240400822000026],
            [119.30427133600006, 10.237404262000041],
            [119.30227027100011, 10.233870025000044],
            [119.29898252700002, 10.237945189000072],
            [119.30058251000003, 10.240400822000026],
        ],
        [
            [119.30161753200002, 10.242977061000033],
            [119.30067189500005, 10.241088607000052],
            [119.29930304800007, 10.24301339300007],
            [119.30022458500002, 10.242672109000068],
            [119.30161753200002, 10.242977061000033],
        ],
        [
            [119.32640627400008, 10.249936456000057],
            [119.33287749200008, 10.24111836700007],
            [119.32635628300011, 10.236565514000063],
            [119.32168837300003, 10.240615202000072],
            [119.32640627400008, 10.249936456000057],
        ],
        [
            [119.38404603900005, 10.253648763000058],
            [119.38687396900002, 10.250649226000064],
            [119.38620468300007, 10.247708250000073],
            [119.38323859700006, 10.251692682000055],
            [119.38404603900005, 10.253648763000058],
        ],
        [
            [119.36820553200005, 10.258557083000028],
            [119.36944088400003, 10.258075657000063],
            [119.36979861100008, 10.256449444000054],
            [119.36695024900007, 10.257009866000033],
            [119.36820553200005, 10.258557083000028],
        ],
        [
            [119.497389569, 10.26846101500007],
            [119.49024205600006, 10.265910862000055],
            [119.4895997970001, 10.266084790000036],
            [119.49550358700003, 10.270268156000043],
            [119.497389569, 10.26846101500007],
        ],
        [
            [119.35604726800011, 10.281940639000027],
            [119.36240275700004, 10.27672145300005],
            [119.3521128110001, 10.269186495000042],
            [119.35071465700003, 10.271830487000045],
            [119.35604726800011, 10.281940639000027],
        ],
        [
            [119.45198400400011, 10.284519475000025],
            [119.45276891300011, 10.282401899000035],
            [119.44964241800005, 10.283193202000064],
            [119.44972525800006, 10.284405255000024],
            [119.45198400400011, 10.284519475000025],
        ],
        [
            [119.36478362700007, 10.287060717000031],
            [119.36547683300012, 10.286298225000053],
            [119.36422463400004, 10.284917557000028],
            [119.36304535600004, 10.286071913000058],
            [119.36478362700007, 10.287060717000031],
        ],
        [
            [119.39129703300011, 10.306504999000026],
            [119.39297688300007, 10.302909628000066],
            [119.38892320500008, 10.301294145000043],
            [119.38887233000003, 10.30518831300003],
            [119.39129703300011, 10.306504999000026],
        ],
        [
            [119.48094666600002, 10.32006246900005],
            [119.4831780830001, 10.31869869600007],
            [119.48303141100007, 10.317797960000064],
            [119.48042266800007, 10.317735913000035],
            [119.48094666600002, 10.32006246900005],
        ],
        [
            [118.95344154800011, 10.334160649000069],
            [118.95370435400002, 10.333966821000047],
            [118.95314383000004, 10.33373405900005],
            [118.95307803000003, 10.334279060000028],
            [118.95344154800011, 10.334160649000069],
        ],
        [
            [118.94996677900008, 10.334523510000054],
            [118.95271075900007, 10.334496199000057],
            [118.94516181900008, 10.32984274200004],
            [118.93782478600008, 10.331733652000025],
            [118.94996677900008, 10.334523510000054],
        ],
        [
            [118.95851675000006, 10.334695026000077],
            [118.95713699800001, 10.332383794000066],
            [118.955276378, 10.333015698000054],
            [118.95891160500003, 10.335854021000046],
            [118.95851675000006, 10.334695026000077],
        ],
        [
            [118.960305134, 10.336783991000061],
            [118.96070581200001, 10.336211301000048],
            [118.9605960880001, 10.33557640600003],
            [118.95953953100002, 10.336659561000033],
            [118.960305134, 10.336783991000061],
        ],
        [
            [118.965662941, 10.364871184000037],
            [118.96574857700011, 10.364378852000073],
            [118.9650748030001, 10.364427141000021],
            [118.96520306800005, 10.364862696000046],
            [118.965662941, 10.364871184000037],
        ],
        [
            [119.14691864500003, 10.407685209000022],
            [119.14673020100008, 10.406399356000065],
            [119.14594878500009, 10.406361126000036],
            [119.14587669700006, 10.407329635000053],
            [119.14691864500003, 10.407685209000022],
        ],
        [
            [119.13740455800007, 10.41782089700007],
            [119.13820222600009, 10.419739173000039],
            [119.1416113250001, 10.416526720000036],
            [119.138087358, 10.406338258000062],
            [119.13740455800007, 10.41782089700007],
        ],
        [
            [119.015651047, 10.442270862000044],
            [119.0272478390001, 10.434992196000053],
            [119.02182073600011, 10.418097400000022],
            [119.01142274500012, 10.431854866000037],
            [119.015651047, 10.442270862000044],
        ],
        [
            [119.1582535660001, 10.459068975000037],
            [119.16139708000003, 10.458355127000061],
            [119.1619853310001, 10.457770329000027],
            [119.15703910900004, 10.458311102000039],
            [119.1582535660001, 10.459068975000037],
        ],
        [
            [119.00031996000007, 10.459214134000035],
            [119.00455545900002, 10.450604354000063],
            [118.99922483500006, 10.443599712000037],
            [118.99524532900011, 10.452685485000075],
            [119.00031996000007, 10.459214134000035],
        ],
        [
            [119.15572095800007, 10.459896996000055],
            [119.1565132290001, 10.458955315000026],
            [119.1545597060001, 10.457930267000052],
            [119.15469086700011, 10.459389714000054],
            [119.15572095800007, 10.459896996000055],
        ],
        [
            [119.16708522500005, 10.462691464000045],
            [119.17743985800007, 10.461485051000068],
            [119.18263168400006, 10.450806219000071],
            [119.16305026000009, 10.458106003000069],
            [119.16708522500005, 10.462691464000045],
        ],
        [
            [119.14993056300011, 10.466223220000074],
            [119.14982215000009, 10.46410301900005],
            [119.15344361700011, 10.460986477000063],
            [119.14808893000009, 10.462516486000027],
            [119.14993056300011, 10.466223220000074],
        ],
        [
            [119.16163483100001, 10.470764701000064],
            [119.1628034260001, 10.470071004000033],
            [119.1635403360001, 10.465971258000025],
            [119.16089590500007, 10.466815471000075],
            [119.16163483100001, 10.470764701000064],
        ],
        [
            [119.16550484400011, 10.481836116000068],
            [119.1653500540001, 10.480453015000023],
            [119.16481205500008, 10.480545016000065],
            [119.16442909400007, 10.481357162000052],
            [119.16550484400011, 10.481836116000068],
        ],
        [
            [119.15820660200006, 10.48236034000007],
            [119.16231648400003, 10.480890026000054],
            [119.15993252200008, 10.477291113000035],
            [119.157650579, 10.481784128000072],
            [119.15820660200006, 10.48236034000007],
        ],
        [
            [119.15216590600005, 10.491699599000071],
            [119.1536812920001, 10.490287661000025],
            [119.1521760170001, 10.488132794000023],
            [119.1517202770001, 10.490964344000076],
            [119.15216590600005, 10.491699599000071],
        ],
        [
            [119.99894768000001, 10.495288017000064],
            [119.9971698170001, 10.489104209000061],
            [119.99243443700004, 10.489754215000062],
            [119.99195829500002, 10.495918389000053],
            [119.99894768000001, 10.495288017000064],
        ],
        [
            [119.1330645270001, 10.50925077100004],
            [119.14452489100006, 10.504911803000027],
            [119.15185697100003, 10.492415612000059],
            [119.13225725500001, 10.493864981000058],
            [119.1330645270001, 10.50925077100004],
        ],
        [
            [119.06909012100004, 10.512517925000054],
            [119.08317641800011, 10.503408261000061],
            [119.07777443700002, 10.48523102400003],
            [119.05458172600004, 10.489331374000074],
            [119.06909012100004, 10.512517925000054],
        ],
        [
            [120.00848235700005, 10.517574255000056],
            [120.00865729500003, 10.515953755000055],
            [120.00585263200003, 10.514472426000054],
            [120.00518636200002, 10.516123888000038],
            [120.00848235700005, 10.517574255000056],
        ],
        [
            [119.2308534660001, 10.534972357000072],
            [119.23117516700006, 10.534087268000064],
            [119.22825534200001, 10.53183021700005],
            [119.228361962, 10.533178656000075],
            [119.2308534660001, 10.534972357000072],
        ],
        [
            [119.72729652100008, 10.536365399000033],
            [119.72968778300003, 10.534579053000073],
            [119.72462636600005, 10.533790554000063],
            [119.72515768400001, 10.535391767000021],
            [119.72729652100008, 10.536365399000033],
        ],
        [
            [120.02512922300002, 10.533649376000028],
            [120.02181796800005, 10.529815116000066],
            [120.01845731100002, 10.531746228000031],
            [120.02531001900002, 10.537889021000069],
            [120.02512922300002, 10.533649376000028],
        ],
        [
            [119.11625568000011, 10.542407210000022],
            [119.11767177800004, 10.539616911000053],
            [119.11580584, 10.538779290000036],
            [119.11544552400005, 10.54159183300004],
            [119.11625568000011, 10.542407210000022],
        ],
        [
            [119.73200110300002, 10.547925607000025],
            [119.7406059860001, 10.538959333000037],
            [119.73951225600001, 10.533781766000061],
            [119.73165905500002, 10.536668605000045],
            [119.73200110300002, 10.547925607000025],
        ],
        [
            [120.00709703900009, 10.549319351000065],
            [120.01013465400001, 10.548660055000028],
            [120.01451056500002, 10.544968604000076],
            [120.00945548300001, 10.542099620000045],
            [120.00709703900009, 10.549319351000065],
        ],
        [
            [119.70496109100009, 10.549548891000029],
            [119.7063401150001, 10.548947003000023],
            [119.70597731900011, 10.54808525900006],
            [119.70434445400008, 10.548298974000033],
            [119.70496109100009, 10.549548891000029],
        ],
        [
            [119.11096604400007, 10.554170136000039],
            [119.11542048600006, 10.552894476000063],
            [119.11541766000005, 10.552005396000027],
            [119.1114816060001, 10.551208552000048],
            [119.11096604400007, 10.554170136000039],
        ],
        [
            [119.19938596000009, 10.555941345000065],
            [119.20380442400005, 10.55288533700002],
            [119.20373967800003, 10.552263390000064],
            [119.19876821700007, 10.550806925000074],
            [119.19938596000009, 10.555941345000065],
        ],
        [
            [119.70754358500005, 10.562750373000029],
            [119.70843282400006, 10.556187426000065],
            [119.7026068240001, 10.554704424000022],
            [119.70320176100006, 10.559985933000064],
            [119.70754358500005, 10.562750373000029],
        ],
        [
            [119.7215824220001, 10.565766230000065],
            [119.71826758500004, 10.561066562000065],
            [119.71652776500002, 10.562873108000076],
            [119.71826408800007, 10.565150131000053],
            [119.7215824220001, 10.565766230000065],
        ],
        [
            [119.74503379300006, 10.566508959000032],
            [119.74697596600004, 10.559747103000063],
            [119.74063154600003, 10.55742904300007],
            [119.74231944600001, 10.56581568100006],
            [119.74503379300006, 10.566508959000032],
        ],
        [
            [119.71214283600011, 10.57374608200007],
            [119.71266093700001, 10.573369175000039],
            [119.71131636500002, 10.572507423000047],
            [119.7109796420001, 10.573117265000064],
            [119.71214283600011, 10.57374608200007],
        ],
        [
            [119.74677666900004, 10.587308896000025],
            [119.74949204500001, 10.581660162000048],
            [119.74562650500002, 10.57408083100006],
            [119.74257836200002, 10.580648392000057],
            [119.74677666900004, 10.587308896000025],
        ],
        [
            [119.16086065600007, 10.592758097000058],
            [119.1981608430001, 10.564341740000032],
            [119.11905021000007, 10.549454482000044],
            [119.1195294470001, 10.585107318000041],
            [119.16086065600007, 10.592758097000058],
        ],
        [
            [119.75071547200002, 10.597028718000047],
            [119.75224850400002, 10.594046584000068],
            [119.74745818400004, 10.588215670000068],
            [119.7462022950001, 10.590307489000054],
            [119.75071547200002, 10.597028718000047],
        ],
        [
            [119.82768619100011, 10.652520525000057],
            [119.90404578800008, 10.598038015000043],
            [119.98296169500009, 10.599934561000055],
            [120.00333612600002, 10.565115766000076],
            [119.93079263800007, 10.504099256000075],
            [119.90590907900003, 10.54562880100002],
            [119.88360022200004, 10.550825501000077],
            [119.92402407600002, 10.483319098000038],
            [119.85579421300008, 10.485197941000024],
            [119.87434919100008, 10.461080412000058],
            [119.80485340000007, 10.441238601000066],
            [119.76228283600005, 10.464395268000033],
            [119.74238961000003, 10.549665507000043],
            [119.79291545400008, 10.54675144600003],
            [119.82768619100011, 10.652520525000057],
        ],
        [
            [120.24608706600009, 10.674788703000047],
            [120.25403068800006, 10.661000386000069],
            [120.25576296700001, 10.63267139900006],
            [120.2467115720001, 10.632916390000048],
            [120.24608706600009, 10.674788703000047],
        ],
        [
            [119.60296464600003, 10.679929713000035],
            [119.60326193800006, 10.676563671000054],
            [119.60112922700011, 10.674086251000062],
            [119.5995558950001, 10.676471482000068],
            [119.60296464600003, 10.679929713000035],
        ],
        [
            [120.24642931500011, 10.67938392700006],
            [120.24633812600007, 10.681737614000042],
            [120.24741324500008, 10.682491582000068],
            [120.24698239100007, 10.680198437000058],
            [120.24642931500011, 10.67938392700006],
        ],
        [
            [119.58732226300003, 10.682926817000066],
            [119.58705628000007, 10.67676812600007],
            [119.58216779100007, 10.675084002000062],
            [119.585698911, 10.682258328000046],
            [119.58732226300003, 10.682926817000066],
        ],
        [
            [120.32867431600005, 10.681274414000029],
            [120.3255004880001, 10.682678223000039],
            [120.33227539100005, 10.682922363000046],
            [120.33172607400002, 10.681884766000053],
            [120.32867431600005, 10.681274414000029],
        ],
        [
            [119.29698036000002, 10.694154010000034],
            [119.29916060900007, 10.693265972000063],
            [119.2949907090001, 10.691619457000058],
            [119.29488807700011, 10.693146958000057],
            [119.29698036000002, 10.694154010000034],
        ],
        [
            [120.88772537200009, 10.69327104000007],
            [120.88600620400007, 10.69298759700007],
            [120.88598588700006, 10.694125863000068],
            [120.8869693370001, 10.694987019000052],
            [120.88772537200009, 10.69327104000007],
        ],
        [
            [120.27071370600004, 10.695079878000058],
            [120.27200718900008, 10.693117495000024],
            [120.27112845200008, 10.690681840000025],
            [120.26902402100006, 10.694326123000053],
            [120.27071370600004, 10.695079878000058],
        ],
        [
            [119.30798379500004, 10.70402630700005],
            [119.31190709700002, 10.694445511000026],
            [119.30379822700002, 10.688477179000074],
            [119.30216229100006, 10.69580284500006],
            [119.30798379500004, 10.70402630700005],
        ],
        [
            [120.964538532, 10.704698433000033],
            [120.9658303330001, 10.70397745200006],
            [120.964150517, 10.701885749000041],
            [120.96321173000001, 10.703141086000073],
            [120.964538532, 10.704698433000033],
        ],
        [
            [120.89008654500003, 10.70807557300003],
            [120.89095644600002, 10.706639512000038],
            [120.89089457700004, 10.70452690600007],
            [120.88797573900001, 10.707102003000045],
            [120.89008654500003, 10.70807557300003],
        ],
        [
            [120.26581969900008, 10.71283865600003],
            [120.2671322860001, 10.69557996900005],
            [120.25594433800006, 10.694080043000042],
            [120.25464837900006, 10.713060231000043],
            [120.26581969900008, 10.71283865600003],
        ],
        [
            [120.3140869130001, 10.716125489000035],
            [120.31249999900001, 10.71868896500007],
            [120.31530761700003, 10.719482422000056],
            [120.31610107400002, 10.717529297000056],
            [120.3140869130001, 10.716125489000035],
        ],
        [
            [120.77392578100012, 10.718322754000042],
            [120.77288818400007, 10.719299317000036],
            [120.77447509800004, 10.71990966800007],
            [120.77447509800004, 10.71868896500007],
            [120.77392578100012, 10.718322754000042],
        ],
        [
            [119.62643358500009, 10.722028648000048],
            [119.63579825900001, 10.719866970000055],
            [119.63385613900005, 10.710107687000061],
            [119.62274404100003, 10.71109350300003],
            [119.62643358500009, 10.722028648000048],
        ],
        [
            [120.77508544900002, 10.721923828000058],
            [120.77410888600002, 10.721679688000052],
            [120.77392578100012, 10.722290039000029],
            [120.77447509800004, 10.722717285000044],
            [120.77508544900002, 10.721923828000058],
        ],
        [
            [120.79124117600009, 10.72611567000007],
            [120.79517854700009, 10.725591103000056],
            [120.79587651300005, 10.72047770000006],
            [120.78926574000002, 10.727276173000064],
            [120.79124117600009, 10.72611567000007],
        ],
        [
            [119.69850003400006, 10.728203948000044],
            [119.70278710000002, 10.700496613000041],
            [119.69334253000011, 10.683585047000065],
            [119.6887271270001, 10.708143894000045],
            [119.69850003400006, 10.728203948000044],
        ],
        [
            [119.62731460600003, 10.732563417000051],
            [119.63473025400003, 10.730247133000034],
            [119.63485042100001, 10.727435528000058],
            [119.6287486550001, 10.728527808000024],
            [119.62731460600003, 10.732563417000051],
        ],
        [
            [120.90005692000011, 10.739189042000021],
            [120.90942424000002, 10.732777935000058],
            [120.90226768100001, 10.722398612000063],
            [120.89208449800003, 10.734106433000022],
            [120.90005692000011, 10.739189042000021],
        ],
        [
            [119.65713862000007, 10.748157],
            [119.65751265500012, 10.746696905000022],
            [119.66021083100009, 10.74463558900004],
            [119.654625656, 10.744518957000025],
            [119.65713862000007, 10.748157],
        ],
        [
            [121.06531916800009, 10.75680598100007],
            [121.06988733600008, 10.753894364000075],
            [121.06926859200007, 10.75031],
            [121.06265606900001, 10.751186226000073],
            [121.06531916800009, 10.75680598100007],
        ],
        [
            [119.29609906200005, 10.763345111000035],
            [119.29603811600009, 10.762152644000025],
            [119.29484249500001, 10.761006422000037],
            [119.29496584800006, 10.76240335500006],
            [119.29609906200005, 10.763345111000035],
        ],
        [
            [119.37442012600002, 10.796326623000027],
            [119.37606807000009, 10.795838916000037],
            [119.37653826700011, 10.795454391000021],
            [119.37452977100008, 10.794827603000044],
            [119.37442012600002, 10.796326623000027],
        ],
        [
            [119.64710832000003, 10.802953914000057],
            [119.64864839300003, 10.801092078000067],
            [119.6445594170001, 10.79703192900007],
            [119.6454758430001, 10.80279458900003],
            [119.64710832000003, 10.802953914000057],
        ],
        [
            [119.62193034900008, 10.814658525000027],
            [119.62381970000001, 10.812888943000075],
            [119.61949540100011, 10.813700432000076],
            [119.62014838900006, 10.814385128000026],
            [119.62193034900008, 10.814658525000027],
        ],
        [
            [120.88460416500004, 10.817053791000035],
            [120.88640064300012, 10.815726765000022],
            [120.88494038100009, 10.814380304000053],
            [120.88356553100004, 10.815931515000045],
            [120.88460416500004, 10.817053791000035],
        ],
        [
            [119.35192144300004, 10.823590411000055],
            [119.35225429600007, 10.822315166000067],
            [119.35155646900012, 10.821966233000069],
            [119.35058892800009, 10.823281869000027],
            [119.35192144300004, 10.823590411000055],
        ],
        [
            [119.32854516400005, 10.829669747000025],
            [119.333874207, 10.827598267000042],
            [119.32840922200012, 10.821334336000064],
            [119.32626929600008, 10.826536173000022],
            [119.32854516400005, 10.829669747000025],
        ],
        [
            [120.9822364040001, 10.829290502000049],
            [120.98559251200004, 10.81185761300003],
            [120.95867241700012, 10.817290293000042],
            [120.96176459600008, 10.827257228000065],
            [120.9822364040001, 10.829290502000049],
        ],
        [
            [119.35288580200006, 10.831189306000056],
            [119.3548578760001, 10.82792218800006],
            [119.35521484000003, 10.826278455000022],
            [119.3539440290001, 10.827436588000069],
            [119.35288580200006, 10.831189306000056],
        ],
        [
            [119.32929347100003, 10.832047502000023],
            [119.329170051, 10.830847594000033],
            [119.32828644000006, 10.83044164200004],
            [119.3278800700001, 10.831258689000038],
            [119.32929347100003, 10.832047502000023],
        ],
        [
            [119.23789171400006, 10.836314824000056],
            [119.23911809200001, 10.835392484000067],
            [119.23879979700007, 10.834132533000059],
            [119.23575294200009, 10.831067579000035],
            [119.23789171400006, 10.836314824000056],
        ],
        [
            [119.35006064200002, 10.836119402000065],
            [119.351879918, 10.834605976000034],
            [119.35104218400011, 10.829344835000029],
            [119.34653063500002, 10.832269418000067],
            [119.35006064200002, 10.836119402000065],
        ],
        [
            [119.62579422400006, 10.838149714000053],
            [119.64146762400003, 10.820678101000055],
            [119.63213325700008, 10.798097660000053],
            [119.62851487700004, 10.818444976000023],
            [119.61711427600005, 10.820999284000038],
            [119.62579422400006, 10.838149714000053],
        ],
        [
            [119.23174295400008, 10.841111513000044],
            [119.23171529500007, 10.841194813000072],
            [119.23195682200003, 10.84136323000007],
            [119.23187201500002, 10.84119481700003],
            [119.23174295400008, 10.841111513000044],
        ],
        [
            [119.30930495200005, 10.843868415000031],
            [119.311126811, 10.842084919000058],
            [119.31101492000005, 10.841648835000058],
            [119.30897123900002, 10.843173064000041],
            [119.30930495200005, 10.843868415000031],
        ],
        [
            [119.43061817000012, 10.846612442000037],
            [119.43206402900012, 10.846279855000034],
            [119.43009616300003, 10.843502417000025],
            [119.42902141500008, 10.84560091800006],
            [119.43061817000012, 10.846612442000037],
        ],
        [
            [119.30357145500011, 10.850168538000048],
            [119.30425459600008, 10.844097280000028],
            [119.29594740800007, 10.849736742000061],
            [119.30010567400006, 10.848702206000041],
            [119.30357145500011, 10.850168538000048],
        ],
        [
            [119.342110595, 10.850812967000024],
            [119.34359472400001, 10.849111046000075],
            [119.338628835, 10.845568986000046],
            [119.33893249700009, 10.847313266000072],
            [119.342110595, 10.850812967000024],
        ],
        [
            [119.36989917500011, 10.852977747000068],
            [119.36976078100008, 10.852618782000036],
            [119.36945832900005, 10.852678010000034],
            [119.36944560000006, 10.852893334000044],
            [119.36989917500011, 10.852977747000068],
        ],
        [
            [119.36765306500001, 10.85305005600003],
            [119.3689867270001, 10.853003836000028],
            [119.36936513700005, 10.852686303000041],
            [119.36893474900012, 10.852289986000073],
            [119.36765306500001, 10.85305005600003],
        ],
        [
            [119.37004482200007, 10.853856480000047],
            [119.37030444600009, 10.853777427000068],
            [119.37052382000002, 10.853574597000033],
            [119.37002490800012, 10.853443132000052],
            [119.37004482200007, 10.853856480000047],
        ],
        [
            [119.36865246800005, 10.858995684000035],
            [119.36860983400004, 10.857618987000023],
            [119.36737551200008, 10.856970102000048],
            [119.36776411400001, 10.858735510000031],
            [119.36865246800005, 10.858995684000035],
        ],
        [
            [119.3216973540001, 10.861110576000044],
            [119.32723442100007, 10.858466098000065],
            [119.31834989700008, 10.855885897000064],
            [119.3175001950001, 10.859884230000034],
            [119.3216973540001, 10.861110576000044],
        ],
        [
            [119.35667511800011, 10.861761600000023],
            [119.35633529400002, 10.858689121000054],
            [119.35428158200011, 10.858938113000022],
            [119.35406698300005, 10.860927317000062],
            [119.35667511800011, 10.861761600000023],
        ],
        [
            [119.63424981900005, 10.867567380000025],
            [119.63538131900009, 10.866704952000077],
            [119.6333185090001, 10.850795579000021],
            [119.62140500100008, 10.857998223000038],
            [119.63424981900005, 10.867567380000025],
        ],
        [
            [119.32566251800006, 10.869751540000038],
            [119.32660359200008, 10.869674401000054],
            [119.32670649700003, 10.86951822900005],
            [119.32473455200011, 10.86950347100003],
            [119.32566251800006, 10.869751540000038],
        ],
        [
            [119.36221747000002, 10.870491423000033],
            [119.36431532300003, 10.86963995900004],
            [119.36553804200003, 10.867894245000059],
            [119.35866247500007, 10.868707017000077],
            [119.36221747000002, 10.870491423000033],
        ],
        [
            [119.31478326400008, 10.870222670000032],
            [119.31433937300005, 10.869347729000026],
            [119.31152835500006, 10.870824782000057],
            [119.31286373600005, 10.87158633100006],
            [119.31478326400008, 10.870222670000032],
        ],
        [
            [119.22547539700008, 10.871654367000076],
            [119.2257460080001, 10.871300981000047],
            [119.22560521000003, 10.870735973000023],
            [119.22526111400009, 10.871489537000059],
            [119.22547539700008, 10.871654367000076],
        ],
        [
            [119.22190325400004, 10.873557122000022],
            [119.22189660400011, 10.872660145000054],
            [119.22178586000007, 10.872399132000055],
            [119.22170380500006, 10.873562851000031],
            [119.22190325400004, 10.873557122000022],
        ],
        [
            [119.30670729100007, 10.875400417000037],
            [119.3072805700001, 10.875425103000055],
            [119.3076849040001, 10.875026235000064],
            [119.30680431700011, 10.87494861600004],
            [119.30670729100007, 10.875400417000037],
        ],
        [
            [120.93776753600002, 10.876654707000057],
            [120.94072485600009, 10.87379149000003],
            [120.93575261600006, 10.87235873800006],
            [120.93543355800011, 10.875411204000045],
            [120.93776753600002, 10.876654707000057],
        ],
        [
            [119.34601018800004, 10.880331553000076],
            [119.34124930700011, 10.861830734000023],
            [119.3332356950001, 10.863482958000077],
            [119.33200504700005, 10.876426199000036],
            [119.34601018800004, 10.880331553000076],
        ],
        [
            [119.24048876400002, 10.881444262000059],
            [119.24039933900008, 10.88156568900007],
            [119.2404927660001, 10.881671613000037],
            [119.24053670400008, 10.881568963000063],
            [119.24048876400002, 10.881444262000059],
        ],
        [
            [119.23997669300002, 10.881789592000075],
            [119.24023087900002, 10.881283230000065],
            [119.23972305400002, 10.880977605000055],
            [119.23955982900009, 10.881565261000048],
            [119.23997669300002, 10.881789592000075],
        ],
        [
            [119.24005503100011, 10.881840511000064],
            [119.24001211400002, 10.881965649000051],
            [119.24027990500008, 10.88209708900007],
            [119.24030525400008, 10.882011155000043],
            [119.24005503100011, 10.881840511000064],
        ],
        [
            [119.61921468700007, 10.885856143000069],
            [119.61969699600002, 10.885222816000066],
            [119.61959611300006, 10.880757686000038],
            [119.61725509500002, 10.87815414000005],
            [119.61921468700007, 10.885856143000069],
        ],
        [
            [119.24724931500009, 10.886266104000072],
            [119.2469471500001, 10.886074804000032],
            [119.24686723400009, 10.886089845000072],
            [119.2471694190001, 10.886546285000065],
            [119.24724931500009, 10.886266104000072],
        ],
        [
            [119.32059208700002, 10.884592895000026],
            [119.32603136900002, 10.88205272700003],
            [119.32990116500002, 10.876228597000022],
            [119.321564125, 10.877889953000022],
            [119.32059208700002, 10.884592895000026],
        ],
        [
            [121.05246082500003, 10.889859174000037],
            [121.0522652840001, 10.890339268000048],
            [121.05241717600006, 10.890960308000047],
            [121.05259814600004, 10.890298396000048],
            [121.05246082500003, 10.889859174000037],
        ],
        [
            [119.3405667620001, 10.891203272000041],
            [119.34102737900002, 10.89032196200003],
            [119.34103253600006, 10.889418913000043],
            [119.33961050700009, 10.890385781000077],
            [119.3405667620001, 10.891203272000041],
        ],
        [
            [121.05198241900007, 10.89223918600004],
            [121.05215507300011, 10.891730495000047],
            [121.05214672700004, 10.891035903000045],
            [121.05157048100011, 10.891705998000077],
            [121.05198241900007, 10.89223918600004],
        ],
        [
            [121.19795161400009, 10.893401876000041],
            [121.20733142000006, 10.889241625000068],
            [121.20992833500009, 10.883387921000065],
            [121.19911955700002, 10.879710235000061],
            [121.19795161400009, 10.893401876000041],
        ],
        [
            [121.05098237000004, 10.896405555000058],
            [121.05150565200006, 10.89512026400007],
            [121.04968094700007, 10.891204819000052],
            [121.05052361500009, 10.888567113000022],
            [121.0463095230001, 10.887985169000046],
            [121.05098237000004, 10.896405555000058],
        ],
        [
            [119.62140353300003, 10.90271714100004],
            [119.62287975900006, 10.895866051000041],
            [119.61989454400009, 10.889809124000067],
            [119.61863458000005, 10.898107701000072],
            [119.62140353300003, 10.90271714100004],
        ],
        [
            [120.99432373000002, 10.902709961000028],
            [120.99371337900004, 10.902709961000028],
            [120.99328613300008, 10.903320312000062],
            [120.99407958900008, 10.903686523000033],
            [120.99432373000002, 10.902709961000028],
        ],
        [
            [119.29556094500003, 10.906516224000029],
            [119.29642477300001, 10.906139513000028],
            [119.29390763600009, 10.905712882000046],
            [119.29500621300008, 10.90648574200003],
            [119.29556094500003, 10.906516224000029],
        ],
        [
            [121.06687377700007, 10.90799989900006],
            [121.06558187000007, 10.808445487000029],
            [121.02349774700008, 10.799509579000073],
            [121.00463535400002, 10.856974440000045],
            [121.04606698600003, 10.87252558800003],
            [121.06687377700007, 10.90799989900006],
        ],
        [
            [121.06601946800004, 10.886696586000028],
            [121.0641504680001, 10.885593269000026],
            [121.06404712800008, 10.884246787000052],
            [121.0656574090001, 10.884112842000036],
            [121.06601946800004, 10.886696586000028],
        ],
        [
            [119.29460689000007, 10.909723480000025],
            [119.2939038290001, 10.909477293000066],
            [119.29512515500005, 10.910741029000064],
            [119.29517634600006, 10.910253842000031],
            [119.29460689000007, 10.909723480000025],
        ],
        [
            [121.01620533800008, 10.910735873000021],
            [121.0143487690001, 10.90966594400004],
            [121.01319917100011, 10.910604878000072],
            [121.0162263420001, 10.91113215100006],
            [121.01620533800008, 10.910735873000021],
        ],
        [
            [121.0169437730001, 10.913323825000077],
            [121.01720692100002, 10.913038287000063],
            [121.0168967620001, 10.912483460000033],
            [121.01650897900004, 10.912749949000045],
            [121.0169437730001, 10.913323825000077],
        ],
        [
            [119.50285922500007, 10.91365501200005],
            [119.50119360200006, 10.912667536000072],
            [119.50207400200009, 10.915629964000061],
            [119.50270455900011, 10.915582375000042],
            [119.50285922500007, 10.91365501200005],
        ],
        [
            [121.0375845860001, 10.916027992000068],
            [121.04582994600003, 10.913474763000067],
            [121.04646317600009, 10.908964775000072],
            [121.044196596, 10.906152415000065],
            [121.0375845860001, 10.916027992000068],
        ],
        [
            [119.5146809040001, 10.920032896000066],
            [119.51423076800006, 10.919784006000043],
            [119.51361278900004, 10.920277978000058],
            [119.5140934420001, 10.920633673000054],
            [119.5146809040001, 10.920032896000066],
        ],
        [
            [119.2948778220001, 10.926026083000068],
            [119.29769886000008, 10.922036323000043],
            [119.28654476800011, 10.919505869000034],
            [119.29331749200003, 10.926584516000048],
            [119.2948778220001, 10.926026083000068],
        ],
        [
            [119.35376276000011, 10.930592900000022],
            [119.354592969, 10.927554477000058],
            [119.34951445500008, 10.927189843000065],
            [119.35040438600004, 10.930018940000025],
            [119.35376276000011, 10.930592900000022],
        ],
        [
            [119.34355746800009, 10.935933430000034],
            [119.34391507500004, 10.93318040400004],
            [119.34222209100005, 10.931340527000032],
            [119.34227688900012, 10.93346510200007],
            [119.34355746800009, 10.935933430000034],
        ],
        [
            [119.35361904700005, 10.937803759000076],
            [119.35452068200004, 10.936523634000025],
            [119.35334476800006, 10.93569954000003],
            [119.3522150550001, 10.937000242000067],
            [119.35361904700005, 10.937803759000076],
        ],
        [
            [119.34019713100008, 10.938911233000056],
            [119.34216555400008, 10.937031215000047],
            [119.3377846940001, 10.93117053800006],
            [119.3375478160001, 10.935610907000068],
            [119.34019713100008, 10.938911233000056],
        ],
        [
            [119.31874892300004, 10.940448181000022],
            [119.31818560700003, 10.939955518000033],
            [119.317173066, 10.939389909000056],
            [119.31769108200001, 10.940250718000073],
            [119.31874892300004, 10.940448181000022],
        ],
        [
            [119.22940699300011, 10.959383377000051],
            [119.230345682, 10.958677856000065],
            [119.22942220700008, 10.957460680000054],
            [119.22818409500007, 10.958359185000063],
            [119.22940699300011, 10.959383377000051],
        ],
        [
            [121.23253500100009, 10.959425724000027],
            [121.2395030890001, 10.954887314000075],
            [121.23883436400001, 10.952123156000027],
            [121.231207358, 10.954112593000048],
            [121.23253500100009, 10.959425724000027],
        ],
        [
            [119.71419937900009, 10.963219164000066],
            [119.71591896900009, 10.95503706200003],
            [119.71322401500004, 10.936665722000043],
            [119.70583930400005, 10.954265816000031],
            [119.71419937900009, 10.963219164000066],
        ],
        [
            [119.61330631200008, 10.963207125000054],
            [119.615373868, 10.961145410000029],
            [119.61813564400006, 10.947338082000044],
            [119.61213897100004, 10.954150697000046],
            [119.61330631200008, 10.963207125000054],
        ],
        [
            [120.723918894, 10.971570295000049],
            [120.73407366900005, 10.965931860000069],
            [120.72631453800011, 10.953233960000034],
            [120.71850712100002, 10.965223861000027],
            [120.723918894, 10.971570295000049],
        ],
        [
            [119.52925716400011, 10.973817876000055],
            [119.53596679800012, 10.972585756000058],
            [119.53682177600001, 10.971746475000032],
            [119.52827242800004, 10.972723554000027],
            [119.52925716400011, 10.973817876000055],
        ],
        [
            [121.21718262900004, 10.980083414000035],
            [121.23443263800004, 10.970887363000031],
            [121.2257783880001, 10.956924438000044],
            [121.2096838440001, 10.969567114000029],
            [121.21718262900004, 10.980083414000035],
        ],
        [
            [119.57348795400003, 10.98223063000006],
            [119.57500160100005, 10.982014366000044],
            [119.5740896740001, 10.98043978000004],
            [119.57314717500003, 10.982004251000035],
            [119.57348795400003, 10.98223063000006],
        ],
        [
            [119.63694714300004, 10.990741856000056],
            [119.63836443600007, 10.987757421000026],
            [119.63791463100006, 10.98634580700002],
            [119.63602268500006, 10.99022033700004],
            [119.63694714300004, 10.990741856000056],
        ],
        [
            [119.5907977600001, 10.992747501000053],
            [119.59169391400007, 10.992692917000056],
            [119.59158893900008, 10.990426352000043],
            [119.59066453900004, 10.990457296000045],
            [119.5907977600001, 10.992747501000053],
        ],
        [
            [119.595069426, 10.99781011600004],
            [119.59601592400008, 10.997728687000063],
            [119.59619865200011, 10.996848493000073],
            [119.59525217900011, 10.996701718000054],
            [119.595069426, 10.99781011600004],
        ],
        [
            [120.94945859600011, 10.99851134100004],
            [120.96490042300002, 10.98338730000006],
            [120.95873946800009, 10.974529414000074],
            [120.93809946100009, 10.985590671000068],
            [120.94945859600011, 10.99851134100004],
        ],
        [
            [121.09872050800004, 11.000120953000021],
            [121.10340165100001, 10.997460110000077],
            [121.10253539000007, 10.995520818000045],
            [121.097155068, 10.996787804000064],
            [121.09872050800004, 11.000120953000021],
        ],
        [
            [120.77248792600005, 11.005481917000054],
            [120.77422567100007, 11.000148349000028],
            [120.76385905900008, 10.997549460000073],
            [120.76374884900008, 10.999708561000034],
            [120.77248792600005, 11.005481917000054],
        ],
        [
            [119.69575757300004, 11.007628513000043],
            [119.69714772400005, 11.000447832000077],
            [119.69671247000008, 10.995838564000053],
            [119.69508622, 11.000137065000047],
            [119.69575757300004, 11.007628513000043],
        ],
        [
            [120.82843846900005, 11.01354837200006],
            [120.83111511300001, 11.008213193000074],
            [120.81772947200011, 11.003550486000051],
            [120.81610401400008, 11.009148486000072],
            [120.82843846900005, 11.01354837200006],
        ],
        [
            [119.35452258600003, 11.014918611000041],
            [119.35521551700003, 11.01515052600007],
            [119.35590949200002, 11.01438556200003],
            [119.3547752820001, 11.013666827000065],
            [119.35452258600003, 11.014918611000041],
        ],
        [
            [119.59323850600003, 11.012836200000038],
            [119.59109206000005, 11.013954755000043],
            [119.59371614600002, 11.017414862000066],
            [119.59544021800002, 11.01539925000003],
            [119.59323850600003, 11.012836200000038],
        ],
        [
            [119.33482766400004, 11.017412716000024],
            [119.33539803500003, 11.016160435000074],
            [119.33381196700009, 11.015176370000063],
            [119.3340185730001, 11.016983993000053],
            [119.33482766400004, 11.017412716000024],
        ],
        [
            [119.29489770400005, 11.02150944300007],
            [119.29496063200008, 11.021489345000077],
            [119.2946662170001, 11.021245516000022],
            [119.2946764080001, 11.021480705000045],
            [119.29489770400005, 11.02150944300007],
        ],
        [
            [119.30640820400004, 11.021852499000033],
            [119.30759837200003, 11.020551813000054],
            [119.30620613600001, 11.018708377000053],
            [119.3057939470001, 11.020671884000024],
            [119.30640820400004, 11.021852499000033],
        ],
        [
            [119.2915019300001, 11.02299570300005],
            [119.30241864600009, 11.01519739300005],
            [119.30504676400005, 11.01563820900003],
            [119.28783533, 10.980338514000039],
            [119.30059564800001, 10.959223012000052],
            [119.291809467, 10.948045243000024],
            [119.26233931900003, 10.983084409000071],
            [119.2915019300001, 11.02299570300005],
        ],
        [
            [119.66532691400005, 11.027172113000063],
            [119.67136739800003, 11.021800891000055],
            [119.66822410600003, 11.018927700000063],
            [119.66484217400011, 11.020718869000063],
            [119.66532691400005, 11.027172113000063],
        ],
        [
            [119.73100162600008, 11.03025790700002],
            [119.74657310600003, 11.017945815000076],
            [119.73643688400011, 11.007981175000054],
            [119.72551941000006, 11.021509749000074],
            [119.73100162600008, 11.03025790700002],
        ],
        [
            [121.14116836500011, 11.037097273000029],
            [121.1435370150001, 11.03530096000003],
            [121.141042835, 11.03332819600007],
            [121.1392686690001, 11.035707256000023],
            [121.14116836500011, 11.037097273000029],
        ],
        [
            [119.30507100200009, 11.039563058000056],
            [119.30487124600006, 11.039206179000075],
            [119.30452382300007, 11.039545338000039],
            [119.3048153850001, 11.039815662000024],
            [119.30507100200009, 11.039563058000056],
        ],
        [
            [120.86792700900003, 11.042883252000024],
            [120.87240905500005, 11.039832212000022],
            [120.87031726400005, 11.037506741000072],
            [120.86558891600009, 11.03948271400003],
            [120.86792700900003, 11.042883252000024],
        ],
        [
            [119.30383361400004, 11.043164008000076],
            [119.3044877530001, 11.042185347000043],
            [119.30464163600004, 11.039693123000063],
            [119.30321059900007, 11.042307227000038],
            [119.30383361400004, 11.043164008000076],
        ],
        [
            [119.73342782200007, 11.046997573000056],
            [119.73265061200004, 11.048096853000061],
            [119.7332430890001, 11.048653154000021],
            [119.73375636500009, 11.047681136000051],
            [119.73342782200007, 11.046997573000056],
        ],
        [
            [119.30516965000004, 11.04911091100007],
            [119.30691870800001, 11.047263576000034],
            [119.30458427000008, 11.044120914000075],
            [119.30340904800005, 11.046082009000031],
            [119.30516965000004, 11.04911091100007],
        ],
        [
            [114.28839997700004, 11.053735533000065],
            [114.28976767900008, 11.051458195000066],
            [114.27790168600006, 11.05063427600004],
            [114.284325168, 11.056262802000049],
            [114.28839997700004, 11.053735533000065],
        ],
        [
            [119.32454528300002, 11.056749779000029],
            [119.32447475200001, 11.056302292000055],
            [119.323551382, 11.055563843000073],
            [119.32364554500009, 11.056815246000042],
            [119.32454528300002, 11.056749779000029],
        ],
        [
            [119.70814201000007, 11.057499886000073],
            [119.72574598200003, 11.042336315000057],
            [119.72359502600011, 11.029554060000066],
            [119.69849972500003, 11.031124086000034],
            [119.70814201000007, 11.057499886000073],
        ],
        [
            [119.7060789630001, 11.06102093100003],
            [119.70593875300005, 11.062566401000026],
            [119.70630709900001, 11.063127790000067],
            [119.70659461900004, 11.061585636000075],
            [119.7060789630001, 11.06102093100003],
        ],
        [
            [119.37255825300008, 11.069827708000048],
            [119.37501656600011, 11.063850187000071],
            [119.37198568600002, 11.060160039000039],
            [119.36925159200007, 11.06184423600007],
            [119.37255825300008, 11.069827708000048],
        ],
        [
            [119.38618075400007, 11.071164897000074],
            [119.38632741000004, 11.071209510000074],
            [119.3864871610001, 11.071035407000068],
            [119.38600984900006, 11.071036110000023],
            [119.38618075400007, 11.071164897000074],
        ],
        [
            [119.38587636300008, 11.071290151000028],
            [119.38527539200004, 11.071265916000073],
            [119.3852747630001, 11.071527272000026],
            [119.38569253900005, 11.07170771400007],
            [119.38587636300008, 11.071290151000028],
        ],
        [
            [119.68450696900004, 11.072104945000035],
            [119.69671161300005, 11.06443631600007],
            [119.67465945100003, 11.02868260200006],
            [119.6718679390001, 11.055049150000059],
            [119.68450696900004, 11.072104945000035],
        ],
        [
            [119.39103220900006, 11.07564387800005],
            [119.3905421070001, 11.075437972000032],
            [119.39031216100011, 11.076442287000077],
            [119.39097541100011, 11.076033663000032],
            [119.39103220900006, 11.07564387800005],
        ],
        [
            [119.38507667400006, 11.07507143500004],
            [119.38449937700011, 11.076076516000057],
            [119.38484974500011, 11.076861561000044],
            [119.38550463100012, 11.076254659000028],
            [119.38507667400006, 11.07507143500004],
        ],
        [
            [119.72915498400005, 11.07893477600004],
            [119.73892914100009, 11.073009411000044],
            [119.73857747300008, 11.065366746000052],
            [119.72793710100007, 11.068655221000029],
            [119.72915498400005, 11.07893477600004],
        ],
        [
            [119.71106904600003, 11.08348385100004],
            [119.71154073000002, 11.085634361000075],
            [119.7118852210001, 11.086073338000062],
            [119.71178113700012, 11.084654556000032],
            [119.71106904600003, 11.08348385100004],
        ],
        [
            [119.67443488600009, 11.091257290000044],
            [119.67270719200008, 11.088592278000021],
            [119.66995907800003, 11.088624515000049],
            [119.67132254300009, 11.091585010000074],
            [119.67443488600009, 11.091257290000044],
        ],
        [
            [119.7134975560001, 11.094508439000037],
            [119.71344907800005, 11.093707504000065],
            [119.71282394900004, 11.092035260000046],
            [119.712681298, 11.094438215000025],
            [119.7134975560001, 11.094508439000037],
        ],
        [
            [119.34141173800003, 11.094551005000028],
            [119.34055857800001, 11.094400452000059],
            [119.34046890400009, 11.096438301000035],
            [119.3411791200001, 11.095902394000063],
            [119.34141173800003, 11.094551005000028],
        ],
        [
            [120.94977701900007, 11.095294909000074],
            [120.94869643100003, 11.093738801000029],
            [120.94764688600003, 11.09561648500005],
            [120.94874185600008, 11.096577684000067],
            [120.94977701900007, 11.095294909000074],
        ],
        [
            [119.392306415, 11.098549238000032],
            [119.40697763100002, 11.085682124000073],
            [119.40483966500005, 11.073536527000044],
            [119.38743376500008, 11.090674903000036],
            [119.392306415, 11.098549238000032],
        ],
        [
            [119.58496897100008, 11.100130372000024],
            [119.58907778600008, 11.08770357000003],
            [119.62428619400009, 11.085777114000052],
            [119.6336530420001, 10.994936990000042],
            [119.62925404100008, 11.023698005000028],
            [119.61030706200006, 11.005013420000068],
            [119.56127064200007, 11.04364],
            [119.58496897100008, 11.100130372000024],
        ],
        [
            [119.62104003900004, 11.070151202000034],
            [119.62023547000001, 11.07108450100003],
            [119.61896442200009, 11.06988214300003],
            [119.62023534500008, 11.06938851600006],
            [119.62104003900004, 11.070151202000034],
        ],
        [
            [119.3570265510001, 11.100298661000068],
            [119.35687362400006, 11.099648047000073],
            [119.35597360000008, 11.099656910000022],
            [119.35632814600001, 11.101244550000047],
            [119.3570265510001, 11.100298661000068],
        ],
        [
            [119.59953845700011, 11.098858035000035],
            [119.60024254400003, 11.095127157000036],
            [119.59769511700006, 11.094348315000047],
            [119.59767625200004, 11.101265625000053],
            [119.59953845700011, 11.098858035000035],
        ],
        [
            [119.58914928700005, 11.100713713000061],
            [119.5885192400001, 11.101022812000053],
            [119.588694228, 11.101595269000029],
            [119.58952261000002, 11.101503708000052],
            [119.58914928700005, 11.100713713000061],
        ],
        [
            [120.69489228300006, 11.105368181000074],
            [120.69751096000005, 11.103764221000063],
            [120.69746765500008, 11.10244233000003],
            [120.69440571300004, 11.102368409000064],
            [120.69489228300006, 11.105368181000074],
        ],
        [
            [119.40610167700004, 11.107608233000065],
            [119.40488355200011, 11.103246140000067],
            [119.40543532800007, 11.09884429400006],
            [119.40101591100006, 11.105661703000067],
            [119.40610167700004, 11.107608233000065],
        ],
        [
            [119.60941485100011, 11.10816544000005],
            [119.6094935970001, 11.105922458000066],
            [119.6069844970001, 11.105909634000056],
            [119.60668239000006, 11.107830353000054],
            [119.60941485100011, 11.10816544000005],
        ],
        [
            [119.30585533900012, 11.109645072000035],
            [119.30655743600005, 11.107127666000054],
            [119.306384535, 11.106465208000031],
            [119.30497805700008, 11.111241972000073],
            [119.30585533900012, 11.109645072000035],
        ],
        [
            [119.54110432100003, 11.111922959000026],
            [119.54063867500008, 11.110193667000033],
            [119.5391312700001, 11.110568221000051],
            [119.54001067200011, 11.111796512000069],
            [119.54110432100003, 11.111922959000026],
        ],
        [
            [119.3302386360001, 11.11892417000007],
            [119.33544062100009, 11.116698666000048],
            [119.33673172800002, 11.112875174000067],
            [119.32659452500002, 11.115764114000058],
            [119.3302386360001, 11.11892417000007],
        ],
        [
            [119.75201683600005, 11.119838901000037],
            [119.7505576850001, 11.115449234000039],
            [119.74775642500003, 11.116768621000062],
            [119.74873308300005, 11.118808888000046],
            [119.75201683600005, 11.119838901000037],
        ],
        [
            [119.70000078800001, 11.123747928000057],
            [119.70182939400001, 11.120698749000042],
            [119.6949361290001, 11.119944370000042],
            [119.69718699400005, 11.123427703000061],
            [119.70000078800001, 11.123747928000057],
        ],
        [
            [119.39093494500003, 11.12485840100004],
            [119.39406480500008, 11.123961266000038],
            [119.3946793660001, 11.119203993000042],
            [119.390793142, 11.119823705000044],
            [119.39093494500003, 11.12485840100004],
        ],
        [
            [119.68776960900004, 11.123053654000046],
            [119.69796373200006, 11.093050215000062],
            [119.67686344200001, 11.075963139000066],
            [119.68652669700009, 11.089538143000027],
            [119.66693430400005, 11.121541241000045],
            [119.68776960900004, 11.123053654000046],
        ],
        [
            [119.25530605800009, 11.126209250000045],
            [119.26029711300009, 11.121691121000026],
            [119.26125848800007, 11.111691558000075],
            [119.24823936300004, 11.12434582700007],
            [119.25530605800009, 11.126209250000045],
        ],
        [
            [121.14375385300002, 11.126772427000049],
            [121.14895716500007, 11.119963459000076],
            [121.14312629000005, 11.11798077700007],
            [121.14076241400005, 11.12165890500006],
            [121.14375385300002, 11.126772427000049],
        ],
        [
            [119.66035087300008, 11.12794798300007],
            [119.6608168780001, 11.127384145000065],
            [119.65965898600007, 11.125750775000029],
            [119.65860240600011, 11.127687233000074],
            [119.66035087300008, 11.12794798300007],
        ],
        [
            [119.33126102000006, 11.131506269000056],
            [119.33542089700006, 11.131190919000062],
            [119.33674759400003, 11.126223080000045],
            [119.33012093100001, 11.128006439000046],
            [119.33126102000006, 11.131506269000056],
        ],
        [
            [119.41963413500002, 11.135651174000031],
            [119.41929631100004, 11.135118329000022],
            [119.41873793600007, 11.134864650000054],
            [119.4186041690001, 11.135587142000077],
            [119.41963413500002, 11.135651174000031],
        ],
        [
            [119.31943456700003, 11.137266428000032],
            [119.32051039900011, 11.135360886000058],
            [119.3144072230001, 11.128694321000069],
            [119.31532800200011, 11.133526957000072],
            [119.31943456700003, 11.137266428000032],
        ],
        [
            [119.6569046830001, 11.139400685000055],
            [119.65886788500006, 11.135013186000037],
            [119.65791809200005, 11.133306197000024],
            [119.65463870700012, 11.135831655000061],
            [119.6569046830001, 11.139400685000055],
        ],
        [
            [119.24908447200005, 11.12689209000007],
            [119.23791503900009, 11.136718750000057],
            [119.23791503900009, 11.140319825000063],
            [119.24847412100007, 11.133911133000026],
            [119.24908447200005, 11.12689209000007],
        ],
        [
            [119.318079796, 11.14012634200003],
            [119.31923162800001, 11.139228875000072],
            [119.31916503600007, 11.137593034000076],
            [119.31776729400008, 11.137806089000037],
            [119.318079796, 11.14012634200003],
        ],
        [
            [119.31828880100011, 11.14010956900006],
            [119.3179879170001, 11.140444384000034],
            [119.31794021600001, 11.140809802000035],
            [119.31814019500007, 11.140739599000028],
            [119.31828880100011, 11.14010956900006],
        ],
        [
            [119.66773934900004, 11.141615083000033],
            [119.66895408000005, 11.138052562000041],
            [119.6678381700001, 11.13741598200005],
            [119.66557087000001, 11.13874480100003],
            [119.66773934900004, 11.141615083000033],
        ],
        [
            [119.55702781100001, 11.144116105000023],
            [119.55540152700007, 11.143611393000072],
            [119.5549949220001, 11.143740405000074],
            [119.55647751600009, 11.145758662000048],
            [119.55702781100001, 11.144116105000023],
        ],
        [
            [119.390162228, 11.146418690000075],
            [119.39093278300004, 11.145983890000025],
            [119.39144182700011, 11.144462545000067],
            [119.38979582400009, 11.144269590000022],
            [119.390162228, 11.146418690000075],
        ],
        [
            [119.55437268600008, 11.146767433000036],
            [119.55370297200011, 11.147025474000031],
            [119.55397784800005, 11.14829267500005],
            [119.55501832400012, 11.147729618000028],
            [119.55437268600008, 11.146767433000036],
        ],
        [
            [119.69684424200011, 11.158238178000033],
            [119.70004468700006, 11.157116400000064],
            [119.69010078300005, 11.149221773000022],
            [119.69477378900001, 11.15792035100003],
            [119.69684424200011, 11.158238178000033],
        ],
        [
            [119.3199266470001, 11.159263923000026],
            [119.3219678160001, 11.143474209000033],
            [119.30519879600001, 11.143391093000048],
            [119.3096150990001, 11.155722625000067],
            [119.3199266470001, 11.159263923000026],
        ],
        [
            [119.54020591400001, 11.168734366000024],
            [119.54241891400011, 11.167275069000027],
            [119.54049073500005, 11.164552683000068],
            [119.53912113100012, 11.166189021000037],
            [119.54020591400001, 11.168734366000024],
        ],
        [
            [119.65091785600009, 11.167057563000071],
            [119.65360541400003, 11.162552515000073],
            [119.65247654400002, 11.16051449500003],
            [119.64928806400007, 11.16906846300003],
            [119.65091785600009, 11.167057563000071],
        ],
        [
            [119.66507671900001, 11.170125688000041],
            [119.66498053600003, 11.169775955000034],
            [119.66446281700007, 11.170161200000052],
            [119.66489860000001, 11.170397954000066],
            [119.66507671900001, 11.170125688000041],
        ],
        [
            [120.97864360400001, 11.173845162000077],
            [120.98737833700011, 11.154232208000053],
            [120.94481378600005, 11.135546356000077],
            [120.942206037, 11.158914055000025],
            [120.97864360400001, 11.173845162000077],
        ],
        [
            [119.67077805600002, 11.174157158000071],
            [119.67261763600004, 11.172057321000068],
            [119.67214369200008, 11.166364929000054],
            [119.66735378600004, 11.169908373000055],
            [119.67077805600002, 11.174157158000071],
        ],
        [
            [119.54927693200011, 11.173826090000034],
            [119.55127105600002, 11.16666280100003],
            [119.54144078000002, 11.157004329000074],
            [119.54276498900003, 11.164343809000059],
            [119.54927693200011, 11.173826090000034],
        ],
        [
            [119.29216868800006, 11.179853268000045],
            [119.2923469750001, 11.178699152000036],
            [119.29167927200001, 11.178209716000026],
            [119.29185838500007, 11.179751875000022],
            [119.29216868800006, 11.179853268000045],
        ],
        [
            [119.67608474800011, 11.190154179000046],
            [119.67529127900002, 11.18701438000005],
            [119.67173845400009, 11.187256133000062],
            [119.67564321500004, 11.19082521100006],
            [119.67608474800011, 11.190154179000046],
        ],
        [
            [119.5987259740001, 11.196637718000034],
            [119.62527642000009, 11.162152394000032],
            [119.56215374100009, 11.138198758000044],
            [119.55613454600007, 11.173240365000026],
            [119.5987259740001, 11.196637718000034],
        ],
        [
            [120.90649414000006, 11.202697754000042],
            [120.90551757800006, 11.203125001000046],
            [120.90612792900004, 11.20428466800007],
            [120.90667724600007, 11.204101563000052],
            [120.90649414000006, 11.202697754000042],
        ],
        [
            [119.68675836600005, 11.206932018000032],
            [119.68731120100006, 11.206339816000025],
            [119.68623481700001, 11.205827354000064],
            [119.6858027290001, 11.206537877000073],
            [119.68675836600005, 11.206932018000032],
        ],
        [
            [119.33696592600006, 11.20780022200006],
            [119.34070756400001, 11.200628251000069],
            [119.33650121700009, 11.194366412000022],
            [119.33459423600004, 11.20491570400003],
            [119.33696592600006, 11.20780022200006],
        ],
        [
            [119.37984427200001, 11.210303983000074],
            [119.37949428900004, 11.208459713000025],
            [119.37812952800004, 11.208203222000066],
            [119.3781697170001, 11.210028226000077],
            [119.37984427200001, 11.210303983000074],
        ],
        [
            [120.68785135900009, 11.213035923000064],
            [120.68952190400012, 11.21159426500003],
            [120.68725090800001, 11.208574997000028],
            [120.68637134200003, 11.210390550000056],
            [120.68785135900009, 11.213035923000064],
        ],
        [
            [119.274605199, 11.213173684000026],
            [119.29149044400003, 11.179346343000077],
            [119.28303324100011, 11.13605758600005],
            [119.28177909400006, 11.175751571000035],
            [119.27190148500006, 11.207753839000077],
            [119.274605199, 11.213173684000026],
        ],
        [
            [119.28312144900008, 11.190530717000058],
            [119.28257847900011, 11.190285473000074],
            [119.28295403700008, 11.189431714000023],
            [119.28327429700005, 11.190412560000027],
            [119.28312144900008, 11.190530717000058],
        ],
        [
            [119.28195104600002, 11.191863800000021],
            [119.2817950860001, 11.19185439100005],
            [119.28213727900004, 11.191507068000021],
            [119.28209050700002, 11.191785928000058],
            [119.28195104600002, 11.191863800000021],
        ],
        [
            [119.29216697600009, 11.216597788000058],
            [119.29804234100004, 11.204213442000025],
            [119.29732405800007, 11.194438584000068],
            [119.29252575800001, 11.199744569000075],
            [119.29216697600009, 11.216597788000058],
        ],
        [
            [120.75328584400006, 11.219103161000021],
            [120.76033634200007, 11.218568250000033],
            [120.7621973470001, 11.21370730700005],
            [120.75259208700004, 11.212374115000046],
            [120.75328584400006, 11.219103161000021],
        ],
        [
            [119.25921472000005, 11.226420523000058],
            [119.27309137800012, 11.200553117000027],
            [119.27038198200012, 11.188122822000025],
            [119.25465979100011, 11.207982978000075],
            [119.25921472000005, 11.226420523000058],
        ],
        [
            [119.27020126100001, 11.20404753500003],
            [119.27010350800003, 11.20450168800005],
            [119.2696312920001, 11.204807496000058],
            [119.27042022700005, 11.203298447000066],
            [119.27020126100001, 11.20404753500003],
        ],
        [
            [121.066211339, 11.22985299000004],
            [121.06808188000002, 11.220267447000026],
            [121.06121267100002, 11.22086226700003],
            [121.05914967400008, 11.22670899800005],
            [121.066211339, 11.22985299000004],
        ],
        [
            [120.27248675700002, 11.239468886000054],
            [120.27385250600003, 11.236462442000061],
            [120.27051029100005, 11.233305839000025],
            [120.26837346000002, 11.235328691000063],
            [120.27248675700002, 11.239468886000054],
        ],
        [
            [120.85529070000007, 11.239832160000049],
            [120.85514403800005, 11.240178739000044],
            [120.85557589100006, 11.240318818000048],
            [120.85556429600001, 11.240168726000036],
            [120.85529070000007, 11.239832160000049],
        ],
        [
            [120.85245447900002, 11.24141159900006],
            [120.85352245700005, 11.23760758000003],
            [120.85006617400006, 11.237611207000043],
            [120.84975858100006, 11.240696413000023],
            [120.85245447900002, 11.24141159900006],
        ],
        [
            [119.3475004280001, 11.247065373000055],
            [119.37657691900006, 11.226016714000025],
            [119.37497291300008, 11.212541715000043],
            [119.38052717300002, 11.194464973000038],
            [119.34411513300006, 11.208995042000026],
            [119.3475004280001, 11.247065373000055],
        ],
        [
            [119.36603182300007, 11.233495692000076],
            [119.36469510400002, 11.231978927000057],
            [119.3652765380001, 11.230792364000024],
            [119.366119851, 11.231400363000034],
            [119.36603182300007, 11.233495692000076],
        ],
        [
            [119.68193414000007, 11.247527177000052],
            [119.68498258700004, 11.245527013000071],
            [119.68544987700011, 11.23701152600006],
            [119.67712725800004, 11.239231353000037],
            [119.68193414000007, 11.247527177000052],
        ],
        [
            [119.35594388400011, 11.247867772000063],
            [119.35566692000009, 11.248749601000043],
            [119.3563264180001, 11.249525763000065],
            [119.35675360500011, 11.249025730000028],
            [119.35594388400011, 11.247867772000063],
        ],
        [
            [119.40708714700008, 11.252999087000035],
            [119.40954372200008, 11.25046837800005],
            [119.4092990580001, 11.249251963000063],
            [119.40836324000009, 11.249282808000032],
            [119.40708714700008, 11.252999087000035],
        ],
        [
            [120.9365918630001, 11.257996927000022],
            [120.94416963600008, 11.242536465000057],
            [120.92979497300007, 11.23081815200004],
            [120.92345050100005, 11.243002081000043],
            [120.9365918630001, 11.257996927000022],
        ],
        [
            [119.71433708100005, 11.257295553000063],
            [119.73053704200004, 11.254306032000045],
            [119.69637482300004, 11.228700121000031],
            [119.70179228100005, 11.247936034000077],
            [119.71433708100005, 11.257295553000063],
        ],
        [
            [119.69565065800009, 11.25975515700003],
            [119.69536800500009, 11.261485436000044],
            [119.69718318200012, 11.263724183000022],
            [119.69730345000005, 11.262464729000044],
            [119.69565065800009, 11.25975515700003],
        ],
        [
            [119.62801687100011, 11.263156987000059],
            [119.63556294500006, 11.256764076000024],
            [119.6236896050001, 11.231108557000027],
            [119.61983309400011, 11.23772976400005],
            [119.62801687100011, 11.263156987000059],
        ],
        [
            [119.35014191000005, 11.272276420000026],
            [119.35839047500008, 11.25926559100003],
            [119.35779084900003, 11.254086069000039],
            [119.34743668500005, 11.26526268300006],
            [119.35014191000005, 11.272276420000026],
        ],
        [
            [119.34588473600002, 11.274151055000061],
            [119.34601236600008, 11.273986235000052],
            [119.3456183940001, 11.27422593500006],
            [119.34567597400007, 11.274246921000042],
            [119.34588473600002, 11.274151055000061],
        ],
        [
            [119.34332745900008, 11.274985079000032],
            [119.34462922300008, 11.273929820000035],
            [119.34408379600006, 11.271967092000068],
            [119.34197327800007, 11.273756133000063],
            [119.34332745900008, 11.274985079000032],
        ],
        [
            [119.34325576700007, 11.275685864000025],
            [119.3433801110001, 11.275487655000063],
            [119.3428618480001, 11.275614293000046],
            [119.34293578100005, 11.275676137000062],
            [119.34325576700007, 11.275685864000025],
        ],
        [
            [120.23414186500008, 11.295527924000055],
            [120.23238873700006, 11.295474980000051],
            [120.2322779430001, 11.297027868000043],
            [120.23380446700003, 11.296803864000026],
            [120.23414186500008, 11.295527924000055],
        ],
        [
            [120.68862931900003, 11.320567012000026],
            [120.6992474540001, 11.301638401000048],
            [120.6889892690001, 11.290196556000069],
            [120.67147784200006, 11.304676405000066],
            [120.68862931900003, 11.320567012000026],
        ],
        [
            [119.6903665210001, 11.32562673600006],
            [119.69622037500005, 11.310707953000076],
            [119.67706694000003, 11.263046515000042],
            [119.65621420900004, 11.299235004000025],
            [119.6903665210001, 11.32562673600006],
        ],
        [
            [119.42679915100007, 11.330212454000048],
            [119.42697888300006, 11.329642173000025],
            [119.42597540100007, 11.330178179000029],
            [119.42652207000003, 11.330440073000034],
            [119.42679915100007, 11.330212454000048],
        ],
        [
            [120.09484242400003, 11.343009743000039],
            [120.09513377200005, 11.343018803000064],
            [120.09529861900012, 11.342846222000048],
            [120.09481512900004, 11.342697005000048],
            [120.09484242400003, 11.343009743000039],
        ],
        [
            [120.09152899500009, 11.34449036500007],
            [120.09186004900005, 11.344319877000032],
            [120.09166257000004, 11.343994985000052],
            [120.09129248700003, 11.344241564000072],
            [120.09152899500009, 11.34449036500007],
        ],
        [
            [119.5472327540001, 11.343370915000037],
            [119.54687077000006, 11.34273907100004],
            [119.54472251800007, 11.343293883000058],
            [119.54575181500002, 11.344701626000074],
            [119.5472327540001, 11.343370915000037],
        ],
        [
            [119.70056526600001, 11.350915046000068],
            [119.71411191000004, 11.343924860000072],
            [119.7073004230001, 11.336352436000027],
            [119.6976700250001, 11.335618736000072],
            [119.70056526600001, 11.350915046000068],
        ],
        [
            [120.73092123200001, 11.356810931000041],
            [120.7400149880001, 11.346837399000037],
            [120.73983700100007, 11.346015432000058],
            [120.72166095400007, 11.361888773000032],
            [120.73092123200001, 11.356810931000041],
        ],
        [
            [119.4172265410001, 11.367336781000063],
            [119.41459466000003, 11.356338148000077],
            [119.4063437850001, 11.349898726000049],
            [119.40494473100011, 11.358621679000066],
            [119.4172265410001, 11.367336781000063],
        ],
        [
            [120.86500774800004, 11.36922011200005],
            [120.86516250700004, 11.37124880400006],
            [120.8668722220001, 11.372235153000076],
            [120.86606543700009, 11.370342847000074],
            [120.86500774800004, 11.36922011200005],
        ],
        [
            [119.53636521500005, 11.374978944000077],
            [119.53759404900006, 11.364890648000028],
            [119.5257624620001, 11.365473388000055],
            [119.52531022500011, 11.369094716000063],
            [119.53636521500005, 11.374978944000077],
        ],
        [
            [119.45520174600006, 11.385116022000034],
            [119.455524179, 11.384917536000046],
            [119.45510563900007, 11.384490253000024],
            [119.45480122100003, 11.38508297900006],
            [119.45520174600006, 11.385116022000034],
        ],
        [
            [119.70327996800006, 11.391611285000067],
            [119.70321686800003, 11.391337104000058],
            [119.70272554900009, 11.391525019000028],
            [119.70298768900011, 11.391705259000048],
            [119.70327996800006, 11.391611285000067],
        ],
        [
            [120.08985885600009, 11.392219754000052],
            [120.11256944500008, 11.38088695500005],
            [120.1086379940001, 11.364391055000056],
            [120.090857217, 11.365766810000025],
            [120.08985885600009, 11.392219754000052],
        ],
        [
            [119.4551988390001, 11.392345638000052],
            [119.45654419800007, 11.389918719000036],
            [119.4554795250001, 11.385310609000044],
            [119.45346536800002, 11.388192240000024],
            [119.4551988390001, 11.392345638000052],
        ],
        [
            [119.80727166400004, 11.392612672000041],
            [119.80870813100012, 11.388915019000024],
            [119.80611161400009, 11.386782450000055],
            [119.80645379500004, 11.39228844400003],
            [119.80727166400004, 11.392612672000041],
        ],
        [
            [119.66605783400007, 11.399478438000074],
            [119.66653987100005, 11.398251926000057],
            [119.66602951900006, 11.397505242000022],
            [119.66441412900008, 11.398651877000077],
            [119.66605783400007, 11.399478438000074],
        ],
        [
            [119.51486647500008, 11.40304246200003],
            [119.51492707000011, 11.401431178000053],
            [119.5131492480001, 11.401148920000026],
            [119.51398002300004, 11.40268442100006],
            [119.51486647500008, 11.40304246200003],
        ],
        [
            [120.82207348000009, 11.40353445900007],
            [120.82312983700001, 11.401388552000071],
            [120.82233352300011, 11.399678289000065],
            [120.82070359000011, 11.40080154900005],
            [120.82207348000009, 11.40353445900007],
        ],
        [
            [119.51935423200007, 11.410187650000069],
            [119.51862826500007, 11.409579195000049],
            [119.51801558500006, 11.41066396900004],
            [119.51889100400001, 11.410788204000028],
            [119.51935423200007, 11.410187650000069],
        ],
        [
            [120.14030627500006, 11.412024787000064],
            [120.1412350060001, 11.410119254000051],
            [120.14399900500007, 11.409493957000052],
            [120.14465622600005, 11.408293945000025],
            [120.13500818700004, 11.410274637000043],
            [120.14030627500006, 11.412024787000064],
        ],
        [
            [119.72188150300008, 11.41426113500006],
            [119.72483079100004, 11.412538013000074],
            [119.72139075400003, 11.39904301200005],
            [119.71645253000008, 11.402373349000072],
            [119.72188150300008, 11.41426113500006],
        ],
        [
            [119.467851934, 11.425229239000032],
            [119.46668815600003, 11.421574768000028],
            [119.46391190000008, 11.421800708000035],
            [119.463869498, 11.422836628000027],
            [119.467851934, 11.425229239000032],
        ],
        [
            [119.47685016300011, 11.425364440000067],
            [119.50525985900003, 11.415181769000071],
            [119.51028216300006, 11.331798892000052],
            [119.553877424, 11.340111536000052],
            [119.56889038100007, 11.29255435500005],
            [119.49991413200007, 11.13294344700006],
            [119.53614630300001, 11.06804644500005],
            [119.56126252500007, 11.084274770000036],
            [119.5511210520001, 11.061739486000022],
            [119.56984138100006, 11.007341504000067],
            [119.50236624200011, 11.00759914300005],
            [119.48402676600006, 10.873470380000072],
            [119.53430227100012, 10.812189991000025],
            [119.57485904500004, 10.838446942000076],
            [119.59963049400005, 10.821752769000057],
            [119.57054675800009, 10.664290521000055],
            [119.6577475690001, 10.674663304000035],
            [119.6677230250001, 10.655891307000047],
            [119.62212790100011, 10.659816019000061],
            [119.62504454500004, 10.622197608000022],
            [119.71645737200004, 10.507368717000077],
            [119.58669841000005, 10.42245923300004],
            [119.57000357200002, 10.372600116000058],
            [119.45648774300003, 10.375327688000027],
            [119.32243325000002, 10.311140616000046],
            [119.23277203600003, 10.181011918000024],
            [119.19711689400003, 10.047823479000044],
            [118.74957583600008, 9.928836549000039],
            [118.74181240400003, 9.841258672000038],
            [118.77268558100002, 9.728742619000059],
            [118.73242269700006, 9.73005992800006],
            [118.72093831200004, 9.788676294000027],
            [118.69016833800003, 9.758360121000067],
            [118.69419113700008, 9.711751187000061],
            [118.72920539800009, 9.708542831000045],
            [118.70719664, 9.690365482000061],
            [118.70478944000001, 9.679573417000029],
            [118.73124006300009, 9.700104106000026],
            [118.76064695200012, 9.666702377000036],
            [118.72160065700007, 9.658243233000064],
            [118.48960708300001, 9.294616245000043],
            [118.42961316500009, 9.278176787000064],
            [118.34760668400008, 9.179262927000025],
            [118.12808430700011, 9.14828963900004],
            [118.00190118800003, 8.879352374000064],
            [117.88446837700008, 8.82733965400007],
            [117.7421060910001, 8.687034469000025],
            [117.62002433300006, 8.656251590000068],
            [117.56676832100004, 8.674384839000027],
            [117.50114933200007, 8.501052905000051],
            [117.45573798100008, 8.521312372000068],
            [117.45294533000003, 8.500370876000034],
            [117.4471248210001, 8.493914838000023],
            [117.37214781400007, 8.493883021000045],
            [117.1819428980001, 8.332534796000061],
            [117.25495034100004, 8.609300529000052],
            [117.3330453860001, 8.672533298000076],
            [117.35922083600008, 8.744816944000036],
            [117.424656303, 8.75837765700004],
            [117.49111160900009, 8.88867189900003],
            [117.62132791200008, 8.999213247000057],
            [117.62976043300011, 9.04818074000002],
            [117.68947931000002, 9.088972425000065],
            [117.74637080600007, 9.067825068000047],
            [117.81063447000008, 9.197299736000048],
            [117.98166549300004, 9.280601065000042],
            [117.98370074000002, 9.244369274000064],
            [118.01904656700003, 9.243178487000023],
            [118.08694226500006, 9.33334293200005],
            [118.1271195920001, 9.342894753000053],
            [118.12739134900005, 9.397683406000056],
            [118.18453569400003, 9.407672175000073],
            [118.1973711820001, 9.471560190000048],
            [118.32877691300007, 9.580875225000057],
            [118.34038711500011, 9.648590495000064],
            [118.40631520900001, 9.663104310000051],
            [118.60575098800007, 9.870873646000064],
            [118.60490020300006, 9.91482441900007],
            [118.6633495640001, 9.975380849000032],
            [118.64474611500009, 10.003200554000045],
            [118.72295335600006, 10.035735972000055],
            [118.760223128, 10.131333493000056],
            [118.77362979300005, 10.069989686000042],
            [118.7412559170001, 10.075792038000031],
            [118.77658420900002, 10.021698429000025],
            [118.79395578700007, 10.036596016000033],
            [118.80825265900012, 10.027905920000023],
            [118.84025191800004, 10.10672446700005],
            [118.80481429200006, 10.121161378000068],
            [118.80576419300007, 10.192237022000029],
            [118.93779874600011, 10.207239250000043],
            [118.93710219900004, 10.264305166000042],
            [118.96262921200002, 10.269639815000062],
            [118.94780116600009, 10.284365817000037],
            [118.93266253600007, 10.285413981000033],
            [118.93236353900011, 10.289488476000031],
            [119.02773831800005, 10.33855793500004],
            [119.01457442600008, 10.376345086000072],
            [118.97514143300009, 10.346361114000047],
            [118.986914651, 10.407360836000066],
            [119.06445125200003, 10.388113518000068],
            [119.06364320500006, 10.422996062000038],
            [119.10496779800008, 10.43359742000007],
            [119.07393353400005, 10.451048537000077],
            [119.08282419600005, 10.48064216900002],
            [119.11503806100006, 10.484415799000033],
            [119.11312581600009, 10.411334182000076],
            [119.142435825, 10.381749078000041],
            [119.21557394400008, 10.481225233000032],
            [119.25633516200003, 10.483874204000074],
            [119.26874792100011, 10.513172156000053],
            [119.2295677400001, 10.547649157000023],
            [119.26444370200011, 10.537307858000077],
            [119.3172551990001, 10.589105360000076],
            [119.34321583400003, 10.730957231000048],
            [119.31772646400009, 10.77074585300005],
            [119.27414860600004, 10.76499437800004],
            [119.25953114100002, 10.834396520000041],
            [119.2087945610001, 10.848986358000047],
            [119.2594039060001, 10.884967650000021],
            [119.21381038400011, 10.904750283000055],
            [119.22067755400008, 10.954497715000059],
            [119.24422365500004, 10.909842336000054],
            [119.28449431500007, 10.936314258000039],
            [119.27771052100002, 10.892258817000027],
            [119.29155548400001, 10.895701092000024],
            [119.29881996600011, 10.891575637000074],
            [119.26626902300006, 10.870114113000056],
            [119.30813666800009, 10.871108142000026],
            [119.3016016150001, 10.864405676000047],
            [119.28577508800004, 10.861307212000042],
            [119.28251263600009, 10.847368264000067],
            [119.33245965100002, 10.810002189000045],
            [119.35703655700001, 10.821422965000068],
            [119.34609476100002, 10.798449938000033],
            [119.39052582400006, 10.790784595000048],
            [119.4299159740001, 10.718705285000055],
            [119.46254957000008, 10.725064349000036],
            [119.43397556500008, 10.800027219000071],
            [119.45116189200007, 10.849720714000057],
            [119.41305729300007, 10.871931224000036],
            [119.34839396900009, 10.871218875000068],
            [119.3616287110001, 10.936928236000028],
            [119.31037882500004, 10.942814361000046],
            [119.33247690400003, 10.950271697000062],
            [119.3030236400001, 11.007341461000067],
            [119.31945002900011, 11.034556889000044],
            [119.34667659100012, 10.989559712000073],
            [119.36684276000005, 11.009125483000048],
            [119.32878575900008, 11.036560501000054],
            [119.32552421100002, 11.106521569000051],
            [119.36943981800005, 11.04488694400004],
            [119.39959208500011, 11.031373444000053],
            [119.41789242000004, 11.037134103000028],
            [119.42889313600006, 11.13630871600003],
            [119.42247983400011, 11.146630724000033],
            [119.42474965400004, 11.149486337000042],
            [119.42319593400009, 11.150225499000044],
            [119.40018795800006, 11.132501228000024],
            [119.37502598300011, 11.182569202000025],
            [119.41658032400005, 11.210038538000049],
            [119.41008966200002, 11.311964185000022],
            [119.47258767700009, 11.362546508000037],
            [119.47685016300011, 11.425364440000067],
        ],
        [
            [118.38220083500005, 9.225050176000025],
            [118.38231439300012, 9.225255670000024],
            [118.38206125300007, 9.225844136000035],
            [118.38176080100004, 9.225272016000076],
            [118.38220083500005, 9.225050176000025],
        ],
        [
            [118.73607507000008, 9.754357409000022],
            [118.73537085600003, 9.754075458000045],
            [118.73609369000008, 9.753274651000027],
            [118.73642209700006, 9.753871919000062],
            [118.73607507000008, 9.754357409000022],
        ],
        [
            [118.69963724900003, 9.772979870000029],
            [118.69946568600005, 9.77386965200003],
            [118.698546985, 9.77452637500005],
            [118.69859892200009, 9.773342441000068],
            [118.69963724900003, 9.772979870000029],
        ],
        [
            [118.79004873500003, 10.024342047000061],
            [118.78868329500006, 10.024187742000038],
            [118.78878855800008, 10.02249749200007],
            [118.78973403500004, 10.023298219000026],
            [118.79004873500003, 10.024342047000061],
        ],
        [
            [119.09387570800004, 10.42804669800006],
            [119.09336209600008, 10.42777824500007],
            [119.0934722610001, 10.426832218000072],
            [119.09449268100002, 10.427371203000064],
            [119.09387570800004, 10.42804669800006],
        ],
        [
            [119.24198627800001, 10.841975175000073],
            [119.24185207200003, 10.842137670000056],
            [119.2416645610001, 10.842000442000028],
            [119.24198995900008, 10.841852398000071],
            [119.24198627800001, 10.841975175000073],
        ],
        [
            [119.29477437800006, 10.865373134000038],
            [119.29454147700005, 10.865330310000047],
            [119.29434993600012, 10.864805798000077],
            [119.29475252400005, 10.865121529000021],
            [119.29477437800006, 10.865373134000038],
        ],
        [
            [119.21534611600009, 10.908782168000073],
            [119.21508981000011, 10.909309180000037],
            [119.21480991700003, 10.90854706400006],
            [119.21502469400002, 10.908402959000057],
            [119.21534611600009, 10.908782168000073],
        ],
        [
            [119.25122904700004, 10.912606599000071],
            [119.25093706900009, 10.912613767000039],
            [119.25094081800012, 10.912328322000064],
            [119.25133823700003, 10.912455903000023],
            [119.25122904700004, 10.912606599000071],
        ],
        [
            [119.346414589, 10.93983831600002],
            [119.34536676300002, 10.939615210000056],
            [119.34536127000001, 10.939004038000064],
            [119.34635395300006, 10.939201963000073],
            [119.346414589, 10.93983831600002],
        ],
        [
            [120.82006940100007, 11.426482614000065],
            [120.82021970800008, 11.425013712000066],
            [120.81874581300008, 11.424217584000075],
            [120.81880759900002, 11.425364608000052],
            [120.82006940100007, 11.426482614000065],
        ],
        [
            [119.70584526300001, 11.427555384000073],
            [119.71151474500004, 11.425011090000055],
            [119.7117483610001, 11.424094582000066],
            [119.7063038770001, 11.424133639000047],
            [119.70584526300001, 11.427555384000073],
        ],
        [
            [119.70540496400008, 11.427785737000022],
            [119.70509810300007, 11.427889642000025],
            [119.70510740200007, 11.428296146000037],
            [119.70537148800008, 11.428075577000072],
            [119.70540496400008, 11.427785737000022],
        ],
        [
            [120.82538597300004, 11.427125570000044],
            [120.82319226000004, 11.427305853000064],
            [120.82355854100001, 11.429808240000057],
            [120.82522281400009, 11.428755986000056],
            [120.82538597300004, 11.427125570000044],
        ],
        [
            [120.17933202100005, 11.430958943000064],
            [120.17110205400002, 11.415341308000052],
            [120.16898950900008, 11.414573546000042],
            [120.16921881400003, 11.421312830000034],
            [120.17933202100005, 11.430958943000064],
        ],
        [
            [120.75754050900002, 11.430834889000039],
            [120.76242584900001, 11.429454498000041],
            [120.76324449000003, 11.42798143500005],
            [120.75692892600011, 11.430552152000075],
            [120.75700497000003, 11.431763729000068],
            [120.75754050900002, 11.430834889000039],
        ],
        [
            [120.18113928900004, 11.43259419800006],
            [120.18102099100008, 11.43167346100006],
            [120.18007010000008, 11.432115835000047],
            [120.18044235100001, 11.432492507000063],
            [120.18113928900004, 11.43259419800006],
        ],
        [
            [119.64204393700004, 11.435386812000047],
            [119.66742187300008, 11.418868847000056],
            [119.65952456200012, 11.395527583000046],
            [119.63284739500011, 11.430595398000037],
            [119.64204393700004, 11.435386812000047],
        ],
        [
            [120.81113707200007, 11.436616296000068],
            [120.8195494360001, 11.421199816000069],
            [120.814567796, 11.41102870900005],
            [120.80698209500008, 11.432740133000038],
            [120.81113707200007, 11.436616296000068],
        ],
        [
            [119.70798943200009, 11.43830740200002],
            [119.7094623480001, 11.435810256000025],
            [119.70569384100008, 11.435170250000056],
            [119.70591938000007, 11.437484377000033],
            [119.70798943200009, 11.43830740200002],
        ],
        [
            [119.71883310700002, 11.444752248000043],
            [119.72235249500011, 11.44312472100006],
            [119.71938411500003, 11.440775578000057],
            [119.7171963080001, 11.443576115000042],
            [119.71883310700002, 11.444752248000043],
        ],
        [
            [119.49914253300005, 11.444983333000039],
            [119.50660774000005, 11.438772029000063],
            [119.5029210570001, 11.421813770000028],
            [119.49577647300009, 11.43798984600005],
            [119.49914253300005, 11.444983333000039],
        ],
        [
            [120.7680674930001, 11.446270850000076],
            [120.77957619900008, 11.430321228000025],
            [120.77859891800006, 11.425987271000054],
            [120.76887099700002, 11.432684063000067],
            [120.7680674930001, 11.446270850000076],
        ],
        [
            [120.80169765200003, 11.445351306000077],
            [120.8011341130001, 11.446539347000055],
            [120.8015757600001, 11.448171099000035],
            [120.80247340900007, 11.446588009000038],
            [120.80169765200003, 11.445351306000077],
        ],
        [
            [120.83045451700002, 11.44997767700005],
            [120.85305008000012, 11.428104072000053],
            [120.8347737790001, 11.417556220000051],
            [120.82200606300012, 11.44591519100004],
            [120.83045451700002, 11.44997767700005],
        ],
        [
            [119.64416945300002, 11.453980714000068],
            [119.64724450000006, 11.450819250000052],
            [119.64759479600002, 11.449511287000064],
            [119.64455422000003, 11.451286433000064],
            [119.64416945300002, 11.453980714000068],
        ],
        [
            [119.83362010600001, 11.457871602000068],
            [119.8334352600001, 11.457993584000064],
            [119.8334770460001, 11.458099961000073],
            [119.83365878100005, 11.457968481000023],
            [119.83362010600001, 11.457871602000068],
        ],
        [
            [119.8329610190001, 11.458593794000024],
            [119.83279982200008, 11.458690570000044],
            [119.83274991100006, 11.45915966900003],
            [119.83318620700004, 11.458859683000071],
            [119.8329610190001, 11.458593794000024],
        ],
        [
            [120.80814278100002, 11.459111326000027],
            [120.80873475500005, 11.455338897000047],
            [120.80739279900001, 11.44853385600004],
            [120.80386950800005, 11.455550079000034],
            [120.80814278100002, 11.459111326000027],
        ],
        [
            [119.6693848650001, 11.462049481000065],
            [119.66917018200002, 11.462102136000055],
            [119.6690951060001, 11.462365169000066],
            [119.66963181400001, 11.462254574000042],
            [119.6693848650001, 11.462049481000065],
        ],
        [
            [120.18490784200003, 11.463403189000076],
            [120.19799300800003, 11.450100514000042],
            [120.1523648430001, 11.43152546300007],
            [120.16169478900008, 11.436052389000054],
            [120.18490784200003, 11.463403189000076],
        ],
        [
            [120.82071025300002, 11.463890774000049],
            [120.82168655200007, 11.463243629000033],
            [120.8211918610001, 11.462786576000042],
            [120.820344137, 11.463297030000035],
            [120.82071025300002, 11.463890774000049],
        ],
        [
            [120.81358060500008, 11.464312015000075],
            [120.82350645300005, 11.458813487000043],
            [120.8196146900001, 11.45118522100006],
            [120.81492827500006, 11.457305182000027],
            [120.81358060500008, 11.464312015000075],
        ],
        [
            [119.6671632990001, 11.464412453000023],
            [119.66649134800002, 11.463934417000075],
            [119.66590976900011, 11.46468494100003],
            [119.6660524020001, 11.464721693000058],
            [119.6671632990001, 11.464412453000023],
        ],
        [
            [120.81330624300006, 11.465861016000076],
            [120.81362177800008, 11.465754895000032],
            [120.81388877800009, 11.465182174000063],
            [120.8129645680001, 11.466018372000065],
            [120.81330624300006, 11.465861016000076],
        ],
        [
            [119.66152033600008, 11.468544946000065],
            [119.66309644700004, 11.46794495000006],
            [119.66531627100005, 11.465266327000052],
            [119.66296170100009, 11.466029023000033],
            [119.66152033600008, 11.468544946000065],
        ],
        [
            [119.83578269600002, 11.469350286000065],
            [119.8359336310001, 11.469313769000053],
            [119.83569921500009, 11.469261321000033],
            [119.83563243100002, 11.46955538700007],
            [119.83578269600002, 11.469350286000065],
        ],
        [
            [119.8875122070001, 11.471496582000043],
            [119.88787841800001, 11.470520020000038],
            [119.88708496100003, 11.470886231000065],
            [119.8875122070001, 11.471496582000043],
        ],
        [
            [119.88549804700006, 11.470886231000065],
            [119.8840942380001, 11.471679687000062],
            [119.88452148400006, 11.472717286000034],
            [119.88568115200007, 11.472717286000034],
            [119.88549804700006, 11.470886231000065],
        ],
        [
            [119.83323831500002, 11.473036098000023],
            [119.83307290900007, 11.472769034000066],
            [119.83278263800003, 11.472927040000059],
            [119.83314092400008, 11.473104036000052],
            [119.83323831500002, 11.473036098000023],
        ],
        [
            [119.64314246800006, 11.47338664800003],
            [119.64279983600011, 11.472520521000035],
            [119.64153139300004, 11.473113109000053],
            [119.64214727400008, 11.473043508000046],
            [119.64314246800006, 11.47338664800003],
        ],
        [
            [119.75725258500006, 11.472038455000074],
            [119.75653542200007, 11.472071835000065],
            [119.75578775600002, 11.475015633000055],
            [119.75691690200006, 11.474516890000075],
            [119.75725258500006, 11.472038455000074],
        ],
        [
            [119.88237984900002, 11.475171487000068],
            [119.88280083500001, 11.473970411000039],
            [119.88267531200006, 11.473578559000032],
            [119.88182932000007, 11.474111108000045],
            [119.88237984900002, 11.475171487000068],
        ],
        [
            [119.71148880600003, 11.477742187000047],
            [119.7128902290001, 11.476464521000025],
            [119.71328369500009, 11.473808432000055],
            [119.71024743400005, 11.476746621000075],
            [119.71148880600003, 11.477742187000047],
        ],
        [
            [119.71003569600009, 11.47822273600002],
            [119.71025646600003, 11.477780189000043],
            [119.71008671300001, 11.477667285000052],
            [119.70964509700002, 11.478357816000027],
            [119.71003569600009, 11.47822273600002],
        ],
        [
            [119.71243172900006, 11.479307965000032],
            [119.71360205200006, 11.47996676300005],
            [119.71465298500004, 11.478987137000047],
            [119.71357811200005, 11.478007674000025],
            [119.71243172900006, 11.479307965000032],
        ],
        [
            [119.87244634800004, 11.479973312000027],
            [119.87789028800012, 11.47764317800005],
            [119.87922282800002, 11.47180135900004],
            [119.8710949870001, 11.475511789000052],
            [119.87244634800004, 11.479973312000027],
        ],
        [
            [119.71288115000004, 11.480361751000032],
            [119.71308229300007, 11.480127694000032],
            [119.71278546100007, 11.479893831000027],
            [119.71246852800004, 11.48056914600005],
            [119.71288115000004, 11.480361751000032],
        ],
        [
            [119.65451275100008, 11.48109749200006],
            [119.66250344200012, 11.47899004900006],
            [119.65945452900007, 11.469913719000033],
            [119.65378925000005, 11.474472682000055],
            [119.65451275100008, 11.48109749200006],
        ],
        [
            [119.72751398800006, 11.48292531800007],
            [119.7286595270001, 11.481434078000063],
            [119.72872438500008, 11.480790438000042],
            [119.72844933100009, 11.48029944700005],
            [119.72751398800006, 11.48292531800007],
        ],
        [
            [119.65153474300007, 11.484785393000038],
            [119.65350937800008, 11.48412300900003],
            [119.65397334700003, 11.483080863000055],
            [119.651243571, 11.482857574000036],
            [119.65153474300007, 11.484785393000038],
        ],
        [
            [119.87529436500006, 11.48738933900006],
            [119.8771773840001, 11.481618884000056],
            [119.87501667300012, 11.47983176400004],
            [119.87183266200009, 11.482809777000057],
            [119.87529436500006, 11.48738933900006],
        ],
        [
            [119.66584336200003, 11.487492570000029],
            [119.66549882700008, 11.487712141000031],
            [119.66538863700009, 11.488043094000034],
            [119.66583655800002, 11.487870776000022],
            [119.66584336200003, 11.487492570000029],
        ],
        [
            [119.67245853400004, 11.488488327000027],
            [119.66762337300008, 11.476628750000032],
            [119.66655633500011, 11.47623072700003],
            [119.6663352600001, 11.486560524000026],
            [119.66565755500005, 11.48844946500003],
            [119.67245853400004, 11.488488327000027],
        ],
        [
            [119.84151717500004, 11.48920998400007],
            [119.84253127500006, 11.488980840000067],
            [119.84171154400008, 11.487887156000056],
            [119.84119251200002, 11.48854588200004],
            [119.84151717500004, 11.48920998400007],
        ],
        [
            [119.67346877800003, 11.489201782000066],
            [119.67330107400005, 11.488862599000072],
            [119.67280191500004, 11.489019838000047],
            [119.6733813730001, 11.48937677300006],
            [119.67346877800003, 11.489201782000066],
        ],
        [
            [119.9285278320001, 11.49212646500007],
            [119.92749023400006, 11.49212646500007],
            [119.92767333900008, 11.493286133000026],
            [119.92907714800003, 11.493103028000064],
            [119.9285278320001, 11.49212646500007],
        ],
        [
            [119.83897573700006, 11.49363676300004],
            [119.84084711600008, 11.490203597000061],
            [119.83574134600008, 11.48990271100007],
            [119.83684397500008, 11.49284381900003],
            [119.83897573700006, 11.49363676300004],
        ],
        [
            [119.77802871800009, 11.49414166300005],
            [119.777660706, 11.494314580000037],
            [119.77794678200007, 11.494621418000065],
            [119.77823638500001, 11.494314230000043],
            [119.77802871800009, 11.49414166300005],
        ],
        [
            [119.77570736700011, 11.49564149500003],
            [119.77580083700002, 11.494812488000036],
            [119.77502507600002, 11.496950855000023],
            [119.77558601100009, 11.495718321000027],
            [119.77570736700011, 11.49564149500003],
        ],
        [
            [119.89519991300006, 11.505417290000025],
            [119.90087898700006, 11.486844586000075],
            [119.88481284500006, 11.485341642000037],
            [119.88185437000004, 11.49185187200004],
            [119.89519991300006, 11.505417290000025],
        ],
        [
            [119.86894694900002, 11.506607896000048],
            [119.86886003000006, 11.50631856800004],
            [119.86849199300002, 11.506259271000033],
            [119.86878318800007, 11.506802808000032],
            [119.86894694900002, 11.506607896000048],
        ],
        [
            [119.91127518400003, 11.512501372000031],
            [119.91158298800008, 11.511435719000076],
            [119.91054203600004, 11.511117479000063],
            [119.91006871600007, 11.51199168900007],
            [119.91127518400003, 11.512501372000031],
        ],
        [
            [119.7555570400001, 11.514036818000022],
            [119.75527855500002, 11.513687098000048],
            [119.75501627400001, 11.51415544300005],
            [119.75525797800003, 11.514458877000038],
            [119.7555570400001, 11.514036818000022],
        ],
        [
            [119.82563000400012, 11.51497217800005],
            [119.82552375700004, 11.514706870000055],
            [119.82539284100005, 11.514618742000039],
            [119.82547000500006, 11.515022345000034],
            [119.82563000400012, 11.51497217800005],
        ],
        [
            [119.67124459600007, 11.515408078000064],
            [119.69048780300011, 11.50253258500004],
            [119.68406786500009, 11.486714021000068],
            [119.66861239700006, 11.501775520000024],
            [119.67124459600007, 11.515408078000064],
        ],
        [
            [119.81494800500002, 11.51930941300003],
            [119.87195376000011, 11.492610985000056],
            [119.81956498900001, 11.37648725400004],
            [119.80189790400004, 11.401327843000047],
            [119.82478713000012, 11.427272198000026],
            [119.77378267000006, 11.394692861000067],
            [119.71201614600011, 11.464330653000047],
            [119.72824385600006, 11.479243998000072],
            [119.72800641200001, 11.465313648000063],
            [119.7390595380001, 11.466399184000068],
            [119.76171507600009, 11.43860872600004],
            [119.77060405100008, 11.437115449000032],
            [119.77591046500004, 11.493591171000048],
            [119.79438839900001, 11.455721510000046],
            [119.83508333400005, 11.45721792300003],
            [119.84757840000009, 11.486128875000077],
            [119.81494800500002, 11.51930941300003],
        ],
        [
            [119.8011403490001, 11.451901993000035],
            [119.80122601700009, 11.45194129600003],
            [119.80118591700011, 11.452034192000042],
            [119.80109295700004, 11.451987743000075],
            [119.8011403490001, 11.451901993000035],
        ],
        [
            [119.81354442200006, 11.453919392000046],
            [119.81358720000003, 11.454030045000025],
            [119.81347689900008, 11.454071745000022],
            [119.81342183700008, 11.453955733000043],
            [119.81354442200006, 11.453919392000046],
        ],
        [
            [119.81099126400011, 11.51974202200006],
            [119.811091873, 11.519656609000037],
            [119.81090692200007, 11.519638961000055],
            [119.81088685800012, 11.519716782000046],
            [119.81099126400011, 11.51974202200006],
        ],
        [
            [119.86431739700004, 11.521184559000062],
            [119.86438489800003, 11.520842655000024],
            [119.86384808800005, 11.520113239000068],
            [119.86379015300008, 11.520305668000049],
            [119.86431739700004, 11.521184559000062],
        ],
        [
            [119.73246364700003, 11.528178836000052],
            [119.73261992300002, 11.528076652000038],
            [119.73237538400008, 11.527476845000024],
            [119.73184456000001, 11.527528142000051],
            [119.73246364700003, 11.528178836000052],
        ],
        [
            [119.88346562600009, 11.534294886000055],
            [119.88720023500002, 11.529937990000064],
            [119.87878181400004, 11.526378864000037],
            [119.87892088000001, 11.53283086500005],
            [119.88346562600009, 11.534294886000055],
        ],
        [
            [119.91326771600006, 11.538829967000026],
            [119.91512782300003, 11.535290040000064],
            [119.91343052200011, 11.53206085000005],
            [119.91190880500005, 11.534333424000067],
            [119.91326771600006, 11.538829967000026],
        ],
        [
            [119.84064737800009, 11.543950883000036],
            [119.84047168100005, 11.544260747000067],
            [119.8405233420001, 11.544500733000064],
            [119.84073314200009, 11.544191468000065],
            [119.84064737800009, 11.543950883000036],
        ],
        [
            [119.83912610200002, 11.544859630000076],
            [119.84007127500001, 11.54390903600006],
            [119.83933934700008, 11.542752954000036],
            [119.83847780500003, 11.544146419000072],
            [119.83912610200002, 11.544859630000076],
        ],
        [
            [119.80597114500006, 11.547794590000024],
            [119.8099006650001, 11.546250394000026],
            [119.81968356300001, 11.546427056000027],
            [119.80981569000005, 11.541751523000073],
            [119.80597114500006, 11.547794590000024],
        ],
        [
            [119.87533753500009, 11.552568275000056],
            [119.87667484000008, 11.543519721000052],
            [119.87343042600003, 11.54309648900005],
            [119.87140852300001, 11.54573698300004],
            [119.87533753500009, 11.552568275000056],
        ],
        [
            [119.84332978900011, 11.554163943000049],
            [119.8439203260001, 11.552689805000057],
            [119.84294969400003, 11.552329561000022],
            [119.84273751800004, 11.553450886000064],
            [119.84332978900011, 11.554163943000049],
        ],
        [
            [119.8965761820001, 11.555804533000071],
            [119.89886036100006, 11.553798659000051],
            [119.896443352, 11.550841682000055],
            [119.89565918500011, 11.554927813000063],
            [119.8965761820001, 11.555804533000071],
        ],
        [
            [119.8523231160001, 11.556542542000045],
            [119.85966844100005, 11.550297623000063],
            [119.85194436300003, 11.544782095000073],
            [119.84569471200007, 11.551971038000033],
            [119.8523231160001, 11.556542542000045],
        ],
        [
            [119.88819079600012, 11.559086571000023],
            [119.88963127800002, 11.551791859000048],
            [119.88527599200006, 11.546393899000066],
            [119.88605180500008, 11.55787808100007],
            [119.88819079600012, 11.559086571000023],
        ],
        [
            [119.92957827200007, 11.563073850000023],
            [119.93062703100009, 11.562492204000023],
            [119.92936467000004, 11.56116402500004],
            [119.9288986040001, 11.561976758000071],
            [119.92957827200007, 11.563073850000023],
        ],
        [
            [119.86796008800002, 11.565822973000024],
            [119.870262, 11.56135689000007],
            [119.86868635700012, 11.559253586000068],
            [119.86637830200004, 11.562574297000026],
            [119.86796008800002, 11.565822973000024],
        ],
        [
            [119.91589701400005, 11.577183070000046],
            [119.92009803600001, 11.57556359800003],
            [119.91920561000006, 11.572352207000051],
            [119.9163218970001, 11.575075541000047],
            [119.91589701400005, 11.577183070000046],
        ],
        [
            [119.93064459900006, 11.588319894000051],
            [119.94356158300002, 11.58495010100006],
            [119.94679660800011, 11.576535888000024],
            [119.92783209400011, 11.576748198000075],
            [119.93064459900006, 11.588319894000051],
        ],
        [
            [119.85841263400005, 11.600767920000067],
            [119.85832439600006, 11.60079156200004],
            [119.85833828000011, 11.60089511700005],
            [119.85845488700011, 11.600895918000049],
            [119.85841263400005, 11.600767920000067],
        ],
        [
            [119.85822432500004, 11.601141555000027],
            [119.85830300600003, 11.601140211000029],
            [119.8583164590001, 11.601106878000053],
            [119.8582031090001, 11.60106352300005],
            [119.85822432500004, 11.601141555000027],
        ],
        [
            [119.85860125400006, 11.601012836000052],
            [119.85847394100006, 11.600993992000042],
            [119.858423463, 11.60102065600006],
            [119.85863725000002, 11.601151223000045],
            [119.85860125400006, 11.601012836000052],
        ],
        [
            [119.85698702600007, 11.608778220000033],
            [119.86429646300007, 11.595568883000055],
            [119.86240036900006, 11.593434100000025],
            [119.85973830700004, 11.600004381000076],
            [119.85872953300009, 11.60163312800006],
            [119.85859546000006, 11.601266003000035],
            [119.85819875300001, 11.601332166000077],
            [119.85698702600007, 11.608778220000033],
        ],
        [
            [119.91417027800003, 11.609844554000063],
            [119.91599125500011, 11.607323138000027],
            [119.91514458400002, 11.605432543000063],
            [119.9127325070001, 11.607537617000048],
            [119.91417027800003, 11.609844554000063],
        ],
        [
            [119.97405402200002, 11.633009139000023],
            [119.97504998300008, 11.632366533000038],
            [119.97514536200003, 11.631348956000068],
            [119.97427280700003, 11.631900074000043],
            [119.97405402200002, 11.633009139000023],
        ],
        [
            [119.97343890800005, 11.633486902000072],
            [119.97366537200003, 11.633468136000033],
            [119.97368973100004, 11.63294903800005],
            [119.97331079900005, 11.633113040000069],
            [119.97319144900007, 11.633889554000064],
            [119.97343890800005, 11.633486902000072],
        ],
        [
            [119.95393719200001, 11.657218723000028],
            [119.96666479500004, 11.654584670000077],
            [119.97102527600009, 11.632888979000029],
            [119.96002590900002, 11.635811491000027],
            [119.95393719200001, 11.657218723000028],
        ],
        [
            [119.94440713900008, 11.658159386000023],
            [119.94415014000003, 11.65837373200003],
            [119.94433611800002, 11.65860708200006],
            [119.94449003800003, 11.658344624000051],
            [119.94440713900008, 11.658159386000023],
        ],
        [
            [119.96244908500012, 11.660796319000042],
            [119.9620749400001, 11.658355138000047],
            [119.96144810500004, 11.658423466000045],
            [119.96030148800003, 11.660599217000026],
            [119.96244908500012, 11.660796319000042],
        ],
        [
            [120.10824462500011, 11.664713243000051],
            [120.12269805500011, 11.65664977800003],
            [120.10798067000007, 11.64705990300007],
            [120.10615117100008, 11.648036572000024],
            [120.10824462500011, 11.664713243000051],
        ],
        [
            [119.96582206900007, 11.670256338000058],
            [119.96578313900011, 11.670082309000065],
            [119.96562602400002, 11.670208683000055],
            [119.96572574600009, 11.670378365000033],
            [119.96582206900007, 11.670256338000058],
        ],
        [
            [119.96579982000003, 11.670751702000075],
            [119.96575189400005, 11.670550872000035],
            [119.96569747900003, 11.670515289000036],
            [119.96568830900003, 11.670714020000048],
            [119.96579982000003, 11.670751702000075],
        ],
        [
            [119.96558883000012, 11.67075850200007],
            [119.9655123440001, 11.670267414000023],
            [119.96525443700011, 11.670202370000027],
            [119.96516547800002, 11.670698714000025],
            [119.96558883000012, 11.67075850200007],
        ],
        [
            [120.04096315200002, 11.672394943000029],
            [120.04114896500005, 11.672309061000021],
            [120.04085435400009, 11.67208279600004],
            [120.04070993000005, 11.672316242000022],
            [120.04096315200002, 11.672394943000029],
        ],
        [
            [120.03937592600005, 11.678707688000031],
            [120.03999688800002, 11.678541031000066],
            [120.04001512500008, 11.678192374000048],
            [120.0392481, 11.678146397000035],
            [120.03937592600005, 11.678707688000031],
        ],
        [
            [120.13723063600003, 11.680230355000049],
            [120.13709092400006, 11.678196544000059],
            [120.13560776800011, 11.677961437000022],
            [120.13577459100009, 11.679489983000053],
            [120.13723063600003, 11.680230355000049],
        ],
        [
            [120.02126292000003, 11.687518032000071],
            [120.02076757600003, 11.685588482000071],
            [120.01714129600009, 11.682792965000033],
            [120.0180922620001, 11.687139055000046],
            [120.02126292000003, 11.687518032000071],
        ],
        [
            [120.03954031800004, 11.68800999900003],
            [120.0481985460001, 11.68287678300004],
            [120.038928456, 11.670873253000025],
            [120.04207616700012, 11.678702246000057],
            [120.03954031800004, 11.68800999900003],
        ],
        [
            [120.14929587800009, 11.69245201800004],
            [120.14602143200011, 11.683234614000071],
            [120.14180863400009, 11.68239613000003],
            [120.13929397100003, 11.689617744000032],
            [120.14929587800009, 11.69245201800004],
        ],
        [
            [120.20455307800012, 11.706274135000058],
            [120.2051312750001, 11.705213343000025],
            [120.20329696700003, 11.704473947000054],
            [120.20354944000007, 11.70575253100003],
            [120.20455307800012, 11.706274135000058],
        ],
        [
            [119.93774201000008, 11.70802509400005],
            [119.93760701100007, 11.708186880000028],
            [119.93785365100007, 11.708413280000059],
            [119.93794742700004, 11.708225906000052],
            [119.93774201000008, 11.70802509400005],
        ],
        [
            [119.93892437400007, 11.717683400000055],
            [119.93897296600005, 11.717558997000026],
            [119.93884924100007, 11.717339344000038],
            [119.93871367600002, 11.717640009000036],
            [119.93892437400007, 11.717683400000055],
        ],
        [
            [119.97669994900002, 11.718559768000034],
            [119.97571516500011, 11.715502679000053],
            [119.97202576900008, 11.714675614000043],
            [119.97225183300009, 11.716825331000052],
            [119.97669994900002, 11.718559768000034],
        ],
        [
            [120.15572589700002, 11.729600806000064],
            [120.15747731800002, 11.727118959000052],
            [120.15450224200004, 11.71758555200006],
            [120.15331191000007, 11.726778120000063],
            [120.15572589700002, 11.729600806000064],
        ],
        [
            [119.95258081800011, 11.73575635900005],
            [119.95149950600012, 11.736348204000024],
            [119.95291161400007, 11.738322521000043],
            [119.95299038900009, 11.737319593000052],
            [119.95258081800011, 11.73575635900005],
        ],
        [
            [120.17506502100002, 11.738513667000063],
            [120.17482109600007, 11.737133147000065],
            [120.17330584600006, 11.737249891000033],
            [120.17384733900008, 11.73833501300004],
            [120.17506502100002, 11.738513667000063],
        ],
        [
            [120.10112872700006, 11.741296656000031],
            [120.10891134300005, 11.729734551000035],
            [120.10005407300002, 11.72062971300005],
            [120.10350745500011, 11.73012796100005],
            [120.10112872700006, 11.741296656000031],
        ],
        [
            [119.93239961800009, 11.747824841000067],
            [119.93757573500011, 11.737765893000073],
            [119.929695637, 11.723684306000052],
            [119.9238772220001, 11.744165203000023],
            [119.93239961800009, 11.747824841000067],
        ],
        [
            [119.96258401700004, 11.75547754400003],
            [119.96645860800004, 11.752785133000032],
            [119.94890309800007, 11.742707057000075],
            [119.95646909200002, 11.754351167000038],
            [119.96258401700004, 11.75547754400003],
        ],
        [
            [120.08506673600004, 11.764706262000061],
            [120.0858141440001, 11.763895602000048],
            [120.08452177400011, 11.763670636000029],
            [120.08413035, 11.765288192000071],
            [120.08506673600004, 11.764706262000061],
        ],
        [
            [119.96524647800004, 11.768486520000067],
            [119.96484465000003, 11.766988463000075],
            [119.96374497600004, 11.766559377000021],
            [119.963402384, 11.76799277400005],
            [119.96524647800004, 11.768486520000067],
        ],
        [
            [120.22466768800007, 11.769800560000022],
            [120.22556564900003, 11.767081201000053],
            [120.21896081300008, 11.76749140000004],
            [120.21888925700011, 11.768270648000055],
            [120.22466768800007, 11.769800560000022],
        ],
        [
            [120.16676839000002, 11.769877097000062],
            [120.16620353700011, 11.77025945400004],
            [120.16617863300007, 11.771680481000033],
            [120.1669753430001, 11.771008941000048],
            [120.16676839000002, 11.769877097000062],
        ],
        [
            [120.12639665400002, 11.771972387000062],
            [120.12879036400011, 11.771326700000031],
            [120.12566491300004, 11.769562027000063],
            [120.12517094600003, 11.771521802000052],
            [120.12639665400002, 11.771972387000062],
        ],
        [
            [119.99030140700006, 11.77435766800005],
            [119.990483519, 11.773636708000026],
            [119.99008361400001, 11.77325737800004],
            [119.98972239800003, 11.773845351000034],
            [119.99030140700006, 11.77435766800005],
        ],
        [
            [120.06514873600008, 11.774482416000069],
            [120.07009431800009, 11.772343915000022],
            [120.05657157900009, 11.76251288700007],
            [120.05658257200002, 11.77054602800007],
            [120.06514873600008, 11.774482416000069],
        ],
        [
            [119.9910539330001, 11.775000438000063],
            [119.99123608000002, 11.774657330000025],
            [119.9907651530001, 11.774273476000076],
            [119.99054904900004, 11.774708782000062],
            [119.9910539330001, 11.775000438000063],
        ],
        [
            [120.17594300500002, 11.77439914100006],
            [120.17473346500003, 11.775267503000066],
            [120.17572159100007, 11.775959580000062],
            [120.17618271300012, 11.775067530000058],
            [120.17594300500002, 11.77439914100006],
        ],
        [
            [119.99343533500007, 11.780308382000044],
            [119.99387795700011, 11.780037633000063],
            [119.993805, 11.779632611000068],
            [119.9928638670001, 11.780105440000057],
            [119.99343533500007, 11.780308382000044],
        ],
        [
            [119.9669861650001, 11.780561403000036],
            [119.9741384780001, 11.780092006000075],
            [119.97514301000001, 11.77805266100006],
            [119.96797411800003, 11.775926895000055],
            [119.9669861650001, 11.780561403000036],
        ],
        [
            [120.08296372600012, 11.781896939000035],
            [120.08427689200005, 11.78152883000007],
            [120.08406170600006, 11.779115794000063],
            [120.0832489710001, 11.779357036000022],
            [120.08296372600012, 11.781896939000035],
        ],
        [
            [119.98259957000005, 11.782057836000035],
            [119.9830495220001, 11.78138612500004],
            [119.98169775600002, 11.781218410000065],
            [119.9818583550001, 11.781814550000036],
            [119.98259957000005, 11.782057836000035],
        ],
        [
            [120.13442896200002, 11.78309620400006],
            [120.13494804800007, 11.781274085000064],
            [120.13428065200003, 11.780342817000076],
            [120.13456032400006, 11.781348752000042],
            [120.13442896200002, 11.78309620400006],
        ],
        [
            [119.977407072, 11.783328119000032],
            [119.9772320400001, 11.783436368000025],
            [119.977537632, 11.783642260000022],
            [119.97756984900002, 11.783428810000032],
            [119.977407072, 11.783328119000032],
        ],
        [
            [120.17484008000008, 11.783699399000056],
            [120.19446032300004, 11.77456135400007],
            [120.19737496700009, 11.751035884000032],
            [120.13866013900008, 11.75204111100004],
            [120.1342793450001, 11.780232698000077],
            [120.14475998600005, 11.76291223800007],
            [120.18889833500009, 11.757025034000037],
            [120.17484008000008, 11.783699399000056],
        ],
        [
            [119.97616331000006, 11.78383679600006],
            [119.97732256100005, 11.782875717000024],
            [119.9762641210001, 11.78211669600006],
            [119.97471950200008, 11.78345663500005],
            [119.97616331000006, 11.78383679600006],
        ],
        [
            [119.99957562200007, 11.783545890000028],
            [119.99930453500008, 11.783466618000034],
            [119.9994416830001, 11.78386769900004],
            [119.99960680900006, 11.783774648000076],
            [119.99957562200007, 11.783545890000028],
        ],
        [
            [119.97815569200009, 11.784011986000053],
            [119.978625523, 11.78375939600005],
            [119.97865468600003, 11.783664695000027],
            [119.97792376400002, 11.78351297200004],
            [119.97815569200009, 11.784011986000053],
        ],
        [
            [119.98046541100007, 11.784140165000053],
            [119.98088308600006, 11.780615246000025],
            [119.97743498700004, 11.779414928000051],
            [119.97918291300005, 11.783688935000043],
            [119.98046541100007, 11.784140165000053],
        ],
        [
            [119.98516911600007, 11.784335201000033],
            [119.98909691900008, 11.782229449000056],
            [119.99056035400008, 11.77997240700006],
            [119.9853300530001, 11.779527415000075],
            [119.98516911600007, 11.784335201000033],
        ],
        [
            [120.00111020800011, 11.78386901400006],
            [120.00018635600009, 11.78379440200007],
            [120.00065385900007, 11.784782595000024],
            [120.00078782900005, 11.78469259800005],
            [120.00111020800011, 11.78386901400006],
        ],
        [
            [119.977802644, 11.78487784400005],
            [119.9778026030001, 11.784577214000024],
            [119.97761834300002, 11.784578741000075],
            [119.97764448100008, 11.784843292000062],
            [119.977802644, 11.78487784400005],
        ],
        [
            [120.13475181900003, 11.785226076000072],
            [120.13470799100003, 11.784263966000026],
            [120.13384161200008, 11.784111963000043],
            [120.13417691100005, 11.785068025000044],
            [120.13475181900003, 11.785226076000072],
        ],
        [
            [119.97194258800005, 11.788112460000036],
            [119.97267360700005, 11.787977518000048],
            [119.97289484300006, 11.787616585000023],
            [119.97198268400007, 11.787429820000057],
            [119.97194258800005, 11.788112460000036],
        ],
        [
            [119.98092854200002, 11.789151348000075],
            [119.98296851100008, 11.787755977000074],
            [119.97924406600009, 11.78548451000006],
            [119.97920098600002, 11.787851922000073],
            [119.98092854200002, 11.789151348000075],
        ],
        [
            [119.99065768000003, 11.792007463000061],
            [119.99106414100004, 11.79162204100004],
            [119.99029095300011, 11.791261445000032],
            [119.9901258110001, 11.791869123000026],
            [119.99065768000003, 11.792007463000061],
        ],
        [
            [119.9691934010001, 11.792946203000042],
            [119.96937105000006, 11.792288732000031],
            [119.96886831300003, 11.792011225000067],
            [119.9686973360001, 11.79227529600007],
            [119.9691934010001, 11.792946203000042],
        ],
        [
            [119.9801643620001, 11.793435981000073],
            [119.98029339400011, 11.793223412000032],
            [119.98005736000005, 11.793123291000029],
            [119.97998025700008, 11.793269624000061],
            [119.9801643620001, 11.793435981000073],
        ],
        [
            [120.11494975000005, 11.793848316000037],
            [120.1156048360001, 11.788362995000057],
            [120.11022611200008, 11.787279381000076],
            [120.11377272700008, 11.790446670000051],
            [120.11494975000005, 11.793848316000037],
        ],
        [
            [119.985017276, 11.795130350000022],
            [119.98494338900002, 11.794491852000021],
            [119.98442800200007, 11.79442358700004],
            [119.98455288100001, 11.794995077000067],
            [119.985017276, 11.795130350000022],
        ],
        [
            [119.98681174800004, 11.795415932000026],
            [119.98711096200009, 11.794688689000054],
            [119.98601839900005, 11.794125189000056],
            [119.98598890400001, 11.794411599000057],
            [119.98681174800004, 11.795415932000026],
        ],
        [
            [119.9889620670001, 11.79707735900007],
            [119.98912565700005, 11.796507456000029],
            [119.98877082800004, 11.79630938300005],
            [119.98841108400006, 11.796799819000057],
            [119.9889620670001, 11.79707735900007],
        ],
        [
            [120.04725048800003, 11.805792331000077],
            [120.04711956200003, 11.80556150600006],
            [120.04710079400002, 11.806144064000023],
            [120.0472787970001, 11.805968809000035],
            [120.04725048800003, 11.805792331000077],
        ],
        [
            [120.0484593430001, 11.80681579700007],
            [120.04841194500011, 11.806088320000072],
            [120.04724838900006, 11.806161968000026],
            [120.04768194300004, 11.806742523000025],
            [120.0484593430001, 11.80681579700007],
        ],
        [
            [120.05069998200008, 11.813925634000043],
            [120.05307152700004, 11.811367200000063],
            [120.05300074500008, 11.807715072000065],
            [120.04880234000007, 11.80937457400006],
            [120.05069998200008, 11.813925634000043],
        ],
        [
            [120.12233497700004, 11.817526540000074],
            [120.12263393900002, 11.814283155000055],
            [120.11843163000003, 11.816313268000044],
            [120.12004091400001, 11.817530084000055],
            [120.12233497700004, 11.817526540000074],
        ],
        [
            [120.3127917280001, 11.82129784600005],
            [120.3129750380001, 11.820901548000052],
            [120.31294489700008, 11.820607249000034],
            [120.31234207000011, 11.821193125000036],
            [120.3127917280001, 11.82129784600005],
        ],
        [
            [120.06469418300003, 11.81844280100006],
            [120.07214163200001, 11.816663652000045],
            [120.05705623500012, 11.816260217000035],
            [120.0626995770001, 11.821804514000064],
            [120.06469418300003, 11.81844280100006],
        ],
        [
            [120.0462596430001, 11.823183039000071],
            [120.04602765000004, 11.820938761000036],
            [120.0422660800001, 11.820090202000074],
            [120.04202927900008, 11.82194159200003],
            [120.0462596430001, 11.823183039000071],
        ],
        [
            [120.05941330500002, 11.823640872000055],
            [120.05981073500004, 11.823099074000027],
            [120.05839494200006, 11.822578082000064],
            [120.05869121900002, 11.823194563000072],
            [120.05941330500002, 11.823640872000055],
        ],
        [
            [120.12747072800005, 11.824621599000068],
            [120.13323625600003, 11.811492567000073],
            [120.11579309700005, 11.797480762000077],
            [120.11471589400003, 11.808264931000053],
            [120.12809203600011, 11.814473863000046],
            [120.12747072800005, 11.824621599000068],
        ],
        [
            [120.0477477720001, 11.82596009200006],
            [120.04894512900012, 11.824376252000036],
            [120.0463733040001, 11.82314950600005],
            [120.04633043900003, 11.824788389000048],
            [120.0477477720001, 11.82596009200006],
        ],
        [
            [120.05496554600006, 11.826002625000058],
            [120.0555469630001, 11.825884667000025],
            [120.05564979500002, 11.825234053000031],
            [120.05472981700007, 11.825270458000034],
            [120.05496554600006, 11.826002625000058],
        ],
        [
            [120.05202326400001, 11.826665278000064],
            [120.05365408700004, 11.826077187000067],
            [120.05398650900008, 11.825482087000069],
            [120.0514180780001, 11.824879082000052],
            [120.05202326400001, 11.826665278000064],
        ],
        [
            [120.06002065500002, 11.827133576000051],
            [120.060509066, 11.826928920000057],
            [120.061167909, 11.826944368000056],
            [120.06012778900003, 11.82628924200003],
            [120.06002065500002, 11.827133576000051],
        ],
        [
            [120.0542125400001, 11.83318061600005],
            [120.05661806700004, 11.828922903000034],
            [120.058160444, 11.828277737000064],
            [120.05334118000007, 11.829838037000059],
            [120.0542125400001, 11.83318061600005],
        ],
        [
            [120.24424363700007, 11.833196432000022],
            [120.24398923400008, 11.833205859000032],
            [120.24405985900012, 11.833569365000074],
            [120.2442361300001, 11.83347599800004],
            [120.24424363700007, 11.833196432000022],
        ],
        [
            [120.05496394700003, 11.83451272900004],
            [120.054517615, 11.834945138000023],
            [120.05471868100005, 11.83516658700006],
            [120.05516544600005, 11.834940912000036],
            [120.05496394700003, 11.83451272900004],
        ],
        [
            [120.07833919900008, 11.836040938000053],
            [120.078572559, 11.835455445000036],
            [120.07801552600006, 11.834809178000057],
            [120.07768896700009, 11.834991027000058],
            [120.07833919900008, 11.836040938000053],
        ],
        [
            [120.05937957600008, 11.836529550000023],
            [120.0596872970001, 11.836557692000042],
            [120.06004824600006, 11.836356033000072],
            [120.05954391700004, 11.836045543000068],
            [120.05937957600008, 11.836529550000023],
        ],
        [
            [120.11314411100011, 11.843371528000034],
            [120.11436358600008, 11.843191556000022],
            [120.11503748900009, 11.842504786000063],
            [120.11214575100007, 11.842152402000067],
            [120.11314411100011, 11.843371528000034],
        ],
        [
            [120.31930938500011, 11.845509402000062],
            [120.32132274500009, 11.844341734000068],
            [120.3209742900001, 11.841155737000065],
            [120.31868564500007, 11.845764598000073],
            [120.31930938500011, 11.845509402000062],
        ],
        [
            [120.3212415270001, 11.847596649000025],
            [120.32158603300002, 11.847551573000032],
            [120.32156222000003, 11.847316529000068],
            [120.32095802800006, 11.847602658000028],
            [120.3212415270001, 11.847596649000025],
        ],
        [
            [120.09141695200003, 11.848572699000044],
            [120.09128818300007, 11.848379243000068],
            [120.09105537800008, 11.848390766000023],
            [120.09116247200006, 11.848605278000036],
            [120.09141695200003, 11.848572699000044],
        ],
        [
            [120.31724205000012, 11.85076155300004],
            [120.32151518600006, 11.849174206000043],
            [120.31713940800012, 11.844846845000063],
            [120.31198587000006, 11.825494369000069],
            [120.31724205000012, 11.85076155300004],
        ],
        [
            [120.07238993100009, 11.851293799000075],
            [120.10287787300001, 11.845837970000048],
            [120.11520911900004, 11.810781605000045],
            [120.08325228000001, 11.826470138000047],
            [120.07238993100009, 11.851293799000075],
        ],
        [
            [119.89678692400003, 11.861226],
            [119.8969190250001, 11.861029292000069],
            [119.89616011800001, 11.860844158000077],
            [119.8963844760001, 11.86122115300003],
            [119.89678692400003, 11.861226],
        ],
        [
            [120.07981837600005, 11.868905373000075],
            [120.08282650100011, 11.86812246200003],
            [120.09208968200005, 11.86071976900007],
            [120.08054430100003, 11.859158911000065],
            [120.07981837600005, 11.868905373000075],
        ],
        [
            [119.99804502600011, 11.892796616000055],
            [119.99775852500011, 11.892970439000067],
            [119.99804492300007, 11.89338919100004],
            [119.99821900300003, 11.893263253000043],
            [119.99804502600011, 11.892796616000055],
        ],
        [
            [120.05380234900008, 11.91043699100004],
            [120.05409844000008, 11.909243460000027],
            [120.05324926700007, 11.909097260000067],
            [120.05273163400011, 11.909766111000067],
            [120.05380234900008, 11.91043699100004],
        ],
        [
            [120.04717682400008, 11.91553377100007],
            [120.0503678020001, 11.91306548800003],
            [120.04259755800001, 11.915358162000075],
            [120.04657238900006, 11.915774180000028],
            [120.04717682400008, 11.91553377100007],
        ],
        [
            [120.04098325600012, 11.916667626000049],
            [120.04275125400011, 11.914966707000076],
            [120.03751406000003, 11.91499477800005],
            [120.0382305600001, 11.915876315000048],
            [120.04098325600012, 11.916667626000049],
        ],
        [
            [120.02397932400004, 11.929097220000074],
            [120.02561585800004, 11.928630777000023],
            [120.02465382700007, 11.926220982000075],
            [120.02231979200008, 11.927373695000028],
            [120.02397932400004, 11.929097220000074],
        ],
        [
            [120.01975808500003, 11.930988701000047],
            [120.02137075400003, 11.930955919000041],
            [120.02178339400007, 11.930793101000063],
            [120.01898304800011, 11.93049061000005],
            [120.01975808500003, 11.930988701000047],
        ],
        [
            [120.03251481200004, 11.93184315600007],
            [120.03473130800012, 11.930802095000047],
            [120.0345665640001, 11.929967387000033],
            [120.03169199400008, 11.930893680000054],
            [120.03251481200004, 11.93184315600007],
        ],
        [
            [120.039360052, 11.934117938000043],
            [120.03980206900007, 11.933453271000076],
            [120.03878963400007, 11.933553535000044],
            [120.03889803700008, 11.933955426000068],
            [120.039360052, 11.934117938000043],
        ],
        [
            [120.04313249200004, 11.934205789000032],
            [120.06169339900009, 11.929992904000073],
            [120.06841962500005, 11.916954213000054],
            [120.04313987700004, 11.91742195200004],
            [120.04313249200004, 11.934205789000032],
        ],
        [
            [119.97982260100002, 11.935004011000046],
            [119.98036180600002, 11.930978737000032],
            [119.97448401800011, 11.930377822000025],
            [119.9749204850001, 11.934186648000036],
            [119.97982260100002, 11.935004011000046],
        ],
        [
            [120.02395254300006, 11.937084850000076],
            [120.02596233200006, 11.935932670000057],
            [120.02714908300004, 11.933117965000065],
            [120.02396281500012, 11.934503800000073],
            [120.02395254300006, 11.937084850000076],
        ],
        [
            [119.82225487500011, 11.939612295000074],
            [119.82237386500003, 11.939098742000056],
            [119.82156467300001, 11.938606175000075],
            [119.82150349100004, 11.939210280000054],
            [119.82225487500011, 11.939612295000074],
        ],
        [
            [119.98958959900006, 11.94167032200005],
            [119.99319562300002, 11.940708087000075],
            [119.99425373300005, 11.936830927000074],
            [119.99036587400008, 11.937652964000051],
            [119.98958959900006, 11.94167032200005],
        ],
        [
            [119.99746428300011, 11.942464862000065],
            [120.00222557200004, 11.940536436000059],
            [120.00222560500004, 11.93806700600004],
            [119.99518449800007, 11.940153130000056],
            [119.99746428300011, 11.942464862000065],
        ],
        [
            [119.96846097600007, 11.948224478000043],
            [119.96964319400001, 11.946958738000035],
            [119.97488298200005, 11.945411845000024],
            [119.96739180500003, 11.945208774000037],
            [119.96846097600007, 11.948224478000043],
        ],
        [
            [120.02789463800002, 11.948680309000054],
            [120.0262590100001, 11.946914002000028],
            [120.02970934900009, 11.946194581000043],
            [120.03258508800002, 11.940089562000026],
            [120.0248719970001, 11.946282291000045],
            [120.02789463800002, 11.948680309000054],
        ],
        [
            [120.01257831500004, 11.949114303000044],
            [120.01641441600009, 11.94823784600004],
            [120.0180610110001, 11.946978032000061],
            [120.01640015200007, 11.945996586000035],
            [120.01257831500004, 11.949114303000044],
        ],
        [
            [119.9823369080001, 11.94945053500004],
            [119.98197153600006, 11.948742068000058],
            [119.98111560000007, 11.949044571000059],
            [119.98164966600007, 11.949464593000073],
            [119.9823369080001, 11.94945053500004],
        ],
        [
            [119.86703228300007, 11.950726334000024],
            [119.86736358300004, 11.950083935000066],
            [119.86622889900002, 11.949396722000074],
            [119.86586083300006, 11.950191580000023],
            [119.86703228300007, 11.950726334000024],
        ],
        [
            [119.97362050200002, 11.952782821000028],
            [119.97781977300008, 11.951661909000052],
            [119.97813605200008, 11.951342521000072],
            [119.97427454800004, 11.950362833000042],
            [119.97362050200002, 11.952782821000028],
        ],
        [
            [120.27752685500002, 11.954528808000077],
            [120.27630615200007, 11.955078125000057],
            [120.27807617200006, 11.956481933000077],
            [120.27807617200006, 11.955322266000053],
            [120.27752685500002, 11.954528808000077],
        ],
        [
            [119.97054580600002, 11.956541322000021],
            [119.97071411000002, 11.955989419000048],
            [119.96994834500003, 11.95507744400004],
            [119.968451952, 11.955947841000068],
            [119.97054580600002, 11.956541322000021],
        ],
        [
            [120.27587890600012, 11.955871582000043],
            [120.2747192380001, 11.955871582000043],
            [120.274902343, 11.957092285000044],
            [120.2756958010001, 11.957275391000053],
            [120.27587890600012, 11.955871582000043],
        ],
        [
            [119.94137614800002, 11.957939643000032],
            [119.9424025190001, 11.957148509000035],
            [119.94223809100004, 11.95590868100004],
            [119.94030872400003, 11.956900102000077],
            [119.94137614800002, 11.957939643000032],
        ],
        [
            [120.08511487600003, 11.958020784000041],
            [120.08676194100008, 11.957583728000031],
            [120.0870418930001, 11.957313959000032],
            [120.0857879030001, 11.957185151000033],
            [120.08511487600003, 11.958020784000041],
        ],
        [
            [120.26691014100004, 11.958444839000038],
            [120.26705205300004, 11.958256212000038],
            [120.26683193000008, 11.95817366700004],
            [120.26681209100002, 11.958338551000054],
            [120.26691014100004, 11.958444839000038],
        ],
        [
            [119.95983644800003, 11.957988579000073],
            [119.95920331800005, 11.958019428000057],
            [119.95829049800011, 11.958907043000067],
            [119.95921737200001, 11.958784259000026],
            [119.95983644800003, 11.957988579000073],
        ],
        [
            [119.93720259500003, 11.96058477300005],
            [119.93739393400006, 11.960516072000075],
            [119.93714009500002, 11.959812845000044],
            [119.93699705900008, 11.960077565000063],
            [119.93720259500003, 11.96058477300005],
        ],
        [
            [119.93746266800008, 11.96157604900003],
            [119.93748453400008, 11.961048257000073],
            [119.93726951700012, 11.960922136000022],
            [119.93704865600012, 11.961178486000051],
            [119.93746266800008, 11.96157604900003],
        ],
        [
            [119.93177378700011, 11.961838278000073],
            [119.93277069900012, 11.959513910000055],
            [119.93166842900007, 11.95855923800002],
            [119.93055069200011, 11.960203561000071],
            [119.93177378700011, 11.961838278000073],
        ],
        [
            [119.84560562500008, 11.96192921000005],
            [119.84552974000007, 11.961762622000037],
            [119.84537055900012, 11.961925584000028],
            [119.84543904100008, 11.962021554000046],
            [119.84560562500008, 11.96192921000005],
        ],
        [
            [119.8455038190001, 11.962220735000074],
            [119.84560191900005, 11.962137443000074],
            [119.84555935000003, 11.96207044700003],
            [119.84536130000004, 11.962162789000047],
            [119.8455038190001, 11.962220735000074],
        ],
        [
            [120.10405881800011, 11.962232468000025],
            [120.10932840700002, 11.957161987000063],
            [120.10912484000005, 11.955101352000042],
            [120.1033077410001, 11.962121712000055],
            [120.10405881800011, 11.962232468000025],
        ],
        [
            [120.16646124700003, 11.962413198000036],
            [120.16507068200008, 11.956086223000057],
            [120.15656889000002, 11.959487170000045],
            [120.16414834200009, 11.960965936000036],
            [120.16646124700003, 11.962413198000036],
        ],
        [
            [120.18092265400003, 11.963646011000037],
            [120.18046938700002, 11.962948012000027],
            [120.17949579300011, 11.96323327500005],
            [120.17998436900007, 11.963862212000038],
            [120.18092265400003, 11.963646011000037],
        ],
        [
            [120.31811523400006, 11.962280274000022],
            [120.31451416000004, 11.964477540000075],
            [120.31347656300011, 11.968078613000046],
            [120.31890869200004, 11.964721679000036],
            [120.31811523400006, 11.962280274000022],
        ],
        [
            [119.99648395600002, 11.969884311000044],
            [120.02139637700009, 11.958998802000053],
            [120.01123721700003, 11.950778872000058],
            [120.0154820790001, 11.943009938000046],
            [119.9750887350001, 11.956410014000028],
            [119.99648395600002, 11.969884311000044],
        ],
        [
            [120.15089288500008, 11.973449196000047],
            [120.15062525100006, 11.973091575000069],
            [120.14992685000004, 11.973025537000069],
            [120.15039489000003, 11.973408328000062],
            [120.15089288500008, 11.973449196000047],
        ],
        [
            [120.15206610400003, 11.973508354000046],
            [120.1524048980001, 11.972102987000028],
            [120.14983172500001, 11.97057750700003],
            [120.14977330900001, 11.972768694000024],
            [120.15206610400003, 11.973508354000046],
        ],
        [
            [119.864622284, 11.97510333100007],
            [119.86417781700004, 11.974691470000039],
            [119.86349924300009, 11.974893420000058],
            [119.8637480000001, 11.97506876500006],
            [119.864622284, 11.97510333100007],
        ],
        [
            [120.30688476600005, 11.975708008000026],
            [120.30609130800008, 11.97509765600006],
            [120.30572509700005, 11.976074219000054],
            [120.30627441400009, 11.976074219000054],
            [120.30688476600005, 11.975708008000026],
        ],
        [
            [120.30590820300006, 11.977478028000064],
            [120.30529785200008, 11.977111816000047],
            [120.30487060500002, 11.978088379000042],
            [120.30548095600011, 11.978088379000042],
            [120.30590820300006, 11.977478028000064],
        ],
        [
            [119.97636563200001, 11.979294548000041],
            [119.97977945100001, 11.97846041300005],
            [119.98016983100001, 11.977594802000056],
            [119.9780309790001, 11.977377223000076],
            [119.97636563200001, 11.979294548000041],
        ],
        [
            [119.90267817900008, 11.979596301000072],
            [119.92106182000009, 11.956987050000066],
            [119.96663980800008, 11.944924526000023],
            [119.94462488400006, 11.90965486400006],
            [120.0123729390001, 11.933867419000023],
            [120.02964759300005, 11.914150394000046],
            [119.98752148800008, 11.896882513000037],
            [120.04213937100008, 11.862426335000066],
            [120.07499482300011, 11.863258735000045],
            [120.03642090400001, 11.858265926000058],
            [120.01975240400009, 11.840750771000046],
            [120.0511790270001, 11.839691964000053],
            [120.03012886700003, 11.806327791000058],
            [120.07373031800012, 11.788258281000026],
            [120.0347217100001, 11.757589721000045],
            [120.0578990140001, 11.756317792000061],
            [120.04931016300009, 11.718367019000027],
            [119.98071536400005, 11.66662658100006],
            [119.95824086800008, 11.695004509000057],
            [119.9567512110001, 11.658807902000035],
            [119.93871218100003, 11.730450563000034],
            [119.94776136100006, 11.739734287000033],
            [119.94882761200006, 11.723273435000067],
            [119.96720097700006, 11.728868397000042],
            [119.97119552200002, 11.71465416500007],
            [119.97898034500008, 11.713493434000043],
            [119.97729376500001, 11.719651249000037],
            [119.9706733590001, 11.722954880000032],
            [119.96872283800008, 11.732111810000049],
            [119.95378276500003, 11.732284801000048],
            [119.95457899300004, 11.743345326000053],
            [119.97251596100011, 11.748247968000044],
            [119.9723498730001, 11.765029790000028],
            [119.99515536000001, 11.769710704000033],
            [120.00340259900008, 11.78705640100003],
            [119.9889558540001, 11.801541556000075],
            [119.96346413000003, 11.800351703000047],
            [119.96291798100003, 11.764470354000025],
            [119.93027599700008, 11.76009620000002],
            [119.90687521600012, 11.792627908000043],
            [119.91519531400002, 11.844123608000075],
            [119.84598547300004, 11.947911610000062],
            [119.8909212420001, 11.923624712000048],
            [119.872165934, 11.969581947000052],
            [119.90267817900008, 11.979596301000072],
        ],
        [
            [120.05441639900005, 11.747608777000039],
            [120.05365527200001, 11.747348190000025],
            [120.0539849270001, 11.74654577800004],
            [120.05450275900012, 11.747208236000063],
            [120.05441639900005, 11.747608777000039],
        ],
        [
            [119.96435251900004, 11.904931221000027],
            [119.96380723900006, 11.904833039000039],
            [119.96364379800002, 11.90458462600003],
            [119.96466429200007, 11.904472261000024],
            [119.96435251900004, 11.904931221000027],
        ],
        [
            [119.94345904400006, 11.981617301000028],
            [119.95904813100003, 11.97719898500003],
            [119.97429984500002, 11.964246738000043],
            [119.95268964800005, 11.966449785000066],
            [119.93877222900005, 11.957411099000069],
            [119.94345904400006, 11.981617301000028],
        ],
        [
            [119.8328866920001, 11.981844831000046],
            [119.83258937900007, 11.980629917000044],
            [119.83168162600009, 11.98059896600006],
            [119.83203194100008, 11.98145322800002],
            [119.8328866920001, 11.981844831000046],
        ],
        [
            [119.87214718300004, 11.982463594000023],
            [119.878596732, 11.980979346000026],
            [119.85359347600001, 11.975198873000068],
            [119.83037570300007, 11.938463885000033],
            [119.82291779600007, 11.940322261000063],
            [119.84544051900002, 11.980200999000033],
            [119.87214718300004, 11.982463594000023],
        ],
        [
            [119.96266487900004, 11.98276994300005],
            [119.96445033100008, 11.981569171000046],
            [119.96442009500004, 11.981153358000029],
            [119.9606681140001, 11.982268489000035],
            [119.96266487900004, 11.98276994300005],
        ],
        [
            [120.23019503500007, 11.983498753000049],
            [120.23109558500005, 11.983481726000036],
            [120.23121587000003, 11.983333099000049],
            [120.23048466800003, 11.98276336300006],
            [120.23019503500007, 11.983498753000049],
        ],
        [
            [120.12278654600004, 11.983727131000023],
            [120.12520394900002, 11.979681471000049],
            [120.12248335900006, 11.977868414000056],
            [120.12024657500001, 11.981395478000024],
            [120.12278654600004, 11.983727131000023],
        ],
        [
            [119.97913091200007, 11.983835141000043],
            [119.98522489400011, 11.980842155000062],
            [119.98699765900005, 11.97682465500003],
            [119.97354753400009, 11.982441723000022],
            [119.97913091200007, 11.983835141000043],
        ],
        [
            [119.83228559300005, 11.983724577000032],
            [119.83281690000001, 11.983005676000062],
            [119.8298359910001, 11.982491221000032],
            [119.83131911900011, 11.983793690000027],
            [119.83228559300005, 11.983724577000032],
        ],
        [
            [120.19894351500011, 11.98353749100005],
            [120.20115266200003, 11.982513668000024],
            [120.20090213700007, 11.97993675500004],
            [120.19678044400007, 11.98016179900003],
            [120.19894351500011, 11.98353749100005],
        ],
        [
            [120.22980885700008, 11.984242737000045],
            [120.22999877900008, 11.984177714000054],
            [120.229959215, 11.983683842000062],
            [120.22968066200008, 11.983738026000026],
            [120.22980885700008, 11.984242737000045],
        ],
        [
            [120.22990984800003, 11.985049339000057],
            [120.22975660400004, 11.984752618000073],
            [120.22945643000003, 11.984998337000036],
            [120.22971394500007, 11.985302789000059],
            [120.22990984800003, 11.985049339000057],
        ],
        [
            [120.23232691900012, 11.985362162000058],
            [120.23257674500007, 11.985279073000072],
            [120.23259839500008, 11.984894582000038],
            [120.2321170670001, 11.985163401000023],
            [120.23232691900012, 11.985362162000058],
        ],
        [
            [120.23163821700007, 11.984939617000066],
            [120.2312258720001, 11.985443425000028],
            [120.2312716880001, 11.985533060000023],
            [120.23170457100002, 11.98517915800005],
            [120.23163821700007, 11.984939617000066],
        ],
        [
            [120.22948170300003, 11.985662868000077],
            [120.22943272700002, 11.98561032300006],
            [120.22941219000006, 11.985486689000027],
            [120.22942324700011, 11.98573086600004],
            [120.22948170300003, 11.985662868000077],
        ],
        [
            [120.24527796200005, 11.98714489200006],
            [120.27670409900009, 11.935764137000035],
            [120.2487566640001, 11.907932501000062],
            [120.2621872410001, 11.80725270000005],
            [120.19161877400006, 11.936801143000025],
            [120.19280138500005, 11.952992237000046],
            [120.24527796200005, 11.98714489200006],
        ],
        [
            [120.20338769800003, 11.947166174000074],
            [120.20284617000004, 11.944796499000063],
            [120.20401052500006, 11.94450196200006],
            [120.20373812000003, 11.946846711000035],
            [120.20338769800003, 11.947166174000074],
        ],
        [
            [120.20608588700009, 11.948892134000062],
            [120.20564466600001, 11.948956036000027],
            [120.20536748400002, 11.947423152000056],
            [120.20766440300008, 11.948490051000022],
            [120.20608588700009, 11.948892134000062],
        ],
        [
            [120.21318691800002, 11.954825303000064],
            [120.21301404700012, 11.955145125000058],
            [120.21247495700004, 11.954842240000062],
            [120.21309417300006, 11.954370185000073],
            [120.21318691800002, 11.954825303000064],
        ],
        [
            [120.22764553800005, 11.962414161000027],
            [120.22738776500012, 11.962271189000035],
            [120.22763450200011, 11.96205283300003],
            [120.22771782400002, 11.962288074000071],
            [120.22764553800005, 11.962414161000027],
        ],
        [
            [120.2265214890001, 11.962704403000032],
            [120.22495434000007, 11.962015085000075],
            [120.22589440800004, 11.960790987000053],
            [120.2270529970001, 11.962280445000033],
            [120.2265214890001, 11.962704403000032],
        ],
        [
            [120.22918503800008, 11.96617778700005],
            [120.22937297500005, 11.966465150000033],
            [120.22916609000004, 11.966594929000053],
            [120.228847072, 11.966193239000063],
            [120.22918503800008, 11.96617778700005],
        ],
        [
            [120.23779590700008, 11.981951337000055],
            [120.23734385600005, 11.981342262000055],
            [120.23871765500007, 11.980644260000076],
            [120.23883067700001, 11.981010577000063],
            [120.23779590700008, 11.981951337000055],
        ],
        [
            [119.88288040200007, 11.987143828000058],
            [119.88788023300003, 11.985001347000036],
            [119.88761245600006, 11.981928853000056],
            [119.88211139600003, 11.984993576000022],
            [119.88288040200007, 11.987143828000058],
        ],
        [
            [120.019292543, 11.987221082000076],
            [120.02702724700009, 11.97507263600005],
            [120.02544751700009, 11.971282216000077],
            [120.00994556500007, 11.980227996000053],
            [120.019292543, 11.987221082000076],
        ],
        [
            [119.96451076100004, 11.991852041000072],
            [119.96740755700012, 11.991038145000061],
            [119.96756994400005, 11.990372140000034],
            [119.96648091400004, 11.990040264000072],
            [119.96560866000004, 11.990024541000025],
            [119.96537788300009, 11.990063689000067],
            [119.96517574900008, 11.990145803000075],
            [119.96451076100004, 11.991852041000072],
        ],
        [
            [119.92240134400004, 11.992192489000047],
            [119.92357804400001, 11.99177194200007],
            [119.92405514600011, 11.990876915000058],
            [119.92153845500002, 11.99107964600006],
            [119.92240134400004, 11.992192489000047],
        ],
        [
            [120.18030328300006, 11.992650570000023],
            [120.1975375180001, 11.968202597000072],
            [120.17740229800006, 11.98216629600006],
            [120.13053873100012, 11.974791289000052],
            [120.13339942400012, 11.992259513000022],
            [120.18030328300006, 11.992650570000023],
        ],
        [
            [120.16288068100005, 11.986362317000044],
            [120.1619396210001, 11.985319828000058],
            [120.16413986900011, 11.985443438000061],
            [120.16344494400005, 11.986207643000057],
            [120.16288068100005, 11.986362317000044],
        ],
        [
            [120.15246600900002, 11.988188068000056],
            [120.151886009, 11.986716299000022],
            [120.15273539600003, 11.985673102000021],
            [120.154072788, 11.987320604000047],
            [120.15246600900002, 11.988188068000056],
        ],
        [
            [120.17171973200004, 11.988906008000072],
            [120.1702046150001, 11.988185714000053],
            [120.16976305800006, 11.987693849000038],
            [120.17085641300002, 11.987377124000034],
            [120.17171973200004, 11.988906008000072],
        ],
        [
            [120.3831176760001, 11.990478516000053],
            [120.38171386700003, 11.99108886700003],
            [120.38452148400006, 11.995117188000052],
            [120.3850708010001, 11.991699219000054],
            [120.3831176760001, 11.990478516000053],
        ],
        [
            [120.06134090500007, 11.995306208000045],
            [120.07500331800009, 11.984180448000075],
            [120.08464989800007, 11.958532385000069],
            [120.06598665000001, 11.96243168500007],
            [120.06134090500007, 11.995306208000045],
        ],
        [
            [120.07071507800003, 11.962573717000055],
            [120.07075195700008, 11.963052957000059],
            [120.07038834200011, 11.963161853000031],
            [120.07037678000006, 11.962933325000051],
            [120.07071507800003, 11.962573717000055],
        ],
        [
            [119.9473727620001, 11.996040480000033],
            [119.96102624000002, 11.992496540000047],
            [119.96290625000006, 11.989692620000028],
            [119.93591407200006, 11.98642452100006],
            [119.9473727620001, 11.996040480000033],
        ],
        [
            [120.14155956500008, 11.99999411500005],
            [120.14419753600009, 11.996088263000047],
            [120.14438762000009, 11.99258913400007],
            [120.14196651200007, 11.995250180000028],
            [120.14155956500008, 11.99999411500005],
        ],
        [
            [119.84017923400006, 12.000360687000068],
            [119.86303834400007, 11.999513721000028],
            [119.87348449800004, 11.993791646000034],
            [119.83553141700008, 11.988170371000024],
            [119.84017923400006, 12.000360687000068],
        ],
        [
            [119.85379656400005, 11.997184847000028],
            [119.85374691400011, 11.997256794000066],
            [119.85386460400002, 11.996961808000037],
            [119.85391425300008, 11.997017568000047],
            [119.85379656400005, 11.997184847000028],
        ],
        [
            [119.85384253100005, 11.997647114000074],
            [119.8538480520001, 11.997188445000063],
            [119.85411469000007, 11.996945622000055],
            [119.85405584000011, 11.997585959000048],
            [119.85384253100005, 11.997647114000074],
        ],
        [
            [120.1909709570001, 12.001643235000074],
            [120.19237749100012, 11.999856118000025],
            [120.1924414560001, 11.999109848000046],
            [120.18989297700011, 11.999551340000039],
            [120.1909709570001, 12.001643235000074],
        ],
        [
            [120.18490559700001, 12.007364261000077],
            [120.18583965300002, 12.007145984000033],
            [120.1857155240001, 12.006245056000068],
            [120.18437536300007, 12.007020234000038],
            [120.18490559700001, 12.007364261000077],
        ],
        [
            [119.88550022600009, 12.007411005000051],
            [119.88847346300008, 12.006822534000037],
            [119.88817808100009, 12.005315694000046],
            [119.88327290300003, 12.005928551000068],
            [119.88550022600009, 12.007411005000051],
        ],
        [
            [119.86772950600005, 12.011295145000076],
            [119.87086889900002, 12.010841259000074],
            [119.87211165600002, 12.008121754000058],
            [119.86633402700011, 12.00975420900005],
            [119.86772950600005, 12.011295145000076],
        ],
        [
            [119.86754195700007, 12.011725899000055],
            [119.86765641300008, 12.011594487000025],
            [119.86725277800008, 12.011339888000066],
            [119.86734748300012, 12.01166052900004],
            [119.86754195700007, 12.011725899000055],
        ],
        [
            [119.94221356500009, 12.01126677600007],
            [119.94299261600008, 12.009873601000038],
            [119.94168569200008, 12.006970204000027],
            [119.94046377100005, 12.013291994000042],
            [119.94221356500009, 12.01126677600007],
        ],
        [
            [119.88227033200008, 12.015072682000039],
            [119.88435028000004, 12.008750301000077],
            [119.87610942200001, 12.010925497000073],
            [119.87958408100008, 12.014301741000054],
            [119.88227033200008, 12.015072682000039],
        ],
        [
            [119.89590556400003, 12.018517848000045],
            [119.89927024000008, 12.018439864000072],
            [119.89844231000006, 12.015060670000025],
            [119.8956159380001, 12.015366866000022],
            [119.89590556400003, 12.018517848000045],
        ],
        [
            [120.14697522200004, 12.01988822900006],
            [120.16157234200011, 12.008059485000047],
            [120.18274729900008, 12.002630348000025],
            [120.17591682500006, 11.996296888000074],
            [120.14697522200004, 12.01988822900006],
        ],
        [
            [120.15422969500003, 12.022101340000063],
            [120.15451614200003, 12.021727868000028],
            [120.15385304100005, 12.021658278000075],
            [120.15384359600012, 12.022034255000051],
            [120.15422969500003, 12.022101340000063],
        ],
        [
            [119.88863895800012, 12.026142210000046],
            [119.89512736600011, 12.021079817000043],
            [119.88773466700002, 12.015840758000024],
            [119.88536743000009, 12.016847540000072],
            [119.88863895800012, 12.026142210000046],
        ],
        [
            [119.9797096310001, 12.02682184300005],
            [119.98047423100002, 12.02616944600004],
            [119.98075745100004, 12.024856014000022],
            [119.97940840400008, 12.025713308000036],
            [119.9797096310001, 12.02682184300005],
        ],
        [
            [119.91353001700008, 12.028788101000032],
            [119.9136671760001, 12.028632755000046],
            [119.91357262300005, 12.02855554100006],
            [119.91323982800009, 12.028907119000053],
            [119.91353001700008, 12.028788101000032],
        ],
        [
            [119.91948883200007, 12.030527581000058],
            [119.92153024100003, 12.02196089000006],
            [119.91850415700003, 12.016103754000028],
            [119.92014980700003, 12.022253695000074],
            [119.91948883200007, 12.030527581000058],
        ],
        [
            [119.95229769000002, 12.031175383000061],
            [119.95050323200007, 12.022293270000034],
            [119.94189058000006, 12.01670460400004],
            [119.94464793500003, 12.025817825000047],
            [119.95229769000002, 12.031175383000061],
        ],
        [
            [119.90652664100003, 12.037222963000033],
            [119.91237935700008, 12.028899370000033],
            [119.91583803000003, 12.02593938700005],
            [119.91015265600004, 12.018835654000043],
            [119.90652664100003, 12.037222963000033],
        ],
        [
            [120.35724549500003, 12.043691344000024],
            [120.35998645600012, 12.03007418900006],
            [120.35888256100009, 12.028171764000035],
            [120.35352938100004, 12.038624988000038],
            [120.35724549500003, 12.043691344000024],
        ],
        [
            [119.90473507600007, 12.047594012000047],
            [119.905275243, 12.046984672000065],
            [119.9053033450001, 12.04622352000007],
            [119.90389859200002, 12.047954119000053],
            [119.90473507600007, 12.047594012000047],
        ],
        [
            [119.86601485300002, 12.049488802000042],
            [119.87032843500003, 12.046859122000058],
            [119.87854704400002, 12.047372093000035],
            [119.88011022900002, 12.046826176000025],
            [119.86761042, 12.046501737000028],
            [119.86601485300002, 12.049488802000042],
        ],
        [
            [119.90159217100006, 12.051179039000033],
            [119.89533283300011, 12.042497592000075],
            [119.89114786000005, 12.04438783200004],
            [119.89939703000005, 12.050765846000047],
            [119.90159217100006, 12.051179039000033],
        ],
        [
            [119.95509555400008, 12.053025561000027],
            [119.96067049500004, 12.051990280000041],
            [119.95988097700001, 12.04615433400005],
            [119.9531701300001, 12.048493903000065],
            [119.95509555400008, 12.053025561000027],
        ],
        [
            [119.8994099250001, 12.05608359100006],
            [119.90415186300004, 12.054243573000065],
            [119.90451296700007, 12.053384527000048],
            [119.90182952500004, 12.051282928000035],
            [119.8994099250001, 12.05608359100006],
        ],
        [
            [119.87975307700003, 12.057347537000055],
            [119.87807102900001, 12.056761916000028],
            [119.87729811400004, 12.05709239500004],
            [119.87776383900007, 12.05784359100005],
            [119.87975307700003, 12.057347537000055],
        ],
        [
            [119.79213249700001, 12.05898066900005],
            [119.79496684800006, 12.05133238600007],
            [119.78457543400009, 12.051244190000034],
            [119.78596749400003, 12.054264867000029],
            [119.79213249700001, 12.05898066900005],
        ],
        [
            [119.87662787700003, 12.066028643000038],
            [119.87815611400003, 12.066102407000074],
            [119.87940620900008, 12.065313127000024],
            [119.87757416400007, 12.064888034000035],
            [119.87662787700003, 12.066028643000038],
        ],
        [
            [119.83569336000005, 12.073486328000058],
            [119.83532714800003, 12.073120118000077],
            [119.83410644500009, 12.073730469000054],
            [119.83508300800008, 12.074890136000022],
            [119.83569336000005, 12.073486328000058],
        ],
        [
            [120.33892822300004, 12.07592773500005],
            [120.33648681600005, 12.076293946000021],
            [120.33648681600005, 12.078674316000047],
            [120.3377075190001, 12.079101563000052],
            [120.33892822300004, 12.07592773500005],
        ],
        [
            [119.87515085200005, 12.083464380000066],
            [119.87669115200003, 12.08259487600003],
            [119.87340206300007, 12.081385759000057],
            [119.87399128400011, 12.083245659000056],
            [119.87515085200005, 12.083464380000066],
        ],
        [
            [121.93699499800005, 12.09667379900003],
            [121.96175664200007, 12.065356047000023],
            [121.95383669700004, 12.031422525000039],
            [121.91069489900008, 12.06301428100005],
            [121.93699499800005, 12.09667379900003],
        ],
        [
            [119.84647162300007, 12.107369457000061],
            [119.851857461, 12.10710399800007],
            [119.85088625800006, 12.103819687000055],
            [119.84765207500004, 12.102484609000044],
            [119.84647162300007, 12.107369457000061],
        ],
        [
            [119.87382749000005, 12.115216704000034],
            [119.87360052300005, 12.115550282000072],
            [119.87380072300004, 12.115861796000047],
            [119.87402346400006, 12.115627461000031],
            [119.87382749000005, 12.115216704000034],
        ],
        [
            [119.86871337900004, 12.115905762000068],
            [119.8682861320001, 12.115478516000053],
            [119.86810302700007, 12.11608886700003],
            [119.86871337900004, 12.115905762000068],
        ],
        [
            [119.87484749000009, 12.116619864000029],
            [119.87409381300006, 12.116083282000034],
            [119.87419899600002, 12.119372311000063],
            [119.87521935900008, 12.117929740000022],
            [119.87484749000009, 12.116619864000029],
        ],
        [
            [119.87550570300004, 12.125213248000023],
            [119.8759360030001, 12.125013722000062],
            [119.87584740900002, 12.124674997000056],
            [119.87536332200011, 12.12491628500004],
            [119.87550570300004, 12.125213248000023],
        ],
        [
            [119.9204243370001, 12.132144985000025],
            [119.92241734800007, 12.12663376100005],
            [119.92114667200008, 12.125295857000026],
            [119.91750102300011, 12.126261938000027],
            [119.9204243370001, 12.132144985000025],
        ],
        [
            [119.8451812720001, 12.133146383000053],
            [119.8555582240001, 12.11442136900007],
            [119.85430323800006, 12.11279857900007],
            [119.84431886300001, 12.114542243000074],
            [119.8451812720001, 12.133146383000053],
        ],
        [
            [119.88513473700004, 12.139871392000032],
            [119.88686327500011, 12.135680623000042],
            [119.88611433200003, 12.130096432000073],
            [119.88130247400011, 12.13658558000003],
            [119.88513473700004, 12.139871392000032],
        ],
        [
            [120.17986984400011, 12.140032140000073],
            [120.1838384350001, 12.139362604000041],
            [120.18409834200008, 12.139082361000021],
            [120.18163251200008, 12.13747907000004],
            [120.17986984400011, 12.140032140000073],
        ],
        [
            [120.15660848100003, 12.146833623000077],
            [120.16145488500001, 12.144038623000029],
            [120.1627022020001, 12.141012815000067],
            [120.15973830000007, 12.141472478000026],
            [120.15660848100003, 12.146833623000077],
        ],
        [
            [120.187288039, 12.148903045000054],
            [120.18902038800002, 12.14782228100006],
            [120.18926215500005, 12.147274913000047],
            [120.18803931500008, 12.147429165000062],
            [120.187288039, 12.148903045000054],
        ],
        [
            [120.20902076900006, 12.152053580000029],
            [120.20931766800004, 12.151884274000054],
            [120.20959447100006, 12.151142038000046],
            [120.20924035700011, 12.151318901000025],
            [120.20902076900006, 12.152053580000029],
        ],
        [
            [122.0427051050001, 12.15458886600004],
            [122.04358510500003, 12.141315834000068],
            [122.03098270700002, 12.140995042000043],
            [122.03227159300002, 12.146999128000061],
            [122.0427051050001, 12.15458886600004],
        ],
        [
            [122.03874836500006, 12.15427851000004],
            [122.03627667300009, 12.154120609000074],
            [122.03593939100006, 12.152439247000075],
            [122.0343612040001, 12.152241447000051],
            [122.03581447900001, 12.155069597000022],
            [122.03874836500006, 12.15427851000004],
        ],
        [
            [120.26554478700007, 12.156530822000036],
            [120.2672179430001, 12.155910335000044],
            [120.26623538000001, 12.154172137000046],
            [120.26497006300008, 12.154342019000069],
            [120.26554478700007, 12.156530822000036],
        ],
        [
            [120.25411199400003, 12.156657334000045],
            [120.26480541900003, 12.154713423000032],
            [120.259278472, 12.14260041700004],
            [120.25649607800005, 12.142649937000044],
            [120.25411199400003, 12.156657334000045],
        ],
        [
            [121.12587507500007, 12.156901568000023],
            [121.12597909200008, 12.15679202800004],
            [121.12577123200003, 12.156580672000075],
            [121.12564328500002, 12.156822246000047],
            [121.12587507500007, 12.156901568000023],
        ],
        [
            [121.11654503200009, 12.157061948000035],
            [121.11662179700011, 12.156654143000026],
            [121.11611048500004, 12.15659609200003],
            [121.11619595000002, 12.157016640000052],
            [121.11654503200009, 12.157061948000035],
        ],
        [
            [121.11392218200001, 12.158639786000037],
            [121.11380694200011, 12.15834277600004],
            [121.1133732400001, 12.158838786000047],
            [121.11359776900008, 12.15900061800005],
            [121.11392218200001, 12.158639786000037],
        ],
        [
            [120.25069667800005, 12.15827200800004],
            [120.25082291800004, 12.156395262000046],
            [120.24963753000009, 12.156430660000069],
            [120.25039607000008, 12.159087562000025],
            [120.25069667800005, 12.15827200800004],
        ],
        [
            [121.11200518400005, 12.159219232000055],
            [121.11225395200006, 12.159105766000039],
            [121.11170950600001, 12.159033195000063],
            [121.11177626500012, 12.159242447000054],
            [121.11200518400005, 12.159219232000055],
        ],
        [
            [121.11101084400002, 12.160281343000065],
            [121.11134263600002, 12.159808592000047],
            [121.11055376600007, 12.159788588000026],
            [121.11075571200001, 12.160213394000039],
            [121.11101084400002, 12.160281343000065],
        ],
        [
            [119.87872117400002, 12.160264121000068],
            [119.8810662090001, 12.159177398000054],
            [119.88145327100005, 12.157354371000054],
            [119.87646322300009, 12.157936251000024],
            [119.87872117400002, 12.160264121000068],
        ],
        [
            [120.16345188900004, 12.160600165000062],
            [120.17100745500011, 12.158515049000073],
            [120.171784709, 12.153651986000057],
            [120.1658833140001, 12.151244933000044],
            [120.16345188900004, 12.160600165000062],
        ],
        [
            [120.3928833010001, 12.161071778000064],
            [120.39428710900006, 12.160888672000056],
            [120.39587402300003, 12.159729004000042],
            [120.39392089800003, 12.159484864000035],
            [120.3928833010001, 12.161071778000064],
        ],
        [
            [119.81890563400009, 12.16118272600005],
            [119.81951817800007, 12.156423668000059],
            [119.8159917690001, 12.146162551000032],
            [119.81398216900004, 12.144292284000073],
            [119.81890563400009, 12.16118272600005],
        ],
        [
            [120.39172363300008, 12.162475586000028],
            [120.39031982400002, 12.162902833000032],
            [120.39031982400002, 12.163513184000067],
            [120.3909301760001, 12.163513184000067],
            [120.39172363300008, 12.162475586000028],
        ],
        [
            [119.8718589990001, 12.167588238000064],
            [119.87642383000002, 12.157397672000059],
            [119.87315516900003, 12.13818083800004],
            [119.87498748000007, 12.124090760000058],
            [119.87581141200008, 12.123810237000043],
            [119.86681989400006, 12.120035194000025],
            [119.8718589990001, 12.167588238000064],
        ],
        [
            [120.15290917300001, 12.169033694000063],
            [120.15401186400004, 12.16554810100007],
            [120.15070209700002, 12.162466402000064],
            [120.1487280130001, 12.16751565100003],
            [120.15290917300001, 12.169033694000063],
        ],
        [
            [121.10253642000009, 12.169641624000064],
            [121.10435780000012, 12.169068435000042],
            [121.1057853860001, 12.167803328000048],
            [121.10231274600005, 12.16909204600006],
            [121.10253642000009, 12.169641624000064],
        ],
        [
            [121.10251942100001, 12.170085137000058],
            [121.10245605400007, 12.170303541000067],
            [121.10258560500006, 12.170631768000021],
            [121.10264696200011, 12.170419696000067],
            [121.10251942100001, 12.170085137000058],
        ],
        [
            [121.10287796300008, 12.170925572000044],
            [121.10278946100004, 12.17091526300004],
            [121.10266089400011, 12.170766230000027],
            [121.10287939400007, 12.171125729000039],
            [121.10287796300008, 12.170925572000044],
        ],
        [
            [120.14551357800008, 12.182237463000035],
            [120.14569839800004, 12.181993232000025],
            [120.14554318100011, 12.181396363000033],
            [120.14497543100003, 12.18170705600005],
            [120.14551357800008, 12.182237463000035],
        ],
        [
            [119.87715556300009, 12.182869198000049],
            [119.88219311000012, 12.17441141300003],
            [119.88075118600011, 12.16788484600005],
            [119.87480127200001, 12.171694758000058],
            [119.87715556300009, 12.182869198000049],
        ],
        [
            [120.25258418300007, 12.183480175000057],
            [120.256971055, 12.172759582000026],
            [120.25387988200009, 12.15950729900004],
            [120.24812240900008, 12.170535767000047],
            [120.25258418300007, 12.183480175000057],
        ],
        [
            [119.87841552100008, 12.186274299000047],
            [119.87769281200008, 12.185137662000045],
            [119.87747273200011, 12.185209881000048],
            [119.87781658600011, 12.18685208200003],
            [119.87841552100008, 12.186274299000047],
        ],
        [
            [120.1313164930001, 12.187272485000051],
            [120.132687658, 12.186583230000053],
            [120.13535598800001, 12.183006743000021],
            [120.13309536000008, 12.183571335000067],
            [120.1313164930001, 12.187272485000051],
        ],
        [
            [121.02234362100012, 12.188021717000026],
            [121.02217828800008, 12.187985489000027],
            [121.02192578800009, 12.187723203000076],
            [121.0221231380001, 12.188243226000054],
            [121.02234362100012, 12.188021717000026],
        ],
        [
            [120.38585156400006, 12.189416584000071],
            [120.38782806200004, 12.187833082000054],
            [120.38762483000005, 12.185951203000059],
            [120.3848367600001, 12.188327394000055],
            [120.38585156400006, 12.189416584000071],
        ],
        [
            [120.13841642800003, 12.199445995000076],
            [120.1766391970001, 12.161586055000043],
            [120.20090095900002, 12.147145726000076],
            [120.147876343, 12.175056794000056],
            [120.15006286800008, 12.186604592000037],
            [120.13841642800003, 12.199445995000076],
        ],
        [
            [120.136133717, 12.201980389000028],
            [120.13604409900006, 12.202040379000039],
            [120.13600171900009, 12.202222556000038],
            [120.136136125, 12.202086455000028],
            [120.136133717, 12.201980389000028],
        ],
        [
            [120.2422675680001, 12.202703891000056],
            [120.2426511220001, 12.202288330000044],
            [120.24117377100004, 12.202376198000024],
            [120.24188686900004, 12.202487552000036],
            [120.2422675680001, 12.202703891000056],
        ],
        [
            [120.13551390200007, 12.20280650500007],
            [120.13588898900002, 12.20272036800003],
            [120.13586807400009, 12.202239938000048],
            [120.13538966700003, 12.202685184000075],
            [120.13551390200007, 12.20280650500007],
        ],
        [
            [120.1338651210001, 12.203390844000069],
            [120.13420975500003, 12.203098227000055],
            [120.1341283800001, 12.202961564000077],
            [120.13373814700003, 12.203111146000026],
            [120.1338651210001, 12.203390844000069],
        ],
        [
            [120.39515218300005, 12.205518779000045],
            [120.39973891200009, 12.201797181000074],
            [120.40081087700003, 12.194755711000028],
            [120.39398062700002, 12.206951063000076],
            [120.39515218300005, 12.205518779000045],
        ],
        [
            [120.12789022600009, 12.208315859000038],
            [120.13136566800006, 12.206629803000055],
            [120.13151052900002, 12.206001525000033],
            [120.130527701, 12.205929365000031],
            [120.12789022600009, 12.208315859000038],
        ],
        [
            [121.28408739100007, 12.21293464200005],
            [121.28376977000005, 12.21263216400007],
            [121.28349856800003, 12.21286619600005],
            [121.28398090100006, 12.21304841400007],
            [121.28408739100007, 12.21293464200005],
        ],
        [
            [121.27940804400009, 12.214400082000054],
            [121.27925175400003, 12.214172432000055],
            [121.27908532700008, 12.214452012000038],
            [121.27931152700012, 12.21452686300006],
            [121.27940804400009, 12.214400082000054],
        ],
        [
            [120.24069933200008, 12.214674108000054],
            [120.2434964580001, 12.207211259000076],
            [120.24268631100006, 12.204430642000034],
            [120.24121931900004, 12.203158631000065],
            [120.24069933200008, 12.214674108000054],
        ],
        [
            [121.28303334700001, 12.216735138000047],
            [121.28350322800009, 12.215795680000042],
            [121.28255912000009, 12.212257899000065],
            [121.27960730000007, 12.215668693000055],
            [121.28303334700001, 12.216735138000047],
        ],
        [
            [121.20463157300003, 12.211387025000022],
            [121.20365321700001, 12.21422953900003],
            [121.2045891140001, 12.216882114000043],
            [121.2059203340001, 12.212742417000072],
            [121.20463157300003, 12.211387025000022],
        ],
        [
            [120.20527728800005, 12.219941836000032],
            [120.20529202700004, 12.219708721000075],
            [120.20462119800004, 12.21968004200005],
            [120.20481896500007, 12.220029565000061],
            [120.20527728800005, 12.219941836000032],
        ],
        [
            [120.38250732400002, 12.223876954000048],
            [120.38189697200005, 12.223510743000077],
            [120.38128662100007, 12.224487305000025],
            [120.382324218, 12.224670410000044],
            [120.38250732400002, 12.223876954000048],
        ],
        [
            [120.10491943400007, 12.22650146500007],
            [120.10412597600009, 12.22631835900006],
            [120.10369873000002, 12.228881836000028],
            [120.10491943400007, 12.227905273000033],
            [120.10491943400007, 12.22650146500007],
        ],
        [
            [120.05037960300001, 12.232384187000036],
            [120.0516861750001, 12.232072925000068],
            [120.04950552000003, 12.230209430000059],
            [120.04852644200002, 12.231158122000068],
            [120.05037960300001, 12.232384187000036],
        ],
        [
            [120.3947965970001, 12.23369550700005],
            [120.39799093900001, 12.232543451000026],
            [120.39518099700001, 12.209329682000032],
            [120.38453579600002, 12.231934907000038],
            [120.3947965970001, 12.23369550700005],
        ],
        [
            [121.01358447700011, 12.235024072000044],
            [121.03773352100006, 12.204252925000048],
            [121.02782300800004, 12.185429627000076],
            [121.0012611730001, 12.217543050000074],
            [121.01358447700011, 12.235024072000044],
        ],
        [
            [121.02653455400002, 12.194747259000053],
            [121.02594352900007, 12.195232477000047],
            [121.02561911500004, 12.194917272000055],
            [121.02693715200007, 12.19440409300006],
            [121.02653455400002, 12.194747259000053],
        ],
        [
            [121.02915557500012, 12.19554643600003],
            [121.02753294900003, 12.196078966000073],
            [121.02787705500009, 12.19429390700003],
            [121.02895018100003, 12.194528473000048],
            [121.02915557500012, 12.19554643600003],
        ],
        [
            [120.0873282020001, 12.237608502000057],
            [120.090727678, 12.234203255000068],
            [120.08898041700002, 12.231509318000064],
            [120.08539566500008, 12.236138910000022],
            [120.0873282020001, 12.237608502000057],
        ],
        [
            [120.0466868100001, 12.24025477500004],
            [120.04803268300009, 12.239243419000047],
            [120.04775216900009, 12.236314681000067],
            [120.04737168500003, 12.23591827100006],
            [120.0466868100001, 12.24025477500004],
        ],
        [
            [119.854178165, 12.244991878000064],
            [119.85396750400002, 12.242835765000052],
            [119.84456737200003, 12.239503305000028],
            [119.84593146600002, 12.24119541400006],
            [119.854178165, 12.244991878000064],
        ],
        [
            [121.28322667400005, 12.245756807000078],
            [121.28380466300007, 12.244548419000068],
            [121.2832217990001, 12.242391722000036],
            [121.28231020800001, 12.243696913000065],
            [121.28322667400005, 12.245756807000078],
        ],
        [
            [119.8542217910001, 12.25116072700007],
            [119.8534568990001, 12.248515172000054],
            [119.85199097800012, 12.24791407400005],
            [119.85414553100009, 12.251652043000036],
            [119.8542217910001, 12.25116072700007],
        ],
        [
            [120.3582671260001, 12.255021149000072],
            [120.35955135400002, 12.254798435000055],
            [120.36511205500005, 12.242041879000055],
            [120.36048053600007, 12.24793130300003],
            [120.3582671260001, 12.255021149000072],
        ],
        [
            [119.86148856300008, 12.259078375000058],
            [119.86104926300004, 12.257685752000043],
            [119.86037272200008, 12.25782081500006],
            [119.86029852600007, 12.258429467000042],
            [119.86148856300008, 12.259078375000058],
        ],
        [
            [121.38488283600009, 12.26402868300005],
            [121.387852199, 12.254766977000031],
            [121.38069260200007, 12.250054842000054],
            [121.37954843700004, 12.259718385000042],
            [121.38488283600009, 12.26402868300005],
        ],
        [
            [121.27622042400003, 12.267164253000033],
            [121.27795635100006, 12.266701956000077],
            [121.27815992700005, 12.260363558000051],
            [121.27499872500005, 12.268995603000064],
            [121.27622042400003, 12.267164253000033],
        ],
        [
            [120.09258242800001, 12.270947428000056],
            [120.09839629300006, 12.267260553000028],
            [120.09887778400002, 12.265418842000031],
            [120.09113018300002, 12.27032646300006],
            [120.09258242800001, 12.270947428000056],
        ],
        [
            [120.0898488690001, 12.271870902000046],
            [120.09061985200003, 12.271318680000036],
            [120.09070544500003, 12.270686065000064],
            [120.08912706800004, 12.271613012000046],
            [120.0898488690001, 12.271870902000046],
        ],
        [
            [121.27286797700003, 12.27162484300004],
            [121.27272963700011, 12.271853858000043],
            [121.27277134400003, 12.27237530900004],
            [121.27295876900007, 12.271970230000022],
            [121.27286797700003, 12.27162484300004],
        ],
        [
            [121.38200935500004, 12.27981346000007],
            [121.38629617200002, 12.269105806000027],
            [121.3777162, 12.263547217000053],
            [121.36902668100004, 12.278522004000024],
            [121.38200935500004, 12.27981346000007],
        ],
        [
            [120.35207749800009, 12.289369900000054],
            [120.35353017200009, 12.288930462000053],
            [120.35292239600005, 12.287668582000038],
            [120.35146087300006, 12.289414699000076],
            [120.35207749800009, 12.289369900000054],
        ],
        [
            [121.07428948900008, 12.297352560000036],
            [121.13578950100009, 12.165817767000021],
            [121.12116425700003, 12.153658851000046],
            [121.07520944700002, 12.211740945000031],
            [121.03784844000006, 12.224856591000048],
            [121.04279715100006, 12.289825490000055],
            [121.07428948900008, 12.297352560000036],
        ],
        [
            [121.10453185000006, 12.200277537000034],
            [121.10425189300008, 12.200217745000032],
            [121.104443865, 12.19982658300006],
            [121.10468220900009, 12.199965046000045],
            [121.10453185000006, 12.200277537000034],
        ],
        [
            [121.10210950400005, 12.201126539000029],
            [121.10191660700002, 12.20083409700004],
            [121.10242881400006, 12.200951282000062],
            [121.10213762300009, 12.200966020000067],
            [121.10210950400005, 12.201126539000029],
        ],
        [
            [120.26197896700012, 12.299401570000043],
            [120.2622991500001, 12.29749118500007],
            [120.2592945240001, 12.297998795000069],
            [120.25933558700001, 12.298358982000025],
            [120.26197896700012, 12.299401570000043],
        ],
        [
            [120.35885933500003, 12.30586683200005],
            [120.35853348, 12.305736701000058],
            [120.3585282470001, 12.306223027000044],
            [120.35885334700004, 12.305993553000064],
            [120.35885933500003, 12.30586683200005],
        ],
        [
            [120.3426892120001, 12.305206944000076],
            [120.3437865620001, 12.304261088000032],
            [120.34235254200007, 12.30451473100004],
            [120.34178675100009, 12.306749933000049],
            [120.3426892120001, 12.305206944000076],
        ],
        [
            [120.34870982000007, 12.306912428000032],
            [120.36835705600004, 12.296369068000047],
            [120.37436249200005, 12.262054148000061],
            [120.36097961200005, 12.272515664000025],
            [120.34870982000007, 12.306912428000032],
        ],
        [
            [119.85009765600012, 12.32611084000007],
            [119.84967041000004, 12.325500489000035],
            [119.84887695300006, 12.32611084000007],
            [119.84912109400011, 12.32647705100004],
            [119.85009765600012, 12.32611084000007],
        ],
        [
            [119.89471935400002, 12.329604364000033],
            [119.926297384, 12.318017584000074],
            [119.92954599400002, 12.270135701000072],
            [120.01488349500005, 12.253915577000043],
            [120.06262085800006, 12.189930835000041],
            [120.08750508700007, 12.203446635000034],
            [120.10914686500007, 12.194316032000074],
            [120.08570636400009, 12.170219306000035],
            [120.16345488500008, 12.11902950700005],
            [120.21409676300004, 12.13267286000007],
            [120.20546757700004, 12.219844614000067],
            [120.21744783000008, 12.226455417000068],
            [120.24628945400002, 12.130938842000035],
            [120.27414752700008, 12.144272425000054],
            [120.33284693000007, 12.091619949000062],
            [120.34061544000008, 12.05510068600006],
            [120.31551070800003, 12.044532674000038],
            [120.30672976300002, 12.028851081000028],
            [120.33583697900008, 11.99234156600005],
            [120.25297073900003, 12.006801148000022],
            [120.22435672000006, 11.982156469000074],
            [120.17132202000005, 12.028576441000041],
            [120.13201279700002, 12.032743373000073],
            [120.12731289900012, 11.99124002600007],
            [120.09569394900007, 12.002748980000035],
            [120.11929113700012, 11.977861568000037],
            [120.09975965900003, 11.960414644000025],
            [120.05283003700004, 12.02018152100004],
            [120.02065137900001, 11.987882992000038],
            [119.97786622400008, 12.009606211000062],
            [119.99687334900011, 12.023761474000025],
            [119.93782263700007, 12.07313631900007],
            [119.95149295500005, 12.078949891000036],
            [119.89654349400007, 12.202703851000024],
            [119.87898393500006, 12.20235122500003],
            [119.85246311900005, 12.148012478000055],
            [119.86068805800005, 12.25543271500004],
            [119.91724320300011, 12.273218138000061],
            [119.86684068700004, 12.268108098000027],
            [119.89471935400002, 12.329604364000033],
        ],
        [
            [120.09179521600004, 11.973491741000032],
            [120.0914087760001, 11.973371077000024],
            [120.09233407400006, 11.972024956000041],
            [120.092492923, 11.972179464000021],
            [120.09179521600004, 11.973491741000032],
        ],
        [
            [120.08611497100003, 11.979696316000059],
            [120.08599164100008, 11.979324856000062],
            [120.08622332000004, 11.978997718000073],
            [120.08623843500004, 11.979195381000068],
            [120.08611497100003, 11.979696316000059],
        ],
        [
            [120.08561783400012, 11.979862045000061],
            [120.08547033400009, 11.97979777300003],
            [120.08572467600004, 11.979492888000038],
            [120.08581520700011, 11.979687700000056],
            [120.08561783400012, 11.979862045000061],
        ],
        [
            [120.21017736300007, 11.996109302000036],
            [120.20959811000012, 11.995982755000057],
            [120.20986409800003, 11.995425070000067],
            [120.2104324280001, 11.995469652000054],
            [120.21017736300007, 11.996109302000036],
        ],
        [
            [120.08209485300006, 12.000103108000076],
            [120.0808503400001, 12.000143580000042],
            [120.08138706300008, 11.998903838000047],
            [120.0814062500001, 11.999742014000049],
            [120.08209485300006, 12.000103108000076],
        ],
        [
            [120.1252029420001, 12.028699010000025],
            [120.12482772600003, 12.028580831000056],
            [120.12538510600007, 12.028206684000054],
            [120.12539614900004, 12.02864091400005],
            [120.1252029420001, 12.028699010000025],
        ],
        [
            [119.96424413500006, 12.061125908000065],
            [119.96382955600006, 12.060977447000027],
            [119.96403832800002, 12.060568913000054],
            [119.964386439, 12.060646211000062],
            [119.96424413500006, 12.061125908000065],
        ],
        [
            [119.96300060200008, 12.061706112000024],
            [119.9630607900001, 12.06201247000007],
            [119.96250402600003, 12.062975016000053],
            [119.96226649800008, 12.062018812000076],
            [119.96300060200008, 12.061706112000024],
        ],
        [
            [120.31133735000003, 12.105898136000064],
            [120.3072680890001, 12.105284191000067],
            [120.30631546300003, 12.103710837000051],
            [120.3097000250001, 12.103686008000068],
            [120.31133735000003, 12.105898136000064],
        ],
        [
            [120.301293181, 12.119220883000025],
            [120.30097616800003, 12.119263257000057],
            [120.30086989600011, 12.119173756000066],
            [120.3012795410001, 12.118815568000059],
            [120.301293181, 12.119220883000025],
        ],
        [
            [120.2698992930001, 12.334195409000074],
            [120.269688502, 12.334327788000053],
            [120.26951136500008, 12.33458216300005],
            [120.2700551690001, 12.33444200100007],
            [120.2698992930001, 12.334195409000074],
        ],
        [
            [120.27214184900004, 12.33576087800003],
            [120.2771516890001, 12.331853766000052],
            [120.27639847900002, 12.329666470000063],
            [120.27209519100006, 12.328799102000062],
            [120.27214184900004, 12.33576087800003],
        ],
        [
            [120.27095709000002, 12.340151087000038],
            [120.271043888, 12.33978359300005],
            [120.27064417800011, 12.339265940000075],
            [120.27061345900006, 12.340043324000021],
            [120.27095709000002, 12.340151087000038],
        ],
        [
            [120.27142187700008, 12.342063345000042],
            [120.27163697700007, 12.342044593000026],
            [120.27155618000006, 12.341835453000044],
            [120.2713198780001, 12.342007117000037],
            [120.27142187700008, 12.342063345000042],
        ],
        [
            [119.95837351800003, 12.34470256800006],
            [119.9544095550001, 12.339417064000031],
            [119.95150198800002, 12.339324225000041],
            [119.95642262900003, 12.344085581000058],
            [119.95837351800003, 12.34470256800006],
        ],
        [
            [120.26211084400006, 12.353821991000075],
            [120.27063314300005, 12.347832284000049],
            [120.27065691100006, 12.342548195000063],
            [120.26275882700008, 12.347449245000064],
            [120.26211084400006, 12.353821991000075],
        ],
        [
            [121.400526807, 12.35387227700005],
            [121.4016038420001, 12.339510892000021],
            [121.40044422900007, 12.336542037000072],
            [121.39704243100005, 12.349398864000023],
            [121.400526807, 12.35387227700005],
        ],
        [
            [119.90825476000009, 12.37019562100005],
            [119.9156031870001, 12.36704620100005],
            [119.89545145200009, 12.359808314000077],
            [119.90022447600006, 12.367148458000031],
            [119.90825476000009, 12.37019562100005],
        ],
        [
            [119.89910888600002, 12.380310058000077],
            [119.89807128900009, 12.380676270000038],
            [119.89868164000006, 12.38189697200005],
            [119.89947509800004, 12.380920410000044],
            [119.89910888600002, 12.380310058000077],
        ],
        [
            [121.45485293900003, 12.382438334000028],
            [121.4556661900001, 12.382189579000055],
            [121.45584001400005, 12.381785851000075],
            [121.45460162600011, 12.381732989000056],
            [121.45485293900003, 12.382438334000028],
        ],
        [
            [121.44418680900003, 12.383747792000065],
            [121.4616813880001, 12.37635335400006],
            [121.46060233700007, 12.361953392000032],
            [121.44519298500006, 12.369236957000055],
            [121.44418680900003, 12.383747792000065],
        ],
        [
            [122.54468839800006, 12.505659712000067],
            [122.65468045400007, 12.483956369000055],
            [122.69865023600005, 12.401690147000068],
            [122.63431353700003, 12.267473468000048],
            [122.42482785600009, 12.432666244000075],
            [122.4614269540001, 12.486757544000056],
            [122.54468839800006, 12.505659712000067],
        ],
        [
            [122.32114470300007, 12.555032347000065],
            [122.32231394000007, 12.554218061000029],
            [122.32055249000007, 12.553435175000061],
            [122.3205428980001, 12.555254536000064],
            [122.32114470300007, 12.555032347000065],
        ],
        [
            [122.32087988, 12.555722570000057],
            [122.32064859000002, 12.555710801000032],
            [122.32064126400007, 12.555927350000047],
            [122.32086078800012, 12.555906854000057],
            [122.32087988, 12.555722570000057],
        ],
        [
            [122.25163061300009, 12.599585647000026],
            [122.24801052400005, 12.583713286000034],
            [122.239875933, 12.583803810000063],
            [122.24642245200005, 12.599309530000028],
            [122.25163061300009, 12.599585647000026],
        ],
        [
            [122.28370532000008, 12.625319661000049],
            [122.3268919730001, 12.540218984000035],
            [122.30169539400003, 12.477892044000043],
            [122.24387934300012, 12.572453059000054],
            [122.28370532000008, 12.625319661000049],
        ],
        [
            [122.26075381800001, 12.630742779000059],
            [122.25474232700003, 12.613527146000024],
            [122.23588930200003, 12.617049907000023],
            [122.24025859800008, 12.625701766000077],
            [122.26075381800001, 12.630742779000059],
        ],
        [
            [122.23998607300007, 12.671417481000049],
            [122.24586846000011, 12.661901148000027],
            [122.23857289000011, 12.647592877000022],
            [122.23014532500008, 12.662915786000042],
            [122.23998607300007, 12.671417481000049],
        ],
        [
            [122.11073341100007, 12.67433965400005],
            [122.15385358300011, 12.660023871000021],
            [122.16241076800009, 12.632145399000024],
            [122.12242585400008, 12.620441397000036],
            [122.13911010800007, 12.53824103200003],
            [122.04001737400006, 12.228795258000048],
            [122.06893105100005, 12.181400477000068],
            [122.01767320400006, 12.14355037100006],
            [122.01438597200001, 12.099014794000027],
            [121.95899513900008, 12.191456538000068],
            [121.96803660400008, 12.238378479000062],
            [121.98854457200002, 12.189429142000051],
            [122.01850951200004, 12.233149715000025],
            [121.91968869200002, 12.312927716000047],
            [121.94118798200009, 12.391231117000075],
            [122.00592815300001, 12.444372808000026],
            [122.00189083200007, 12.597238436000055],
            [122.07599722000009, 12.622406655000077],
            [122.11073341100007, 12.67433965400005],
        ],
        [
            [122.08726657200009, 12.837587427000074],
            [122.06125235800005, 12.78464034700005],
            [122.01872524500004, 12.79631603100006],
            [122.0359843660001, 12.815733881000028],
            [122.08726657200009, 12.837587427000074],
        ],
        [
            [122.03058088500006, 12.79674618200005],
            [122.0287306460001, 12.795140760000038],
            [122.0314307970001, 12.79357452100004],
            [122.03120442300008, 12.79665742800006],
            [122.03058088500006, 12.79674618200005],
        ],
        [
            [120.75237555900003, 12.844840603000023],
            [120.75359767700002, 12.844348816000036],
            [120.75757655000007, 12.838656967000077],
            [120.74969905000012, 12.842147216000058],
            [120.75237555900003, 12.844840603000023],
        ],
        [
            [120.74747541800002, 12.860013030000061],
            [120.75395964000006, 12.858910158000072],
            [120.7549604620001, 12.857831099000066],
            [120.74742660700008, 12.854872664000027],
            [120.74747541800002, 12.860013030000061],
        ],
        [
            [121.70534530900011, 12.949107394000066],
            [121.7364209000001, 12.928864444000055],
            [121.7170293910001, 12.895748266000055],
            [121.68084723900006, 12.929306489000055],
            [121.70534530900011, 12.949107394000066],
        ],
        [
            [122.06152351000003, 12.963018927000064],
            [122.09917921100009, 12.956201509000039],
            [122.069383001, 12.904967209000063],
            [122.03270048700006, 12.94958778800003],
            [122.06152351000003, 12.963018927000064],
        ],
        [
            [121.99888218700005, 13.194103033000033],
            [122.00189971800012, 13.192133236000075],
            [121.99897915500003, 13.189599480000027],
            [121.9975206790001, 13.191823189000047],
            [121.99888218700005, 13.194103033000033],
        ],
        [
            [121.81388893300004, 13.22938937400005],
            [121.81324282300011, 13.220700965000049],
            [121.80490871600011, 13.226003849000051],
            [121.80664605700008, 13.228273672000057],
            [121.81388893300004, 13.22938937400005],
        ],
        [
            [121.83063511300008, 13.237275454000041],
            [121.83587805600007, 13.235183482000025],
            [121.8366980180001, 13.231975560000024],
            [121.8307815610001, 13.231521257000054],
            [121.83063511300008, 13.237275454000041],
        ],
        [
            [121.86702630600007, 13.252611216000048],
            [121.8665410960001, 13.244353674000024],
            [121.84896079200007, 13.247789579000028],
            [121.85962161200007, 13.252596991000075],
            [121.86702630600007, 13.252611216000048],
        ],
        [
            [122.12673551600005, 13.426665488000026],
            [122.14771184900007, 13.407430136000073],
            [122.14749682600007, 13.395977796000068],
            [122.12358229600011, 13.405215628000064],
            [122.12673551600005, 13.426665488000026],
        ],
        [
            [121.21663643200009, 13.429560517000027],
            [121.21723140600011, 13.426190402000032],
            [121.2147032790001, 13.426640475000056],
            [121.21584705600003, 13.42898591900007],
            [121.21663643200009, 13.429560517000027],
        ],
        [
            [121.22132131900003, 13.447282106000046],
            [121.2222725370001, 13.444709207000074],
            [121.21721752600001, 13.438538677000054],
            [121.21902168200006, 13.445235288000049],
            [121.22132131900003, 13.447282106000046],
        ],
        [
            [121.16404374700005, 13.467073836000054],
            [121.1631121260001, 13.46426899200003],
            [121.16051813000001, 13.46312281300004],
            [121.16402183900004, 13.467366083000059],
            [121.16404374700005, 13.467073836000054],
        ],
        [
            [122.06964944300012, 13.48254193300005],
            [122.06988749300001, 13.481770944000061],
            [122.0693591700001, 13.481395811000027],
            [122.06915689900006, 13.481929882000031],
            [122.06964944300012, 13.48254193300005],
        ],
        [
            [122.07015620700008, 13.484316060000026],
            [122.07117857300011, 13.483644609000066],
            [122.07146870500003, 13.480240612000046],
            [122.06944487100009, 13.483367963000035],
            [122.07015620700008, 13.484316060000026],
        ],
        [
            [122.07167216100004, 13.485152696000057],
            [122.07162362100007, 13.484144250000043],
            [122.07124347500007, 13.484075064000024],
            [122.07089402100007, 13.484970482000051],
            [122.07167216100004, 13.485152696000057],
        ],
        [
            [122.04457819600009, 13.48629670500003],
            [122.0440827110001, 13.483987865000074],
            [122.0411945830001, 13.485803846000067],
            [122.0418416760001, 13.48603107300005],
            [122.04457819600009, 13.48629670500003],
        ],
        [
            [122.068716472, 13.527467684000044],
            [122.09879548300012, 13.505536150000069],
            [122.09988633900002, 13.496785651000039],
            [122.0653787980001, 13.503583006000042],
            [122.068716472, 13.527467684000044],
        ],
        [
            [122.17736665400002, 13.528968672000076],
            [122.18811884000002, 13.515878834000034],
            [122.18180828900006, 13.503964763000056],
            [122.1679913910001, 13.519524410000031],
            [122.17736665400002, 13.528968672000076],
        ],
        [
            [120.41313826900011, 13.530858070000022],
            [120.76133272000004, 13.464587221000045],
            [120.9925642820001, 13.522857964000025],
            [120.9554081340001, 13.49555287000004],
            [121.03628388400011, 13.418602254000064],
            [121.14139719700006, 13.405304542000067],
            [121.20011342900011, 13.437529462000043],
            [121.37910162000003, 13.239409770000066],
            [121.44076327500011, 13.22805635900005],
            [121.44198713000003, 13.14350403900005],
            [121.50941928500004, 13.151373617000047],
            [121.55728390100012, 13.119831068000053],
            [121.4873839280001, 13.022287795000068],
            [121.47579928800008, 12.77726178100005],
            [121.53865040300002, 12.695960267000032],
            [121.55712424, 12.604860764000023],
            [121.43684051700006, 12.514835427000037],
            [121.41265626300003, 12.396430352000039],
            [121.45257716300011, 12.359377641000037],
            [121.38388504200009, 12.362762088000068],
            [121.39658539400011, 12.285951252000075],
            [121.34478311200007, 12.326277619000052],
            [121.333374, 12.294916948000036],
            [121.27607736400012, 12.28497247000007],
            [121.24475543100004, 12.207207351000022],
            [121.19121232500004, 12.244788823000022],
            [121.10891855400007, 12.242833296000072],
            [121.09290208900006, 12.287719307000032],
            [121.11799089200008, 12.337393673000065],
            [121.08479965100003, 12.327555861000064],
            [120.97623407000003, 12.427785460000052],
            [120.92459545000008, 12.505669198000021],
            [120.92805587100008, 12.614858393000077],
            [120.85619810000003, 12.716767204000064],
            [120.78899065000007, 12.734430004000046],
            [120.76045061100001, 12.839184104000026],
            [120.78412682700002, 12.931035910000048],
            [120.6539222670001, 13.188131331000022],
            [120.52289617600002, 13.224013813000056],
            [120.4582209780001, 13.417560355000035],
            [120.39134620100003, 13.410711696000021],
            [120.38164559400002, 13.375102250000054],
            [120.30956407100007, 13.420212028000037],
            [120.31261066600007, 13.476705190000075],
            [120.41313826900011, 13.530858070000022],
        ],
        [
            [121.26805768600002, 12.272728504000042],
            [121.26815046900003, 12.272861945000045],
            [121.26809541400007, 12.27309017400006],
            [121.26788776900003, 12.273012065000046],
            [121.26805768600002, 12.272728504000042],
        ],
        [
            [121.26792861800004, 12.273154951000038],
            [121.26810127600004, 12.273186042000077],
            [121.2680782010001, 12.273858966000034],
            [121.26777248200005, 12.273771243000056],
            [121.26792861800004, 12.273154951000038],
        ],
        [
            [121.270128053, 12.27450611200004],
            [121.27020582500006, 12.27475245100004],
            [121.26987277, 12.274704217000021],
            [121.26993454800004, 12.274553787000059],
            [121.270128053, 12.27450611200004],
        ],
        [
            [121.11589823700001, 12.317751994000048],
            [121.11419154700002, 12.316080500000055],
            [121.11435932300003, 12.31551182800007],
            [121.11493630900009, 12.315487009000037],
            [121.11589823700001, 12.317751994000048],
        ],
        [
            [121.11373655400007, 12.319609671000023],
            [121.11189472800004, 12.31900769400005],
            [121.1115479880001, 12.318274580000036],
            [121.11460786000009, 12.318881606000048],
            [121.11373655400007, 12.319609671000023],
        ],
        [
            [121.86094156400009, 13.529369092000024],
            [121.860012933, 13.52936548200006],
            [121.85885423700006, 13.530697920000023],
            [121.86047075800002, 13.530837078000047],
            [121.86094156400009, 13.529369092000024],
        ],
        [
            [120.9513962420001, 13.53151060600004],
            [120.95753465900009, 13.525375675000078],
            [120.9589445250001, 13.516376897000043],
            [120.94692682900006, 13.524640431000023],
            [120.9513962420001, 13.53151060600004],
        ],
        [
            [121.85157545200002, 13.532831713000064],
            [121.85220330900006, 13.53276313300006],
            [121.85079913400011, 13.53201639100007],
            [121.85121619200004, 13.532778661000066],
            [121.85157545200002, 13.532831713000064],
        ],
        [
            [121.85283554800003, 13.535886465000033],
            [121.85346310000011, 13.535545022000065],
            [121.85318281100001, 13.534576935000075],
            [121.85256962400001, 13.534794336000061],
            [121.85283554800003, 13.535886465000033],
        ],
        [
            [121.94866009700002, 13.53674970000003],
            [121.9477809550001, 13.534391792000065],
            [121.9456950020001, 13.535371540000028],
            [121.94630150900002, 13.536647908000077],
            [121.94866009700002, 13.53674970000003],
        ],
        [
            [122.10635598400006, 13.538686088000077],
            [122.13165463500002, 13.535386997000046],
            [122.13547291900011, 13.517014127000039],
            [122.10956527700012, 13.52560802100004],
            [122.10635598400006, 13.538686088000077],
        ],
        [
            [121.94823374200007, 13.541690624000069],
            [121.94867900100007, 13.540894323000032],
            [121.94767200400008, 13.540190295000059],
            [121.94745638400002, 13.54140945100005],
            [121.94823374200007, 13.541690624000069],
        ],
        [
            [121.94228448700005, 13.541948352000077],
            [121.94258246400011, 13.541059992000044],
            [121.94217471900004, 13.54062256900005],
            [121.94203665500004, 13.541776464000066],
            [121.94228448700005, 13.541948352000077],
        ],
        [
            [121.9458516630001, 13.542344994000075],
            [121.94542314000012, 13.54076006300005],
            [121.94397219900009, 13.541291027000057],
            [121.94396982900003, 13.541836898000042],
            [121.9458516630001, 13.542344994000075],
        ],
        [
            [121.96028865400001, 13.547080845000039],
            [121.96247337900002, 13.545706971000072],
            [121.95863897000004, 13.542575788000022],
            [121.94935223800007, 13.541087214000072],
            [121.96028865400001, 13.547080845000039],
        ],
        [
            [121.94229417500003, 13.555756187000043],
            [121.94539051200002, 13.554472593000071],
            [121.94588210600011, 13.553732006000075],
            [121.9441368790001, 13.55237442400005],
            [121.94229417500003, 13.555756187000043],
        ],
        [
            [121.86653475300011, 13.570656743000029],
            [121.91864490600005, 13.525130859000058],
            [121.96563569500006, 13.528725201000043],
            [121.9643215850001, 13.545386390000033],
            [121.97214062500007, 13.558563458000037],
            [121.96686894800007, 13.528964163000069],
            [121.99930540100002, 13.522177642000031],
            [122.00930077800001, 13.549452244000065],
            [122.04056975200001, 13.485536125000067],
            [122.05414247400006, 13.476888881000036],
            [122.07575206400008, 13.47507157900003],
            [122.08650919800004, 13.489365818000067],
            [122.12718605400005, 13.455329379000034],
            [122.10105724100003, 13.422302941000055],
            [122.15067202900002, 13.371106172000054],
            [122.04671488500003, 13.276764662000062],
            [122.02849834300002, 13.19944859800006],
            [121.86594229000002, 13.28483886400005],
            [121.82018059400002, 13.34479107900006],
            [121.81094714200003, 13.453291232000026],
            [121.87492820500006, 13.540597441000045],
            [121.86653475300011, 13.570656743000029],
        ],
        [
            [120.40926552000008, 13.627082579000046],
            [120.40936343300007, 13.626652618000037],
            [120.40888329600011, 13.626196615000026],
            [120.40889429000003, 13.626790812000024],
            [120.40926552000008, 13.627082579000046],
        ],
        [
            [120.2705127480001, 13.670569415000045],
            [120.27072354000006, 13.670419981000066],
            [120.27072775600004, 13.670213311000055],
            [120.27024555500009, 13.670319238000047],
            [120.2705127480001, 13.670569415000045],
        ],
        [
            [120.27477684000007, 13.675142999000059],
            [120.27495920500007, 13.675082115000066],
            [120.27490673000011, 13.67483210100005],
            [120.27466755600005, 13.675007105000077],
            [120.27477684000007, 13.675142999000059],
        ],
        [
            [120.2751256680001, 13.677843477000067],
            [120.275032183, 13.677808797000068],
            [120.27488297000002, 13.67786060700007],
            [120.27508323100005, 13.678016512000056],
            [120.2751256680001, 13.677843477000067],
        ],
        [
            [120.304607916, 13.682234509000068],
            [120.41162492700005, 13.654637181000055],
            [120.42254968300006, 13.626808940000046],
            [120.38723526100011, 13.633182030000057],
            [120.304607916, 13.682234509000068],
        ],
        [
            [120.27907271400011, 13.683068958000035],
            [120.27930677900008, 13.682963491000066],
            [120.27932400600002, 13.682063034000066],
            [120.27842608500009, 13.682961163000073],
            [120.27907271400011, 13.683068958000035],
        ],
        [
            [120.29675812300002, 13.70336321800005],
            [120.29702820400007, 13.702948531000061],
            [120.296931416, 13.702567550000026],
            [120.29616075100012, 13.70389397300005],
            [120.29675812300002, 13.70336321800005],
        ],
        [
            [120.29670111400003, 13.706248213000038],
            [120.29774586500002, 13.704274723000026],
            [120.29429707600002, 13.705395852000038],
            [120.29557507800007, 13.705577788000028],
            [120.29670111400003, 13.706248213000038],
        ],
        [
            [120.09581013900004, 13.798405856000045],
            [120.09530940500008, 13.797777451000059],
            [120.09451698100008, 13.797939278000058],
            [120.09463538800003, 13.798207909000041],
            [120.09581013900004, 13.798405856000045],
        ],
        [
            [120.09401164300004, 13.799241682000059],
            [120.094169168, 13.799200184000028],
            [120.09415071900003, 13.798940052000034],
            [120.09387904900007, 13.798962135000068],
            [120.09401164300004, 13.799241682000059],
        ],
        [
            [120.09387439500006, 13.79975784900006],
            [120.0936975080001, 13.799431947000073],
            [120.09357248600008, 13.799394224000025],
            [120.09358284900009, 13.799726082000063],
            [120.09387439500006, 13.79975784900006],
        ],
        [
            [120.09323583600008, 13.800978953000026],
            [120.09319267600006, 13.800726570000052],
            [120.09301786100002, 13.80067200800005],
            [120.092969777, 13.800894178000021],
            [120.09323583600008, 13.800978953000026],
        ],
        [
            [120.09368041100004, 13.829881855000053],
            [120.09352625500003, 13.830345944000044],
            [120.09375437100005, 13.830757332000076],
            [120.09380082300004, 13.83043669400007],
            [120.09368041100004, 13.829881855000053],
        ],
        [
            [120.2902480140001, 13.836559649000037],
            [120.33647043400003, 13.80727299800003],
            [120.31214326200006, 13.774025810000069],
            [120.261212483, 13.807032394000032],
            [120.2902480140001, 13.836559649000037],
        ],
        [
            [120.3298783030001, 13.84046002100007],
            [120.33244413000011, 13.837612467000042],
            [120.32884805000003, 13.831628375000037],
            [120.32871936900005, 13.838758421000023],
            [120.3298783030001, 13.84046002100007],
        ],
        [
            [120.34464391900008, 13.864409826000042],
            [120.34679500200002, 13.862953828000059],
            [120.34586789600007, 13.86076296300007],
            [120.3445737290001, 13.861423084000023],
            [120.34464391900008, 13.864409826000042],
        ],
        [
            [120.09042471700002, 13.864472474000024],
            [120.22329411300007, 13.820665785000074],
            [120.28829886200003, 13.734642876000066],
            [120.25082891500006, 13.719084735000024],
            [120.29529159300012, 13.68569558300004],
            [120.27907549400004, 13.68725445900003],
            [120.26708657300003, 13.671099663000064],
            [120.1003052960001, 13.784830129000056],
            [120.09042471700002, 13.864472474000024],
        ],
        [
            [120.2511034470001, 13.698223213000063],
            [120.25074226000004, 13.698123777000035],
            [120.250530464, 13.697493947000055],
            [120.25136022900006, 13.697875107000073],
            [120.2511034470001, 13.698223213000063],
        ],
        [
            [120.220511826, 13.711932832000059],
            [120.22049959300011, 13.712104246000024],
            [120.22024278600009, 13.71223322800006],
            [120.22035459800009, 13.711902278000025],
            [120.220511826, 13.711932832000059],
        ],
        [
            [120.2151015820001, 13.713260436000041],
            [120.21503404200007, 13.713394780000044],
            [120.21459184300011, 13.713243237000029],
            [120.2153315270001, 13.713235448000034],
            [120.2151015820001, 13.713260436000041],
        ],
        [
            [120.2141532490001, 13.715219403000049],
            [120.21398561, 13.71538735100006],
            [120.21351674700009, 13.715132882000034],
            [120.21389655500002, 13.714868239000054],
            [120.2141532490001, 13.715219403000049],
        ],
        [
            [120.17435955100007, 13.735903587000053],
            [120.17422446300009, 13.736132241000064],
            [120.174169559, 13.736145878000059],
            [120.17418063600007, 13.735906102000058],
            [120.17435955100007, 13.735903587000053],
        ],
        [
            [120.17433912400008, 13.736333750000028],
            [120.17437789900009, 13.736064752000061],
            [120.17459332400006, 13.73611835500003],
            [120.17448406100004, 13.736266584000077],
            [120.17433912400008, 13.736333750000028],
        ],
        [
            [120.18872475100011, 13.826602662000028],
            [120.18850279600008, 13.826555249000023],
            [120.18865528200001, 13.826261644000056],
            [120.18885717100011, 13.826379283000051],
            [120.18872475100011, 13.826602662000028],
        ],
        [
            [120.04599278600006, 13.866495275000034],
            [120.04594559200007, 13.866544488000045],
            [120.04603966200011, 13.866679630000021],
            [120.04609557100002, 13.866578546000028],
            [120.04599278600006, 13.866495275000034],
        ],
        [
            [120.04835056000002, 13.86675660000003],
            [120.04814645600004, 13.866740870000058],
            [120.04808376100004, 13.86680863600003],
            [120.04823770700011, 13.866878230000054],
            [120.04835056000002, 13.86675660000003],
        ],
        [
            [120.0534739410001, 13.870146223000063],
            [120.0536404930001, 13.870217797000066],
            [120.05368838900006, 13.870153548000076],
            [120.05330385700006, 13.870061390000046],
            [120.0534739410001, 13.870146223000063],
        ],
        [
            [120.02680764500008, 13.897670894000044],
            [120.02687498600005, 13.897603437000043],
            [120.02674323300005, 13.897528923000039],
            [120.02667153900006, 13.897657521000042],
            [120.02680764500008, 13.897670894000044],
        ],
        [
            [120.03979579400004, 13.899117207000074],
            [120.0586515330001, 13.87663815600007],
            [120.04872373100011, 13.86707356900007],
            [120.01836228200011, 13.886675443000058],
            [120.03979579400004, 13.899117207000074],
        ],
        [
            [121.88378639600012, 6.691384652000067],
            [121.8809247480001, 6.687232743000038],
            [121.87488798000004, 6.687176560000069],
            [121.87524450500007, 6.691408360000025],
            [121.88378639600012, 6.691384652000067],
        ],
        [
            [121.98049900300009, 6.736249801000042],
            [121.98412201700012, 6.735603562000051],
            [121.98354470800007, 6.730539022000073],
            [121.98029998900006, 6.733092538000051],
            [121.98049900300009, 6.736249801000042],
        ],
        [
            [121.99230667200004, 6.736376754000048],
            [121.99510123300001, 6.736206777000064],
            [121.99011524900004, 6.734195735000071],
            [121.99063212200008, 6.735268315000042],
            [121.99230667200004, 6.736376754000048],
        ],
        [
            [121.93648783900005, 6.564648783000052],
            [121.91717787000005, 6.674741475000076],
            [121.92235495000011, 6.673539847000029],
            [121.92877861700003, 6.66738102100004],
            [121.931126145, 6.666423077000047],
            [122.0163753280001, 6.746141904000069],
            [122.05126759500001, 6.675526478000052],
            [122.04289291400005, 6.564819979000049],
        ],
        [
            [121.98039912500008, 6.755141325000068],
            [121.97162801900004, 6.712509083000043],
            [121.94125366600008, 6.711234836000074],
            [121.94645979500001, 6.737733],
            [121.98039912500008, 6.755141325000068],
        ],
        [
            [122.05710077300012, 6.872738853000044],
            [122.06458823600008, 6.871934372000055],
            [122.0735527600001, 6.862475968000069],
            [122.05967484400003, 6.858353478000026],
            [122.05710077300012, 6.872738853000044],
        ],
        [
            [122.2969207650001, 6.875511104000054],
            [122.29957973600006, 6.875257139000041],
            [122.30025921000004, 6.874563677000026],
            [122.29871257000002, 6.873486895000042],
            [122.2969207650001, 6.875511104000054],
        ],
        [
            [122.03920686000004, 6.885727750000058],
            [122.04010954000012, 6.885372166000025],
            [122.05045810900003, 6.883350264000057],
            [122.03627643700008, 6.884843205000038],
            [122.03920686000004, 6.885727750000058],
        ],
        [
            [122.1596267430001, 6.89051325500003],
            [122.15999740600012, 6.888776664000034],
            [122.15699442800008, 6.884406197000033],
            [122.15783338800009, 6.882592954000074],
            [122.15590546600004, 6.88117993700007],
            [122.13585120300002, 6.880897687000072],
            [122.1596267430001, 6.89051325500003],
        ],
        [
            [122.27962427900002, 6.893523071000061],
            [122.29037913000002, 6.887860104000026],
            [122.29400309300001, 6.87111049300006],
            [122.27348984100001, 6.882440710000026],
            [122.27962427900002, 6.893523071000061],
        ],
        [
            [122.16593734900005, 6.896790151000062],
            [122.16945271500003, 6.892528826000046],
            [122.16737491000004, 6.886902619000068],
            [122.16282210400004, 6.894665374000056],
            [122.16593734900005, 6.896790151000062],
        ],
        [
            [122.1613452150001, 6.914664568000035],
            [122.1628166480001, 6.912927074000038],
            [122.15608639300001, 6.910204084000043],
            [122.16116755900009, 6.916627781000045],
            [122.1613452150001, 6.914664568000035],
        ],
        [
            [122.18172393100008, 6.918848788000048],
            [122.18386155900009, 6.91683686600004],
            [122.18418222900004, 6.914724068000055],
            [122.17939582100007, 6.912501934000034],
            [122.18172393100008, 6.918848788000048],
        ],
        [
            [122.32666121500006, 6.956276801000058],
            [122.32831352700009, 6.95299985500003],
            [122.3236144980001, 6.953517955000052],
            [122.32406680100007, 6.955811574000052],
            [122.32666121500006, 6.956276801000058],
        ],
        [
            [122.35847311400005, 6.983966389000045],
            [122.35771084500004, 6.982131246000051],
            [122.35528637900006, 6.98302331900004],
            [122.35570975700011, 6.983661651000034],
            [122.35847311400005, 6.983966389000045],
        ],
        [
            [122.35616011000002, 6.988810310000076],
            [122.35767759400005, 6.988108686000032],
            [122.35476506900011, 6.986477661000038],
            [122.35455741400006, 6.976769068000067],
            [122.34730541400006, 6.978440993000049],
            [122.35616011000002, 6.988810310000076],
        ],
        [
            [122.27244269700009, 6.999375243000031],
            [122.27270634600006, 6.957637933000058],
            [122.19909790100007, 6.919244508000077],
            [122.21414691300004, 6.979905748000022],
            [122.27244269700009, 6.999375243000031],
        ],
        [
            [122.25379847300007, 7.104320727000072],
            [122.25376028800008, 7.098928891000071],
            [122.25226076400008, 7.098274657000047],
            [122.25057463500002, 7.10231566300007],
            [122.25379847300007, 7.104320727000072],
        ],
        [
            [122.2700113190001, 7.11888545000005],
            [122.27097355, 7.118534244000045],
            [122.26967585900002, 7.117091290000076],
            [122.269401549, 7.118359281000039],
            [122.2700113190001, 7.11888545000005],
        ],
        [
            [122.27171925300001, 7.119903528000066],
            [122.27234445900001, 7.119372443000032],
            [122.27240164700004, 7.119077504000074],
            [122.27139065400002, 7.119510867000031],
            [122.27171925300001, 7.119903528000066],
        ],
        [
            [122.27075382300006, 7.120996851000029],
            [122.27113181800007, 7.120910072000072],
            [122.27099101800002, 7.120363387000054],
            [122.27059002100009, 7.120533802000068],
            [122.27075382300006, 7.120996851000029],
        ],
        [
            [122.27258569800006, 7.126155233000077],
            [122.27516746600008, 7.125084638000033],
            [122.27465711500008, 7.123692554000058],
            [122.27140144100008, 7.124737067000069],
            [122.27258569800006, 7.126155233000077],
        ],
        [
            [122.26221459700002, 7.131991338000034],
            [122.26297045800004, 7.130804097000066],
            [122.26249858200003, 7.129103959000076],
            [122.26084828300009, 7.131623877000038],
            [122.26221459700002, 7.131991338000034],
        ],
        [
            [122.26815613400004, 7.135240682000074],
            [122.27115390600011, 7.131845776000034],
            [122.2686048490001, 7.127522437000039],
            [122.26594102700005, 7.132484248000026],
            [122.26815613400004, 7.135240682000074],
        ],
        [
            [122.26615420300004, 7.15238176500003],
            [122.26606153900002, 7.149683318000029],
            [122.26196913800004, 7.144940124000073],
            [122.26116282100008, 7.148527124000054],
            [122.26615420300004, 7.15238176500003],
        ],
        [
            [122.27319575100012, 7.155955328000061],
            [122.27409092900007, 7.155359444000055],
            [122.27337814600003, 7.150282478000065],
            [122.27060648300005, 7.15497375800004],
            [122.27319575100012, 7.155955328000061],
        ],
        [
            [122.28811036500008, 7.171681080000042],
            [122.28840308300005, 7.169729145000076],
            [122.28625718300009, 7.169641241000022],
            [122.28705835400001, 7.171379195000043],
            [122.28811036500008, 7.171681080000042],
        ],
        [
            [122.27520850200005, 7.170836489000067],
            [122.27564873400001, 7.162726902000031],
            [122.26668230100006, 7.164746295000043],
            [122.27036347900003, 7.172227430000021],
            [122.27520850200005, 7.170836489000067],
        ],
        [
            [122.28895055100008, 7.174191697000026],
            [122.28851725200002, 7.174554908000061],
            [122.28883840000003, 7.175039659000049],
            [122.2891962010001, 7.174599717000035],
            [122.28895055100008, 7.174191697000026],
        ],
        [
            [122.2866340600001, 7.176814207000064],
            [122.28788445000009, 7.174212012000055],
            [122.28537999600007, 7.171661251000046],
            [122.28261218700004, 7.175450347000037],
            [122.2866340600001, 7.176814207000064],
        ],
        [
            [122.2697161970001, 7.180828133000034],
            [122.27104432300007, 7.178622011000073],
            [122.267282281, 7.176529788000039],
            [122.26699111900007, 7.178711900000053],
            [122.2697161970001, 7.180828133000034],
        ],
        [
            [122.84298107000006, 7.279850583000041],
            [122.84398515500004, 7.278026259000058],
            [122.83938218000003, 7.277189404000069],
            [122.84112126700006, 7.277959168000052],
            [122.84298107000006, 7.279850583000041],
        ],
        [
            [122.8545370600001, 7.284474274000047],
            [122.86003261700012, 7.273910249000039],
            [122.85103635100006, 7.267828308000048],
            [122.84105570500003, 7.275578421000034],
            [122.8545370600001, 7.284474274000047],
        ],
        [
            [122.85654029600005, 7.288895186000047],
            [122.85848162600007, 7.287178056000073],
            [122.85610955800007, 7.287850304000074],
            [122.85543240900006, 7.286863928000059],
            [122.85462151500008, 7.28686540700005],
            [122.853918668, 7.287356216000035],
            [122.85654029600005, 7.288895186000047],
        ],
        [
            [122.31731360900005, 7.315339188000053],
            [122.31876837900006, 7.311501114000066],
            [122.30962411300004, 7.307570105000025],
            [122.31096074600009, 7.314116170000034],
            [122.31731360900005, 7.315339188000053],
        ],
        [
            [122.9185142130001, 7.343325508000021],
            [122.91887228100006, 7.341449637000039],
            [122.91844395300006, 7.340899667000031],
            [122.91679582300003, 7.342484808000052],
            [122.9185142130001, 7.343325508000021],
        ],
        [
            [122.95455433100005, 7.348834149000027],
            [122.95470069700002, 7.348265588000061],
            [122.9535907500001, 7.348246578000044],
            [122.95374582900001, 7.348806499000034],
            [122.95455433100005, 7.348834149000027],
        ],
        [
            [122.40930175800008, 7.354125977000024],
            [122.40808105400004, 7.354919434000067],
            [122.40808105400004, 7.356689453000058],
            [122.4094848630001, 7.355895997000061],
            [122.40930175800008, 7.354125977000024],
        ],
        [
            [122.40527343700012, 7.359313965000069],
            [122.40429687500011, 7.35968017600004],
            [122.40472412100007, 7.363098144000048],
            [122.40570068400007, 7.362304688000052],
            [122.40527343700012, 7.359313965000069],
        ],
        [
            [123.32952880800008, 7.368530273000033],
            [123.32849121100003, 7.368530273000033],
            [123.32867431600005, 7.369506836000028],
            [123.32952880800008, 7.369079590000069],
            [123.32952880800008, 7.368530273000033],
        ],
        [
            [123.32875726700001, 7.374916640000038],
            [123.33065384100007, 7.37296335700006],
            [123.329148916, 7.370461614000021],
            [123.32776409600001, 7.372553094000068],
            [123.32875726700001, 7.374916640000038],
        ],
        [
            [122.42889404300001, 7.385925293000071],
            [122.42749023400006, 7.38647461000005],
            [122.42889404300001, 7.388122559000067],
            [122.4295043950001, 7.387695313000052],
            [122.42889404300001, 7.385925293000071],
        ],
        [
            [122.78768426500005, 7.390678404000028],
            [122.79058171800011, 7.386989386000039],
            [122.78845266600001, 7.384570769000049],
            [122.78522919200009, 7.387586570000053],
            [122.78768426500005, 7.390678404000028],
        ],
        [
            [122.38788593600009, 7.395486230000074],
            [122.38860760800003, 7.395236207000039],
            [122.38748078300011, 7.394079337000051],
            [122.38740598900006, 7.395463792000044],
            [122.38788593600009, 7.395486230000074],
        ],
        [
            [122.40356240500012, 7.395192835000046],
            [122.40209960900006, 7.39288330100004],
            [122.40008544900002, 7.393920898000033],
            [122.40192057700006, 7.396977431000039],
            [122.40356240500012, 7.395192835000046],
        ],
        [
            [122.37383530600005, 7.406502819000025],
            [122.37330294900005, 7.403678266000043],
            [122.37011900800007, 7.40436870800005],
            [122.36991711000007, 7.406937054000025],
            [122.37383530600005, 7.406502819000025],
        ],
        [
            [122.37209495000002, 7.410814901000037],
            [122.37381335300006, 7.410043508000058],
            [122.3706129410001, 7.408193607000044],
            [122.37004449300002, 7.412427433000062],
            [122.37209495000002, 7.410814901000037],
        ],
        [
            [122.92789694200007, 7.430220809000048],
            [122.92662144600001, 7.432442639000044],
            [122.92775299000004, 7.433663241000033],
            [122.92889637200005, 7.431494039000029],
            [122.92789694200007, 7.430220809000048],
        ],
        [
            [122.84823396000002, 7.436415363000037],
            [122.84859903900008, 7.434300503000031],
            [122.84521735600003, 7.434045853000043],
            [122.84721888000001, 7.436336141000027],
            [122.84823396000002, 7.436415363000037],
        ],
        [
            [122.85786587100006, 7.436246115000074],
            [122.8537761230001, 7.430056917000059],
            [122.84929380100004, 7.430848387000026],
            [122.85006920500007, 7.434161893000066],
            [122.85786587100006, 7.436246115000074],
        ],
        [
            [122.89848872400012, 7.442824855000026],
            [122.97482088200002, 7.36208070400005],
            [122.92490707200011, 7.37210992200005],
            [122.95280880900009, 7.349137734000067],
            [122.94945232100008, 7.338117918000023],
            [122.9169211630001, 7.348386769000058],
            [122.81732778100002, 7.283715589000053],
            [122.78721729500012, 7.352534347000073],
            [122.80311993700002, 7.422770237000066],
            [122.84836309800005, 7.425740845000064],
            [122.8780700960001, 7.373060250000037],
            [122.87390920300004, 7.365798325000071],
            [122.87499434800009, 7.364869726000052],
            [122.89119030100005, 7.378810944000065],
            [122.89848872400012, 7.442824855000026],
        ],
        [
            [122.9663495740001, 7.455747878000068],
            [122.96687655200003, 7.454942475000053],
            [122.96684747800009, 7.454426883000053],
            [122.96638046800001, 7.454916971000046],
            [122.9663495740001, 7.455747878000068],
        ],
        [
            [122.96274709000011, 7.458384838000029],
            [122.96276424300004, 7.458135798000058],
            [122.96326173700004, 7.458004256000038],
            [122.96259976600004, 7.458137970000053],
            [122.96274709000011, 7.458384838000029],
        ],
        [
            [122.96416976500007, 7.462291327000059],
            [122.96751253700006, 7.460512332000064],
            [122.96927699900004, 7.456101234000073],
            [122.96899117600003, 7.454329907000044],
            [122.97022581100009, 7.452387600000066],
            [122.97026397000002, 7.452202014000022],
            [122.9700731690001, 7.452045259000045],
            [122.96416976500007, 7.462291327000059],
        ],
        [
            [122.39016454400007, 7.487191741000061],
            [122.39053020300003, 7.486598836000042],
            [122.3902064560001, 7.486170939000033],
            [122.38975582400008, 7.486652354000057],
            [122.38978774200007, 7.488005866000037],
            [122.39016454400007, 7.487191741000061],
        ],
        [
            [122.46350097700008, 7.486877441000047],
            [122.46148681600005, 7.487487793000071],
            [122.4627075190001, 7.488891602000024],
            [122.4636840820001, 7.488281251000046],
            [122.46350097700008, 7.486877441000047],
        ],
        [
            [123.13646832800009, 7.487037994000048],
            [123.1340942380001, 7.48608398500005],
            [123.1331176760001, 7.488708496000072],
            [123.13549804600007, 7.489318848000039],
            [123.13646832800009, 7.487037994000048],
        ],
        [
            [122.41838244500002, 7.497001987000033],
            [122.42348930600008, 7.496038322000061],
            [122.41612162900003, 7.489650630000028],
            [122.415422465, 7.492623415000025],
            [122.41838244500002, 7.497001987000033],
        ],
        [
            [122.43697380600008, 7.519391229000064],
            [122.43678186500006, 7.520097203000034],
            [122.43819214500002, 7.521539509000036],
            [122.43838686400011, 7.520825259000048],
            [122.43697380600008, 7.519391229000064],
        ],
        [
            [123.22056129700002, 7.522086222000041],
            [123.22313546300006, 7.519793850000042],
            [123.2243290350001, 7.516235511000048],
            [123.21731930900012, 7.520473853000055],
            [123.22056129700002, 7.522086222000041],
        ],
        [
            [123.2531676110001, 7.528992406000043],
            [123.25503272300011, 7.528125842000065],
            [123.25626054600002, 7.527254668000069],
            [123.2512658060001, 7.527400904000046],
            [123.2531676110001, 7.528992406000043],
        ],
        [
            [122.45721790900006, 7.531103841000061],
            [122.45782376600005, 7.530454765000059],
            [122.45643191200008, 7.530281206000041],
            [122.45636707800008, 7.530711137000026],
            [122.45721790900006, 7.531103841000061],
        ],
        [
            [122.48582212500003, 7.534935852000046],
            [122.48604068600002, 7.53459902000003],
            [122.48596428100007, 7.534327490000067],
            [122.48523746500007, 7.535092564000024],
            [122.48582212500003, 7.534935852000046],
        ],
        [
            [122.44554117500002, 7.544373363000034],
            [122.44677569900011, 7.543924813000046],
            [122.44800554100004, 7.541757729000039],
            [122.44435464600008, 7.54233352500006],
            [122.44554117500002, 7.544373363000034],
        ],
        [
            [122.79111712500003, 7.555458900000076],
            [122.79696112800002, 7.555926717000034],
            [122.79904229800002, 7.553947634000053],
            [122.78873359300007, 7.552472301000023],
            [122.79111712500003, 7.555458900000076],
        ],
        [
            [123.04939540300006, 7.576336185000059],
            [123.04980750300001, 7.573327353000025],
            [123.04920610600004, 7.572704775000034],
            [123.0471839600001, 7.576004711000053],
            [123.04939540300006, 7.576336185000059],
        ],
        [
            [123.0453537080001, 7.586100619000035],
            [123.05150362000006, 7.582523629000036],
            [123.0517740570001, 7.58095951100006],
            [123.0468294740001, 7.582725409000034],
            [123.0453537080001, 7.586100619000035],
        ],
        [
            [123.03928430200006, 7.58612320800006],
            [123.03837840900007, 7.586242464000065],
            [123.03826517000005, 7.587084305000076],
            [123.03924183700008, 7.587357904000044],
            [123.03928430200006, 7.58612320800006],
        ],
        [
            [122.44668139600003, 7.587675096000055],
            [122.44731859500007, 7.587909056000058],
            [122.44746381300001, 7.587579169000037],
            [122.44629333000012, 7.587389385000051],
            [122.44668139600003, 7.587675096000055],
        ],
        [
            [122.44501355700004, 7.587958491000052],
            [122.44603014800009, 7.587335182000061],
            [122.44307805000005, 7.587105232000056],
            [122.4437228490001, 7.587791476000064],
            [122.44501355700004, 7.587958491000052],
        ],
        [
            [123.04917882900008, 7.591880229000026],
            [123.04999608500009, 7.589725590000057],
            [123.04957522100005, 7.589379564000069],
            [123.04843008300008, 7.591340167000055],
            [123.04917882900008, 7.591880229000026],
        ],
        [
            [122.49260913300009, 7.596260122000047],
            [122.49205100900008, 7.593674229000044],
            [122.48925334300009, 7.593988403000026],
            [122.4895395420001, 7.595226188000026],
            [122.49260913300009, 7.596260122000047],
        ],
        [
            [123.07723049200001, 7.607023125000069],
            [123.07629394500009, 7.608093262000068],
            [123.07690429700006, 7.608520508000026],
            [123.07769775300005, 7.607482910000044],
            [123.07723049200001, 7.607023125000069],
        ],
        [
            [123.39856876500005, 7.609709956000074],
            [123.40000608700007, 7.607014413000059],
            [123.3974978650001, 7.605123836000075],
            [123.39508762600008, 7.608755467000037],
            [123.39856876500005, 7.609709956000074],
        ],
        [
            [123.18742779900003, 7.611272619000033],
            [123.18838165000011, 7.610747188000062],
            [123.18828364300009, 7.60991142000006],
            [123.18712913400009, 7.610030103000042],
            [123.18742779900003, 7.611272619000033],
        ],
        [
            [123.08021723200011, 7.61238653700002],
            [123.0799151010001, 7.610976556000026],
            [123.07921053300004, 7.610898616000043],
            [123.07927481600007, 7.612145548000058],
            [123.08021723200011, 7.61238653700002],
        ],
        [
            [123.07241560600005, 7.614649391000057],
            [123.07654922600011, 7.612413200000049],
            [123.076368838, 7.608957426000075],
            [123.07464181900002, 7.609454193000033],
            [123.07241560600005, 7.614649391000057],
        ],
        [
            [123.45762937900008, 7.615762586000073],
            [123.46474566400002, 7.609717944000067],
            [123.46128250200002, 7.603928847000077],
            [123.45406074300001, 7.608275287000026],
            [123.45762937900008, 7.615762586000073],
        ],
        [
            [123.1800232280001, 7.616636959000061],
            [123.17968311700008, 7.614888080000071],
            [123.179255882, 7.614903168000069],
            [123.1790837740001, 7.616249630000027],
            [123.1800232280001, 7.616636959000061],
        ],
        [
            [123.17830308900011, 7.618650180000031],
            [123.17908441700001, 7.617049620000046],
            [123.17851248300008, 7.616281886000024],
            [123.17794695900011, 7.615841631000023],
            [123.17763694100006, 7.615744978000066],
            [123.17830308900011, 7.618650180000031],
        ],
        [
            [123.1792441120001, 7.620329244000061],
            [123.1810029080001, 7.617614756000023],
            [123.18071059200008, 7.617043481000053],
            [123.17925425900012, 7.617381545000057],
            [123.1792441120001, 7.620329244000061],
        ],
        [
            [123.46721106400003, 7.61926177600003],
            [123.46621806600001, 7.618505379000055],
            [123.46354907800003, 7.618735506000064],
            [123.46532159500009, 7.620679958000039],
            [123.46721106400003, 7.61926177600003],
        ],
        [
            [123.4612146830001, 7.621125237000058],
            [123.46160198100006, 7.619754141000044],
            [123.46040442200001, 7.619387886000027],
            [123.45995382900003, 7.62088766100004],
            [123.4612146830001, 7.621125237000058],
        ],
        [
            [123.0569757290001, 7.627031503000069],
            [123.05717643500009, 7.626708244000042],
            [123.05663482600005, 7.626736034000032],
            [123.05659645600008, 7.626913022000053],
            [123.0569757290001, 7.627031503000069],
        ],
        [
            [123.05740187800006, 7.627835267000023],
            [123.05812303400012, 7.627525727000034],
            [123.05754310100008, 7.626783019000072],
            [123.05695369200009, 7.627107978000026],
            [123.05740187800006, 7.627835267000023],
        ],
        [
            [123.0607531490001, 7.629559770000071],
            [123.06026246300007, 7.629602071000022],
            [123.06003403900002, 7.630718805000072],
            [123.06088851100003, 7.630498842000065],
            [123.0607531490001, 7.629559770000071],
        ],
        [
            [123.06048584000007, 7.632324219000054],
            [123.0598754880001, 7.63171386700003],
            [123.05908203100012, 7.63311767600004],
            [123.06030273400006, 7.633483887000068],
            [123.06048584000007, 7.632324219000054],
        ],
        [
            [123.11389160100009, 7.637695312000062],
            [123.11328124900001, 7.637084961000028],
            [123.11248779300001, 7.637878418000071],
            [123.11328124900001, 7.638488770000038],
            [123.11389160100009, 7.637695312000062],
        ],
        [
            [123.09252929700006, 7.647521973000039],
            [123.09051513700001, 7.648071289000029],
            [123.09167480400004, 7.650085449000073],
            [123.09350585900006, 7.649475098000039],
            [123.09252929700006, 7.647521973000039],
        ],
        [
            [123.08929443400007, 7.650085449000073],
            [123.08831787100007, 7.650085449000073],
            [123.08972167900004, 7.651916504000042],
            [123.09027099600007, 7.651123047000056],
            [123.08929443400007, 7.650085449000073],
        ],
        [
            [123.07071409800005, 7.658205855000062],
            [123.07136780000008, 7.65723711000004],
            [123.07069724200005, 7.653549355000052],
            [123.06996321000008, 7.655225408000035],
            [123.07071409800005, 7.658205855000062],
        ],
        [
            [123.04955916300003, 7.662770430000023],
            [123.05016776100001, 7.662923009000053],
            [123.05048505600007, 7.66273398900006],
            [123.04979205600011, 7.662129390000075],
            [123.04955916300003, 7.662770430000023],
        ],
        [
            [123.04895495500011, 7.663740124000071],
            [123.04914719100009, 7.663655682000069],
            [123.04985835900004, 7.663036240000054],
            [123.04955623600006, 7.66308983600004],
            [123.04895495500011, 7.663740124000071],
        ],
        [
            [123.12231445300006, 7.66827392600004],
            [123.12127685500002, 7.668701172000056],
            [123.12371826100002, 7.670471191000047],
            [123.12408447200005, 7.669311524000022],
            [123.12231445300006, 7.66827392600004],
        ],
        [
            [123.10945869200009, 7.681582841000022],
            [123.11035562200004, 7.675712029000067],
            [123.10614277200011, 7.673700733000032],
            [123.10552978500004, 7.679870606000065],
            [123.10945869200009, 7.681582841000022],
        ],
        [
            [122.54247199400004, 7.687230950000071],
            [122.54570259500008, 7.68555131200003],
            [122.54573944200001, 7.682246533000068],
            [122.54041244000007, 7.685007679000023],
            [122.54247199400004, 7.687230950000071],
        ],
        [
            [123.49314080500005, 7.780997858000035],
            [123.49277716200004, 7.78098406600003],
            [123.49291809500005, 7.781342637000023],
            [123.49360710300004, 7.781415042000049],
            [123.49314080500005, 7.780997858000035],
        ],
        [
            [123.43538552600012, 7.794816749000063],
            [123.43603613900007, 7.794295371000032],
            [123.43544853800006, 7.792414910000048],
            [123.43494248500008, 7.794313080000052],
            [123.43538552600012, 7.794816749000063],
        ],
        [
            [123.48982968300004, 8.648388812000064],
            [123.48942219600008, 8.648882633000028],
            [123.49048692100007, 8.649142539000024],
            [123.49036861900004, 8.64845378900003],
            [123.48982968300004, 8.648388812000064],
        ],
        [
            [123.50025348000008, 8.657290490000037],
            [123.50342136800009, 8.656016978000025],
            [123.49613916900012, 8.650182160000043],
            [123.49571853700002, 8.657134550000023],
            [123.50025348000008, 8.657290490000037],
        ],
        [
            [123.6350335190001, 7.93272192400002],
            [123.666222005, 7.888529371000061],
        ],
        [
            [123.666222005, 7.888529371000061],
            [123.62335146100008, 7.829692316000035],
            [123.53938130800009, 7.85019756500003],
            [123.42283010400001, 7.814922662000072],
            [123.42019930700008, 7.767744625000034],
            [123.48238666000009, 7.729081775000054],
            [123.46747724000011, 7.638056370000072],
            [123.38480191600001, 7.606106290000071],
            [123.38820633300008, 7.555738105000046],
            [123.33766562800008, 7.570300326000051],
            [123.381939224, 7.534666879000042],
            [123.3944749320001, 7.458342879000043],
            [123.44654487700006, 7.442770703000065],
            [123.4517850310001, 7.371866457000067],
            [123.40552019000006, 7.357573197000022],
            [123.3270219310001, 7.419847492000031],
            [123.28242373500007, 7.473018711000066],
            [123.30053085500003, 7.532152125000039],
            [123.2244263340001, 7.540223671000035],
            [123.17730887400012, 7.466162292000035],
            [123.11564108000005, 7.514043945000026],
            [123.10220794600002, 7.556901433000064],
            [123.13109094600009, 7.580457680000052],
            [123.1210141580001, 7.589101931000073],
            [123.09769117500002, 7.600291104000064],
            [123.09666550600002, 7.602627583000071],
            [123.12540727700002, 7.602618549000056],
            [123.13718726200011, 7.576410623000072],
            [123.19696958400004, 7.591136281000047],
            [123.17510992600012, 7.644948890000023],
            [123.13115799500008, 7.655193672000053],
            [123.14519615300003, 7.69881080600004],
            [123.11381757200002, 7.735720506000064],
            [123.08426088300007, 7.677323490000049],
            [123.062402829, 7.680626406000044],
            [123.03434210500006, 7.657553655000072],
            [123.05347970800005, 7.65358797500005],
            [123.04843879000009, 7.638734026000066],
            [123.0548090630001, 7.638016036000067],
            [123.05577372400012, 7.626289300000053],
            [123.05636419700011, 7.62587045500004],
            [123.05647731400006, 7.626685394000049],
            [123.05736905200001, 7.626284117000068],
            [123.05046482400007, 7.620658902000059],
            [123.02620027000012, 7.627087675000041],
            [122.99225176700008, 7.457801528000061],
            [122.90452097200011, 7.545037020000052],
            [122.85774707100006, 7.49900575700002],
            [122.87432170600005, 7.463954414000057],
            [122.81494585900009, 7.433799509000039],
            [122.81759086200009, 7.479858548000038],
            [122.77934145300003, 7.474652246000062],
            [122.78734006000002, 7.539021336000076],
            [122.798506427, 7.545697103000066],
            [122.82820899300009, 7.521850500000028],
            [122.78665410300005, 7.614780235000069],
            [122.81223501200009, 7.745659049000039],
            [122.65735562300006, 7.786901395000029],
            [122.5444648990001, 7.734446216000038],
            [122.48993138000003, 7.631459925000058],
            [122.44599192100009, 7.608885819000022],
            [122.43696787300007, 7.568933181000034],
            [122.50653193800008, 7.578249679000066],
            [122.45847842700005, 7.506901668000069],
            [122.4352030330001, 7.499677192000036],
            [122.46762118900006, 7.538429194000059],
            [122.43894799400005, 7.546330149000028],
            [122.42191037300006, 7.503399233000039],
            [122.40846300900012, 7.506418189000044],
            [122.35420013800001, 7.468663019000076],
            [122.34337360000006, 7.39658911600003],
            [122.39347030800002, 7.390385279000043],
            [122.34021969300011, 7.313745187000052],
            [122.29190018800011, 7.325375536000024],
            [122.27978474800011, 7.230860643000028],
            [122.24765272500008, 7.206260497000073],
            [122.26516364200006, 7.194533041000057],
            [122.25688127400008, 7.111316802000033],
            [122.20412061900004, 7.068335755000021],
            [122.15922114900002, 6.916042091000065],
            [122.11268679300008, 6.888271473000032],
            [121.94820730600009, 6.955813865000039],
            [121.90162062600007, 7.144830770000056],
            [121.97200398400003, 7.246846628000071],
            [122.06406920900008, 7.296292146000042],
            [122.03105146300004, 7.35643755600006],
            [122.09045101100003, 7.496524238000063],
            [122.07294217700007, 7.520711643000027],
            [122.143342533, 7.573705180000047],
            [122.10518026300008, 7.596935418000044],
            [122.13487305300009, 7.668536320000044],
            [122.08588828800009, 7.736703097000031],
            [122.12490084, 7.75609124500005],
            [122.10167401800004, 7.779473511000049],
            [122.16037813600008, 7.85917015900003],
            [122.22593046700001, 7.907280179000054],
            [122.22440756800006, 7.95814505900006],
            [122.34514362900006, 8.03873077000003],
            [122.58345185100006, 8.08270830500004],
            [122.66165965100004, 8.16224079400007],
            [122.68537783900001, 8.121326666000073],
            [122.7433964390001, 8.11076453100003],
            [122.92197031800004, 8.15229527300005],
            [122.9957965320001, 8.214418889000058],
            [122.936790201, 8.307411675000026],
            [122.98327860500001, 8.328350083000032],
            [122.97967272000005, 8.41339819600006],
            [123.0255855470001, 8.483649428000035],
            [123.18305033900003, 8.533149976000061],
            [123.30413815500003, 8.52160223800007],
            [123.35066971100002, 8.63525707100007],
            [123.41427773500004, 8.63593922900003],
            [123.38998785900003, 8.727439678000053],
            [123.45156847600003, 8.684285033000037],
            [123.50132148900002, 8.701159414000074],
            [123.50791357000003, 8.682585275000065],
            [123.48473646200011, 8.656729384000073],
            [123.48850730900006, 8.64188712400005],
            [123.55484985200007, 8.620580207000046],
            [123.55983807100006, 8.026096774000052],
            [123.63585284700002, 8.03380525800003],
            [123.66371876000005, 7.997576211000023],
            [123.6350335190001, 7.93272192400002],
        ],
        [
            [122.25824545400008, 7.136844776000032],
            [122.2583020730001, 7.136571482000022],
            [122.25855858800003, 7.136423622000052],
            [122.25870762900001, 7.136775367000041],
            [122.25824545400008, 7.136844776000032],
        ],
        [
            [122.25684087500008, 7.137511427000049],
            [122.25449311200009, 7.134345278000069],
            [122.25585145600007, 7.132716516000073],
            [122.25734573900002, 7.134415471000068],
            [122.25684087500008, 7.137511427000049],
        ],
        [
            [122.25452092100011, 7.139144584000064],
            [122.2536279410001, 7.138605786000028],
            [122.2546268320001, 7.137952442000028],
            [122.25480847400001, 7.138857719000043],
            [122.25452092100011, 7.139144584000064],
        ],
        [
            [122.25739170100007, 7.140268416000026],
            [122.25554776500007, 7.138286502000028],
            [122.25839527700009, 7.137332141000059],
            [122.25893921000011, 7.138371543000062],
            [122.25739170100007, 7.140268416000026],
        ],
        [
            [122.32447867400003, 7.319384873000047],
            [122.32301731100006, 7.318509667000058],
            [122.3264534650001, 7.318000519000066],
            [122.32589593800003, 7.319029374000024],
            [122.32447867400003, 7.319384873000047],
        ],
        [
            [122.32796168700008, 7.319717168000068],
            [122.32717495600002, 7.319002127000033],
            [122.32849792800005, 7.318728878000059],
            [122.3285284000001, 7.319538822000027],
            [122.32796168700008, 7.319717168000068],
        ],
        [
            [123.3029234070001, 7.519435682000051],
            [123.30301935300008, 7.518251581000072],
            [123.30508160300008, 7.518537249000076],
            [123.30500913100002, 7.519027292000033],
            [123.3029234070001, 7.519435682000051],
        ],
        [
            [123.3019362550001, 7.519539009000027],
            [123.30162166100001, 7.519287212000052],
            [123.30230251700004, 7.518985508000071],
            [123.30230609800003, 7.519535500000075],
            [123.3019362550001, 7.519539009000027],
        ],
        [
            [122.82030766800005, 7.520443912000076],
            [122.82279687300002, 7.526119702000074],
            [122.81831547400009, 7.529045843000063],
            [122.8157557290001, 7.521888959000023],
            [122.82030766800005, 7.520443912000076],
        ],
        [
            [122.09473772000001, 7.531043847000035],
            [122.093597756, 7.531583302000058],
            [122.09254916800012, 7.530146022000054],
            [122.09381623700006, 7.529610509000065],
            [122.09473772000001, 7.531043847000035],
        ],
        [
            [122.4550760190001, 7.543503915000031],
            [122.45500716000004, 7.543193249000069],
            [122.45587270400006, 7.542233751000026],
            [122.45563114200002, 7.543120122000062],
            [122.4550760190001, 7.543503915000031],
        ],
        [
            [123.36662550000005, 7.572344456000053],
            [123.36556539600008, 7.571280862000037],
            [123.36824576600009, 7.569622769000034],
            [123.36829300800002, 7.570091713000068],
            [123.36662550000005, 7.572344456000053],
        ],
        [
            [122.43493983400003, 7.573134502000073],
            [122.43462427200006, 7.573079204000067],
            [122.43447427700005, 7.572574792000069],
            [122.43496327700007, 7.572773658000074],
            [122.43493983400003, 7.573134502000073],
        ],
        [
            [123.38131328000009, 7.596498017000044],
            [123.38080989700006, 7.596264886000029],
            [123.38070018200006, 7.595997255000043],
            [123.38194907900004, 7.596340950000069],
            [123.38131328000009, 7.596498017000044],
        ],
        [
            [123.3805312610001, 7.596901738000042],
            [123.38002786600009, 7.596803280000074],
            [123.37999480100007, 7.59645968500007],
            [123.38049996000007, 7.596302609000077],
            [123.3805312610001, 7.596901738000042],
        ],
        [
            [123.3817377470001, 7.597620064000068],
            [123.38152370300008, 7.597652555000025],
            [123.38098863500011, 7.597296628000038],
            [123.38136320400008, 7.597301792000053],
            [123.3817377470001, 7.597620064000068],
        ],
        [
            [123.22664937600007, 8.749102202000074],
            [123.22580642000003, 8.743182428000068],
            [123.21821982200004, 8.74374152200005],
            [123.21919587500008, 8.748499266000067],
            [123.22664937600007, 8.749102202000074],
        ],
        [
            [123.41987524100011, 8.849736929000073],
            [123.41321906100006, 8.852685201000043],
            [123.41390763100003, 8.86021452500006],
            [123.4211146670001, 8.856631312000047],
            [123.41987524100011, 8.849736929000073],
        ],
        [
            [122.9882253830001, 11.730793677000065],
            [122.98927542500007, 11.729849762000072],
            [122.98849827800007, 11.728982863000056],
            [122.98750011700008, 11.73016966800003],
            [122.9882253830001, 11.730793677000065],
        ],
        [
            [123.02404760000002, 11.758962953000037],
            [123.02661735700008, 11.757919345000062],
            [123.02358389200003, 11.754882603000055],
            [123.02228427900002, 11.758061562000023],
            [123.02404760000002, 11.758962953000037],
        ],
        [
            [123.91053903900001, 11.81879493100007],
            [123.91691706600011, 11.810490332000029],
            [123.90604762600003, 11.80876958400006],
            [123.9038613670001, 11.815200988000072],
            [123.91053903900001, 11.81879493100007],
        ],
        [
            [123.84616615200002, 11.819191403000048],
            [123.84553797800004, 11.817056912000055],
            [123.84436576100006, 11.817244292000055],
            [123.84420316800004, 11.819139020000023],
            [123.84616615200002, 11.819191403000048],
        ],
        [
            [124.10234041500007, 11.836300039000037],
            [124.10347076000005, 11.833836121000047],
            [124.10163201900002, 11.832325756000046],
            [124.09950234300004, 11.834175218000041],
            [124.10234041500007, 11.836300039000037],
        ],
        [
            [123.76770703000011, 11.859260969000047],
            [123.7705002130001, 11.85676942400005],
            [123.77103135000004, 11.855920669000056],
            [123.76745642600008, 11.856715399000052],
            [123.76770703000011, 11.859260969000047],
        ],
        [
            [123.13538068300011, 11.861503957000025],
            [123.14184556700002, 11.852101502000039],
            [123.12214700600009, 11.834937296000021],
            [123.11825551600009, 11.853469590000032],
            [123.13538068300011, 11.861503957000025],
        ],
        [
            [124.08654321000006, 11.88256238300005],
            [124.095093958, 11.876421180000023],
            [124.09587250800007, 11.870798325000067],
            [124.07845359500004, 11.875474255000029],
            [124.08654321000006, 11.88256238300005],
        ],
        [
            [123.6619280330001, 11.904486047000034],
            [123.67422580700008, 11.901306314000067],
            [123.6712258660001, 11.870701556000029],
            [123.66004667600009, 11.881873314000075],
            [123.6619280330001, 11.904486047000034],
        ],
        [
            [123.59502648700004, 11.917963744000076],
            [123.60525298100004, 11.915518596000027],
            [123.6102323450001, 11.907739442000036],
            [123.60540419400002, 11.906317865000062],
            [123.59502648700004, 11.917963744000076],
        ],
        [
            [123.58764370000006, 11.937597918000051],
            [123.58940845600011, 11.935795436000035],
            [123.58925689700004, 11.934128470000076],
            [123.58716421400004, 11.937348274000044],
            [123.58764370000006, 11.937597918000051],
        ],
        [
            [123.61854439000001, 11.95937895700007],
            [123.6220070490001, 11.956723929000077],
            [123.62355620900007, 11.951717578000057],
            [123.62106302500001, 11.953032266000037],
            [123.61854439000001, 11.95937895700007],
        ],
        [
            [123.55640343700009, 11.94847186800007],
            [123.55143551000003, 11.959220071000061],
            [123.55216479800004, 11.96246453200007],
            [123.55673177200003, 11.953803999000058],
            [123.55640343700009, 11.94847186800007],
        ],
        [
            [123.57576231100006, 11.989477392000026],
            [123.5783885830001, 11.988014405000058],
            [123.57949103900012, 11.986287642000036],
            [123.57630065, 11.986971442000026],
            [123.57576231100006, 11.989477392000026],
        ],
        [
            [123.56556103600008, 11.994756874000075],
            [123.56718627100008, 11.993377505000069],
            [123.56677031100003, 11.992341268000075],
            [123.56485058300007, 11.994817107000074],
            [123.56556103600008, 11.994756874000075],
        ],
        [
            [123.62980689100004, 12.01957582700004],
            [123.63040399400006, 12.01918721900006],
            [123.63032509600009, 12.01872555500006],
            [123.62967941600004, 12.01906223800006],
            [123.62980689100004, 12.01957582700004],
        ],
        [
            [123.6377576540001, 12.02212368000005],
            [123.63560033400006, 12.016350657000032],
            [123.63152173200001, 12.019545161000053],
            [123.63855832400009, 12.025827116000073],
            [123.6377576540001, 12.02212368000005],
        ],
        [
            [123.54700248600011, 12.041968712000028],
            [123.5494446130001, 12.03741502400004],
            [123.54807178100009, 12.031832355000063],
            [123.5450826870001, 12.03895204500003],
            [123.54700248600011, 12.041968712000028],
        ],
        [
            [123.2312730330001, 12.167454173000067],
            [123.23106448900012, 12.162280810000027],
            [123.22543212200003, 12.16109977700006],
            [123.22710896400008, 12.165994133000027],
            [123.2312730330001, 12.167454173000067],
        ],
        [
            [123.26265833900004, 12.191686236000066],
            [123.25808814100003, 12.171954284000037],
            [123.23247875900006, 12.16977109100003],
            [123.2516677970001, 12.17880855900006],
            [123.26265833900004, 12.191686236000066],
        ],
        [
            [123.85063118500011, 12.250537789000077],
            [123.86635829800002, 12.24396372700005],
            [123.8643802900001, 12.228971845000046],
            [123.84332840200011, 12.250834980000036],
            [123.85063118500011, 12.250537789000077],
        ],
        [
            [123.83516977700003, 12.256142917000034],
            [123.83755290400006, 12.254301318000046],
            [123.83847278000007, 12.248226420000037],
            [123.8353177250001, 12.252889495000034],
            [123.83516977700003, 12.256142917000034],
        ],
        [
            [123.83971174200008, 12.257672151000065],
            [123.84047692100012, 12.255734550000057],
            [123.84018968900011, 12.254017841000064],
            [123.83831850700005, 12.256693151000036],
            [123.83971174200008, 12.257672151000065],
        ],
        [
            [123.83095730900004, 12.270026658000063],
            [123.83958806200008, 12.266005896000024],
            [123.8334205860001, 12.259320486000036],
            [123.83083041700002, 12.262574208000046],
            [123.83095730900004, 12.270026658000063],
        ],
        [
            [123.22297032400002, 12.283314636000057],
            [123.22334228500006, 12.282782743000041],
            [123.22418939800002, 12.281961906000049],
            [123.22330701800001, 12.282602869000073],
            [123.22278959900007, 12.283546388000048],
            [123.22297032400002, 12.283314636000057],
        ],
        [
            [123.22292110600006, 12.28409133200006],
            [123.22339629600003, 12.283293578000041],
            [123.22417529000006, 12.282485387000065],
            [123.2238190170001, 12.282732074000023],
            [123.22266655500005, 12.284067389000029],
            [123.22292110600006, 12.28409133200006],
        ],
        [
            [123.2185501030001, 12.285073608000062],
            [123.22144068600005, 12.28471163200004],
            [123.22270543400009, 12.283588646000055],
            [123.213253903, 12.28230260600003],
            [123.2185501030001, 12.285073608000062],
        ],
        [
            [123.79832887500004, 12.331260111000063],
            [123.80852775900007, 12.322468116000039],
            [123.8093735860001, 12.30860431800005],
            [123.79365831300004, 12.333041904000027],
            [123.79832887500004, 12.331260111000063],
        ],
        [
            [123.24599463400011, 12.38428243900006],
            [123.25336767600004, 12.378186650000032],
            [123.23716209000008, 12.343462755000076],
            [123.23361313200007, 12.371049595000045],
            [123.24599463400011, 12.38428243900006],
        ],
        [
            [123.24288075400011, 12.391023392000022],
            [123.2434104560001, 12.389698056000043],
            [123.2445472060001, 12.388827813000034],
            [123.244503011, 12.388562885000056],
            [123.24131289200011, 12.389086290000023],
            [123.24288075400011, 12.391023392000022],
        ],
        [
            [123.25379257800012, 12.409343900000067],
            [123.2569926430001, 12.404500652000024],
            [123.24734064800009, 12.401305878000073],
            [123.2491429580001, 12.405907349000074],
            [123.25379257800012, 12.409343900000067],
        ],
        [
            [123.25382648700008, 12.439339338000025],
            [123.25768003500002, 12.431119827000032],
            [123.25067303000003, 12.42059931600005],
            [123.25106449100008, 12.436682896000036],
            [123.25382648700008, 12.439339338000025],
        ],
        [
            [123.20771276800008, 12.440401032000068],
            [123.20899327000006, 12.44003060600005],
            [123.20757377000007, 12.438858117000052],
            [123.20767214500006, 12.440564247000054],
            [123.20771276800008, 12.440401032000068],
        ],
        [
            [123.34862409100003, 12.446965540000065],
            [123.34863375500004, 12.447294802000044],
            [123.34876280200001, 12.447688663000065],
            [123.34876927700009, 12.447250697000072],
            [123.34862409100003, 12.446965540000065],
        ],
        [
            [123.34853370000008, 12.447863523000024],
            [123.3484240570001, 12.446574828000053],
            [123.34833533500012, 12.446349539000039],
            [123.34839657700002, 12.447633506000045],
            [123.34853370000008, 12.447863523000024],
        ],
        [
            [123.34738499600007, 12.452357840000047],
            [123.34767283400004, 12.452271620000033],
            [123.348410424, 12.451896375000047],
            [123.347718643, 12.451934667000046],
            [123.34738499600007, 12.452357840000047],
        ],
        [
            [123.34788543000002, 12.452405774000056],
            [123.34834171600005, 12.452295608000043],
            [123.34867372200006, 12.452006577000077],
            [123.34772188800002, 12.452396184000065],
            [123.34788543000002, 12.452405774000056],
        ],
        [
            [123.34415725800011, 12.455549446000077],
            [123.3471449000001, 12.451917839000032],
            [123.34892368700002, 12.451474807000068],
            [123.3447555460001, 12.444974056000035],
            [123.34415725800011, 12.455549446000077],
        ],
        [
            [123.34696810000003, 12.455815198000039],
            [123.34719363900001, 12.45496967400004],
            [123.34691428300005, 12.454669722000062],
            [123.34678839100002, 12.455687553000075],
            [123.34696810000003, 12.455815198000039],
        ],
        [
            [123.34934436200001, 12.45751449900007],
            [123.34914342900004, 12.457160314000078],
            [123.34823010800005, 12.457311804000028],
            [123.3489816770001, 12.457200186000023],
            [123.34934436200001, 12.45751449900007],
        ],
        [
            [123.37730176800005, 12.46602534300007],
            [123.3773589110001, 12.465877084000056],
            [123.37714339800004, 12.465645929000061],
            [123.37705850200007, 12.466323456000055],
            [123.37730176800005, 12.46602534300007],
        ],
        [
            [123.3733126940001, 12.476187336000066],
            [123.37346183300008, 12.47618503800004],
            [123.3736342520001, 12.476037121000047],
            [123.3729864390001, 12.476089547000072],
            [123.3733126940001, 12.476187336000066],
        ],
        [
            [123.3712769660001, 12.477072488000033],
            [123.37200629800009, 12.47534574100007],
            [123.37125145900006, 12.474553373000049],
            [123.37095977400008, 12.476670633000026],
            [123.3712769660001, 12.477072488000033],
        ],
        [
            [124.10113335900007, 12.546529430000021],
            [124.10159448000002, 12.546136207000075],
            [124.10141903800002, 12.545659726000054],
            [124.10047349500007, 12.546127890000037],
            [124.10113335900007, 12.546529430000021],
        ],
        [
            [124.10247520300004, 12.54761028400003],
            [124.10227757700011, 12.546977037000033],
            [124.10174838600005, 12.547042365000038],
            [124.10177546900002, 12.547453598000061],
            [124.10247520300004, 12.54761028400003],
        ],
        [
            [124.08703063200005, 12.548569143000066],
            [124.09078907600008, 12.54796346300003],
            [124.08944004600005, 12.543739813000059],
            [124.08705587300005, 12.547157084000048],
            [124.08703063200005, 12.548569143000066],
        ],
        [
            [124.10701618100006, 12.550443775000076],
            [124.11352143600004, 12.542924723000056],
            [124.090588249, 12.523738798000068],
            [124.09486695700002, 12.541301385000054],
            [124.1024193290001, 12.540265246000047],
            [124.10701618100006, 12.550443775000076],
        ],
        [
            [124.11515002600004, 12.561003739000057],
            [124.11962272000005, 12.556942351000032],
            [124.11780239900008, 12.544281678000061],
            [124.10905907800009, 12.552324953000038],
            [124.11515002600004, 12.561003739000057],
        ],
        [
            [124.0985426950001, 12.567901992000031],
            [124.09948498200004, 12.565670688000068],
            [124.09781581200002, 12.565414256000054],
            [124.09737615100005, 12.567301049000037],
            [124.0985426950001, 12.567901992000031],
        ],
        [
            [124.09757253900011, 12.568391634000022],
            [124.09713127600003, 12.56810196400005],
            [124.09706156700008, 12.568899362000025],
            [124.09730863000004, 12.568928456000037],
            [124.09757253900011, 12.568391634000022],
        ],
        [
            [124.09770066100009, 12.56901345700004],
            [124.09810368900003, 12.568447512000034],
            [124.09774905100005, 12.568074267000043],
            [124.09748242700005, 12.568776850000063],
            [124.09770066100009, 12.56901345700004],
        ],
        [
            [124.09809319200008, 12.570969002000027],
            [124.09965034800007, 12.56915299700006],
            [124.09856634000005, 12.568183913000041],
            [124.0974992030001, 12.570547249000072],
            [124.09809319200008, 12.570969002000027],
        ],
        [
            [124.12424177000003, 12.585133101000054],
            [124.12998097700006, 12.58194504100004],
            [124.1261990050001, 12.577545666000049],
            [124.12270199500006, 12.577783281000052],
            [124.12424177000003, 12.585133101000054],
        ],
        [
            [123.237051, 12.601248518000034],
            [123.379433446, 12.541442865000022],
            [123.33849715100007, 12.53923856700004],
            [123.36058441900002, 12.48407],
            [123.32320647900008, 12.467432419000033],
            [123.32908593900004, 12.43184971100004],
            [123.38304177900011, 12.465424468000037],
            [123.37100448900003, 12.505788400000029],
            [123.44425549400012, 12.516966054000022],
            [123.5376910980001, 12.448137081000027],
            [123.55525127900012, 12.462124870000025],
            [123.60999625900001, 12.382407201000035],
            [123.58186949900005, 12.353176345000065],
            [123.62688625800001, 12.379420628000048],
            [123.69662179300008, 12.330977407000034],
            [123.78300020000006, 12.195252780000033],
            [123.799378853, 12.243960094000045],
            [123.85421838500008, 12.194502963000048],
            [123.89355717600006, 12.209923309000033],
            [124.05208063300006, 11.96832319400005],
            [124.04840280200006, 11.947671266000043],
            [123.99787125800003, 12.011943614000074],
            [124.06998484700011, 11.853308549000076],
            [124.07042209000008, 11.722680614000069],
            [123.92741940000008, 11.861770032000038],
            [123.72192047700003, 11.931817594000051],
            [123.74170596400006, 11.983797131000074],
            [123.64974493800003, 12.047683626000037],
            [123.66192233700008, 12.080005884000059],
            [123.60074657100006, 12.07503256700005],
            [123.61535309200008, 12.095268579000049],
            [123.53977156600001, 12.213320576000058],
            [123.43013360000009, 12.202350546000048],
            [123.29682049500002, 12.022442536000028],
            [123.15960937400007, 11.90605688100004],
            [123.1428992860001, 11.933836421000024],
            [123.21764746000008, 12.13197579000007],
            [123.2462714620001, 12.120962914000074],
            [123.28178494200006, 12.162622068000076],
            [123.26966309800002, 12.198307578000026],
            [123.30118287900007, 12.205699624000033],
            [123.29774153200003, 12.238297942000031],
            [123.28668149400005, 12.215077597000061],
            [123.26685904700003, 12.244578131000026],
            [123.22834326500003, 12.216875754000057],
            [123.21679377300006, 12.238482977000047],
            [123.28862541100011, 12.421743076000041],
            [123.25094181000009, 12.45717399700004],
            [123.237051, 12.601248518000034],
        ],
        [
            [123.34732257700011, 12.440078304000053],
            [123.34691271300005, 12.439744511000072],
            [123.34732257000007, 12.43920980400003],
            [123.34740519600007, 12.439980222000031],
            [123.34732257700011, 12.440078304000053],
        ],
        [
            [123.5828871110001, 12.663976723000076],
            [123.5858360520001, 12.654968434000068],
            [123.58523745200011, 12.652944208000065],
            [123.58191532400008, 12.658629566000059],
            [123.5828871110001, 12.663976723000076],
        ],
        [
            [123.59939508200011, 12.675254160000065],
            [123.60046525700011, 12.67434453800007],
            [123.59926307700005, 12.672020755000062],
            [123.59707075300003, 12.674606201000074],
            [123.59939508200011, 12.675254160000065],
        ],
        [
            [123.59627146500009, 12.686768877000077],
            [123.59619459400005, 12.680349097000033],
            [123.59485455200002, 12.677709452000045],
            [123.59209264300011, 12.681727737000074],
            [123.59627146500009, 12.686768877000077],
        ],
        [
            [123.61050583300005, 12.69372198700006],
            [123.61098575900007, 12.69329117600006],
            [123.6111057390001, 12.693021163000026],
            [123.61190060900003, 12.692452167000056],
            [123.6105948500001, 12.693012640000063],
            [123.61050583300005, 12.69372198700006],
        ],
        [
            [123.62186821400007, 12.693273987000055],
            [123.72540724800001, 12.614413507000052],
            [123.78968506800004, 12.338330529000075],
            [123.57921349800006, 12.630902190000029],
            [123.58181856500005, 12.653230361000055],
            [123.61487014000011, 12.633167626000045],
            [123.60924059000001, 12.638710580000065],
            [123.60909113500009, 12.658341905000043],
            [123.60117766000008, 12.677060892000043],
            [123.59853693700006, 12.677490110000065],
            [123.62186821400007, 12.693273987000055],
        ],
        [
            [123.35913251600005, 12.696587205000071],
            [123.35966139400011, 12.696443367000029],
            [123.35967981200008, 12.696188089000032],
            [123.35925596800007, 12.696171924000055],
            [123.35913251600005, 12.696587205000071],
        ],
        [
            [123.59937585000011, 12.708368291000056],
            [123.6001658880001, 12.708075934000021],
            [123.60002461200008, 12.70649525600004],
            [123.59888322600011, 12.708106835000024],
            [123.59937585000011, 12.708368291000056],
        ],
        [
            [123.60263864300009, 12.708531249000032],
            [123.60563846500008, 12.701707268000064],
            [123.61735045000012, 12.693648825000025],
            [123.60604299800002, 12.698549864000029],
            [123.60263864300009, 12.708531249000032],
        ],
        [
            [123.59936007100009, 12.711804992000054],
            [123.59916378600008, 12.711865412000066],
            [123.59872662200007, 12.712407316000053],
            [123.59933982600012, 12.712403140000049],
            [123.59936007100009, 12.711804992000054],
        ],
        [
            [123.59047324800008, 12.718076996000036],
            [123.59807814700002, 12.714886269000033],
            [123.59923135000008, 12.710220880000065],
            [123.59397295800011, 12.712722341000074],
            [123.59047324800008, 12.718076996000036],
        ],
        [
            [123.82792434300006, 12.838135203000036],
            [123.82767557700004, 12.837491921000037],
            [123.82664448600008, 12.836718936000068],
            [123.82649088800008, 12.837167243000067],
            [123.82792434300006, 12.838135203000036],
        ],
        [
            [123.80163155000002, 12.839801129000023],
            [123.82682861900003, 12.831451524000045],
            [123.82745018300011, 12.821061198000052],
            [123.79085481100003, 12.832256036000047],
            [123.80163155000002, 12.839801129000023],
        ],
        [
            [123.76522843000009, 12.836896252000031],
            [123.76384371300003, 12.840602561000026],
            [123.77029220300005, 12.850610388000064],
            [123.76932117400008, 12.841253508000023],
            [123.76522843000009, 12.836896252000031],
        ],
        [
            [124.15500572200006, 12.855206484000064],
            [124.15501003400004, 12.854677279000043],
            [124.15469267900005, 12.854380473000049],
            [124.15471995900009, 12.854905479000024],
            [124.15500572200006, 12.855206484000064],
        ],
        [
            [123.92100004800011, 12.856091160000062],
            [123.92186133000007, 12.856194715000072],
            [123.92196123800011, 12.85589471000003],
            [123.92028148300005, 12.85544172300007],
            [123.92100004800011, 12.856091160000062],
        ],
        [
            [124.1581793470001, 12.859109110000077],
            [124.15825660500002, 12.854629910000028],
            [124.15547574900006, 12.853142869000067],
            [124.156474935, 12.85577141400006],
            [124.15362032000007, 12.857506064000063],
            [124.1581793470001, 12.859109110000077],
        ],
        [
            [124.15229279400012, 12.862931640000056],
            [124.15274808800007, 12.862832299000047],
            [124.153583077, 12.862212180000029],
            [124.1518062780001, 12.86263839000003],
            [124.15229279400012, 12.862931640000056],
        ],
        [
            [123.99578946000008, 12.863448040000037],
            [123.99599014700004, 12.863387590000059],
            [123.99646982200011, 12.862598610000077],
            [123.99608639300004, 12.862563624000074],
            [123.99578946000008, 12.863448040000037],
        ],
        [
            [123.99068072700004, 12.864884553000024],
            [123.9905704040001, 12.864804291000041],
            [123.99020157000007, 12.864831582000022],
            [123.9905951070001, 12.865295498000023],
            [123.99068072700004, 12.864884553000024],
        ],
        [
            [123.90625585200007, 12.865584366000064],
            [123.91015110600006, 12.859137891000046],
            [123.90026289100001, 12.86064883000006],
            [123.89955903300006, 12.863394464000066],
            [123.90625585200007, 12.865584366000064],
        ],
        [
            [123.99176159800004, 12.865947325000036],
            [123.99133247700001, 12.865646692000041],
            [123.99161638600003, 12.86660904300004],
            [123.9918105480001, 12.866265458000044],
            [123.99176159800004, 12.865947325000036],
        ],
        [
            [123.81245450200004, 12.866580360000057],
            [123.8129476800001, 12.86598467300007],
            [123.812636945, 12.864415673000053],
            [123.81212264600003, 12.86433441400004],
            [123.81245450200004, 12.866580360000057],
        ],
        [
            [123.83077798600004, 12.86977857000005],
            [123.82998141300004, 12.870202296000059],
            [123.83068103900007, 12.871086696000077],
            [123.8314828130001, 12.870558537000022],
            [123.83077798600004, 12.86977857000005],
        ],
        [
            [123.80986549200009, 12.874120295000068],
            [123.81262364300005, 12.872317470000041],
            [123.81397165700002, 12.868550201000062],
            [123.81323530000009, 12.868768827000054],
            [123.80986549200009, 12.874120295000068],
        ],
        [
            [123.83534404700004, 12.87507671700007],
            [123.83708482500003, 12.875066053000069],
            [123.83910859500008, 12.873957836000045],
            [123.83431135300009, 12.874193816000059],
            [123.83534404700004, 12.87507671700007],
        ],
        [
            [123.98505761800004, 12.87690205000007],
            [123.98482956500004, 12.876346885000032],
            [123.9834829890001, 12.875766149000071],
            [123.98392871100009, 12.876336872000024],
            [123.98505761800004, 12.87690205000007],
        ],
        [
            [123.99008488400011, 12.877750394000032],
            [123.9892531160001, 12.877128957000025],
            [123.9886826180001, 12.877340072000038],
            [123.98971030400003, 12.878222829000038],
            [123.99008488400011, 12.877750394000032],
        ],
        [
            [123.84077289800007, 12.881679056000053],
            [123.84174939900004, 12.881224952000025],
            [123.84177566800008, 12.880767831000071],
            [123.83952343600004, 12.881666898000049],
            [123.84077289800007, 12.881679056000053],
        ],
        [
            [123.84324956900002, 12.88219226900003],
            [123.84344027700001, 12.881994882000072],
            [123.84259147900002, 12.881780948000028],
            [123.84289519300012, 12.882165916000076],
            [123.84324956900002, 12.88219226900003],
        ],
        [
            [123.83969424600002, 12.884048275000055],
            [123.83887832000005, 12.880991702000074],
            [123.836160876, 12.880781231000071],
            [123.83852139100009, 12.883936280000057],
            [123.83969424600002, 12.884048275000055],
        ],
        [
            [123.88664127200002, 12.888577431000044],
            [123.9021445940001, 12.880635960000063],
            [123.90368026300007, 12.868750742000032],
            [123.88767847500003, 12.869401653000068],
            [123.88664127200002, 12.888577431000044],
        ],
        [
            [122.95650886200008, 13.084753312000032],
            [122.95798844, 13.084121117000052],
            [122.95834278400002, 13.081939638000051],
            [122.95655863800005, 13.083395452000047],
            [122.95650886200008, 13.084753312000032],
        ],
        [
            [122.9666771420001, 13.127781305000042],
            [122.96728095800006, 13.126753885000028],
            [122.9671833540001, 13.126554157000044],
            [122.96628900400003, 13.127023191000035],
            [122.9666771420001, 13.127781305000042],
        ],
        [
            [122.95659245500008, 13.129159522000066],
            [122.95805525500009, 13.128631033000033],
            [122.95829503000004, 13.12751230200007],
            [122.95668537200004, 13.127796433000071],
            [122.95659245500008, 13.129159522000066],
        ],
        [
            [122.84623105000003, 13.140957448000051],
            [122.84376827100004, 13.142939253000065],
            [122.8433671900001, 13.144387506000044],
            [122.84715287800009, 13.142405359000065],
            [122.84623105000003, 13.140957448000051],
        ],
        [
            [122.84198824500004, 13.144849968000074],
            [122.8404952840001, 13.14610969100005],
            [122.84106883800007, 13.14712225900007],
            [122.84257526800002, 13.14640782500004],
            [122.84198824500004, 13.144849968000074],
        ],
        [
            [122.80115947500008, 13.151222006000069],
            [122.8001044340001, 13.151334449000046],
            [122.80038477700009, 13.152562461000059],
            [122.80169534600009, 13.15253828300007],
            [122.80115947500008, 13.151222006000069],
        ],
        [
            [122.97395349100009, 13.157007331000045],
            [122.97295563300008, 13.135810032000052],
            [122.94802993700011, 13.135676634000049],
            [122.94686681900009, 13.14157358400007],
            [122.97395349100009, 13.157007331000045],
        ],
        [
            [122.99475486600011, 13.159153355000058],
            [123.04525104200002, 13.134990616000039],
            [123.18210944500004, 12.913873201000058],
            [123.27747667300002, 12.888033419000067],
            [123.28711722300011, 12.819517405000056],
            [123.3852515320001, 12.693829220000055],
            [123.26248627400003, 12.83202254500003],
            [123.13816457400003, 12.892723879000073],
            [123.06431219500007, 12.999178631000063],
            [122.94530963000011, 13.02583938500004],
            [122.96031490200005, 13.08455516600003],
            [122.92848237800001, 13.113311209000074],
            [122.9805556010001, 13.116310911000028],
            [122.99475486600011, 13.159153355000058],
        ],
        [
            [123.19733214900009, 12.908746514000029],
            [123.19695662300012, 12.908770503000028],
            [123.1969682780001, 12.908280864000062],
            [123.19731409000008, 12.90851854500005],
            [123.19733214900009, 12.908746514000029],
        ],
        [
            [123.19643125400012, 12.908998325000027],
            [123.19641473900003, 12.909166885000047],
            [123.19610356400005, 12.908749409000052],
            [123.19641484800002, 12.908751092000045],
            [123.19643125400012, 12.908998325000027],
        ],
        [
            [124.20992349900007, 13.168713534000062],
            [124.21048056600011, 13.168639041000063],
            [124.21079850300009, 13.168394177000039],
            [124.20957409400012, 13.16810891700004],
            [124.20992349900007, 13.168713534000062],
        ],
        [
            [124.18889432000003, 13.171686258000022],
            [124.18926347500008, 13.17146017500005],
            [124.18923845400002, 13.171146350000072],
            [124.18864945200005, 13.171364317000041],
            [124.18889432000003, 13.171686258000022],
        ],
        [
            [124.18785530700006, 13.171797065000021],
            [124.1881474590001, 13.171553428000038],
            [124.18784951100008, 13.17124238200006],
            [124.18751367000004, 13.171557522000057],
            [124.18785530700006, 13.171797065000021],
        ],
        [
            [122.85868393300007, 13.173328260000062],
            [122.8954126430001, 13.146860223000033],
            [122.89409824100005, 13.140415548000021],
            [122.87121200100012, 13.144898635000061],
            [122.85868393300007, 13.173328260000062],
        ],
        [
            [124.16084526000009, 13.179988470000069],
            [124.1608711450001, 13.179665224000075],
            [124.16052267500004, 13.17970650500007],
            [124.160576837, 13.17988073400005],
            [124.16084526000009, 13.179988470000069],
        ],
        [
            [122.93724949300008, 13.180142449000073],
            [122.93830430600008, 13.178408685000022],
            [122.93691265400003, 13.175135872000055],
            [122.93588099800002, 13.178719651000051],
            [122.93724949300008, 13.180142449000073],
        ],
        [
            [124.12996460700003, 13.236063615000035],
            [124.20372810700007, 13.211022381000078],
            [124.2172576800001, 13.175823624000031],
            [124.05794307800011, 13.207199863000028],
            [124.12996460700003, 13.236063615000035],
        ],
        [
            [123.82836444600002, 13.27407736300006],
            [123.83243018900009, 13.273244758000033],
            [123.8364759970001, 13.270534564000059],
            [123.8287117320001, 13.267712585000027],
            [123.82836444600002, 13.27407736300006],
        ],
        [
            [124.00349956900004, 13.285731608000049],
            [124.00322678600003, 13.285856169000056],
            [124.00352946700002, 13.28607437200003],
            [124.00358645100005, 13.285877077000066],
            [124.00349956900004, 13.285731608000049],
        ],
        [
            [124.00323589400011, 13.287405813000078],
            [124.00404536600001, 13.287244630000032],
            [124.00228557700007, 13.286854511000058],
            [124.00257036700009, 13.287705574000029],
            [124.00323589400011, 13.287405813000078],
        ],
        [
            [123.97714792200009, 13.291574914000023],
            [123.98610884300001, 13.259304005000047],
            [124.0088068010001, 13.286971091000055],
            [124.0290307790001, 13.258254890000046],
            [124.04104753000001, 13.279274075000046],
            [124.09904918900008, 13.258836102000032],
            [124.022486264, 13.216940108000074],
            [123.95163429700006, 13.23359150500005],
            [123.90835664200006, 13.28616310600006],
            [123.97714792200009, 13.291574914000023],
        ],
        [
            [123.91044036000005, 13.298303051000062],
            [123.91139403200009, 13.296294628000055],
            [123.90984850000007, 13.295507782000072],
            [123.91013184200006, 13.292257421000045],
            [123.9094334460001, 13.291849157000058],
            [123.90829212500012, 13.296986353000023],
            [123.91044036000005, 13.298303051000062],
        ],
        [
            [123.96091560800005, 13.30800176400004],
            [123.96938286000011, 13.298010533000024],
            [123.95694489100003, 13.293284793000055],
            [123.95835651900006, 13.304157283000052],
            [123.96091560800005, 13.30800176400004],
        ],
        [
            [123.93797399700009, 13.32452051000007],
            [123.9455550350001, 13.319657066000048],
            [123.94863655800009, 13.306026274000033],
            [123.92704933000005, 13.306730870000024],
            [123.93797399700009, 13.32452051000007],
        ],
        [
            [123.85113006300003, 13.354361781000023],
            [123.93005976100005, 13.328011175000029],
            [123.88486362800006, 13.281197679000059],
            [123.91235179400007, 13.23732536600005],
            [123.88435276700011, 13.224412695000069],
            [123.83928254400007, 13.273055940000063],
            [123.85113006300003, 13.354361781000023],
        ],
        [
            [123.76555594700005, 13.407375745000024],
            [123.82677084000011, 13.367883475000042],
            [123.85172965100003, 13.368795910000074],
            [123.83276455200007, 13.34396765400004],
            [123.76555594700005, 13.407375745000024],
        ],
        [
            [124.3146233120001, 13.560866403000034],
            [124.31451889300001, 13.560633387000053],
            [124.31433664500003, 13.560643083000059],
            [124.31433289300003, 13.561082696000028],
            [124.3146233120001, 13.560866403000034],
        ],
        [
            [123.57045753200009, 13.59197215200004],
            [123.57862149900006, 13.583474477000038],
            [123.57751957700009, 13.580103475000044],
            [123.56414567000002, 13.584776911000063],
            [123.57045753200009, 13.59197215200004],
        ],
        [
            [124.34862442300005, 13.601609881000059],
            [124.34858742400002, 13.601835700000038],
            [124.34867812700008, 13.60195634400003],
            [124.34877679200008, 13.601848078000046],
            [124.34862442300005, 13.601609881000059],
        ],
        [
            [124.38309130200003, 13.64863136100007],
            [124.3828989640001, 13.648859737000066],
            [124.38333583000008, 13.649037403000023],
            [124.38336577500002, 13.648960774000045],
            [124.38309130200003, 13.64863136100007],
        ],
        [
            [124.38446814500003, 13.649237896000045],
            [124.38444602900006, 13.649081592000073],
            [124.38395234900008, 13.648716985000021],
            [124.383961913, 13.64914146700005],
            [124.38446814500003, 13.649237896000045],
        ],
        [
            [124.38387842000009, 13.649509272000046],
            [124.38375842100004, 13.648890194000046],
            [124.38343987700011, 13.64890252500004],
            [124.38380272000006, 13.64948783400007],
            [124.38387842000009, 13.649509272000046],
        ],
        [
            [124.38485628600006, 13.650069920000021],
            [124.38479784200001, 13.649680696000075],
            [124.38457069900005, 13.649437090000049],
            [124.38489263800011, 13.650405516000035],
            [124.38485628600006, 13.650069920000021],
        ],
        [
            [124.38838599700011, 13.652449602000047],
            [124.38864311400005, 13.652549065000073],
            [124.38809690300002, 13.652144615000054],
            [124.3883526840001, 13.652560797000035],
            [124.38838599700011, 13.652449602000047],
        ],
        [
            [124.38801539000008, 13.652633360000038],
            [124.3879171000001, 13.652279713000041],
            [124.38758885300001, 13.652342219000047],
            [124.3877376260001, 13.65259007900005],
            [124.38801539000008, 13.652633360000038],
        ],
        [
            [124.38880217200006, 13.652254389000063],
            [124.38876965100008, 13.652459871000076],
            [124.38895508200005, 13.65272297100006],
            [124.38894407500004, 13.65243186400005],
            [124.38880217200006, 13.652254389000063],
        ],
        [
            [124.3881215240001, 13.653037415000028],
            [124.38805404800007, 13.652818861000071],
            [124.38767401400003, 13.652763635000042],
            [124.38807224800007, 13.653150956000047],
            [124.3881215240001, 13.653037415000028],
        ],
        [
            [124.39687241500008, 13.653040473000033],
            [124.39675686100009, 13.653180719000034],
            [124.39688265900008, 13.653462902000058],
            [124.39699103300006, 13.653344946000061],
            [124.39687241500008, 13.653040473000033],
        ],
        [
            [124.40494067800012, 13.658887924000055],
            [124.40490818700005, 13.658613537000065],
            [124.40442385300003, 13.65844891200004],
            [124.40446278200011, 13.65866291900005],
            [124.40494067800012, 13.658887924000055],
        ],
        [
            [124.40611956200007, 13.660562015000039],
            [124.40605999700006, 13.660313750000057],
            [124.40570889300011, 13.660322890000032],
            [124.40623242000004, 13.660770679000052],
            [124.40611956200007, 13.660562015000039],
        ],
        [
            [124.4159883750001, 13.664455947000022],
            [124.41565183000012, 13.663741462000075],
            [124.41465651700003, 13.66393842900004],
            [124.41517282900008, 13.664367855000023],
            [124.4159883750001, 13.664455947000022],
        ],
        [
            [124.41661093400012, 13.667210877000059],
            [124.41683017600008, 13.667117670000039],
            [124.41655865100006, 13.66695343300006],
            [124.41651611100008, 13.667316737000021],
            [124.41661093400012, 13.667210877000059],
        ],
        [
            [124.40454649700007, 13.688166239000054],
            [124.40443104200006, 13.688351706000049],
            [124.40455071200006, 13.68847488800003],
            [124.40472611300004, 13.68828923500007],
            [124.40454649700007, 13.688166239000054],
        ],
        [
            [124.40444757600005, 13.688744555000028],
            [124.40434346900008, 13.689029461000075],
            [124.40449615900002, 13.689086779000036],
            [124.40449963000003, 13.688881108000032],
            [124.40444757600005, 13.688744555000028],
        ],
        [
            [124.40829350900003, 13.689115782000044],
            [124.40812967600004, 13.688752435000026],
            [124.40762365900002, 13.688735827000073],
            [124.40783777200011, 13.689057990000038],
            [124.40829350900003, 13.689115782000044],
        ],
        [
            [124.40339606300006, 13.688984764000054],
            [124.40349669900002, 13.689182006000067],
            [124.40382984100006, 13.689175264000028],
            [124.40372573500008, 13.689072428000031],
            [124.40339606300006, 13.688984764000054],
        ],
        [
            [124.39746966200005, 13.704160213000023],
            [124.397534145, 13.704031635000035],
            [124.3971674610001, 13.703952506000064],
            [124.3972549450001, 13.704144233000022],
            [124.39746966200005, 13.704160213000023],
        ],
        [
            [123.67064676000007, 13.703632614000071],
            [123.67145025400009, 13.703433045000054],
            [123.67158357400001, 13.702935338000032],
            [123.67024075900008, 13.702580090000026],
            [123.67064676000007, 13.703632614000071],
        ],
        [
            [124.39810544800002, 13.708722219000038],
            [124.39828456200007, 13.70868506100004],
            [124.39779576100011, 13.708372224000072],
            [124.39801727300005, 13.708701981000047],
            [124.39810544800002, 13.708722219000038],
        ],
        [
            [123.99613046500008, 13.713813539000057],
            [123.99786083900005, 13.713444647000074],
            [123.99874222500011, 13.71156643300003],
            [123.9948254740001, 13.71093305900007],
            [123.99613046500008, 13.713813539000057],
        ],
        [
            [123.97269580000011, 13.714360631000034],
            [123.97292701200001, 13.714262948000055],
            [123.97283907000008, 13.714038892000076],
            [123.9724295850001, 13.714201435000064],
            [123.97269580000011, 13.714360631000034],
        ],
        [
            [124.39607044600007, 13.715196442000035],
            [124.39601294900001, 13.714941232000058],
            [124.39573689500003, 13.714915316000031],
            [124.39571443400007, 13.71509482600004],
            [124.39607044600007, 13.715196442000035],
        ],
        [
            [124.00057222300006, 13.715141839000069],
            [124.00233313400008, 13.71328846800003],
            [124.00084385100001, 13.711527471000068],
            [123.9991442910001, 13.714319419000049],
            [124.00057222300006, 13.715141839000069],
        ],
        [
            [124.39552731300012, 13.71584372500007],
            [124.39542318800011, 13.715840212000046],
            [124.39559978400007, 13.71597926100003],
            [124.39561969500005, 13.715942660000053],
            [124.39552731300012, 13.71584372500007],
        ],
        [
            [124.39526155700003, 13.715960132000077],
            [124.39521260200002, 13.716065482000033],
            [124.39539430600007, 13.716121309000073],
            [124.39536674700003, 13.71600539700006],
            [124.39526155700003, 13.715960132000077],
        ],
        [
            [124.39737449000006, 13.71626830100007],
            [124.3971237940001, 13.715992570000026],
            [124.39669247400002, 13.716107951000026],
            [124.39714468200009, 13.716270188000067],
            [124.39737449000006, 13.71626830100007],
        ],
        [
            [123.98101578300009, 13.720365582000056],
            [123.98181619900004, 13.718987253000023],
            [123.98160656700009, 13.718730373000028],
            [123.98103531800007, 13.718997596000065],
            [123.98101578300009, 13.720365582000056],
        ],
        [
            [124.40021001100001, 13.720993974000066],
            [124.39965793800002, 13.717690892000064],
            [124.3949607620001, 13.716027100000076],
            [124.39361585300003, 13.718366819000039],
            [124.40021001100001, 13.720993974000066],
        ],
        [
            [123.97432337900011, 13.725662377000049],
            [123.97462735300007, 13.724722402000054],
            [123.97377035800002, 13.724392774000023],
            [123.97363613300001, 13.725587477000033],
            [123.97432337900011, 13.725662377000049],
        ],
        [
            [123.98165551700004, 13.727270672000031],
            [123.98283472600008, 13.726058540000054],
            [123.9818488190001, 13.725108096000042],
            [123.97978787200009, 13.726689823000072],
            [123.98165551700004, 13.727270672000031],
        ],
        [
            [123.25718903600011, 13.744963079000058],
            [123.25609454300002, 13.74465697900007],
            [123.25572991000001, 13.746274802000073],
            [123.2566598090001, 13.746288181000068],
            [123.25718903600011, 13.744963079000058],
        ],
        [
            [123.24460906600007, 13.748627179000039],
            [123.24654742100006, 13.746958930000062],
            [123.24425535400007, 13.741329940000071],
            [123.24236687600012, 13.74768281200005],
            [123.24460906600007, 13.748627179000039],
        ],
        [
            [124.40939164600002, 13.748894027000063],
            [124.40936646800003, 13.748312162000047],
            [124.40841507400012, 13.748671562000027],
            [124.40908205900007, 13.748583540000027],
            [124.40939164600002, 13.748894027000063],
        ],
        [
            [124.40866094000012, 13.749957747000053],
            [124.40831476100004, 13.749962234000066],
            [124.40824098100006, 13.750189463000027],
            [124.40855426700011, 13.750268490000053],
            [124.40866094000012, 13.749957747000053],
        ],
        [
            [124.40921069800004, 13.750605738000047],
            [124.4091552970001, 13.750444854000023],
            [124.40890723300004, 13.750576304000049],
            [124.40909905400008, 13.75072751600004],
            [124.40921069800004, 13.750605738000047],
        ],
        [
            [124.40988530100003, 13.752274942000042],
            [124.40998321500001, 13.752004126000031],
            [124.40946543000007, 13.752092787000038],
            [124.40948866400004, 13.752312018000055],
            [124.40988530100003, 13.752274942000042],
        ],
        [
            [123.95988657600003, 13.754176337000047],
            [123.96026804700011, 13.754112716000066],
            [123.96013098300011, 13.753767803000073],
            [123.95953059500005, 13.753956753000068],
            [123.95988657600003, 13.754176337000047],
        ],
        [
            [124.40520184200011, 13.76211395300004],
            [124.40511161100005, 13.761896064000041],
            [124.40503274000002, 13.76188774800005],
            [124.4051955970001, 13.762335747000066],
            [124.40520184200011, 13.76211395300004],
        ],
        [
            [124.41283846300007, 13.769662014000062],
            [124.41273458300009, 13.769655054000054],
            [124.41254944600007, 13.769738922000045],
            [124.4127200160001, 13.76991516000004],
            [124.41283846300007, 13.769662014000062],
        ],
        [
            [123.99250995200009, 13.770974084000045],
            [123.99205635100009, 13.770871845000045],
            [123.99227836800003, 13.771381187000031],
            [123.99253674800002, 13.771269651000068],
            [123.99250995200009, 13.770974084000045],
        ],
        [
            [123.27092246400002, 13.768776982000077],
            [123.26882273700005, 13.769509320000054],
            [123.2675887360001, 13.771399689000077],
            [123.27054589300008, 13.770716496000034],
            [123.27092246400002, 13.768776982000077],
        ],
        [
            [124.40557721200003, 13.773405061000062],
            [124.41240814800005, 13.770609984000032],
            [124.41108960300005, 13.766775128000063],
            [124.40472870200006, 13.769591534000028],
            [124.40557721200003, 13.773405061000062],
        ],
        [
            [124.40901174100009, 13.771596983000052],
            [124.40901974300004, 13.771729873000027],
            [124.40892943500012, 13.771770225000068],
            [124.40887450000002, 13.771637524000027],
            [124.40901174100009, 13.771596983000052],
        ],
        [
            [123.9907766770001, 13.776403965000043],
            [123.99286698300011, 13.774994913000057],
            [123.9919435060001, 13.771503946000053],
            [123.99012373300002, 13.773240758000043],
            [123.9907766770001, 13.776403965000043],
        ],
        [
            [124.4241534030001, 13.777027438000061],
            [124.42398589600009, 13.77693714700007],
            [124.42408942300005, 13.777259874000038],
            [124.42416218900007, 13.777224837000063],
            [124.4241534030001, 13.777027438000061],
        ],
        [
            [123.27843214100005, 13.776917067000056],
            [123.272314993, 13.77364218300005],
            [123.26829770300003, 13.77528746300004],
            [123.27636432300005, 13.777358297000035],
            [123.27843214100005, 13.776917067000056],
        ],
        [
            [123.94919789000005, 13.778206517000058],
            [123.9543368410001, 13.776498247000063],
            [123.953649057, 13.77367468600005],
            [123.94762939000009, 13.77385255400003],
            [123.94919789000005, 13.778206517000058],
        ],
        [
            [124.4233199030001, 13.778640462000055],
            [124.42362604900006, 13.778207080000072],
            [124.42278294300002, 13.778191932000027],
            [124.42305133800005, 13.778657792000047],
            [124.4233199030001, 13.778640462000055],
        ],
        [
            [124.42227820700009, 13.778775864000067],
            [124.42257827700007, 13.777854260000026],
            [124.42393348200005, 13.77725478700006],
            [124.42312778900009, 13.776059046000057],
            [124.42227820700009, 13.778775864000067],
        ],
        [
            [124.42108800500012, 13.782139805000043],
            [124.4209579730001, 13.781844577000072],
            [124.42066243600004, 13.782057794000025],
            [124.42096810200007, 13.782215251000025],
            [124.42108800500012, 13.782139805000043],
        ],
        [
            [124.42038736400002, 13.782706607000023],
            [124.42093790600006, 13.782427787000074],
            [124.42086360300004, 13.782281813000054],
            [124.41986890800001, 13.782631153000068],
            [124.42038736400002, 13.782706607000023],
        ],
        [
            [124.42015262100006, 13.782862418000036],
            [124.42023199400012, 13.78284929800003],
            [124.42044984800009, 13.782742691000067],
            [124.42027252700007, 13.782723007000072],
            [124.42015262100006, 13.782862418000036],
        ],
        [
            [124.42037554, 13.782905066000069],
            [124.42090750500006, 13.782900150000046],
            [124.42102234300012, 13.782783700000039],
            [124.42011884400006, 13.782934585000078],
            [124.42037554, 13.782905066000069],
        ],
        [
            [123.98638668700005, 13.784085297000047],
            [123.9864144500001, 13.783948701000043],
            [123.9862478980001, 13.783752790000051],
            [123.98614425700009, 13.784083494000072],
            [123.98638668700005, 13.784085297000047],
        ],
        [
            [122.75709725500008, 13.783916821000048],
            [122.7579272050001, 13.783989139000028],
            [122.75817308, 13.783734111000058],
            [122.75704066800006, 13.782973587000072],
            [122.75709725500008, 13.783916821000048],
        ],
        [
            [122.74335498500011, 13.78309656500005],
            [122.73558266400005, 13.775818688000072],
            [122.72391998500007, 13.779136168000036],
            [122.73397766700009, 13.782878863000064],
            [122.74335498500011, 13.78309656500005],
        ],
        [
            [124.42080380800007, 13.78437195600003],
            [124.42128982700001, 13.783385863000035],
            [124.42000717600001, 13.783061556000064],
            [124.41995481600009, 13.783589685000038],
            [124.42080380800007, 13.78437195600003],
        ],
        [
            [124.418862622, 13.784854289000066],
            [124.41903846200012, 13.784842878000063],
            [124.41939517600008, 13.784543264000035],
            [124.4190676930001, 13.784494363000022],
            [124.418862622, 13.784854289000066],
        ],
        [
            [124.41866619400002, 13.785124663000033],
            [124.41880630000003, 13.785049617000027],
            [124.41879497500008, 13.784949676000053],
            [124.41847992200007, 13.785099297000045],
            [124.41866619400002, 13.785124663000033],
        ],
        [
            [122.76255567400005, 13.785412434000023],
            [122.76339847200006, 13.784631571000034],
            [122.76219707200005, 13.784053881000034],
            [122.76157730000011, 13.784629213000073],
            [122.76255567400005, 13.785412434000023],
        ],
        [
            [122.76521076400002, 13.785828079000055],
            [122.76478443400003, 13.785571926000046],
            [122.7640497650001, 13.785662252000066],
            [122.76417570700005, 13.785786013000063],
            [122.76521076400002, 13.785828079000055],
        ],
        [
            [124.41809952400001, 13.78600767000006],
            [124.41828611200003, 13.785885277000034],
            [124.41792238900007, 13.785845829000039],
            [124.41799171700006, 13.786059948000059],
            [124.41809952400001, 13.78600767000006],
        ],
        [
            [124.41836050300003, 13.786185122000063],
            [124.41833312000006, 13.786140441000043],
            [124.41812572700007, 13.786084609000056],
            [124.41816771000003, 13.786188627000058],
            [124.41836050300003, 13.786185122000063],
        ],
        [
            [124.4182220460001, 13.787036864000072],
            [124.41817271200011, 13.787195650000058],
            [124.41822585200009, 13.787285688000054],
            [124.4182547470001, 13.78712418300006],
            [124.4182220460001, 13.787036864000072],
        ],
        [
            [124.4183431460001, 13.78729860900006],
            [124.4183564650001, 13.787158527000031],
            [124.41829074600003, 13.787131647000024],
            [124.41828601200007, 13.787286849000054],
            [124.4183431460001, 13.78729860900006],
        ],
        [
            [122.75965664700004, 13.787437860000068],
            [122.76003633300002, 13.78705928100004],
            [122.759110372, 13.787165763000075],
            [122.7591870760001, 13.787341479000077],
            [122.75965664700004, 13.787437860000068],
        ],
        [
            [124.42049350600007, 13.789933850000068],
            [124.4208526650001, 13.789873563000071],
            [124.42013309700008, 13.789841984000077],
            [124.42036467000003, 13.789986877000047],
            [124.42049350600007, 13.789933850000068],
        ],
        [
            [124.4200922330001, 13.790611386000023],
            [124.42040392100012, 13.790584329000069],
            [124.42036735500005, 13.790104064000047],
            [124.41960990100006, 13.790487936000034],
            [124.4200922330001, 13.790611386000023],
        ],
        [
            [123.98726291300011, 13.793959985000072],
            [123.9904433260001, 13.786557962000074],
            [123.988753169, 13.782609145000038],
            [123.98628154700009, 13.784284797000055],
            [123.98417435100009, 13.784881446000043],
            [123.98726291300011, 13.793959985000072],
        ],
        [
            [124.4235809170001, 13.796551634000025],
            [124.42334706100007, 13.796548441000027],
            [124.42321009800003, 13.796857604000024],
            [124.42346114200006, 13.796726660000047],
            [124.4235809170001, 13.796551634000025],
        ],
        [
            [124.42281025200009, 13.79693336400004],
            [124.42306828000005, 13.796708113000022],
            [124.4221767890001, 13.796764758000052],
            [124.42264975300009, 13.797029046000034],
            [124.42281025200009, 13.79693336400004],
        ],
        [
            [124.42337571400003, 13.797065270000076],
            [124.42349463300002, 13.797098549000054],
            [124.42359627100006, 13.796943958000043],
            [124.42336882400002, 13.796963860000062],
            [124.42328792, 13.797119628000075],
            [124.42337571400003, 13.797065270000076],
        ],
        [
            [124.4235890550001, 13.797300905000043],
            [124.42371725900011, 13.797287991000076],
            [124.42378931600001, 13.797106463000034],
            [124.42337501100008, 13.797271057000046],
            [124.4235890550001, 13.797300905000043],
        ],
        [
            [124.42242532900002, 13.806516147000025],
            [124.42286129700005, 13.805715356000064],
            [124.42371826900012, 13.806441422000034],
            [124.42485928100007, 13.804563673000075],
            [124.42227812700003, 13.80467892200005],
            [124.42242532900002, 13.806516147000025],
        ],
        [
            [124.4224288900001, 13.806833245000064],
            [124.42281605500011, 13.806563703000052],
            [124.4227674760001, 13.806303891000027],
            [124.42219565000005, 13.806811415000027],
            [124.4224288900001, 13.806833245000064],
        ],
        [
            [123.90913597600002, 13.810434822000047],
            [123.90903783800002, 13.81008937200005],
            [123.9080181700001, 13.809592052000028],
            [123.90823437200004, 13.81000748200006],
            [123.90913597600002, 13.810434822000047],
        ],
        [
            [123.90658256800009, 13.812573678000035],
            [123.90785850800012, 13.812046319000046],
            [123.90802342900008, 13.811500590000037],
            [123.90599647300007, 13.811309810000068],
            [123.90658256800009, 13.812573678000035],
        ],
        [
            [123.85605216400006, 13.823423818000037],
            [123.85719702600011, 13.82063850700007],
            [123.85438997100005, 13.819093590000023],
            [123.8535425560001, 13.823177092000037],
            [123.85605216400006, 13.823423818000037],
        ],
        [
            [123.84920593700008, 13.842840163000062],
            [123.85292442900004, 13.83846705600007],
            [123.84976742100002, 13.827538984000057],
            [123.83923195700004, 13.837867402000029],
            [123.84920593700008, 13.842840163000062],
        ],
        [
            [123.80563685600009, 13.845292967000034],
            [123.80646355800002, 13.84427886800006],
            [123.80360773300004, 13.842773625000063],
            [123.80490201700002, 13.845169141000042],
            [123.80563685600009, 13.845292967000034],
        ],
        [
            [123.84095017000004, 13.847884050000062],
            [123.84274199000004, 13.846524785000042],
            [123.83981952700003, 13.842041786000038],
            [123.83742293900002, 13.84487970300006],
            [123.84095017000004, 13.847884050000062],
        ],
        [
            [123.84012643900007, 13.850113301000022],
            [123.84059892300002, 13.849984093000046],
            [123.83945333300005, 13.849537431000044],
            [123.83954399900006, 13.849797359000036],
            [123.84012643900007, 13.850113301000022],
        ],
        [
            [124.41352612900005, 13.85897959500005],
            [124.41462214500007, 13.859118109000065],
            [124.41423203500005, 13.858816583000078],
            [124.4124324820001, 13.858097285000042],
            [124.41231623400006, 13.858148371000027],
            [124.41352612900005, 13.85897959500005],
        ],
        [
            [124.41531511700009, 13.859389773000032],
            [124.4148112790001, 13.858956616000057],
            [124.41474402200004, 13.85901031000003],
            [124.41496464600004, 13.859339404000025],
            [124.41531511700009, 13.859389773000032],
        ],
        [
            [124.41471346100002, 13.85937060200007],
            [124.41436117800004, 13.859111508000069],
            [124.41416590300003, 13.859243634000052],
            [124.41445788900012, 13.859554611000021],
            [124.41471346100002, 13.85937060200007],
        ],
        [
            [123.81170838300011, 13.859375883000041],
            [123.81127971600006, 13.859699798000065],
            [123.811603364, 13.860640368000077],
            [123.81198864600003, 13.860007137000025],
            [123.81170838300011, 13.859375883000041],
        ],
        [
            [123.79967212000008, 13.861433431000023],
            [123.79957164000007, 13.860120321000068],
            [123.79804076300002, 13.861484507000057],
            [123.79918111300003, 13.861734934000026],
            [123.79967212000008, 13.861433431000023],
        ],
        [
            [123.82089754200001, 13.863826305000032],
            [123.82260071300004, 13.861812193000048],
            [123.82255163000002, 13.861051898000028],
            [123.82002811600012, 13.86187138200006],
            [123.82089754200001, 13.863826305000032],
        ],
        [
            [123.86915704700004, 13.864875833000042],
            [123.87122006800007, 13.864946674000066],
            [123.87170792800009, 13.864714304000074],
            [123.86921135000011, 13.862821170000075],
            [123.86703934900004, 13.863676210000051],
            [123.86915704700004, 13.864875833000042],
        ],
        [
            [124.41439942000011, 13.865133866000065],
            [124.41432374200008, 13.865464283000051],
            [124.41449199800002, 13.865540616000033],
            [124.41454267200004, 13.865192428000057],
            [124.41439942000011, 13.865133866000065],
        ],
        [
            [124.41484004300003, 13.865620944000057],
            [124.41520474200001, 13.865538614000059],
            [124.4152942500001, 13.865328386000044],
            [124.41466242400008, 13.865439181000056],
            [124.41484004300003, 13.865620944000057],
        ],
        [
            [124.41422424100006, 13.86653737100005],
            [124.4141606390001, 13.866960816000073],
            [124.41422494000005, 13.867157002000056],
            [124.41439216600008, 13.866765907000058],
            [124.41422424100006, 13.86653737100005],
        ],
        [
            [123.85646453200002, 13.867024356000059],
            [123.86265176500001, 13.864131650000047],
            [123.85584492700002, 13.859071936000078],
            [123.85347509600001, 13.865358756000035],
            [123.85646453200002, 13.867024356000059],
        ],
        [
            [123.76376728700006, 13.870460112000046],
            [123.76522634700007, 13.868568443000072],
            [123.76126835500008, 13.867493546000048],
            [123.76123754000002, 13.869836645000078],
            [123.76376728700006, 13.870460112000046],
        ],
        [
            [123.7840969450001, 13.873143047000042],
            [123.78375554200011, 13.874009458000046],
            [123.78397727800007, 13.87432900400006],
            [123.78436897000006, 13.873441505000073],
            [123.7840969450001, 13.873143047000042],
        ],
        [
            [123.83848246900004, 13.875109069000075],
            [123.84092302900001, 13.872415291000038],
            [123.83939395400012, 13.86668996900005],
            [123.83695403600007, 13.86988715800004],
            [123.83848246900004, 13.875109069000075],
        ],
        [
            [123.80642105400011, 13.87457403600007],
            [123.80942674100004, 13.873924411000075],
            [123.80773117000001, 13.870941386000027],
            [123.80448812300006, 13.87470386800004],
            [123.80642105400011, 13.87457403600007],
        ],
        [
            [123.83151093400011, 13.881220579000058],
            [123.8358487160001, 13.874975641000049],
            [123.833236112, 13.869508732000043],
            [123.82413977700003, 13.873485689000063],
            [123.83151093400011, 13.881220579000058],
        ],
        [
            [123.85581675300011, 13.882684672000039],
            [123.85902453200003, 13.881886307000059],
            [123.84947884700011, 13.85669990100007],
            [123.84061612900007, 13.865079422000065],
            [123.85581675300011, 13.882684672000039],
        ],
        [
            [124.40383120700005, 13.885407905000022],
            [124.40399171700005, 13.885118784000042],
            [124.40397031600003, 13.885046071000033],
            [124.40375630800008, 13.885179375000064],
            [124.40383120700005, 13.885407905000022],
        ],
        [
            [124.40349949200004, 13.885558521000064],
            [124.40358153900002, 13.884863480000035],
            [124.40324448700005, 13.884390837000069],
            [124.40301083200006, 13.886065598000073],
            [124.40349949200004, 13.885558521000064],
        ],
        [
            [123.83865319300003, 13.885522738000077],
            [123.84149077400002, 13.886095391000026],
            [123.83674271100006, 13.87706978600005],
            [123.83537503200012, 13.885592384000063],
            [123.83865319300003, 13.885522738000077],
        ],
        [
            [123.85660977700002, 13.88691420400005],
            [123.8561936000001, 13.885767294000061],
            [123.84905462100005, 13.882165589000067],
            [123.8486161840001, 13.882653491000042],
            [123.85660977700002, 13.88691420400005],
        ],
        [
            [123.7871080330001, 13.89075684900007],
            [123.796351608, 13.873456012000076],
            [123.78984574900005, 13.867817961000071],
            [123.77918830900012, 13.884901676000027],
            [123.7871080330001, 13.89075684900007],
        ],
        [
            [123.61038056500001, 13.895154657000035],
            [123.60982425300006, 13.894528422000064],
            [123.6093900410001, 13.894823262000045],
            [123.60975769100003, 13.895606759000032],
            [123.61038056500001, 13.895154657000035],
        ],
        [
            [124.3956606270001, 13.897473299000069],
            [124.39599821200011, 13.897268075000056],
            [124.39518447300009, 13.897345649000044],
            [124.39540300400006, 13.89747501200003],
            [124.3956606270001, 13.897473299000069],
        ],
        [
            [123.62685197000008, 13.897948068000062],
            [123.62843897700009, 13.89664846100004],
            [123.62881477000008, 13.895378278000067],
            [123.62638877400002, 13.896653190000052],
            [123.62685197000008, 13.897948068000062],
        ],
        [
            [124.39588520300003, 13.89864816000005],
            [124.39597696600003, 13.89838906700004],
            [124.395624956, 13.898795509000024],
            [124.39573338800005, 13.898818185000039],
            [124.39588520300003, 13.89864816000005],
        ],
        [
            [124.39417373700007, 13.899150871000074],
            [124.39541654800007, 13.898567920000062],
            [124.39488064400007, 13.897569844000031],
            [124.39563855900008, 13.896604375000038],
            [124.3930845970001, 13.893737196000075],
            [124.39417373700007, 13.899150871000074],
        ],
        [
            [124.395211216, 13.899308825000048],
            [124.39546145000008, 13.899227869000072],
            [124.39560659500012, 13.89899630800005],
            [124.39506443300002, 13.898944463000078],
            [124.395211216, 13.899308825000048],
        ],
        [
            [124.39478581800006, 13.899399488000029],
            [124.39499769300005, 13.899166311000045],
            [124.39498101600009, 13.899077246000047],
            [124.39466738700003, 13.899195443000053],
            [124.39478581800006, 13.899399488000029],
        ],
        [
            [124.39550980900003, 13.89959060800004],
            [124.39583513200012, 13.899146920000021],
            [124.39497432600001, 13.89940273600007],
            [124.39511110900003, 13.899580872000058],
            [124.39550980900003, 13.89959060800004],
        ],
        [
            [123.62909953100007, 13.900760153000022],
            [123.63260364300004, 13.900394608000056],
            [123.63313946400001, 13.899152316000027],
            [123.62842416, 13.898891392000053],
            [123.62909953100007, 13.900760153000022],
        ],
        [
            [123.62558468300006, 13.902438545000052],
            [123.62789922600007, 13.902439077000054],
            [123.6282476240001, 13.901762571000063],
            [123.624650287, 13.902191825000045],
            [123.62558468300006, 13.902438545000052],
        ],
        [
            [123.63787411800001, 13.906964940000023],
            [123.63694472200007, 13.90516053400006],
            [123.63531959200009, 13.905698770000072],
            [123.63647403000004, 13.905943742000034],
            [123.63787411800001, 13.906964940000023],
        ],
        [
            [123.63913898800001, 13.90774032400003],
            [123.6388450930001, 13.90717440900005],
            [123.63831428600008, 13.90700081500006],
            [123.63833992100001, 13.907233133000034],
            [123.63913898800001, 13.90774032400003],
        ],
        [
            [123.5768179580001, 13.91589286900006],
            [123.57752371200002, 13.915052873000036],
            [123.57648255200002, 13.913726974000042],
            [123.5757725420001, 13.914999235000039],
            [123.5768179580001, 13.91589286900006],
        ],
        [
            [124.30520214900002, 13.922794140000065],
            [124.30521083000008, 13.921899967000058],
            [124.30411736300005, 13.922396664000075],
            [124.30423868600008, 13.922522926000056],
            [124.30520214900002, 13.922794140000065],
        ],
        [
            [123.55279105500006, 13.931978155000024],
            [123.55062450700007, 13.93074721000005],
            [123.55005531800009, 13.93115623600005],
            [123.55078914800004, 13.931939795000062],
            [123.55279105500006, 13.931978155000024],
        ],
        [
            [123.44604134800011, 13.93147689400007],
            [123.44550550300005, 13.931932909000068],
            [123.44593297200004, 13.932464099000072],
            [123.44625049100011, 13.932098426000039],
            [123.44604134800011, 13.93147689400007],
        ],
        [
            [123.58214578900004, 13.932904688000065],
            [123.599424397, 13.92379941300004],
            [123.59600703500007, 13.916317844000048],
            [123.57808987200008, 13.927892113000041],
            [123.58214578900004, 13.932904688000065],
        ],
        [
            [123.44538313400005, 13.935818854000047],
            [123.4450924140001, 13.935531367000067],
            [123.44494075600005, 13.935877033000054],
            [123.44524331600007, 13.936069087000021],
            [123.44538313400005, 13.935818854000047],
        ],
        [
            [124.32785336900008, 13.936339815000053],
            [124.3286988320001, 13.936130502000026],
            [124.32870089800008, 13.93560950400007],
            [124.32720264900001, 13.935449362000043],
            [124.32785336900008, 13.936339815000053],
        ],
        [
            [123.44519178700011, 13.940773271000069],
            [123.4455148290001, 13.94063045300004],
            [123.44548236300011, 13.940450848000069],
            [123.44514444700008, 13.940372701000058],
            [123.44519178700011, 13.940773271000069],
        ],
        [
            [123.31702606100009, 13.941336343000046],
            [123.31717963100004, 13.940642166000032],
            [123.31611927200004, 13.940091256000073],
            [123.31604513200011, 13.940279025000052],
            [123.31702606100009, 13.941336343000046],
        ],
        [
            [123.42233417800003, 13.942653255000039],
            [123.42288955200002, 13.942734150000035],
            [123.42152616900012, 13.941962143000069],
            [123.42094208100002, 13.94224293700006],
            [123.42233417800003, 13.942653255000039],
        ],
        [
            [123.42316661900009, 13.942863418000059],
            [123.42304004900006, 13.942971691000025],
            [123.42300831000011, 13.943389667000076],
            [123.42315512900007, 13.943263348000073],
            [123.42316661900009, 13.942863418000059],
        ],
        [
            [123.31830460300012, 13.948687991000043],
            [123.31884623600001, 13.948194871000055],
            [123.31911704000004, 13.94742496400005],
            [123.31860656200001, 13.947752940000044],
            [123.31830460300012, 13.948687991000043],
        ],
        [
            [123.41688266500012, 13.948884675000045],
            [123.41667990500002, 13.948694696000075],
            [123.41622627400011, 13.948870544000044],
            [123.41669703500008, 13.949175701000058],
            [123.41688266500012, 13.948884675000045],
        ],
        [
            [123.41645784500008, 13.949494394000055],
            [123.41625161700006, 13.94915491100005],
            [123.41557041300007, 13.949524311000062],
            [123.4161850810001, 13.949709107000047],
            [123.41645784500008, 13.949494394000055],
        ],
        [
            [123.41969230600012, 13.949906679000037],
            [123.42088424200006, 13.947843449000061],
            [123.4194596850001, 13.94708425500005],
            [123.41862756400008, 13.94893963900006],
            [123.41969230600012, 13.949906679000037],
        ],
        [
            [123.85199347600008, 13.950391786000068],
            [123.84805204600002, 13.946469532000037],
            [123.84393129400007, 13.947188308000023],
            [123.84749070400005, 13.949749556000029],
            [123.85199347600008, 13.950391786000068],
        ],
        [
            [123.44435347300009, 13.951007211000046],
            [123.44460249200006, 13.950728340000069],
            [123.44446388500012, 13.950567182000043],
            [123.44413923600007, 13.951044158000059],
            [123.4442604840001, 13.95136659600007],
            [123.44435347300009, 13.951007211000046],
        ],
        [
            [124.340983348, 13.951874554000028],
            [124.34112310900002, 13.951711185000022],
            [124.34074354400002, 13.951785151000024],
            [124.34087535300011, 13.951913082000033],
            [124.340983348, 13.951874554000028],
        ],
        [
            [123.33060879300001, 13.953627828000037],
            [123.33193906000008, 13.953406660000041],
            [123.3298847960001, 13.952218836000043],
            [123.32974885100009, 13.952879903000053],
            [123.33060879300001, 13.953627828000037],
        ],
        [
            [123.326267045, 13.956891343000052],
            [123.32568310500005, 13.954359252000074],
            [123.32534692000002, 13.954169445000048],
            [123.32545089400003, 13.95540327200007],
            [123.326267045, 13.956891343000052],
        ],
        [
            [123.24870053500001, 13.95840645900006],
            [123.24969372700002, 13.95804402500005],
            [123.25193807200003, 13.954111392000073],
            [123.24963724000008, 13.956118085000071],
            [123.24870053500001, 13.95840645900006],
        ],
        [
            [124.35147613600009, 13.958574617000068],
            [124.35233135900012, 13.957859108000036],
            [124.35189886, 13.957133388000045],
            [124.35080211200011, 13.957918152000047],
            [124.35147613600009, 13.958574617000068],
        ],
        [
            [123.51522727400004, 13.958827080000049],
            [123.51580438400003, 13.957692227000052],
            [123.51221881700008, 13.952794530000062],
            [123.5122257480001, 13.957754635000072],
            [123.51522727400004, 13.958827080000049],
        ],
        [
            [123.54053333800005, 13.959135460000027],
            [123.53736303700009, 13.95482729400004],
            [123.53388869600008, 13.954759155000033],
            [123.53678220800009, 13.958198049000032],
            [123.54053333800005, 13.959135460000027],
        ],
        [
            [123.2518813800001, 13.960828777000074],
            [123.252727649, 13.958852752000041],
            [123.25461415500001, 13.956931778000069],
            [123.24998767500006, 13.957813144000056],
            [123.2518813800001, 13.960828777000074],
        ],
        [
            [123.81296659800012, 13.961182188000066],
            [123.81464549100008, 13.95934950800006],
            [123.81431990200008, 13.95808143000005],
            [123.81230325000001, 13.959407105000025],
            [123.81296659800012, 13.961182188000066],
        ],
        [
            [123.78210449200003, 13.96087646500007],
            [123.78112793000003, 13.960083008000026],
            [123.77850341800001, 13.961914063000052],
            [123.78070068400007, 13.962707520000038],
            [123.78210449200003, 13.96087646500007],
        ],
        [
            [123.25277054900005, 13.962954825000054],
            [123.25349465800002, 13.961680127000022],
            [123.25333299700003, 13.961480751000067],
            [123.25230577100001, 13.96169973900004],
            [123.25277054900005, 13.962954825000054],
        ],
        [
            [123.46154256800003, 13.963244469000074],
            [123.4615089780001, 13.96301819000007],
            [123.45999043100005, 13.962174214000072],
            [123.4600828, 13.963083050000023],
            [123.46154256800003, 13.963244469000074],
        ],
        [
            [123.44606550700007, 13.965575716000046],
            [123.44644781900001, 13.963932186000022],
            [123.44319084500012, 13.963461089000077],
            [123.44411249100006, 13.965066627000056],
            [123.44606550700007, 13.965575716000046],
        ],
        [
            [124.30376164600011, 13.966369587000031],
            [124.30617625200011, 13.960132677000047],
            [124.29891785600012, 13.953062138000064],
            [124.29905463600005, 13.963529871000048],
            [124.30376164600011, 13.966369587000031],
        ],
        [
            [123.7039184570001, 13.965087891000053],
            [123.7022705070001, 13.965087891000053],
            [123.70190429600007, 13.965270997000061],
            [123.70410156200012, 13.966674805000025],
            [123.7039184570001, 13.965087891000053],
        ],
        [
            [123.85915545400007, 13.967098689000068],
            [123.87063490100002, 13.95352235200005],
            [123.872103207, 13.94880542900006],
            [123.85744651200002, 13.949015211000074],
            [123.85915545400007, 13.967098689000068],
        ],
        [
            [123.52320078800005, 13.967517205000036],
            [123.52280578200009, 13.96411474000007],
            [123.51801909500011, 13.962504999000032],
            [123.51732751700001, 13.965870546000076],
            [123.52320078800005, 13.967517205000036],
        ],
        [
            [123.44877095800007, 13.968355968000026],
            [123.448827058, 13.967254586000024],
            [123.44812171100011, 13.966786261000038],
            [123.44784079500005, 13.968055390000075],
            [123.44877095800007, 13.968355968000026],
        ],
        [
            [123.81179466100002, 13.968794367000044],
            [123.81348455600005, 13.967777142000045],
            [123.81365765500004, 13.965612431000068],
            [123.81153355900005, 13.96769641800006],
            [123.81179466100002, 13.968794367000044],
        ],
        [
            [123.5652671260001, 13.968545566000046],
            [123.56681981700001, 13.967381687000056],
            [123.56319305900001, 13.967006352000055],
            [123.56366633800008, 13.968726078000032],
            [123.5652671260001, 13.968545566000046],
        ],
        [
            [123.44902128400008, 13.969134841000027],
            [123.44933422100007, 13.96883770200003],
            [123.4489105670001, 13.968517228000053],
            [123.44851647200005, 13.968862272000024],
            [123.44902128400008, 13.969134841000027],
        ],
        [
            [123.44788630800008, 13.969531127000039],
            [123.4483412940001, 13.96917759300004],
            [123.44805368900006, 13.968564340000057],
            [123.4477484030001, 13.96933987500006],
            [123.44788630800008, 13.969531127000039],
        ],
        [
            [123.57775347900008, 13.969881650000048],
            [123.57028040800003, 13.944343659000026],
            [123.57484006400011, 13.93125492200005],
            [123.556227669, 13.955167328000073],
            [123.57775347900008, 13.969881650000048],
        ],
        [
            [123.2236998080001, 13.970327194000049],
            [123.23404473000005, 13.966265046000046],
            [123.23344963700004, 13.963580314000069],
            [123.22940876300004, 13.963967126000057],
            [123.2236998080001, 13.970327194000049],
        ],
        [
            [123.774902343, 13.973327637000068],
            [123.77349853500004, 13.973510743000077],
            [123.77410888700001, 13.97491455100004],
            [123.77508544900002, 13.97491455100004],
            [123.774902343, 13.973327637000068],
        ],
        [
            [123.55014729600009, 13.97710130300004],
            [123.557826943, 13.971166208000056],
            [123.55739497800005, 13.968286426000077],
            [123.54751192600008, 13.97402904300003],
            [123.55014729600009, 13.97710130300004],
        ],
        [
            [123.54613936400006, 13.977664598000047],
            [123.54450414500002, 13.973826763000034],
            [123.53931160900004, 13.975608692000037],
            [123.54026082300004, 13.976768583000023],
            [123.54613936400006, 13.977664598000047],
        ],
        [
            [123.81795992900004, 13.978474025000025],
            [123.83973412800003, 13.969629663000035],
            [123.83160873200006, 13.889459657000032],
            [123.81153692100008, 13.912345366000068],
            [123.81795992900004, 13.978474025000025],
        ],
        [
            [123.4007877140001, 13.980242696000062],
            [123.40096764800012, 13.978814468000053],
            [123.39992656600009, 13.978425509000033],
            [123.39985632000003, 13.979773486000056],
            [123.4007877140001, 13.980242696000062],
        ],
        [
            [123.40040422700008, 13.981143486000065],
            [123.4006976180001, 13.980408256000032],
            [123.39996266600008, 13.980253753000056],
            [123.39993418100005, 13.98061960900003],
            [123.40040422700008, 13.981143486000065],
        ],
        [
            [123.81787109400011, 13.980102539000029],
            [123.81707763600002, 13.980712890000063],
            [123.81811523400006, 13.981689453000058],
            [123.81848144500009, 13.980712890000063],
            [123.81787109400011, 13.980102539000029],
        ],
        [
            [123.64427264900007, 13.978375624000023],
            [123.66964736700004, 13.966581578000046],
            [123.67781324200007, 13.942650682000021],
            [123.62515324000003, 13.907007735000036],
            [123.601371459, 13.91421594600007],
            [123.59531687000003, 13.945580165000024],
            [123.60667533500009, 13.961758495000026],
            [123.62157817800005, 13.938934263000021],
            [123.63470894200009, 13.964772158000073],
            [123.65459029200008, 13.945253660000049],
            [123.65823411000008, 13.944107684000073],
            [123.66038060200003, 13.946633233000057],
            [123.64427264900007, 13.978375624000023],
        ],
        [
            [123.40168683900004, 13.982133399000077],
            [123.40293990300006, 13.979860004000045],
            [123.40166972800012, 13.978527246000056],
            [123.40043274400011, 13.981277832000046],
            [123.40168683900004, 13.982133399000077],
        ],
        [
            [123.64450913400003, 13.983929215000046],
            [123.64557402600008, 13.983436566000023],
            [123.64577410200002, 13.981814217000021],
            [123.64452888900007, 13.982288802000028],
            [123.64450913400003, 13.983929215000046],
        ],
        [
            [123.82634477400006, 13.985441110000068],
            [123.826847799, 13.98336795800003],
            [123.82459380600005, 13.981726954000067],
            [123.82412059400008, 13.983918251000034],
            [123.82634477400006, 13.985441110000068],
        ],
        [
            [124.32665398800009, 13.98703411100007],
            [124.34038445200008, 13.951571633000071],
            [124.34316298200008, 13.949745363000034],
            [124.35053129900007, 13.957666458000062],
            [124.35500350600012, 13.945984485000054],
            [124.3097772750001, 13.958333207000067],
            [124.32665398800009, 13.98703411100007],
        ],
        [
            [123.57230761300002, 13.987495542000033],
            [123.57178820500008, 13.986227510000049],
            [123.571101139, 13.986169379000046],
            [123.57165339100004, 13.987399227000026],
            [123.57230761300002, 13.987495542000033],
        ],
        [
            [123.52199483400011, 13.988375478000023],
            [123.52212899300002, 13.988342931000034],
            [123.52166033800006, 13.988396999000031],
            [123.52186059100006, 13.98846517100003],
            [123.52199483400011, 13.988375478000023],
        ],
        [
            [123.52106147300003, 13.988621137000052],
            [123.52661728700002, 13.980579016000036],
            [123.51379405300008, 13.971729209000046],
            [123.5133680990001, 13.97814392500004],
            [123.52106147300003, 13.988621137000052],
        ],
        [
            [123.5315609490001, 13.989775748000056],
            [123.53174001800005, 13.988931044000026],
            [123.52851944300005, 13.988109379000036],
            [123.52943976300003, 13.989465207000023],
            [123.5315609490001, 13.989775748000056],
        ],
        [
            [123.56745964100003, 13.991212045000054],
            [123.5695659370001, 13.98965507400004],
            [123.56917495500011, 13.988289078000037],
            [123.56798111500007, 13.988607479000052],
            [123.56745964100003, 13.991212045000054],
        ],
        [
            [123.52292487500006, 13.99212729800007],
            [123.52287291700009, 13.990961300000038],
            [123.52141138200011, 13.99129934900003],
            [123.52203891400006, 13.99185522700003],
            [123.52292487500006, 13.99212729800007],
        ],
        [
            [123.6333721090001, 13.989785076000032],
            [123.63226268100004, 13.990987756000038],
            [123.63206745500008, 13.992461286000037],
            [123.63341417700008, 13.99027042800003],
            [123.6333721090001, 13.989785076000032],
        ],
        [
            [123.53709550500002, 13.992867227000033],
            [123.53762601800008, 13.992275524000036],
            [123.53631803700011, 13.992399306000038],
            [123.53687408600001, 13.992859741000075],
            [123.53709550500002, 13.992867227000033],
        ],
        [
            [123.55795851300002, 13.993874875000074],
            [123.57365927700005, 13.982667261000074],
            [123.58053611700007, 13.986071826000057],
            [123.5751281250001, 13.969203132000075],
            [123.55795851300002, 13.993874875000074],
        ],
        [
            [123.55718806200002, 13.994739579000054],
            [123.55713201200001, 13.994034422000027],
            [123.55599190100008, 13.993381467000063],
            [123.55611539200004, 13.994565948000059],
            [123.55718806200002, 13.994739579000054],
        ],
        [
            [123.63882473900003, 13.995044634000067],
            [123.64256427600003, 13.989544093000063],
            [123.63996015400005, 13.984235591000072],
            [123.63705056100002, 13.988428404000047],
            [123.63882473900003, 13.995044634000067],
        ],
        [
            [123.51258985700008, 13.999712123000052],
            [123.51359457800004, 13.99957635000004],
            [123.51391518200012, 13.99910475400003],
            [123.51216066800009, 13.998794411000063],
            [123.51258985700008, 13.999712123000052],
        ],
        [
            [123.51642689300002, 14.002285522000022],
            [123.5171882200001, 14.000498710000045],
            [123.51428315200008, 13.998751081000023],
            [123.51501921400006, 14.001817739000046],
            [123.51642689300002, 14.002285522000022],
        ],
        [
            [123.40354243500008, 14.010217032000071],
            [123.40513886200006, 14.009267185000056],
            [123.40534839200006, 14.008342945000038],
            [123.40273324700001, 14.009447084000044],
            [123.40354243500008, 14.010217032000071],
        ],
        [
            [124.26777042000003, 14.023181145000024],
            [124.26859344600007, 14.022829988000069],
            [124.268320205, 14.019328790000031],
            [124.26643724200005, 14.019740526000021],
            [124.26777042000003, 14.023181145000024],
        ],
        [
            [123.394271376, 14.024686579000047],
            [123.39481116000002, 14.024237228000061],
            [123.39379384400002, 14.024081114000069],
            [123.39384328300002, 14.024563802000046],
            [123.394271376, 14.024686579000047],
        ],
        [
            [124.01317193700004, 14.026096134000056],
            [124.01760152300005, 14.025432421000062],
            [124.0251973500001, 14.014200377000066],
            [124.01782463100005, 14.014508362000072],
            [124.01317193700004, 14.026096134000056],
        ],
        [
            [123.21268377000001, 14.030992464000065],
            [123.22494760300003, 14.026207151000051],
            [123.22441002000005, 14.024814592000041],
            [123.20760295000002, 14.024315282000032],
            [123.21268377000001, 14.030992464000065],
        ],
        [
            [123.39181483700008, 14.031233180000072],
            [123.39279839800008, 14.030604033000031],
            [123.39175653500001, 14.029336322000063],
            [123.39105650300007, 14.030405642000062],
            [123.39181483700008, 14.031233180000072],
        ],
        [
            [124.05946556300012, 14.031578023000066],
            [124.06644301300003, 14.022186075000036],
            [124.06515911300005, 14.020668757000067],
            [124.05938705200003, 14.02802622400003],
            [124.05946556300012, 14.031578023000066],
        ],
        [
            [124.01692447200003, 14.032038312000054],
            [124.0177049130001, 14.031393769000033],
            [124.01832939400003, 14.029706692000047],
            [124.0166895640001, 14.031126682000036],
            [124.01692447200003, 14.032038312000054],
        ],
        [
            [124.04398290800009, 14.032090922000066],
            [124.04434271600007, 14.03179582100006],
            [124.04389016000005, 14.031378374000042],
            [124.043734373, 14.031871403000025],
            [124.04398290800009, 14.032090922000066],
        ],
        [
            [124.03913243000011, 14.032197497000027],
            [124.04415231000007, 14.028728133000072],
            [124.05135281100002, 14.030345426000054],
            [124.04728873700003, 14.013651348000053],
            [124.03913243000011, 14.032197497000027],
        ],
        [
            [123.10509961900004, 14.046707566000066],
            [123.11129041100003, 14.04201002600007],
            [123.11221162700008, 14.030238523000037],
            [123.0942275220001, 14.039890728000046],
            [123.10509961900004, 14.046707566000066],
        ],
        [
            [123.08927832600011, 14.056751396000038],
            [123.089421592, 14.053907219000052],
            [123.085296674, 14.054050841000048],
            [123.0881106700001, 14.055326231000038],
            [123.08927832600011, 14.056751396000038],
        ],
        [
            [123.0784490640001, 14.070565141000031],
            [123.07576552700004, 14.06472455000005],
            [123.0664766540001, 14.067610107000064],
            [123.07482157400011, 14.073291151000035],
            [123.0784490640001, 14.070565141000031],
        ],
        [
            [123.10510410600011, 14.090019398000038],
            [123.11754016200007, 14.079006750000076],
            [123.11692050400006, 14.075243072000035],
            [123.09848027900011, 14.08026475400004],
            [123.10510410600011, 14.090019398000038],
        ],
        [
            [123.08078450800008, 14.090735954000024],
            [123.08071533200007, 14.090454847000046],
            [123.08035783900004, 14.090673206000076],
            [123.08039609500008, 14.090718866000032],
            [123.08078450800008, 14.090735954000024],
        ],
        [
            [123.08657293500005, 14.090796870000077],
            [123.08616118000009, 14.087264491000042],
            [123.085701061, 14.08658351300005],
            [123.085627111, 14.088920147000067],
            [123.08657293500005, 14.090796870000077],
        ],
        [
            [123.0904077880001, 14.091046713000026],
            [123.09490074400003, 14.086125312000036],
            [123.09546656400005, 14.080278010000029],
            [123.08489886300003, 14.084473118000062],
            [123.0904077880001, 14.091046713000026],
        ],
        [
            [123.08158253500005, 14.092064406000077],
            [123.08396179700003, 14.090112051000062],
            [123.08476699200003, 14.08500514700006],
            [123.08085377100008, 14.086599303000071],
            [123.08158253500005, 14.092064406000077],
        ],
        [
            [124.20640531800007, 14.099928587000022],
            [124.31192880100002, 13.897476420000032],
            [124.3515922790001, 13.939904353000031],
            [124.38718959200003, 13.871744969000076],
            [124.40781984800003, 13.879476630000056],
            [124.42202778700005, 13.79594263100006],
            [124.41742610900008, 13.789683892000028],
            [124.41870441900005, 13.788469580000026],
            [124.4178765900001, 13.788438005000046],
            [124.41774677100011, 13.786054264000029],
            [124.41869300200005, 13.78294020800007],
            [124.3928661220001, 13.779031110000062],
            [124.40963007900007, 13.751545838000027],
            [124.392920075, 13.74812023800007],
            [124.38441019400011, 13.714752953000072],
            [124.4165268910001, 13.666168413000037],
            [124.34210184900007, 13.640714573000025],
            [124.34494882900003, 13.548791090000066],
            [124.31722674900004, 13.552003935000073],
            [124.31093954800008, 13.589251973000046],
            [124.2563859070001, 13.593274043000065],
            [124.21041863500011, 13.559098075000065],
            [124.20841048900002, 13.516627809000056],
            [124.04780630200003, 13.60185137600007],
            [124.0233119610001, 13.663203388000056],
            [124.09563079100008, 13.70468472500005],
            [124.13575339600004, 13.796071295000047],
            [124.12652064000008, 14.060347028000024],
            [124.17037226800005, 14.050681378000036],
            [124.20640531800007, 14.099928587000022],
        ],
        [
            [124.33541101800006, 13.562454194000054],
            [124.3344697230001, 13.56208715200006],
            [124.33401196300008, 13.561507899000048],
            [124.33643967000012, 13.561370543000066],
            [124.33541101800006, 13.562454194000054],
        ],
        [
            [124.33917649000011, 13.562543386000073],
            [124.33845370400002, 13.562562824000054],
            [124.33689478000008, 13.561387937000063],
            [124.34002276100011, 13.562278551000077],
            [124.33917649000011, 13.562543386000073],
        ],
        [
            [124.33684914900005, 13.567809905000047],
            [124.336780599, 13.567845543000033],
            [124.3370213390001, 13.567530979000026],
            [124.3370787120001, 13.567737088000058],
            [124.33684914900005, 13.567809905000047],
        ],
        [
            [124.39532554000004, 13.690678667000043],
            [124.395451352, 13.69112270100004],
            [124.39496623500008, 13.690549825000062],
            [124.39506787500011, 13.690502306000042],
            [124.39532554000004, 13.690678667000043],
        ],
        [
            [124.39363234200005, 13.69197785700004],
            [124.39329245200008, 13.691946733000066],
            [124.39317144400002, 13.69177729300003],
            [124.39346506900006, 13.69166664200003],
            [124.39363234200005, 13.69197785700004],
        ],
        [
            [124.39430857000002, 13.692394543000034],
            [124.39415908800004, 13.692382439000028],
            [124.3940309620001, 13.692074682000055],
            [124.3942961140001, 13.692245851000052],
            [124.39430857000002, 13.692394543000034],
        ],
        [
            [124.42019082200011, 13.795145037000054],
            [124.4200048990001, 13.794771523000065],
            [124.4203543750001, 13.794621306000067],
            [124.42038287900004, 13.794680422000056],
            [124.42019082200011, 13.795145037000054],
        ],
        [
            [124.42064062300005, 13.797776777000024],
            [124.42052572000011, 13.797875653000062],
            [124.420753912, 13.797521300000028],
            [124.42078439000011, 13.79774132600005],
            [124.42064062300005, 13.797776777000024],
        ],
        [
            [124.41524033100006, 13.82616065600007],
            [124.41438881600004, 13.825943834000043],
            [124.4141371930001, 13.825769080000043],
            [124.41492538500006, 13.825722154000061],
            [124.41524033100006, 13.82616065600007],
        ],
        [
            [124.41438558300001, 13.826378359000046],
            [124.41417667700011, 13.826560477000044],
            [124.41378732600003, 13.826074091000066],
            [124.41408644600006, 13.825998010000035],
            [124.41438558300001, 13.826378359000046],
        ],
        [
            [124.41456762900009, 13.829282071000023],
            [124.414030894, 13.828921421000075],
            [124.41525747000003, 13.82764535900003],
            [124.41545773500002, 13.828304917000025],
            [124.41456762900009, 13.829282071000023],
        ],
        [
            [124.41463627900009, 13.83140265700007],
            [124.4144224050001, 13.83128810900007],
            [124.4148066790001, 13.830996631000062],
            [124.41498263900007, 13.831375663000074],
            [124.41463627900009, 13.83140265700007],
        ],
        [
            [124.40288624400011, 13.857580505000044],
            [124.4027641880001, 13.857273035000048],
            [124.40324505600006, 13.856969140000047],
            [124.403180184, 13.857528946000059],
            [124.40288624400011, 13.857580505000044],
        ],
        [
            [124.40718566800001, 13.860935488000052],
            [124.40652052700011, 13.861513535000029],
            [124.406290968, 13.861454589000061],
            [124.40670357400006, 13.860905225000067],
            [124.40718566800001, 13.860935488000052],
        ],
        [
            [124.40718007200007, 13.876781271000027],
            [124.4070804050001, 13.87694887300006],
            [124.40693268200005, 13.876864209000075],
            [124.40698073600004, 13.876819284000021],
            [124.40718007200007, 13.876781271000027],
        ],
        [
            [124.31897225700004, 13.900469215000044],
            [124.31969170200011, 13.901289008000049],
            [124.31413054000006, 13.897802957000067],
            [124.31748138500006, 13.898909095000022],
            [124.31897225700004, 13.900469215000044],
        ],
        [
            [124.1446046310001, 13.90965222400007],
            [124.144408096, 13.90947223300003],
            [124.1446426440001, 13.908896854000034],
            [124.1449675560001, 13.909106070000064],
            [124.1446046310001, 13.90965222400007],
        ],
        [
            [124.1433119830001, 13.92180084000006],
            [124.14333437500011, 13.921442009000032],
            [124.14359844000012, 13.92151190100003],
            [124.14356163700006, 13.921671900000035],
            [124.1433119830001, 13.92180084000006],
        ],
        [
            [123.29880567000009, 14.128800049000063],
            [123.32777847300008, 14.110564370000077],
            [123.3181368700001, 14.088780539000027],
            [123.29043622800009, 14.122259361000033],
            [123.29880567000009, 14.128800049000063],
        ],
        [
            [123.054069937, 14.129729695000037],
            [123.05436936100011, 14.129525970000032],
            [123.05419067200012, 14.129188771000031],
            [123.0539153950001, 14.129605586000025],
            [123.054069937, 14.129729695000037],
        ],
        [
            [123.05207999400011, 14.129602478000038],
            [123.05446309400008, 14.12905104500004],
            [123.05977138900005, 14.129578593000076],
            [123.06560324600002, 14.128447582000035],
            [123.06873184300002, 14.129057472000056],
            [123.06923839600006, 14.097684036000032],
            [123.05207999400011, 14.129602478000038],
        ],
        [
            [122.92712419400004, 14.194428685000048],
            [122.9276403340001, 14.194239271000072],
            [122.92806607200009, 14.193577744000038],
            [122.92643600300005, 14.194061175000058],
            [122.92712419400004, 14.194428685000048],
        ],
        [
            [122.91445711000006, 14.196395318000043],
            [122.91463690800003, 14.190848376000076],
            [122.91080639400002, 14.189921083000058],
            [122.90989509400003, 14.19308385200003],
            [122.91445711000006, 14.196395318000043],
        ],
        [
            [122.91767956900003, 14.198207332000038],
            [122.91934899800003, 14.196473879000052],
            [122.91701598000009, 14.195720140000049],
            [122.91633477200003, 14.197835973000053],
            [122.91767956900003, 14.198207332000038],
        ],
        [
            [122.91419365800004, 14.199361557000032],
            [122.91405917100008, 14.19955714100007],
            [122.91401945500002, 14.200022387000047],
            [122.914205906, 14.199817909000046],
            [122.91419365800004, 14.199361557000032],
        ],
        [
            [122.95144870700005, 14.204981309000061],
            [122.95248928800004, 14.202612327000054],
            [122.94736988700004, 14.201592522000055],
            [122.94806308500006, 14.203604745000064],
            [122.95144870700005, 14.204981309000061],
        ],
        [
            [122.91640761100007, 14.209646464000059],
            [122.91585927400001, 14.209322955000061],
            [122.91637198600006, 14.21172639200006],
            [122.91658653200011, 14.21150682800004],
            [122.91640761100007, 14.209646464000059],
        ],
        [
            [122.91203183800008, 14.217693728000029],
            [122.9129469720001, 14.217113695000023],
            [122.91316255400011, 14.216610433000028],
            [122.91159187000005, 14.216849271000058],
            [122.91203183800008, 14.217693728000029],
        ],
        [
            [122.924726286, 14.222311371000046],
            [122.9401041640001, 14.189405769000075],
            [122.93783669700008, 14.193478435000031],
            [122.92267091800011, 14.205799133000028],
            [122.924726286, 14.222311371000046],
        ],
        [
            [122.91514553500008, 14.22352950100003],
            [122.9162873900001, 14.223083592000023],
            [122.91627655900004, 14.222627209000052],
            [122.91552975200011, 14.222747876000028],
            [122.91514553500008, 14.22352950100003],
        ],
        [
            [122.58080431200005, 14.327757313000063],
            [122.58044135300008, 14.327624034000053],
            [122.58036872500008, 14.327691840000057],
            [122.58072902200001, 14.32801102600007],
            [122.58080431200005, 14.327757313000063],
        ],
        [
            [122.59042969600011, 14.330626597000048],
            [122.59334164100005, 14.329740496000056],
            [122.58549302300003, 14.325918785000056],
            [122.58212848100004, 14.325541532000045],
            [122.58095526900001, 14.327116677000049],
            [122.59042969600011, 14.330626597000048],
        ],
        [
            [122.38376856000002, 14.066641330000039],
            [122.2992594640001, 14.07077963300003],
            [122.35169710800005, 14.122302428000069],
            [122.33228815500001, 14.196732763000057],
            [122.35686074000012, 14.187234494000052],
            [122.34962867100012, 14.225751462000062],
            [122.38223786500009, 14.215225343000043],
            [122.35997067000005, 14.25040073100007],
            [122.38407226400011, 14.286704200000031],
            [122.4690046400001, 14.339649681000026],
            [122.52086653600009, 14.317512209000029],
            [122.52236392900011, 14.349205238000025],
            [122.62056126700008, 14.288019830000053],
            [122.63121139900011, 14.321785402000046],
            [122.63406206200011, 14.281581244000051],
            [122.64933477300008, 14.314496204000022],
            [122.69424881100008, 14.285003532000076],
            [122.66999879600007, 14.341351213000053],
            [122.77470876000007, 14.320524158000069],
            [122.78984568400006, 14.280250696000053],
            [122.864493003, 14.270669165000072],
            [122.916578909, 14.219468379000034],
            [122.89864098400005, 14.222656541000049],
            [122.90278331500008, 14.220745475000058],
            [122.90249916900007, 14.214744110000026],
            [122.89969471600011, 14.220483683000054],
            [122.89329138700009, 14.218802851000078],
            [122.91226713500009, 14.196032591000062],
            [122.90613879800003, 14.199701502000039],
            [122.8975041220001, 14.197851739000043],
            [122.89158207700007, 14.202344130000029],
            [122.88939420000008, 14.202420241000027],
            [122.888166554, 14.200771183000029],
            [122.91215388900002, 14.188828663000038],
            [122.93744859000003, 14.190606294000077],
            [123.01181875000009, 14.096905680000077],
            [123.0410022310001, 14.101227921000032],
            [123.02995300500004, 14.035893950000059],
            [123.08342937600003, 13.981792994000045],
            [123.09540164500004, 13.891374240000061],
            [123.06524966200004, 13.873629308000034],
            [123.04557475000001, 13.776434318000042],
            [123.12003810800002, 13.721126771000058],
            [123.2393672390001, 13.731963116000031],
            [123.27433009600009, 13.748809754000035],
            [123.32470102400009, 13.800320698000064],
            [123.28451733200006, 13.896269587000063],
            [123.33266240400008, 13.93795360300004],
            [123.33892524600003, 13.98244588600005],
            [123.2938821460001, 13.926984405000042],
            [123.26545843600002, 13.962419037000075],
            [123.23238114700007, 13.967753189000064],
            [123.22786420700004, 14.000253087000033],
            [123.27014570800009, 13.999128244000076],
            [123.23048529000005, 14.025623762000066],
            [123.28332153400004, 14.033235441000045],
            [123.25541769900008, 14.072882526000058],
            [123.32130201500001, 14.039544698000043],
            [123.33990949600002, 14.105403274000025],
            [123.37446290300011, 14.040301258000056],
            [123.35191162400008, 14.038781081000025],
            [123.34274073800009, 14.013254127000039],
            [123.38853656800006, 14.034123278000038],
            [123.3822534090001, 14.008082711000043],
            [123.42600007800002, 13.920229127000027],
            [123.45121104700002, 13.92013877100004],
            [123.45796414300003, 13.937877461000028],
            [123.44558417100006, 13.939926867000054],
            [123.44750545900001, 13.965309715000046],
            [123.45013688300003, 13.967144560000065],
            [123.48907008600008, 13.939292934000036],
            [123.5011594980001, 13.941608272000053],
            [123.49062298400008, 13.913764408000077],
            [123.54254672000002, 13.909369727000069],
            [123.54534074900005, 13.932115375000024],
            [123.5993775610001, 13.892308867000054],
            [123.68068762300004, 13.878508182000076],
            [123.70688593300008, 13.943214560000058],
            [123.73736290600004, 13.884374534000074],
            [123.78332616000012, 13.843609273000027],
            [123.84850103300005, 13.809933513000033],
            [123.86704009200002, 13.825756424000076],
            [123.94158380600004, 13.79536378000006],
            [123.94737259500005, 13.754654627000036],
            [123.97567772200011, 13.739153953000027],
            [123.96888439600002, 13.709012693000034],
            [123.88333927100007, 13.738999051000064],
            [123.80262613600007, 13.687670033000074],
            [123.5825831190001, 13.728129402000036],
            [123.53000668100003, 13.573717110000075],
            [123.67784063500005, 13.477405744000066],
            [123.74406117300009, 13.324870177000037],
            [123.81547615900001, 13.288131475000057],
            [123.8162115880001, 13.25400865000006],
            [123.83232003800003, 13.234180913000046],
            [123.82885122500011, 13.266791990000058],
            [123.86805804300002, 13.239715339000043],
            [123.86200779700005, 13.224352750000037],
            [123.77461890900008, 13.227495044000023],
            [123.75638192300005, 13.145103132000031],
            [123.7860299030001, 13.114708476000033],
            [123.75124296600006, 13.089891824000063],
            [123.75889439700006, 13.05880484000005],
            [123.81247258300004, 13.054055959000038],
            [123.87948568700006, 13.143200516000036],
            [123.97210444000007, 13.10933744700003],
            [124.07500734400003, 13.003549031000034],
            [124.13082535100011, 13.074937401000057],
            [124.19291605900003, 13.06090385500005],
            [124.19831856200005, 13.018549655000072],
            [124.15143330900003, 12.997973628000068],
            [124.11735377000002, 12.908669144000044],
            [124.14856319800003, 12.893048528000065],
            [124.1558129880001, 12.808789560000037],
            [124.0811488390001, 12.53630709600003],
            [123.98943185100006, 12.544828284000062],
            [123.9388562690001, 12.625296994000053],
            [123.87471473500011, 12.655680752000023],
            [123.83038406800006, 12.827972689000035],
            [123.85910440300006, 12.875797471000055],
            [123.92526756900008, 12.844821548000027],
            [123.94988661100001, 12.876194911000027],
            [123.997704214, 12.861721791000036],
            [124.03412081300007, 12.964106247000075],
            [123.88360889100011, 12.97854301600006],
            [123.85522726800002, 12.897953054000027],
            [123.83404806400006, 12.904138268000054],
            [123.79611849700007, 12.862809809000055],
            [123.75943497100002, 12.880442152000057],
            [123.73615106700004, 12.844990069000062],
            [123.71011390500007, 12.87609124900007],
            [123.74163175100011, 12.88529434000003],
            [123.73443738900005, 12.897656960000063],
            [123.69187495900007, 12.896934326000064],
            [123.70652119400006, 12.877879419000067],
            [123.69257713900004, 12.865094256000077],
            [123.67253667300008, 12.908468661000029],
            [123.69645683600004, 12.91509568400005],
            [123.71131235900009, 12.94102687000003],
            [123.66213564300006, 12.917684413000075],
            [123.65214763200004, 12.87015470700004],
            [123.42586610300009, 13.039905270000077],
            [123.319808953, 13.006635878000054],
            [123.28072276500006, 13.057653196000047],
            [123.28827248700009, 13.146970002000046],
            [123.3273411780001, 13.198223321000057],
            [123.23858758600011, 13.290379663000067],
            [123.1915330380001, 13.431023826000057],
            [122.88821281900005, 13.576154275000022],
            [122.79865096500009, 13.650544668000066],
            [122.86220509300006, 13.689709840000035],
            [122.83608908000008, 13.735044763000076],
            [122.74248891900004, 13.777337234000072],
            [122.76860407200002, 13.785823910000033],
            [122.74915115400006, 13.79112311700004],
            [122.72247131800009, 13.817124299000056],
            [122.66835808600001, 13.809829562000061],
            [122.64198812300003, 13.882488029000058],
            [122.5540381940001, 13.922532122000064],
            [122.58387379100009, 13.96181139600003],
            [122.79251799700012, 14.013752262000025],
        ],
        [
            [124.14030489600009, 12.874540978000027],
            [124.13965667600007, 12.87397204000007],
            [124.14055257500002, 12.873369343000036],
            [124.1408364560001, 12.873884447000023],
            [124.14030489600009, 12.874540978000027],
        ],
        [
            [124.1403759430001, 12.875414018000072],
            [124.14043272100002, 12.875473986000031],
            [124.14041694000002, 12.875672336000036],
            [124.14026868300004, 12.875555471000041],
            [124.1403759430001, 12.875414018000072],
        ],
        [
            [123.96182736700007, 13.723364847000028],
            [123.96149085700006, 13.723029135000047],
            [123.96270878900009, 13.722993105000057],
            [123.96240969000007, 13.723060583000063],
            [123.96182736700007, 13.723364847000028],
        ],
        [
            [123.9508678740001, 13.726486785000077],
            [123.95083900800012, 13.725920475000066],
            [123.9507336800001, 13.725712145000045],
            [123.9512223810001, 13.725992203000033],
            [123.9508678740001, 13.726486785000077],
        ],
        [
            [122.74341580600003, 13.80296916900005],
            [122.74285285100007, 13.801865531000033],
            [122.74528701500003, 13.802406382000072],
            [122.74460973300006, 13.802795289000073],
            [122.74341580600003, 13.80296916900005],
        ],
        [
            [123.89138402600008, 13.805138925000051],
            [123.88980748900008, 13.80514916800007],
            [123.8912515720001, 13.802936407000061],
            [123.89074895800002, 13.80397085800007],
            [123.89138402600008, 13.805138925000051],
        ],
        [
            [123.88839380200011, 13.807443530000057],
            [123.88822020100008, 13.807586939000032],
            [123.88810107000006, 13.808228560000032],
            [123.88775451800007, 13.80721747900003],
            [123.88839380200011, 13.807443530000057],
        ],
        [
            [123.907955979, 13.808362464000027],
            [123.90702765800006, 13.80830379300005],
            [123.90665903000001, 13.804987973000038],
            [123.90796941700012, 13.806109723000077],
            [123.907955979, 13.808362464000027],
        ],
        [
            [123.89018156500003, 13.809121481000034],
            [123.88896578200001, 13.808873256000027],
            [123.88875485200003, 13.807537014000047],
            [123.89008203800006, 13.807731126000022],
            [123.89018156500003, 13.809121481000034],
        ],
        [
            [123.89501785900006, 13.811950079000042],
            [123.89420364900002, 13.809255704000066],
            [123.8984960570001, 13.810582392000072],
            [123.89839932000007, 13.811949966000043],
            [123.89501785900006, 13.811950079000042],
        ],
        [
            [123.45074020000004, 13.966331007000065],
            [123.45032178800011, 13.965383631000066],
            [123.4504969190001, 13.964960165000036],
            [123.45112333500003, 13.965923601000043],
            [123.45074020000004, 13.966331007000065],
        ],
        [
            [123.23494214000004, 13.993167889000063],
            [123.23484088500004, 13.993059189000064],
            [123.23496368100007, 13.992921222000064],
            [123.23511448600004, 13.993104131000052],
            [123.23494214000004, 13.993167889000063],
        ],
        [
            [123.23449577400004, 13.993485975000056],
            [123.23413821800011, 13.993450877000043],
            [123.23402691900003, 13.992741977000037],
            [123.23477057000002, 13.993089423000072],
            [123.23449577400004, 13.993485975000056],
        ],
        [
            [123.23266714500005, 13.99527084400006],
            [123.23245686500002, 13.995128400000056],
            [123.23249400100008, 13.995034396000051],
            [123.23273633600002, 13.995127269000022],
            [123.23266714500005, 13.99527084400006],
        ],
        [
            [123.22928064100006, 13.995963269000072],
            [123.22873452700003, 13.99561043400007],
            [123.22872422400008, 13.995499205000044],
            [123.22921752800005, 13.995589188000054],
            [123.22928064100006, 13.995963269000072],
        ],
        [
            [122.60658110100007, 14.349209084000051],
            [122.6069913230001, 14.34316231500003],
            [122.606095105, 14.342234306000023],
            [122.60372195200011, 14.347147820000032],
            [122.60658110100007, 14.349209084000051],
        ],
        [
            [122.640228997, 14.350349170000072],
            [122.64080284700003, 14.349640031000035],
            [122.63961386500011, 14.348606521000022],
            [122.63950632800004, 14.349560207000025],
            [122.640228997, 14.350349170000072],
        ],
        [
            [122.9509177970001, 14.37563334400005],
            [122.96122076300003, 14.375408567000022],
            [122.96321458700004, 14.371878504000051],
            [122.9581532200001, 14.369421393000039],
            [122.9509177970001, 14.37563334400005],
        ],
        [
            [122.8137578520001, 14.40757138500004],
            [122.81791477400009, 14.403099059000056],
            [122.81928633600012, 14.385347423000042],
            [122.80566095100005, 14.418826978000027],
            [122.8137578520001, 14.40757138500004],
        ],
        [
            [122.92109997000011, 14.419547116000047],
            [122.92166318800003, 14.419478304000052],
            [122.92254368400006, 14.419165064000026],
            [122.91987006700003, 14.419302258000073],
            [122.92109997000011, 14.419547116000047],
        ],
        [
            [122.92906904400002, 14.418558473000076],
            [122.92811780800002, 14.414651605000074],
            [122.92336435800007, 14.418151898000076],
            [122.92861411900003, 14.419979494000074],
            [122.92906904400002, 14.418558473000076],
        ],
        [
            [122.94530186600002, 14.429523909000068],
            [122.94598430600001, 14.429209487000037],
            [122.94497314800003, 14.428476825000075],
            [122.94434409700011, 14.429153536000058],
            [122.94530186600002, 14.429523909000068],
        ],
        [
            [122.95039430700001, 14.429704565000065],
            [122.95039996100002, 14.430325528000026],
            [122.950875085, 14.430769127000076],
            [122.95082362000005, 14.43020914400006],
            [122.95039430700001, 14.429704565000065],
        ],
        [
            [122.94995906500003, 14.430979708000052],
            [122.94973595200008, 14.429621329000042],
            [122.94856239600006, 14.429260815000077],
            [122.94839627600004, 14.430048085000067],
            [122.94995906500003, 14.430979708000052],
        ],
        [
            [122.99010152800008, 14.435296059000052],
            [122.9957025860001, 14.432157093000058],
            [123.01953851400003, 14.430239651000022],
            [122.98505219600008, 14.428237075000027],
            [122.99010152800008, 14.435296059000052],
        ],
        [
            [122.93975364700009, 14.439882897000075],
            [122.944101756, 14.427863473000059],
            [122.98007728400012, 14.405429465000054],
            [122.92993068800001, 14.425524685000028],
            [122.93975364700009, 14.439882897000075],
        ],
        [
            [122.94264279600009, 14.440702260000023],
            [122.94277917400007, 14.44012232800003],
            [122.94197100100007, 14.439565896000033],
            [122.94218027000011, 14.44054662800005],
            [122.94264279600009, 14.440702260000023],
        ],
        [
            [122.93858249400012, 14.444820437000033],
            [122.94058703700011, 14.442783759000065],
            [122.94010073400011, 14.441358281000078],
            [122.93783325000004, 14.44395430700007],
            [122.93858249400012, 14.444820437000033],
        ],
        [
            [122.98799582000004, 14.448918314000025],
            [122.99452920100009, 14.448076553000021],
            [122.99505308800008, 14.446608963000074],
            [122.98764902300002, 14.446285036000063],
            [122.98799582000004, 14.448918314000025],
        ],
        [
            [122.98094175900007, 14.449053804000073],
            [122.98099516400009, 14.447712902000035],
            [122.97771992000003, 14.446851151000033],
            [122.9783598890001, 14.448480061000055],
            [122.98094175900007, 14.449053804000073],
        ],
        [
            [122.98367864300008, 14.449645915000076],
            [122.9839886210001, 14.448983096000063],
            [122.98287138, 14.44872752200007],
            [122.98313537900003, 14.449842102000048],
            [122.98367864300008, 14.449645915000076],
        ],
        [
            [122.9757169610001, 14.451778692000062],
            [122.9756956760001, 14.450999008000053],
            [122.97533547000012, 14.450966219000065],
            [122.97524229300006, 14.451405315000045],
            [122.9757169610001, 14.451778692000062],
        ],
        [
            [122.97045861700008, 14.45250627300004],
            [122.97456514600003, 14.44937643000003],
            [122.9675272930001, 14.44737600600007],
            [122.9665813790001, 14.448522237000077],
            [122.96681045200012, 14.450143187000037],
            [122.97045861700008, 14.45250627300004],
        ],
        [
            [122.98163424600011, 14.452766133000068],
            [122.98266501400008, 14.45213235400007],
            [122.9826493490001, 14.45150994200003],
            [122.98166562900008, 14.45154407900003],
            [122.98163424600011, 14.452766133000068],
        ],
        [
            [122.92274017800003, 14.471973501000036],
            [122.92352294800003, 14.471362943000031],
            [122.9231467830001, 14.470811337000043],
            [122.92211831300006, 14.47139241800005],
            [122.92274017800003, 14.471973501000036],
        ],
        [
            [122.9363813870001, 14.49060541800003],
            [122.93780582200009, 14.486031999000033],
            [122.93086308400007, 14.489477383000064],
            [122.93439619500009, 14.489663428000028],
            [122.9363813870001, 14.49060541800003],
        ],
        [
            [122.90759019900008, 14.493008251000049],
            [122.90859546400009, 14.491790552000055],
            [122.90776141600008, 14.490756729000054],
            [122.90582054900005, 14.491918076000047],
            [122.90759019900008, 14.493008251000049],
        ],
        [
            [122.93439013300008, 14.493676029000028],
            [122.93509113000005, 14.493520357000023],
            [122.93511790100001, 14.493256656000028],
            [122.93430526200007, 14.493161605000068],
            [122.93439013300008, 14.493676029000028],
        ],
        [
            [122.94944700100007, 14.494790820000048],
            [122.94464038600006, 14.45011723400006],
            [122.90126267000005, 14.445706682000036],
            [122.93641267200007, 14.471784381000077],
            [122.94944700100007, 14.494790820000048],
        ],
        [
            [122.930225876, 14.495466021000027],
            [122.93310918100008, 14.492411563000076],
            [122.92701449300012, 14.490141938000022],
            [122.92693430400004, 14.492327659000068],
            [122.930225876, 14.495466021000027],
        ],
        [
            [122.89949343300009, 14.49599726200006],
            [122.90145444200004, 14.49602574100004],
            [122.90168729000004, 14.495525688000043],
            [122.90065660500011, 14.49528581900006],
            [122.89949343300009, 14.49599726200006],
        ],
        [
            [122.95388807400002, 14.496279784000023],
            [122.95403720200011, 14.495552425000028],
            [122.95350426400012, 14.493891432000055],
            [122.95271574800006, 14.494397020000065],
            [122.95388807400002, 14.496279784000023],
        ],
        [
            [122.90468031300009, 14.500558159000036],
            [122.90739898100003, 14.495058681000046],
            [122.903087647, 14.492348210000046],
            [122.90203633700003, 14.496216951000065],
            [122.90468031300009, 14.500558159000036],
        ],
        [
            [122.92915309900002, 14.501112956000043],
            [122.93033883400005, 14.500737405000052],
            [122.9310856400001, 14.50007778500003],
            [122.92797390500004, 14.500694373000044],
            [122.92915309900002, 14.501112956000043],
        ],
        [
            [122.43810951300009, 9.653540355000075],
            [122.43751512300003, 9.647201787000029],
            [122.43432809500007, 9.643432515000029],
            [122.4328685590001, 9.647661816000038],
            [122.43810951300009, 9.653540355000075],
        ],
        [
            [122.40042709500005, 9.671871191000037],
            [122.40100696700006, 9.671773715000029],
            [122.40100711200012, 9.671354628000074],
            [122.40026332600007, 9.671342028000026],
            [122.40042709500005, 9.671871191000037],
        ],
        [
            [122.39832690100002, 9.67491307900002],
            [122.39957193600003, 9.67429310700004],
            [122.39943912800004, 9.672792852000043],
            [122.3978442, 9.67441266700007],
            [122.39832690100002, 9.67491307900002],
        ],
        [
            [122.40021047300002, 9.679760057000067],
            [122.39994370600004, 9.67944490900004],
            [122.39904185700004, 9.679705976000037],
            [122.4002578090001, 9.679945474000021],
            [122.40021047300002, 9.679760057000067],
        ],
        [
            [122.39748624300012, 9.680168309000067],
            [122.39827796400004, 9.679854430000034],
            [122.39806407000003, 9.67932038300006],
            [122.39666458200008, 9.680632527000057],
            [122.39748624300012, 9.680168309000067],
        ],
        [
            [122.39373140500004, 9.797115739000049],
            [122.39380573800008, 9.796653136000032],
            [122.39315871000008, 9.797490172000039],
            [122.39335144800009, 9.797539007000069],
            [122.39373140500004, 9.797115739000049],
        ],
        [
            [122.39397873700011, 9.800724229000025],
            [122.39415096200003, 9.800527292000027],
            [122.39400310000008, 9.800260223000066],
            [122.39374476100011, 9.800455560000046],
            [122.39397873700011, 9.800724229000025],
        ],
        [
            [122.39690034800003, 9.801598747000071],
            [122.39723917600008, 9.800434120000034],
            [122.39680057800001, 9.799953179000056],
            [122.39606971900002, 9.801132094000025],
            [122.39690034800003, 9.801598747000071],
        ],
        [
            [122.39470789900008, 9.80168087900006],
            [122.39505261700003, 9.801474044000031],
            [122.39495948000001, 9.80118503400007],
            [122.39447159100007, 9.801424746000066],
            [122.39470789900008, 9.80168087900006],
        ],
        [
            [122.3963580940001, 9.803524289000052],
            [122.39688778400011, 9.803091639000058],
            [122.39657313900011, 9.802145801000052],
            [122.39536090100012, 9.803338647000032],
            [122.3963580940001, 9.803524289000052],
        ],
        [
            [122.39650180800004, 9.804154080000046],
            [122.3965729040001, 9.803964908000069],
            [122.39635781800007, 9.803782751000028],
            [122.39626006100002, 9.804005202000042],
            [122.39650180800004, 9.804154080000046],
        ],
        [
            [122.36747621600011, 9.830034127000033],
            [122.36897602300007, 9.828081136000037],
            [122.36510964000001, 9.828177556000071],
            [122.36491490300011, 9.82914805400003],
            [122.36747621600011, 9.830034127000033],
        ],
        [
            [122.3654319200001, 9.833452474000069],
            [122.36591380800007, 9.833129426000028],
            [122.36664654000003, 9.831728794000071],
            [122.36530990100005, 9.832971032000046],
            [122.3654319200001, 9.833452474000069],
        ],
        [
            [122.38491254100006, 9.862399086000039],
            [122.38702490100002, 9.86130969800007],
            [122.38388722400009, 9.859509648000028],
            [122.38307981500009, 9.861871443000041],
            [122.38491254100006, 9.862399086000039],
        ],
        [
            [122.37419152000007, 9.869629730000042],
            [122.37439697400009, 9.869466677000048],
            [122.3747885890001, 9.869324277000032],
            [122.37419152300004, 9.86931486800006],
            [122.37419152000007, 9.869629730000042],
        ],
        [
            [122.37442162900004, 9.878317610000067],
            [122.37488279900003, 9.87825470200005],
            [122.37501472800011, 9.878190293000046],
            [122.37415448200011, 9.87780013400004],
            [122.37442162900004, 9.878317610000067],
        ],
        [
            [122.37340934600002, 9.87921582000007],
            [122.37327398800005, 9.879251650000072],
            [122.37328991200002, 9.879351179000025],
            [122.37354470600008, 9.879327292000028],
            [122.37340934600002, 9.87921582000007],
        ],
        [
            [122.37561498200012, 9.88054537100004],
            [122.37923551000006, 9.880339998000068],
            [122.37997738900003, 9.87684140500005],
            [122.37752179800009, 9.86593627600007],
            [122.37561498200012, 9.88054537100004],
        ],
        [
            [122.60572, 10.398020001000077],
            [122.61670999900002, 10.39772],
            [122.62437000000011, 10.38955],
            [122.592219999, 10.39517],
            [122.60572, 10.398020001000077],
        ],
        [
            [122.50562658000001, 10.404169285000023],
            [122.50640471100007, 10.40441283000007],
            [122.5056821600001, 10.402842713000041],
            [122.50496987600002, 10.40464527000006],
            [122.50562658000001, 10.404169285000023],
        ],
        [
            [122.50678614200001, 10.40634803200004],
            [122.50801502400009, 10.405888060000052],
            [122.50749520700003, 10.404099808000069],
            [122.50639465300003, 10.404568409000035],
            [122.50678614200001, 10.40634803200004],
        ],
        [
            [122.55718, 10.40473],
            [122.55137999900012, 10.40393],
            [122.5505, 10.40439],
            [122.55403, 10.40831],
            [122.55718, 10.40473],
        ],
        [
            [122.51032978, 10.410650432000068],
            [122.51362238700005, 10.403552906000073],
            [122.50845359200002, 10.402268208000066],
            [122.50819521500011, 10.408255205000046],
            [122.51032978, 10.410650432000068],
        ],
        [
            [122.50562574700007, 10.414960026000074],
            [122.50709310000002, 10.41337889600004],
            [122.5058521410001, 10.41130044700003],
            [122.5048692470001, 10.412222221000036],
            [122.50562574700007, 10.414960026000074],
        ],
        [
            [122.58803000000012, 10.41148000100003],
            [122.58531, 10.41315],
            [122.58618999900011, 10.41533],
            [122.58992, 10.41444],
            [122.58803000000012, 10.41148000100003],
        ],
        [
            [122.58139, 10.415830001000074],
            [122.58361, 10.4125],
            [122.5791699990001, 10.41167],
            [122.57805999900006, 10.41444],
            [122.58139, 10.415830001000074],
        ],
        [
            [122.56360999900005, 10.41528],
            [122.57326000000012, 10.407560001000036],
            [122.59742, 10.41287],
            [122.59709, 10.404670001000056],
            [122.55999999900007, 10.40111],
            [122.56360999900005, 10.41528],
        ],
        [
            [122.50728722100007, 10.418128524000053],
            [122.50922041000001, 10.415562700000066],
            [122.50818906200004, 10.414171795000073],
            [122.50563033900005, 10.415288023000073],
            [122.50728722100007, 10.418128524000053],
        ],
        [
            [122.5054030010001, 10.418815042000062],
            [122.50602142700006, 10.417844485000046],
            [122.50552180600005, 10.417410854000025],
            [122.5044544320001, 10.418113951000066],
            [122.5054030010001, 10.418815042000062],
        ],
        [
            [122.5046741760001, 10.419923985000025],
            [122.50279076000004, 10.416524071000026],
            [122.50556566600005, 10.415658233000045],
            [122.50189176000003, 10.415076459000034],
            [122.5046741760001, 10.419923985000025],
        ],
        [
            [122.50154573400005, 10.419940698000062],
            [122.50227132300006, 10.419417431000056],
            [122.50207474500007, 10.418894501000068],
            [122.50120272800007, 10.41953591500004],
            [122.50154573400005, 10.419940698000062],
        ],
        [
            [121.91984305200003, 10.420306678000031],
            [121.92299815900003, 10.418322411000076],
            [121.91943633900007, 10.41476059100006],
            [121.91629355600003, 10.417348765000042],
            [121.91984305200003, 10.420306678000031],
        ],
        [
            [122.50678806000008, 10.420697451000024],
            [122.50816285500002, 10.420078707000073],
            [122.50818138500006, 10.418301402000054],
            [122.5053681170001, 10.419068380000056],
            [122.50678806000008, 10.420697451000024],
        ],
        [
            [122.50131716100009, 10.420622363000064],
            [122.50130034600011, 10.42014385300007],
            [122.50101749800001, 10.42017641800004],
            [122.50115982300008, 10.42093666900007],
            [122.50131716100009, 10.420622363000064],
        ],
        [
            [122.50279122400002, 10.42226985600007],
            [122.5040375850001, 10.421478335000074],
            [122.5025452320001, 10.420389966000073],
            [122.50193444900003, 10.421325633000038],
            [122.50279122400002, 10.42226985600007],
        ],
        [
            [122.50680460300009, 10.422496208000041],
            [122.50722600200004, 10.420797203000063],
            [122.50672388800001, 10.42092716600007],
            [122.50373500400008, 10.419776399000057],
            [122.50299816300003, 10.420229494000068],
            [122.50237785900003, 10.41965908800006],
            [122.50317501200004, 10.420679236000069],
            [122.50512058900006, 10.420927341000038],
            [122.50423257200009, 10.421914486000048],
            [122.50680460300009, 10.422496208000041],
        ],
        [
            [122.49902546900012, 10.428828615000043],
            [122.50289164000003, 10.42658175300005],
            [122.49928528800001, 10.424962293000021],
            [122.50193692300002, 10.422176144000048],
            [122.50037844300005, 10.42088115100006],
            [122.5016942640001, 10.417992397000035],
            [122.500400409, 10.416643360000023],
            [122.49734931300009, 10.428018229000031],
            [122.49902546900012, 10.428828615000043],
        ],
        [
            [122.6658900000001, 10.427140001000055],
            [122.66316, 10.42955],
            [122.66279, 10.434020001000022],
            [122.66686, 10.43004],
            [122.6658900000001, 10.427140001000055],
        ],
        [
            [122.65295, 10.43707],
            [122.6506, 10.43394],
            [122.64793, 10.43581],
            [122.65218, 10.43786],
            [122.65295, 10.43707],
        ],
        [
            [122.504707832, 10.440160552000066],
            [122.50571694000007, 10.438940925000054],
            [122.50532929200006, 10.43683698700005],
            [122.50285666100001, 10.439327931000037],
            [122.504707832, 10.440160552000066],
        ],
        [
            [122.64599796900006, 10.441500285000075],
            [122.64442736900003, 10.442492325000046],
            [122.64467004900007, 10.444112881000024],
            [122.64566196500004, 10.443082968000056],
            [122.64599796900006, 10.441500285000075],
        ],
        [
            [122.50420080800006, 10.446926057000042],
            [122.50452344100006, 10.446796339000059],
            [122.50390022500005, 10.446429256000044],
            [122.50388727100005, 10.446694757000046],
            [122.50420080800006, 10.446926057000042],
        ],
        [
            [122.50372262600001, 10.450406878000024],
            [122.50600846700002, 10.449235314000077],
            [122.5056411280001, 10.447467827000025],
            [122.50297306700008, 10.44776564700004],
            [122.50372262600001, 10.450406878000024],
        ],
        [
            [122.647185379, 10.452684538000028],
            [122.64639234200001, 10.450206094000066],
            [122.64269656800002, 10.450362406000067],
            [122.64260922400001, 10.451529110000024],
            [122.647185379, 10.452684538000028],
        ],
        [
            [122.65334, 10.45753],
            [122.65087, 10.4588],
            [122.65114, 10.46048],
            [122.65311, 10.46022],
            [122.65334, 10.45753],
        ],
        [
            [122.67854000000011, 10.46167],
            [122.67554, 10.46229],
            [122.67511999900012, 10.46309],
            [122.67784, 10.463780001000032],
            [122.67854000000011, 10.46167],
        ],
        [
            [122.70597000100008, 10.47458],
            [122.72813, 10.45316],
            [122.68332999900008, 10.443620001000056],
            [122.68681, 10.46795],
            [122.70597000100008, 10.47458],
        ],
        [
            [123.44602621000001, 10.48041868000007],
            [123.45041004400002, 10.46796864700002],
            [123.42153191600005, 10.435590193000053],
            [123.41643708800007, 10.446444837000058],
            [123.44602621000001, 10.48041868000007],
        ],
        [
            [122.7205323500001, 10.490111659000036],
            [122.71996290100003, 10.49015577800003],
            [122.71988618600005, 10.490615064000053],
            [122.72052921700003, 10.490580371000021],
            [122.7205323500001, 10.490111659000036],
        ],
        [
            [122.72637653000004, 10.500406177000059],
            [122.72593879500005, 10.500556895000045],
            [122.72633290700003, 10.501331604000029],
            [122.72669943800008, 10.500766609000038],
            [122.72637653000004, 10.500406177000059],
        ],
        [
            [122.72601999900007, 10.496740001000035],
            [122.7259600000001, 10.491790001000027],
            [122.7131, 10.49644],
            [122.71888000100012, 10.501620001000049],
            [122.72601999900007, 10.496740001000035],
        ],
        [
            [122.72125163900012, 10.503197354000065],
            [122.71999081600006, 10.503906809000057],
            [122.72076513400009, 10.50506000200005],
            [122.72214912800007, 10.50439665600004],
            [122.72125163900012, 10.503197354000065],
        ],
        [
            [122.74132999900007, 10.50079],
            [122.73845, 10.503270001000033],
            [122.74270999900011, 10.507080001000077],
            [122.74350999900003, 10.50243],
            [122.74132999900007, 10.50079],
        ],
        [
            [122.73359, 10.51535],
            [122.73995, 10.51335],
            [122.7386, 10.50521],
            [122.73096999900008, 10.51383],
            [122.73359, 10.51535],
        ],
        [
            [122.51863748800008, 10.54627602200003],
            [122.51868193300004, 10.545363632000033],
            [122.51775101200008, 10.544986835000032],
            [122.51733241300008, 10.545809334000069],
            [122.51863748800008, 10.54627602200003],
        ],
        [
            [122.51726454800007, 10.559300773000075],
            [122.517029965, 10.559492947000024],
            [122.5172034840001, 10.559942970000066],
            [122.51738408800009, 10.559556108000038],
            [122.51726454800007, 10.559300773000075],
        ],
        [
            [122.51855938000006, 10.56107933900006],
            [122.51920404600003, 10.559949514000039],
            [122.51840132000007, 10.557581072000062],
            [122.51739360400006, 10.559912907000069],
            [122.51855938000006, 10.56107933900006],
        ],
        [
            [122.51460159800001, 10.561621097000057],
            [122.51454828100009, 10.561110446000043],
            [122.51379560300006, 10.561864936000063],
            [122.51420045000009, 10.561951412000042],
            [122.51460159800001, 10.561621097000057],
        ],
        [
            [122.51118719400006, 10.568201424000051],
            [122.51098988400008, 10.566225342000052],
            [122.51037558900009, 10.565882143000067],
            [122.51079727400008, 10.569871136000074],
            [122.51118719400006, 10.568201424000051],
        ],
        [
            [122.69582012700005, 10.725657196000043],
            [122.69672664100005, 10.725585952000074],
            [122.69642877600006, 10.724501418000045],
            [122.69573448100004, 10.724978673000066],
            [122.69582012700005, 10.725657196000043],
        ],
        [
            [122.65824598000006, 10.754189134000057],
            [122.7221184870001, 10.69254769500003],
            [122.72692556000004, 10.616411396000046],
            [122.68261722200009, 10.502248333000068],
            [122.62745649700003, 10.434586525000043],
            [122.58152524200011, 10.428859286000034],
            [122.59386115100006, 10.445190197000045],
            [122.5820978380001, 10.454187683000043],
            [122.51438187800011, 10.40676940700007],
            [122.50748075100012, 10.469404378000036],
            [122.48582236100003, 10.463718339000025],
            [122.47469464100004, 10.481094578000068],
            [122.54387465500008, 10.540329597000039],
            [122.52216039400003, 10.539991266000072],
            [122.52856445000009, 10.553632076000042],
            [122.51115626100011, 10.582875983000065],
            [122.65824598000006, 10.754189134000057],
        ],
        [
            [122.48976197700006, 10.474659256000052],
            [122.488887266, 10.475109260000067],
            [122.48799230800012, 10.474129093000045],
            [122.48972136300006, 10.47362914100006],
            [122.48976197700006, 10.474659256000052],
        ],
        [
            [122.48260658100003, 10.47573638700004],
            [122.48086775500008, 10.477336335000075],
            [122.48017675000006, 10.477106123000056],
            [122.48046670700012, 10.475188211000045],
            [122.48260658100003, 10.47573638700004],
        ],
        [
            [122.48012086300002, 10.478925424000067],
            [122.47967500800007, 10.479319927000063],
            [122.47998723700005, 10.477643143000023],
            [122.48056670500011, 10.478651476000039],
            [122.48012086300002, 10.478925424000067],
        ],
        [
            [122.53672359100005, 10.550126050000074],
            [122.53651073900005, 10.550084447000074],
            [122.5364898680001, 10.549873773000058],
            [122.53651646000003, 10.549801152000043],
            [122.5367973220001, 10.549892364000073],
            [122.53672359100005, 10.550126050000074],
        ],
        [
            [122.65492255800007, 10.734982028000047],
            [122.65453623700012, 10.734262458000046],
            [122.65523885800008, 10.73389596900006],
            [122.65552834300001, 10.734139422000055],
            [122.65492255800007, 10.734982028000047],
        ],
        [
            [123.5395186080001, 10.851218316000029],
            [123.5391712060001, 10.851008923000052],
            [123.53805999800011, 10.851161209000054],
            [123.53889280900012, 10.852262899000038],
            [123.5395186080001, 10.851218316000029],
        ],
        [
            [123.5652092570001, 10.874840179000046],
            [123.56477648600003, 10.873994788000061],
            [123.56027312000003, 10.871652655000048],
            [123.56210853000005, 10.87389678300002],
            [123.5652092570001, 10.874840179000046],
        ],
        [
            [123.50889475400004, 10.909718209000062],
            [123.50896057200009, 10.908730425000044],
            [123.5055064930001, 10.908699355000067],
            [123.50776370900007, 10.909851870000068],
            [123.50889475400004, 10.909718209000062],
        ],
        [
            [123.50957897100011, 10.910483641000042],
            [123.50963537300004, 10.909620442000062],
            [123.50855445800005, 10.910197838000045],
            [123.50880485100004, 10.910370976000024],
            [123.50957897100011, 10.910483641000042],
        ],
        [
            [123.503817163, 10.938127241000075],
            [123.51199312200004, 10.936900304000062],
            [123.51374444400005, 10.932229892000066],
            [123.50251704200002, 10.928226281000036],
            [123.503817163, 10.938127241000075],
        ],
        [
            [123.45400088600002, 10.952469675000032],
            [123.45747322500006, 10.951959233000025],
            [123.45831122400011, 10.949759013000062],
            [123.45534078300011, 10.948021919000041],
            [123.45400088600002, 10.952469675000032],
        ],
        [
            [123.57014255500007, 10.953080499000066],
            [123.57150676300012, 10.952420764000067],
            [123.57077249000008, 10.949942504000035],
            [123.5694342700001, 10.950391636000063],
            [123.57014255500007, 10.953080499000066],
        ],
        [
            [123.56950351000012, 10.95342110300004],
            [123.56972919900011, 10.953221920000033],
            [123.5693770470001, 10.951800672000047],
            [123.56916343800003, 10.95241702900006],
            [123.56950351000012, 10.95342110300004],
        ],
        [
            [123.57088979900004, 10.953026192000038],
            [123.57060211800001, 10.953127400000028],
            [123.57063453700005, 10.953422437000029],
            [123.57095309100009, 10.953351046000023],
            [123.57088979900004, 10.953026192000038],
        ],
        [
            [123.57038255300006, 10.953560768000045],
            [123.57053899400012, 10.953389805000029],
            [123.57044533500004, 10.953095263000023],
            [123.57013930800008, 10.953280798000037],
            [123.57038255300006, 10.953560768000045],
        ],
        [
            [123.56845186500004, 10.95384866300003],
            [123.56925832500008, 10.951587328000073],
            [123.56855343900008, 10.949836907000076],
            [123.56800625400001, 10.951783617000046],
            [123.56845186500004, 10.95384866300003],
        ],
        [
            [123.56364943200003, 10.954330691000052],
            [123.56761899900005, 10.953786782000066],
            [123.56771262000007, 10.949813092000056],
            [123.563592287, 10.951762678000023],
            [123.56364943200003, 10.954330691000052],
        ],
        [
            [123.54281995800011, 10.968353015000048],
            [123.54297599000006, 10.966348205000031],
            [123.54250611600003, 10.965415860000064],
            [123.54149204500004, 10.967348581000067],
            [123.54281995800011, 10.968353015000048],
        ],
        [
            [123.54309382100007, 10.969116619000033],
            [123.54315805200008, 10.968818923000072],
            [123.5428909090001, 10.968879045000051],
            [123.5429220960001, 10.969092155000055],
            [123.54309382100007, 10.969116619000033],
        ],
        [
            [123.54397150300008, 10.970589950000033],
            [123.54384103300004, 10.970630248000077],
            [123.5438687620001, 10.970821663000038],
            [123.54398160900007, 10.970789882000076],
            [123.54397150300008, 10.970589950000033],
        ],
        [
            [123.54475868200007, 10.970666860000051],
            [123.56266275300004, 10.970631063000042],
            [123.57266334600001, 10.954087082000058],
            [123.55904922000002, 10.955178734000071],
            [123.55312681600003, 10.950619585000027],
            [123.54475868200007, 10.970666860000051],
        ],
        [
            [123.54821578000008, 10.966792436000048],
            [123.54776200600008, 10.96662808000002],
            [123.54832799100006, 10.965309414000046],
            [123.54870126600008, 10.966089053000076],
            [123.54821578000008, 10.966792436000048],
        ],
        [
            [123.54798387500011, 10.96801560800003],
            [123.54809934700006, 10.967254953000065],
            [123.54847275700001, 10.967336626000076],
            [123.5485522250001, 10.967787790000045],
            [123.54798387500011, 10.96801560800003],
        ],
        [
            [123.54796486400005, 10.969007416000068],
            [123.54737229300008, 10.96879903000007],
            [123.54762528900005, 10.968058713000062],
            [123.54826502600008, 10.968438741000057],
            [123.54796486400005, 10.969007416000068],
        ],
        [
            [123.53958896400002, 10.976996606000057],
            [123.53999049200002, 10.97695755500007],
            [123.54084171500006, 10.976188878000073],
            [123.53919401300004, 10.976620173000072],
            [123.53958896400002, 10.976996606000057],
        ],
        [
            [123.54133111300007, 10.978961088000062],
            [123.5450593170001, 10.978107591000025],
            [123.544551038, 10.974667145000069],
            [123.54227966000008, 10.97547609000003],
            [123.54133111300007, 10.978961088000062],
        ],
        [
            [123.46463756600008, 10.97823014200003],
            [123.46475479900005, 10.977734167000051],
            [123.46440761300005, 10.977209757000026],
            [123.46455888600008, 10.97771853300003],
            [123.46412585100006, 10.97853308200007],
            [123.46423152400007, 10.979240871000059],
            [123.46463756600008, 10.97823014200003],
        ],
        [
            [123.33591507200003, 10.382476470000029],
            [123.23662027800003, 10.437750262000066],
            [123.14432497400003, 10.434843284000067],
            [123.18881825200003, 10.260563292000029],
            [123.01579588600009, 10.01218724100005],
        ],
        [
            [123.01579588600009, 10.01218724100005],
            [122.98320250300003, 9.912625363000075],
        ],
        [
            [122.98320250300003, 9.912625363000075],
            [122.5813035010001, 9.44544286100006],
            [122.4805874110001, 9.564879544000064],
            [122.46627948000003, 9.624726729000031],
            [122.44334345800007, 9.620266196000046],
            [122.45697282700007, 9.661501175000069],
            [122.40833191400009, 9.659451980000028],
            [122.42048606900005, 9.702184639000052],
            [122.381360717, 9.705865298000049],
            [122.38906652300011, 9.79056424600003],
            [122.40436589700005, 9.804277075000073],
            [122.37606729400011, 9.83657985900004],
            [122.43560177100005, 9.903903040000046],
            [122.4508442770001, 9.976342267000064],
            [122.66070431300011, 9.977045273000044],
            [122.78439505900008, 10.075423121000028],
            [122.82342271100003, 10.060509811000031],
            [122.86775279800008, 10.095118616000036],
            [122.838004984, 10.22889239500006],
            [122.86677783900006, 10.378945846000022],
            [122.7933035320001, 10.518829984000035],
            [122.8804914750001, 10.56375663600005],
            [122.94957537200003, 10.680898738000053],
            [122.95229668400009, 10.894315050000046],
            [123.07163828600005, 10.913265370000033],
            [123.20098259000008, 11.002791339000055],
            [123.31955225700005, 10.948493339000038],
            [123.37324315400008, 10.961181043000067],
            [123.42883217000008, 10.950518639000052],
            [123.46506553300003, 10.915591211000049],
            [123.49290485600011, 10.935020939000026],
            [123.53210889600007, 10.836908554000047],
            [123.5657442810001, 10.843775748000041],
            [123.46387176300004, 10.522072703000049],
            [123.367199045, 10.451813768000022],
            [123.33591507200003, 10.382476470000029],
        ],
        [
            [122.4968432280001, 9.556070453000075],
            [122.49390870600007, 9.55370202000006],
            [122.49608755200006, 9.548862471000064],
            [122.49990636900009, 9.551610148000066],
            [122.4968432280001, 9.556070453000075],
        ],
        [
            [122.38320831300007, 9.714224139000066],
            [122.38262020200011, 9.714239297000063],
            [122.38249900700009, 9.71401935700004],
            [122.38271570900008, 9.713840151000056],
            [122.38320831300007, 9.714224139000066],
        ],
        [
            [122.38676895100002, 9.725344047000021],
            [122.38719091500002, 9.724365818000024],
            [122.387800362, 9.724398070000063],
            [122.38793673400005, 9.725014070000043],
            [122.38676895100002, 9.725344047000021],
        ],
        [
            [122.38745541000003, 9.727022418000047],
            [122.3870694850001, 9.727465061000032],
            [122.38725047700007, 9.726689618000023],
            [122.38784736700006, 9.726548578000063],
            [122.38778703300011, 9.726833800000065],
            [122.38745541000003, 9.727022418000047],
        ],
        [
            [122.38719958900003, 9.727621990000046],
            [122.38733464000006, 9.727814924000029],
            [122.38717692000012, 9.727948931000071],
            [122.3870726770001, 9.727786339000033],
            [122.38719958900003, 9.727621990000046],
        ],
        [
            [122.394274386, 9.729732033000062],
            [122.39399728100011, 9.72950594200006],
            [122.39394476200005, 9.729202959000077],
            [122.39446556700011, 9.729333324000038],
            [122.394274386, 9.729732033000062],
        ],
        [
            [122.39171319900004, 9.729793095000048],
            [122.39153670600001, 9.729863394000063],
            [122.39170883500003, 9.72958176800006],
            [122.39177829900007, 9.729605118000052],
            [122.39171319900004, 9.729793095000048],
        ],
        [
            [122.39249422700004, 9.730397766000067],
            [122.39235445100007, 9.730320147000043],
            [122.39249747600002, 9.730157051000049],
            [122.3926420570001, 9.73035502700003],
            [122.39249422700004, 9.730397766000067],
        ],
        [
            [122.3905507400001, 9.730470788000048],
            [122.38970879700003, 9.729974514000048],
            [122.38961655700007, 9.729644395000037],
            [122.39042995500006, 9.729501207000055],
            [122.3905507400001, 9.730470788000048],
        ],
        [
            [122.39402297700008, 9.730871449000063],
            [122.39357119600004, 9.73058499900003],
            [122.39362075800011, 9.73007989000007],
            [122.39416032000008, 9.73057060900004],
            [122.39402297700008, 9.730871449000063],
        ],
        [
            [122.39069998000002, 9.731202996000036],
            [122.39061079600003, 9.73177636500003],
            [122.39016506000007, 9.730699896000033],
            [122.39049625700011, 9.730646343000046],
            [122.39069998000002, 9.731202996000036],
        ],
        [
            [122.38852840100003, 9.736282533000065],
            [122.388196622, 9.735662277000074],
            [122.38890688300012, 9.73419061900006],
            [122.38920153000004, 9.735315367000055],
            [122.38852840100003, 9.736282533000065],
        ],
        [
            [122.39571577600009, 9.736452846000077],
            [122.39581676300008, 9.736679414000037],
            [122.39556562400003, 9.736831331000076],
            [122.39544869100007, 9.736543211000026],
            [122.39571577600009, 9.736452846000077],
        ],
        [
            [122.39351396500001, 9.73780664700007],
            [122.3896026220001, 9.73654549400004],
            [122.39324417700004, 9.734356540000022],
            [122.39278374000003, 9.736029980000069],
            [122.39351396500001, 9.73780664700007],
        ],
        [
            [122.40284428500001, 9.75817857900006],
            [122.40158691600004, 9.758012201000042],
            [122.40127399500011, 9.75732626000007],
            [122.40333163600008, 9.757833719000075],
            [122.40284428500001, 9.75817857900006],
        ],
        [
            [122.38897965400008, 9.789340605000064],
            [122.38900581300004, 9.788741363000042],
            [122.38964872400004, 9.789120658000058],
            [122.38956168800007, 9.789414478000026],
            [122.38897965400008, 9.789340605000064],
        ],
        [
            [123.40020292500003, 10.944533569000043],
            [123.39824536100002, 10.94475682600006],
            [123.39753317100008, 10.943417357000044],
            [123.39898247600001, 10.943427280000037],
            [123.40020292500003, 10.944533569000043],
        ],
        [
            [123.39954167500002, 10.949714507000067],
            [123.39853839700004, 10.948309209000058],
            [123.398045453, 10.944893361000027],
            [123.40019672400001, 10.945402410000042],
            [123.39954167500002, 10.949714507000067],
        ],
        [
            [123.39641868700005, 10.95567019200007],
            [123.39509454900008, 10.954214678000028],
            [123.3973124370001, 10.949472289000028],
            [123.40088023300007, 10.954219849000026],
            [123.39641868700005, 10.95567019200007],
        ],
        [
            [123.19713030600008, 11.044568200000072],
            [123.20175009700006, 11.042314938000061],
            [123.20599353700004, 11.042317953000065],
            [123.1998888280001, 11.040517048000027],
            [123.19713030600008, 11.044568200000072],
        ],
        [
            [123.01329147900003, 11.078642609000042],
            [123.01479519700001, 11.072129851000057],
            [123.01281943100003, 11.069251757000075],
            [123.01107719600009, 11.07371949800006],
            [123.01329147900003, 11.078642609000042],
        ],
        [
            [123.02293658100007, 11.08130764200007],
            [123.02224129800004, 11.078844547000074],
            [123.02303425900004, 11.07334107500003],
            [123.01862143700009, 11.080117692000044],
            [123.02293658100007, 11.08130764200007],
        ],
        [
            [123.1540192440001, 11.097371244000044],
            [123.15687917700006, 11.09548953500007],
            [123.1552272020001, 11.093707876000053],
            [123.152949497, 11.095670007000024],
            [123.1540192440001, 11.097371244000044],
        ],
        [
            [123.04780822200007, 11.134621103000029],
            [123.04897911400008, 11.132034107000038],
            [123.04562868200003, 11.132544169000028],
            [123.04698149900003, 11.134901566000053],
            [123.04780822200007, 11.134621103000029],
        ],
        [
            [123.04857868300007, 11.142496650000055],
            [123.04760271000009, 11.144773944000065],
            [123.04845101300009, 11.147706389000064],
            [123.04988099400009, 11.146000405000052],
            [123.04857868300007, 11.142496650000055],
        ],
        [
            [123.14504718400008, 11.15431129600006],
            [123.15238630100009, 11.142141724000055],
            [123.14316468700008, 11.140603633000069],
            [123.12641337100001, 11.103542051000034],
            [123.12075939100009, 11.097954105000042],
            [123.11611571500009, 11.100083655000049],
            [123.10783520100006, 11.136185311000077],
            [123.14504718400008, 11.15431129600006],
        ],
        [
            [123.16978854000001, 11.180145180000068],
            [123.16853836000007, 11.179859155000031],
            [123.16810102600004, 11.18116742500007],
            [123.16949704000001, 11.181494368000074],
            [123.16978854000001, 11.180145180000068],
        ],
        [
            [123.17766032100008, 11.187878248000061],
            [123.1767432040001, 11.183486921000053],
            [123.17320542100003, 11.185270268000068],
            [123.17325121200008, 11.187140825000029],
            [123.17766032100008, 11.187878248000061],
        ],
        [
            [123.15899452400004, 11.187175012000068],
            [123.1601738920001, 11.182769645000064],
            [123.1562308880001, 11.178127674000052],
            [123.15594898400002, 11.182546393000052],
            [123.1582850740001, 11.184969228000057],
            [123.15832917000012, 11.187066210000069],
            [123.15899765800009, 11.188199059000056],
            [123.159856439, 11.18911836500007],
            [123.15899452400004, 11.187175012000068],
        ],
        [
            [123.33822044200008, 11.203001482000047],
            [123.34156725600008, 11.20060281000002],
            [123.34057470200003, 11.197841706000077],
            [123.33752649400003, 11.20115019800005],
            [123.33822044200008, 11.203001482000047],
        ],
        [
            [123.16699863400004, 11.22311217400005],
            [123.1902720380001, 11.219237630000066],
            [123.17242433500007, 11.192680213000074],
            [123.15671619700004, 11.211050710000052],
            [123.16699863400004, 11.22311217400005],
        ],
        [
            [123.19693000100006, 11.22803574300002],
            [123.19593853200001, 11.223986221000075],
            [123.19259944200007, 11.226999118000037],
            [123.19558426800006, 11.228644064000036],
            [123.19693000100006, 11.22803574300002],
        ],
        [
            [123.16018010900007, 11.23448974400003],
            [123.16212771000005, 11.229307794000022],
            [123.15494270300007, 11.22881338700006],
            [123.15548869500003, 11.233413118000044],
            [123.16018010900007, 11.23448974400003],
        ],
        [
            [123.19500995500005, 11.238320968000039],
            [123.19602949500006, 11.236693477000074],
            [123.1953070830001, 11.235801988000048],
            [123.19455553300008, 11.237840971000026],
            [123.19500995500005, 11.238320968000039],
        ],
        [
            [123.21570988500002, 11.249687867000034],
            [123.21368296100002, 11.235508038000035],
            [123.19832350000001, 11.235394295000049],
            [123.20189932100004, 11.245348368000066],
            [123.21570988500002, 11.249687867000034],
        ],
        [
            [123.17692011300005, 11.264694235000036],
            [123.17958648100011, 11.263388012000064],
            [123.17611553100005, 11.256412281000053],
            [123.17248150400007, 11.26024688800004],
            [123.17692011300005, 11.264694235000036],
        ],
        [
            [123.10431842800006, 11.267372086000023],
            [123.1034324310001, 11.267496276000031],
            [123.10319738400005, 11.267753423000045],
            [123.10436371000003, 11.268489272000068],
            [123.10431842800006, 11.267372086000023],
        ],
        [
            [123.10744876500007, 11.273403896000048],
            [123.10725548100004, 11.272737150000069],
            [123.10617482500004, 11.272589843000048],
            [123.10631085700004, 11.27331976000005],
            [123.10744876500007, 11.273403896000048],
        ],
        [
            [123.15349896500004, 11.30488938700006],
            [123.15383746600003, 11.304665754000041],
            [123.15389522300006, 11.30426751300007],
            [123.15311802100007, 11.304395166000063],
            [123.15349896500004, 11.30488938700006],
        ],
        [
            [123.15161965000004, 11.309573218000025],
            [123.15139484100007, 11.306014818000051],
            [123.14877581600001, 11.305676865000066],
            [123.14829743000007, 11.308043682000061],
            [123.15161965000004, 11.309573218000025],
        ],
        [
            [123.16132519100006, 11.312650741000027],
            [123.1940586500001, 11.292042125000023],
            [123.14969876000009, 11.247398876000034],
            [123.1534201390001, 11.303381666000064],
            [123.16132519100006, 11.312650741000027],
        ],
        [
            [123.16995607900003, 11.315464690000056],
            [123.170087996, 11.314456106000023],
            [123.16816483900004, 11.313611791000028],
            [123.16872918700005, 11.314815324000051],
            [123.16995607900003, 11.315464690000056],
        ],
        [
            [123.17608380100012, 11.319845600000065],
            [123.18117979700003, 11.31951902700007],
            [123.17816974700008, 11.315564547000065],
            [123.17312280700003, 11.315518901000075],
            [123.17608380100012, 11.319845600000065],
        ],
        [
            [123.18129952900006, 11.324745116000031],
            [123.18104642100002, 11.324923604000048],
            [123.18123284800004, 11.325134254000034],
            [123.18131381500007, 11.325099776000059],
            [123.18129952900006, 11.324745116000031],
        ],
        [
            [123.18060998900012, 11.325666333000072],
            [123.18087956600004, 11.324789510000073],
            [123.17925812700003, 11.324661078000076],
            [123.17962960500006, 11.325386103000028],
            [123.18060998900012, 11.325666333000072],
        ],
        [
            [123.16170287800003, 11.388325485000053],
            [123.1651054130001, 11.386185897000075],
            [123.16359112100008, 11.384178890000044],
            [123.15738874200008, 11.387658415000033],
            [123.16170287800003, 11.388325485000053],
        ],
        [
            [123.14762856800007, 11.40164064000004],
            [123.1477138670001, 11.401048142000036],
            [123.14705388300001, 11.401454067000032],
            [123.14747199800001, 11.401710555000022],
            [123.14762856800007, 11.40164064000004],
        ],
        [
            [122.0148239880001, 11.411713190000057],
            [122.01515985800006, 11.411015616000043],
            [122.01393694900003, 11.410274981000043],
            [122.01376470900004, 11.411136184000043],
            [122.0148239880001, 11.411713190000057],
        ],
        [
            [123.14222731600012, 11.41346817300007],
            [123.14495233200012, 11.412030252000022],
            [123.14328744800002, 11.409006415000022],
            [123.14221193800006, 11.410309],
            [123.14222731600012, 11.41346817300007],
        ],
        [
            [122.02448243000003, 11.41704300300006],
            [122.0268166190001, 11.416890884000054],
            [122.02800239100009, 11.415920742000026],
            [122.02803334300006, 11.415146368000023],
            [122.01572147200011, 11.409582134000061],
            [122.02448243000003, 11.41704300300006],
        ],
        [
            [123.18033081800002, 11.423705919000042],
            [123.18022146300007, 11.42279359500003],
            [123.179442676, 11.423148751000042],
            [123.17960456000003, 11.423705046000066],
            [123.18033081800002, 11.423705919000042],
        ],
        [
            [123.17451371600009, 11.438079081000069],
            [123.17662104500005, 11.437328868000066],
            [123.17390499900011, 11.43502464200003],
            [123.17270320900002, 11.437852813000063],
            [123.17451371600009, 11.438079081000069],
        ],
        [
            [123.15854390800007, 11.438304157000061],
            [123.1595029130001, 11.438127803000043],
            [123.15926613900001, 11.437395890000062],
            [123.15792946800002, 11.437436737000041],
            [123.15854390800007, 11.438304157000061],
        ],
        [
            [123.16648688300006, 11.438523995000025],
            [123.16899019100003, 11.437780382000028],
            [123.16930341500006, 11.43699575200003],
            [123.16835808700012, 11.436652412000058],
            [123.16648688300006, 11.438523995000025],
        ],
        [
            [123.18663191100006, 11.439298804000032],
            [123.18779501600011, 11.435618371000032],
            [123.17945949300008, 11.424691042000063],
            [123.17752463500005, 11.432964002000062],
            [123.18663191100006, 11.439298804000032],
        ],
        [
            [123.28438654000001, 11.458378312000036],
            [123.28422983300004, 11.455252496000071],
            [123.27783564900005, 11.455822653000041],
            [123.281566053, 11.458041739000066],
            [123.28438654000001, 11.458378312000036],
        ],
        [
            [123.25098151000009, 11.466130501000066],
            [123.27737396400005, 11.446605505000036],
            [123.26086343800011, 11.423295869000071],
            [123.2431020040001, 11.448617974000058],
            [123.25098151000009, 11.466130501000066],
        ],
        [
            [123.17117664500006, 11.466196773000036],
            [123.17416762800008, 11.463288539000075],
            [123.17384984000012, 11.456813253000064],
            [123.16450029500004, 11.461802633000048],
            [123.17117664500006, 11.466196773000036],
        ],
        [
            [123.18923745600011, 11.475315763000026],
            [123.19093440300003, 11.474139438000066],
            [123.19109155700005, 11.469328826000037],
            [123.18519468800002, 11.470573725000065],
            [123.18923745600011, 11.475315763000026],
        ],
        [
            [121.92588643600004, 11.479078378000054],
            [121.92983347900008, 11.477007662000062],
            [121.93112579800004, 11.47456670500003],
            [121.93118453000011, 11.47367126000006],
            [121.91549604000011, 11.462873917000024],
            [121.8900708320001, 11.470806862000074],
            [121.92588643600004, 11.479078378000054],
        ],
        [
            [123.1974023780001, 11.488040678000061],
            [123.19697821500006, 11.487769982000032],
            [123.19684860200005, 11.488126254000065],
            [123.19712369700005, 11.48826278100006],
            [123.1974023780001, 11.488040678000061],
        ],
        [
            [123.25651419700012, 11.48838315100005],
            [123.25693353600002, 11.484500463000074],
            [123.25030083200011, 11.484770180000055],
            [123.25092167300011, 11.485597730000052],
            [123.25651419700012, 11.48838315100005],
        ],
        [
            [123.18569223500003, 11.493560676000072],
            [123.18356108800003, 11.490485974000023],
            [123.1813397300001, 11.49269630200007],
            [123.18434696300005, 11.493764879000025],
            [123.18569223500003, 11.493560676000072],
        ],
        [
            [123.19078320100004, 11.493877593000036],
            [123.19622335100007, 11.487932200000046],
            [123.1847364140001, 11.476432834000036],
            [123.18052565000005, 11.482790145000024],
            [123.19078320100004, 11.493877593000036],
        ],
        [
            [123.1854356120001, 11.496120035000047],
            [123.18545384800007, 11.495585510000069],
            [123.18452838500002, 11.495046850000051],
            [123.18460970400008, 11.495776498000055],
            [123.1854356120001, 11.496120035000047],
        ],
        [
            [123.1774111100001, 11.497886852000022],
            [123.17990080900006, 11.495695782000041],
            [123.17341813700011, 11.491273429000046],
            [123.17314896100004, 11.493406359000062],
            [123.1774111100001, 11.497886852000022],
        ],
        [
            [123.18389670400006, 11.502001810000024],
            [123.18433991500001, 11.501165351000054],
            [123.18404950900003, 11.500860440000054],
            [123.18298640800003, 11.500584309000033],
            [123.18389670400006, 11.502001810000024],
        ],
        [
            [123.229012151, 11.515967899000032],
            [123.23936216800007, 11.50718108600006],
            [123.23526503900007, 11.464959382000075],
            [123.20572117100005, 11.460845392000067],
            [123.1986462860001, 11.503453878000073],
            [123.229012151, 11.515967899000032],
        ],
        [
            [123.19800471200006, 11.517505185000061],
            [123.19824302000006, 11.516299161000063],
            [123.19730429700007, 11.516138500000068],
            [123.19737332800003, 11.517099729000051],
            [123.19800471200006, 11.517505185000061],
        ],
        [
            [123.12424847000011, 11.518923907000044],
            [123.12929442200004, 11.51757933600004],
            [123.13728479200006, 11.499473486000056],
            [123.1227993440001, 11.511594393000053],
            [123.12424847000011, 11.518923907000044],
        ],
        [
            [123.1877501140001, 11.53775593100005],
            [123.19096124400005, 11.51212098800005],
            [123.15457002100004, 11.491927266000062],
            [123.166779786, 11.52388729300003],
            [123.1877501140001, 11.53775593100005],
        ],
        [
            [123.1967409230001, 11.539942077000035],
            [123.2006366600001, 11.533713427000066],
            [123.19216261800011, 11.529079755000055],
            [123.19559505300003, 11.535095277000039],
            [123.1967409230001, 11.539942077000035],
        ],
        [
            [123.1936851260001, 11.543818120000026],
            [123.1941607650001, 11.542630203000044],
            [123.19335406400012, 11.542131330000075],
            [123.19322559300008, 11.54385097100004],
            [123.1936851260001, 11.543818120000026],
        ],
        [
            [123.34570831000008, 11.554522621000046],
            [123.3447702840001, 11.55667425400003],
            [123.3469395080001, 11.560494131000041],
            [123.34682016900001, 11.555966216000058],
            [123.34570831000008, 11.554522621000046],
        ],
        [
            [123.2373726510001, 11.560690734000048],
            [123.23846327600006, 11.558611507000023],
            [123.22565492800004, 11.545091371000069],
            [123.23032912600002, 11.554857049000077],
            [123.2373726510001, 11.560690734000048],
        ],
        [
            [123.34902373700004, 11.569876448000059],
            [123.34940682500007, 11.567086248000066],
            [123.34740190700006, 11.564834107000024],
            [123.34677684300004, 11.569497472000023],
            [123.34902373700004, 11.569876448000059],
        ],
        [
            [123.36059093200004, 11.57282918900006],
            [123.3582463250001, 11.569653422000044],
            [123.35750785900007, 11.570064959000035],
            [123.35723458900009, 11.571232680000037],
            [123.36059093200004, 11.57282918900006],
        ],
        [
            [123.28102140400006, 11.576202495000075],
            [123.27709166200009, 11.585650484000041],
            [123.27825668100002, 11.588897068000051],
            [123.28242232500008, 11.581631342000037],
            [123.28102140400006, 11.576202495000075],
        ],
        [
            [123.21028098500005, 11.593093340000053],
            [123.21750838300011, 11.585051349000025],
            [123.20521213900008, 11.58132420000004],
            [123.203508639, 11.587170228000048],
            [123.21028098500005, 11.593093340000053],
        ],
        [
            [122.42966171700004, 11.599899739000023],
            [122.42997997400005, 11.598826770000073],
            [122.42863773500005, 11.597615426000061],
            [122.42831388500008, 11.598734357000069],
            [122.42966171700004, 11.599899739000023],
        ],
        [
            [123.35679877500002, 11.599651123000058],
            [123.35552475400004, 11.585019959000022],
            [123.32744486900003, 11.573253537000028],
            [123.32920139400005, 11.598375016000034],
            [123.35679877500002, 11.599651123000058],
        ],
        [
            [123.17880531700007, 11.60413808100003],
            [123.178917049, 11.603562113000066],
            [123.1784126660001, 11.602738738000028],
            [123.17770439500009, 11.603891426000075],
            [123.17880531700007, 11.60413808100003],
        ],
        [
            [121.68614466400004, 11.608530939000048],
            [121.69559759300012, 11.604137894000075],
            [121.69931603200007, 11.593382405000057],
            [121.6909422870001, 11.594805837000024],
            [121.68614466400004, 11.608530939000048],
        ],
        [
            [123.3614679430001, 11.610149518000071],
            [123.36196968700006, 11.609460593000051],
            [123.36015958200005, 11.608703207000076],
            [123.36036858200009, 11.60972657000002],
            [123.3614679430001, 11.610149518000071],
        ],
        [
            [122.43831121700009, 11.616457430000025],
            [122.44436808800003, 11.612472877000073],
            [122.43123273600008, 11.603428343000076],
            [122.43064175500001, 11.614075440000022],
            [122.43427342200005, 11.614258317000065],
            [122.43831121700009, 11.616457430000025],
        ],
        [
            [122.82654167900012, 11.617493072000059],
            [122.82704136600012, 11.617213486000026],
            [122.82535313800008, 11.616913079000028],
            [122.82625614300002, 11.617516867000063],
            [122.82654167900012, 11.617493072000059],
        ],
        [
            [122.43119635100004, 11.62532691000007],
            [122.43706820200009, 11.617418632000067],
            [122.42451564300006, 11.612299389000043],
            [122.42856157100005, 11.620229768000058],
            [122.42237258800003, 11.621614855000075],
            [122.43119635100004, 11.62532691000007],
        ],
        [
            [122.7443888250001, 11.625044808000041],
            [122.74278599800004, 11.625761862000047],
            [122.74540113500007, 11.627322509000066],
            [122.74510587800012, 11.626099299000032],
            [122.7443888250001, 11.625044808000041],
        ],
        [
            [122.41703593700004, 11.630473713000072],
            [122.42225586300003, 11.621794031000036],
            [122.41674133300012, 11.618692415000055],
            [122.41188057200009, 11.626413385000035],
            [122.41703593700004, 11.630473713000072],
        ],
        [
            [122.42079726600002, 11.63458706700004],
            [122.4291290000001, 11.633050413000035],
            [122.42943968000009, 11.627826758000026],
            [122.42140886800007, 11.625269758000059],
            [122.42079726600002, 11.63458706700004],
        ],
        [
            [122.82642962900002, 11.63683187600003],
            [122.82652036000002, 11.636074260000044],
            [122.82589385800009, 11.63514501800006],
            [122.82557464100012, 11.636071303000051],
            [122.82642962900002, 11.63683187600003],
        ],
        [
            [123.3715439, 11.635958085000027],
            [123.37077663000002, 11.636589307000065],
            [123.37208610500011, 11.638359366000032],
            [123.37276652900005, 11.63738778800007],
            [123.3715439, 11.635958085000027],
        ],
        [
            [123.35794147500008, 11.63871290000003],
            [123.3589625520001, 11.630270726000049],
            [123.34784928200008, 11.606139520000056],
            [123.34086494000007, 11.63066582600004],
            [123.35794147500008, 11.63871290000003],
        ],
        [
            [122.83592517900001, 11.645279892000076],
            [122.84596687900012, 11.641690911000069],
            [122.83405380400006, 11.631121526000072],
            [122.8326962000001, 11.642163466000056],
            [122.83592517900001, 11.645279892000076],
        ],
        [
            [122.40479636300006, 11.64533761000007],
            [122.41273800300007, 11.637925462000055],
            [122.40405010200004, 11.63292708800003],
            [122.39804651700001, 11.636310090000052],
            [122.40479636300006, 11.64533761000007],
        ],
        [
            [122.84152918600012, 11.645996497000056],
            [122.84172210100007, 11.64538206800006],
            [122.84119757200006, 11.64492468800006],
            [122.84097756800008, 11.645235068000034],
            [122.84152918600012, 11.645996497000056],
        ],
        [
            [122.40926039800001, 11.647427690000029],
            [122.40969574500002, 11.647303780000072],
            [122.40903899900002, 11.64685189100004],
            [122.40914318900002, 11.647516977000066],
            [122.40926039800001, 11.647427690000029],
        ],
        [
            [122.41009492900002, 11.64754227000003],
            [122.4102330830001, 11.64747085600004],
            [122.40989728200009, 11.64648986900005],
            [122.40973227200004, 11.64732615400004],
            [122.41009492900002, 11.64754227000003],
        ],
        [
            [122.40957337200007, 11.64883252900006],
            [122.40949809500012, 11.64869429600003],
            [122.40877921900005, 11.648716419000039],
            [122.40881685700003, 11.648786456000039],
            [122.40957337200007, 11.64883252900006],
        ],
        [
            [122.40962418600009, 11.649241982000035],
            [122.40968440600011, 11.649208806000047],
            [122.40971263300003, 11.649074257000052],
            [122.40959595700008, 11.649129551000044],
            [122.40962418600009, 11.649241982000035],
        ],
        [
            [122.40920641100001, 11.649629039000047],
            [122.40893918300003, 11.649568217000024],
            [122.40889966400005, 11.64958111900006],
            [122.40946611100003, 11.649704605000068],
            [122.40920641100001, 11.649629039000047],
        ],
        [
            [122.40959784100005, 11.649520012000039],
            [122.40952068800004, 11.649927341000023],
            [122.40958655300005, 11.649982634000025],
            [122.40966370900003, 11.64967114700005],
            [122.40959784100005, 11.649520012000039],
        ],
        [
            [122.42716352800005, 11.650678661000029],
            [122.43210341200006, 11.63592815900006],
            [122.45901175000006, 11.608399447000068],
            [122.41835200700007, 11.642301306000036],
            [122.42716352800005, 11.650678661000029],
        ],
        [
            [122.42446009000003, 11.65269466500007],
            [122.42320811600007, 11.651250735000076],
            [122.42253532900008, 11.651101655000048],
            [122.42307288000006, 11.652260801000068],
            [122.42446009000003, 11.65269466500007],
        ],
        [
            [122.41490747600005, 11.654771427000071],
            [122.41809194500001, 11.651091002000044],
            [122.41273879700009, 11.648168758000054],
            [122.41071044900002, 11.652887200000066],
            [122.41490747600005, 11.654771427000071],
        ],
        [
            [121.32259290000002, 11.856100799000046],
            [121.3243985040001, 11.854635081000026],
            [121.32599038800004, 11.851910221000026],
            [121.3211767030001, 11.854723074000049],
            [121.32259290000002, 11.856100799000046],
        ],
        [
            [121.31613605600012, 11.86142438500002],
            [121.3192571720001, 11.859858116000055],
            [121.32135224600006, 11.85754152100003],
            [121.31738959100005, 11.858941285000071],
            [121.31613605600012, 11.86142438500002],
        ],
        [
            [121.28730921800002, 11.865326104000076],
            [121.29406695400007, 11.861412278000046],
            [121.29515317500011, 11.856251246000056],
            [121.282674444, 11.863155638000023],
            [121.28730921800002, 11.865326104000076],
        ],
        [
            [121.45311122700002, 11.869039799000063],
            [121.5128014600001, 11.861429162000036],
            [121.53044574500007, 11.843639716000041],
            [121.41368304500008, 11.835286429000064],
            [121.45311122700002, 11.869039799000063],
        ],
        [
            [121.4999538190001, 11.862323961000072],
            [121.4998776860001, 11.862450269000021],
            [121.49892008000006, 11.862410638000028],
            [121.49952688400003, 11.862075601000072],
            [121.4999538190001, 11.862323961000072],
        ],
        [
            [121.50227136900003, 11.862641581000048],
            [121.5021015640001, 11.862554192000061],
            [121.502697108, 11.862383539000064],
            [121.50235257000008, 11.862503642000036],
            [121.50227136900003, 11.862641581000048],
        ],
        [
            [121.47784257900003, 11.864923395000062],
            [121.47768785900007, 11.864910265000049],
            [121.47752001200001, 11.864765719000047],
            [121.4776893720001, 11.864711111000076],
            [121.47784257900003, 11.864923395000062],
        ],
        [
            [121.47903383900007, 11.865101655000046],
            [121.478888417, 11.865038757000036],
            [121.47920958500004, 11.864878848000046],
            [121.47925115500004, 11.865009290000046],
            [121.47903383900007, 11.865101655000046],
        ],
        [
            [121.57333054700007, 11.927904113000068],
            [121.57325588000003, 11.927740165000046],
            [121.57299540500003, 11.927847314000076],
            [121.57323100400004, 11.927993397000023],
            [121.57333054700007, 11.927904113000068],
        ],
        [
            [121.95460842800003, 11.939041340000074],
            [122.0867349770001, 11.834405111000024],
            [122.22208112500005, 11.813653740000063],
            [122.3076887410001, 11.744560393000029],
            [122.38546608500008, 11.734820390000039],
            [122.49311767900008, 11.609025641000073],
            [122.48169583200001, 11.594877937000035],
            [122.42801834500005, 11.653616574000068],
            [122.41342595800006, 11.658492138000042],
            [122.40223677100005, 11.653072885000029],
            [122.39729430400007, 11.635406766000074],
            [122.40343657000005, 11.629910254000038],
            [122.41264511500003, 11.635540671000058],
            [122.41074434600012, 11.617560112000035],
            [122.4248148580001, 11.618463911000049],
            [122.4220176560001, 11.611867607000022],
            [122.43049497900006, 11.611373951000076],
            [122.42013914900008, 11.591728638000063],
            [122.44952933600007, 11.608712285000024],
            [122.4869915810001, 11.571760754000024],
            [122.44287042700012, 11.580277472000034],
            [122.45245365400001, 11.551626933000023],
            [122.482287272, 11.555150378000064],
            [122.50766246800004, 11.592255943000055],
            [122.5740132200001, 11.564211372000045],
            [122.58016720600006, 11.508696689000033],
            [122.63526674000002, 11.521851668000068],
            [122.64234543000009, 11.572223034000046],
            [122.68554646700011, 11.545351235000055],
            [122.71488548800005, 11.613780685000052],
            [122.82599177700001, 11.610561545000053],
            [122.86437347600008, 11.540742416000057],
            [122.93106601800002, 11.51614812400004],
            [122.88026619700008, 11.462921067000025],
            [122.90145245500003, 11.431242019000024],
            [122.91714603200012, 11.482979383000043],
            [123.00872548000007, 11.492218163000075],
            [123.14913255500005, 11.598025387000064],
            [123.16233462000002, 11.556440666000071],
            [123.11725147800007, 11.513291541000058],
            [123.16529631100002, 11.46867880600007],
            [123.12805995500003, 11.415711092000038],
            [123.1513101160001, 11.381912126000032],
            [123.099202966, 11.32886213300003],
            [123.09346645000005, 11.224609240000063],
            [123.12672351100002, 11.171075821000045],
            [123.07921051800008, 11.177587631000051],
            [123.08881095100003, 11.14564772600005],
            [123.03639293700007, 11.171628113000054],
            [122.95224487300004, 11.033626993000041],
            [122.92414484500011, 11.067051701000025],
            [122.9054525470001, 11.020913068000027],
            [122.7817651260001, 10.98796989300007],
            [122.75956354700008, 10.946484693000059],
            [122.78535832700004, 10.861337183000046],
            [122.73418543800005, 10.785933778000071],
            [122.61065542500012, 10.77515539600006],
            [122.5800133240001, 10.686939351000035],
            [122.20694313500007, 10.638565895000056],
            [122.09582767800009, 10.57539838100007],
            [122.05082353300008, 10.486852118000058],
            [121.96077029700007, 10.40629232200007],
            [121.91261381200002, 10.446559955000055],
            [121.91450016300007, 10.50448248500004],
            [121.9576370530001, 10.549816748000069],
            [121.97808132300008, 10.675039620000064],
            [121.92304056100011, 10.763911705000055],
            [122.05407960500008, 11.032181618000038],
            [122.05203945100004, 11.261286728000073],
            [122.0270985950001, 11.298934789000043],
            [122.05795717400008, 11.34383693500007],
            [122.05156068400004, 11.46913362500004],
            [122.0838118580001, 11.497005140000056],
            [122.10166479100008, 11.649257632000058],
            [122.06723470300005, 11.739441341000031],
            [121.84350763900011, 11.762758098000063],
            [121.88078926500009, 11.816529570000057],
            [121.8846249930001, 11.898967652000067],
            [121.95460842800003, 11.939041340000074],
        ],
        [
            [122.43979859300009, 11.597165261000043],
            [122.43989189000001, 11.597232058000031],
            [122.43988470700003, 11.597314667000035],
            [122.43976449400009, 11.597268960000065],
            [122.43979859300009, 11.597165261000043],
        ],
        [
            [122.43988111500005, 11.597367397000028],
            [122.43998338400002, 11.597434194000073],
            [122.43998517000011, 11.597553714000071],
            [122.43984881000006, 11.597474611000052],
            [122.43988111500005, 11.597367397000028],
        ],
        [
            [122.43947959700006, 11.602642866000053],
            [122.43876854700011, 11.600865706000036],
            [122.43978478400004, 11.600017034000075],
            [122.43994740500011, 11.60088597300006],
            [122.43947959700006, 11.602642866000053],
        ],
        [
            [121.93440917200007, 11.939144100000021],
            [121.93435593400011, 11.93914165800004],
            [121.93433567000011, 11.939166475000036],
            [121.93437878800012, 11.939193727000031],
            [121.93440917200007, 11.939144100000021],
        ],
        [
            [121.93319748500005, 11.939449203000038],
            [121.93327141300006, 11.939464117000057],
            [121.9333096260001, 11.93943416600007],
            [121.93320255300011, 11.939406806000022],
            [121.9331414180001, 11.939461709000057],
            [121.93319748500005, 11.939449203000038],
        ],
        [
            [121.96147456000006, 11.939363762000028],
            [121.96205775500005, 11.938882239000066],
            [121.96181884200007, 11.938580586000057],
            [121.9612093930001, 11.938905453000075],
            [121.96147456000006, 11.939363762000028],
        ],
        [
            [121.95979386600004, 11.939501093000047],
            [121.9599204330001, 11.939288583000064],
            [121.95977245100005, 11.939169440000057],
            [121.959622007, 11.939407636000055],
            [121.95979386600004, 11.939501093000047],
        ],
        [
            [121.93424169900004, 11.939520840000057],
            [121.93420104200004, 11.93939036100005],
            [121.93419113200002, 11.939704414000062],
            [121.93426209300003, 11.939674601000036],
            [121.93424169900004, 11.939520840000057],
        ],
        [
            [121.95709721500009, 11.942669477000038],
            [121.95742844400002, 11.941773015000024],
            [121.95707275600012, 11.941560251000055],
            [121.9567860630001, 11.942141424000056],
            [121.95709721500009, 11.942669477000038],
        ],
        [
            [121.96163641800001, 11.94284035000004],
            [121.9616581140001, 11.942925327000069],
            [121.96173049700008, 11.942894657000068],
            [121.96173050300001, 11.942863972000055],
            [121.96163641800001, 11.94284035000004],
        ],
        [
            [121.96158233200003, 11.943936646000054],
            [121.96188638600006, 11.943599175000031],
            [121.9615005070001, 11.94294528200004],
            [121.9612084470001, 11.94361792500007],
            [121.96158233200003, 11.943936646000054],
        ],
        [
            [121.9573277720001, 11.946011722000037],
            [121.95868742400012, 11.945290141000044],
            [121.95950973000004, 11.943173614000045],
            [121.95755477400007, 11.94485553000004],
            [121.9573277720001, 11.946011722000037],
        ],
        [
            [121.94910892200005, 11.94925343400007],
            [121.94927195500009, 11.948829997000075],
            [121.94919171900005, 11.948787154000058],
            [121.94881474500005, 11.948982148000027],
            [121.94910892200005, 11.94925343400007],
        ],
        [
            [121.95143739900004, 11.95014242800005],
            [121.95192880200011, 11.949686295000049],
            [121.95126050500005, 11.949439718000065],
            [121.95115555000007, 11.950313151000046],
            [121.95143739900004, 11.95014242800005],
        ],
        [
            [121.55432271600012, 11.95964398500007],
            [121.58299779300012, 11.90571658500005],
            [121.55354146000002, 11.891379234000055],
            [121.5377280350001, 11.948924398000031],
            [121.55432271600012, 11.95964398500007],
        ],
        [
            [121.91871677200004, 11.968202985000062],
            [121.918602641, 11.96796609300003],
            [121.91845219200002, 11.967975888000069],
            [121.91865599400012, 11.968264799000053],
            [121.91871677200004, 11.968202985000062],
        ],
        [
            [121.556769486, 11.96845773900003],
            [121.55634590500006, 11.968097931000045],
            [121.55627668000011, 11.96873462800005],
            [121.55647108000005, 11.968793993000077],
            [121.556769486, 11.96845773900003],
        ],
        [
            [121.55998239200005, 11.990412917000072],
            [121.56730659800007, 11.978418954000063],
            [121.55659960700007, 11.969169434000037],
            [121.5554681110001, 11.983109940000077],
            [121.55998239200005, 11.990412917000072],
        ],
        [
            [121.37977301900003, 11.99503714900004],
            [121.37983161800003, 11.99482805200006],
            [121.37959888800003, 11.994762301000037],
            [121.37953511600006, 11.994932616000028],
            [121.37977301900003, 11.99503714900004],
        ],
        [
            [121.92735311000001, 11.995316222000042],
            [121.92726381900002, 11.995381360000067],
            [121.92740774700007, 11.995521199000052],
            [121.92747154900007, 11.995422499000028],
            [121.92735311000001, 11.995316222000042],
        ],
        [
            [121.92835147500011, 11.995969846000037],
            [121.9282416530001, 11.995491345000062],
            [121.92764320000003, 11.995580412000038],
            [121.92781782100008, 11.995908582000027],
            [121.92835147500011, 11.995969846000037],
        ],
        [
            [121.92833510700007, 11.997362254000052],
            [121.92851221500007, 11.99726744700007],
            [121.9283407470001, 11.997028613000055],
            [121.928095718, 11.997224158000051],
            [121.92833510700007, 11.997362254000052],
        ],
        [
            [121.92167722400006, 11.999300319000042],
            [121.9476402030001, 11.954627174000052],
            [121.94294404100003, 11.940174617000025],
            [121.90675574800002, 11.982416924000063],
            [121.92167722400006, 11.999300319000042],
        ],
        [
            [121.93673188200012, 11.956221994000032],
            [121.93656443500004, 11.956085484000027],
            [121.93661652600008, 11.95585978500003],
            [121.93689374400003, 11.956045437000057],
            [121.93673188200012, 11.956221994000032],
        ],
        [
            [121.93039555400003, 11.974887540000054],
            [121.93041784800005, 11.97496362000004],
            [121.93037549000007, 11.975032730000066],
            [121.93033892100004, 11.974951202000057],
            [121.93039555400003, 11.974887540000054],
        ],
        [
            [121.36120327600008, 12.06737296800003],
            [121.36150928300003, 12.067017606000036],
            [121.36073077700007, 12.067081861000077],
            [121.36096236800006, 12.067512874000045],
            [121.36120327600008, 12.06737296800003],
        ],
        [
            [121.35862967900005, 12.070569613000032],
            [121.35885632300005, 12.070306243000061],
            [121.35835145100009, 12.070114778000061],
            [121.35829597300005, 12.070531114000062],
            [121.35862967900005, 12.070569613000032],
        ],
        [
            [121.36208812900009, 12.071129214000052],
            [121.36190892900004, 12.069577206000076],
            [121.36149739200005, 12.069360965000044],
            [121.36109081400002, 12.070472832000064],
            [121.36208812900009, 12.071129214000052],
        ],
        [
            [121.36105534800004, 12.071883425000067],
            [121.36066015300003, 12.070162741000047],
            [121.35959818600008, 12.070304534000059],
            [121.36037235700007, 12.07165455300003],
            [121.36105534800004, 12.071883425000067],
        ],
        [
            [121.35904770800005, 12.077577614000063],
            [121.36115590800011, 12.076094053000077],
            [121.36117223400004, 12.072304890000055],
            [121.3555686420001, 12.075653923000061],
            [121.35904770800005, 12.077577614000063],
        ],
        [
            [121.36097926000002, 12.083971710000071],
            [121.36152854000011, 12.082095479000031],
            [121.3595847040001, 12.079070221000052],
            [121.35872003800011, 12.081330638000054],
            [121.36097926000002, 12.083971710000071],
        ],
        [
            [121.34373939200009, 12.085434513000052],
            [121.34426599100004, 12.085009978000073],
            [121.344771852, 12.084821971000054],
            [121.34374795500003, 12.084834963000048],
            [121.34373939200009, 12.085434513000052],
        ],
        [
            [121.34388875700006, 12.093241810000052],
            [121.34398121800007, 12.092803703000072],
            [121.3435882870001, 12.092471639000053],
            [121.34346737100009, 12.093297440000072],
            [121.34388875700006, 12.093241810000052],
        ],
        [
            [121.3444962850001, 12.093978029000027],
            [121.3448280990001, 12.09289443800003],
            [121.34418164500005, 12.091895600000043],
            [121.34419402700007, 12.09373811000006],
            [121.3444962850001, 12.093978029000027],
        ],
        [
            [121.34435280100001, 12.094160683000041],
            [121.34442747600008, 12.094155469000043],
            [121.34442925500002, 12.094073758000036],
            [121.34432435400004, 12.094084188000068],
            [121.34435280100001, 12.094160683000041],
        ],
        [
            [121.34425856500002, 12.094268472000067],
            [121.34405409600004, 12.094244131000039],
            [121.34424078000006, 12.09464573200006],
            [121.34434035100003, 12.094513604000042],
            [121.34425856500002, 12.094268472000067],
        ],
        [
            [121.3449218720001, 12.09527597400006],
            [121.3449167770001, 12.095076938000034],
            [121.34475356300004, 12.09498198600005],
            [121.34480631600002, 12.095564052000043],
            [121.3449218720001, 12.09527597400006],
        ],
        [
            [121.34807658900002, 12.100783077000074],
            [121.3479463330001, 12.10070360900005],
            [121.34781091000002, 12.100970871000072],
            [121.34803412800011, 12.100905666000074],
            [121.34807658900002, 12.100783077000074],
        ],
        [
            [121.34787824700004, 12.101234635000026],
            [121.34795947200007, 12.10115044500003],
            [121.34791459600001, 12.101043985000047],
            [121.34773524000002, 12.101116932000025],
            [121.34787824700004, 12.101234635000026],
        ],
        [
            [121.57847063200006, 12.11010602400006],
            [121.58418099300002, 12.099157671000057],
            [121.56875740900011, 12.094904969000027],
            [121.5737152700001, 12.106538296000053],
            [121.57847063200006, 12.11010602400006],
        ],
        [
            [121.38138388900006, 12.125839453000026],
            [121.42726459800008, 12.02935872300003],
            [121.41863608800008, 12.010514489000059],
            [121.38871863800011, 11.983197260000054],
            [121.35354170700009, 12.055093364000072],
            [121.38173454700006, 12.07050558800006],
            [121.36375375800003, 12.06777657200007],
            [121.36166781700001, 12.085516760000075],
            [121.34851605500012, 12.08341845700005],
            [121.34305853600006, 12.087791856000024],
            [121.38138388900006, 12.125839453000026],
        ],
        [
            [121.4009961270001, 11.997322250000025],
            [121.40090488600003, 11.997531183000035],
            [121.40051608600004, 11.996879810000053],
            [121.40105241100002, 11.99710157000004],
            [121.4009961270001, 11.997322250000025],
        ],
        [
            [121.40129643700004, 11.998217843000077],
            [121.4011130020001, 11.998189485000069],
            [121.401231402, 11.997985723000056],
            [121.40142268300008, 11.998133715000051],
            [121.40129643700004, 11.998217843000077],
        ],
        [
            [121.40795285000002, 12.051012186000037],
            [121.40802638100001, 12.051075898000022],
            [121.4079895220001, 12.051249349000045],
            [121.40786670200009, 12.051111099000025],
            [121.40795285000002, 12.051012186000037],
        ],
        [
            [121.3469933240001, 12.090586654000049],
            [121.34684425700004, 12.090646284000059],
            [121.34674092800003, 12.090575062000028],
            [121.34719490000009, 12.09045745700007],
            [121.3469933240001, 12.090586654000049],
        ],
        [
            [121.39672851600005, 12.154296875000057],
            [121.39569091700002, 12.155273438000052],
            [121.39691162100007, 12.156677246000072],
            [121.39709472700008, 12.155700684000067],
            [121.39672851600005, 12.154296875000057],
        ],
        [
            [121.43519835200004, 12.208970570000076],
            [121.43405398000004, 12.197131874000036],
            [121.42712354900004, 12.19511471900006],
            [121.42165865900006, 12.204717811000023],
            [121.43519835200004, 12.208970570000076],
        ],
        [
            [123.27038790600011, 9.084596680000061],
            [123.2752400820001, 9.07748248300004],
            [123.26816145200007, 9.071053595000024],
            [123.26777770600006, 9.083411020000028],
            [123.27038790600011, 9.084596680000061],
        ],
        [
            [123.61380577900002, 9.300946112000076],
            [123.68666246900011, 9.221334869000032],
            [123.65659475700011, 9.18860240600003],
            [123.70196462000001, 9.144887218000065],
            [123.58816909300003, 9.094686502000059],
            [123.45194263600001, 9.193182224000054],
            [123.46950208900012, 9.224266802000045],
            [123.56099977500003, 9.227043413000047],
            [123.61380577900002, 9.300946112000076],
        ],
        [
            [123.38679174600009, 9.434405029000061],
            [123.39076110500002, 9.434588424000026],
            [123.39111160100003, 9.428621174000057],
            [123.38892685000008, 9.429203297000072],
            [123.38679174600009, 9.434405029000061],
        ],
        [
            [123.92261527300002, 9.49996119900004],
            [123.92984111300007, 9.491760244000034],
            [123.92114135400004, 9.485589416000039],
            [123.9182411810001, 9.491034374000037],
            [123.92261527300002, 9.49996119900004],
        ],
        [
            [123.68500139800005, 9.519942897000021],
            [123.68739504300004, 9.515485099000045],
            [123.68280978900009, 9.514500370000064],
            [123.68177889200001, 9.518430429000034],
            [123.68500139800005, 9.519942897000021],
        ],
        [
            [123.7201575580001, 9.560053316000051],
            [123.72126606600011, 9.55982160000002],
            [123.72235943300007, 9.55898578800003],
            [123.72284374600008, 9.557711348000055],
            [123.72283333700011, 9.557085123000036],
            [123.72253867200004, 9.556415123000022],
            [123.7201575580001, 9.560053316000051],
        ],
        [
            [124.0033785380001, 9.596244348000027],
            [124.00336180500005, 9.595861630000059],
            [124.00303202300006, 9.596008707000067],
            [124.00306440100007, 9.596209675000068],
            [124.0033785380001, 9.596244348000027],
        ],
        [
            [124.002792225, 9.597199500000045],
            [124.00258059900011, 9.595465966000063],
            [124.00123832300005, 9.595589251000035],
            [124.00146940000002, 9.59693876800003],
            [124.002792225, 9.597199500000045],
        ],
        [
            [123.96254101300008, 9.604570549000073],
            [123.96273985800008, 9.604147563000026],
            [123.9620523970001, 9.60393553700004],
            [123.96216074000006, 9.604435856000066],
            [123.96254101300008, 9.604570549000073],
        ],
        [
            [123.14648244400007, 9.620965141000056],
            [123.14800926800001, 9.617241087000025],
            [123.14439811900002, 9.615418250000062],
            [123.14247708200003, 9.617275289000077],
            [123.14648244400007, 9.620965141000056],
        ],
        [
            [123.83648725700004, 9.644078256000057],
            [123.86960014300007, 9.604568113000028],
            [123.79958833, 9.552420098000027],
            [123.75187569200011, 9.546115262000058],
            [123.71786205700005, 9.587760839000055],
            [123.83648725700004, 9.644078256000057],
        ],
        [
            [123.73940202100005, 9.581151672000033],
            [123.73923773600006, 9.58112120800007],
            [123.73913524800003, 9.580853363000074],
            [123.73947195800008, 9.581034585000054],
            [123.73940202100005, 9.581151672000033],
        ],
        [
            [123.73191000500003, 9.584662234000064],
            [123.73163835500009, 9.584793905000026],
            [123.73065611600009, 9.58361913300007],
            [123.73207881600001, 9.583533780000039],
            [123.73191000500003, 9.584662234000064],
        ],
        [
            [123.73081350400003, 9.585019897000052],
            [123.73043540900005, 9.585019826000064],
            [123.73016122400008, 9.584821074000047],
            [123.73063904700007, 9.584776099000067],
            [123.73081350400003, 9.585019897000052],
        ],
        [
            [123.71964938000008, 9.587298764000025],
            [123.7192453240001, 9.58729203300004],
            [123.71907829700001, 9.587207430000035],
            [123.71957944200005, 9.58701830800004],
            [123.71964938000008, 9.587298764000025],
        ],
        [
            [123.74487659400006, 9.59153264500003],
            [123.74466289700001, 9.591267660000028],
            [123.74508600200011, 9.591233356000032],
            [123.74519543300005, 9.59140829000006],
            [123.74487659400006, 9.59153264500003],
        ],
        [
            [124.5613481900001, 9.830677781000077],
            [124.56225252400009, 9.828549619000057],
            [124.55904620100011, 9.829466726000021],
            [124.55941988900008, 9.830269047000058],
            [124.5613481900001, 9.830677781000077],
        ],
        [
            [124.55216818400004, 9.833502490000058],
            [124.55301213400003, 9.832229425000037],
            [124.55210876600006, 9.83175015300003],
            [124.551219005, 9.832586371000048],
            [124.55216818400004, 9.833502490000058],
        ],
        [
            [124.56329821200006, 9.835338406000062],
            [124.56534021300001, 9.83385971100006],
            [124.56517745200006, 9.832793440000046],
            [124.56078130300011, 9.834258877000025],
            [124.56329821200006, 9.835338406000062],
        ],
        [
            [124.55485720200011, 9.839724162000039],
            [124.5571407540001, 9.835630242000036],
            [124.55390229400007, 9.833155308000073],
            [124.55234692700003, 9.839520526000058],
            [124.55485720200011, 9.839724162000039],
        ],
        [
            [123.79012127300007, 9.864313846000073],
            [123.81562068000005, 9.854338390000066],
            [123.81582679200005, 9.849679170000059],
            [123.79590989400003, 9.839608751000071],
            [123.79012127300007, 9.864313846000073],
        ],
        [
            [124.56839122800011, 9.866112351000027],
            [124.56934728100009, 9.859121067000046],
            [124.56293310500007, 9.851359278000075],
            [124.56075621500008, 9.863569184000028],
            [124.56839122800011, 9.866112351000027],
        ],
        [
            [123.78174871800002, 9.892355811000073],
            [123.79243011100004, 9.886096964000046],
            [123.76452895800003, 9.861037980000049],
            [123.75945721500011, 9.889806270000065],
            [123.78174871800002, 9.892355811000073],
        ],
        [
            [123.38024408100011, 9.893167750000032],
            [123.3843265700001, 9.888388452000072],
            [123.38189603900003, 9.874638104000041],
            [123.3724661980001, 9.878287378000039],
            [123.38024408100011, 9.893167750000032],
        ],
        [
            [123.82394237800008, 9.911229657000035],
            [123.83917589000009, 9.900736470000027],
            [123.85491662700008, 9.906214728000066],
            [123.86282038700006, 9.906699514000024],
            [123.83561564700005, 9.885603710000055],
            [123.82394237800008, 9.911229657000035],
        ],
        [
            [123.3799835320001, 9.911825478000026],
            [123.37880897700006, 9.912770703000035],
            [123.37946598200006, 9.913909620000027],
            [123.38006097900006, 9.91349864700004],
            [123.3799835320001, 9.911825478000026],
        ],
        [
            [124.5561892610001, 9.92669352200005],
            [124.554481355, 9.927686024000025],
            [124.55476397500001, 9.928279087000021],
            [124.55677908200005, 9.927540745000044],
            [124.5561892610001, 9.92669352200005],
        ],
        [
            [123.86846659500009, 9.929470597000034],
            [123.87280121200001, 9.922036720000051],
            [123.86567145800007, 9.917114022000021],
            [123.86537281100004, 9.928338009000072],
            [123.86846659500009, 9.929470597000034],
        ],
        [
            [123.8533387440001, 9.941637275000062],
            [123.852560777, 9.942379776000053],
            [123.8531073900001, 9.942896659000041],
            [123.85376227600011, 9.94214282300004],
            [123.8533387440001, 9.941637275000062],
        ],
        [
            [123.909676439, 9.947786292000046],
            [123.91288785600011, 9.946527764000052],
            [123.91174711400004, 9.94418898500004],
            [123.90737050300004, 9.946082965000073],
            [123.909676439, 9.947786292000046],
        ],
        [
            [123.87408447300004, 9.94647216800007],
            [123.87109375000011, 9.947082519000048],
            [123.87109375000011, 9.949279785000044],
            [123.8718872070001, 9.947875977000024],
            [123.87408447300004, 9.94647216800007],
        ],
        [
            [123.85054510700002, 9.95152323000002],
            [123.85978224500002, 9.94462059600005],
            [123.85683281900003, 9.93935110800004],
            [123.85304714300003, 9.943902782000066],
            [123.850965, 9.94469194800007],
            [123.85054510700002, 9.95152323000002],
        ],
        [
            [123.92234921300007, 9.953758476000075],
            [123.92266240100003, 9.953631334000022],
            [123.92221804300004, 9.952984769000068],
            [123.92206776700004, 9.953622997000025],
            [123.92234921300007, 9.953758476000075],
        ],
        [
            [123.91792907500007, 9.955929003000051],
            [123.92133970700002, 9.954497696000033],
            [123.92204076000007, 9.952887418000046],
            [123.91926841200006, 9.951977022000051],
            [123.91792907500007, 9.955929003000051],
        ],
        [
            [123.90224714900012, 9.959325146000026],
            [123.90258435300007, 9.959259486000064],
            [123.90263468700005, 9.959120577000022],
            [123.90251511600002, 9.958410464000053],
            [123.90139112800011, 9.956588897000074],
            [123.89508383900011, 9.958435117000022],
            [123.90224714900012, 9.959325146000026],
        ],
        [
            [124.57629394500009, 9.957092286000034],
            [124.57044675000009, 9.954431052000075],
            [124.5692893480001, 9.963456241000074],
            [124.57314056900009, 9.963803056000074],
            [124.57629394500009, 9.957092286000034],
        ],
        [
            [123.39559068400001, 9.977974525000036],
            [123.39596370000004, 9.976630654000076],
            [123.39411928900006, 9.976172846000054],
            [123.39382172800003, 9.97751398400004],
            [123.39559068400001, 9.977974525000036],
        ],
        [
            [123.40010635300007, 9.977930455000035],
            [123.4017478620001, 9.97678905600003],
            [123.39833329800001, 9.976694347000034],
            [123.39831843000002, 9.977308231000052],
            [123.40010635300007, 9.977930455000035],
        ],
        [
            [124.55407714800003, 9.97650146500007],
            [124.55249023400006, 9.976928711000028],
            [124.55267334000007, 9.979125977000024],
            [124.55328369100005, 9.979309082000043],
            [124.55407714800003, 9.97650146500007],
        ],
        [
            [123.98932811300006, 9.980691182000044],
            [123.993839223, 9.974425561000032],
            [123.98975471200004, 9.971595751000052],
            [123.98449467400008, 9.975071609000054],
            [123.98932811300006, 9.980691182000044],
        ],
        [
            [123.3902577980001, 9.981365925000034],
            [123.39073584800008, 9.981374003000042],
            [123.39056430000005, 9.980404195000062],
            [123.3898819100001, 9.981144579000045],
            [123.3902577980001, 9.981365925000034],
        ],
        [
            [123.38937133200011, 9.98191556100005],
            [123.389607393, 9.981602804000033],
            [123.38915253000005, 9.980875789000038],
            [123.38868042900003, 9.981235025000046],
            [123.38937133200011, 9.98191556100005],
        ],
        [
            [123.38859454700003, 9.981953550000071],
            [123.38888638600008, 9.98180986400007],
            [123.38858599800005, 9.981463259000066],
            [123.38846582100007, 9.981640769000023],
            [123.38859454700003, 9.981953550000071],
        ],
        [
            [123.39039512600004, 9.98272240800003],
            [123.3915519090001, 9.982216148000077],
            [123.38916552800004, 9.982392104000041],
            [123.38972305800007, 9.982903651000072],
            [123.39039512600004, 9.98272240800003],
        ],
        [
            [123.38852906400007, 9.984248112000046],
            [123.3896876880001, 9.983222535000039],
            [123.38832709300004, 9.982132625000077],
            [123.38794657200003, 9.983704946000046],
            [123.38852906400007, 9.984248112000046],
        ],
        [
            [123.99652099600007, 9.982116700000063],
            [123.9915161130001, 9.982299805000025],
            [123.99310302800006, 9.986694336000028],
            [123.99670410100009, 9.985717774000022],
            [123.99652099600007, 9.982116700000063],
        ],
        [
            [123.38653949000002, 9.986715230000073],
            [123.38602049700012, 9.985937758000034],
            [123.38517697200007, 9.986747079000054],
            [123.38602704400012, 9.987501396000027],
            [123.38653949000002, 9.986715230000073],
        ],
        [
            [123.88288905200011, 9.987286719000053],
            [123.88246012900004, 9.986753484000076],
            [123.88141547300006, 9.987705808000044],
            [123.88210615300011, 9.988161540000021],
            [123.88288905200011, 9.987286719000053],
        ],
        [
            [124.00292968700012, 9.992309571000021],
            [124.00531005800008, 9.991882324000073],
            [124.00592041000004, 9.990722657000049],
            [124.00091552700007, 9.991271973000039],
            [124.00292968700012, 9.992309571000021],
        ],
        [
            [124.00787353500004, 9.993713379000042],
            [124.00512695200007, 9.993713379000042],
            [124.0046997070001, 9.99407959000007],
            [124.00708007800006, 9.996520996000072],
            [124.00787353500004, 9.993713379000042],
        ],
        [
            [123.94034040500003, 9.99834912700004],
            [123.94161683700008, 9.99815307800003],
            [123.94190652500004, 9.997651358000041],
            [123.93941858500011, 9.997947440000075],
            [123.94034040500003, 9.99834912700004],
        ],
        [
            [124.01470947300004, 10.002502442000036],
            [124.01312255900007, 10.00311279300007],
            [124.01550292900004, 10.004882812000062],
            [124.01593017500011, 10.003906250000057],
            [124.01470947300004, 10.002502442000036],
        ],
        [
            [123.96592043400005, 10.024014273000034],
            [123.96380290700006, 10.023131491000072],
            [123.96356621900009, 10.023557182000047],
            [123.96575522000012, 10.024431310000068],
            [123.96592043400005, 10.024014273000034],
        ],
        [
            [123.9670327120001, 10.02545520600006],
            [123.96745433800004, 10.025090904000024],
            [123.96632923000004, 10.024168400000065],
            [123.96602498100003, 10.024547594000069],
            [123.9670327120001, 10.02545520600006],
        ],
        [
            [123.97782402900009, 10.041132179000044],
            [123.9834100270001, 10.021230368000033],
            [123.99179090500002, 10.011231086000066],
            [123.98077957100008, 10.023677845000066],
            [123.97782402900009, 10.041132179000044],
        ],
        [
            [124.01767053300011, 10.04410749300007],
            [124.01920337700005, 10.043343600000071],
            [124.01905847100011, 10.04171883500004],
            [124.01637187100005, 10.042583444000059],
            [124.01767053300011, 10.04410749300007],
        ],
        [
            [123.89884525600007, 10.056329642000037],
            [123.90049680300001, 10.05554449300007],
            [123.90065122900012, 10.05398849200003],
            [123.89750153200009, 10.054955733000043],
            [123.89884525600007, 10.056329642000037],
        ],
        [
            [124.5297624960001, 10.065164938000066],
            [124.52980451200006, 10.063805870000067],
            [124.52892444200006, 10.06362819900005],
            [124.52855477000003, 10.065191385000048],
            [124.5297624960001, 10.065164938000066],
        ],
        [
            [124.02245539500007, 10.071870904000036],
            [124.02410011800009, 10.07125886800003],
            [124.0255528350001, 10.069460481000021],
            [124.02065746200003, 10.070740749000038],
            [124.02245539500007, 10.071870904000036],
        ],
        [
            [123.92702345100008, 10.071935068000073],
            [123.92868094300002, 10.071663663000038],
            [123.92964072300003, 10.071843140000055],
            [123.92818707700008, 10.070706881000035],
            [123.92702345100008, 10.071935068000073],
        ],
        [
            [124.52618020000011, 10.073586287000069],
            [124.52682827100011, 10.072597960000053],
            [124.52680839600009, 10.070942779000063],
            [124.52519395200011, 10.071942634000038],
            [124.52618020000011, 10.073586287000069],
        ],
        [
            [124.05726863300004, 10.079068143000029],
            [124.05572509800004, 10.083129883000026],
            [124.05847167900004, 10.085083008000026],
            [124.05950927700007, 10.083679200000063],
            [124.05726863300004, 10.079068143000029],
        ],
        [
            [124.50975297100001, 10.094452087000036],
            [124.51275320000002, 10.089328457000022],
            [124.51323932100001, 10.08339789200005],
            [124.50443747100007, 10.08898665700002],
            [124.50975297100001, 10.094452087000036],
        ],
        [
            [123.98886166000011, 10.113834005000058],
            [123.99046716900011, 10.111586182000053],
            [123.97990340800004, 10.111495691000073],
            [123.98435821200007, 10.113260097000023],
            [123.98886166000011, 10.113834005000058],
        ],
        [
            [124.64403791500001, 10.124992485000064],
            [124.64489429100001, 10.121480114000065],
            [124.64156361100004, 10.120617657000025],
            [124.6406752580001, 10.124247979000074],
            [124.64403791500001, 10.124992485000064],
        ],
        [
            [124.540215181, 10.133687812000062],
            [124.54605627, 10.129894851000074],
            [124.5433924140001, 10.12187460900003],
            [124.53796949000002, 10.127640792000022],
            [124.540215181, 10.133687812000062],
        ],
        [
            [124.53769139600001, 10.133998421000058],
            [124.53667182200002, 10.134332297000071],
            [124.53640819000009, 10.135002511000039],
            [124.5374706980001, 10.134859781000046],
            [124.53769139600001, 10.133998421000058],
        ],
        [
            [124.57519693200004, 10.134138059000065],
            [124.57428093500005, 10.13463402900004],
            [124.57416693700009, 10.135107996000045],
            [124.57505893400003, 10.13481801200004],
            [124.57519693200004, 10.134138059000065],
        ],
        [
            [124.5486507810001, 10.136766177000027],
            [124.54744218200005, 10.136594280000054],
            [124.5469165930001, 10.138750817000073],
            [124.54817551800011, 10.138485024000033],
            [124.5486507810001, 10.136766177000027],
        ],
        [
            [124.5891889500001, 10.144634258000053],
            [124.58845695200012, 10.144957239000064],
            [124.5888609540001, 10.145419204000063],
            [124.5891809530001, 10.145464200000049],
            [124.5891889500001, 10.144634258000053],
        ],
        [
            [124.58190917900004, 10.146118164000029],
            [124.58236095500001, 10.14273742100005],
            [124.5780809580001, 10.141484528000035],
            [124.57738597800005, 10.145776228000045],
            [124.58190917900004, 10.146118164000029],
        ],
        [
            [124.5840089730001, 10.147512077000044],
            [124.58273397500011, 10.147721068000067],
            [124.58280298400007, 10.149566937000031],
            [124.58355798100001, 10.149288954000042],
            [124.5840089730001, 10.147512077000044],
        ],
        [
            [124.61547633000009, 10.153081935000046],
            [124.58576151500006, 10.109960278000074],
            [124.60418447300003, 10.087116231000039],
            [124.56107818700002, 10.092409370000041],
            [124.534642415, 10.05489887300007],
            [124.52492893700003, 10.118440043000021],
            [124.57569387500007, 10.11095483400004],
            [124.61547633000009, 10.153081935000046],
        ],
        [
            [124.50531816900002, 10.157985669000027],
            [124.50435644700008, 10.158833471000037],
            [124.50381810800002, 10.16018329800005],
            [124.50552385900005, 10.159636288000058],
            [124.50531816900002, 10.157985669000027],
        ],
        [
            [124.44322885600002, 10.162600380000072],
            [124.44399561800003, 10.160540881000031],
            [124.44216170300001, 10.158692708000046],
            [124.4405895540001, 10.16055231100006],
            [124.44322885600002, 10.162600380000072],
        ],
        [
            [124.04108307500007, 10.161825100000044],
            [124.04706531500005, 10.156932777000065],
            [124.04780494700003, 10.15474385400006],
            [124.03781601100002, 10.164386786000023],
            [124.04108307500007, 10.161825100000044],
        ],
        [
            [124.38867187500011, 10.163085938000052],
            [124.38732910100009, 10.163330078000058],
            [124.3883056630001, 10.164489746000072],
            [124.38909912100007, 10.164123535000044],
            [124.38867187500011, 10.163085938000052],
        ],
        [
            [124.50036554500002, 10.164277489000028],
            [124.49985393500003, 10.162971645000027],
            [124.49852771000008, 10.164006390000054],
            [124.49950537200004, 10.164594074000036],
            [124.50036554500002, 10.164277489000028],
        ],
        [
            [124.28993463000006, 10.17363597000002],
            [124.54697681300001, 10.04094597300002],
            [124.5701535720001, 9.977134173000024],
            [124.55473616100005, 9.988330406000046],
            [124.543689018, 9.97683547500003],
            [124.53698380500009, 9.922024685000054],
            [124.57618204900007, 9.91302070200004],
            [124.5135502710001, 9.849163521000037],
            [124.59702857800005, 9.805217208000045],
            [124.59259817600002, 9.75582718100003],
            [124.52001557100004, 9.721852801000068],
            [124.48448919900011, 9.760939703000076],
            [124.40825146600002, 9.710272936000024],
            [124.39954060500008, 9.652923654000062],
            [124.25881750400004, 9.598485886000049],
            [124.05567851600006, 9.589279053000041],
            [123.85363153700007, 9.636835293000047],
            [123.86568778000003, 9.715820023000049],
            [123.78712140200003, 9.739835060000075],
            [123.80205199800002, 9.84216722900004],
            [123.83808186200008, 9.86087821500007],
            [123.83981854800004, 9.88312514100005],
            [123.87027456700002, 9.890179820000071],
            [123.88190687400004, 9.929175497000074],
            [123.89098120200003, 9.910163175000037],
            [124.02753459100006, 9.967249969000022],
            [124.06260115700002, 10.068990684000028],
            [124.09897911700011, 10.063793021000038],
            [124.15182067600006, 10.153448443000059],
            [124.27894794000008, 10.154560642000035],
            [124.28993463000006, 10.17363597000002],
        ],
        [
            [123.84885502500003, 9.881866856000045],
            [123.84856413400007, 9.88156391800004],
            [123.84903874300005, 9.88143999500005],
            [123.8491748890001, 9.881669726000041],
            [123.84885502500003, 9.881866856000045],
        ],
        [
            [123.84842595700002, 9.884700666000072],
            [123.84814607500005, 9.884287961000041],
            [123.84821345800003, 9.884142817000054],
            [123.84879016100001, 9.884379310000043],
            [123.84842595700002, 9.884700666000072],
        ],
        [
            [124.11463878100005, 10.167928266000047],
            [124.11124878700002, 10.165882228000044],
            [124.1062171100001, 10.169110701000022],
            [124.11357090800004, 10.175732709000044],
            [124.11463878100005, 10.167928266000047],
        ],
        [
            [124.1865098180001, 10.176492609000036],
            [124.17782114800002, 10.154017123000074],
            [124.15923770400002, 10.16252387000003],
            [124.1682133490001, 10.173610233000034],
            [124.1865098180001, 10.176492609000036],
        ],
        [
            [124.46077732100002, 10.174257925000063],
            [124.45737690200008, 10.174202343000047],
            [124.46050894300004, 10.180080175000057],
            [124.46251164800003, 10.177301645000057],
            [124.46077732100002, 10.174257925000063],
        ],
        [
            [124.13366052200001, 10.181041984000046],
            [124.13555319000011, 10.180701028000044],
            [124.13777340100012, 10.179430839000077],
            [124.13292011600004, 10.179999090000024],
            [124.13366052200001, 10.181041984000046],
        ],
        [
            [124.08895970100002, 10.181054199000073],
            [124.08321171500006, 10.177874987000052],
            [124.07810983000002, 10.177221116000055],
            [124.08228539100003, 10.179580917000067],
            [124.08895970100002, 10.181054199000073],
        ],
        [
            [124.38145154200004, 10.18461964900007],
            [124.39275102400006, 10.17737713400004],
            [124.35206278200008, 10.165509015000055],
            [124.34969893200002, 10.174701739000056],
            [124.38145154200004, 10.18461964900007],
        ],
        [
            [124.30068448400004, 10.186928516000023],
            [124.30416161700009, 10.180074065000042],
            [124.2951031880001, 10.179908629000067],
            [124.29488376300003, 10.182234385000072],
            [124.30068448400004, 10.186928516000023],
        ],
        [
            [124.14161929000011, 10.187485344000038],
            [124.143779289, 10.185706288000063],
            [124.14004769200005, 10.183582493000074],
            [124.13953607400003, 10.185516113000062],
            [124.14161929000011, 10.187485344000038],
        ],
        [
            [124.12907235800003, 10.188386019000063],
            [124.1353247180001, 10.186862795000025],
            [124.13658671000007, 10.184299977000023],
            [124.1364645860001, 10.181772825000053],
            [124.1185319970001, 10.180396224000049],
            [124.12907235800003, 10.188386019000063],
        ],
        [
            [124.00064208000003, 10.190894479000065],
            [124.00073474300007, 10.189951412000028],
            [123.99948258900008, 10.190539006000051],
            [124.00020592300007, 10.19091863400007],
            [124.00064208000003, 10.190894479000065],
        ],
        [
            [124.25474212600011, 10.19374153900003],
            [124.25545547900003, 10.193400029000031],
            [124.25573025800009, 10.192631056000039],
            [124.25423964600009, 10.192886499000053],
            [124.25474212600011, 10.19374153900003],
        ],
        [
            [124.28162751400009, 10.19496590600005],
            [124.28362369500007, 10.187863297000035],
            [124.27012740900011, 10.193258422000042],
            [124.27205992400002, 10.194874422000055],
            [124.28162751400009, 10.19496590600005],
        ],
        [
            [124.56628865700009, 10.192555541000047],
            [124.56296974600002, 10.189533849000043],
            [124.56057426600012, 10.18473685300006],
            [124.56080774700001, 10.191776490000052],
            [124.56798476800009, 10.197823024000058],
            [124.56628865700009, 10.192555541000047],
        ],
        [
            [124.01815259400007, 10.20383090100006],
            [124.02083988700008, 10.203217711000036],
            [124.02132968800004, 10.202447896000024],
            [124.0181877770001, 10.202156383000045],
            [124.01815259400007, 10.20383090100006],
        ],
        [
            [124.41417103700007, 10.204870155000037],
            [124.41914653300012, 10.203791116000048],
            [124.41946632300005, 10.203459361000057],
            [124.41248788000007, 10.201588779000076],
            [124.41417103700007, 10.204870155000037],
        ],
        [
            [124.25892127400004, 10.206539847000045],
            [124.2368418430001, 10.178343514000062],
            [124.19754244800004, 10.186899237000034],
            [124.2035999630001, 10.196890403000054],
            [124.25892127400004, 10.206539847000045],
        ],
        [
            [123.98947937600008, 10.209769925000046],
            [123.99188798800003, 10.205631346000075],
            [123.99120653500006, 10.203316203000043],
            [123.98626674900004, 10.204513710000072],
            [123.98947937600008, 10.209769925000046],
        ],
        [
            [124.16851781200012, 10.211361110000041],
            [124.18538591600009, 10.19697622800004],
            [124.15021281100007, 10.190888973000028],
            [124.15433545300004, 10.204793179000035],
            [124.16851781200012, 10.211361110000041],
        ],
        [
            [124.19740998600003, 10.213389323000058],
            [124.19822432400008, 10.212279685000055],
            [124.1967824400001, 10.210199043000046],
            [124.19597314000009, 10.213032566000038],
            [124.19740998600003, 10.213389323000058],
        ],
        [
            [124.35425831900011, 10.215297790000022],
            [124.35466963600004, 10.209688799000048],
            [124.34889745900011, 10.211359686000037],
            [124.3499501020001, 10.214258905000065],
            [124.35425831900011, 10.215297790000022],
        ],
        [
            [124.04250572600006, 10.220995908000077],
            [124.04335921200004, 10.220187034000048],
            [124.04110014800006, 10.220581319000075],
            [124.04168097200011, 10.221101286000021],
            [124.04250572600006, 10.220995908000077],
        ],
        [
            [124.04335867500004, 10.224159401000065],
            [124.04475277600011, 10.222565256000053],
            [124.044487849, 10.220083661000047],
            [124.04058971100005, 10.223286287000064],
            [124.04335867500004, 10.224159401000065],
        ],
        [
            [124.33115885600012, 10.22520959600007],
            [124.32464227800006, 10.216907537000054],
            [124.31780734500012, 10.215384547000042],
            [124.32051484800002, 10.222651466000059],
            [124.33115885600012, 10.22520959600007],
        ],
        [
            [124.03866467700004, 10.225327879000076],
            [124.04282104600009, 10.21704545600005],
            [124.03154029400002, 10.213802556000076],
            [124.03497606400003, 10.216837620000035],
            [124.03866467700004, 10.225327879000076],
        ],
        [
            [124.04366239100011, 10.227869510000062],
            [124.04606125500004, 10.226990454000031],
            [124.04627504200005, 10.225098417000027],
            [124.04263696100008, 10.225022574000036],
            [124.04366239100011, 10.227869510000062],
        ],
        [
            [124.28319701600003, 10.229746385000055],
            [124.2853996880001, 10.227099959000043],
            [124.28155243300012, 10.224491322000063],
            [124.28041403700001, 10.227971263000029],
            [124.28319701600003, 10.229746385000055],
        ],
        [
            [124.03971947100001, 10.233419906000051],
            [124.04055144400002, 10.232297430000074],
            [124.039357515, 10.22886920700006],
            [124.03626348400007, 10.230975697000076],
            [124.03971947100001, 10.233419906000051],
        ],
        [
            [124.02987673700011, 10.236773206000066],
            [124.0343838550001, 10.236237565000067],
            [124.03472600400005, 10.235653847000037],
            [124.02852865500006, 10.234655173000021],
            [124.02987673700011, 10.236773206000066],
        ],
        [
            [124.01125349400002, 10.238149828000076],
            [124.0117923890001, 10.237484202000076],
            [124.01063358600004, 10.236319262000052],
            [124.01071147000005, 10.238043482000023],
            [124.01125349400002, 10.238149828000076],
        ],
        [
            [124.02539608000006, 10.238467240000034],
            [124.02825708700004, 10.237181940000028],
            [124.0278639820001, 10.235285632000057],
            [124.0253035830001, 10.23521370700007],
            [124.02539608000006, 10.238467240000034],
        ],
        [
            [124.3810083620001, 10.24063755800006],
            [124.38603101400008, 10.236569770000074],
            [124.38267040100004, 10.226409199000045],
            [124.37933579300011, 10.227477357000055],
            [124.3810083620001, 10.24063755800006],
        ],
        [
            [124.02707958100007, 10.241524250000055],
            [124.02689854300002, 10.241239269000062],
            [124.02650033000009, 10.241286333000062],
            [124.0263439690001, 10.241577047000021],
            [124.02694504200008, 10.24278395500005],
            [124.02707958100007, 10.241524250000055],
        ],
        [
            [124.48662712700002, 10.242800191000072],
            [124.48998650700003, 10.241300137000053],
            [124.48949117100005, 10.237617928000077],
            [124.48191943300003, 10.240293995000059],
            [124.48662712700002, 10.242800191000072],
        ],
        [
            [124.04997948400012, 10.240080199000033],
            [124.05298841900003, 10.234483649000026],
            [124.04626509800005, 10.22993933400005],
            [124.04167323800004, 10.233809390000033],
            [124.04997948400012, 10.240080199000033],
        ],
        [
            [124.05040410400011, 10.236684699000023],
            [124.05042894300004, 10.236892143000034],
            [124.0502429930001, 10.237174369000059],
            [124.0500305810001, 10.236864762000039],
            [124.05040410400011, 10.236684699000023],
        ],
        [
            [124.02662302500005, 10.243947666000054],
            [124.02677940100011, 10.24378662600003],
            [124.02676633300007, 10.243454605000068],
            [124.02643184800002, 10.243644161000077],
            [124.02662302500005, 10.243947666000054],
        ],
        [
            [124.02702561800004, 10.244214098000043],
            [124.02701687600006, 10.243706803000066],
            [124.02692564300003, 10.243654087000039],
            [124.02674179000007, 10.24416995200005],
            [124.02702561800004, 10.244214098000043],
        ],
        [
            [124.315917968, 10.233520508000026],
            [124.31512451200001, 10.23468017600004],
            [124.3175048820001, 10.240112305000025],
            [124.32629394500009, 10.244689942000036],
            [124.315917968, 10.233520508000026],
        ],
        [
            [124.40313766400004, 10.246858463000024],
            [124.40468023500011, 10.246562050000023],
            [124.40557129000001, 10.245461657000021],
            [124.40307030600002, 10.245611064000059],
            [124.40313766400004, 10.246858463000024],
        ],
        [
            [124.29857708400004, 10.247161959000039],
            [124.29910110700007, 10.246123917000034],
            [124.2919166910001, 10.240219246000038],
            [124.29088354700002, 10.239595781000048],
            [124.29012344900002, 10.239586553000038],
            [124.29857708400004, 10.247161959000039],
        ],
        [
            [124.33111572200005, 10.247314453000058],
            [124.33007812500011, 10.248291016000053],
            [124.33288574200003, 10.248107910000044],
            [124.33251953100012, 10.247680664000029],
            [124.33111572200005, 10.247314453000058],
        ],
        [
            [124.33648681600005, 10.248474122000061],
            [124.33691406200012, 10.25048828100006],
            [124.34008789000006, 10.25048828100006],
            [124.33972167900004, 10.249877930000025],
            [124.33648681600005, 10.248474122000061],
        ],
        [
            [124.291424688, 10.250879033000047],
            [124.29717186000005, 10.24858720100002],
            [124.29653073100008, 10.246243164000077],
            [124.29385561700008, 10.246178504000056],
            [124.291424688, 10.250879033000047],
        ],
        [
            [124.44566636200011, 10.252521695000041],
            [124.45713018800006, 10.24589131600004],
            [124.47093317100007, 10.241911600000037],
            [124.45262640600004, 10.246686612000076],
            [124.44566636200011, 10.252521695000041],
        ],
        [
            [123.9143891110001, 10.257406401000026],
            [123.91799366300006, 10.248128717000043],
            [123.91596944200012, 10.246160918000044],
            [123.91443128300011, 10.247054090000063],
            [123.9143891110001, 10.257406401000026],
        ],
        [
            [123.90442024900005, 10.272183492000067],
            [123.90332031300011, 10.272094727000024],
            [123.90368652300003, 10.274719238000046],
            [123.90447998000002, 10.274475098000039],
            [123.90442024900005, 10.272183492000067],
        ],
        [
            [123.9163208010001, 10.27709961000005],
            [123.91491699200003, 10.277893066000047],
            [123.915527343, 10.279724121000072],
            [123.9171142570001, 10.278930665000075],
            [123.9163208010001, 10.27709961000005],
        ],
        [
            [124.1707153320001, 10.278076172000056],
            [124.16899898500003, 10.276639203000059],
            [124.16668701100002, 10.279724121000072],
            [124.16931152400002, 10.279907227000024],
            [124.1707153320001, 10.278076172000056],
        ],
        [
            [123.90588378900009, 10.276306152000075],
            [123.90429687500011, 10.277526856000065],
            [123.90551757800006, 10.280883790000075],
            [123.90667724600007, 10.279724121000072],
            [123.90588378900009, 10.276306152000075],
        ],
        [
            [124.1770419500001, 10.28518534400007],
            [124.17377129800002, 10.284718835000035],
            [124.17222604100004, 10.285319179000055],
            [124.1785278320001, 10.287109375000057],
            [124.1770419500001, 10.28518534400007],
        ],
        [
            [124.06993184500004, 10.288777482000057],
            [124.05459844900008, 10.237325784000063],
            [124.04945991400007, 10.256170442000041],
            [124.01963498400005, 10.241527846000054],
            [124.06993184500004, 10.288777482000057],
        ],
        [
            [124.02791750500012, 10.248028600000055],
            [124.02650063500005, 10.247069186000033],
            [124.02642228200011, 10.245920230000024],
            [124.0271191280001, 10.247178065000071],
            [124.02791750500012, 10.248028600000055],
        ],
        [
            [124.0439318440001, 10.334258299000055],
            [123.9836561840001, 10.25859351400004],
            [123.93203380000011, 10.250407679000034],
            [123.9431312370001, 10.311061075000055],
            [124.0439318440001, 10.334258299000055],
        ],
        [
            [123.33591507200003, 10.382476470000029],
            [123.33149030300001, 10.278038312000035],
            [123.13169936400004, 9.838505601000065],
            [123.15710382500004, 9.632466990000069],
            [123.12415428400004, 9.657290862000025],
            [123.1046667820001, 9.629939296000032],
            [123.16403743400008, 9.577707456000041],
            [123.13337840600002, 9.584890281000071],
            [123.11772951500006, 9.546883190000074],
            [123.14700892100007, 9.55490665800005],
            [123.18475520800007, 9.478918642000053],
            [123.23048142700009, 9.46368190100003],
            [123.3117982760001, 9.299349416000041],
            [123.20280244500009, 9.093866692000063],
            [123.12816456500002, 9.045908699000051],
            [123.0738064190001, 9.066716127000063],
            [123.015502792, 9.03836771300007],
            [122.94023217000006, 9.076842347000024],
            [122.90877215600005, 9.137390352000068],
            [122.87028796400011, 9.325582303000033],
            [122.67438737900011, 9.379784507000068],
            [122.58889196900009, 9.444032428000071],
            [122.98320250300003, 9.912625363000075],
        ],
        [
            [123.01579588600009, 10.01218724100005],
            [123.19455747000006, 10.271815747000062],
            [123.16309338700012, 10.314090966000037],
            [123.18321414700006, 10.358187988000054],
            [123.13183057200001, 10.41167899100003],
            [123.21963844700008, 10.439330970000071],
            [123.33591507200003, 10.382476470000029],
        ],
        [
            [123.11763789000008, 9.649499695000031],
            [123.11720106900009, 9.649342238000031],
            [123.11689212700003, 9.649451359000068],
            [123.11754241200003, 9.648777203000066],
            [123.11763789000008, 9.649499695000031],
        ],
        [
            [124.0339192570001, 10.547495720000029],
            [124.03399798800001, 10.547489915000028],
            [124.03405309700008, 10.547422188000041],
            [124.03382084300006, 10.547443477000058],
            [124.0339192570001, 10.547495720000029],
        ],
        [
            [124.03338585900008, 10.547756959000026],
            [124.03373424500012, 10.547737601000051],
            [124.0339330380001, 10.547619561000033],
            [124.033696845, 10.547617631000037],
            [124.03338585900008, 10.547756959000026],
        ],
        [
            [124.03506085300012, 10.547373788000073],
            [124.03521830900002, 10.547147387000052],
            [124.03430307500003, 10.547749200000055],
            [124.03446250700006, 10.547785962000034],
            [124.03506085300012, 10.547373788000073],
        ],
        [
            [124.03629103300011, 10.547667878000027],
            [124.03697400900012, 10.547122184000045],
            [124.03650160200004, 10.546497186000067],
            [124.03514352500008, 10.547607925000023],
            [124.03629103300011, 10.547667878000027],
        ],
        [
            [124.035003791, 10.54785754300002],
            [124.03473610200001, 10.547743384000057],
            [124.0346672170001, 10.547991068000044],
            [124.03484830100001, 10.548095555000032],
            [124.035003791, 10.54785754300002],
        ],
        [
            [124.02668188200005, 10.566610027000024],
            [124.02746494200005, 10.565314196000031],
            [124.02675966400011, 10.564637369000025],
            [124.0259481270001, 10.565414453000074],
            [124.02668188200005, 10.566610027000024],
        ],
        [
            [124.03128503800008, 10.57129089800003],
            [124.0343014770001, 10.569146949000071],
            [124.03474485900006, 10.566701956000031],
            [124.03367460600009, 10.565525015000048],
            [124.03128503800008, 10.57129089800003],
        ],
        [
            [124.43627293300005, 10.717939886000067],
            [124.5144092490001, 10.65595152000003],
            [124.44175764600004, 10.626960537000059],
            [124.38319657200009, 10.646099622000065],
            [124.31252634300006, 10.586686531000055],
            [124.27479925300008, 10.590881859000035],
            [124.31580786900008, 10.709105329000067],
            [124.37497291600005, 10.689540684000065],
            [124.38325037800007, 10.646165040000028],
            [124.43627293300005, 10.717939886000067],
        ],
        [
            [124.31569262300002, 10.725848816000052],
            [124.32012181900006, 10.724421174000042],
            [124.3255292880001, 10.71370243900003],
            [124.3148338950001, 10.720554585000059],
            [124.31569262300002, 10.725848816000052],
        ],
        [
            [124.52625941300005, 10.740299209000057],
            [124.52622307700005, 10.74023177600003],
            [124.52614771500009, 10.740358710000066],
            [124.52623653600006, 10.740402341000049],
            [124.52625941300005, 10.740299209000057],
        ],
        [
            [124.52611541700003, 10.740434076000042],
            [124.52603063300012, 10.740465810000046],
            [124.52610061500002, 10.740562331000035],
            [124.52616521100003, 10.740473742000063],
            [124.52611541700003, 10.740434076000042],
        ],
        [
            [124.5353201590001, 10.800204744000041],
            [124.53526966900006, 10.800323540000022],
            [124.53533685100001, 10.800359897000021],
            [124.5354259390001, 10.800307145000033],
            [124.5353201590001, 10.800204744000041],
        ],
        [
            [124.53580049900006, 10.800480700000037],
            [124.53556364500002, 10.800404616000037],
            [124.53547271100001, 10.800685127000065],
            [124.53566255200008, 10.800718267000036],
            [124.53580049900006, 10.800480700000037],
        ],
        [
            [124.535964841, 10.800923131000047],
            [124.53594651700007, 10.800701961000073],
            [124.5357247070001, 10.800734816000045],
            [124.53572796000003, 10.800885007000034],
            [124.535964841, 10.800923131000047],
        ],
        [
            [124.54711421700006, 10.806907022000075],
            [124.54713801100002, 10.80679795900005],
            [124.54691594600001, 10.806763681000064],
            [124.54702221900004, 10.80690390500007],
            [124.54711421700006, 10.806907022000075],
        ],
        [
            [124.54722366200008, 10.807037898000033],
            [124.54744572700008, 10.806878979000032],
            [124.54736324800001, 10.806676433000064],
            [124.54709994100006, 10.807016085000043],
            [124.54722366200008, 10.807037898000033],
        ],
        [
            [124.55129273500006, 10.808581622000077],
            [124.55137969400005, 10.808371494000028],
            [124.55107533300009, 10.808412496000074],
            [124.55114664200005, 10.808579914000063],
            [124.55129273500006, 10.808581622000077],
        ],
        [
            [124.55092924100006, 10.808509873000048],
            [124.5510109820001, 10.808267287000035],
            [124.55098141500002, 10.808186995000028],
            [124.55071010000006, 10.808350999000027],
            [124.55092924100006, 10.808509873000048],
        ],
        [
            [124.55201332800004, 10.808731906000048],
            [124.55207140000005, 10.808659556000066],
            [124.55184193700006, 10.808519036000064],
            [124.55188159800002, 10.808791733000021],
            [124.55201332800004, 10.808731906000048],
        ],
        [
            [124.55287852700008, 10.808894115000044],
            [124.55293139100002, 10.808766195000032],
            [124.5527457180001, 10.808997974000022],
            [124.55281405700009, 10.808985307000057],
            [124.55287852700008, 10.808894115000044],
        ],
        [
            [124.55273024600001, 10.80913729100007],
            [124.5528205060001, 10.80908916200002],
            [124.55266964400005, 10.809039770000027],
            [124.55264772500004, 10.809122094000031],
            [124.55273024600001, 10.80913729100007],
        ],
        [
            [124.55488464100006, 10.810129412000038],
            [124.55476621000003, 10.81000031900004],
            [124.55446724900003, 10.809980463000045],
            [124.55458423700009, 10.810191836000058],
            [124.55488464100006, 10.810129412000038],
        ],
        [
            [124.5603179100001, 10.81305975400005],
            [124.56042738300005, 10.812919145000023],
            [124.56038865000005, 10.812790113000062],
            [124.560265705, 10.812889365000046],
            [124.5603179100001, 10.81305975400005],
        ],
        [
            [124.56012086400006, 10.813101106000033],
            [124.56020675600007, 10.813094492000062],
            [124.56020170800002, 10.812861243000043],
            [124.5600636040001, 10.812985309000055],
            [124.56012086400006, 10.813101106000033],
        ],
        [
            [124.56423810400008, 10.814038140000036],
            [124.5709565630001, 10.80572595500007],
            [124.54646662500011, 10.759318993000022],
            [124.50139219300002, 10.729013761000033],
            [124.56423810400008, 10.814038140000036],
        ],
        [
            [123.58994342900007, 11.034461184000065],
            [123.59086695600001, 11.034331967000071],
            [123.59093460500003, 11.03168660600005],
            [123.58881155800009, 11.032499206000068],
            [123.58994342900007, 11.034461184000065],
        ],
        [
            [123.603027988, 11.037564413000041],
            [123.60445175200005, 11.03598439600006],
            [123.60794322600009, 11.035473269000022],
            [123.60274039100011, 11.034076683000023],
            [123.603027988, 11.037564413000041],
        ],
        [
            [123.63498383800004, 11.060676774000058],
            [123.63270985500003, 11.051280332000033],
            [123.622345859, 11.04589547200004],
            [123.62582325500011, 11.05766363500004],
            [123.63498383800004, 11.060676774000058],
        ],
        [
            [123.64752543700001, 11.093111179000061],
            [123.65927130300008, 11.092266882000047],
            [123.63605136900003, 11.066296492000049],
            [123.63567453500002, 11.085110884000073],
            [123.64752543700001, 11.093111179000061],
        ],
        [
            [123.67081368900006, 11.105923408000024],
            [123.67268704100002, 11.097543464000069],
            [123.66274792400009, 11.092536609000035],
            [123.6645157480001, 11.10089627800005],
            [123.67081368900006, 11.105923408000024],
        ],
        [
            [123.7021979000001, 11.128280348000033],
            [123.70889106200002, 11.125776534000067],
            [123.70742744900008, 11.118004203000055],
            [123.70094463300006, 11.117363126000043],
            [123.7021979000001, 11.128280348000033],
        ],
        [
            [123.71445157000005, 11.131362559000024],
            [123.7142090420001, 11.131004607000023],
            [123.71204461100001, 11.130373490000068],
            [123.71236503600005, 11.131059295000057],
            [123.71445157000005, 11.131362559000024],
        ],
        [
            [123.69784354, 11.135086064000063],
            [123.699087, 11.127739105000046],
            [123.69255875600004, 11.126990651000028],
            [123.69063923100009, 11.131237030000023],
            [123.69784354, 11.135086064000063],
        ],
        [
            [123.720471072, 11.135700727000028],
            [123.72003027700009, 11.13473050600004],
            [123.715371763, 11.132757962000028],
            [123.7163965200001, 11.134842786000036],
            [123.720471072, 11.135700727000028],
        ],
        [
            [123.70244621900008, 11.141772368000034],
            [123.7034324220001, 11.14161215100006],
            [123.70174602000009, 11.140694318000044],
            [123.70162664500003, 11.141464940000049],
            [123.70244621900008, 11.141772368000034],
        ],
        [
            [123.70027357400011, 11.14473472800006],
            [123.70077926700003, 11.141707330000031],
            [123.69808065900008, 11.140997058000039],
            [123.69831395500012, 11.143591610000044],
            [123.70027357400011, 11.14473472800006],
        ],
        [
            [123.7037611500001, 11.147619204000023],
            [123.70329137600004, 11.147394174000056],
            [123.70386530000007, 11.148426534000066],
            [123.70397125000011, 11.14821653100006],
            [123.7037611500001, 11.147619204000023],
        ],
        [
            [123.70262500500007, 11.148440587000039],
            [123.70245403000001, 11.147396163000053],
            [123.70137499100008, 11.14743324400007],
            [123.70190012400008, 11.14835365600004],
            [123.70262500500007, 11.148440587000039],
        ],
        [
            [123.70629356900008, 11.149005267000064],
            [123.70690149000006, 11.145746057000053],
            [123.703507768, 11.143846902000064],
            [123.7039204030001, 11.147945550000031],
            [123.70629356900008, 11.149005267000064],
        ],
        [
            [123.64354070800005, 11.149615587000028],
            [123.64474840800005, 11.14674539400005],
            [123.64981690400009, 11.142948059000048],
            [123.64263634600002, 11.143078949000028],
            [123.64354070800005, 11.149615587000028],
        ],
        [
            [123.70432059200004, 11.151729107000051],
            [123.70419341500008, 11.151010721000034],
            [123.70344210100006, 11.15071282100007],
            [123.70443388700005, 11.152369296000074],
            [123.70432059200004, 11.151729107000051],
        ],
        [
            [123.92290425100009, 11.195330648000038],
            [123.92595617000006, 11.192433983000058],
            [123.92454103600005, 11.172191921000035],
            [123.91488392700012, 11.18950157300003],
            [123.92290425100009, 11.195330648000038],
        ],
        [
            [123.82042083600004, 11.215107277000072],
            [123.8294218530001, 11.205975944000045],
            [123.81972237800005, 11.190008066000075],
            [123.8115447460001, 11.208373250000022],
            [123.82042083600004, 11.215107277000072],
        ],
        [
            [123.79129035400001, 11.220092564000026],
            [123.79580077500009, 11.217421599000033],
            [123.79657950700005, 11.215089669000065],
            [123.79117421800004, 11.214429559000052],
            [123.79129035400001, 11.220092564000026],
        ],
        [
            [124.06353364600011, 11.285703472000023],
            [124.03489332700008, 11.146887354000057],
            [123.98248911500002, 11.07338297800004],
            [124.04297820400006, 11.055806890000042],
            [124.02983855700006, 10.929146338000066],
            [124.05401637400007, 10.881796758000064],
            [124.00432962900004, 10.75532174600005],
            [124.02270726900008, 10.557528705000038],
            [124.03641651700002, 10.551870350000058],
            [124.03285004300005, 10.54797676000004],
            [124.02959517900001, 10.536183021000056],
            [124.02751482700012, 10.513314344000037],
            [124.03311189900012, 10.49755519100006],
            [123.99841221100007, 10.414418185000045],
            [124.02127575400004, 10.383355686000073],
            [123.95933978200003, 10.35940245100005],
            [123.96996137500003, 10.33138569600004],
            [123.88546045500004, 10.289363234000064],
            [123.86314373500011, 10.248475431000031],
            [123.76605760400003, 10.226406835000034],
            [123.6812787560001, 10.085897705000036],
            [123.6396627800001, 10.083506189000047],
            [123.608945, 9.875061001000063],
            [123.53707353200002, 9.805354066000064],
            [123.466361, 9.57110300100004],
            [123.35437690600008, 9.425461143000064],
            [123.3016020450001, 9.416704042000049],
            [123.34448870900007, 9.786127197000042],
            [123.39984609900011, 9.881082586000048],
            [123.3712215270001, 9.993527072000063],
            [123.3894945290001, 9.962373526000022],
            [123.40269900900012, 9.972414713000035],
            [123.41456684900004, 10.051705273000039],
            [123.51462119000007, 10.148377396000058],
            [123.58282492400008, 10.263989235000054],
            [123.58628546600005, 10.338661268000067],
            [123.71475622600008, 10.49678977900004],
            [123.74171187400009, 10.634273913000072],
            [123.83114495900008, 10.733348657000022],
            [123.92256503600004, 10.951653608000072],
            [123.93354260400008, 10.993839241000046],
            [123.90125488000001, 11.03423986100006],
            [123.93380505900006, 11.106693792000044],
            [123.94851324100011, 11.089103813000065],
            [123.96909264300007, 11.080560910000031],
            [123.94436278100011, 11.187109831000043],
            [123.99857568400012, 11.271394560000033],
            [124.06353364600011, 11.285703472000023],
        ],
        [
            [123.73299986200004, 11.299457373000052],
            [123.7744578280001, 11.196864652000045],
            [123.80805973100007, 11.151849989000027],
            [123.7523790680001, 11.151135594000039],
            [123.73324024700003, 11.137272119000045],
            [123.72074830100007, 11.137248244000034],
            [123.688062349, 11.226517318000049],
            [123.73299986200004, 11.299457373000052],
        ],
        [
            [124.06333160100007, 11.306851547000065],
            [124.06477706500004, 11.306770561000064],
            [124.06325189300003, 11.304745592000074],
            [124.062558824, 11.30548519100006],
            [124.06333160100007, 11.306851547000065],
        ],
        [
            [124.1085225170001, 11.323930028000063],
            [124.10890843000004, 11.32340169300005],
            [124.10898332500005, 11.323477031000039],
            [124.10902172500005, 11.32341155000006],
            [124.10864348200005, 11.32336800400003],
            [124.10850127200001, 11.32356986600007],
            [124.1083223280001, 11.323428524000064],
            [124.1085225170001, 11.323930028000063],
        ],
        [
            [124.10610061400007, 11.347603246000062],
            [124.10583181700008, 11.347215169000037],
            [124.10525237900004, 11.347380048000048],
            [124.10580976900007, 11.347789653000063],
            [124.10610061400007, 11.347603246000062],
        ],
        [
            [124.11682829900008, 11.347983767000073],
            [124.12181867800007, 11.329800797000075],
            [124.11245290200009, 11.326221542000042],
            [124.10630081700003, 11.346700920000046],
            [124.11682829900008, 11.347983767000073],
        ],
        [
            [123.89718544400012, 11.352787874000057],
            [123.89927845900002, 11.30597840300004],
            [123.887960528, 11.295776596000053],
            [123.88466187600011, 11.333227843000031],
            [123.89718544400012, 11.352787874000057],
        ],
        [
            [124.09385581600009, 11.52330964400005],
            [124.10419048000006, 11.516901826000037],
            [124.10501959300007, 11.50671585300006],
            [124.09067356500009, 11.51310931200004],
            [124.09385581600009, 11.52330964400005],
        ],
        [
            [125.06042068800002, 9.96466237200002],
            [125.07965721300002, 9.93448776300005],
            [125.07348616200011, 9.89520022000005],
            [125.07370276100005, 9.923506408000037],
            [125.06042068800002, 9.96466237200002],
        ],
        [
            [125.12920936300009, 10.16187869600003],
            [125.21267403500008, 10.128015933000029],
            [125.28030097100009, 9.994365600000037],
            [125.2873645630001, 9.912044818000027],
            [125.2555727890001, 9.914124854000022],
            [125.18656045700004, 10.037018941000042],
            [125.13478301400005, 10.061588672000028],
            [125.12920936300009, 10.16187869600003],
        ],
        [
            [124.61889977300007, 10.263207054000077],
            [124.61758096400001, 10.263233674000048],
            [124.61498241700008, 10.265182586000037],
            [124.61693132700009, 10.266428220000023],
            [124.61889977300007, 10.263207054000077],
        ],
        [
            [125.2217783540001, 10.434141878000048],
            [125.22843447700006, 10.430240497000057],
            [125.22502864500007, 10.425030865000053],
            [125.21627710300004, 10.432416284000055],
            [125.2217783540001, 10.434141878000048],
        ],
        [
            [125.22502151600008, 10.474569501000076],
            [125.22437049400003, 10.462324891000037],
            [125.2323078610001, 10.444916954000064],
            [125.22268656200004, 10.457719306000058],
            [125.22502151600008, 10.474569501000076],
        ],
        [
            [124.67834987000003, 10.492356222000069],
            [124.6735934510001, 10.486616997000056],
            [124.66789097100002, 10.485665826000059],
            [124.66791808000005, 10.489101583000036],
            [124.67834987000003, 10.492356222000069],
        ],
        [
            [124.67175601400004, 10.522177175000024],
            [124.67338459300004, 10.519292359000076],
            [124.67290731000003, 10.515660314000058],
            [124.668891916, 10.51955053100005],
            [124.67175601400004, 10.522177175000024],
        ],
        [
            [124.6370117570001, 10.540002007000055],
            [124.64166683600001, 10.537930092000067],
            [124.64273715500008, 10.534961274000068],
            [124.63484232000008, 10.536884650000047],
            [124.6370117570001, 10.540002007000055],
        ],
        [
            [124.65923703500005, 10.546330263000073],
            [124.6620573140001, 10.544080724000025],
            [124.66185171000006, 10.542508914000052],
            [124.65979271900005, 10.54425094100003],
            [124.65923703500005, 10.546330263000073],
        ],
        [
            [125.9371910860001, 10.773610830000052],
            [125.9383950880001, 10.771541052000032],
            [125.93693232500004, 10.770389671000032],
            [125.9357988270001, 10.772440095000036],
            [125.9371910860001, 10.773610830000052],
        ],
        [
            [125.95745492100002, 10.775898686000062],
            [125.96797824200007, 10.757624788000044],
            [125.96685639600003, 10.746818733000055],
            [125.93799877700008, 10.768303142000036],
            [125.95745492100002, 10.775898686000062],
        ],
        [
            [125.95267073000002, 10.776256136000029],
            [125.9518638940001, 10.774749901000064],
            [125.95093822500007, 10.774886681000055],
            [125.95198443000004, 10.776039165000043],
            [125.95267073000002, 10.776256136000029],
        ],
        [
            [125.95263746400008, 10.77749409200004],
            [125.95354394500009, 10.777296799000055],
            [125.953686618, 10.77691118000007],
            [125.95290280900008, 10.77665907100004],
            [125.95263746400008, 10.77749409200004],
        ],
        [
            [125.6517916360001, 10.785499463000065],
            [125.64640188100009, 10.777767054000037],
            [125.64382404800006, 10.777856368000073],
            [125.64744275200007, 10.784560224000074],
            [125.6517916360001, 10.785499463000065],
        ],
        [
            [125.69382858900008, 10.82346973600005],
            [125.7276295480001, 10.797867152000038],
            [125.71869337900011, 10.745874152000056],
            [125.8112100620001, 10.730854807000071],
            [125.81078384200009, 10.69664782600006],
            [125.75211628800002, 10.689194375000056],
            [125.67040147500006, 10.74413942600006],
            [125.66044383500002, 10.79085844900004],
            [125.69382858900008, 10.82346973600005],
        ],
        [
            [125.83844693900005, 10.931342253000025],
            [125.83796466900003, 10.93074751000006],
            [125.83740892800006, 10.931356727000036],
            [125.83814554100002, 10.931544367000072],
            [125.83844693900005, 10.931342253000025],
        ],
        [
            [125.83484388400007, 10.93169757000004],
            [125.84008916500011, 10.921713926000052],
            [125.83799753200003, 10.913878774000068],
            [125.82956871400006, 10.929447319000076],
            [125.83484388400007, 10.93169757000004],
        ],
        [
            [125.8330077820001, 10.939525931000048],
            [125.8334562020001, 10.939360108000074],
            [125.83354937900003, 10.939180948000057],
            [125.8326913630001, 10.939474474000065],
            [125.8330077820001, 10.939525931000048],
        ],
        [
            [125.8313462640001, 10.939562889000058],
            [125.83487425600003, 10.93371305900007],
            [125.82629970900007, 10.934402042000045],
            [125.82535666900003, 10.93786208900002],
            [125.8313462640001, 10.939562889000058],
        ],
        [
            [125.62114787700011, 11.004335751000042],
            [125.62109579700007, 11.00439740400003],
            [125.6212908980001, 11.004548145000058],
            [125.62132692500006, 11.004427486000054],
            [125.62114787700011, 11.004335751000042],
        ],
        [
            [125.62204717100008, 11.004909826000073],
            [125.6219722940001, 11.004728882000052],
            [125.62173315600012, 11.004715850000025],
            [125.62176795000005, 11.004886317000057],
            [125.62204717100008, 11.004909826000073],
        ],
        [
            [125.62767572200005, 11.005852186000027],
            [125.65243034600007, 11.005038154000033],
            [125.65287627200007, 10.98112997000004],
            [125.6180121220001, 10.987286784000048],
            [125.62767572200005, 11.005852186000027],
        ],
        [
            [125.64331946100003, 11.008402476000072],
            [125.645135148, 11.007987159000038],
            [125.6452549500001, 11.00777133500003],
            [125.64204055300002, 11.00845130600004],
            [125.64331946100003, 11.008402476000072],
        ],
        [
            [125.74685663900004, 11.016476762000025],
            [125.74767986200004, 11.016320300000075],
            [125.74907870900006, 11.014195015000041],
            [125.74550558700003, 11.01416559300003],
            [125.74685663900004, 11.016476762000025],
        ],
        [
            [125.69384027600006, 11.02890732800006],
            [125.69667946000004, 11.025304856000048],
            [125.69199906400002, 11.023129681000057],
            [125.68877059800002, 11.028096746000074],
            [125.69384027600006, 11.02890732800006],
        ],
        [
            [125.76110511600007, 11.02923998700004],
            [125.76100875300006, 11.029365091000045],
            [125.761084922, 11.029490188000068],
            [125.7611610780001, 11.029368136000073],
            [125.76110511600007, 11.02923998700004],
        ],
        [
            [125.76152327900002, 11.030196530000069],
            [125.76158698200004, 11.02972206000004],
            [125.76138025000012, 11.02958781600006],
            [125.76122017600005, 11.030033304000028],
            [125.76152327900002, 11.030196530000069],
        ],
        [
            [125.76910285100007, 11.032563933000063],
            [125.82598460400004, 10.970005185000048],
            [125.83824668600005, 10.94024134500006],
            [125.76319980800008, 11.014265006000073],
            [125.76910285100007, 11.032563933000063],
        ],
        [
            [125.77103297000008, 11.007666177000033],
            [125.77086987500002, 11.007515997000041],
            [125.77127338600008, 11.007263471000044],
            [125.77123136300008, 11.007573747000038],
            [125.77103297000008, 11.007666177000033],
        ],
        [
            [125.77014859000008, 11.007822995000026],
            [125.77028814500011, 11.007966576000058],
            [125.77015700900006, 11.008219092000047],
            [125.77001913600009, 11.008126674000039],
            [125.77014859000008, 11.007822995000026],
        ],
        [
            [125.7627156740001, 11.033138046000033],
            [125.76331204300004, 11.032265178000046],
            [125.76189222000005, 11.030549346000043],
            [125.76132585000005, 11.033449692000033],
            [125.7627156740001, 11.033138046000033],
        ],
        [
            [125.76182793800001, 11.038483043000042],
            [125.761531966, 11.03818489200006],
            [125.76099957000008, 11.038392403000046],
            [125.76146623400007, 11.038885736000054],
            [125.76182793800001, 11.038483043000042],
        ],
        [
            [125.76063321900006, 11.039929355000027],
            [125.76080546300011, 11.039800245000038],
            [125.76055021400009, 11.039692671000068],
            [125.76051577400005, 11.039894011000058],
            [125.76063321900006, 11.039929355000027],
        ],
        [
            [125.62888317400007, 11.046765822000054],
            [125.63024836400007, 11.046620782000048],
            [125.63043836500003, 11.045460458000036],
            [125.62710279700002, 11.047145689000047],
            [125.62888317400007, 11.046765822000054],
        ],
        [
            [125.70143633600003, 11.054604323000035],
            [125.701677646, 11.054564657000071],
            [125.70172521500001, 11.054435954000041],
            [125.70156423800006, 11.054333730000053],
            [125.70143633600003, 11.054604323000035],
        ],
        [
            [125.7076141120001, 11.056023569000047],
            [125.70775938000008, 11.055405534000045],
            [125.70751801800009, 11.055067138000027],
            [125.70717029200011, 11.055923607000068],
            [125.7076141120001, 11.056023569000047],
        ],
        [
            [125.70110819400008, 11.056263265000041],
            [125.70064707100005, 11.055446348000032],
            [125.70009851300006, 11.057177460000048],
            [125.70033322600011, 11.057168475000026],
            [125.70110819400008, 11.056263265000041],
        ],
        [
            [125.69551451400002, 11.058457395000062],
            [125.69638112200005, 11.057007935000058],
            [125.69514820600011, 11.056333662000043],
            [125.695109838, 11.058179414000051],
            [125.69551451400002, 11.058457395000062],
        ],
        [
            [125.68163672300011, 11.059790796000073],
            [125.69769699300002, 11.054419274000054],
            [125.71209859100009, 11.044560832000059],
            [125.68914775500002, 11.033064553000031],
            [125.68163672300011, 11.059790796000073],
        ],
        [
            [125.70186844400007, 11.059366652000051],
            [125.70154273100002, 11.059571428000027],
            [125.70177666100005, 11.060018728000045],
            [125.7020826370001, 11.059620424000059],
            [125.70186844400007, 11.059366652000051],
        ],
        [
            [125.69706228600012, 11.062169403000041],
            [125.698340346, 11.060968563000074],
            [125.69839485400007, 11.058341150000047],
            [125.69326253100007, 11.061123098000053],
            [125.69706228600012, 11.062169403000041],
        ],
        [
            [125.68537094300007, 11.072646933000044],
            [125.68542669700003, 11.070385370000054],
            [125.68344750900008, 11.07056076300006],
            [125.68331448200001, 11.071483924000063],
            [125.68537094300007, 11.072646933000044],
        ],
        [
            [125.58149200700007, 11.10420685500003],
            [125.5824083440001, 11.103722884000035],
            [125.58087655700001, 11.103860191000024],
            [125.57980571400003, 11.103789321000022],
            [125.58149200700007, 11.10420685500003],
        ],
        [
            [125.48247834800009, 11.10468912500005],
            [125.48311037300005, 11.104481022000073],
            [125.48323794400005, 11.104043666000052],
            [125.48233790900008, 11.104511923000075],
            [125.48247834800009, 11.10468912500005],
        ],
        [
            [125.57588974100008, 11.107295059000023],
            [125.57905575200004, 11.106622538000067],
            [125.57901737600002, 11.103888526000048],
            [125.58542204800005, 11.099509190000049],
            [125.57776101400009, 11.093011017000038],
            [125.57588974100008, 11.107295059000023],
        ],
        [
            [125.66199467100012, 11.110460107000051],
            [125.65710552200005, 11.104432512000074],
            [125.65340398900003, 11.105080532000045],
            [125.65380545200003, 11.108428350000054],
            [125.66199467100012, 11.110460107000051],
        ],
        [
            [125.6772654780001, 11.11218801900003],
            [125.68565692700008, 11.100265131000072],
            [125.66831333700009, 11.091011954000066],
            [125.66337705300009, 11.11044015300007],
            [125.6772654780001, 11.11218801900003],
        ],
        [
            [125.47650743300005, 11.113086538000061],
            [125.47696801900008, 11.112946847000046],
            [125.4757011050001, 11.112171674000024],
            [125.47617451200006, 11.11294674000004],
            [125.47650743300005, 11.113086538000061],
        ],
        [
            [125.4696218580001, 11.115803541000048],
            [125.46956359100011, 11.112765082000067],
            [125.46855645200003, 11.112103422000075],
            [125.46800672000006, 11.114681999000027],
            [125.4696218580001, 11.115803541000048],
        ],
        [
            [125.4699382020001, 11.116974299000049],
            [125.46995030500011, 11.116808262000063],
            [125.46975238800007, 11.116794900000059],
            [125.46982035200006, 11.117023208000035],
            [125.4699382020001, 11.116974299000049],
        ],
        [
            [125.52795904000004, 11.126742914000033],
            [125.52866521700003, 11.126450588000068],
            [125.52829016900012, 11.125698338000063],
            [125.52776092300007, 11.126125677000061],
            [125.52795904000004, 11.126742914000033],
        ],
        [
            [125.5268829040001, 11.129043110000055],
            [125.52637722800011, 11.128368366000075],
            [125.52611021100006, 11.127268583000046],
            [125.52590934000011, 11.128738497000029],
            [125.5268829040001, 11.129043110000055],
        ],
        [
            [125.52725341500002, 11.129854413000032],
            [125.52745724400006, 11.129674102000024],
            [125.52725340100005, 11.12946501500005],
            [125.52711442900011, 11.129657446000067],
            [125.52725341500002, 11.129854413000032],
        ],
        [
            [125.52797306000002, 11.13097409900007],
            [125.52792824900007, 11.130175608000059],
            [125.52768579600001, 11.129883188000065],
            [125.527574651, 11.130936235000036],
            [125.52797306000002, 11.13097409900007],
        ],
        [
            [125.52065857000002, 11.135762747000058],
            [125.52236644900006, 11.135487641000054],
            [125.52274188500007, 11.13488594100005],
            [125.5209552980001, 11.133962115000031],
            [125.52065857000002, 11.135762747000058],
        ],
        [
            [125.5349102990001, 11.136487253000041],
            [125.53562773500005, 11.136067466000043],
            [125.53491766800005, 11.132805166000026],
            [125.53228732500008, 11.135032248000073],
            [125.5349102990001, 11.136487253000041],
        ],
        [
            [125.53624801600006, 11.138275315000044],
            [125.53810309800008, 11.138160666000033],
            [125.53961234500002, 11.136685208000074],
            [125.53416337700003, 11.137230271000021],
            [125.53624801600006, 11.138275315000044],
        ],
        [
            [125.54631717300003, 11.142537808000043],
            [125.54737883200005, 11.142134037000062],
            [125.5474974230001, 11.141513039000074],
            [125.54557975600005, 11.141975908000063],
            [125.54631717300003, 11.142537808000043],
        ],
        [
            [125.54119984200008, 11.142816252000046],
            [125.54153228700011, 11.142607811000062],
            [125.5401516070001, 11.142465998000034],
            [125.54056875900005, 11.142721176000066],
            [125.54119984200008, 11.142816252000046],
        ],
        [
            [125.54296869200004, 11.143054719000077],
            [125.5436321950001, 11.142293069000061],
            [125.54122854700006, 11.14051087200005],
            [125.54165263200002, 11.142704500000036],
            [125.54296869200004, 11.143054719000077],
        ],
        [
            [125.54717672700008, 11.14353529400006],
            [125.54746646400008, 11.143265323000037],
            [125.54721082700007, 11.142870837000032],
            [125.54692272300008, 11.14318073800007],
            [125.54717672700008, 11.14353529400006],
        ],
        [
            [125.55116502300007, 11.143523216000062],
            [125.55137523700012, 11.143523186000039],
            [125.5514691730001, 11.143360674000064],
            [125.55116976200009, 11.143256028000053],
            [125.55116502300007, 11.143523216000062],
        ],
        [
            [125.55203456200002, 11.143654344000026],
            [125.55223357600005, 11.143307441000047],
            [125.55165073000012, 11.143427835000068],
            [125.5518689590001, 11.143790305000039],
            [125.55203456200002, 11.143654344000026],
        ],
        [
            [125.5491264630001, 11.143972689000066],
            [125.54875848600011, 11.141879737000068],
            [125.54767231200003, 11.142082237000068],
            [125.54728983400003, 11.142751530000055],
            [125.5491264630001, 11.143972689000066],
        ],
        [
            [125.54976032700006, 11.145187448000058],
            [125.55162865600005, 11.144973157000038],
            [125.5521509460001, 11.144541833000062],
            [125.5509434380001, 11.144176346000052],
            [125.54976032700006, 11.145187448000058],
        ],
        [
            [125.0145613840001, 11.152750567000055],
            [125.01595455400002, 11.151480734000074],
            [125.01585246600007, 11.149828769000067],
            [125.01516423300006, 11.14933925500003],
            [125.0145613840001, 11.152750567000055],
        ],
        [
            [125.04664266000009, 11.217416215000071],
            [125.04748107300009, 11.217333090000068],
            [125.0482125420001, 11.214954250000062],
            [125.04669009500003, 11.215881792000062],
            [125.04664266000009, 11.217416215000071],
        ],
        [
            [125.08506490000002, 11.258251466000047],
            [125.08256159100006, 11.254275362000044],
            [125.07075201700002, 11.265253823000023],
            [125.07495379500006, 11.26923935000002],
            [125.08506490000002, 11.258251466000047],
        ],
        [
            [124.97367834600004, 11.300043157000061],
            [124.97374359500009, 11.29975862300006],
            [124.97359739900003, 11.299626271000022],
            [124.97346241200012, 11.300007850000043],
            [124.97367834600004, 11.300043157000061],
        ],
        [
            [124.97221909300004, 11.303183111000067],
            [124.97373228100003, 11.30075254600007],
            [124.97303781500011, 11.300015803000065],
            [124.9711746380001, 11.302574427000025],
            [124.97221909300004, 11.303183111000067],
        ],
        [
            [124.97164193100002, 11.306615083000054],
            [124.97160123000003, 11.305266265000057],
            [124.97091768700011, 11.30470596400005],
            [124.97128194200002, 11.306415464000054],
            [124.97164193100002, 11.306615083000054],
        ],
        [
            [124.97226008100006, 11.321675251000045],
            [124.97260405400004, 11.320735392000074],
            [124.972462629, 11.320189392000032],
            [124.9715581910001, 11.321299722000049],
            [124.97226008100006, 11.321675251000045],
        ],
        [
            [124.97471045900011, 11.33764910900004],
            [124.97529106200011, 11.33735521500006],
            [124.97357206600009, 11.336336566000057],
            [124.97333447800008, 11.336934042000053],
            [124.97471045900011, 11.33764910900004],
        ],
        [
            [124.97723119000011, 11.341558042000031],
            [124.97852954400003, 11.33955221900004],
            [124.97564804100011, 11.33837193100004],
            [124.97537211300005, 11.339690157000064],
            [124.97723119000011, 11.341558042000031],
        ],
        [
            [124.97983533000001, 11.362066282000058],
            [124.98078157200007, 11.361796007000066],
            [124.97865959600006, 11.360559026000033],
            [124.97860782900011, 11.361637913000038],
            [124.97983533000001, 11.362066282000058],
        ],
        [
            [124.98086407700009, 11.364388076000068],
            [124.98149590000003, 11.363098729000058],
            [124.98025498100003, 11.362723467000023],
            [124.98031309800001, 11.363603994000073],
            [124.98086407700009, 11.364388076000068],
        ],
        [
            [124.97981464100008, 11.365791310000077],
            [124.97919509200005, 11.36376699300007],
            [124.97835423800007, 11.362980465000021],
            [124.97826854300001, 11.365388735000067],
            [124.97981464100008, 11.365791310000077],
        ],
        [
            [124.89733579900007, 11.39958064600006],
            [124.89743096400002, 11.399042747000067],
            [124.89685981500008, 11.398279827000067],
            [124.89646231200004, 11.399383080000064],
            [124.89733579900007, 11.39958064600006],
        ],
        [
            [124.89558014800002, 11.401545240000075],
            [124.89672880800003, 11.401127615000064],
            [124.89618866400008, 11.400016538000045],
            [124.89485743400007, 11.400478907000036],
            [124.89558014800002, 11.401545240000075],
        ],
        [
            [124.95553214000006, 11.409352893000062],
            [124.95592439500001, 11.407430111000053],
            [124.9553908470001, 11.406880208000075],
            [124.95523396700003, 11.408514571000069],
            [124.95553214000006, 11.409352893000062],
        ],
        [
            [124.96973065000009, 11.422223598000073],
            [124.97442723400002, 11.421301654000047],
            [124.97352085400007, 11.417731662000051],
            [124.96861912700001, 11.417592089000038],
            [124.96973065000009, 11.422223598000073],
        ],
        [
            [124.98695375600005, 11.422740420000025],
            [124.98714031800012, 11.422686852000027],
            [124.98590060600009, 11.422443767000061],
            [124.98377778100007, 11.421203123000055],
            [124.98452349000002, 11.42221999800006],
            [124.98695375600005, 11.422740420000025],
        ],
        [
            [124.9605413590001, 11.422420381000052],
            [124.97987827000009, 11.403217110000071],
            [124.96940911800004, 11.392905496000026],
            [124.95260462700003, 11.401269533000061],
            [124.95650206900007, 11.40704863600007],
            [124.9564213750001, 11.412976298000046],
            [124.95220603900009, 11.418628800000022],
            [124.9605413590001, 11.422420381000052],
        ],
        [
            [124.96667891800007, 11.42502031600003],
            [124.9678786290001, 11.42392439400004],
            [124.9677153130001, 11.42353035800005],
            [124.96572416000004, 11.42526659200007],
            [124.96667891800007, 11.42502031600003],
        ],
        [
            [124.96309286100006, 11.430536844000073],
            [124.96355407800002, 11.428432050000026],
            [124.96291208500008, 11.427835325000046],
            [124.96194539200008, 11.428706891000047],
            [124.96309286100006, 11.430536844000073],
        ],
        [
            [124.87067321100005, 11.434457512000051],
            [124.87217553200003, 11.432544378000046],
            [124.87227653700006, 11.431977084000039],
            [124.87069713000005, 11.43268824200004],
            [124.87067321100005, 11.434457512000051],
        ],
        [
            [124.90931779900006, 11.43481865900003],
            [124.91068778300007, 11.430797318000032],
            [124.91346951900005, 11.429029792000051],
            [124.90878032100011, 11.42824951700004],
            [124.90931779900006, 11.43481865900003],
        ],
        [
            [124.85324429700006, 11.439627364000046],
            [124.85416558400004, 11.43945781800005],
            [124.8541153750001, 11.43683399300005],
            [124.85485579300007, 11.435966347000033],
            [124.85482268500004, 11.433988351000039],
            [124.84873506200006, 11.435501549000037],
            [124.85324429700006, 11.439627364000046],
        ],
        [
            [125.55236414600006, 11.439499640000065],
            [125.55497152200007, 11.438060442000051],
            [125.56092731700005, 11.430743283000027],
            [125.54810659500004, 11.43082503900007],
            [125.55236414600006, 11.439499640000065],
        ],
        [
            [124.888202352, 11.44127626200003],
            [124.89278937100005, 11.437638916000026],
            [124.89177827300011, 11.429780549000043],
            [124.88976776900006, 11.435134575000063],
            [124.88603170600004, 11.439201080000032],
            [124.888202352, 11.44127626200003],
        ],
        [
            [124.89659809700004, 11.500577132000046],
            [124.90082166500008, 11.499811953000062],
            [124.9048275450001, 11.496681134000028],
            [124.89840327600007, 11.495898751000027],
            [124.89567970700011, 11.493679833000044],
            [124.89659809700004, 11.500577132000046],
        ],
        [
            [124.79528556700006, 11.527173281000046],
            [124.79929551500004, 11.526714303000063],
            [124.800453005, 11.525926020000043],
            [124.79737622100004, 11.524073921000024],
            [124.79528556700006, 11.527173281000046],
        ],
        [
            [124.81175035100011, 11.527608324000028],
            [124.81642138300003, 11.52591158000007],
            [124.80179897200003, 11.520496319000074],
            [124.80574845300009, 11.524219791000064],
            [124.81175035100011, 11.527608324000028],
        ],
        [
            [124.81787685800009, 11.534524900000065],
            [124.81782905900002, 11.534429105000072],
            [124.81773346200009, 11.53446955100003],
            [124.81792465600006, 11.534612181000057],
            [124.81787685800009, 11.534524900000065],
        ],
        [
            [124.85579308600006, 11.547466163000024],
            [124.85630343300011, 11.545876853000038],
            [124.8545482510001, 11.546057125000061],
            [124.85402763700006, 11.547020169000064],
            [124.85579308600006, 11.547466163000024],
        ],
        [
            [124.85447361800004, 11.550459562000071],
            [124.8544944360001, 11.550198158000057],
            [124.85427871900004, 11.550207426000043],
            [124.85416139500012, 11.550491075000025],
            [124.85447361800004, 11.550459562000071],
        ],
        [
            [124.78701744800003, 11.550049982000075],
            [124.78455216800012, 11.54839220200006],
            [124.78285446200005, 11.548520675000077],
            [124.78802678600005, 11.550941541000043],
            [124.78701744800003, 11.550049982000075],
        ],
        [
            [124.78826101000004, 11.551664881000022],
            [124.78889179300006, 11.551654987000063],
            [124.78906161900011, 11.551704509000047],
            [124.78819086100009, 11.551077922000047],
            [124.78826101000004, 11.551664881000022],
        ],
        [
            [124.8536493690001, 11.552942242000029],
            [124.85377187200004, 11.55149409300003],
            [124.85312491800005, 11.55442185100003],
            [124.85363893300007, 11.553827565000063],
            [124.8536493690001, 11.552942242000029],
        ],
        [
            [124.85853286100007, 11.555260894000071],
            [124.86196550700004, 11.549913931000049],
            [124.86134453200009, 11.547542846000056],
            [124.85879654900009, 11.547895234000066],
            [124.85853286100007, 11.555260894000071],
        ],
        [
            [124.849872419, 11.562505187000056],
            [124.85206428600009, 11.562348199000041],
            [124.85247451600003, 11.55998461300004],
            [124.84907327500002, 11.56091617800007],
            [124.849872419, 11.562505187000056],
        ],
        [
            [124.31394764700008, 11.563557892000063],
            [124.47421470200004, 11.37639202400004],
            [124.46270933300002, 11.44547850300006],
            [124.48100366800008, 11.461151733000065],
            [124.5371753930001, 11.425775305000059],
            [124.58471319600005, 11.30496211600007],
            [124.70165345800001, 11.304945994000036],
            [124.80686523100007, 11.384642502000077],
            [124.8153327660001, 11.43240804100003],
            [124.86225080500003, 11.426346117000037],
            [124.85474991500007, 11.414488488000075],
            [124.8807081000001, 11.407813013000066],
            [124.87259708200008, 11.435133224000026],
            [124.88028785800009, 11.44219356800005],
            [124.8895884960001, 11.434346769000058],
            [124.89353718600012, 11.400814457000024],
            [124.8988647540001, 11.396548274000054],
            [124.94147337700008, 11.428135471000076],
            [124.95472262300007, 11.415084619000027],
            [124.95160486000009, 11.400630250000063],
            [124.95634404000009, 11.393914404000043],
            [124.9684241000001, 11.391626617000043],
            [124.97999858700007, 11.399201720000065],
            [124.96196685900009, 11.280239166000058],
            [125.01969831400004, 11.20784181700003],
            [125.0308962690001, 11.238238705000072],
            [125.00716334800006, 11.158196367000073],
            [125.0397791580001, 11.063832932000025],
            [125.01050262000001, 10.757500768000057],
            [125.11742647000005, 10.696088858000053],
            [125.11264689600011, 10.659269503000075],
            [125.18699216400012, 10.591181196000036],
            [125.1643179130001, 10.533539381000026],
            [125.18015137800012, 10.427147503000072],
            [125.25778989600008, 10.371834087000025],
            [125.26803386300003, 10.299889350000058],
            [125.21742901000005, 10.246862339000074],
            [125.13098265300005, 10.276931758000046],
            [125.13954481400003, 10.172343630000057],
            [125.1253759550001, 10.162366826000039],
            [125.02515985500008, 10.368500526000048],
            [124.96983619700006, 10.377046689000053],
            [125.02781441200011, 10.004747395000038],
            [124.88893332600003, 10.121271783000054],
            [124.75760619500011, 10.155576487000076],
            [124.79091106900012, 10.318702683000026],
            [124.73278371300012, 10.376745701000061],
            [124.72058021200007, 10.485684141000036],
            [124.80412649300001, 10.661692153000047],
            [124.78287958400006, 10.775713802000041],
            [124.68367510700011, 10.938756299000033],
            [124.58989860600002, 11.014229132000025],
            [124.53779110200003, 10.97754942000006],
            [124.55081833700001, 10.929791747000024],
            [124.51592451300007, 10.86798032400003],
            [124.43083014700005, 10.890685088000055],
            [124.41598343200008, 10.950874760000033],
            [124.41284559700011, 10.94969962500005],
            [124.41711547400007, 10.927191151000045],
            [124.4139623000001, 10.911896241000022],
            [124.37498430900007, 10.923859995000043],
            [124.41440727600002, 10.986213044000067],
            [124.3691875500001, 11.063418950000028],
            [124.40155021700002, 11.109498766000058],
            [124.40329449900003, 11.239776671000072],
            [124.38978632800001, 11.29853214800005],
            [124.34223090000012, 11.314040229000057],
            [124.36126724600001, 11.365344641000036],
            [124.32990740700006, 11.379474350000066],
            [124.349196215, 11.405436741000074],
            [124.31763149800008, 11.413975020000066],
            [124.28937197800008, 11.49298106200007],
            [124.31394764700008, 11.563557892000063],
        ],
        [
            [125.02684167300004, 10.735001369000031],
            [125.02417675100003, 10.732987741000045],
            [125.02499879700008, 10.733354925000071],
            [125.02798812500009, 10.72728455400005],
            [125.03137403000005, 10.72695122700003],
            [125.02818223500003, 10.730433082000047],
            [125.02684167300004, 10.735001369000031],
        ],
        [
            [124.85359162500004, 11.566372655000066],
            [124.8537469150001, 11.56323959100007],
            [124.85306618200002, 11.56243157700004],
            [124.85205262400007, 11.565312523000046],
            [124.85359162500004, 11.566372655000066],
        ],
        [
            [124.91372918500008, 11.581970277000039],
            [124.91255713800001, 11.580605352000077],
            [124.91201056500006, 11.580423300000064],
            [124.91228802100011, 11.581441384000073],
            [124.91372918500008, 11.581970277000039],
        ],
        [
            [124.2652766540001, 11.582488364000028],
            [124.27758118000008, 11.563262475000045],
            [124.26516525600005, 11.553713992000041],
            [124.25434989400003, 11.577860544000032],
            [124.2652766540001, 11.582488364000028],
        ],
        [
            [124.90678923000007, 11.582821242000023],
            [124.90816293700004, 11.581818651000049],
            [124.90735728100003, 11.579822413000045],
            [124.90581355100005, 11.581070079000028],
            [124.90678923000007, 11.582821242000023],
        ],
        [
            [124.91574444700007, 11.58459519400003],
            [124.91611945000011, 11.584014031000038],
            [124.91566043400007, 11.582969271000024],
            [124.91528243200003, 11.582885299000054],
            [124.91574444700007, 11.58459519400003],
        ],
        [
            [124.90599717300006, 11.600039142000071],
            [124.91592792100005, 11.59645563500004],
            [124.92028144800008, 11.598233503000074],
            [124.90800965300002, 11.592437160000031],
            [124.90599717300006, 11.600039142000071],
        ],
        [
            [125.49844086600001, 11.601408151000044],
            [125.50391887100011, 11.599570957000026],
            [125.50429198100005, 11.593037754000022],
            [125.49824060800006, 11.594008607000035],
            [125.49844086600001, 11.601408151000044],
        ],
        [
            [124.75660259000006, 11.610686371000043],
            [124.7591098900001, 11.608614052000064],
            [124.75954230500008, 11.605623252000044],
            [124.7572607620001, 11.606493599000032],
            [124.75660259000006, 11.610686371000043],
        ],
        [
            [124.8938587350001, 11.612424185000066],
            [124.90625942300005, 11.587802710000062],
            [124.88675345100012, 11.579721558000074],
            [124.87558512300006, 11.59218265900006],
            [124.8938587350001, 11.612424185000066],
        ],
        [
            [124.36312180900006, 11.619350913000062],
            [124.3652499640001, 11.61899812300004],
            [124.36643596700003, 11.618338946000051],
            [124.36043633200006, 11.618922029000032],
            [124.36312180900006, 11.619350913000062],
        ],
        [
            [124.87696970000002, 11.620889211000076],
            [124.87652990300012, 11.618347765000067],
            [124.87434839000002, 11.618808891000072],
            [124.87482072700004, 11.61982425900004],
            [124.87696970000002, 11.620889211000076],
        ],
        [
            [124.34293486400009, 11.630990389000033],
            [124.34458934000008, 11.629724637000038],
            [124.34430126600012, 11.627536470000052],
            [124.34155931400005, 11.62899819300003],
            [124.34293486400009, 11.630990389000033],
        ],
        [
            [124.83391162200007, 11.637922487000026],
            [124.83481797200011, 11.636907024000038],
            [124.83531173200004, 11.636579247000043],
            [124.83266779300004, 11.637407007000036],
            [124.83391162200007, 11.637922487000026],
        ],
        [
            [125.46935959000007, 11.644979371000034],
            [125.46856098800004, 11.645258716000058],
            [125.4684469020001, 11.645733600000028],
            [125.47008688900007, 11.64546822400007],
            [125.46935959000007, 11.644979371000034],
        ],
        [
            [124.88751656800002, 11.646438887000045],
            [124.88802055800011, 11.641789605000042],
            [124.88206294500003, 11.640378076000047],
            [124.88120553300007, 11.642941956000072],
            [124.88751656800002, 11.646438887000045],
        ],
        [
            [125.48468990200001, 11.64594310800004],
            [125.48854030600012, 11.646655433000035],
            [125.48951003700006, 11.630397204000076],
            [125.47668961800002, 11.644713994000028],
            [125.48468990200001, 11.64594310800004],
        ],
        [
            [124.89075948800007, 11.658714175000057],
            [124.89050998900007, 11.658491837000042],
            [124.89018406600007, 11.658511649000047],
            [124.89028072000008, 11.658617314000026],
            [124.89075948800007, 11.658714175000057],
        ],
        [
            [124.78104309700007, 11.673624386000029],
            [124.78195892800011, 11.673368568000058],
            [124.7831480970001, 11.670619969000029],
            [124.77870768500009, 11.672290690000068],
            [124.78104309700007, 11.673624386000029],
        ],
        [
            [124.32753254400006, 11.675714888000073],
            [124.33238137500007, 11.672175371000037],
            [124.33238006200008, 11.671695047000071],
            [124.32565075100001, 11.67231705100005],
            [124.32753254400006, 11.675714888000073],
        ],
        [
            [124.89899180300006, 11.686554560000047],
            [124.89938107100011, 11.686544319000063],
            [124.89808844400011, 11.685551882000027],
            [124.89658759300005, 11.685329468000077],
            [124.89899180300006, 11.686554560000047],
        ],
        [
            [124.90495258100009, 11.692889704000038],
            [124.90495455900009, 11.692788894000046],
            [124.90479420000008, 11.69280052800002],
            [124.90484369500007, 11.692885829000033],
            [124.90495258100009, 11.692889704000038],
        ],
        [
            [124.35940237600005, 11.69441144800004],
            [124.3628822820001, 11.692296377000048],
            [124.36188548200005, 11.689487765000024],
            [124.35821775600004, 11.691165676000026],
            [124.35940237600005, 11.69441144800004],
        ],
        [
            [124.90720738200002, 11.698928355000021],
            [124.90621973500004, 11.693680963000077],
            [124.90386032300012, 11.692639266000072],
            [124.90253775000008, 11.688800236000077],
            [124.8995695210001, 11.686352330000034],
            [124.90720738200002, 11.698928355000021],
        ],
        [
            [124.34396983400006, 11.699290977000032],
            [124.34483208000006, 11.698254357000053],
            [124.34474062600009, 11.69757011400003],
            [124.34340301500004, 11.698560651000037],
            [124.34396983400006, 11.699290977000032],
        ],
        [
            [124.42627325100011, 11.70720989800003],
            [124.53654036300009, 11.675346111000067],
            [124.61695459000009, 11.543269629000065],
            [124.60596963000012, 11.488665317000027],
            [124.47304444500003, 11.46143862100007],
            [124.44476217400006, 11.483022249000044],
            [124.33433674600008, 11.676263237000057],
            [124.42627325100011, 11.70720989800003],
        ],
        [
            [124.8227524890001, 11.70965575100007],
            [124.89049842400004, 11.679495235000047],
            [124.87097897300009, 11.648253985000053],
            [124.88234616300008, 11.624622311000053],
            [124.83493636000003, 11.632686456000044],
            [124.84111053600009, 11.666887080000038],
            [124.8227524890001, 11.70965575100007],
        ],
        [
            [124.33533965000004, 11.70969844700005],
            [124.33942522100006, 11.708625236000046],
            [124.33925091800006, 11.707843599000057],
            [124.33653672800006, 11.70802320200005],
            [124.33533965000004, 11.70969844700005],
        ],
        [
            [124.86988217600003, 11.715103336000027],
            [124.88263381100012, 11.705037533000052],
            [124.88809742700005, 11.69489162900004],
            [124.87474261300008, 11.704236249000076],
            [124.86988217600003, 11.715103336000027],
        ],
        [
            [124.72742492300006, 11.73271184500004],
            [124.75443390300006, 11.67665829300006],
            [124.78220601800001, 11.690952502000073],
            [124.76826014900007, 11.66633742700003],
            [124.80739749400004, 11.64505058100002],
            [124.79484255000011, 11.600174654000057],
            [124.8501553210001, 11.599998514000049],
            [124.82364178500006, 11.530019520000053],
            [124.71672420900006, 11.673496184000044],
            [124.72742492300006, 11.73271184500004],
        ],
        [
            [124.71298858000011, 11.737139159000037],
            [124.71767503100011, 11.734508386000073],
            [124.7186386410001, 11.731562588000031],
            [124.71432680900011, 11.733752350000032],
            [124.71298858000011, 11.737139159000037],
        ],
        [
            [124.74571436500003, 11.739035472000069],
            [124.77638661700007, 11.730181221000066],
            [124.77415434000011, 11.702588323000043],
            [124.75233655500006, 11.701647260000072],
            [124.74571436500003, 11.739035472000069],
        ],
        [
            [124.87652667300006, 11.74555760000004],
            [124.87795314900006, 11.741246469000032],
            [124.87729499400007, 11.736370553000029],
            [124.87290499300002, 11.742753093000033],
            [124.87652667300006, 11.74555760000004],
        ],
        [
            [124.89731503200005, 11.748463996000055],
            [124.89708019200009, 11.745696126000041],
            [124.89749575200005, 11.742292490000068],
            [124.89596324000001, 11.747675248000064],
            [124.89731503200005, 11.748463996000055],
        ],
        [
            [124.86936776800007, 11.751057165000077],
            [124.8720592310001, 11.75047008000007],
            [124.8724649940001, 11.74676927300004],
            [124.87063068500004, 11.747239122000053],
            [124.86936776800007, 11.751057165000077],
        ],
        [
            [124.26631530700001, 11.759756152000023],
            [124.26704115700011, 11.759197764000021],
            [124.26674829500007, 11.75857647600003],
            [124.26583450800001, 11.75979017000003],
            [124.26631530700001, 11.759756152000023],
        ],
        [
            [124.26654413000006, 11.767998713000054],
            [124.26387738300002, 11.764968948000046],
            [124.26515093500007, 11.762289864000024],
            [124.26486603800004, 11.761663111000075],
            [124.26311645300007, 11.766160727000056],
            [124.26654413000006, 11.767998713000054],
        ],
        [
            [124.26801167100007, 11.76997269800006],
            [124.26704822700003, 11.768861463000064],
            [124.26654781500008, 11.768935746000068],
            [124.26696859900005, 11.769598427000062],
            [124.26801167100007, 11.76997269800006],
        ],
        [
            [124.26961683200011, 11.773110188000032],
            [124.27008092400001, 11.771739739000054],
            [124.2687272180001, 11.770358543000043],
            [124.26824743300006, 11.770712497000034],
            [124.26961683200011, 11.773110188000032],
        ],
        [
            [124.73448016900011, 11.785130239000068],
            [124.73559426600002, 11.78445937400005],
            [124.73480597100001, 11.78295924400004],
            [124.73384660200009, 11.783925038000064],
            [124.73448016900011, 11.785130239000068],
        ],
        [
            [124.72336310900005, 11.791724567000074],
            [124.72416173400006, 11.789217282000038],
            [124.72160849300008, 11.789508029000046],
            [124.72284327600005, 11.790078651000044],
            [124.72336310900005, 11.791724567000074],
        ],
        [
            [124.734143861, 11.792618357000038],
            [124.73531596100008, 11.79123766300006],
            [124.73419608300003, 11.79034671900007],
            [124.73341191200007, 11.790977191000025],
            [124.734143861, 11.792618357000038],
        ],
        [
            [124.71952942900009, 11.793212133000054],
            [124.71978714400007, 11.79263019900003],
            [124.71893727500003, 11.79243974800005],
            [124.7192534730001, 11.793140833000052],
            [124.71952942900009, 11.793212133000054],
        ],
        [
            [124.79899883400003, 11.794727010000031],
            [124.79822773700005, 11.793904265000037],
            [124.79732186600006, 11.794369053000025],
            [124.79903908100005, 11.79487468800005],
            [124.79899883400003, 11.794727010000031],
        ],
        [
            [124.80610509500002, 11.798425683000062],
            [124.8038714810001, 11.795172797000077],
            [124.80130798800008, 11.795976651000046],
            [124.80208872300011, 11.796732907000035],
            [124.80610509500002, 11.798425683000062],
        ],
        [
            [124.7157694870001, 11.800406974000055],
            [124.71629640000003, 11.796786349000058],
            [124.71407092600009, 11.795087526000032],
            [124.71521979200008, 11.801483044000065],
            [124.7157694870001, 11.800406974000055],
        ],
        [
            [124.7015660400001, 11.809139935000076],
            [124.70738553600006, 11.801435010000034],
            [124.70672715100011, 11.79408275700007],
            [124.69930294100004, 11.801146221000067],
            [124.7015660400001, 11.809139935000076],
        ],
        [
            [124.69449512200003, 11.813028474000077],
            [124.69503925100003, 11.812577119000025],
            [124.6948155880001, 11.811163673000067],
            [124.6942350270001, 11.811619234000034],
            [124.69449512200003, 11.813028474000077],
        ],
        [
            [124.6913618750001, 11.815558792000047],
            [124.69143241400002, 11.814784819000067],
            [124.69128173700005, 11.814584130000071],
            [124.69094709800004, 11.81537458500003],
            [124.6913618750001, 11.815558792000047],
        ],
        [
            [124.31768282300004, 11.81726167200003],
            [124.35018681300005, 11.802617113000053],
            [124.32494305400007, 11.759936091000043],
            [124.29255201400008, 11.787662609000051],
            [124.31768282300004, 11.81726167200003],
        ],
        [
            [124.69134240300002, 11.817450751000024],
            [124.6911608470001, 11.816771316000029],
            [124.69129534600006, 11.81621937600005],
            [124.69088387900001, 11.816823505000059],
            [124.69134240300002, 11.817450751000024],
        ],
        [
            [124.81854497800009, 11.818449930000043],
            [124.81928576700011, 11.816813527000022],
            [124.81725682600006, 11.817045767000025],
            [124.8173764170001, 11.818123188000072],
            [124.81854497800009, 11.818449930000043],
        ],
        [
            [124.73714526200001, 11.820722140000044],
            [124.74299310000004, 11.814453796000066],
            [124.74029151500008, 11.808761245000028],
            [124.73771051400001, 11.811698335000074],
            [124.73714526200001, 11.820722140000044],
        ],
        [
            [124.72834078100004, 11.828313274000038],
            [124.73058371800005, 11.825755780000065],
            [124.72564297100007, 11.819810593000057],
            [124.72411716400006, 11.823532267000076],
            [124.72834078100004, 11.828313274000038],
        ],
        [
            [124.68402637100007, 11.830386238000074],
            [124.69007485000009, 11.828185681000036],
            [124.68216579200009, 11.822304513000063],
            [124.696989744, 11.79591743800006],
            [124.67303323600004, 11.821450192000043],
            [124.68402637100007, 11.830386238000074],
        ],
        [
            [124.69660726900008, 11.837003128000049],
            [124.70872443400003, 11.825420339000061],
            [124.69161697600009, 11.818427412000062],
            [124.6928443160001, 11.828109237000035],
            [124.68738130800011, 11.836310419000029],
            [124.69660726900008, 11.837003128000049],
        ],
        [
            [124.67728387700004, 11.839935393000076],
            [124.67978586700008, 11.839438597000026],
            [124.68028144200002, 11.838550989000055],
            [124.67761307100011, 11.838056081000047],
            [124.67728387700004, 11.839935393000076],
        ],
        [
            [124.7173710620001, 11.844446825000034],
            [124.7196366170001, 11.842074066000066],
            [124.71905047200005, 11.841343041000073],
            [124.71613932700006, 11.843300146000047],
            [124.7173710620001, 11.844446825000034],
        ],
        [
            [125.46878057200001, 11.862327949000075],
            [125.47626746800006, 11.849348367000061],
            [125.44943609300003, 11.855355062000058],
            [125.45134046300007, 11.859425044000034],
            [125.46878057200001, 11.862327949000075],
        ],
        [
            [125.45873266100011, 11.866633431000025],
            [125.45815776200004, 11.86242726300003],
            [125.45214057800001, 11.863810573000023],
            [125.45720253400009, 11.869082867000031],
            [125.45873266100011, 11.866633431000025],
        ],
        [
            [125.46879169100009, 11.880644225000026],
            [125.47058069700006, 11.877274965000026],
            [125.46515742100007, 11.87706576100004],
            [125.46546121500012, 11.879058696000072],
            [125.46879169100009, 11.880644225000026],
        ],
        [
            [124.27984103400001, 11.890504813000064],
            [124.27929422200009, 11.887459032000038],
            [124.27640003500005, 11.888732670000024],
            [124.2770114970001, 11.890209311000035],
            [124.27984103400001, 11.890504813000064],
        ],
        [
            [124.77887887500003, 11.891338584000039],
            [124.78042912700005, 11.891512328000033],
            [124.78255180200006, 11.889912301000038],
            [124.77960035400008, 11.888007453000057],
            [124.77887887500003, 11.891338584000039],
        ],
        [
            [124.72283040200011, 11.896242778000044],
            [124.72149282200007, 11.892644432000054],
            [124.71856657, 11.894563188000063],
            [124.72416737600008, 11.898135105000051],
            [124.72283040200011, 11.896242778000044],
        ],
        [
            [124.71525431000009, 11.908804902000043],
            [124.71711852100009, 11.903194215000042],
            [124.71399655700009, 11.899192968000023],
            [124.71041236100007, 11.904959116000043],
            [124.71525431000009, 11.908804902000043],
        ],
        [
            [124.62852434800004, 11.914547022000022],
            [124.63017754700002, 11.909269579000068],
            [124.62420162500007, 11.906296182000062],
            [124.62464552900008, 11.913724131000038],
            [124.62852434800004, 11.914547022000022],
        ],
        [
            [124.64053440900011, 11.920964710000021],
            [124.66431082000008, 11.909092773000054],
            [124.657373688, 11.889682166000057],
            [124.63362743500011, 11.908351770000024],
            [124.64053440900011, 11.920964710000021],
        ],
        [
            [124.6195661800001, 11.926674302000038],
            [124.62316012500003, 11.92502999800007],
            [124.61705453500008, 11.91984020600006],
            [124.61515854800007, 11.92487680000005],
            [124.6195661800001, 11.926674302000038],
        ],
        [
            [124.40621858400004, 11.92886926600005],
            [124.4067656200001, 11.928802752000024],
            [124.40774691000001, 11.92720399600006],
            [124.40495422200001, 11.92740563500007],
            [124.40621858400004, 11.92886926600005],
        ],
        [
            [124.44385164800008, 11.932969549000063],
            [124.46699953000007, 11.891138807000061],
            [124.45021932200007, 11.879685809000023],
            [124.41105908700001, 11.897483069000032],
            [124.44385164800008, 11.932969549000063],
        ],
        [
            [124.35525868900004, 11.942578688000026],
            [124.35603066500005, 11.941311669000072],
            [124.353943178, 11.940392922000058],
            [124.3536750610001, 11.941968463000023],
            [124.35525868900004, 11.942578688000026],
        ],
        [
            [124.34689120500002, 11.949785121000048],
            [124.34616224900003, 11.948458757000026],
            [124.34571596700005, 11.948475920000021],
            [124.3460094720001, 11.949396296000032],
            [124.34689120500002, 11.949785121000048],
        ],
        [
            [124.36630169300008, 11.954861962000052],
            [124.37479897300011, 11.95124164300006],
            [124.3707117460001, 11.937299151000047],
            [124.3610314550001, 11.940326860000027],
            [124.36630169300008, 11.954861962000052],
        ],
        [
            [124.33232972000008, 11.960314149000055],
            [124.31113721200006, 11.90167206500007],
            [124.27927354500002, 11.897835301000043],
            [124.28030777000004, 11.929081395000026],
            [124.33232972000008, 11.960314149000055],
        ],
        [
            [124.67039142400006, 11.986114990000033],
            [124.67459987000007, 11.983657210000047],
            [124.67361083800006, 11.98119212100005],
            [124.66815390700003, 11.981187521000038],
            [124.67039142400006, 11.986114990000033],
        ],
        [
            [124.422194181, 11.991895379000027],
            [124.43683964900004, 11.975828687000046],
            [124.42818546800004, 11.956263061000072],
            [124.40355706000003, 11.96668591200006],
            [124.422194181, 11.991895379000027],
        ],
        [
            [125.55643680100002, 12.006435958000054],
            [125.55509629000005, 12.01237807700005],
            [125.55680758000005, 12.015502519000052],
            [125.5599164250001, 12.010564768000052],
            [125.55643680100002, 12.006435958000054],
        ],
        [
            [125.55923190900012, 12.01544672500006],
            [125.55647958300005, 12.017831878000038],
            [125.55713557800004, 12.02193261800005],
            [125.56031572600011, 12.019003524000027],
            [125.55923190900012, 12.01544672500006],
        ],
        [
            [125.56064372300011, 12.023425048000036],
            [125.5564938440001, 12.023452944000041],
            [125.55710705600006, 12.027246748000039],
            [125.56017311800008, 12.02693989900007],
            [125.56064372300011, 12.023425048000036],
        ],
        [
            [125.56273910100003, 12.068328783000027],
            [125.568856965, 12.050143133000063],
            [125.55861774300001, 12.034536520000074],
            [125.56360273700011, 12.047320316000025],
            [125.56273910100003, 12.068328783000027],
        ],
        [
            [125.57050148700012, 12.066977247000068],
            [125.57173705900004, 12.064997855000058],
            [125.57269071400003, 12.059710639000059],
            [125.5677640350001, 12.070555808000051],
            [125.57050148700012, 12.066977247000068],
        ],
        [
            [124.22148487800007, 12.08404015900004],
            [124.23742488500011, 12.057975437000039],
            [124.14524930200002, 12.046297760000073],
            [124.16820726300011, 12.076788928000042],
            [124.22148487800007, 12.08404015900004],
        ],
        [
            [125.56416548700008, 12.093684343000064],
            [125.56415122700002, 12.091230143000075],
            [125.56218324200006, 12.091411420000043],
            [125.56253976100004, 12.093670399000075],
            [125.56416548700008, 12.093684343000064],
        ],
        [
            [124.19918831600012, 12.096711325000058],
            [124.20125842800007, 12.093371238000032],
            [124.1979678350001, 12.089409252000053],
            [124.19380851300002, 12.093681594000032],
            [124.19918831600012, 12.096711325000058],
        ],
        [
            [125.5504045450001, 12.119325047000075],
            [125.56668964100004, 12.107656123000027],
            [125.56788754500008, 12.099010996000061],
            [125.54602384300006, 12.120681705000038],
            [125.5504045450001, 12.119325047000075],
        ],
        [
            [124.09920148300012, 12.290554591000046],
            [124.11392976400009, 12.27573743000005],
            [124.09879463100003, 12.256415411000035],
            [124.08439753900007, 12.281567639000059],
            [124.09920148300012, 12.290554591000046],
        ],
        [
            [124.05612238600008, 12.35953058900003],
            [124.06095430500011, 12.343451903000073],
            [124.03771872800007, 12.337747638000053],
            [124.04650732300001, 12.35258252400007],
            [124.05612238600008, 12.35953058900003],
        ],
        [
            [124.03191846300001, 12.361468597000055],
            [124.0441246800001, 12.354123662000063],
            [124.02703284300003, 12.345114754000065],
            [124.0337596060001, 12.353749052000069],
            [124.03191846300001, 12.361468597000055],
        ],
        [
            [124.0116530890001, 12.374655192000034],
            [124.01593030800007, 12.369787987000052],
            [124.01490195400004, 12.358329772000047],
            [124.00950691000003, 12.370305063000046],
            [124.0116530890001, 12.374655192000034],
        ],
        [
            [124.04422843800012, 12.383055467000077],
            [124.04370603300003, 12.378554527000063],
            [124.03688173500007, 12.37748795300007],
            [124.03478449200009, 12.37921766200003],
            [124.04422843800012, 12.383055467000077],
        ],
        [
            [124.06194443400011, 12.386510841000074],
            [124.07906124600004, 12.371617924000077],
            [124.08053159600001, 12.359852545000024],
            [124.07281399100009, 12.35815017300007],
            [124.06194443400011, 12.386510841000074],
        ],
        [
            [124.03007602100001, 12.409841555000071],
            [124.02468964200011, 12.397886260000064],
            [124.00448825, 12.378881981000063],
            [124.005447537, 12.394596310000054],
            [124.03007602100001, 12.409841555000071],
        ],
        [
            [124.24641868900005, 12.45948068000007],
            [124.27975802700007, 12.414455903000032],
            [124.2763523970001, 12.362652661000027],
            [124.24972231200002, 12.403884141000049],
            [124.24641868900005, 12.45948068000007],
        ],
        [
            [124.14153079300002, 12.483072205000042],
            [124.1925398950001, 12.412480510000023],
            [124.18236677000004, 12.38096534400006],
            [124.13896820900004, 12.431895146000045],
            [124.14153079300002, 12.483072205000042],
        ],
        [
            [124.50242008200007, 12.532899908000047],
            [124.50642043500011, 12.532523106000042],
            [124.51054131300009, 12.530522198000028],
            [124.508251373, 12.528990849000024],
            [124.50242008200007, 12.532899908000047],
        ],
        [
            [124.48116113700007, 12.533124952000037],
            [124.48155089800002, 12.53261231700003],
            [124.48069728400003, 12.532186522000075],
            [124.48046710100004, 12.532854966000059],
            [124.48116113700007, 12.533124952000037],
        ],
        [
            [124.70345139900007, 12.534825817000069],
            [124.70235959200011, 12.530875308000077],
            [124.69686318800007, 12.532641015000024],
            [124.70209525300004, 12.53571686500004],
            [124.70345139900007, 12.534825817000069],
        ],
        [
            [124.47418611600006, 12.541364161000047],
            [124.4763179570001, 12.539612265000073],
            [124.47618304900004, 12.537425362000022],
            [124.47320620300002, 12.53949244200004],
            [124.47418611600006, 12.541364161000047],
        ],
        [
            [124.4812350310001, 12.543494886000076],
            [124.48512839300008, 12.540967718000047],
            [124.48533246300008, 12.540421911000067],
            [124.48150841300003, 12.541062608000061],
            [124.4812350310001, 12.543494886000076],
        ],
        [
            [124.42470453300007, 12.544092629000033],
            [124.4315205040001, 12.540401561000067],
            [124.43468822400007, 12.536291621000032],
            [124.42517198300004, 12.53456200200003],
            [124.42470453300007, 12.544092629000033],
        ],
        [
            [124.45622871000012, 12.548838752000051],
            [124.45777803600004, 12.546839368000064],
            [124.45503482600009, 12.54338683900005],
            [124.45424362300002, 12.546708427000056],
            [124.45622871000012, 12.548838752000051],
        ],
        [
            [124.68356592700002, 12.550229405000039],
            [124.68730087500012, 12.54866811100004],
            [124.68886969000005, 12.544096640000078],
            [124.68541458400011, 12.544898216000036],
            [124.68356592700002, 12.550229405000039],
        ],
        [
            [125.04612914200004, 12.551402778000067],
            [125.04890151900008, 12.550896627000043],
            [125.04895663700006, 12.54784490700007],
            [125.04492766100009, 12.548392866000029],
            [125.04612914200004, 12.551402778000067],
        ],
        [
            [125.0518292050001, 12.552237561000027],
            [125.05325992000007, 12.550304023000024],
            [125.04996203400003, 12.546798385000045],
            [125.04937808400007, 12.550690079000049],
            [125.0518292050001, 12.552237561000027],
        ],
        [
            [124.48616698300009, 12.553550427000062],
            [124.49208841100005, 12.550739060000069],
            [124.49744353900007, 12.539637184000071],
            [124.48935331900009, 12.544345484000075],
            [124.48616698300009, 12.553550427000062],
        ],
        [
            [124.46782539700007, 12.55812121100007],
            [124.4685455660001, 12.55719622600003],
            [124.4676727310001, 12.555091168000047],
            [124.46692320900002, 12.557468319000066],
            [124.46782539700007, 12.55812121100007],
        ],
        [
            [125.02024914200001, 12.560485678000077],
            [125.02935260700008, 12.548964382000065],
            [125.04857089300003, 12.545845807000035],
            [125.02702779900005, 12.53214689300006],
            [125.02024914200001, 12.560485678000077],
        ],
        [
            [125.0682575080001, 12.562510177000036],
            [125.0628727720001, 12.549063887000045],
            [125.05599732000007, 12.547676015000036],
            [125.06303329100001, 12.561232042000029],
            [125.0682575080001, 12.562510177000036],
        ],
        [
            [124.32039491300009, 12.57083853100005],
            [124.32351379300007, 12.56632528700004],
            [124.32161401300004, 12.561421082000038],
            [124.31818501200007, 12.568383556000072],
            [124.32039491300009, 12.57083853100005],
        ],
        [
            [124.42759462700008, 12.580821228000048],
            [124.45594829000004, 12.554594980000047],
            [124.44718845700004, 12.53593789100006],
            [124.412439403, 12.557061343000044],
            [124.42759462700008, 12.580821228000048],
        ],
        [
            [125.14541179900004, 12.584765602000061],
            [125.33994468100002, 12.405467516000044],
            [125.29858985200008, 12.397001208000063],
            [125.28633420000006, 12.336951634000059],
            [125.32024196300006, 12.327334643000029],
            [125.29310204, 12.290138863000038],
            [125.33523931500008, 12.31817428900007],
            [125.31725746600011, 12.273999074000074],
            [125.33785542200008, 12.26927613600003],
            [125.38244594700006, 12.30225540300006],
            [125.36628629900008, 12.270013819000042],
            [125.4385186720001, 12.273084439000058],
            [125.51533771200002, 12.192309905000059],
            [125.43673025200007, 12.12630912800006],
            [125.51571051600001, 12.060149065000076],
            [125.4262299290001, 11.955871225000067],
            [125.4352877990001, 11.827426239000033],
            [125.47408902900008, 11.792818927000042],
            [125.41344368800003, 11.756783940000048],
            [125.46155767300002, 11.759226515000023],
            [125.49249813500012, 11.671391044000075],
            [125.45195761900004, 11.669084403000056],
            [125.43909485400002, 11.606996613000035],
            [125.47482051200006, 11.590928149000035],
            [125.46956074700006, 11.545277382000052],
            [125.52759425300007, 11.475202102000026],
            [125.51158338900007, 11.469142145000035],
            [125.49209118200008, 11.448233420000065],
            [125.5229830190001, 11.453744352000058],
            [125.56329976400002, 11.393237548000059],
            [125.63249121700005, 11.355886743000042],
            [125.54702109800007, 11.25967838300005],
            [125.53437858300003, 11.194852949000051],
            [125.61753239000006, 11.189595693000058],
            [125.59672323900008, 11.232477979000066],
            [125.66525378100005, 11.198113983000042],
            [125.75986856500003, 11.045817888000045],
            [125.75590600700002, 11.010799315000042],
            [125.75286354900004, 11.017111671000066],
            [125.71808326500002, 11.02884814600003],
            [125.72172160600007, 11.031343397000057],
            [125.70230967300006, 11.067101554000033],
            [125.6725224490001, 11.083229020000033],
            [125.6760739240001, 11.091306232000022],
            [125.6993127510001, 11.107800762000068],
            [125.66105307700002, 11.14256739800004],
            [125.57855942100002, 11.107012991000033],
            [125.57257033300004, 11.149759863000043],
            [125.5346201110001, 11.15295663300003],
            [125.51734560900002, 11.134359301000075],
            [125.5113255010001, 11.081446698000036],
            [125.48312242300005, 11.093684147000033],
            [125.489330988, 11.11071633000006],
            [125.46122849800008, 11.126366956000027],
            [125.4073520720001, 11.081839560000049],
            [125.29735602500011, 11.142885988000046],
            [125.23430667600007, 11.085962841000025],
            [125.15149140200003, 11.275099658000045],
            [124.97840284900008, 11.283598501000029],
            [124.9841651160001, 11.420434750000027],
            [124.99484671300002, 11.423554542000034],
            [124.99652219600011, 11.427492100000052],
            [124.90231642600008, 11.470678927000051],
            [124.90653910200001, 11.497218243000077],
            [124.89311363500008, 11.509744743000056],
            [124.89044818800005, 11.463262515000054],
            [124.84009768500005, 11.465410074000033],
            [124.81899191700006, 11.515980097000067],
            [124.89366355600009, 11.53872960800004],
            [124.88091591200009, 11.57733603400004],
            [124.95339877000004, 11.57309093300006],
            [124.99378435200003, 11.61451541200006],
            [124.97304449700005, 11.669786071000033],
            [125.0432654660001, 11.752300870000056],
            [124.99729593000006, 11.779932478000035],
            [124.8858362850001, 11.753412983000032],
            [124.86014425200005, 11.81108834500003],
            [124.82903832400007, 11.795415353000067],
            [124.83598844100004, 11.830322806000027],
            [124.79750150300003, 11.858929644000057],
            [124.77676624000003, 11.85959348700004],
            [124.77455251700007, 11.863062268000022],
            [124.799432152, 11.870616315000063],
            [124.78931019900006, 11.904132644000072],
            [124.81662374300004, 11.882635115000028],
            [124.82358465100003, 11.890072556000064],
            [124.79304153500004, 11.91363949500004],
            [124.7370971580001, 11.896617157000037],
            [124.69165496800008, 12.01017846800005],
            [124.48271915100008, 12.10025661700007],
            [124.38992760400004, 12.195816120000075],
            [124.26085319800006, 12.549516083000071],
            [124.28878777200009, 12.584151144000032],
            [124.32930396600011, 12.53526346700005],
            [124.39117747000012, 12.566757881000058],
            [124.4290452460001, 12.529734847000043],
            [124.45477427800006, 12.533718798000052],
            [124.46663881200004, 12.546039711000049],
            [124.46348070800002, 12.520937478000064],
            [124.67640752500006, 12.50863948500006],
            [124.86017676800009, 12.531244772000036],
            [124.88269564900008, 12.565009258000032],
            [124.85774165100008, 12.58166004700007],
            [124.85860178300004, 12.58471641400007],
            [124.95657421600004, 12.584096386000056],
            [125.02847081300001, 12.530238567000026],
            [125.08139297800005, 12.540550922000023],
            [125.07285260900005, 12.578839595000034],
            [125.14541179900004, 12.584765602000061],
        ],
        [
            [125.69081879100008, 11.098695593000059],
            [125.68630313100005, 11.096450755000035],
            [125.6864235380001, 11.094926901000065],
            [125.6893919470001, 11.095529980000038],
            [125.69081879100008, 11.098695593000059],
        ],
        [
            [124.98633132100008, 11.362868329000037],
            [124.9855345100001, 11.36260578100007],
            [124.98541413100008, 11.362023837000038],
            [124.98645371700002, 11.36194375100007],
            [124.98633132100008, 11.362868329000037],
        ],
        [
            [124.9876149800001, 11.363182102000053],
            [124.98792018800009, 11.359571714000026],
            [124.99087635700005, 11.356987657000047],
            [124.99118457600002, 11.361344153000061],
            [124.9876149800001, 11.363182102000053],
        ],
        [
            [124.98705491700002, 11.36586931200003],
            [124.98671210000009, 11.366671545000031],
            [124.98668106500008, 11.36776694200006],
            [124.98532430700004, 11.366091666000045],
            [124.98705491700002, 11.36586931200003],
        ],
        [
            [124.98542046900002, 11.368067921000033],
            [124.9850459480001, 11.368058051000048],
            [124.9847882570001, 11.367143156000054],
            [124.98530166900002, 11.367488753000032],
            [124.98542046900002, 11.368067921000033],
        ],
        [
            [124.98867595000002, 11.369647074000056],
            [124.98818649500004, 11.364247507000073],
            [124.99068039000008, 11.363588941000046],
            [124.99139692100005, 11.366618309000046],
            [124.98867595000002, 11.369647074000056],
        ],
        [
            [124.98453237300009, 11.388885388000062],
            [124.98397119200001, 11.387007528000026],
            [124.98574458500002, 11.386516075000031],
            [124.98698669600003, 11.388591973000075],
            [124.98453237300009, 11.388885388000062],
        ],
        [
            [124.98465417600005, 11.410866068000075],
            [124.98377701000004, 11.410190216000046],
            [124.98456165800008, 11.408529346000023],
            [124.98536438400004, 11.410396809000076],
            [124.98465417600005, 11.410866068000075],
        ],
        [
            [125.12893610200001, 12.577900897000063],
            [125.12838081600012, 12.57894877700005],
            [125.12738140200008, 12.57898670000003],
            [125.12797499600003, 12.57787733400005],
            [125.12893610200001, 12.577900897000063],
        ],
        [
            [124.38247788100011, 12.585263936000047],
            [124.38449379200006, 12.58457695800007],
            [124.38543374800008, 12.582382334000044],
            [124.38001317600003, 12.58373983000007],
            [124.38247788100011, 12.585263936000047],
        ],
        [
            [124.48607222800001, 12.586429999000075],
            [124.50219116300002, 12.575760767000077],
            [124.5208935600001, 12.543310172000076],
            [124.49974868600009, 12.540714923000053],
            [124.48607222800001, 12.586429999000075],
        ],
        [
            [124.36170086600009, 12.589807578000034],
            [124.38645614100005, 12.580375263000064],
            [124.38278177900008, 12.568314488000055],
            [124.3624037410001, 12.563349062000043],
            [124.36170086600009, 12.589807578000034],
        ],
        [
            [125.1434100030001, 12.601896894000049],
            [125.14904437100006, 12.590145298000039],
            [125.142937845, 12.584887870000045],
            [125.13616198500006, 12.598898205000069],
            [125.1434100030001, 12.601896894000049],
        ],
        [
            [125.03593074000003, 12.617382250000048],
            [125.03598859800002, 12.617191714000057],
            [125.0358439690001, 12.61709432500004],
            [125.03580346700005, 12.617307442000026],
            [125.03593074000003, 12.617382250000048],
        ],
        [
            [125.03567906800004, 12.61784517700005],
            [125.03559374600002, 12.61749797300007],
            [125.03532906400005, 12.61770120400007],
            [125.03544910300002, 12.617852226000025],
            [125.03567906800004, 12.61784517700005],
        ],
        [
            [124.43013877900012, 12.623772990000077],
            [124.4305642060001, 12.62329436500005],
            [124.42876042400007, 12.621386227000073],
            [124.4283916170001, 12.622290448000058],
            [124.43013877900012, 12.623772990000077],
        ],
        [
            [124.43761567000001, 12.624407666000025],
            [124.4469226870001, 12.61797897100007],
            [124.44131830900005, 12.610230228000034],
            [124.42838110100001, 12.61467217300003],
            [124.43761567000001, 12.624407666000025],
        ],
        [
            [124.438711839, 12.624740402000043],
            [124.43868298600012, 12.624226030000045],
            [124.43790747300011, 12.62456271900004],
            [124.43810777100009, 12.62478733200004],
            [124.438711839, 12.624740402000043],
        ],
        [
            [124.44079623000005, 12.625883980000026],
            [124.44263503600007, 12.624478273000022],
            [124.43893249400003, 12.624219050000022],
            [124.43903496300004, 12.625398799000038],
            [124.44079623000005, 12.625883980000026],
        ],
        [
            [124.43192563700006, 12.62613762500007],
            [124.43266594400006, 12.624454575000073],
            [124.43031495000002, 12.62365068400004],
            [124.43108518100007, 12.62585806800007],
            [124.43192563700006, 12.62613762500007],
        ],
        [
            [124.359006829, 12.627582136000058],
            [124.39331389300003, 12.602736825000022],
            [124.39185853000004, 12.57990529500006],
            [124.38051905900011, 12.596210918000054],
            [124.35832398000002, 12.595093141000063],
            [124.359006829, 12.627582136000058],
        ],
        [
            [124.44010031000005, 12.627988119000065],
            [124.43995588200005, 12.627322395000022],
            [124.43910642500009, 12.627348355000038],
            [124.43930596200005, 12.627721088000044],
            [124.44010031000005, 12.627988119000065],
        ],
        [
            [124.42015519800009, 12.628426298000022],
            [124.42055823900012, 12.627144498000064],
            [124.42027489400004, 12.626733413000068],
            [124.4194099560001, 12.627789033000056],
            [124.42015519800009, 12.628426298000022],
        ],
        [
            [124.4161131300001, 12.629242868000063],
            [124.41628924600002, 12.62912519200006],
            [124.41634861500006, 12.628301428000043],
            [124.41587577900009, 12.628669400000035],
            [124.4161131300001, 12.629242868000063],
        ],
        [
            [125.08445610000001, 12.630195652000054],
            [125.08930283300003, 12.625477175000071],
            [125.08806155900004, 12.621475411000063],
            [125.081645019, 12.624881005000077],
            [125.08445610000001, 12.630195652000054],
        ],
        [
            [124.42737637800008, 12.631252190000055],
            [124.42758620100005, 12.630781422000041],
            [124.42749206200006, 12.630626418000077],
            [124.42711946800011, 12.631221580000044],
            [124.42737637800008, 12.631252190000055],
        ],
        [
            [124.3913790900001, 12.635405164000076],
            [124.39237311500005, 12.633527526000023],
            [124.38945109100007, 12.632239102000028],
            [124.39008215000001, 12.634696576000067],
            [124.3913790900001, 12.635405164000076],
        ],
        [
            [124.4383773080001, 12.63896752200003],
            [124.4382100150001, 12.636142471000028],
            [124.43479605300001, 12.63668664200003],
            [124.43534146500008, 12.638392973000066],
            [124.4383773080001, 12.63896752200003],
        ],
        [
            [124.39213546500002, 12.63918762000003],
            [124.3918537720001, 12.638408683000023],
            [124.3909049770001, 12.638514720000046],
            [124.39104274300007, 12.638955850000059],
            [124.39213546500002, 12.63918762000003],
        ],
        [
            [124.39466646800008, 12.639467490000072],
            [124.39406904700002, 12.636957257000063],
            [124.39153672000009, 12.637725975000023],
            [124.39272889300003, 12.638887364000027],
            [124.39466646800008, 12.639467490000072],
        ],
        [
            [124.99359242000003, 12.642559316000074],
            [125.07002087900003, 12.57297399500004],
            [125.05396840800006, 12.55304723200004],
            [125.00382700300008, 12.572284642000056],
            [124.99359242000003, 12.642559316000074],
        ],
        [
            [125.01918226700002, 12.568022172000042],
            [125.01892909100002, 12.567915934000041],
            [125.01872366600003, 12.567021562000036],
            [125.0198934870001, 12.567720103000056],
            [125.01918226700002, 12.568022172000042],
        ],
        [
            [124.4219123370001, 12.643688518000033],
            [124.42349461600008, 12.640937981000036],
            [124.42292534700005, 12.639683844000047],
            [124.4212268330001, 12.642108933000031],
            [124.4219123370001, 12.643688518000033],
        ],
        [
            [124.42664140600004, 12.646820516000048],
            [124.43214172000012, 12.628749568000046],
            [124.42706568500012, 12.63221675400007],
            [124.4176020000001, 12.62744218000006],
            [124.42664140600004, 12.646820516000048],
        ],
        [
            [124.424860254, 12.649471638000023],
            [124.425609, 12.648924670000042],
            [124.42556782400004, 12.648587944000042],
            [124.42458938200002, 12.648693166000044],
            [124.424860254, 12.649471638000023],
        ],
        [
            [124.36916403600003, 12.651285341000062],
            [124.37708243800012, 12.645427427000072],
            [124.37948395800004, 12.631358815000056],
            [124.373427966, 12.634673215000078],
            [124.36916403600003, 12.651285341000062],
        ],
        [
            [124.42923686900008, 12.658814122000024],
            [124.42951844100003, 12.658195471000056],
            [124.42816715300012, 12.656716741000025],
            [124.42791768000006, 12.65721482400005],
            [124.42923686900008, 12.658814122000024],
        ],
        [
            [124.3601215440001, 12.661764829000049],
            [124.36742623300006, 12.646436490000042],
            [124.36574447900011, 12.64333472100003],
            [124.35579828900006, 12.656435327000054],
            [124.3601215440001, 12.661764829000049],
        ],
        [
            [124.99931755300008, 12.663525144000062],
            [125.00544094200006, 12.663399062000053],
            [125.00725238600012, 12.662163022000072],
            [125.01104423000004, 12.641028925000057],
            [124.99931755300008, 12.663525144000062],
        ],
        [
            [124.39880369200012, 12.677980675000072],
            [124.42370952800002, 12.66834749000003],
            [124.42636521800011, 12.65195996500006],
            [124.41411461700011, 12.652503656000022],
            [124.39880369200012, 12.677980675000072],
        ],
        [
            [124.41959712300002, 12.653696386000036],
            [124.41951751500005, 12.653404215000023],
            [124.41993824000008, 12.65282170100005],
            [124.41988519100005, 12.653370917000075],
            [124.41959712300002, 12.653696386000036],
        ],
        [
            [124.41675484200005, 12.664121605000048],
            [124.41657776600005, 12.664112895000073],
            [124.4165613350001, 12.663976940000055],
            [124.4166682130001, 12.663958884000067],
            [124.41675484200005, 12.664121605000048],
        ],
        [
            [124.41712326600009, 12.665308358000061],
            [124.41713881900012, 12.66536039500005],
            [124.41708165600005, 12.665377313000022],
            [124.41705079000008, 12.665332243000023],
            [124.41712326600009, 12.665308358000061],
        ],
        [
            [124.3828024610001, 12.68052199500005],
            [124.38260209200007, 12.680635788000075],
            [124.38259809100009, 12.68078852800005],
            [124.38279388100011, 12.680653921000044],
            [124.3828024610001, 12.68052199500005],
        ],
        [
            [124.38211002900005, 12.680844641000022],
            [124.3824192400001, 12.680717610000045],
            [124.38266569900009, 12.680466048000028],
            [124.381943266, 12.680817752000053],
            [124.38211002900005, 12.680844641000022],
        ],
        [
            [125.06245144900004, 12.685977853000054],
            [125.07425086400008, 12.621418937000044],
            [125.08901295500004, 12.602502920000063],
            [125.03317732300002, 12.620264013000053],
            [125.06010325300008, 12.636810248000074],
            [125.03057011500005, 12.67185313300007],
            [125.06245144900004, 12.685977853000054],
        ],
        [
            [125.05427775300006, 12.629346515000066],
            [125.05326189100003, 12.628803642000037],
            [125.05319375500005, 12.627839681000069],
            [125.054808277, 12.628615782000054],
            [125.05427775300006, 12.629346515000066],
        ],
        [
            [124.3810923960001, 12.688525686000048],
            [124.38682668800004, 12.684730933000026],
            [124.38354598300009, 12.680969935000064],
            [124.37693439700001, 12.684287234000067],
            [124.3810923960001, 12.688525686000048],
        ],
        [
            [124.3563674400001, 12.696379380000053],
            [124.39170740200007, 12.67394984300006],
            [124.39377069200009, 12.639913965000062],
            [124.36610276200008, 12.654455315000064],
            [124.3563674400001, 12.696379380000053],
        ],
        [
            [124.36799375300006, 12.697531307000077],
            [124.37750441800006, 12.691372308000041],
            [124.3760218540001, 12.688215423000031],
            [124.37430120300007, 12.687932303000025],
            [124.36799375300006, 12.697531307000077],
        ],
        [
            [123.57503388200007, 8.633431735000045],
            [123.57242312200003, 8.62546528300004],
            [123.56678838900007, 8.619931379000036],
            [123.57154034700011, 8.631463350000047],
            [123.57503388200007, 8.633431735000045],
        ],
        [
            [123.60854864700002, 8.670095012000047],
            [123.6314608130001, 8.63279325600007],
            [123.68776063400003, 8.64111321200005],
            [123.75531687000012, 8.600184505000072],
            [123.86364416000004, 8.32460052600004],
            [123.86565604600003, 8.158336313000063],
            [123.75965480400009, 8.05071917600003],
            [123.64399, 8.01231000100006],
            [123.55910696, 8.032329293000032],
            [123.55382672300004, 8.616682562000051],
            [123.56696359800003, 8.571427587000073],
            [123.604339632, 8.65111545600007],
            [123.57996015000003, 8.659645800000021],
            [123.60854864700002, 8.670095012000047],
        ],
        [
            [125.2381393180001, 8.987511528000027],
            [125.21726934600008, 8.918522864000067],
            [125.26259864700012, 8.842400689000044],
            [125.24109649700006, 8.840640068000027],
            [125.23851595000008, 8.66030526700007],
            [125.16978647600001, 8.583903805000034],
        ],
        [
            [125.16978647600001, 8.583903805000034],
            [125.26173252700005, 8.587565607000045],
        ],
        [
            [125.26173252700005, 8.587565607000045],
            [125.24756096900012, 8.478069553000068],
            [125.28727226700005, 8.422475134000024],
            [125.27508000000012, 8.354652],
        ],
        [
            [125.27508000000012, 8.354652],
            [125.44338435100008, 8.095016403000045],
            [125.37505743800011, 8.014980926000021],
            [125.42010363000009, 7.909866804000046],
            [125.42456248600001, 7.622786366000071],
        ],
        [
            [125.42456248600001, 7.622786366000071],
            [125.3009240020001, 7.637283149000041],
            [125.32590265800002, 7.565047433000075],
            [125.26559191100012, 7.564791229000036],
            [125.26359983300006, 7.506819022000059],
        ],
        [
            [125.26359983300006, 7.506819022000059],
            [125.16362012000002, 7.50916058100006],
        ],
        [
            [125.16362012000002, 7.50916058100006],
            [125.15531106600008, 7.465819585000077],
            [125.06695334500012, 7.45118165100007],
            [125.04682822600012, 7.404642533000072],
            [124.97362400200007, 7.400869115000035],
            [124.93002318700007, 7.435718253000061],
        ],
        [
            [124.93002318700007, 7.435718253000061],
            [124.88196147500003, 7.418062108000072],
            [124.81701625700009, 7.499056179000036],
        ],
        [
            [124.81701625700009, 7.499056179000036],
            [124.788596976, 7.484095310000043],
        ],
        [
            [124.788596976, 7.484095310000043],
            [124.82126781800002, 7.590487068000073],
            [124.59761010300008, 7.902537395000024],
        ],
        [
            [124.53716690600004, 8.090485116000025],
            [124.48123857000007, 8.163486510000041],
            [124.43501488000004, 8.128414759000066],
        ],
        [
            [124.00162475900004, 7.742659211000046],
            [123.9593233600001, 7.724984796000058],
            [123.87027291100003, 7.738132882000059],
            [123.84981568, 7.697723370000062],
            [123.7743708910001, 7.703912306000063],
            [123.72113380100006, 7.790961268000046],
            [123.62413370100012, 7.830433768000034],
            [123.666222005, 7.888529371000061],
        ],
        [
            [123.6350335190001, 7.93272192400002],
            [123.64985195300005, 7.959801629000026],
            [123.74542293200011, 7.993936426000062],
            [123.84804236100001, 8.112285651000036],
            [123.89903245200003, 8.114241203000063],
            [124.01417998700003, 8.195099559000028],
            [124.15441668800008, 8.184848354000053],
            [124.23123875800002, 8.21888434400006],
            [124.31223703900002, 8.53613684800007],
            [124.38665807500001, 8.593828259000077],
            [124.4676280440001, 8.625117906000071],
            [124.47119689600004, 8.591245099000048],
            [124.57766572700007, 8.519007008000074],
            [124.69961164300003, 8.472188206000055],
            [124.74279424600002, 8.49429342700006],
            [124.77154012300002, 8.595019623000042],
            [124.74042025500012, 8.692371367000021],
            [124.77745746500011, 8.71818832200006],
            [124.78950297300003, 8.825009181000041],
            [124.77858028900005, 8.976373547000037],
            [124.8761164330001, 9.01684050800003],
            [125.02442240200003, 8.918836125000041],
            [125.07805276500005, 8.828173926000034],
            [125.163803572, 8.845685025000023],
            [125.17131059700012, 9.010177416000033],
            [125.20772470700001, 9.09365308100007],
            [125.2381393180001, 8.987511528000027],
        ],
        [
            [124.82542573900002, 9.172776295000062],
            [124.82510409600002, 9.171169785000075],
            [124.82242300700011, 9.172022157000072],
            [124.82357889100001, 9.173167585000044],
            [124.82542573900002, 9.172776295000062],
        ],
        [
            [124.70245905400009, 9.25778741800002],
            [124.77888893500005, 9.203107051000075],
            [124.80647043200008, 9.117664306000052],
            [124.77521632200012, 9.080132390000074],
            [124.67489404300011, 9.12055355900003],
            [124.63498810900012, 9.170154266000054],
            [124.64317309100011, 9.232753423000077],
            [124.70245905400009, 9.25778741800002],
        ],
        [
            [125.39719472100012, 5.437910860000045],
            [125.42960297400009, 5.419554692000077],
            [125.42041173400003, 5.365733267000053],
            [125.32889593000004, 5.389441418000047],
            [125.39719472100012, 5.437910860000045],
        ],
        [
            [125.47759251900004, 5.495800466000048],
            [125.49987194500011, 5.468294730000025],
            [125.471686997, 5.389414831000067],
            [125.45168742400006, 5.435526123000045],
            [125.47759251900004, 5.495800466000048],
        ],
        [
            [125.48942543100009, 5.515293694000036],
            [125.4913101510001, 5.512402859000076],
            [125.48850884600006, 5.510734935000073],
            [125.4869224790001, 5.514557016000026],
            [125.48942543100009, 5.515293694000036],
        ],
        [
            [126.29186904100004, 6.768422887000042],
            [126.28963118800004, 6.769445362000056],
            [126.28995584800009, 6.771223209000027],
            [126.29183568300004, 6.770723012000076],
            [126.29186904100004, 6.768422887000042],
        ],
        [
            [126.2836113510001, 6.77345592000006],
            [126.28277724300006, 6.77390465600007],
            [126.28290478100007, 6.775250663000065],
            [126.28357670800006, 6.774963004000028],
            [126.2836113510001, 6.77345592000006],
        ],
        [
            [126.2581696310001, 6.796045976000073],
            [126.26949296600003, 6.792573807000053],
            [126.27580926900009, 6.779431061000025],
            [126.26512178100006, 6.784893062000037],
            [126.2581696310001, 6.796045976000073],
        ],
        [
            [126.27458243100011, 6.833275276000052],
            [126.27490040600003, 6.831928564000066],
            [126.27429399900007, 6.830609044000028],
            [126.273143161, 6.832606178000049],
            [126.27458243100011, 6.833275276000052],
        ],
        [
            [125.68714880100003, 6.961858806000066],
            [125.72069109200004, 6.937290821000033],
            [125.713052145, 6.898008830000038],
            [125.66953584700002, 6.945244357000036],
            [125.68714880100003, 6.961858806000066],
        ],
        [
            [125.68209671700004, 7.159678199000041],
            [125.68237407700008, 7.159059575000072],
            [125.6815495620001, 7.155505045000041],
            [125.6809122410001, 7.155951119000065],
            [125.68209671700004, 7.159678199000041],
        ],
        [
            [125.77905360400007, 7.178886628000043],
            [125.78085618800003, 7.170481236000057],
            [125.78542401000004, 7.159721572000024],
            [125.78001243200004, 7.16841770800005],
            [125.77905360400007, 7.178886628000043],
        ],
        [
            [125.77255230700007, 7.193647129000055],
            [125.7739237190001, 7.19006631600007],
            [125.77485941000009, 7.189704373000041],
            [125.77276764500004, 7.189846936000038],
            [125.77255230700007, 7.193647129000055],
        ],
        [
            [125.70940192900002, 7.197899232000054],
            [125.79759457500006, 7.116755306000073],
            [125.77549907500008, 7.031909019000068],
            [125.79327943400006, 6.93807253600005],
            [125.76571171900002, 6.892626629000063],
            [125.72274260900008, 6.96427876100006],
            [125.71228764300008, 7.069452776000048],
            [125.66357594900012, 7.093553460000066],
            [125.70940192900002, 7.197899232000054],
        ],
        [
            [125.83170073500003, 7.28604931700005],
            [125.83502405200011, 7.279174346000048],
            [125.8317503190001, 7.268986202000065],
            [125.82845007700007, 7.274566700000037],
            [125.83170073500003, 7.28604931700005],
        ],
        [
            [125.84168893300011, 7.292776167000056],
            [125.84435797200001, 7.290991826000038],
            [125.83960208400003, 7.287270278000051],
            [125.83944142200005, 7.291605730000072],
            [125.84168893300011, 7.292776167000056],
        ],
        [
            [126.38639313600004, 7.878559899000038],
            [126.3861491350001, 7.878264920000049],
            [126.38574513700007, 7.878442909000057],
            [126.38613413700011, 7.879030865000061],
            [126.38639313600004, 7.878559899000038],
        ],
        [
            [126.387141143, 7.881425685000067],
            [126.3834791480001, 7.87982181600006],
            [126.38207514400005, 7.877577985000073],
            [126.38263215300003, 7.880650756000023],
            [126.387141143, 7.881425685000067],
        ],
        [
            [125.75254004100009, 7.998480444000052],
            [125.77558746000011, 7.951921175000052],
            [125.85149226600004, 7.967149726000059],
            [125.9008660820001, 7.930862946000047],
            [125.911491, 7.999984],
            [125.98004201000003, 7.998677944000065],
            [126.03909698100006, 7.930941297000061],
            [126.14924416600002, 7.996846287000039],
            [126.35158064300003, 8.002065937000054],
        ],
        [
            [126.35158064300003, 8.002065937000054],
            [126.38298739800007, 7.829814393000049],
            [126.57011699200007, 7.718954218000022],
            [126.55900588700001, 7.577831212000035],
            [126.59909005400004, 7.485879984000064],
            [126.59474532200011, 7.448885755000049],
            [126.5490472140001, 7.428681714000049],
            [126.57806242300012, 7.394972218000021],
            [126.55124688500007, 7.312792038000055],
            [126.60496559600006, 7.288605727000061],
            [126.46668698000008, 7.085889775000055],
            [126.45855573100005, 6.99459867500002],
            [126.33806283900003, 7.005641861000072],
            [126.28232622100006, 6.929045160000044],
            [126.34536469300008, 6.857549758000062],
            [126.3502100390001, 6.802589042000022],
            [126.28808742800004, 6.822173794000037],
            [126.2697858900001, 6.92796362100006],
            [126.20558583200011, 6.953721976000054],
            [126.18913423200001, 6.87977810600006],
            [126.15500150800005, 6.906234131000076],
            [126.2603777710001, 6.752009858000065],
            [126.22061610300011, 6.636729260000038],
            [126.22574479700006, 6.435397241000032],
            [126.1928694830001, 6.269284704000029],
            [126.18717725200008, 6.338919315000055],
            [126.13617093100004, 6.387502816000051],
            [126.15056348000007, 6.419357352000077],
            [126.08368159500003, 6.531449433000034],
            [126.07957582300003, 6.846777639000038],
            [125.98664154900007, 6.914005555000074],
            [125.99121957800003, 7.013616763000073],
            [125.88356311500002, 7.126361789000043],
            [125.8925152710001, 7.165850512000077],
            [125.83778490000009, 7.254531412000063],
            [125.85584272100004, 7.342157665000059],
            [125.85199830600004, 7.361307497000041],
            [125.809778692, 7.365896419000023],
            [125.65022142900011, 7.243747089000067],
            [125.64974454900005, 7.096113272000025],
            [125.48943065500009, 6.98489710900003],
            [125.49018483600003, 6.920929862000037],
            [125.379280977, 6.805829566000057],
            [125.37235303600005, 6.723875767000038],
            [125.38704741800007, 6.603455376000056],
            [125.44412701700003, 6.578336999000044],
            [125.42127826500007, 6.621776290000071],
            [125.42952027700005, 6.633026074000043],
            [125.48436040500007, 6.59911820700006],
            [125.52436074200011, 6.51724596400004],
            [125.55131196200011, 6.53495335100007],
            [125.5954335560001, 6.498596697000039],
            [125.58262876700007, 6.463205183000071],
            [125.58277645200008, 6.438834792000023],
            [125.70345797000004, 6.213300230000073],
            [125.70185642400008, 6.024395957000024],
            [125.66093918000001, 5.920675478000021],
            [125.51289608600007, 5.748675381000055],
            [125.41425430000004, 5.57314238400005],
            [125.33194703700008, 5.554826968000043],
            [125.3257177370001, 5.59736130400006],
            [125.39418835800006, 5.649428832000069],
        ],
        [
            [125.39418835800006, 5.649428832000069],
            [125.48315330700007, 5.837673675000076],
            [125.5385663830001, 6.070512974000053],
            [125.50458349500002, 6.229850343000066],
            [125.47366583400003, 6.295944447000068],
            [125.42569052800002, 6.319655984000065],
            [125.4058136650001, 6.480592692000073],
            [125.36340458300003, 6.53496941100002],
            [125.33738888900007, 6.536666667000077],
            [125.30691262300002, 6.454622409000024],
            [125.10770072100001, 6.436109167000041],
            [125.09799452200002, 6.498286680000035],
            [125.1404347460001, 6.520380430000046],
            [125.0467900320001, 6.668458753000039],
            [125.07885684700011, 6.83975507100007],
            [125.15693517600005, 6.857143269000062],
            [125.25922056900004, 7.029416808000065],
            [125.29273864600009, 7.036055654000052],
            [125.28864640400002, 7.115205566000043],
        ],
        [
            [125.28864640400002, 7.115205566000043],
            [125.22876936500006, 7.175858360000063],
            [125.25521114100002, 7.259347723000076],
        ],
        [
            [125.25521114100002, 7.259347723000076],
            [125.22890381500008, 7.355889474000037],
            [125.27566577000005, 7.374365237000063],
            [125.23338329300009, 7.404153070000064],
        ],
        [
            [125.23338329300009, 7.404153070000064],
            [125.2241864660001, 7.471522938000021],
            [125.26359983300006, 7.506819022000059],
        ],
        [
            [125.42456248600001, 7.622786366000071],
            [125.44131302500011, 7.741655047000052],
            [125.37938892500006, 8.003247176000059],
            [125.75254004100009, 7.998480444000052],
        ],
        [
            [124.23449351600004, 7.233458753000036],
            [124.26299592600003, 7.224836556000071],
            [124.31334522100008, 7.135298159000058],
            [124.1578029530001, 7.203421529000025],
            [124.18924799800004, 7.250394842000048],
            [124.241580956, 7.262859672000047],
            [124.23449351600004, 7.233458753000036],
        ],
        [
            [124.7419621140001, 7.590973957000074],
            [124.797288707, 7.532039504000068],
            [124.788596976, 7.484095310000043],
        ],
        [
            [124.81701625700009, 7.499056179000036],
            [124.89446308300012, 7.414624997000033],
            [124.93002318700007, 7.435718253000061],
        ],
        [
            [125.16362012000002, 7.50916058100006],
            [125.21116950500004, 7.499088720000032],
            [125.23338329300009, 7.404153070000064],
        ],
        [
            [125.25521114100002, 7.259347723000076],
            [125.2234718420001, 7.210867900000039],
            [125.28864640400002, 7.115205566000043],
        ],
        [
            [125.39418835800006, 5.649428832000069],
            [125.31703192600003, 5.568640287000051],
            [125.28625206100003, 5.693961637000029],
            [125.1723313120001, 5.812165757000059],
            [125.20582052300006, 5.829386380000074],
            [125.2144269480001, 5.886614141000052],
            [125.27248964900002, 5.91851915500007],
            [125.27153790700004, 6.083965421000073],
            [125.15894113000002, 6.098231359000067],
            [125.07305993000011, 5.858417927000062],
            [124.92395217300009, 5.860013809000066],
            [124.26125214800004, 6.152907130000074],
            [124.18475064300003, 6.210645933000023],
            [124.16777673600006, 6.27261965100007],
            [124.03582770900005, 6.423671682000077],
            [124.02069198600009, 6.530795242000067],
            [124.06388367800002, 6.544531119000055],
            [124.03562512000008, 6.553144693000036],
            [124.05504448800002, 6.603381095000032],
            [124.01630911600012, 6.715420572000028],
            [124.03316300800009, 6.741122303000054],
            [124.28391654000006, 6.75407068800007],
        ],
        [
            [124.57798591900007, 6.781466885000043],
            [124.58028927100008, 6.850143099000036],
        ],
        [
            [124.76099799200006, 6.664839584000049],
            [124.78558916700001, 6.603065123000022],
            [124.86548672100002, 6.609751768000024],
            [124.90200884800004, 6.655854541000053],
        ],
        [
            [124.88680814300005, 6.677562946000023],
            [125.00681249200011, 6.711873362000063],
            [125.00774339400004, 6.734105528000043],
        ],
        [
            [124.958628642, 6.736979865000023],
            [124.95306498800005, 6.785382969000068],
            [124.804196208, 6.816775648000032],
        ],
        [
            [124.7719886320001, 7.075949368000067],
            [124.79752798600009, 7.12597155800006],
            [124.77246232800007, 7.156912165000051],
            [124.694255053, 7.182026060000055],
            [124.73689625200007, 7.110297365000065],
        ],
        [
            [124.52804919700009, 7.638289207000071],
            [124.59036584400008, 7.609324928000035],
            [124.7419621140001, 7.590973957000074],
        ],
        [
            [126.34198239000011, 8.877101650000043],
            [126.33963741000002, 8.877982347000057],
            [126.3397908720001, 8.879719702000045],
            [126.34175563600002, 8.879569425000057],
            [126.34198239000011, 8.877101650000043],
        ],
        [
            [126.1990217010001, 9.229017408000061],
            [126.1986067470001, 9.229017408000061],
            [126.19794506500011, 9.229349501000058],
            [126.19876375700005, 9.229814431000023],
            [126.1990217010001, 9.229017408000061],
        ],
        [
            [126.19745160700006, 9.230600382000034],
            [126.19748525200009, 9.229925128000048],
            [126.19663291600011, 9.229980477000026],
            [126.19662170100003, 9.230545034000045],
            [126.19745160700006, 9.230600382000034],
        ],
        [
            [126.1964983370001, 9.233445290000077],
            [126.19641983200006, 9.232803251000064],
            [126.19554506600002, 9.232770042000027],
            [126.1957020750001, 9.233423151000068],
            [126.1964983370001, 9.233445290000077],
        ],
        [
            [126.19432824400008, 9.23291118000003],
            [126.19509646800009, 9.229349501000058],
            [126.1905992720001, 9.23267041500003],
            [126.19123852500002, 9.23380228600007],
            [126.19432824400008, 9.23291118000003],
        ],
        [
            [125.9981204720001, 9.380315718000077],
            [125.99970647900011, 9.373462715000073],
            [125.99503189500001, 9.373448505000056],
            [125.99426840500007, 9.377639673000033],
            [125.9981204720001, 9.380315718000077],
        ],
        [
            [126.0569619470001, 9.397957208000037],
            [126.05437439700006, 9.389839892000055],
            [126.04362136700001, 9.387126928000043],
            [126.04664376300002, 9.391541559000075],
            [126.0569619470001, 9.397957208000037],
        ],
        [
            [126.01260635400001, 9.406198227000061],
            [126.01264164500003, 9.406018846000052],
            [126.0124412890001, 9.405940733000023],
            [126.01237129800006, 9.406089917000031],
            [126.01260635400001, 9.406198227000061],
        ],
        [
            [126.01324579600009, 9.406584107000072],
            [126.01328414700004, 9.406388566000032],
            [126.01300843100012, 9.406295270000044],
            [126.012945263, 9.40646693900004],
            [126.01324579600009, 9.406584107000072],
        ],
        [
            [125.91165897500002, 9.40544785000003],
            [125.91090709900004, 9.406378291000067],
            [125.91162606300009, 9.40782729600005],
            [125.91222091500003, 9.406657791000043],
            [125.91165897500002, 9.40544785000003],
        ],
        [
            [126.01381978500001, 9.408185179000043],
            [126.013575607, 9.408294254000054],
            [126.0139243960001, 9.408635859000071],
            [126.01413228800004, 9.408328288000064],
            [126.01381978500001, 9.408185179000043],
        ],
        [
            [125.90492627300011, 9.407540751000056],
            [125.90427718600006, 9.407893565000052],
            [125.9043342120001, 9.409205007000025],
            [125.9053197500001, 9.408070420000058],
            [125.90492627300011, 9.407540751000056],
        ],
        [
            [126.0127320900001, 9.409848766000039],
            [126.01297297000008, 9.409463814000048],
            [126.01203833000011, 9.409081537000077],
            [126.01190161300008, 9.409569297000075],
            [126.0127320900001, 9.409848766000039],
        ],
        [
            [125.92457415100012, 9.417200970000067],
            [125.93640360800009, 9.41628393600007],
            [125.94152370300003, 9.407414732000063],
            [125.92073437800002, 9.40529751500003],
            [125.92457415100012, 9.417200970000067],
        ],
        [
            [125.91543697800012, 9.418948838000063],
            [125.91489441800002, 9.414723330000072],
            [125.90845564300002, 9.411265782000044],
            [125.91140924700005, 9.417616260000045],
            [125.91543697800012, 9.418948838000063],
        ],
        [
            [126.01258832200006, 9.430081578000056],
            [126.02529649600001, 9.411830740000028],
            [125.99190063900005, 9.410566182000025],
            [126.00195795000002, 9.424862976000043],
            [126.01258832200006, 9.430081578000056],
        ],
        [
            [126.01410532400007, 9.412278894000053],
            [126.013854906, 9.412104053000064],
            [126.01391349500011, 9.411726642000076],
            [126.01444268300008, 9.411922058000073],
            [126.01410532400007, 9.412278894000053],
        ],
        [
            [125.88031005900007, 9.533874512000068],
            [125.87890624900001, 9.534118653000064],
            [125.87908935500002, 9.53509521500007],
            [125.88031005900007, 9.534484864000035],
            [125.88031005900007, 9.533874512000068],
        ],
        [
            [125.89831543000003, 9.534484864000035],
            [125.8972778320001, 9.534301758000026],
            [125.89691162100007, 9.535278320000032],
            [125.89849853500004, 9.535705567000036],
            [125.89831543000003, 9.534484864000035],
        ],
        [
            [125.8806762690001, 9.536071778000064],
            [125.8796997070001, 9.535888672000056],
            [125.87951660100009, 9.536499024000022],
            [125.8804931630001, 9.536926269000048],
            [125.8806762690001, 9.536071778000064],
        ],
        [
            [125.86921172600012, 9.541366053000047],
            [125.86964778400011, 9.539379018000034],
            [125.86679790100004, 9.540283574000057],
            [125.86712936600009, 9.54072216700007],
            [125.86921172600012, 9.541366053000047],
        ],
        [
            [125.84340296300002, 9.545944509000037],
            [125.84496127500006, 9.545456760000036],
            [125.84700802900011, 9.543867013000067],
            [125.84089344300003, 9.545443784000042],
            [125.84340296300002, 9.545944509000037],
        ],
        [
            [125.82626290200005, 9.554904094000051],
            [125.82649212400008, 9.554400436000037],
            [125.82608351500005, 9.554015460000073],
            [125.82573400900003, 9.554796688000067],
            [125.82626290200005, 9.554904094000051],
        ],
        [
            [125.8389194560001, 9.556074270000067],
            [125.83865253300007, 9.55361885800005],
            [125.83496259500009, 9.554019246000053],
            [125.83665906200008, 9.555821661000039],
            [125.8389194560001, 9.556074270000067],
        ],
        [
            [125.93898563800008, 9.55987437400006],
            [125.93877598200004, 9.559460890000025],
            [125.93815866900002, 9.55941877400005],
            [125.9382130240001, 9.559790145000022],
            [125.93898563800008, 9.55987437400006],
        ],
        [
            [125.9396929510001, 9.560139156000048],
            [125.93953210100005, 9.560316216000047],
            [125.93984631900003, 9.560423188000073],
            [125.93988746700006, 9.560316215000057],
            [125.9396929510001, 9.560139156000048],
        ],
        [
            [125.92798006400005, 9.567168432000074],
            [125.92838155900006, 9.566555695000034],
            [125.92781297800002, 9.565988503000028],
            [125.92742275500007, 9.567471905000048],
            [125.92798006400005, 9.567168432000074],
        ],
        [
            [125.93237343600003, 9.567855468000062],
            [125.92968979800003, 9.566297126000052],
            [125.92927201300006, 9.566842398000063],
            [125.93307893600002, 9.568647221000049],
            [125.93237343600003, 9.567855468000062],
        ],
        [
            [125.93563778600003, 9.570647139000073],
            [125.93538535400012, 9.570899044000043],
            [125.93580910100002, 9.571028802000058],
            [125.93584277200011, 9.570760289000077],
            [125.93563778600003, 9.570647139000073],
        ],
        [
            [125.78457621700011, 9.572641903000033],
            [125.784808515, 9.57233339000004],
            [125.78512978300012, 9.570801050000057],
            [125.78376600100012, 9.571376741000051],
            [125.78457621700011, 9.572641903000033],
        ],
        [
            [125.93604638400006, 9.57357222500002],
            [125.93623801500007, 9.571433889000048],
            [125.93393857800004, 9.571168803000035],
            [125.9345828380001, 9.573469044000035],
            [125.93604638400006, 9.57357222500002],
        ],
        [
            [125.93595449100007, 9.576195519000066],
            [125.93553693100012, 9.576631014000043],
            [125.93587820500011, 9.577102140000022],
            [125.93617130000007, 9.576805212000068],
            [125.93595449100007, 9.576195519000066],
        ],
        [
            [125.93475801900001, 9.577268417000028],
            [125.9343284150001, 9.577157563000071],
            [125.93425614400007, 9.577399064000076],
            [125.93449302800002, 9.577577222000059],
            [125.93475801900001, 9.577268417000028],
        ],
        [
            [125.93225862200006, 9.578471840000077],
            [125.93249488100003, 9.578236849000064],
            [125.93191964300001, 9.578119353000034],
            [125.93187033600009, 9.57833408600004],
            [125.93225862200006, 9.578471840000077],
        ],
        [
            [125.93583403700006, 9.577514670000028],
            [125.93549276200008, 9.578092690000062],
            [125.9359866100001, 9.578844121000031],
            [125.93624758600004, 9.577870985000061],
            [125.93583403700006, 9.577514670000028],
        ],
        [
            [125.92541892300005, 9.579111799000032],
            [125.9257870890001, 9.575242672000059],
            [125.92332507700007, 9.573531165000077],
            [125.92329194900003, 9.578143237000063],
            [125.92541892300005, 9.579111799000032],
        ],
        [
            [125.92854162600008, 9.581085166000037],
            [125.92896372400003, 9.58026845300003],
            [125.92871699200009, 9.580009062000045],
            [125.92789813000002, 9.580488684000045],
            [125.92854162600008, 9.581085166000037],
        ],
        [
            [125.91672601100004, 9.58139828800006],
            [125.91658445200005, 9.581560030000048],
            [125.916735001, 9.581890161000047],
            [125.91686083200011, 9.581763868000053],
            [125.91672601100004, 9.58139828800006],
        ],
        [
            [125.9161755, 9.581956631000025],
            [125.91606315100012, 9.581907887000057],
            [125.91580924100003, 9.582014238000056],
            [125.91600248300006, 9.58217376400006],
            [125.9161755, 9.581956631000025],
        ],
        [
            [125.9153149010001, 9.581901239000047],
            [125.91511267300007, 9.581965493000041],
            [125.91524524400006, 9.58219592000006],
            [125.91542725200009, 9.58204968800004],
            [125.9153149010001, 9.581901239000047],
        ],
        [
            [125.91669230900004, 9.58221364600007],
            [125.91657321800005, 9.582023100000072],
            [125.91642941100008, 9.58211172600005],
            [125.9165147980001, 9.582204784000055],
            [125.91669230900004, 9.58221364600007],
        ],
        [
            [125.91396220900003, 9.58232663800004],
            [125.91394872900003, 9.581976567000027],
            [125.9137465010001, 9.581810392000023],
            [125.91361842100002, 9.582164894000073],
            [125.91396220900003, 9.58232663800004],
        ],
        [
            [125.75702028800004, 9.583682131000046],
            [125.7655352270001, 9.58133893300004],
            [125.76744268100003, 9.577355940000075],
            [125.7558609350001, 9.577106852000043],
            [125.75702028800004, 9.583682131000046],
        ],
        [
            [125.91152056400006, 9.589059174000056],
            [125.91117454500011, 9.589122251000049],
            [125.91108731300005, 9.589271341000028],
            [125.91138099300008, 9.589334416000042],
            [125.91152056400006, 9.589059174000056],
        ],
        [
            [125.91025393900009, 9.588768111000036],
            [125.91022940000005, 9.589713776000053],
            [125.91057568700012, 9.590350374000025],
            [125.91099286800011, 9.58964727600005],
            [125.91025393900009, 9.588768111000036],
        ],
        [
            [125.9061609360001, 9.594451216000039],
            [125.90670151800009, 9.593913317000045],
            [125.90658497400011, 9.593734829000027],
            [125.90547874100002, 9.59451208400003],
            [125.9061609360001, 9.594451216000039],
        ],
        [
            [125.912399348, 9.595175992000065],
            [125.91194800800008, 9.595492790000037],
            [125.91246675800005, 9.596068105000029],
            [125.912796565, 9.595492584000056],
            [125.912399348, 9.595175992000065],
        ],
        [
            [125.9044677280001, 9.596991288000027],
            [125.90618363800002, 9.595550317000061],
            [125.90326734900009, 9.596897931000058],
            [125.90455305000012, 9.599333710000053],
            [125.9044677280001, 9.596991288000027],
        ],
        [
            [126.1777645190001, 9.605603098000074],
            [126.17993268100008, 9.604067749000023],
            [126.18032403300003, 9.602635716000066],
            [126.17836573500006, 9.602975503000039],
            [126.1777645190001, 9.605603098000074],
        ],
        [
            [125.71824098800005, 9.606677426000033],
            [125.71929931600005, 9.604309083000032],
            [125.7141317490001, 9.601400305000027],
            [125.71499026000004, 9.606001541000069],
            [125.71824098800005, 9.606677426000033],
        ],
        [
            [125.9100254120001, 9.612095217000046],
            [125.91043602700006, 9.611353116000032],
            [125.90981157500005, 9.610983704000034],
            [125.90929900800006, 9.611652928000069],
            [125.9100254120001, 9.612095217000046],
        ],
        [
            [126.14577888500003, 9.614432948000058],
            [126.14626221500009, 9.611640231000024],
            [126.1335762870001, 9.602698540000063],
            [126.12900249200004, 9.602834160000043],
            [126.14577888500003, 9.614432948000058],
        ],
        [
            [126.17609694900011, 9.615664672000037],
            [126.18250854900009, 9.611304137000047],
            [126.17101041100011, 9.608365029000026],
            [126.17165810300003, 9.610335031000034],
            [126.17609694900011, 9.615664672000037],
        ],
        [
            [126.17969450900011, 9.640197881000063],
            [126.17997743, 9.623907526000039],
            [126.17630781300011, 9.618820807000077],
            [126.17275128800009, 9.629766437000058],
            [126.17969450900011, 9.640197881000063],
        ],
        [
            [125.71483979400011, 9.653634771000043],
            [125.71473956800003, 9.652082548000067],
            [125.71275184600006, 9.65181971000004],
            [125.71331816700001, 9.654519676000064],
            [125.71483979400011, 9.653634771000043],
        ],
        [
            [125.92586707500004, 9.655791754000063],
            [125.92582612300009, 9.65629105000005],
            [125.92602812700011, 9.656717784000023],
            [125.92603814000006, 9.656104464000066],
            [125.92586707500004, 9.655791754000063],
        ],
        [
            [125.70750850400009, 9.665613673000053],
            [125.70691349900005, 9.664097784000035],
            [125.70678351600009, 9.668228489000057],
            [125.7079055150001, 9.668292480000048],
            [125.70750850400009, 9.665613673000053],
        ],
        [
            [125.67318447900004, 9.680350046000058],
            [125.67437264800003, 9.676601405000042],
            [125.67182028900004, 9.67440460000006],
            [125.66960953600005, 9.678671945000076],
            [125.67318447900004, 9.680350046000058],
        ],
        [
            [125.66152571500004, 9.685661458000027],
            [125.66140170200003, 9.68485572800006],
            [125.66040781000004, 9.68487920900003],
            [125.66065427500007, 9.685460782000064],
            [125.66152571500004, 9.685661458000027],
        ],
        [
            [125.61557753900001, 9.686956491000046],
            [125.6166073060001, 9.686792566000065],
            [125.61677155300004, 9.686161282000057],
            [125.61536153600002, 9.685999382000034],
            [125.61557753900001, 9.686956491000046],
        ],
        [
            [125.99549297400006, 9.687635430000057],
            [125.99665116400001, 9.68687116600006],
            [125.99658381900008, 9.686244900000077],
            [125.99500698500003, 9.68635641800006],
            [125.99549297400006, 9.687635430000057],
        ],
        [
            [125.61715085800006, 9.687753309000072],
            [125.61767595600008, 9.68692917800007],
            [125.61615733700012, 9.687089292000053],
            [125.6165393770001, 9.687678727000048],
            [125.61715085800006, 9.687753309000072],
        ],
        [
            [126.01940120200004, 9.687591732000044],
            [126.02045609600009, 9.687221133000037],
            [126.01980602100002, 9.685357887000066],
            [126.01853825500007, 9.686296703000039],
            [126.01940120200004, 9.687591732000044],
        ],
        [
            [125.66764808800008, 9.688220133000073],
            [125.66816833900009, 9.687351198000044],
            [125.66683921700007, 9.686278927000046],
            [125.66681855700006, 9.687329263000038],
            [125.66764808800008, 9.688220133000073],
        ],
        [
            [125.602103456, 9.690224736000062],
            [125.60175018500001, 9.690172671000028],
            [125.60171375400012, 9.690529875000038],
            [125.6019195240001, 9.690567576000035],
            [125.602103456, 9.690224736000062],
        ],
        [
            [125.6260986320001, 9.69030761700003],
            [125.62548828100012, 9.69189453100006],
            [125.62829589800003, 9.69189453100006],
            [125.62829589800003, 9.691284180000025],
            [125.6260986320001, 9.69030761700003],
        ],
        [
            [125.6084432990001, 9.693789717000072],
            [125.6142532770001, 9.691350503000024],
            [125.60648924000009, 9.683223472000066],
            [125.60210892500004, 9.690030876000037],
            [125.6084432990001, 9.693789717000072],
        ],
        [
            [125.60564422700008, 9.694231251000076],
            [125.60606255400012, 9.69414841500003],
            [125.60603149400004, 9.693638824000061],
            [125.60564422100003, 9.693800889000045],
            [125.60564422700008, 9.694231251000076],
        ],
        [
            [125.60578489800002, 9.69510097500006],
            [125.6057191320001, 9.694868689000032],
            [125.60554193500002, 9.694962326000052],
            [125.60558029800006, 9.69509917800002],
            [125.60578489800002, 9.69510097500006],
        ],
        [
            [125.59117040400008, 9.695284553000022],
            [125.59149652500003, 9.694782881000037],
            [125.59123572600004, 9.694552514000065],
            [125.5910092690001, 9.694791735000024],
            [125.59117040400008, 9.695284553000022],
        ],
        [
            [125.59136957100009, 9.695813087000033],
            [125.59150548500008, 9.69541494400005],
            [125.59139863100006, 9.695313155000065],
            [125.59106893800003, 9.695472014000075],
            [125.59136957100009, 9.695813087000033],
        ],
        [
            [125.59176055900002, 9.696569866000061],
            [125.5922865980001, 9.69645451200006],
            [125.59227377600007, 9.695944471000075],
            [125.5916761630001, 9.696087302000024],
            [125.59176055900002, 9.696569866000061],
        ],
        [
            [126.07424333200004, 9.69682470500004],
            [126.09022078900011, 9.695085407000022],
            [126.0906268330001, 9.692170875000045],
            [126.08073201600007, 9.68956776400006],
            [126.07424333200004, 9.69682470500004],
        ],
        [
            [125.61250959800009, 9.69808920500003],
            [125.61241003500004, 9.69772878300006],
            [125.6122091090001, 9.697784098000056],
            [125.6122688480001, 9.698024975000067],
            [125.61250959800009, 9.69808920500003],
        ],
        [
            [125.607518174, 9.698264859000062],
            [125.60780960700004, 9.698248800000044],
            [125.60771367000007, 9.697822359000043],
            [125.60733353900002, 9.697893730000033],
            [125.607518174, 9.698264859000062],
        ],
        [
            [125.59187847900012, 9.700252595000052],
            [125.59264485500012, 9.69856844800006],
            [125.591987302, 9.696625823000034],
            [125.59104004700009, 9.699887244000024],
            [125.59187847900012, 9.700252595000052],
        ],
        [
            [125.59237547400005, 9.700271592000036],
            [125.59261353900001, 9.70022242500005],
            [125.59268851500008, 9.699543078000033],
            [125.5921048240001, 9.69997823500006],
            [125.59237547400005, 9.700271592000036],
        ],
        [
            [125.59297253400007, 9.700279248000072],
            [125.593218266, 9.70030956200003],
            [125.5932491100001, 9.699454219000074],
            [125.59283631400001, 9.699709627000061],
            [125.59297253400007, 9.700279248000072],
        ],
        [
            [125.5930291090001, 9.702515944000027],
            [125.59315770400008, 9.702328625000064],
            [125.5927776210001, 9.70213756000004],
            [125.59279435300004, 9.702383673000043],
            [125.5930291090001, 9.702515944000027],
        ],
        [
            [125.59400584900004, 9.702514250000036],
            [125.59384001500007, 9.702514225000073],
            [125.593914519, 9.702697900000032],
            [125.59406172900003, 9.702635476000069],
            [125.59400584900004, 9.702514250000036],
        ],
        [
            [125.6130032310001, 9.705285600000025],
            [125.61682406500006, 9.699995053000066],
            [125.61480168600008, 9.69760384500006],
            [125.60830693500009, 9.699495649000028],
            [125.6130032310001, 9.705285600000025],
        ],
        [
            [125.66341298100008, 9.709861624000041],
            [125.6732943400001, 9.700268106000067],
            [125.67225773200005, 9.694183129000066],
            [125.66445774300007, 9.69062219600005],
            [125.66341298100008, 9.709861624000041],
        ],
        [
            [125.61911384100006, 9.713529867000034],
            [125.6206817200001, 9.713040663000072],
            [125.62107573600008, 9.712105921000045],
            [125.61875257500003, 9.712869929000021],
            [125.61911384100006, 9.713529867000034],
        ],
        [
            [125.627757169, 9.727649467000049],
            [125.66395468700011, 9.721578597000075],
            [125.65829160900012, 9.663975424000057],
            [125.61694353200005, 9.70451593200005],
            [125.62328568500004, 9.712285331000032],
            [125.62191344300004, 9.723498462000066],
            [125.627757169, 9.727649467000049],
        ],
        [
            [126.12560587900009, 9.735227419000068],
            [126.1265161440001, 9.734777459000043],
            [126.12675243300009, 9.734507964000045],
            [126.12544642500006, 9.734906885000044],
            [126.12560587900009, 9.735227419000068],
        ],
        [
            [125.98269456700007, 9.736551743000064],
            [126.00887787500005, 9.70322092300006],
            [125.98313426300001, 9.686869699000056],
            [125.9659882840001, 9.713848989000041],
            [125.98269456700007, 9.736551743000064],
        ],
        [
            [126.02770279700007, 9.736939905000042],
            [126.07050592600001, 9.709563582000044],
            [126.00611461000005, 9.68315414600005],
            [126.01083834100007, 9.715539164000063],
            [126.02770279700007, 9.736939905000042],
        ],
        [
            [126.03817496300007, 9.700422637000031],
            [126.03678823300004, 9.69977091900006],
            [126.03754144100003, 9.698223828000039],
            [126.03955750600005, 9.699441754000077],
            [126.03817496300007, 9.700422637000031],
        ],
        [
            [126.04254342700006, 9.739703266000049],
            [126.04802001200005, 9.737953854000068],
            [126.04755908300001, 9.734122180000043],
            [126.04037262300005, 9.73710138000007],
            [126.04254342700006, 9.739703266000049],
        ],
        [
            [125.64432806700006, 9.74068730600004],
            [125.64844278500004, 9.738442668000062],
            [125.63941674500006, 9.732713101000058],
            [125.63755930900004, 9.739101710000057],
            [125.64432806700006, 9.74068730600004],
        ],
        [
            [126.17157542200005, 9.74587740800007],
            [126.16464537400009, 9.736521161000042],
            [126.15319338600011, 9.738545024000075],
            [126.15496758600011, 9.742998965000027],
            [126.17157542200005, 9.74587740800007],
        ],
        [
            [126.0424792020001, 9.751365729000042],
            [126.04272252800001, 9.743865004000043],
            [126.03540422100002, 9.743893231000072],
            [126.03938582300009, 9.750967007000042],
            [126.0424792020001, 9.751365729000042],
        ],
        [
            [125.69496854800002, 9.753202853000062],
            [125.70133219500008, 9.73519477700006],
            [125.67861733400002, 9.74014341000003],
            [125.68263922100004, 9.74641058100002],
            [125.69496854800002, 9.753202853000062],
        ],
        [
            [126.13092707700002, 9.753783299000077],
            [126.13079578300005, 9.753933678000067],
            [126.13096433600003, 9.754049086000066],
            [126.13104240300004, 9.753926683000032],
            [126.13092707700002, 9.753783299000077],
        ],
        [
            [126.13163477000012, 9.755457728000067],
            [126.13218511700006, 9.755047615000024],
            [126.13140203700004, 9.753908004000039],
            [126.13066359600009, 9.754856578000044],
            [126.13163477000012, 9.755457728000067],
        ],
        [
            [125.67385304000004, 9.757257665000054],
            [125.67661763600006, 9.754477733000044],
            [125.67613387100005, 9.751396484000054],
            [125.67207819300006, 9.755684675000055],
            [125.67385304000004, 9.757257665000054],
        ],
        [
            [125.69393616900004, 9.758102242000064],
            [125.69208154900002, 9.75682469800006],
            [125.69065471500005, 9.757294295000065],
            [125.69125237900005, 9.758104509000077],
            [125.69393616900004, 9.758102242000064],
        ],
        [
            [125.93367126700002, 9.760426891000066],
            [125.99048143400012, 9.664608968000039],
            [125.94105336300004, 9.559762264000028],
            [125.93699712500006, 9.579084988000034],
            [125.92972323200001, 9.582285769000066],
            [125.91241433000005, 9.582621681000035],
            [125.91729049300011, 9.598209543000053],
            [125.90953367600002, 9.614609607000034],
            [125.90879831000007, 9.610545756000022],
            [125.88770714000009, 9.611781828000062],
            [125.92707965300008, 9.654231996000021],
            [125.90603961300008, 9.720296978000022],
            [125.93367126700002, 9.760426891000066],
        ],
        [
            [125.55666797200001, 9.760395170000038],
            [125.55617500800008, 9.75930309000006],
            [125.5558751960001, 9.759314170000039],
            [125.55680476100008, 9.760716496000043],
            [125.55666797200001, 9.760395170000038],
        ],
        [
            [125.62103872700004, 9.761380791000022],
            [125.62242085600008, 9.759702238000045],
            [125.61948923300008, 9.758998861000066],
            [125.61897754200004, 9.76090634600007],
            [125.62103872700004, 9.761380791000022],
        ],
        [
            [125.622969194, 9.762146603000076],
            [125.62319095600003, 9.762133056000039],
            [125.62358313700008, 9.761590888000057],
            [125.62275088100012, 9.761806066000076],
            [125.622969194, 9.762146603000076],
        ],
        [
            [125.56809855800009, 9.761972916000047],
            [125.56771461300002, 9.761050703000024],
            [125.566809798, 9.761156154000048],
            [125.56695755500004, 9.762104256000043],
            [125.56809855800009, 9.761972916000047],
        ],
        [
            [125.56649278600003, 9.76136851900003],
            [125.56529214500006, 9.761241392000045],
            [125.56507320500009, 9.76244203300007],
            [125.565461647, 9.762434970000072],
            [125.56649278600003, 9.76136851900003],
        ],
        [
            [125.57601685600002, 9.763114104000067],
            [125.57730045100004, 9.762121405000073],
            [125.57738290400005, 9.759775992000073],
            [125.5748129860001, 9.761801461000061],
            [125.57601685600002, 9.763114104000067],
        ],
        [
            [125.57802074000006, 9.763074207000045],
            [125.57872130300007, 9.762779092000073],
            [125.5785327540001, 9.761409894000053],
            [125.57766890000005, 9.762211437000076],
            [125.57802074000006, 9.763074207000045],
        ],
        [
            [126.16815386100006, 9.765554113000064],
            [126.168332684, 9.765061736000064],
            [126.16764194400002, 9.764990863000037],
            [126.16750442200009, 9.765425500000049],
            [126.16815386100006, 9.765554113000064],
        ],
        [
            [125.6124357000001, 9.76556749200006],
            [125.61603121900009, 9.753172279000069],
            [125.59459183900003, 9.756158984000024],
            [125.59727700200006, 9.760549174000062],
            [125.6124357000001, 9.76556749200006],
        ],
        [
            [125.54040792700005, 9.767818488000046],
            [125.54115914700003, 9.767716903000064],
            [125.5413885270001, 9.767448685000033],
            [125.54125653400001, 9.767375679000054],
            [125.54040792700005, 9.767818488000046],
        ],
        [
            [125.54575725000007, 9.768407919000026],
            [125.54612642300003, 9.76823478600005],
            [125.54392361100008, 9.768080421000036],
            [125.54557720100001, 9.76856988700007],
            [125.54575725000007, 9.768407919000026],
        ],
        [
            [125.540924216, 9.76911147100003],
            [125.54116760900001, 9.768915873000026],
            [125.54074144900005, 9.767991661000053],
            [125.5404686380001, 9.768808725000042],
            [125.540924216, 9.76911147100003],
        ],
        [
            [125.63615252200009, 9.769160568000075],
            [125.6410534580001, 9.754838515000074],
            [125.62460909900005, 9.740025310000021],
            [125.62673608900002, 9.76490663800007],
            [125.63615252200009, 9.769160568000075],
        ],
        [
            [125.5458633390001, 9.769005026000059],
            [125.54616972200006, 9.769336696000039],
            [125.54629678100002, 9.768828607000046],
            [125.54604897700005, 9.768459904000053],
            [125.5458633390001, 9.769005026000059],
        ],
        [
            [125.54548393100004, 9.769507586000032],
            [125.54525041600004, 9.769270014000028],
            [125.54458705400009, 9.769258473000036],
            [125.54494381300003, 9.769662733000075],
            [125.54548393100004, 9.769507586000032],
        ],
        [
            [125.54263399500007, 9.769827806000023],
            [125.54267215000004, 9.769712285000026],
            [125.54219944300007, 9.769751128000053],
            [125.54228058300009, 9.769795654000063],
            [125.54263399500007, 9.769827806000023],
        ],
        [
            [125.58078192900007, 9.770097086000021],
            [125.58222640000008, 9.768930097000066],
            [125.58072204000007, 9.767296566000027],
            [125.57952811100006, 9.767935222000062],
            [125.58078192900007, 9.770097086000021],
        ],
        [
            [125.54370094700005, 9.770168868000042],
            [125.54324122900005, 9.769752216000029],
            [125.54219894800008, 9.769907130000036],
            [125.54264980200003, 9.770126145000063],
            [125.54370094700005, 9.770168868000042],
        ],
        [
            [125.54223449300002, 9.770233587000064],
            [125.54235694600004, 9.770170310000026],
            [125.54167601300003, 9.77000243200007],
            [125.541997336, 9.770424387000048],
            [125.54223449300002, 9.770233587000064],
        ],
        [
            [125.54252442900008, 9.770481748000066],
            [125.54267322900012, 9.77041911300006],
            [125.54248970100002, 9.77037664900007],
            [125.54217308700004, 9.770613634000028],
            [125.54252442900008, 9.770481748000066],
        ],
        [
            [125.54186416100003, 9.770705965000047],
            [125.54201654200006, 9.770505641000057],
            [125.54156217500008, 9.770459952000067],
            [125.54155781600002, 9.770600786000045],
            [125.54186416100003, 9.770705965000047],
        ],
        [
            [125.5424006930001, 9.770763525000064],
            [125.54391128700001, 9.770698785000036],
            [125.5440138030001, 9.770607768000048],
            [125.54288872000006, 9.77046533600003],
            [125.5424006930001, 9.770763525000064],
        ],
        [
            [125.5405500820001, 9.770315144000051],
            [125.54005104700002, 9.769186386000058],
            [125.53880275900008, 9.769947707000028],
            [125.54009524100002, 9.770779947000051],
            [125.5405500820001, 9.770315144000051],
        ],
        [
            [125.63311822100002, 9.770676304000062],
            [125.63367820700012, 9.77036671600007],
            [125.63329019300011, 9.769478325000023],
            [125.6320107790001, 9.770264853000072],
            [125.63311822100002, 9.770676304000062],
        ],
        [
            [125.54275130500002, 9.770979344000068],
            [125.54313474600008, 9.770826832000068],
            [125.54219516700005, 9.77086179500003],
            [125.54223979500011, 9.770903419000035],
            [125.54275130500002, 9.770979344000068],
        ],
        [
            [125.54028056000004, 9.77124182700004],
            [125.54048426100007, 9.771091267000031],
            [125.54089543600003, 9.770974165000041],
            [125.54045219500006, 9.77067676200005],
            [125.54028056000004, 9.77124182700004],
        ],
        [
            [125.53996369000004, 9.77167120300004],
            [125.540227748, 9.77153551200007],
            [125.54030885100008, 9.771410975000038],
            [125.53993728400008, 9.771351494000044],
            [125.53996369000004, 9.77167120300004],
        ],
        [
            [125.5397191300001, 9.771440939000058],
            [125.53992660300003, 9.77081641600006],
            [125.53880247400002, 9.770360994000043],
            [125.53929097800005, 9.771632392000072],
            [125.5397191300001, 9.771440939000058],
        ],
        [
            [125.53578238700004, 9.77207971100006],
            [125.5367649210001, 9.771647689000076],
            [125.53650788400012, 9.77102786100005],
            [125.53548492400012, 9.770932387000073],
            [125.53578238700004, 9.77207971100006],
        ],
        [
            [125.53896532100009, 9.772165827000038],
            [125.53824356700011, 9.770161268000038],
            [125.53691545400011, 9.770765121000068],
            [125.5374615180001, 9.771690423000052],
            [125.53896532100009, 9.772165827000038],
        ],
        [
            [125.5360354280001, 9.772578347000035],
            [125.53606607400002, 9.772337868000022],
            [125.53587908100008, 9.772337294000067],
            [125.5358845940001, 9.772512061000043],
            [125.5360354280001, 9.772578347000035],
        ],
        [
            [125.52209472700008, 9.770874023000033],
            [125.52050781300011, 9.770874023000033],
            [125.51910400400004, 9.772277833000032],
            [125.52252197300004, 9.773681641000053],
            [125.52209472700008, 9.770874023000033],
        ],
        [
            [125.63140779900004, 9.775816304000045],
            [125.63072023000007, 9.770450095000058],
            [125.62418302900005, 9.769674500000065],
            [125.62441432600008, 9.77413894800003],
            [125.63140779900004, 9.775816304000045],
        ],
        [
            [125.54295667000008, 9.777838167000027],
            [125.556874235, 9.775112659000058],
            [125.55978198000003, 9.77704986200007],
            [125.56133581300003, 9.767760959000043],
            [125.54295667000008, 9.777838167000027],
        ],
        [
            [125.53530002500008, 9.779604591000066],
            [125.5388805340001, 9.777764492000074],
            [125.53703557200004, 9.772120047000044],
            [125.5343823390001, 9.774013638000042],
            [125.53168632000006, 9.774333828000067],
            [125.53530002500008, 9.779604591000066],
        ],
        [
            [125.53992326800005, 9.779779523000059],
            [125.54189308600007, 9.778311570000028],
            [125.541127619, 9.776908554000045],
            [125.53894694200005, 9.778480666000064],
            [125.53992326800005, 9.779779523000059],
        ],
        [
            [125.5382093720001, 9.780917058000057],
            [125.538670539, 9.780762749000075],
            [125.53892630000007, 9.78016573800005],
            [125.53776018200006, 9.780579757000055],
            [125.5382093720001, 9.780917058000057],
        ],
        [
            [125.53697892800005, 9.78134264700003],
            [125.53721653800005, 9.781165958000031],
            [125.5370472520001, 9.780659897000021],
            [125.53657608800006, 9.781136325000034],
            [125.53697892800005, 9.78134264700003],
        ],
        [
            [125.55255357400006, 9.788372243000026],
            [125.55852116200003, 9.779106710000065],
            [125.54198586000007, 9.779984819000049],
            [125.54305841900009, 9.783919163000064],
            [125.55255357400006, 9.788372243000026],
        ],
        [
            [125.54599752700005, 9.788779083000065],
            [125.54709494300005, 9.788511885000048],
            [125.54613213800008, 9.787264394000033],
            [125.54505664100009, 9.788848045000066],
            [125.54599752700005, 9.788779083000065],
        ],
        [
            [125.65369225800009, 9.797240111000065],
            [125.65485297000009, 9.792147424000063],
            [125.64998742800003, 9.792623449000075],
            [125.64936638900008, 9.794189815000038],
            [125.65369225800009, 9.797240111000065],
        ],
        [
            [125.6381163530001, 9.798925299000075],
            [125.6676910760001, 9.766879577000054],
            [125.66859874300008, 9.758371565000061],
            [125.66488213000002, 9.752522254000041],
            [125.6381163530001, 9.798925299000075],
        ],
        [
            [125.58627433600009, 9.801664938000044],
            [125.58980227900008, 9.798987698000076],
            [125.58982389000005, 9.797803954000074],
            [125.58427996800003, 9.795107116000054],
            [125.58627433600009, 9.801664938000044],
        ],
        [
            [125.71638593400007, 9.813072688000034],
            [125.74081965700009, 9.781484230000046],
            [125.72566863000009, 9.753218018000041],
            [125.69637507700008, 9.79012384500004],
            [125.71638593400007, 9.813072688000034],
        ],
        [
            [125.75254004100009, 7.998480444000052],
            [125.37939404500003, 8.003230631000065],
            [125.37992309200001, 8.042899480000074],
            [125.393454, 8.043015],
            [125.44290188100001, 8.096643192000045],
            [125.27508000000012, 8.354652],
        ],
        [
            [125.26173252700005, 8.587565607000045],
            [125.25537209600009, 8.579610089000028],
            [125.2458427580001, 8.581976305000069],
            [125.17110421600012, 8.582282192000037],
            [125.16978647600001, 8.583903805000034],
        ],
        [
            [125.2381393180001, 8.987511528000027],
            [125.20790618, 9.093872980000071],
            [125.23721254000009, 9.030769289000034],
            [125.3324415730001, 8.969484782000052],
            [125.5236220060001, 9.01130258400002],
            [125.5306473930001, 9.193532829000048],
            [125.39103199200008, 9.655897624000033],
            [125.40107978500009, 9.767315704000055],
            [125.44122369100012, 9.824685275000036],
            [125.5064790780001, 9.765811039000027],
            [125.55797126100003, 9.75069654500004],
            [125.5732470050001, 9.762123605000056],
            [125.56618085800005, 9.743121905000066],
            [125.57382297400011, 9.733383944000025],
            [125.6186989900001, 9.751197791000038],
            [125.60985184100002, 9.709769639000058],
            [125.59814146400004, 9.70088071500004],
            [125.5941693200001, 9.704853010000022],
            [125.59017001200004, 9.700448666000057],
            [125.59023513600005, 9.695324156000027],
            [125.64015716900008, 9.60983453700004],
            [125.86041412200007, 9.534570269000028],
            [125.94306433300005, 9.445540785000048],
            [125.93865208800003, 9.474481728000058],
            [125.96236087200009, 9.479938815000025],
            [125.95386065000002, 9.441397339000048],
            [125.89362085400012, 9.413744312000063],
            [125.94203047600001, 9.370710676000044],
            [125.98796773200002, 9.403656959000045],
            [125.984307682, 9.322428838000064],
            [126.04815607500007, 9.238836301000049],
            [126.20717583800001, 9.306010183000069],
            [126.15798473900009, 9.10508573200002],
            [126.30669774600005, 8.956098645000054],
            [126.29061611000009, 8.926963559000058],
            [126.32533393400001, 8.919453504000046],
            [126.30678052300004, 8.880898459000036],
            [126.33463146400004, 8.840739960000064],
            [126.30248725900003, 8.78206857500004],
            [126.21313966100001, 8.73351449300003],
            [126.2450067210001, 8.695117828000036],
            [126.18806590100007, 8.69945253800006],
            [126.08211890000007, 8.611543250000068],
            [126.1426963240001, 8.529396360000021],
            [126.22793046400011, 8.526515150000023],
            [126.18817640300006, 8.546432104000075],
            [126.20655883900008, 8.557733632000065],
            [126.28789762500003, 8.529096630000026],
            [126.35475910500008, 8.548575375000041],
            [126.350913235, 8.51976411000004],
            [126.39763888300001, 8.49308510000003],
            [126.39740862800011, 8.467805351000038],
            [126.3546992360001, 8.470305058000065],
            [126.3475959210001, 8.428045608000048],
            [126.38010640000005, 8.409426904000043],
            [126.3182252250001, 8.352569677000076],
            [126.33047083200006, 8.313753470000051],
            [126.38295217600012, 8.292378928000062],
            [126.30817866300004, 8.217787651000037],
            [126.34399275100009, 8.183305159000042],
            [126.45604406500001, 8.244542706000061],
            [126.42629140000008, 8.111204999000051],
            [126.45273051600009, 8.098000623000075],
            [126.40625837900006, 8.00976716200006],
            [126.4494549960001, 7.988591548000045],
            [126.3683475040001, 7.918813413000066],
            [126.35158064300003, 8.002065937000054],
        ],
        [
            [125.6027617090001, 9.70790482600006],
            [125.60196496200001, 9.707426607000059],
            [125.60270390500011, 9.70615751400004],
            [125.60359932300003, 9.706733062000069],
            [125.6027617090001, 9.70790482600006],
        ],
        [
            [126.11359857200011, 9.856445658000041],
            [126.11319120100006, 9.855769387000066],
            [126.11273742900005, 9.856099225000037],
            [126.1129370970001, 9.85642165300004],
            [126.11359857200011, 9.856445658000041],
        ],
        [
            [125.96768485600012, 9.855839815000024],
            [125.9671943830001, 9.855386112000076],
            [125.96821720500009, 9.856400234000034],
            [125.96818829900008, 9.856164972000045],
            [125.96768485600012, 9.855839815000024],
        ],
        [
            [125.97029558800011, 9.856988389000037],
            [125.97281023300002, 9.855264418000047],
            [125.96438714200008, 9.852143650000073],
            [125.96499252000001, 9.854230062000056],
            [125.97029558800011, 9.856988389000037],
        ],
        [
            [125.96813863800003, 9.855705670000077],
            [125.96785612200006, 9.855676692000031],
            [125.96775382400006, 9.855226165000033],
            [125.96814318500003, 9.855287590000046],
            [125.96813863800003, 9.855705670000077],
        ],
        [
            [126.11575297900004, 9.857122945000071],
            [126.11645595800007, 9.856614852000064],
            [126.11500152100007, 9.855711021000047],
            [126.11399234700002, 9.855641867000031],
            [126.11575297900004, 9.857122945000071],
        ],
        [
            [125.96519727200007, 9.85783617900006],
            [125.96432718500012, 9.85512327400005],
            [125.9626557790001, 9.856112899000038],
            [125.96460834900006, 9.858296600000074],
            [125.96519727200007, 9.85783617900006],
        ],
        [
            [125.97055072400008, 9.858477406000077],
            [125.9712131980001, 9.857989275000023],
            [125.970245696, 9.857398800000055],
            [125.97004888800006, 9.858356532000073],
            [125.97055072400008, 9.858477406000077],
        ],
        [
            [125.963068055, 9.858285137000053],
            [125.96280095400004, 9.85839816500004],
            [125.9630971680001, 9.858641075000037],
            [125.96312456100009, 9.858496],
            [125.963068055, 9.858285137000053],
        ],
        [
            [125.96565032500007, 9.859139344000027],
            [125.96686549100002, 9.858007068000063],
            [125.965514159, 9.857044010000038],
            [125.96504274500012, 9.85874578000005],
            [125.96565032500007, 9.859139344000027],
        ],
        [
            [125.9703739690001, 9.859285640000053],
            [125.96991728400008, 9.859127405000038],
            [125.9698054800001, 9.859197227000038],
            [125.97001336300002, 9.85964094600007],
            [125.9703739690001, 9.859285640000053],
        ],
        [
            [125.96703071200011, 9.861657132000062],
            [125.97100895200003, 9.860893179000072],
            [125.96897756400006, 9.859246883000026],
            [125.96866458200009, 9.857466069000054],
            [125.96703071200011, 9.861657132000062],
        ],
        [
            [125.9727842740001, 9.863486483000031],
            [125.97371584700011, 9.86250302600007],
            [125.97157515200001, 9.862047791000066],
            [125.97141685200006, 9.863407798000026],
            [125.9727842740001, 9.863486483000031],
        ],
        [
            [125.96864324400008, 9.865544562000025],
            [125.97028611600001, 9.863139541000066],
            [125.96894643100006, 9.86133617400003],
            [125.96697190800012, 9.862466804000064],
            [125.96864324400008, 9.865544562000025],
        ],
        [
            [125.53398178500004, 9.88762412400007],
            [125.53387151700008, 9.887288928000032],
            [125.53356907300008, 9.887409974000036],
            [125.53386994400012, 9.887715683000067],
            [125.53398178500004, 9.88762412400007],
        ],
        [
            [125.96115522600007, 9.889440639000043],
            [125.96203302900005, 9.888312453000026],
            [125.9604051020001, 9.88650300200004],
            [125.96011035700008, 9.889325166000049],
            [125.96115522600007, 9.889440639000043],
        ],
        [
            [125.53328622000004, 9.890422171000068],
            [125.53322163300004, 9.89018939500005],
            [125.53298849900011, 9.890699950000055],
            [125.53325313900007, 9.890690638000024],
            [125.53328622000004, 9.890422171000068],
        ],
        [
            [125.96286472500003, 9.890954933000046],
            [125.96339752100005, 9.890673549000041],
            [125.96216498400008, 9.889924858000029],
            [125.96248044000004, 9.89068459200007],
            [125.96286472500003, 9.890954933000046],
        ],
        [
            [125.5329176140001, 9.891283440000052],
            [125.533012127, 9.891117395000038],
            [125.53281049600002, 9.890758920000053],
            [125.53265612300004, 9.891249300000027],
            [125.5329176140001, 9.891283440000052],
        ],
        [
            [125.94805645300005, 9.891908810000075],
            [125.94805586600012, 9.891179459000057],
            [125.94721713700005, 9.89136489200007],
            [125.9472410300001, 9.89164912900003],
            [125.94805645300005, 9.891908810000075],
        ],
        [
            [125.53240349600003, 9.892175933000033],
            [125.53237842400006, 9.891754503000072],
            [125.532115169, 9.89175913500003],
            [125.53206815900012, 9.891930484000056],
            [125.53240349600003, 9.892175933000033],
        ],
        [
            [125.92944580800008, 9.892525516000035],
            [125.92958960800001, 9.891730229000075],
            [125.92870471800006, 9.891818638000075],
            [125.92873112200004, 9.892397669000047],
            [125.92944580800008, 9.892525516000035],
        ],
        [
            [125.95049340000003, 9.89272208500006],
            [125.96756148100008, 9.865999842000065],
            [125.94858957800011, 9.850166339000054],
            [125.92395740200004, 9.867845973000044],
            [125.95049340000003, 9.89272208500006],
        ],
        [
            [125.94766170800006, 9.889029476000076],
            [125.94711210500009, 9.889016104000063],
            [125.9474413590001, 9.888109720000045],
            [125.9478546360001, 9.888657084000045],
            [125.94766170800006, 9.889029476000076],
        ],
        [
            [125.90271727600009, 9.894395936000024],
            [125.90272467700004, 9.893490531000054],
            [125.901885031, 9.893779239000025],
            [125.90180083200005, 9.89434611400003],
            [125.90271727600009, 9.894395936000024],
        ],
        [
            [125.90114606600002, 9.89442426000005],
            [125.9008891530001, 9.894600217000061],
            [125.9010093500001, 9.894802954000056],
            [125.90112293900006, 9.894776251000053],
            [125.90114606600002, 9.89442426000005],
        ],
        [
            [125.90629111700002, 9.894967571000052],
            [125.90651792300002, 9.894546443000024],
            [125.9062087850001, 9.893868523000037],
            [125.90582374700011, 9.89455425500006],
            [125.90629111700002, 9.894967571000052],
        ],
        [
            [125.90850763600008, 9.898324444000025],
            [125.90913797200005, 9.898309993000055],
            [125.90912804000004, 9.897202940000057],
            [125.90794960000005, 9.89891483100007],
            [125.90850763600008, 9.898324444000025],
        ],
        [
            [125.90965327800006, 9.899375863000046],
            [125.90998211900012, 9.899185770000031],
            [125.9101518760001, 9.898459691000028],
            [125.90899315000001, 9.898884294000027],
            [125.90965327800006, 9.899375863000046],
        ],
        [
            [125.91018679700005, 9.899628759000052],
            [125.91014252600007, 9.899426203000075],
            [125.90998455500005, 9.899499992000074],
            [125.91002228400009, 9.899625263000075],
            [125.91018679700005, 9.899628759000052],
        ],
        [
            [125.91441225900007, 9.90055645800004],
            [125.91496938500006, 9.900287186000071],
            [125.91490098700001, 9.899955802000022],
            [125.9144702000001, 9.900042867000025],
            [125.91441225900007, 9.90055645800004],
        ],
        [
            [125.89185855900007, 9.900659080000025],
            [125.8915501030001, 9.90031538900007],
            [125.89143404700008, 9.899686172000031],
            [125.89111294200006, 9.90064787600005],
            [125.89185855900007, 9.900659080000025],
        ],
        [
            [125.9051377830001, 9.901257359000056],
            [125.90668144200004, 9.897771633000048],
            [125.90503822100004, 9.895296839000025],
            [125.90394662300002, 9.899678982000069],
            [125.9051377830001, 9.901257359000056],
        ],
        [
            [125.92504051500009, 9.907039145000056],
            [125.9258969650001, 9.906532410000068],
            [125.92623240300009, 9.905727462000073],
            [125.92442581500006, 9.906336358000033],
            [125.92504051500009, 9.907039145000056],
        ],
        [
            [125.97397886100009, 9.907698852000067],
            [125.97382393700002, 9.907029273000035],
            [125.97307239600002, 9.907502687000033],
            [125.97377163800002, 9.907529967000073],
            [125.97397886100009, 9.907698852000067],
        ],
        [
            [125.9722874690001, 9.90744453000002],
            [125.97261273900006, 9.907173439000076],
            [125.9725151020001, 9.90682885900003],
            [125.9717962850001, 9.907724848000043],
            [125.9722874690001, 9.90744453000002],
        ],
        [
            [125.965506419, 9.911609934000069],
            [125.96582988800003, 9.911374374000047],
            [125.96543677900002, 9.91093842500004],
            [125.96523825700001, 9.911222123000073],
            [125.965506419, 9.911609934000069],
        ],
        [
            [125.61128441700009, 9.912129580000055],
            [125.6123922910001, 9.890065270000036],
            [125.59603354, 9.89094330200004],
            [125.57662389300003, 9.853049039000041],
            [125.5835659380001, 9.895082371000058],
            [125.56540385500011, 9.880744088000029],
            [125.55994310400001, 9.894657124000048],
            [125.61128441700009, 9.912129580000055],
        ],
        [
            [125.97010164500011, 9.914846087000058],
            [125.97413104300006, 9.912741118000042],
            [125.96765275400003, 9.90902905400003],
            [125.96760366100011, 9.91142654500004],
            [125.97010164500011, 9.914846087000058],
        ],
        [
            [125.90794720400004, 9.915282780000041],
            [125.90789817500001, 9.915002099000048],
            [125.90744230000007, 9.914939659000026],
            [125.90742484800012, 9.915195379000068],
            [125.90794720400004, 9.915282780000041],
        ],
        [
            [125.64204725200011, 9.916072799000062],
            [125.64393267000003, 9.861680087000025],
            [125.65900179900007, 9.84901992500005],
            [125.68785382900012, 9.849166270000069],
            [125.5916808720001, 9.804545867000058],
            [125.5784998370001, 9.838978262000069],
            [125.64204725200011, 9.916072799000062],
        ],
        [
            [125.44348144500009, 9.91687011700003],
            [125.44756115400003, 9.914861944000052],
            [125.45081911800003, 9.908010417000071],
            [125.44189453100012, 9.912475586000028],
            [125.44348144500009, 9.91687011700003],
        ],
        [
            [125.89887892000002, 9.918760958000064],
            [125.91140394700005, 9.907754732000058],
            [125.89323160900005, 9.892966480000041],
            [125.89135141200006, 9.906817078000074],
            [125.89887892000002, 9.918760958000064],
        ],
        [
            [125.89450166200004, 9.901091571000052],
            [125.8945492040001, 9.901337686000034],
            [125.89431423700012, 9.901393312000039],
            [125.89426519200003, 9.901233627000067],
            [125.89450166200004, 9.901091571000052],
        ],
        [
            [125.51523300200006, 9.921391864000043],
            [125.51871397700006, 9.898651641000072],
            [125.55311185500011, 9.861614324000072],
            [125.5105642960001, 9.886207283000033],
            [125.51523300200006, 9.921391864000043],
        ],
        [
            [125.51787735800008, 9.90323488200005],
            [125.51765155700002, 9.903399750000062],
            [125.51755050700001, 9.903301752000061],
            [125.51773367700002, 9.90307622000006],
            [125.51787735800008, 9.90323488200005],
        ],
        [
            [125.89394977000006, 9.92316145600006],
            [125.89562176400011, 9.922434716000055],
            [125.89484582300008, 9.920044420000067],
            [125.89178898400007, 9.922720223000056],
            [125.89394977000006, 9.92316145600006],
        ],
        [
            [125.89219930900003, 9.924810037000043],
            [125.89195230000007, 9.92494098900005],
            [125.89197643900002, 9.92513834600004],
            [125.89228560400011, 9.925128199000028],
            [125.89219930900003, 9.924810037000043],
        ],
        [
            [125.64129296700003, 9.926704977000043],
            [125.64436565200003, 9.92543459500007],
            [125.64280163600006, 9.919353536000074],
            [125.63872404900007, 9.922357542000043],
            [125.64129296700003, 9.926704977000043],
        ],
        [
            [125.81207980500005, 9.92800358200003],
            [125.81174362400009, 9.922445733000075],
            [125.80587534900008, 9.920451551000042],
            [125.80863896700009, 9.928048473000047],
            [125.81207980500005, 9.92800358200003],
        ],
        [
            [125.4965800440001, 9.929318615000057],
            [125.501210076, 9.926180186000067],
            [125.49635614400006, 9.920690315000058],
            [125.49214561600002, 9.92433363400005],
            [125.4965800440001, 9.929318615000057],
        ],
        [
            [125.93753485400009, 9.929762115000074],
            [125.94110486400007, 9.926888095000038],
            [125.93665180000005, 9.914439412000036],
            [125.93151871300006, 9.919499479000024],
            [125.93753485400009, 9.929762115000074],
        ],
        [
            [125.68060320400002, 9.933776651000073],
            [125.68079230900003, 9.93008487000003],
            [125.67719446700005, 9.930607637000037],
            [125.6790966310001, 9.931891952000058],
            [125.68060320400002, 9.933776651000073],
        ],
        [
            [125.63077729800011, 9.937831981000045],
            [125.63181997900006, 9.932292225000026],
            [125.63299930200003, 9.929777568000077],
            [125.63457884200011, 9.928776458000073],
            [125.63439982800003, 9.928452892000053],
            [125.6347283130001, 9.92836926800004],
            [125.63457140800006, 9.92819925200007],
            [125.63489804300002, 9.927919306000035],
            [125.63484636700002, 9.927704806000065],
            [125.62518743300006, 9.934347413000069],
            [125.63077729800011, 9.937831981000045],
        ],
        [
            [125.688802355, 9.939633640000068],
            [125.68891732600002, 9.93614203900006],
            [125.686643795, 9.935508152000068],
            [125.6865391880001, 9.936766042000045],
            [125.688802355, 9.939633640000068],
        ],
        [
            [125.63092834400004, 9.939888817000053],
            [125.63068872100007, 9.939800536000064],
            [125.63071433200003, 9.940112231000057],
            [125.63078566900003, 9.940103222000062],
            [125.63092834400004, 9.939888817000053],
        ],
        [
            [125.63105638900004, 9.940272580000055],
            [125.63169293700003, 9.940045558000065],
            [125.6309173630001, 9.939443797000024],
            [125.6310655320001, 9.939892420000035],
            [125.63071982000008, 9.94024375600003],
            [125.63105638900004, 9.940272580000055],
        ],
        [
            [125.55346423600008, 9.947295193000059],
            [125.55425851900009, 9.945510463000062],
            [125.55384563600012, 9.943946864000054],
            [125.55099939900003, 9.946807672000034],
            [125.55346423600008, 9.947295193000059],
        ],
        [
            [125.98957163600005, 9.949373870000045],
            [125.99096518200008, 9.94825254500006],
            [125.98837390000006, 9.942927439000073],
            [125.98692559800008, 9.942655170000023],
            [125.98957163600005, 9.949373870000045],
        ],
        [
            [125.54345885500004, 9.949751463000041],
            [125.54852449700002, 9.948970382000027],
            [125.55009657800008, 9.946810102000029],
            [125.54584892300011, 9.943849460000024],
            [125.54345885500004, 9.949751463000041],
        ],
        [
            [125.95812988300008, 9.94952392600004],
            [125.95788574200003, 9.947875977000024],
            [125.95410156200012, 9.949279785000044],
            [125.95709228500004, 9.951904297000056],
            [125.95812988300008, 9.94952392600004],
        ],
        [
            [125.9687249100001, 9.96383061900002],
            [125.98157821900008, 9.942689608000023],
            [125.97056596200002, 9.925368725000055],
            [125.97256831300001, 9.918312623000077],
            [125.92759074000003, 9.896528497000077],
            [125.92653906300006, 9.88173725200005],
            [125.91420521100008, 9.875005956000052],
            [125.9687249100001, 9.96383061900002],
        ],
        [
            [125.93699350100007, 9.90398786000003],
            [125.93654343600008, 9.903347453000038],
            [125.93673788500007, 9.903126855000039],
            [125.93714161200012, 9.903786392000029],
            [125.93699350100007, 9.90398786000003],
        ],
        [
            [125.94626509700004, 9.92071706300004],
            [125.94610841300005, 9.920734645000039],
            [125.9460707290001, 9.920676035000042],
            [125.94616394700006, 9.92062523900006],
            [125.94626509700004, 9.92071706300004],
        ],
        [
            [125.94704382100008, 9.920856017000062],
            [125.94672492300003, 9.920886826000071],
            [125.94681500700005, 9.920550761000072],
            [125.94711588900009, 9.920740659000046],
            [125.94704382100008, 9.920856017000062],
        ],
        [
            [125.94612196500009, 9.921181610000076],
            [125.94587553200006, 9.921019141000045],
            [125.94612002500003, 9.920833737000066],
            [125.94635093400007, 9.92114529500003],
            [125.94612196500009, 9.921181610000076],
        ],
        [
            [125.95553593500006, 9.929581622000057],
            [125.95417848400007, 9.928554724000037],
            [125.95531323000012, 9.92763870300007],
            [125.95593853500009, 9.928841125000076],
            [125.95553593500006, 9.929581622000057],
        ],
        [
            [125.9565781660001, 9.930095728000026],
            [125.95622983300007, 9.93004725000003],
            [125.95681770300007, 9.929255161000071],
            [125.95689529000003, 9.929610593000064],
            [125.9565781660001, 9.930095728000026],
        ],
        [
            [125.96338845800005, 9.936619394000047],
            [125.96296768600007, 9.936389146000067],
            [125.9642351760001, 9.935764886000072],
            [125.96402393400001, 9.936315793000063],
            [125.96338845800005, 9.936619394000047],
        ],
        [
            [125.96541206800009, 9.93657924200005],
            [125.96556294900006, 9.936797094000042],
            [125.9654155070001, 9.937092633000077],
            [125.96518747000005, 9.936678885000049],
            [125.96541206800009, 9.93657924200005],
        ],
        [
            [125.9661676720001, 9.937021985000058],
            [125.96623111100007, 9.937121622000063],
            [125.96616082000003, 9.937304012000027],
            [125.96602194200011, 9.937170601000048],
            [125.9661676720001, 9.937021985000058],
        ],
        [
            [125.96514802000002, 9.937853361000066],
            [125.96367137100003, 9.938202357000023],
            [125.96400040200001, 9.936664283000027],
            [125.96520277200011, 9.937047836000033],
            [125.96514802000002, 9.937853361000066],
        ],
        [
            [125.96655543800011, 9.939504979000048],
            [125.96612373000005, 9.938951775000021],
            [125.96704648500008, 9.93846973500007],
            [125.96723072000009, 9.938957005000077],
            [125.96655543800011, 9.939504979000048],
        ],
        [
            [125.57567896500007, 9.97484819400006],
            [125.57534458600003, 9.97464317300006],
            [125.57472827800007, 9.974893395000038],
            [125.57538392600009, 9.975324423000075],
            [125.57567896500007, 9.97484819400006],
        ],
        [
            [125.52429784700007, 9.981640732000074],
            [125.52414138800009, 9.973136778000026],
            [125.52060987200002, 9.971931573000063],
            [125.51786429900005, 9.982473948000063],
            [125.52429784700007, 9.981640732000074],
        ],
        [
            [125.53583695900011, 9.990873470000054],
            [125.55972449600006, 9.970859225000027],
            [125.55728905400008, 9.961196833000031],
            [125.53827925600001, 9.97813005200004],
            [125.53583695900011, 9.990873470000054],
        ],
        [
            [125.52428025400002, 9.997980277000067],
            [125.52528003000009, 9.994833850000077],
            [125.52468285900011, 9.993595748000075],
            [125.52373575700005, 9.995488186000046],
            [125.52428025400002, 9.997980277000067],
        ],
        [
            [125.51509332700005, 9.998887403000026],
            [125.51430639300008, 9.999818904000051],
            [125.51468150900007, 10.000563563000071],
            [125.51530285700005, 9.999587321000035],
            [125.51509332700005, 9.998887403000026],
        ],
        [
            [125.4972520010001, 10.01819895400007],
            [125.51124015000005, 9.997915224000053],
            [125.50315493300002, 9.981244478000065],
            [125.50392653200004, 9.998709959000053],
            [125.4972520010001, 10.01819895400007],
        ],
        [
            [125.51387847700005, 10.03001916200003],
            [125.5265177870001, 10.023849221000035],
            [125.538081841, 10.00945768300005],
            [125.51295933300003, 10.004402577000064],
            [125.51387847700005, 10.03001916200003],
        ],
        [
            [125.58271253500004, 10.061088922000067],
            [125.58470147900005, 10.058851140000058],
            [125.57991704800008, 10.055597748000025],
            [125.57834130100002, 10.05967167700004],
            [125.58271253500004, 10.061088922000067],
        ],
        [
            [126.07071634700003, 10.056174662000046],
            [126.1206416980001, 9.87851854400003],
            [126.09127840800011, 9.849110620000033],
            [126.16870415700009, 9.810019515000022],
            [126.1133322390001, 9.747674655000026],
            [126.02702617700004, 9.768231441000069],
            [126.03233799600002, 9.744817627000032],
            [125.94896799600008, 9.835477208000043],
            [125.97553845900006, 9.856259221000073],
            [125.97566847900009, 9.863400806000072],
            [125.95948809400011, 9.880729938000059],
            [125.97605229300007, 9.903870287000075],
            [125.97330357700002, 9.923113884000031],
            [126.03761999300002, 10.003073939000046],
            [126.03290727700005, 10.03497138800003],
            [126.07071634700003, 10.056174662000046],
        ],
        [
            [125.50376782500007, 10.067336349000072],
            [125.50453962800009, 10.06639883400004],
            [125.50348793500007, 10.065462232000073],
            [125.50342356800002, 10.067146717000071],
            [125.50376782500007, 10.067336349000072],
        ],
        [
            [125.50130433600009, 10.070546729000057],
            [125.50154505100011, 10.070439031000035],
            [125.50168222900004, 10.070003834000033],
            [125.50119933200006, 10.070269504000066],
            [125.50130433600009, 10.070546729000057],
        ],
        [
            [125.58123020000005, 10.076208547000022],
            [125.5831349880001, 10.075204349000046],
            [125.58306318600012, 10.073158436000028],
            [125.58135452600004, 10.073659243000066],
            [125.58123020000005, 10.076208547000022],
        ],
        [
            [125.47442597200006, 10.07847236300006],
            [125.47488602800001, 10.078081821000069],
            [125.4745067120001, 10.077835855000046],
            [125.47405611900001, 10.07832600100005],
            [125.47442597200006, 10.07847236300006],
        ],
        [
            [125.48777341000005, 10.080195587000048],
            [125.4878582120001, 10.079845615000067],
            [125.4876793730001, 10.079370444000062],
            [125.48750036100012, 10.080012441000065],
            [125.48777341000005, 10.080195587000048],
        ],
        [
            [125.48750536400007, 10.081617136000034],
            [125.4877573120001, 10.081250965000038],
            [125.48781390900001, 10.080615905000059],
            [125.48729121800011, 10.081111829000065],
            [125.48750536400007, 10.081617136000034],
        ],
        [
            [125.47151625700008, 10.082139644000051],
            [125.47276916700002, 10.081259456000055],
            [125.47418450900011, 10.078688472000067],
            [125.47149861000003, 10.079302822000045],
            [125.47151625700008, 10.082139644000051],
        ],
        [
            [125.50539266900012, 10.084220469000059],
            [125.5032258110001, 10.081670583000061],
            [125.50096624900004, 10.082643476000044],
            [125.50277257100004, 10.084094546000074],
            [125.50539266900012, 10.084220469000059],
        ],
        [
            [125.49144423700011, 10.085732724000025],
            [125.49179277000007, 10.085429903000033],
            [125.49060539300001, 10.082033961000036],
            [125.49012689500012, 10.083420038000042],
            [125.49144423700011, 10.085732724000025],
        ],
        [
            [125.4915785720001, 10.08702773400006],
            [125.49185432700006, 10.08654378600005],
            [125.49167002600007, 10.086241268000038],
            [125.49142083600009, 10.086764462000076],
            [125.4915785720001, 10.08702773400006],
        ],
        [
            [125.48489028000006, 10.087651825000023],
            [125.48525858200003, 10.087470619000044],
            [125.4851261980001, 10.086923350000063],
            [125.48451693100003, 10.087312895000025],
            [125.48489028000006, 10.087651825000023],
        ],
        [
            [125.49159784500011, 10.088482793000026],
            [125.49177888300005, 10.088283352000076],
            [125.4915431170001, 10.087979216000065],
            [125.49137364400008, 10.088584130000072],
            [125.49159784500011, 10.088482793000026],
        ],
        [
            [125.47839081600011, 10.090557525000065],
            [125.48384741300003, 10.085974080000028],
            [125.47901831100012, 10.078100248000055],
            [125.4767346320001, 10.08240028800003],
            [125.47839081600011, 10.090557525000065],
        ],
        [
            [125.48481607800011, 10.093783578000057],
            [125.48530353900003, 10.093228323000062],
            [125.48579881500007, 10.09111492900007],
            [125.48298567900008, 10.093173484000033],
            [125.48481607800011, 10.093783578000057],
        ],
        [
            [125.47675813500007, 10.10618545400007],
            [125.482817941, 10.101259298000059],
            [125.48009374300011, 10.09799888200007],
            [125.48252178100006, 10.099829],
            [125.48501233500008, 10.095092322000028],
            [125.47947677800005, 10.097940797000035],
            [125.47955267700002, 10.101132539000048],
            [125.47614835400009, 10.101672956000073],
            [125.47675813500007, 10.10618545400007],
        ],
        [
            [125.4892796370001, 10.139970146000053],
            [125.48914016900005, 10.140079036000031],
            [125.48922353400008, 10.140235263000022],
            [125.48928765800008, 10.140151624000055],
            [125.4892796370001, 10.139970146000053],
        ],
        [
            [125.48905681300005, 10.140356780000047],
            [125.48879711200004, 10.140487766000035],
            [125.48871055600011, 10.14103062700002],
            [125.48899270000004, 10.140822313000058],
            [125.48905681300005, 10.140356780000047],
        ],
        [
            [125.48840758000006, 10.141628722000064],
            [125.48878110200008, 10.141374644000052],
            [125.48851016700007, 10.14106219200005],
            [125.48827291000009, 10.141256301000055],
            [125.48840758000006, 10.141628722000064],
        ],
        [
            [125.48811708800008, 10.143041655000047],
            [125.487667772, 10.143283828000051],
            [125.48772244500003, 10.143726122000032],
            [125.48800262700001, 10.14357476500004],
            [125.48811708800008, 10.143041655000047],
        ],
        [
            [125.48778736700001, 10.143776574000071],
            [125.48754818600003, 10.143864025000028],
            [125.48752426900012, 10.143961567000076],
            [125.487744657, 10.143998562000036],
            [125.48778736700001, 10.143776574000071],
        ],
        [
            [125.48779079400003, 10.145116915000074],
            [125.48788133900007, 10.14480411300002],
            [125.487708784, 10.144561944000031],
            [125.48746106200008, 10.144868021000036],
            [125.48779079400003, 10.145116915000074],
        ],
        [
            [125.48707308000007, 10.145152042000063],
            [125.48723192900002, 10.14424535300003],
            [125.48469721100003, 10.142476351000028],
            [125.48470314000008, 10.143454258000077],
            [125.48707308000007, 10.145152042000063],
        ],
        [
            [125.48155942100004, 10.145834232000027],
            [125.48294840000005, 10.14277385500003],
            [125.48271029300008, 10.141453505000072],
            [125.47929279700008, 10.143666489000054],
            [125.48155942100004, 10.145834232000027],
        ],
        [
            [125.48971946100005, 10.149262986000053],
            [125.48950644000001, 10.149628277000033],
            [125.4896454090001, 10.14974038500003],
            [125.48995599500006, 10.149481373000071],
            [125.48971946100005, 10.149262986000053],
        ],
        [
            [125.48958313900005, 10.150411375000033],
            [125.48962315400001, 10.150041677000047],
            [125.48931417000006, 10.149795617000052],
            [125.48937614300007, 10.150331271000027],
            [125.48958313900005, 10.150411375000033],
        ],
        [
            [125.49139558800005, 10.150490320000074],
            [125.49165994200007, 10.150192804000028],
            [125.49146605900012, 10.149981273000037],
            [125.49132343200006, 10.150099148000038],
            [125.49139558800005, 10.150490320000074],
        ],
        [
            [125.4870438160001, 10.150799155000072],
            [125.4867127650001, 10.150800744000037],
            [125.48659559900011, 10.150900982000053],
            [125.48702506400002, 10.151096610000025],
            [125.4870438160001, 10.150799155000072],
        ],
        [
            [125.4904505500001, 10.151948503000028],
            [125.49082444600003, 10.15157550300006],
            [125.49060024000005, 10.151260549000028],
            [125.49007683100001, 10.151592440000059],
            [125.4904505500001, 10.151948503000028],
        ],
        [
            [125.48339024300003, 10.15321693900006],
            [125.48804550200009, 10.152957913000023],
            [125.48316477900005, 10.149437163000073],
            [125.48315470200009, 10.14557602900004],
            [125.48042716700002, 10.151600364000046],
            [125.48339024300003, 10.15321693900006],
        ],
        [
            [125.4898598640001, 10.170784678000075],
            [125.49014270200007, 10.170668393000028],
            [125.49010332500006, 10.170412905000035],
            [125.48975425100002, 10.170580286000074],
            [125.4898598640001, 10.170784678000075],
        ],
        [
            [125.48977914900001, 10.17186480600003],
            [125.49018545000001, 10.17170438200003],
            [125.49012167600006, 10.171450949000075],
            [125.48965396000006, 10.17152766700002],
            [125.48977914900001, 10.17186480600003],
        ],
        [
            [125.49167331600006, 10.17249449700006],
            [125.49303593500008, 10.171312732000047],
            [125.49261921400011, 10.16828478900004],
            [125.49090738600012, 10.173795408000046],
            [125.49167331600006, 10.17249449700006],
        ],
        [
            [125.46340488400006, 10.174740951000047],
            [125.4665576110001, 10.172082665000062],
            [125.46161544800009, 10.16692381200005],
            [125.46046256300008, 10.169420845000047],
            [125.46340488400006, 10.174740951000047],
        ],
        [
            [125.50488598700008, 10.175703669000029],
            [125.50574196900004, 10.17540589400005],
            [125.50589857900002, 10.174959950000073],
            [125.50465490300007, 10.175149971000053],
            [125.50488598700008, 10.175703669000029],
        ],
        [
            [125.50270341200007, 10.177969963000066],
            [125.50284120600008, 10.177478931000053],
            [125.50160996800003, 10.17680953200005],
            [125.50139542300008, 10.177679818000058],
            [125.50270341200007, 10.177969963000066],
        ],
        [
            [125.50177548300007, 10.182442199000036],
            [125.50233119600011, 10.18186145900006],
            [125.50354094600004, 10.181821181000032],
            [125.50056083700008, 10.18123730000002],
            [125.50177548300007, 10.182442199000036],
        ],
        [
            [125.49746202000006, 10.19989238200003],
            [125.49774993200003, 10.199844884000072],
            [125.49783647400011, 10.199392816000056],
            [125.4971957460001, 10.199676174000047],
            [125.49746202000006, 10.19989238200003],
        ],
        [
            [125.49700934900011, 10.199744965000036],
            [125.49679133600011, 10.199817033000045],
            [125.49663988600003, 10.200324788000046],
            [125.49704596200002, 10.199967723000043],
            [125.49700934900011, 10.199744965000036],
        ],
        [
            [125.4983324100001, 10.200514798000029],
            [125.49787308400005, 10.200038160000076],
            [125.49753025100006, 10.200478760000067],
            [125.4979978990001, 10.20067203700006],
            [125.4983324100001, 10.200514798000029],
        ],
        [
            [125.49711654700002, 10.201915636000024],
            [125.49739189700006, 10.201649984000028],
            [125.49691865500006, 10.200913172000071],
            [125.49666847800006, 10.201545446000068],
            [125.49711654700002, 10.201915636000024],
        ],
        [
            [125.50019396400012, 10.202156556000034],
            [125.49926736800012, 10.200781566000046],
            [125.49844286500002, 10.201328225000054],
            [125.49870741200004, 10.20198343900006],
            [125.50019396400012, 10.202156556000034],
        ],
        [
            [125.49778778100006, 10.201998917000026],
            [125.49765100900004, 10.202083923000032],
            [125.49772478000011, 10.202280520000045],
            [125.4979101460001, 10.202082166000025],
            [125.49778778100006, 10.201998917000026],
        ],
        [
            [125.49809726400008, 10.202744574000064],
            [125.49859036700002, 10.20237443800005],
            [125.49827187200003, 10.201882051000041],
            [125.49768517600012, 10.202514306000069],
            [125.49809726400008, 10.202744574000064],
        ],
        [
            [125.49748720200012, 10.202859662000037],
            [125.49762037200003, 10.20284373100003],
            [125.49762578100001, 10.202677245000075],
            [125.49739362700006, 10.202834861000042],
            [125.49748720200012, 10.202859662000037],
        ],
        [
            [125.49704628000006, 10.203305109000041],
            [125.49736483100003, 10.202864151000028],
            [125.49673864400006, 10.20182978400004],
            [125.49642183700007, 10.203156299000057],
            [125.49704628000006, 10.203305109000041],
        ],
        [
            [125.59045882100008, 10.38209529900007],
            [125.59501715800002, 10.37809567000005],
            [125.5934283360001, 10.369700289000036],
            [125.58753352400004, 10.375250717000029],
            [125.59045882100008, 10.38209529900007],
        ],
        [
            [125.56839807400002, 10.421630457000049],
            [125.56752807700002, 10.42175145300007],
            [125.56742908100011, 10.422803379000072],
            [125.56812308000008, 10.422684384000036],
            [125.56839807400002, 10.421630457000049],
        ],
        [
            [125.5675201040001, 10.427887019000025],
            [125.566597107, 10.428008014000056],
            [125.56673511200006, 10.429409916000054],
            [125.56765810900004, 10.428996940000047],
            [125.5675201040001, 10.427887019000025],
        ],
        [
            [125.47509751300004, 10.438083255000038],
            [125.4762905550001, 10.437259783000059],
            [125.47615107900003, 10.436704605000045],
            [125.47543559200005, 10.43649675100005],
            [125.47509751300004, 10.438083255000038],
        ],
        [
            [125.47295047000011, 10.440568304000067],
            [125.47224288400002, 10.429007331000037],
            [125.46557833000008, 10.42922972100007],
            [125.46477369200011, 10.431646061000038],
            [125.47295047000011, 10.440568304000067],
        ],
        [
            [125.47318464000011, 10.461220749000063],
            [125.5016336000001, 10.445635899000024],
            [125.49810132900006, 10.423155758000064],
            [125.47700238000004, 10.42741684400005],
            [125.47890820200007, 10.436079053000071],
            [125.4633434320001, 10.457047554000042],
            [125.47318464000011, 10.461220749000063],
        ],
        [
            [125.64236496800004, 10.471592963000035],
            [125.68163258200002, 10.391692196000065],
            [125.64386418300012, 10.185145067000065],
            [125.67579485500005, 10.168488922000051],
            [125.66081325000005, 10.120567273000063],
            [125.69806172900007, 10.059608549000075],
            [125.65665924400002, 9.947746107000057],
            [125.7072443190001, 9.891169820000073],
            [125.66695, 9.851670001000059],
            [125.64468556200006, 9.935664726000027],
            [125.59132949100001, 9.954837703000067],
            [125.61678793600004, 9.960432719000039],
            [125.60645584600002, 9.993678265000028],
            [125.57679022100001, 9.976070631000027],
            [125.5595808700001, 9.990968830000043],
            [125.57557486900009, 10.043552069000043],
            [125.60426098300002, 10.043705232000036],
            [125.59010784000009, 10.07718215400007],
            [125.57024344000001, 10.08998390000005],
            [125.57708675100002, 10.064957452000044],
            [125.54834487900007, 10.084534156000075],
            [125.50842392000004, 10.063061253000058],
            [125.50603962000002, 10.084919729000035],
            [125.48112055900003, 10.103987231000076],
            [125.47345514400001, 10.135014726000065],
            [125.47765340900003, 10.139953625000032],
            [125.48114107200001, 10.118876555000043],
            [125.48885662300006, 10.117399541000054],
            [125.4963539470001, 10.181645088000039],
            [125.49993142500011, 10.184029959000043],
            [125.4990101630001, 10.177309756000056],
            [125.50673986100003, 10.172063001000026],
            [125.52603013100008, 10.183892926000055],
            [125.49793578800006, 10.209358057000031],
            [125.5434504110001, 10.203474515000039],
            [125.51234912200005, 10.242417770000031],
            [125.53719293900008, 10.28051391200006],
            [125.513871504, 10.321086077000075],
            [125.55851022700006, 10.319889395000075],
            [125.55106019700008, 10.384806817000026],
            [125.58050084700005, 10.35906839200004],
            [125.59719769700007, 10.36621122300005],
            [125.64236496800004, 10.471592963000035],
        ],
        [
            [125.5691356100001, 10.000581642000043],
            [125.56855633400005, 10.000833362000037],
            [125.56758921300002, 10.00035161300002],
            [125.56977474300004, 10.000147009000045],
            [125.5691356100001, 10.000581642000043],
        ],
        [
            [125.49863510300008, 10.094277483000042],
            [125.49791120800012, 10.094312387000059],
            [125.4983583500001, 10.093596073000072],
            [125.49893257100007, 10.09381897000003],
            [125.49863510300008, 10.094277483000042],
        ],
        [
            [125.49761148700009, 10.09566643100004],
            [125.49756836400002, 10.096458297000027],
            [125.49719993500003, 10.095953665000025],
            [125.4975666690001, 10.095064235000052],
            [125.49761148700009, 10.09566643100004],
        ],
        [
            [125.49393314100007, 10.145820168000057],
            [125.49359206600002, 10.14532050400004],
            [125.49410188700006, 10.144600628000035],
            [125.49432574100001, 10.144827381000027],
            [125.49393314100007, 10.145820168000057],
        ],
        [
            [125.4938915680001, 10.148999763000063],
            [125.49333548800007, 10.148841011000059],
            [125.4944430380001, 10.148597102000053],
            [125.49431028200001, 10.148794577000047],
            [125.4938915680001, 10.148999763000063],
        ],
        [
            [125.49634529900004, 10.174705392000021],
            [125.4959887980001, 10.173373863000052],
            [125.49724325300008, 10.172406225000032],
            [125.49742784200009, 10.174307340000041],
            [125.49634529900004, 10.174705392000021],
        ],
        [
            [125.49745080600007, 10.177949510000076],
            [125.49692493500004, 10.178485246000037],
            [125.49665585600007, 10.178380102000062],
            [125.49690443200006, 10.177809983000031],
            [125.49745080600007, 10.177949510000076],
        ],
    ],
    bbox: [114.27790168600006, 4.587390601000038, 126.60496559600006, 21.121755276000044],
};

export default data;
